/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Bytes: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
  bigint: { input: any; output: any; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  jsonpath: { input: any; output: any; }
  numeric: { input: any; output: any; }
  seed_float: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  uuid: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID']['output'];
  /** Projects the account is listed as artist for */
  projectsCreated?: Maybe<Array<Project>>;
  /** Projects the account owns tokens from */
  projectsOwned?: Maybe<Array<AccountProject>>;
  /** Receipts for the account, on minters with settlement */
  receipts?: Maybe<Array<Receipt>>;
  tokens?: Maybe<Array<Token>>;
  /** Contracts the account is whitelisted on */
  whitelistedOn?: Maybe<Array<Whitelisting>>;
};


export type AccountProjectsCreatedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Project_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Project_Filter>;
};


export type AccountProjectsOwnedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountProject_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountProject_Filter>;
};


export type AccountReceiptsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Receipt_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Receipt_Filter>;
};


export type AccountTokensArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Token_Filter>;
};


export type AccountWhitelistedOnArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Whitelisting_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Whitelisting_Filter>;
};

export type AccountProject = {
  __typename?: 'AccountProject';
  account: Account;
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  project: Project;
};

export type AccountProject_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<AccountProject_Filter>>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_gt?: InputMaybe<Scalars['Int']['input']>;
  count_gte?: InputMaybe<Scalars['Int']['input']>;
  count_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  count_lt?: InputMaybe<Scalars['Int']['input']>;
  count_lte?: InputMaybe<Scalars['Int']['input']>;
  count_not?: InputMaybe<Scalars['Int']['input']>;
  count_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<AccountProject_Filter>>>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum AccountProject_OrderBy {
  Account = 'account',
  AccountId = 'account__id',
  Count = 'count',
  Id = 'id',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website'
}

export type Account_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Account_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Account_Filter>>>;
  projectsCreated_?: InputMaybe<Project_Filter>;
  projectsOwned_?: InputMaybe<AccountProject_Filter>;
  receipts_?: InputMaybe<Receipt_Filter>;
  tokens_?: InputMaybe<Token_Filter>;
  whitelistedOn_?: InputMaybe<Whitelisting_Filter>;
};

export enum Account_OrderBy {
  Id = 'id',
  ProjectsCreated = 'projectsCreated',
  ProjectsOwned = 'projectsOwned',
  Receipts = 'receipts',
  Tokens = 'tokens',
  WhitelistedOn = 'whitelistedOn'
}

export type AllowlistUploadUrlData = {
  __typename?: 'AllowlistUploadUrlData';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Article = {
  __typename?: 'Article';
  CollectionsSection?: Maybe<Array<Maybe<ComponentProjectMetadataProjectMetadata>>>;
  author?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Enum_Article_Category>;
  content?: Maybe<Scalars['String']['output']>;
  coverPhoto?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  embedURL?: Maybe<Scalars['String']['output']>;
  extraInfo?: Maybe<Scalars['String']['output']>;
  homePageLocation?: Maybe<Enum_Article_Homepagelocation>;
  isFeaturedArticle?: Maybe<Scalars['Boolean']['output']>;
  originallyPublished?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seoMetaDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ArticleCollectionsSectionArgs = {
  filters?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleEntity = {
  __typename?: 'ArticleEntity';
  attributes?: Maybe<Article>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ArticleEntityResponse = {
  __typename?: 'ArticleEntityResponse';
  data?: Maybe<ArticleEntity>;
};

export type ArticleEntityResponseCollection = {
  __typename?: 'ArticleEntityResponseCollection';
  data: Array<ArticleEntity>;
  meta: ResponseCollectionMeta;
};

export type ArticleFiltersInput = {
  CollectionsSection?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  category?: InputMaybe<StringFilterInput>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  embedURL?: InputMaybe<StringFilterInput>;
  extraInfo?: InputMaybe<StringFilterInput>;
  homePageLocation?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isFeaturedArticle?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  originallyPublished?: InputMaybe<DateTimeFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seoMetaDescription?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  tagline?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ArticleFiltersInput_Remote_Rel_Projects_Metadataarticle = {
  CollectionsSection?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput_Remote_Rel_Projects_Metadataarticle>;
  and?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  category?: InputMaybe<StringFilterInput>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  embedURL?: InputMaybe<StringFilterInput>;
  extraInfo?: InputMaybe<StringFilterInput>;
  homePageLocation?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isFeaturedArticle?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  originallyPublished?: InputMaybe<DateTimeFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seoMetaDescription?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  tagline?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ArticleInput = {
  CollectionsSection?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataInput>>>;
  author?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Enum_Article_Category>;
  content?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['ID']['input']>;
  embedURL?: InputMaybe<Scalars['String']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  homePageLocation?: InputMaybe<Enum_Article_Homepagelocation>;
  isFeaturedArticle?: InputMaybe<Scalars['Boolean']['input']>;
  originallyPublished?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seoMetaDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ArtistEditorialPage = {
  __typename?: 'ArtistEditorialPage';
  ExhibitionsSection?: Maybe<ComponentArtistEditorialPageExhibitions>;
  FeaturedWorkSection?: Maybe<ComponentArtistEditorialPageFeaturedWork>;
  PressSection?: Maybe<ComponentArtistEditorialPagePress>;
  ReleasesSection?: Maybe<ComponentArtistEditorialPageProjectsCreated>;
  SpectrumArticlesSection?: Maybe<ComponentArtistEditorialPageSpectrumArticles>;
  artistName: Scalars['String']['output'];
  avatar?: Maybe<UploadFileEntityResponse>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  headerImage?: Maybe<UploadFileEntityResponse>;
  instagram?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seoMetaDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userProfileAddress?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ArtistEditorialPageEntity = {
  __typename?: 'ArtistEditorialPageEntity';
  attributes?: Maybe<ArtistEditorialPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ArtistEditorialPageEntityResponse = {
  __typename?: 'ArtistEditorialPageEntityResponse';
  data?: Maybe<ArtistEditorialPageEntity>;
};

export type ArtistEditorialPageEntityResponseCollection = {
  __typename?: 'ArtistEditorialPageEntityResponseCollection';
  data: Array<ArtistEditorialPageEntity>;
  meta: ResponseCollectionMeta;
};

export type ArtistEditorialPageFiltersInput = {
  ExhibitionsSection?: InputMaybe<ComponentArtistEditorialPageExhibitionsFiltersInput>;
  FeaturedWorkSection?: InputMaybe<ComponentArtistEditorialPageFeaturedWorkFiltersInput>;
  PressSection?: InputMaybe<ComponentArtistEditorialPagePressFiltersInput>;
  ReleasesSection?: InputMaybe<ComponentArtistEditorialPageProjectsCreatedFiltersInput>;
  SpectrumArticlesSection?: InputMaybe<ComponentArtistEditorialPageSpectrumArticlesFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ArtistEditorialPageFiltersInput>>>;
  artistName?: InputMaybe<StringFilterInput>;
  bio?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  instagram?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ArtistEditorialPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArtistEditorialPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seoMetaDescription?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  twitter?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userProfileAddress?: InputMaybe<StringFilterInput>;
  website?: InputMaybe<StringFilterInput>;
};

export type ArtistEditorialPageFiltersInput_Remote_Rel_Projects_MetadataartistPage = {
  ExhibitionsSection?: InputMaybe<ComponentArtistEditorialPageExhibitionsFiltersInput>;
  FeaturedWorkSection?: InputMaybe<ComponentArtistEditorialPageFeaturedWorkFiltersInput>;
  PressSection?: InputMaybe<ComponentArtistEditorialPagePressFiltersInput>;
  ReleasesSection?: InputMaybe<ComponentArtistEditorialPageProjectsCreatedFiltersInput_Remote_Rel_Projects_MetadataartistPage>;
  SpectrumArticlesSection?: InputMaybe<ComponentArtistEditorialPageSpectrumArticlesFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ArtistEditorialPageFiltersInput>>>;
  artistName?: InputMaybe<StringFilterInput>;
  bio?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  instagram?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ArtistEditorialPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArtistEditorialPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seoMetaDescription?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  twitter?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userProfileAddress?: InputMaybe<StringFilterInput>;
  website?: InputMaybe<StringFilterInput>;
};

export type ArtistEditorialPageInput = {
  ExhibitionsSection?: InputMaybe<ComponentArtistEditorialPageExhibitionsInput>;
  FeaturedWorkSection?: InputMaybe<ComponentArtistEditorialPageFeaturedWorkInput>;
  PressSection?: InputMaybe<ComponentArtistEditorialPagePressInput>;
  ReleasesSection?: InputMaybe<ComponentArtistEditorialPageProjectsCreatedInput>;
  SpectrumArticlesSection?: InputMaybe<ComponentArtistEditorialPageSpectrumArticlesInput>;
  artistName?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['ID']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<Scalars['ID']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seoMetaDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  userProfileAddress?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AuthMessageOutput = {
  __typename?: 'AuthMessageOutput';
  authMessage: Scalars['String']['output'];
};

export type AuthenticateInput = {
  contracts?: InputMaybe<Array<Scalars['String']['input']>>;
  ip?: InputMaybe<IpInfoInput>;
  message: Scalars['String']['input'];
  mixpanelId?: InputMaybe<Scalars['String']['input']>;
  publicAddress: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};

export type AuthenticateOutput = {
  __typename?: 'AuthenticateOutput';
  expiration: Scalars['Int']['output'];
  jwt: Scalars['String']['output'];
};

export type Bid = {
  __typename?: 'Bid';
  /** The bid type (RAM | SEA) */
  bidType: BidType;
  /** The associated account */
  bidder: Account;
  /** Unique identifier: SEA - {minter contract address}-{bidder}-{value}-{token}; RAM - {minter contract address}-{full project ID}-{bidID} */
  id: Scalars['ID']['output'];
  /** Indicates bid was removed */
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  /** The log index of the event triggering bid update */
  logIndex: Scalars['BigInt']['output'];
  /** The associated minter */
  minter: Minter;
  /** The associated project */
  project: Project;
  /** Indicates settlement status (RAM only) */
  settled?: Maybe<Scalars['Boolean']['output']>;
  /** The slot index of the bid (RAM only) */
  slotIndex?: Maybe<Scalars['BigInt']['output']>;
  /** The timestamp of the bid */
  timestamp: Scalars['BigInt']['output'];
  /** The token associated with SEA bids or winning RAM bids post-settlement */
  token?: Maybe<Token>;
  /** Transaction hash that created the bid */
  txHash: Scalars['Bytes']['output'];
  updatedAt: Scalars['BigInt']['output'];
  /** The value of the bid */
  value: Scalars['BigInt']['output'];
  /** Indicates the highest bid for SEA; For RAM, true for bids that won post-settlement otherwise false. */
  winningBid: Scalars['Boolean']['output'];
};

export enum BidType {
  Ram = 'RAM',
  Sea = 'SEA'
}

export type Bid_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Bid_Filter>>>;
  bidType?: InputMaybe<BidType>;
  bidType_in?: InputMaybe<Array<BidType>>;
  bidType_not?: InputMaybe<BidType>;
  bidType_not_in?: InputMaybe<Array<BidType>>;
  bidder?: InputMaybe<Scalars['String']['input']>;
  bidder_?: InputMaybe<Account_Filter>;
  bidder_contains?: InputMaybe<Scalars['String']['input']>;
  bidder_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  bidder_ends_with?: InputMaybe<Scalars['String']['input']>;
  bidder_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  bidder_gt?: InputMaybe<Scalars['String']['input']>;
  bidder_gte?: InputMaybe<Scalars['String']['input']>;
  bidder_in?: InputMaybe<Array<Scalars['String']['input']>>;
  bidder_lt?: InputMaybe<Scalars['String']['input']>;
  bidder_lte?: InputMaybe<Scalars['String']['input']>;
  bidder_not?: InputMaybe<Scalars['String']['input']>;
  bidder_not_contains?: InputMaybe<Scalars['String']['input']>;
  bidder_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  bidder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  bidder_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  bidder_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  bidder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  bidder_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  bidder_starts_with?: InputMaybe<Scalars['String']['input']>;
  bidder_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isRemoved_not?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  logIndex?: InputMaybe<Scalars['BigInt']['input']>;
  logIndex_gt?: InputMaybe<Scalars['BigInt']['input']>;
  logIndex_gte?: InputMaybe<Scalars['BigInt']['input']>;
  logIndex_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  logIndex_lt?: InputMaybe<Scalars['BigInt']['input']>;
  logIndex_lte?: InputMaybe<Scalars['BigInt']['input']>;
  logIndex_not?: InputMaybe<Scalars['BigInt']['input']>;
  logIndex_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minter?: InputMaybe<Scalars['String']['input']>;
  minter_?: InputMaybe<Minter_Filter>;
  minter_contains?: InputMaybe<Scalars['String']['input']>;
  minter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_ends_with?: InputMaybe<Scalars['String']['input']>;
  minter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_gt?: InputMaybe<Scalars['String']['input']>;
  minter_gte?: InputMaybe<Scalars['String']['input']>;
  minter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minter_lt?: InputMaybe<Scalars['String']['input']>;
  minter_lte?: InputMaybe<Scalars['String']['input']>;
  minter_not?: InputMaybe<Scalars['String']['input']>;
  minter_not_contains?: InputMaybe<Scalars['String']['input']>;
  minter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  minter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  minter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_starts_with?: InputMaybe<Scalars['String']['input']>;
  minter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Bid_Filter>>>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  settled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  settled_not?: InputMaybe<Scalars['Boolean']['input']>;
  settled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  slotIndex?: InputMaybe<Scalars['BigInt']['input']>;
  slotIndex_gt?: InputMaybe<Scalars['BigInt']['input']>;
  slotIndex_gte?: InputMaybe<Scalars['BigInt']['input']>;
  slotIndex_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  slotIndex_lt?: InputMaybe<Scalars['BigInt']['input']>;
  slotIndex_lte?: InputMaybe<Scalars['BigInt']['input']>;
  slotIndex_not?: InputMaybe<Scalars['BigInt']['input']>;
  slotIndex_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_?: InputMaybe<Token_Filter>;
  token_contains?: InputMaybe<Scalars['String']['input']>;
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_gt?: InputMaybe<Scalars['String']['input']>;
  token_gte?: InputMaybe<Scalars['String']['input']>;
  token_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_lt?: InputMaybe<Scalars['String']['input']>;
  token_lte?: InputMaybe<Scalars['String']['input']>;
  token_not?: InputMaybe<Scalars['String']['input']>;
  token_not_contains?: InputMaybe<Scalars['String']['input']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  txHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  value?: InputMaybe<Scalars['BigInt']['input']>;
  value_gt?: InputMaybe<Scalars['BigInt']['input']>;
  value_gte?: InputMaybe<Scalars['BigInt']['input']>;
  value_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  value_lt?: InputMaybe<Scalars['BigInt']['input']>;
  value_lte?: InputMaybe<Scalars['BigInt']['input']>;
  value_not?: InputMaybe<Scalars['BigInt']['input']>;
  value_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  winningBid?: InputMaybe<Scalars['Boolean']['input']>;
  winningBid_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  winningBid_not?: InputMaybe<Scalars['Boolean']['input']>;
  winningBid_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export enum Bid_OrderBy {
  BidType = 'bidType',
  Bidder = 'bidder',
  BidderId = 'bidder__id',
  Id = 'id',
  IsRemoved = 'isRemoved',
  LogIndex = 'logIndex',
  Minter = 'minter',
  MinterExtraMinterDetails = 'minter__extraMinterDetails',
  MinterId = 'minter__id',
  MinterIsGloballyAllowlistedOnMinterFilter = 'minter__isGloballyAllowlistedOnMinterFilter',
  MinterType = 'minter__type',
  MinterUpdatedAt = 'minter__updatedAt',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website',
  Settled = 'settled',
  SlotIndex = 'slotIndex',
  Timestamp = 'timestamp',
  Token = 'token',
  TokenCreatedAt = 'token__createdAt',
  TokenHash = 'token__hash',
  TokenId = 'token__id',
  TokenInvocation = 'token__invocation',
  TokenNextSaleId = 'token__nextSaleId',
  TokenTokenId = 'token__tokenId',
  TokenTransactionHash = 'token__transactionHash',
  TokenUpdatedAt = 'token__updatedAt',
  TokenUri = 'token__uri',
  TxHash = 'txHash',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  WinningBid = 'winningBid'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type ComponentArtistEditorialPageExhibitions = {
  __typename?: 'ComponentArtistEditorialPageExhibitions';
  exhibitionItem?: Maybe<Array<Maybe<ComponentGalleryGridItemGalleryGridItem>>>;
  id: Scalars['ID']['output'];
};


export type ComponentArtistEditorialPageExhibitionsExhibitionItemArgs = {
  filters?: InputMaybe<ComponentGalleryGridItemGalleryGridItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentArtistEditorialPageExhibitionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageExhibitionsFiltersInput>>>;
  exhibitionItem?: InputMaybe<ComponentGalleryGridItemGalleryGridItemFiltersInput>;
  not?: InputMaybe<ComponentArtistEditorialPageExhibitionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageExhibitionsFiltersInput>>>;
};

export type ComponentArtistEditorialPageExhibitionsInput = {
  exhibitionItem?: InputMaybe<Array<InputMaybe<ComponentGalleryGridItemGalleryGridItemInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentArtistEditorialPageFeaturedWork = {
  __typename?: 'ComponentArtistEditorialPageFeaturedWork';
  FeaturedWorkItem?: Maybe<Array<Maybe<ComponentImageWithCaptionImageWithCaption>>>;
  id: Scalars['ID']['output'];
};


export type ComponentArtistEditorialPageFeaturedWorkFeaturedWorkItemArgs = {
  filters?: InputMaybe<ComponentImageWithCaptionImageWithCaptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentArtistEditorialPageFeaturedWorkFiltersInput = {
  FeaturedWorkItem?: InputMaybe<ComponentImageWithCaptionImageWithCaptionFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageFeaturedWorkFiltersInput>>>;
  not?: InputMaybe<ComponentArtistEditorialPageFeaturedWorkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageFeaturedWorkFiltersInput>>>;
};

export type ComponentArtistEditorialPageFeaturedWorkInput = {
  FeaturedWorkItem?: InputMaybe<Array<InputMaybe<ComponentImageWithCaptionImageWithCaptionInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentArtistEditorialPagePress = {
  __typename?: 'ComponentArtistEditorialPagePress';
  PressItem?: Maybe<Array<Maybe<ComponentPressItemPressItem>>>;
  id: Scalars['ID']['output'];
};


export type ComponentArtistEditorialPagePressPressItemArgs = {
  filters?: InputMaybe<ComponentPressItemPressItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentArtistEditorialPagePressFiltersInput = {
  PressItem?: InputMaybe<ComponentPressItemPressItemFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPagePressFiltersInput>>>;
  not?: InputMaybe<ComponentArtistEditorialPagePressFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPagePressFiltersInput>>>;
};

export type ComponentArtistEditorialPagePressInput = {
  PressItem?: InputMaybe<Array<InputMaybe<ComponentPressItemPressItemInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentArtistEditorialPageProjectsCreated = {
  __typename?: 'ComponentArtistEditorialPageProjectsCreated';
  id: Scalars['ID']['output'];
  projectMetadata?: Maybe<Array<Maybe<ComponentProjectMetadataProjectMetadata>>>;
};


export type ComponentArtistEditorialPageProjectsCreatedProjectMetadataArgs = {
  filters?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentArtistEditorialPageProjectsCreatedFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageProjectsCreatedFiltersInput>>>;
  not?: InputMaybe<ComponentArtistEditorialPageProjectsCreatedFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageProjectsCreatedFiltersInput>>>;
  projectMetadata?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
};

export type ComponentArtistEditorialPageProjectsCreatedFiltersInput_Remote_Rel_Projects_MetadataartistPage = {
  and?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageProjectsCreatedFiltersInput>>>;
  not?: InputMaybe<ComponentArtistEditorialPageProjectsCreatedFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageProjectsCreatedFiltersInput>>>;
  projectMetadata?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput_Remote_Rel_Projects_MetadataartistPage>;
};

export type ComponentArtistEditorialPageProjectsCreatedInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectMetadata?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataInput>>>;
};

export type ComponentArtistEditorialPageSpectrumArticles = {
  __typename?: 'ComponentArtistEditorialPageSpectrumArticles';
  SpectrumArticle?: Maybe<Array<Maybe<ComponentSpectrumArticleSpectrumArticle>>>;
  id: Scalars['ID']['output'];
};


export type ComponentArtistEditorialPageSpectrumArticlesSpectrumArticleArgs = {
  filters?: InputMaybe<ComponentSpectrumArticleSpectrumArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentArtistEditorialPageSpectrumArticlesFiltersInput = {
  SpectrumArticle?: InputMaybe<ComponentSpectrumArticleSpectrumArticleFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageSpectrumArticlesFiltersInput>>>;
  not?: InputMaybe<ComponentArtistEditorialPageSpectrumArticlesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArtistEditorialPageSpectrumArticlesFiltersInput>>>;
};

export type ComponentArtistEditorialPageSpectrumArticlesInput = {
  SpectrumArticle?: InputMaybe<Array<InputMaybe<ComponentSpectrumArticleSpectrumArticleInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCuratedHomePageCuratedHomePageItem = {
  __typename?: 'ComponentCuratedHomePageCuratedHomePageItem';
  ArticleTextAlign?: Maybe<Enum_Componentcuratedhomepagecuratedhomepageitem_Articletextalign>;
  Project?: Maybe<ComponentProjectMetadataProjectMetadata>;
  SlideEntries?: Maybe<Array<Maybe<ComponentCuratedHomePageTokenSlideEntry>>>;
  SlideType: Enum_Componentcuratedhomepagecuratedhomepageitem_Slidetype;
  article?: Maybe<ArticleEntityResponse>;
  exhibition?: Maybe<ExhibitionEntityResponse>;
  id: Scalars['ID']['output'];
};


export type ComponentCuratedHomePageCuratedHomePageItemSlideEntriesArgs = {
  filters?: InputMaybe<ComponentCuratedHomePageTokenSlideEntryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCuratedHomePageCuratedHomePageItemFiltersInput = {
  ArticleTextAlign?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  Project?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  SlideEntries?: InputMaybe<ComponentCuratedHomePageTokenSlideEntryFiltersInput>;
  SlideType?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentCuratedHomePageCuratedHomePageItemFiltersInput>>>;
  article?: InputMaybe<ArticleFiltersInput>;
  exhibition?: InputMaybe<ExhibitionFiltersInput>;
  not?: InputMaybe<ComponentCuratedHomePageCuratedHomePageItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCuratedHomePageCuratedHomePageItemFiltersInput>>>;
};

export type ComponentCuratedHomePageCuratedHomePageItemInput = {
  ArticleTextAlign?: InputMaybe<Enum_Componentcuratedhomepagecuratedhomepageitem_Articletextalign>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Project?: InputMaybe<ComponentProjectMetadataProjectMetadataInput>;
  SlideEntries?: InputMaybe<Array<InputMaybe<ComponentCuratedHomePageTokenSlideEntryInput>>>;
  SlideType?: InputMaybe<Enum_Componentcuratedhomepagecuratedhomepageitem_Slidetype>;
  article?: InputMaybe<Scalars['ID']['input']>;
  exhibition?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCuratedHomePageTokenSlideEntry = {
  __typename?: 'ComponentCuratedHomePageTokenSlideEntry';
  CursorTextOverride?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EntryType: Enum_Componentcuratedhomepagetokenslideentry_Entrytype;
  Link?: Maybe<Scalars['String']['output']>;
  MediaOverride?: Maybe<UploadFileEntityResponse>;
  OOBToken?: Maybe<Oob_Tokens_Metadata>;
  Title?: Maybe<Scalars['String']['output']>;
  Token?: Maybe<Tokens_Metadata>;
  id: Scalars['ID']['output'];
  oobTokenId?: Maybe<Scalars['String']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
};

export type ComponentCuratedHomePageTokenSlideEntryFiltersInput = {
  CursorTextOverride?: InputMaybe<StringFilterInput>;
  Description?: InputMaybe<StringFilterInput>;
  EntryType?: InputMaybe<StringFilterInput>;
  Link?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentCuratedHomePageTokenSlideEntryFiltersInput>>>;
  not?: InputMaybe<ComponentCuratedHomePageTokenSlideEntryFiltersInput>;
  oobTokenId?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCuratedHomePageTokenSlideEntryFiltersInput>>>;
  tokenId?: InputMaybe<StringFilterInput>;
};

export type ComponentCuratedHomePageTokenSlideEntryInput = {
  CursorTextOverride?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  EntryType?: InputMaybe<Enum_Componentcuratedhomepagetokenslideentry_Entrytype>;
  Link?: InputMaybe<Scalars['String']['input']>;
  MediaOverride?: InputMaybe<Scalars['ID']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  oobTokenId?: InputMaybe<Scalars['String']['input']>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentExhibitionsExhibitionCollection = {
  __typename?: 'ComponentExhibitionsExhibitionCollection';
  About?: Maybe<Scalars['String']['output']>;
  AdditionalProjects?: Maybe<Array<Maybe<ComponentProjectMetadataProjectMetadata>>>;
  Collection?: Maybe<ComponentProjectMetadataProjectMetadata>;
  Name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};


export type ComponentExhibitionsExhibitionCollectionAdditionalProjectsArgs = {
  filters?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentExhibitionsExhibitionCollectionFiltersInput = {
  About?: InputMaybe<StringFilterInput>;
  AdditionalProjects?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  Collection?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  Name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>>>;
  not?: InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>>>;
};

export type ComponentExhibitionsExhibitionCollectionFiltersInput_Remote_Rel_Projects_MetadataadditionalExhibition = {
  About?: InputMaybe<StringFilterInput>;
  AdditionalProjects?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput_Remote_Rel_Projects_MetadataadditionalExhibition>;
  Collection?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  Name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>>>;
  not?: InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>>>;
};

export type ComponentExhibitionsExhibitionCollectionFiltersInput_Remote_Rel_Projects_Metadataexhibition = {
  About?: InputMaybe<StringFilterInput>;
  AdditionalProjects?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  Collection?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput_Remote_Rel_Projects_Metadataexhibition>;
  Name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>>>;
  not?: InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>>>;
};

export type ComponentExhibitionsExhibitionCollectionInput = {
  About?: InputMaybe<Scalars['String']['input']>;
  AdditionalProjects?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataInput>>>;
  Collection?: InputMaybe<ComponentProjectMetadataProjectMetadataInput>;
  Name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentGalleryGridItemGalleryGridItem = {
  __typename?: 'ComponentGalleryGridItemGalleryGridItem';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentGalleryGridItemGalleryGridItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGalleryGridItemGalleryGridItemFiltersInput>>>;
  not?: InputMaybe<ComponentGalleryGridItemGalleryGridItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGalleryGridItemGalleryGridItemFiltersInput>>>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentGalleryGridItemGalleryGridItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHighlightItemHighlightItem = {
  __typename?: 'ComponentHighlightItemHighlightItem';
  id: Scalars['ID']['output'];
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  project?: Maybe<Array<Maybe<ComponentHighlightItemProjectProject>>>;
  projectLanguage?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Array<Maybe<ComponentHighlightItemTokenToken>>>;
  tokenLanguage?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type ComponentHighlightItemHighlightItemProjectArgs = {
  filters?: InputMaybe<ComponentHighlightItemProjectProjectFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentHighlightItemHighlightItemTokenArgs = {
  filters?: InputMaybe<ComponentHighlightItemTokenTokenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHighlightItemHighlightItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHighlightItemHighlightItemFiltersInput>>>;
  isPublic?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentHighlightItemHighlightItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHighlightItemHighlightItemFiltersInput>>>;
  project?: InputMaybe<ComponentHighlightItemProjectProjectFiltersInput>;
  projectLanguage?: InputMaybe<StringFilterInput>;
  token?: InputMaybe<ComponentHighlightItemTokenTokenFiltersInput>;
  tokenLanguage?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentHighlightItemHighlightItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  project?: InputMaybe<Array<InputMaybe<ComponentHighlightItemProjectProjectInput>>>;
  projectLanguage?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Array<InputMaybe<ComponentHighlightItemTokenTokenInput>>>;
  tokenLanguage?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHighlightItemProjectProject = {
  __typename?: 'ComponentHighlightItemProjectProject';
  id: Scalars['ID']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
};

export type ComponentHighlightItemProjectProjectFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHighlightItemProjectProjectFiltersInput>>>;
  not?: InputMaybe<ComponentHighlightItemProjectProjectFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHighlightItemProjectProjectFiltersInput>>>;
  projectId?: InputMaybe<StringFilterInput>;
};

export type ComponentHighlightItemProjectProjectInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHighlightItemTokenToken = {
  __typename?: 'ComponentHighlightItemTokenToken';
  id: Scalars['ID']['output'];
  tokenId?: Maybe<Scalars['String']['output']>;
};

export type ComponentHighlightItemTokenTokenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHighlightItemTokenTokenFiltersInput>>>;
  not?: InputMaybe<ComponentHighlightItemTokenTokenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHighlightItemTokenTokenFiltersInput>>>;
  tokenId?: InputMaybe<StringFilterInput>;
};

export type ComponentHighlightItemTokenTokenInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeBentoItem = {
  __typename?: 'ComponentHomeBentoItem';
  BentoName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  OverlineText?: Maybe<Scalars['String']['output']>;
  ThumbnailMedia?: Maybe<UploadFileEntityResponse>;
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Enum_Componenthomebentoitem_Type>;
  article?: Maybe<ArticleEntityResponse>;
  artist_editorial_page?: Maybe<ArtistEditorialPageEntityResponse>;
  exhibition?: Maybe<ExhibitionEntityResponse>;
  id: Scalars['ID']['output'];
  project?: Maybe<ComponentProjectMetadataProjectMetadata>;
};

export type ComponentHomeBentoItemFiltersInput = {
  BentoName?: InputMaybe<StringFilterInput>;
  Link?: InputMaybe<StringFilterInput>;
  OverlineText?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentHomeBentoItemFiltersInput>>>;
  article?: InputMaybe<ArticleFiltersInput>;
  artist_editorial_page?: InputMaybe<ArtistEditorialPageFiltersInput>;
  exhibition?: InputMaybe<ExhibitionFiltersInput>;
  not?: InputMaybe<ComponentHomeBentoItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeBentoItemFiltersInput>>>;
  project?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
};

export type ComponentHomeBentoItemInput = {
  BentoName?: InputMaybe<Scalars['String']['input']>;
  Link?: InputMaybe<Scalars['String']['input']>;
  OverlineText?: InputMaybe<Scalars['String']['input']>;
  ThumbnailMedia?: InputMaybe<Scalars['ID']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Enum_Componenthomebentoitem_Type>;
  article?: InputMaybe<Scalars['ID']['input']>;
  artist_editorial_page?: InputMaybe<Scalars['ID']['input']>;
  exhibition?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  project?: InputMaybe<ComponentProjectMetadataProjectMetadataInput>;
};

export type ComponentHomeHeroItem = {
  __typename?: 'ComponentHomeHeroItem';
  Name?: Maybe<Scalars['String']['output']>;
  Project?: Maybe<ComponentProjectMetadataProjectMetadata>;
  exhibition?: Maybe<ExhibitionEntityResponse>;
  id: Scalars['ID']['output'];
};

export type ComponentHomeHeroItemFiltersInput = {
  Name?: InputMaybe<StringFilterInput>;
  Project?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentHomeHeroItemFiltersInput>>>;
  exhibition?: InputMaybe<ExhibitionFiltersInput>;
  not?: InputMaybe<ComponentHomeHeroItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeHeroItemFiltersInput>>>;
};

export type ComponentHomeHeroItemInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  Project?: InputMaybe<ComponentProjectMetadataProjectMetadataInput>;
  exhibition?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentImageWithCaptionImageWithCaption = {
  __typename?: 'ComponentImageWithCaptionImageWithCaption';
  caption?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentImageWithCaptionImageWithCaptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentImageWithCaptionImageWithCaptionFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentImageWithCaptionImageWithCaptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentImageWithCaptionImageWithCaptionFiltersInput>>>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentImageWithCaptionImageWithCaptionInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLandingHeroSlides = {
  __typename?: 'ComponentLandingHeroSlides';
  caption?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Enum_Componentlandingheroslides_Category>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slideImage?: Maybe<UploadFileEntityResponse>;
};

export type ComponentLandingHeroSlidesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLandingHeroSlidesFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  category?: InputMaybe<StringFilterInput>;
  ctaText?: InputMaybe<StringFilterInput>;
  ctaURL?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLandingHeroSlidesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLandingHeroSlidesFiltersInput>>>;
};

export type ComponentLandingHeroSlidesInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Enum_Componentlandingheroslides_Category>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  ctaURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slideImage?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentPressItemPressItem = {
  __typename?: 'ComponentPressItemPressItem';
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  publication?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentPressItemPressItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPressItemPressItemFiltersInput>>>;
  date?: InputMaybe<DateFilterInput>;
  not?: InputMaybe<ComponentPressItemPressItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPressItemPressItemFiltersInput>>>;
  publication?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentPressItemPressItemInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  publication?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProjectMetadataProjectMetadata = {
  __typename?: 'ComponentProjectMetadataProjectMetadata';
  Project?: Maybe<Projects_Metadata>;
  id: Scalars['ID']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
};

export type ComponentProjectMetadataProjectMetadataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  not?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  projectId?: InputMaybe<StringFilterInput>;
};

export type ComponentProjectMetadataProjectMetadataFiltersInput_Remote_Rel_Projects_MetadataadditionalExhibition = {
  and?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  not?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  projectId?: InputMaybe<StringFilterInput_Remote_Rel_Projects_MetadataadditionalExhibition>;
};

export type ComponentProjectMetadataProjectMetadataFiltersInput_Remote_Rel_Projects_Metadataarticle = {
  and?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  not?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  projectId?: InputMaybe<StringFilterInput_Remote_Rel_Projects_Metadataarticle>;
};

export type ComponentProjectMetadataProjectMetadataFiltersInput_Remote_Rel_Projects_MetadataartistPage = {
  and?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  not?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  projectId?: InputMaybe<StringFilterInput_Remote_Rel_Projects_MetadataartistPage>;
};

export type ComponentProjectMetadataProjectMetadataFiltersInput_Remote_Rel_Projects_Metadataexhibition = {
  and?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  not?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>>>;
  projectId?: InputMaybe<StringFilterInput_Remote_Rel_Projects_Metadataexhibition>;
};

export type ComponentProjectMetadataProjectMetadataInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentReleaseInfoReleaseInfo = {
  __typename?: 'ComponentReleaseInfoReleaseInfo';
  AuctionEndTime?: Maybe<Scalars['DateTime']['output']>;
  AuctionStartTime: Scalars['DateTime']['output'];
  CustomAuctionName?: Maybe<Scalars['String']['output']>;
  CustomDescription?: Maybe<Scalars['String']['output']>;
  EndPrice?: Maybe<Scalars['String']['output']>;
  MinterMaxInvocations?: Maybe<Scalars['Int']['output']>;
  MinterType: MinterInfoEntityResponse;
  StartPrice?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentReleaseInfoReleaseInfoFiltersInput = {
  AuctionEndTime?: InputMaybe<DateTimeFilterInput>;
  AuctionStartTime?: InputMaybe<DateTimeFilterInput>;
  CustomAuctionName?: InputMaybe<StringFilterInput>;
  CustomDescription?: InputMaybe<StringFilterInput>;
  EndPrice?: InputMaybe<StringFilterInput>;
  MinterMaxInvocations?: InputMaybe<IntFilterInput>;
  MinterType?: InputMaybe<MinterInfoFiltersInput>;
  StartPrice?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentReleaseInfoReleaseInfoFiltersInput>>>;
  not?: InputMaybe<ComponentReleaseInfoReleaseInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentReleaseInfoReleaseInfoFiltersInput>>>;
};

export type ComponentReleaseInfoReleaseInfoInput = {
  AuctionEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  AuctionStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  CustomAuctionName?: InputMaybe<Scalars['String']['input']>;
  CustomDescription?: InputMaybe<Scalars['String']['input']>;
  EndPrice?: InputMaybe<Scalars['String']['input']>;
  MinterMaxInvocations?: InputMaybe<Scalars['Int']['input']>;
  MinterType?: InputMaybe<Scalars['ID']['input']>;
  StartPrice?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSpectrumArticleSpectrumArticle = {
  __typename?: 'ComponentSpectrumArticleSpectrumArticle';
  id: Scalars['ID']['output'];
  previewImage?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentSpectrumArticleSpectrumArticleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSpectrumArticleSpectrumArticleFiltersInput>>>;
  not?: InputMaybe<ComponentSpectrumArticleSpectrumArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSpectrumArticleSpectrumArticleFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSpectrumArticleSpectrumArticleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  previewImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Contract = {
  __typename?: 'Contract';
  admin: Scalars['Bytes']['output'];
  /** Automatically approve all artist split proposals (used on V3 Engine contracts) */
  autoApproveArtistSplitProposals?: Maybe<Scalars['Boolean']['output']>;
  /** Core contract version (populated on V3 and-on) */
  coreVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['BigInt']['output'];
  /** Curation registry contract address */
  curationRegistry?: Maybe<Scalars['Bytes']['output']>;
  /** Default address that receives secondary sales platform provider royalties when adding new projects (null for pre-V3 contracts) */
  defaultEnginePlatformProviderSecondarySalesAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Default basis points of secondary sales allocated to the platform provider when adding new projects (null for pre-V3 contracts) */
  defaultEnginePlatformProviderSecondarySalesBPS?: Maybe<Scalars['BigInt']['output']>;
  /** Default address that receives secondary sales render provider royalties when adding new projects (null for pre-V3 contracts) */
  defaultRenderProviderSecondarySalesAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Default basis points of secondary sales allocated to the render provider when adding new projects (null for pre-V3 contracts) */
  defaultRenderProviderSecondarySalesBPS?: Maybe<Scalars['BigInt']['output']>;
  /** On chain pointer to dependency registry contract - not used for any on-chain logic or allowlisting. Null if not populated or set to non-indexed Dependency Registry address. */
  dependencyRegistry?: Maybe<DependencyRegistry>;
  /** Address that receives primary sales platform fees, only for V3_Engine contracts */
  enginePlatformProviderAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Percentage of primary sales allocated to the platform, only for V3_Engine contracts */
  enginePlatformProviderPercentage?: Maybe<Scalars['BigInt']['output']>;
  /** Unique identifier made up of the contract address */
  id: Scalars['ID']['output'];
  /** Latest Override Allowlisted on Dependency Registry; only populated if allowlisted on a DependencyRegistry instead of the CoreRegistry */
  latestDependencyRegistryOverrideAllowlistedOn?: Maybe<DependencyRegistry>;
  /** List of contracts that are allowed to mint, equal to the single minterFilter address for V3 contracts */
  mintWhitelisted: Array<Scalars['Bytes']['output']>;
  /** Associated minter filter contract, if any */
  minterFilter?: Maybe<MinterFilter>;
  /** New projects forbidden (can only be true on V3+ contracts) */
  newProjectsForbidden: Scalars['Boolean']['output'];
  nextProjectId: Scalars['BigInt']['output'];
  /** On chain pointer to on-chain generator contract address - not used for any on-chain logic or allowlisting. Null if not populated on chain. */
  onChainGenerator?: Maybe<Scalars['Bytes']['output']>;
  preferredArweaveGateway?: Maybe<Scalars['String']['output']>;
  preferredIPFSGateway?: Maybe<Scalars['String']['output']>;
  /** List of projects on the contract */
  projects?: Maybe<Array<Project>>;
  /** Randomizer contract used to generate token hashes */
  randomizerContract?: Maybe<Scalars['Bytes']['output']>;
  /** Latest core registry that this contract is registered with, if any (used for indexing purposes) */
  registeredOn?: Maybe<CoreRegistry>;
  /** Address that receives primary sales platform fees */
  renderProviderAddress: Scalars['Bytes']['output'];
  /** Percentage of primary sales allocated to the platform */
  renderProviderPercentage: Scalars['BigInt']['output'];
  /** Curent royalty split provider contract address, used on v3.2 and-on */
  royaltySplitProvider?: Maybe<Scalars['Bytes']['output']>;
  /** List of tokens on the contract */
  tokens?: Maybe<Array<Token>>;
  /** Core contract type */
  type: CoreType;
  updatedAt: Scalars['BigInt']['output'];
  /** Accounts whitelisted on the contract */
  whitelisted?: Maybe<Array<Whitelisting>>;
};


export type ContractProjectsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Project_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Project_Filter>;
};


export type ContractTokensArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Token_Filter>;
};


export type ContractWhitelistedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Whitelisting_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Whitelisting_Filter>;
};

export type Contract_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  admin?: InputMaybe<Scalars['Bytes']['input']>;
  admin_contains?: InputMaybe<Scalars['Bytes']['input']>;
  admin_gt?: InputMaybe<Scalars['Bytes']['input']>;
  admin_gte?: InputMaybe<Scalars['Bytes']['input']>;
  admin_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  admin_lt?: InputMaybe<Scalars['Bytes']['input']>;
  admin_lte?: InputMaybe<Scalars['Bytes']['input']>;
  admin_not?: InputMaybe<Scalars['Bytes']['input']>;
  admin_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  admin_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Contract_Filter>>>;
  autoApproveArtistSplitProposals?: InputMaybe<Scalars['Boolean']['input']>;
  autoApproveArtistSplitProposals_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  autoApproveArtistSplitProposals_not?: InputMaybe<Scalars['Boolean']['input']>;
  autoApproveArtistSplitProposals_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  coreVersion?: InputMaybe<Scalars['String']['input']>;
  coreVersion_contains?: InputMaybe<Scalars['String']['input']>;
  coreVersion_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  coreVersion_ends_with?: InputMaybe<Scalars['String']['input']>;
  coreVersion_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreVersion_gt?: InputMaybe<Scalars['String']['input']>;
  coreVersion_gte?: InputMaybe<Scalars['String']['input']>;
  coreVersion_in?: InputMaybe<Array<Scalars['String']['input']>>;
  coreVersion_lt?: InputMaybe<Scalars['String']['input']>;
  coreVersion_lte?: InputMaybe<Scalars['String']['input']>;
  coreVersion_not?: InputMaybe<Scalars['String']['input']>;
  coreVersion_not_contains?: InputMaybe<Scalars['String']['input']>;
  coreVersion_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  coreVersion_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  coreVersion_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreVersion_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  coreVersion_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  coreVersion_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreVersion_starts_with?: InputMaybe<Scalars['String']['input']>;
  coreVersion_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  curationRegistry?: InputMaybe<Scalars['Bytes']['input']>;
  curationRegistry_contains?: InputMaybe<Scalars['Bytes']['input']>;
  curationRegistry_gt?: InputMaybe<Scalars['Bytes']['input']>;
  curationRegistry_gte?: InputMaybe<Scalars['Bytes']['input']>;
  curationRegistry_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  curationRegistry_lt?: InputMaybe<Scalars['Bytes']['input']>;
  curationRegistry_lte?: InputMaybe<Scalars['Bytes']['input']>;
  curationRegistry_not?: InputMaybe<Scalars['Bytes']['input']>;
  curationRegistry_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  curationRegistry_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  defaultEnginePlatformProviderSecondarySalesAddress?: InputMaybe<Scalars['Bytes']['input']>;
  defaultEnginePlatformProviderSecondarySalesAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  defaultEnginePlatformProviderSecondarySalesAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  defaultEnginePlatformProviderSecondarySalesAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  defaultEnginePlatformProviderSecondarySalesAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  defaultEnginePlatformProviderSecondarySalesAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  defaultEnginePlatformProviderSecondarySalesAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  defaultEnginePlatformProviderSecondarySalesAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  defaultEnginePlatformProviderSecondarySalesAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  defaultEnginePlatformProviderSecondarySalesAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  defaultEnginePlatformProviderSecondarySalesBPS?: InputMaybe<Scalars['BigInt']['input']>;
  defaultEnginePlatformProviderSecondarySalesBPS_gt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultEnginePlatformProviderSecondarySalesBPS_gte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultEnginePlatformProviderSecondarySalesBPS_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultEnginePlatformProviderSecondarySalesBPS_lt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultEnginePlatformProviderSecondarySalesBPS_lte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultEnginePlatformProviderSecondarySalesBPS_not?: InputMaybe<Scalars['BigInt']['input']>;
  defaultEnginePlatformProviderSecondarySalesBPS_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultRenderProviderSecondarySalesAddress?: InputMaybe<Scalars['Bytes']['input']>;
  defaultRenderProviderSecondarySalesAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  defaultRenderProviderSecondarySalesAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  defaultRenderProviderSecondarySalesAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  defaultRenderProviderSecondarySalesAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  defaultRenderProviderSecondarySalesAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  defaultRenderProviderSecondarySalesAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  defaultRenderProviderSecondarySalesAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  defaultRenderProviderSecondarySalesAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  defaultRenderProviderSecondarySalesAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  defaultRenderProviderSecondarySalesBPS?: InputMaybe<Scalars['BigInt']['input']>;
  defaultRenderProviderSecondarySalesBPS_gt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultRenderProviderSecondarySalesBPS_gte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultRenderProviderSecondarySalesBPS_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultRenderProviderSecondarySalesBPS_lt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultRenderProviderSecondarySalesBPS_lte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultRenderProviderSecondarySalesBPS_not?: InputMaybe<Scalars['BigInt']['input']>;
  defaultRenderProviderSecondarySalesBPS_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  dependencyRegistry?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_?: InputMaybe<DependencyRegistry_Filter>;
  dependencyRegistry_contains?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_gt?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_gte?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyRegistry_lt?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_lte?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_contains?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyRegistry_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  enginePlatformProviderAddress?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  enginePlatformProviderAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  enginePlatformProviderPercentage?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderPercentage_gt?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderPercentage_gte?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderPercentage_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  enginePlatformProviderPercentage_lt?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderPercentage_lte?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderPercentage_not?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderPercentage_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  latestDependencyRegistryOverrideAllowlistedOn?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_?: InputMaybe<DependencyRegistry_Filter>;
  latestDependencyRegistryOverrideAllowlistedOn_contains?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_ends_with?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_gt?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_gte?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_in?: InputMaybe<Array<Scalars['String']['input']>>;
  latestDependencyRegistryOverrideAllowlistedOn_lt?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_lte?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_not?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_not_contains?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  latestDependencyRegistryOverrideAllowlistedOn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_starts_with?: InputMaybe<Scalars['String']['input']>;
  latestDependencyRegistryOverrideAllowlistedOn_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  mintWhitelisted?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  mintWhitelisted_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  mintWhitelisted_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  mintWhitelisted_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  mintWhitelisted_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  mintWhitelisted_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  minterFilter?: InputMaybe<Scalars['String']['input']>;
  minterFilter_?: InputMaybe<MinterFilter_Filter>;
  minterFilter_contains?: InputMaybe<Scalars['String']['input']>;
  minterFilter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_ends_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_gt?: InputMaybe<Scalars['String']['input']>;
  minterFilter_gte?: InputMaybe<Scalars['String']['input']>;
  minterFilter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minterFilter_lt?: InputMaybe<Scalars['String']['input']>;
  minterFilter_lte?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_contains?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minterFilter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_starts_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  newProjectsForbidden?: InputMaybe<Scalars['Boolean']['input']>;
  newProjectsForbidden_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  newProjectsForbidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  newProjectsForbidden_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  nextProjectId?: InputMaybe<Scalars['BigInt']['input']>;
  nextProjectId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextProjectId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextProjectId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextProjectId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextProjectId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextProjectId_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextProjectId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  onChainGenerator?: InputMaybe<Scalars['Bytes']['input']>;
  onChainGenerator_contains?: InputMaybe<Scalars['Bytes']['input']>;
  onChainGenerator_gt?: InputMaybe<Scalars['Bytes']['input']>;
  onChainGenerator_gte?: InputMaybe<Scalars['Bytes']['input']>;
  onChainGenerator_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  onChainGenerator_lt?: InputMaybe<Scalars['Bytes']['input']>;
  onChainGenerator_lte?: InputMaybe<Scalars['Bytes']['input']>;
  onChainGenerator_not?: InputMaybe<Scalars['Bytes']['input']>;
  onChainGenerator_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  onChainGenerator_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Contract_Filter>>>;
  preferredArweaveGateway?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_contains?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_ends_with?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_gt?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_gte?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_in?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredArweaveGateway_lt?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_lte?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_not?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_not_contains?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredArweaveGateway_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_starts_with?: InputMaybe<Scalars['String']['input']>;
  preferredArweaveGateway_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_contains?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_ends_with?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_gt?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_gte?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_in?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredIPFSGateway_lt?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_lte?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_not?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_not_contains?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredIPFSGateway_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_starts_with?: InputMaybe<Scalars['String']['input']>;
  preferredIPFSGateway_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  projects_?: InputMaybe<Project_Filter>;
  randomizerContract?: InputMaybe<Scalars['Bytes']['input']>;
  randomizerContract_contains?: InputMaybe<Scalars['Bytes']['input']>;
  randomizerContract_gt?: InputMaybe<Scalars['Bytes']['input']>;
  randomizerContract_gte?: InputMaybe<Scalars['Bytes']['input']>;
  randomizerContract_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  randomizerContract_lt?: InputMaybe<Scalars['Bytes']['input']>;
  randomizerContract_lte?: InputMaybe<Scalars['Bytes']['input']>;
  randomizerContract_not?: InputMaybe<Scalars['Bytes']['input']>;
  randomizerContract_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  randomizerContract_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  registeredOn?: InputMaybe<Scalars['String']['input']>;
  registeredOn_?: InputMaybe<CoreRegistry_Filter>;
  registeredOn_contains?: InputMaybe<Scalars['String']['input']>;
  registeredOn_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  registeredOn_ends_with?: InputMaybe<Scalars['String']['input']>;
  registeredOn_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  registeredOn_gt?: InputMaybe<Scalars['String']['input']>;
  registeredOn_gte?: InputMaybe<Scalars['String']['input']>;
  registeredOn_in?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredOn_lt?: InputMaybe<Scalars['String']['input']>;
  registeredOn_lte?: InputMaybe<Scalars['String']['input']>;
  registeredOn_not?: InputMaybe<Scalars['String']['input']>;
  registeredOn_not_contains?: InputMaybe<Scalars['String']['input']>;
  registeredOn_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  registeredOn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  registeredOn_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  registeredOn_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredOn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  registeredOn_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  registeredOn_starts_with?: InputMaybe<Scalars['String']['input']>;
  registeredOn_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  renderProviderAddress?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  renderProviderAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  renderProviderPercentage?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderPercentage_gt?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderPercentage_gte?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderPercentage_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  renderProviderPercentage_lt?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderPercentage_lte?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderPercentage_not?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderPercentage_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  royaltySplitProvider?: InputMaybe<Scalars['Bytes']['input']>;
  royaltySplitProvider_contains?: InputMaybe<Scalars['Bytes']['input']>;
  royaltySplitProvider_gt?: InputMaybe<Scalars['Bytes']['input']>;
  royaltySplitProvider_gte?: InputMaybe<Scalars['Bytes']['input']>;
  royaltySplitProvider_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  royaltySplitProvider_lt?: InputMaybe<Scalars['Bytes']['input']>;
  royaltySplitProvider_lte?: InputMaybe<Scalars['Bytes']['input']>;
  royaltySplitProvider_not?: InputMaybe<Scalars['Bytes']['input']>;
  royaltySplitProvider_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  royaltySplitProvider_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokens_?: InputMaybe<Token_Filter>;
  type?: InputMaybe<CoreType>;
  type_in?: InputMaybe<Array<CoreType>>;
  type_not?: InputMaybe<CoreType>;
  type_not_in?: InputMaybe<Array<CoreType>>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  whitelisted_?: InputMaybe<Whitelisting_Filter>;
};

export enum Contract_OrderBy {
  Admin = 'admin',
  AutoApproveArtistSplitProposals = 'autoApproveArtistSplitProposals',
  CoreVersion = 'coreVersion',
  CreatedAt = 'createdAt',
  CurationRegistry = 'curationRegistry',
  DefaultEnginePlatformProviderSecondarySalesAddress = 'defaultEnginePlatformProviderSecondarySalesAddress',
  DefaultEnginePlatformProviderSecondarySalesBps = 'defaultEnginePlatformProviderSecondarySalesBPS',
  DefaultRenderProviderSecondarySalesAddress = 'defaultRenderProviderSecondarySalesAddress',
  DefaultRenderProviderSecondarySalesBps = 'defaultRenderProviderSecondarySalesBPS',
  DependencyRegistry = 'dependencyRegistry',
  DependencyRegistryId = 'dependencyRegistry__id',
  DependencyRegistryOwner = 'dependencyRegistry__owner',
  DependencyRegistryUpdatedAt = 'dependencyRegistry__updatedAt',
  EnginePlatformProviderAddress = 'enginePlatformProviderAddress',
  EnginePlatformProviderPercentage = 'enginePlatformProviderPercentage',
  Id = 'id',
  LatestDependencyRegistryOverrideAllowlistedOn = 'latestDependencyRegistryOverrideAllowlistedOn',
  LatestDependencyRegistryOverrideAllowlistedOnId = 'latestDependencyRegistryOverrideAllowlistedOn__id',
  LatestDependencyRegistryOverrideAllowlistedOnOwner = 'latestDependencyRegistryOverrideAllowlistedOn__owner',
  LatestDependencyRegistryOverrideAllowlistedOnUpdatedAt = 'latestDependencyRegistryOverrideAllowlistedOn__updatedAt',
  MintWhitelisted = 'mintWhitelisted',
  MinterFilter = 'minterFilter',
  MinterFilterId = 'minterFilter__id',
  MinterFilterType = 'minterFilter__type',
  MinterFilterUpdatedAt = 'minterFilter__updatedAt',
  NewProjectsForbidden = 'newProjectsForbidden',
  NextProjectId = 'nextProjectId',
  OnChainGenerator = 'onChainGenerator',
  PreferredArweaveGateway = 'preferredArweaveGateway',
  PreferredIpfsGateway = 'preferredIPFSGateway',
  Projects = 'projects',
  RandomizerContract = 'randomizerContract',
  RegisteredOn = 'registeredOn',
  RegisteredOnId = 'registeredOn__id',
  RenderProviderAddress = 'renderProviderAddress',
  RenderProviderPercentage = 'renderProviderPercentage',
  RoyaltySplitProvider = 'royaltySplitProvider',
  Tokens = 'tokens',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Whitelisted = 'whitelisted'
}

export type CoreRegistry = {
  __typename?: 'CoreRegistry';
  /** Latest dependency registry to use this Core Registry */
  dependencyRegistry?: Maybe<DependencyRegistry>;
  /**
   * Unique identifier made up of the Core Registry's contract address (legacy name was Engine Registry).
   * Note: For legacy MinterFilters, this is a dummy ID, equal to the address of the single core contract
   * associated with the minter filter.
   *
   */
  id: Scalars['ID']['output'];
  /** All core contracts that are registered on this CoreRegistry, when this is most recent Core Registry to add the contract */
  registeredContracts?: Maybe<Array<Contract>>;
};


export type CoreRegistryRegisteredContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Contract_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Contract_Filter>;
};

export type CoreRegistry_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<CoreRegistry_Filter>>>;
  dependencyRegistry?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_?: InputMaybe<DependencyRegistry_Filter>;
  dependencyRegistry_contains?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_gt?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_gte?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyRegistry_lt?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_lte?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_contains?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyRegistry_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<CoreRegistry_Filter>>>;
  registeredContracts_?: InputMaybe<Contract_Filter>;
};

export enum CoreRegistry_OrderBy {
  DependencyRegistry = 'dependencyRegistry',
  DependencyRegistryId = 'dependencyRegistry__id',
  DependencyRegistryOwner = 'dependencyRegistry__owner',
  DependencyRegistryUpdatedAt = 'dependencyRegistry__updatedAt',
  Id = 'id',
  RegisteredContracts = 'registeredContracts'
}

export enum CoreType {
  /** First Art Blocks flagship core */
  GenArt721CoreV0 = 'GenArt721CoreV0',
  /** Second Art Blocks flagship core */
  GenArt721CoreV1 = 'GenArt721CoreV1',
  /** Art Blocks Engine & Partner cores */
  GenArt721CoreV2 = 'GenArt721CoreV2',
  /** Third Art Blocks flagship core */
  GenArt721CoreV3 = 'GenArt721CoreV3',
  /** V3 Derivative - Art Blocks Engine core */
  GenArt721CoreV3Engine = 'GenArt721CoreV3_Engine',
  /** V3 Derivative - Art Blocks Engine Flex core */
  GenArt721CoreV3EngineFlex = 'GenArt721CoreV3_Engine_Flex'
}

export type CreateApplicationInput = {
  artistName: Scalars['String']['input'];
  creatorHistory?: InputMaybe<Scalars['String']['input']>;
  discord?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  originalityAck: Scalars['Boolean']['input'];
  portfolio: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  returningArtist?: InputMaybe<Scalars['Boolean']['input']>;
  technicalProficiency: Scalars['String']['input'];
  twitter?: InputMaybe<Scalars['String']['input']>;
  walletAddress: Scalars['String']['input'];
};

export type CreateApplicationOutput = {
  __typename?: 'CreateApplicationOutput';
  success: Scalars['Boolean']['output'];
};

export type CuratedHomePage = {
  __typename?: 'CuratedHomePage';
  Slides?: Maybe<Array<Maybe<ComponentCuratedHomePageCuratedHomePageItem>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CuratedHomePageSlidesArgs = {
  filters?: InputMaybe<ComponentCuratedHomePageCuratedHomePageItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CuratedHomePageEntity = {
  __typename?: 'CuratedHomePageEntity';
  attributes?: Maybe<CuratedHomePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CuratedHomePageEntityResponse = {
  __typename?: 'CuratedHomePageEntityResponse';
  data?: Maybe<CuratedHomePageEntity>;
};

export type CuratedHomePageInput = {
  Slides?: InputMaybe<Array<InputMaybe<ComponentCuratedHomePageCuratedHomePageItemInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Dependency = {
  __typename?: 'Dependency';
  /** Number of additional CDNs for this dependency */
  additionalCDNCount: Scalars['BigInt']['output'];
  /** Additional CDNs for this dependency */
  additionalCDNs: Array<DependencyAdditionalCdn>;
  /** Number of additional repositories for this dependency */
  additionalRepositories: Array<DependencyAdditionalRepository>;
  /** Additional repositories for this dependency */
  additionalRepositoryCount: Scalars['BigInt']['output'];
  /** Depenency registry contract that this dependency is registered on */
  dependencyRegistry: DependencyRegistry;
  /** Unique identifier made up of dependency name and version separated by an @ symbol (e.g. p5js@1.0.0) */
  id: Scalars['ID']['output'];
  /** License Type of this dependency */
  licenseType: License;
  /** Preffered CDN for this dependency */
  preferredCDN: Scalars['String']['output'];
  /** Preffered repository for this dependency */
  preferredRepository: Scalars['String']['output'];
  /** Concatenated string of all scripts for this dependency */
  script?: Maybe<Scalars['String']['output']>;
  /** Number of on-chain scripts for this dependency */
  scriptCount: Scalars['BigInt']['output'];
  /** List of on-chain scripts that for this dependency */
  scripts: Array<DependencyScript>;
  /** Timestamp of last update */
  updatedAt: Scalars['BigInt']['output'];
  /** Reference website for this dependency (e.g. https://p5js.org) */
  website: Scalars['String']['output'];
};


export type DependencyAdditionalCdNsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DependencyAdditionalCdn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DependencyAdditionalCdn_Filter>;
};


export type DependencyAdditionalRepositoriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DependencyAdditionalRepository_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DependencyAdditionalRepository_Filter>;
};


export type DependencyScriptsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DependencyScript_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DependencyScript_Filter>;
};

export type DependencyAdditionalCdn = {
  __typename?: 'DependencyAdditionalCDN';
  /** URL of the CDN */
  cdn: Scalars['String']['output'];
  /** Dependency this additional CDN belongs to */
  dependency: Dependency;
  /** Unique identifier made up of dependency id and index */
  id: Scalars['ID']['output'];
  /** Index of this additional CDN */
  index: Scalars['BigInt']['output'];
};

export type DependencyAdditionalCdn_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DependencyAdditionalCdn_Filter>>>;
  cdn?: InputMaybe<Scalars['String']['input']>;
  cdn_contains?: InputMaybe<Scalars['String']['input']>;
  cdn_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  cdn_ends_with?: InputMaybe<Scalars['String']['input']>;
  cdn_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  cdn_gt?: InputMaybe<Scalars['String']['input']>;
  cdn_gte?: InputMaybe<Scalars['String']['input']>;
  cdn_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cdn_lt?: InputMaybe<Scalars['String']['input']>;
  cdn_lte?: InputMaybe<Scalars['String']['input']>;
  cdn_not?: InputMaybe<Scalars['String']['input']>;
  cdn_not_contains?: InputMaybe<Scalars['String']['input']>;
  cdn_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  cdn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  cdn_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  cdn_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cdn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  cdn_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  cdn_starts_with?: InputMaybe<Scalars['String']['input']>;
  cdn_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency?: InputMaybe<Scalars['String']['input']>;
  dependency_?: InputMaybe<Dependency_Filter>;
  dependency_contains?: InputMaybe<Scalars['String']['input']>;
  dependency_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependency_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_gt?: InputMaybe<Scalars['String']['input']>;
  dependency_gte?: InputMaybe<Scalars['String']['input']>;
  dependency_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependency_lt?: InputMaybe<Scalars['String']['input']>;
  dependency_lte?: InputMaybe<Scalars['String']['input']>;
  dependency_not?: InputMaybe<Scalars['String']['input']>;
  dependency_not_contains?: InputMaybe<Scalars['String']['input']>;
  dependency_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependency_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependency_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependency_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependency_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DependencyAdditionalCdn_Filter>>>;
};

export enum DependencyAdditionalCdn_OrderBy {
  Cdn = 'cdn',
  Dependency = 'dependency',
  DependencyAdditionalCdnCount = 'dependency__additionalCDNCount',
  DependencyAdditionalRepositoryCount = 'dependency__additionalRepositoryCount',
  DependencyId = 'dependency__id',
  DependencyPreferredCdn = 'dependency__preferredCDN',
  DependencyPreferredRepository = 'dependency__preferredRepository',
  DependencyScript = 'dependency__script',
  DependencyScriptCount = 'dependency__scriptCount',
  DependencyUpdatedAt = 'dependency__updatedAt',
  DependencyWebsite = 'dependency__website',
  Id = 'id',
  Index = 'index'
}

export type DependencyAdditionalRepository = {
  __typename?: 'DependencyAdditionalRepository';
  /** Dependency this additional repository belongs to */
  dependency: Dependency;
  /** Unique identifier made up of dependency id and index */
  id: Scalars['ID']['output'];
  /** Index of this additional repository */
  index: Scalars['BigInt']['output'];
  /** URL of the repository */
  repository: Scalars['String']['output'];
};

export type DependencyAdditionalRepository_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DependencyAdditionalRepository_Filter>>>;
  dependency?: InputMaybe<Scalars['String']['input']>;
  dependency_?: InputMaybe<Dependency_Filter>;
  dependency_contains?: InputMaybe<Scalars['String']['input']>;
  dependency_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependency_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_gt?: InputMaybe<Scalars['String']['input']>;
  dependency_gte?: InputMaybe<Scalars['String']['input']>;
  dependency_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependency_lt?: InputMaybe<Scalars['String']['input']>;
  dependency_lte?: InputMaybe<Scalars['String']['input']>;
  dependency_not?: InputMaybe<Scalars['String']['input']>;
  dependency_not_contains?: InputMaybe<Scalars['String']['input']>;
  dependency_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependency_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependency_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependency_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependency_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DependencyAdditionalRepository_Filter>>>;
  repository?: InputMaybe<Scalars['String']['input']>;
  repository_contains?: InputMaybe<Scalars['String']['input']>;
  repository_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  repository_ends_with?: InputMaybe<Scalars['String']['input']>;
  repository_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  repository_gt?: InputMaybe<Scalars['String']['input']>;
  repository_gte?: InputMaybe<Scalars['String']['input']>;
  repository_in?: InputMaybe<Array<Scalars['String']['input']>>;
  repository_lt?: InputMaybe<Scalars['String']['input']>;
  repository_lte?: InputMaybe<Scalars['String']['input']>;
  repository_not?: InputMaybe<Scalars['String']['input']>;
  repository_not_contains?: InputMaybe<Scalars['String']['input']>;
  repository_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  repository_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  repository_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  repository_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  repository_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  repository_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  repository_starts_with?: InputMaybe<Scalars['String']['input']>;
  repository_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum DependencyAdditionalRepository_OrderBy {
  Dependency = 'dependency',
  DependencyAdditionalCdnCount = 'dependency__additionalCDNCount',
  DependencyAdditionalRepositoryCount = 'dependency__additionalRepositoryCount',
  DependencyId = 'dependency__id',
  DependencyPreferredCdn = 'dependency__preferredCDN',
  DependencyPreferredRepository = 'dependency__preferredRepository',
  DependencyScript = 'dependency__script',
  DependencyScriptCount = 'dependency__scriptCount',
  DependencyUpdatedAt = 'dependency__updatedAt',
  DependencyWebsite = 'dependency__website',
  Id = 'id',
  Index = 'index',
  Repository = 'repository'
}

export type DependencyRegistry = {
  __typename?: 'DependencyRegistry';
  /** Core registry that defines the base set of contracts supported by this registry */
  coreRegistry?: Maybe<CoreRegistry>;
  /** List of dependencies that are registered on this registry contract */
  dependencies?: Maybe<Array<Dependency>>;
  /** Unique identifier made up of dependency registry contract address */
  id: Scalars['Bytes']['output'];
  /** Current owner of this contract */
  owner: Scalars['Bytes']['output'];
  /** List of core contracts that are explicitly allowlisted on this registry, extending those on the CoreRegistry */
  supportedCoreContractsOverride: Array<Contract>;
  /** Timestamp of last update */
  updatedAt: Scalars['BigInt']['output'];
};


export type DependencyRegistryDependenciesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Dependency_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dependency_Filter>;
};


export type DependencyRegistrySupportedCoreContractsOverrideArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Contract_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Contract_Filter>;
};

export type DependencyRegistry_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DependencyRegistry_Filter>>>;
  coreRegistry?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_?: InputMaybe<CoreRegistry_Filter>;
  coreRegistry_contains?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_ends_with?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_gt?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_gte?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_in?: InputMaybe<Array<Scalars['String']['input']>>;
  coreRegistry_lt?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_lte?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_contains?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  coreRegistry_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_starts_with?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencies_?: InputMaybe<Dependency_Filter>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DependencyRegistry_Filter>>>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  supportedCoreContractsOverride_?: InputMaybe<Contract_Filter>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum DependencyRegistry_OrderBy {
  CoreRegistry = 'coreRegistry',
  CoreRegistryId = 'coreRegistry__id',
  Dependencies = 'dependencies',
  Id = 'id',
  Owner = 'owner',
  SupportedCoreContractsOverride = 'supportedCoreContractsOverride',
  UpdatedAt = 'updatedAt'
}

export type DependencyScript = {
  __typename?: 'DependencyScript';
  /** Address of the bytecode storage contract for this script */
  address: Scalars['Bytes']['output'];
  /** Dependency this script belongs to */
  dependency: Dependency;
  /** Unique identifier made up of dependency id and index */
  id: Scalars['ID']['output'];
  /** Index of this script */
  index: Scalars['BigInt']['output'];
  /** Contents of script */
  script: Scalars['String']['output'];
};

export type DependencyScript_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['Bytes']['input']>;
  address_contains?: InputMaybe<Scalars['Bytes']['input']>;
  address_gt?: InputMaybe<Scalars['Bytes']['input']>;
  address_gte?: InputMaybe<Scalars['Bytes']['input']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  address_lt?: InputMaybe<Scalars['Bytes']['input']>;
  address_lte?: InputMaybe<Scalars['Bytes']['input']>;
  address_not?: InputMaybe<Scalars['Bytes']['input']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<DependencyScript_Filter>>>;
  dependency?: InputMaybe<Scalars['String']['input']>;
  dependency_?: InputMaybe<Dependency_Filter>;
  dependency_contains?: InputMaybe<Scalars['String']['input']>;
  dependency_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependency_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_gt?: InputMaybe<Scalars['String']['input']>;
  dependency_gte?: InputMaybe<Scalars['String']['input']>;
  dependency_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependency_lt?: InputMaybe<Scalars['String']['input']>;
  dependency_lte?: InputMaybe<Scalars['String']['input']>;
  dependency_not?: InputMaybe<Scalars['String']['input']>;
  dependency_not_contains?: InputMaybe<Scalars['String']['input']>;
  dependency_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependency_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependency_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependency_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependency_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependency_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DependencyScript_Filter>>>;
  script?: InputMaybe<Scalars['String']['input']>;
  script_contains?: InputMaybe<Scalars['String']['input']>;
  script_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  script_ends_with?: InputMaybe<Scalars['String']['input']>;
  script_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_gt?: InputMaybe<Scalars['String']['input']>;
  script_gte?: InputMaybe<Scalars['String']['input']>;
  script_in?: InputMaybe<Array<Scalars['String']['input']>>;
  script_lt?: InputMaybe<Scalars['String']['input']>;
  script_lte?: InputMaybe<Scalars['String']['input']>;
  script_not?: InputMaybe<Scalars['String']['input']>;
  script_not_contains?: InputMaybe<Scalars['String']['input']>;
  script_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  script_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  script_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  script_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  script_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_starts_with?: InputMaybe<Scalars['String']['input']>;
  script_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum DependencyScript_OrderBy {
  Address = 'address',
  Dependency = 'dependency',
  DependencyAdditionalCdnCount = 'dependency__additionalCDNCount',
  DependencyAdditionalRepositoryCount = 'dependency__additionalRepositoryCount',
  DependencyId = 'dependency__id',
  DependencyPreferredCdn = 'dependency__preferredCDN',
  DependencyPreferredRepository = 'dependency__preferredRepository',
  DependencyScript = 'dependency__script',
  DependencyScriptCount = 'dependency__scriptCount',
  DependencyUpdatedAt = 'dependency__updatedAt',
  DependencyWebsite = 'dependency__website',
  Id = 'id',
  Index = 'index',
  Script = 'script'
}

export type Dependency_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  additionalCDNCount?: InputMaybe<Scalars['BigInt']['input']>;
  additionalCDNCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalCDNCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalCDNCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalCDNCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalCDNCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalCDNCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  additionalCDNCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalCDNs_?: InputMaybe<DependencyAdditionalCdn_Filter>;
  additionalRepositories_?: InputMaybe<DependencyAdditionalRepository_Filter>;
  additionalRepositoryCount?: InputMaybe<Scalars['BigInt']['input']>;
  additionalRepositoryCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalRepositoryCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalRepositoryCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalRepositoryCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalRepositoryCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalRepositoryCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  additionalRepositoryCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Dependency_Filter>>>;
  dependencyRegistry?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_?: InputMaybe<DependencyRegistry_Filter>;
  dependencyRegistry_contains?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_gt?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_gte?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyRegistry_lt?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_lte?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_contains?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencyRegistry_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_starts_with?: InputMaybe<Scalars['String']['input']>;
  dependencyRegistry_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseType?: InputMaybe<Scalars['String']['input']>;
  licenseType_?: InputMaybe<License_Filter>;
  licenseType_contains?: InputMaybe<Scalars['String']['input']>;
  licenseType_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  licenseType_ends_with?: InputMaybe<Scalars['String']['input']>;
  licenseType_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  licenseType_gt?: InputMaybe<Scalars['String']['input']>;
  licenseType_gte?: InputMaybe<Scalars['String']['input']>;
  licenseType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseType_lt?: InputMaybe<Scalars['String']['input']>;
  licenseType_lte?: InputMaybe<Scalars['String']['input']>;
  licenseType_not?: InputMaybe<Scalars['String']['input']>;
  licenseType_not_contains?: InputMaybe<Scalars['String']['input']>;
  licenseType_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  licenseType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  licenseType_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  licenseType_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  licenseType_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  licenseType_starts_with?: InputMaybe<Scalars['String']['input']>;
  licenseType_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Dependency_Filter>>>;
  preferredCDN?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_contains?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_ends_with?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_gt?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_gte?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_in?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredCDN_lt?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_lte?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_not?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_not_contains?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredCDN_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_starts_with?: InputMaybe<Scalars['String']['input']>;
  preferredCDN_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredRepository?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_contains?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_ends_with?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_gt?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_gte?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_in?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredRepository_lt?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_lte?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_not?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_not_contains?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredRepository_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_starts_with?: InputMaybe<Scalars['String']['input']>;
  preferredRepository_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  scriptCount?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  scriptCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  script_contains?: InputMaybe<Scalars['String']['input']>;
  script_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  script_ends_with?: InputMaybe<Scalars['String']['input']>;
  script_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_gt?: InputMaybe<Scalars['String']['input']>;
  script_gte?: InputMaybe<Scalars['String']['input']>;
  script_in?: InputMaybe<Array<Scalars['String']['input']>>;
  script_lt?: InputMaybe<Scalars['String']['input']>;
  script_lte?: InputMaybe<Scalars['String']['input']>;
  script_not?: InputMaybe<Scalars['String']['input']>;
  script_not_contains?: InputMaybe<Scalars['String']['input']>;
  script_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  script_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  script_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  script_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  script_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_starts_with?: InputMaybe<Scalars['String']['input']>;
  script_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scripts_?: InputMaybe<DependencyScript_Filter>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  website?: InputMaybe<Scalars['String']['input']>;
  website_contains?: InputMaybe<Scalars['String']['input']>;
  website_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  website_ends_with?: InputMaybe<Scalars['String']['input']>;
  website_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  website_gt?: InputMaybe<Scalars['String']['input']>;
  website_gte?: InputMaybe<Scalars['String']['input']>;
  website_in?: InputMaybe<Array<Scalars['String']['input']>>;
  website_lt?: InputMaybe<Scalars['String']['input']>;
  website_lte?: InputMaybe<Scalars['String']['input']>;
  website_not?: InputMaybe<Scalars['String']['input']>;
  website_not_contains?: InputMaybe<Scalars['String']['input']>;
  website_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  website_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  website_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  website_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  website_starts_with?: InputMaybe<Scalars['String']['input']>;
  website_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Dependency_OrderBy {
  AdditionalCdnCount = 'additionalCDNCount',
  AdditionalCdNs = 'additionalCDNs',
  AdditionalRepositories = 'additionalRepositories',
  AdditionalRepositoryCount = 'additionalRepositoryCount',
  DependencyRegistry = 'dependencyRegistry',
  DependencyRegistryId = 'dependencyRegistry__id',
  DependencyRegistryOwner = 'dependencyRegistry__owner',
  DependencyRegistryUpdatedAt = 'dependencyRegistry__updatedAt',
  Id = 'id',
  LicenseType = 'licenseType',
  LicenseTypeId = 'licenseType__id',
  LicenseTypeUpdatedAt = 'licenseType__updatedAt',
  PreferredCdn = 'preferredCDN',
  PreferredRepository = 'preferredRepository',
  Script = 'script',
  ScriptCount = 'scriptCount',
  Scripts = 'scripts',
  UpdatedAt = 'updatedAt',
  Website = 'website'
}

export enum Enum_Article_Category {
  Education = 'EDUCATION',
  Interview = 'INTERVIEW',
  News = 'NEWS',
  Podcast = 'PODCAST',
  Video = 'VIDEO'
}

export enum Enum_Article_Homepagelocation {
  Bottom = 'bottom',
  Middle = 'middle',
  None = 'none',
  Top = 'top'
}

export enum Enum_Componentcuratedhomepagecuratedhomepageitem_Articletextalign {
  Left = 'Left',
  Right = 'Right'
}

export enum Enum_Componentcuratedhomepagecuratedhomepageitem_Slidetype {
  Article = 'Article',
  Exhibition = 'Exhibition',
  Project = 'Project'
}

export enum Enum_Componentcuratedhomepagetokenslideentry_Entrytype {
  Media = 'Media',
  OobToken = 'OOB_Token',
  Token = 'Token'
}

export enum Enum_Componenthomebentoitem_Type {
  Article = 'Article',
  ArtistProfile = 'Artist_Profile',
  Exhibition = 'Exhibition',
  Link = 'Link',
  Project = 'Project'
}

export enum Enum_Componentlandingheroslides_Category {
  Curated = 'curated',
  Platform = 'platform',
  Studio = 'studio'
}

export enum Enum_Exhibition_Exhibitionstage {
  Complete = 'Complete',
  Project_1 = 'Project_1',
  Project_2 = 'Project_2',
  Project_3 = 'Project_3',
  Project_4 = 'Project_4',
  Project_5 = 'Project_5',
  Project_6 = 'Project_6'
}

export enum Enum_Exhibition_Type {
  Group = 'group',
  Solo = 'solo'
}

export enum Exchange {
  /** LooksRare */
  LrV1 = 'LR_V1',
  /** Opensea Seaport */
  OsSp = 'OS_SP',
  /** Opensea V1 */
  OsV1 = 'OS_V1',
  /** Opensea V2 */
  OsV2 = 'OS_V2'
}

export type Exhibition = {
  __typename?: 'Exhibition';
  Collections: Array<Maybe<ComponentExhibitionsExhibitionCollection>>;
  ExhibitionStage?: Maybe<Enum_Exhibition_Exhibitionstage>;
  HeaderImage?: Maybe<UploadFileEntityResponse>;
  Tagline?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Type: Enum_Exhibition_Type;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seoMetaDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ExhibitionCollectionsArgs = {
  filters?: InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExhibitionEntity = {
  __typename?: 'ExhibitionEntity';
  attributes?: Maybe<Exhibition>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ExhibitionEntityResponse = {
  __typename?: 'ExhibitionEntityResponse';
  data?: Maybe<ExhibitionEntity>;
};

export type ExhibitionEntityResponseCollection = {
  __typename?: 'ExhibitionEntityResponseCollection';
  data: Array<ExhibitionEntity>;
  meta: ResponseCollectionMeta;
};

export type ExhibitionFiltersInput = {
  Collections?: InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput>;
  ExhibitionStage?: InputMaybe<StringFilterInput>;
  Tagline?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ExhibitionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ExhibitionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ExhibitionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seoMetaDescription?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ExhibitionFiltersInput_Remote_Rel_Projects_MetadataadditionalExhibition = {
  Collections?: InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput_Remote_Rel_Projects_MetadataadditionalExhibition>;
  ExhibitionStage?: InputMaybe<StringFilterInput>;
  Tagline?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ExhibitionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ExhibitionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ExhibitionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seoMetaDescription?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ExhibitionFiltersInput_Remote_Rel_Projects_Metadataexhibition = {
  Collections?: InputMaybe<ComponentExhibitionsExhibitionCollectionFiltersInput_Remote_Rel_Projects_Metadataexhibition>;
  ExhibitionStage?: InputMaybe<StringFilterInput>;
  Tagline?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ExhibitionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ExhibitionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ExhibitionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seoMetaDescription?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ExhibitionInput = {
  Collections?: InputMaybe<Array<InputMaybe<ComponentExhibitionsExhibitionCollectionInput>>>;
  ExhibitionStage?: InputMaybe<Enum_Exhibition_Exhibitionstage>;
  HeaderImage?: InputMaybe<Scalars['ID']['input']>;
  Tagline?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Enum_Exhibition_Type>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seoMetaDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = Article | ArtistEditorialPage | ComponentArtistEditorialPageExhibitions | ComponentArtistEditorialPageFeaturedWork | ComponentArtistEditorialPagePress | ComponentArtistEditorialPageProjectsCreated | ComponentArtistEditorialPageSpectrumArticles | ComponentCuratedHomePageCuratedHomePageItem | ComponentCuratedHomePageTokenSlideEntry | ComponentExhibitionsExhibitionCollection | ComponentGalleryGridItemGalleryGridItem | ComponentHighlightItemHighlightItem | ComponentHighlightItemProjectProject | ComponentHighlightItemTokenToken | ComponentHomeBentoItem | ComponentHomeHeroItem | ComponentImageWithCaptionImageWithCaption | ComponentLandingHeroSlides | ComponentPressItemPressItem | ComponentProjectMetadataProjectMetadata | ComponentReleaseInfoReleaseInfo | ComponentSpectrumArticleSpectrumArticle | CuratedHomePage | Exhibition | Highlight | HomePage | I18NLocale | LandingPage | MinterInfo | ProjectPage | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type Highlight = {
  __typename?: 'Highlight';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  item?: Maybe<Array<Maybe<ComponentHighlightItemHighlightItem>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type HighlightItemArgs = {
  filters?: InputMaybe<ComponentHighlightItemHighlightItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HighlightEntity = {
  __typename?: 'HighlightEntity';
  attributes?: Maybe<Highlight>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HighlightEntityResponse = {
  __typename?: 'HighlightEntityResponse';
  data?: Maybe<HighlightEntity>;
};

export type HighlightEntityResponseCollection = {
  __typename?: 'HighlightEntityResponseCollection';
  data: Array<HighlightEntity>;
  meta: ResponseCollectionMeta;
};

export type HighlightFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<HighlightFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  item?: InputMaybe<ComponentHighlightItemHighlightItemFiltersInput>;
  not?: InputMaybe<HighlightFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<HighlightFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type HighlightInput = {
  item?: InputMaybe<Array<InputMaybe<ComponentHighlightItemHighlightItemInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type HomePage = {
  __typename?: 'HomePage';
  HeroBento?: Maybe<Array<Maybe<ComponentHomeBentoItem>>>;
  HeroSection?: Maybe<Array<Maybe<ComponentHomeHeroItem>>>;
  SpotlightBento?: Maybe<Array<Maybe<ComponentHomeBentoItem>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type HomePageHeroBentoArgs = {
  filters?: InputMaybe<ComponentHomeBentoItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type HomePageHeroSectionArgs = {
  filters?: InputMaybe<ComponentHomeHeroItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type HomePageSpotlightBentoArgs = {
  filters?: InputMaybe<ComponentHomeBentoItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HomePageEntity = {
  __typename?: 'HomePageEntity';
  attributes?: Maybe<HomePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HomePageEntityResponse = {
  __typename?: 'HomePageEntityResponse';
  data?: Maybe<HomePageEntity>;
};

export type HomePageInput = {
  HeroBento?: InputMaybe<Array<InputMaybe<ComponentHomeBentoItemInput>>>;
  HeroSection?: InputMaybe<Array<InputMaybe<ComponentHomeHeroItemInput>>>;
  SpotlightBento?: InputMaybe<Array<InputMaybe<ComponentHomeBentoItemInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IpInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type LandingPage = {
  __typename?: 'LandingPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  heroSlides?: Maybe<Array<Maybe<ComponentLandingHeroSlides>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LandingPageHeroSlidesArgs = {
  filters?: InputMaybe<ComponentLandingHeroSlidesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LandingPageEntity = {
  __typename?: 'LandingPageEntity';
  attributes?: Maybe<LandingPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LandingPageEntityResponse = {
  __typename?: 'LandingPageEntityResponse';
  data?: Maybe<LandingPageEntity>;
};

export type LandingPageInput = {
  heroSlides?: InputMaybe<Array<InputMaybe<ComponentLandingHeroSlidesInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type License = {
  __typename?: 'License';
  /** Unique identifier made up of licenseType */
  id: Scalars['ID']['output'];
  /** Timestamp of last update */
  updatedAt: Scalars['BigInt']['output'];
};

export type License_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<License_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<License_Filter>>>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum License_OrderBy {
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type Minter = {
  __typename?: 'Minter';
  /** Configuration details used by specific minters (json string) */
  extraMinterDetails: Scalars['String']['output'];
  /** Unique identifier made up of minter contract address */
  id: Scalars['ID']['output'];
  /** Boolean representing if the Mitner is globally allowed on its associated minter filter */
  isGloballyAllowlistedOnMinterFilter: Scalars['Boolean']['output'];
  /** Associated Minter Filter */
  minterFilter: MinterFilter;
  /** Receipts for this minter, only for minters with settlement */
  receipts?: Maybe<Array<Receipt>>;
  /** Minter type - String if minter returns it's type, empty string otherwise */
  type: Scalars['String']['output'];
  updatedAt: Scalars['BigInt']['output'];
};


export type MinterReceiptsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Receipt_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Receipt_Filter>;
};

export type MinterFilter = {
  __typename?: 'MinterFilter';
  /**
   * Core contract registry used by this MinterFilter.
   * Note that for MinterFilterV0 & MinterFilterV1, a dummy CoreRegistry is created in the subgraph that
   * contains a single allowlisted core contract.
   *
   */
  coreRegistry: CoreRegistry;
  /** Unique identifier made up of minter filter contract address */
  id: Scalars['ID']['output'];
  /** Known minters that are tied to this MinterFilter, but are not necessarily approved on this MinterFilter */
  knownMinters: Array<Minter>;
  /**
   * Minters allowlisted at a contract-level on this MinterFilter. In general, this allows a core contract to
   * extend the global minter allowlist to allow minters that are not globally allowlisted.
   * Note: only used for MinterFilterV2+
   *
   */
  minterFilterContractAllowlists: Array<MinterFilterContractAllowlist>;
  /** Minters allowlisted globally on this MinterFilter */
  minterGlobalAllowlist: Array<Minter>;
  /**
   * Speficies which MinterFilter type this MinterFilter is
   *
   */
  type: MinterFilterType;
  updatedAt: Scalars['BigInt']['output'];
};


export type MinterFilterKnownMintersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Minter_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Minter_Filter>;
};


export type MinterFilterMinterFilterContractAllowlistsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MinterFilterContractAllowlist_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MinterFilterContractAllowlist_Filter>;
};


export type MinterFilterMinterGlobalAllowlistArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Minter_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Minter_Filter>;
};

export type MinterFilterContractAllowlist = {
  __typename?: 'MinterFilterContractAllowlist';
  /** Core contract */
  contract: Contract;
  /** Unique identifier made up of {minter filter contract address}-{core contract address} */
  id: Scalars['ID']['output'];
  /** Minter contract addresses allowed at the contract level (extending global MinterFilter allowlist) */
  minterContractAllowlist: Array<Minter>;
  /** MinterFilter contract */
  minterFilter: MinterFilter;
  updatedAt: Scalars['BigInt']['output'];
};


export type MinterFilterContractAllowlistMinterContractAllowlistArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Minter_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Minter_Filter>;
};

export type MinterFilterContractAllowlist_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MinterFilterContractAllowlist_Filter>>>;
  contract?: InputMaybe<Scalars['String']['input']>;
  contract_?: InputMaybe<Contract_Filter>;
  contract_contains?: InputMaybe<Scalars['String']['input']>;
  contract_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_ends_with?: InputMaybe<Scalars['String']['input']>;
  contract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_gt?: InputMaybe<Scalars['String']['input']>;
  contract_gte?: InputMaybe<Scalars['String']['input']>;
  contract_in?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_lt?: InputMaybe<Scalars['String']['input']>;
  contract_lte?: InputMaybe<Scalars['String']['input']>;
  contract_not?: InputMaybe<Scalars['String']['input']>;
  contract_not_contains?: InputMaybe<Scalars['String']['input']>;
  contract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  contract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  contract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_starts_with?: InputMaybe<Scalars['String']['input']>;
  contract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  minterContractAllowlist?: InputMaybe<Array<Scalars['String']['input']>>;
  minterContractAllowlist_?: InputMaybe<Minter_Filter>;
  minterContractAllowlist_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  minterContractAllowlist_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  minterContractAllowlist_not?: InputMaybe<Array<Scalars['String']['input']>>;
  minterContractAllowlist_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  minterContractAllowlist_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  minterFilter?: InputMaybe<Scalars['String']['input']>;
  minterFilter_?: InputMaybe<MinterFilter_Filter>;
  minterFilter_contains?: InputMaybe<Scalars['String']['input']>;
  minterFilter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_ends_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_gt?: InputMaybe<Scalars['String']['input']>;
  minterFilter_gte?: InputMaybe<Scalars['String']['input']>;
  minterFilter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minterFilter_lt?: InputMaybe<Scalars['String']['input']>;
  minterFilter_lte?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_contains?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minterFilter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_starts_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<MinterFilterContractAllowlist_Filter>>>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum MinterFilterContractAllowlist_OrderBy {
  Contract = 'contract',
  ContractAdmin = 'contract__admin',
  ContractAutoApproveArtistSplitProposals = 'contract__autoApproveArtistSplitProposals',
  ContractCoreVersion = 'contract__coreVersion',
  ContractCreatedAt = 'contract__createdAt',
  ContractCurationRegistry = 'contract__curationRegistry',
  ContractDefaultEnginePlatformProviderSecondarySalesAddress = 'contract__defaultEnginePlatformProviderSecondarySalesAddress',
  ContractDefaultEnginePlatformProviderSecondarySalesBps = 'contract__defaultEnginePlatformProviderSecondarySalesBPS',
  ContractDefaultRenderProviderSecondarySalesAddress = 'contract__defaultRenderProviderSecondarySalesAddress',
  ContractDefaultRenderProviderSecondarySalesBps = 'contract__defaultRenderProviderSecondarySalesBPS',
  ContractEnginePlatformProviderAddress = 'contract__enginePlatformProviderAddress',
  ContractEnginePlatformProviderPercentage = 'contract__enginePlatformProviderPercentage',
  ContractId = 'contract__id',
  ContractNewProjectsForbidden = 'contract__newProjectsForbidden',
  ContractNextProjectId = 'contract__nextProjectId',
  ContractOnChainGenerator = 'contract__onChainGenerator',
  ContractPreferredArweaveGateway = 'contract__preferredArweaveGateway',
  ContractPreferredIpfsGateway = 'contract__preferredIPFSGateway',
  ContractRandomizerContract = 'contract__randomizerContract',
  ContractRenderProviderAddress = 'contract__renderProviderAddress',
  ContractRenderProviderPercentage = 'contract__renderProviderPercentage',
  ContractRoyaltySplitProvider = 'contract__royaltySplitProvider',
  ContractType = 'contract__type',
  ContractUpdatedAt = 'contract__updatedAt',
  Id = 'id',
  MinterContractAllowlist = 'minterContractAllowlist',
  MinterFilter = 'minterFilter',
  MinterFilterId = 'minterFilter__id',
  MinterFilterType = 'minterFilter__type',
  MinterFilterUpdatedAt = 'minterFilter__updatedAt',
  UpdatedAt = 'updatedAt'
}

export enum MinterFilterType {
  /** IMinterFilterV0, no minterFilterType function */
  MinterFilterV0 = 'MinterFilterV0',
  /** IMinterFilterV0, added minterFilterType function */
  MinterFilterV1 = 'MinterFilterV1',
  /** IMinterFilterV1 includes minterFilterType function */
  MinterFilterV2 = 'MinterFilterV2',
  /** unknown minter filter type */
  Unknown = 'UNKNOWN'
}

export type MinterFilter_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MinterFilter_Filter>>>;
  coreRegistry?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_?: InputMaybe<CoreRegistry_Filter>;
  coreRegistry_contains?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_ends_with?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_gt?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_gte?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_in?: InputMaybe<Array<Scalars['String']['input']>>;
  coreRegistry_lt?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_lte?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_contains?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  coreRegistry_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_starts_with?: InputMaybe<Scalars['String']['input']>;
  coreRegistry_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  knownMinters_?: InputMaybe<Minter_Filter>;
  minterFilterContractAllowlists_?: InputMaybe<MinterFilterContractAllowlist_Filter>;
  minterGlobalAllowlist?: InputMaybe<Array<Scalars['String']['input']>>;
  minterGlobalAllowlist_?: InputMaybe<Minter_Filter>;
  minterGlobalAllowlist_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  minterGlobalAllowlist_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  minterGlobalAllowlist_not?: InputMaybe<Array<Scalars['String']['input']>>;
  minterGlobalAllowlist_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  minterGlobalAllowlist_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MinterFilter_Filter>>>;
  type?: InputMaybe<MinterFilterType>;
  type_in?: InputMaybe<Array<MinterFilterType>>;
  type_not?: InputMaybe<MinterFilterType>;
  type_not_in?: InputMaybe<Array<MinterFilterType>>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum MinterFilter_OrderBy {
  CoreRegistry = 'coreRegistry',
  CoreRegistryId = 'coreRegistry__id',
  Id = 'id',
  KnownMinters = 'knownMinters',
  MinterFilterContractAllowlists = 'minterFilterContractAllowlists',
  MinterGlobalAllowlist = 'minterGlobalAllowlist',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type MinterInfo = {
  __typename?: 'MinterInfo';
  Description: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MinterInfoEntity = {
  __typename?: 'MinterInfoEntity';
  attributes?: Maybe<MinterInfo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MinterInfoEntityResponse = {
  __typename?: 'MinterInfoEntityResponse';
  data?: Maybe<MinterInfoEntity>;
};

export type MinterInfoEntityResponseCollection = {
  __typename?: 'MinterInfoEntityResponseCollection';
  data: Array<MinterInfoEntity>;
  meta: ResponseCollectionMeta;
};

export type MinterInfoFiltersInput = {
  Description?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<MinterInfoFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MinterInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MinterInfoFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MinterInfoInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Minter_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Minter_Filter>>>;
  extraMinterDetails?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_contains?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_ends_with?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_gt?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_gte?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extraMinterDetails_lt?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_lte?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_contains?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extraMinterDetails_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_starts_with?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isGloballyAllowlistedOnMinterFilter?: InputMaybe<Scalars['Boolean']['input']>;
  isGloballyAllowlistedOnMinterFilter_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isGloballyAllowlistedOnMinterFilter_not?: InputMaybe<Scalars['Boolean']['input']>;
  isGloballyAllowlistedOnMinterFilter_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  minterFilter?: InputMaybe<Scalars['String']['input']>;
  minterFilter_?: InputMaybe<MinterFilter_Filter>;
  minterFilter_contains?: InputMaybe<Scalars['String']['input']>;
  minterFilter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_ends_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_gt?: InputMaybe<Scalars['String']['input']>;
  minterFilter_gte?: InputMaybe<Scalars['String']['input']>;
  minterFilter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minterFilter_lt?: InputMaybe<Scalars['String']['input']>;
  minterFilter_lte?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_contains?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minterFilter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterFilter_starts_with?: InputMaybe<Scalars['String']['input']>;
  minterFilter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Minter_Filter>>>;
  receipts_?: InputMaybe<Receipt_Filter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  type_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Minter_OrderBy {
  ExtraMinterDetails = 'extraMinterDetails',
  Id = 'id',
  IsGloballyAllowlistedOnMinterFilter = 'isGloballyAllowlistedOnMinterFilter',
  MinterFilter = 'minterFilter',
  MinterFilterId = 'minterFilter__id',
  MinterFilterType = 'minterFilter__type',
  MinterFilterUpdatedAt = 'minterFilter__updatedAt',
  Receipts = 'receipts',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type OpenseaCollectionData = {
  __typename?: 'OpenseaCollectionData';
  projectId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  /** Payment id formatted: '{SaleId}-{paymentNumber}' (paymentNumber will be 0 for non-Seaport trades) */
  id: Scalars['ID']['output'];
  /** The address of the token used for the payment */
  paymentToken: Scalars['Bytes']['output'];
  /** Type of token transferred in this payment */
  paymentType: PaymentType;
  /** The price of the sale */
  price: Scalars['BigInt']['output'];
  /** The recipient address */
  recipient: Scalars['Bytes']['output'];
  /** The associated sale */
  sale: Sale;
};

export enum PaymentType {
  Erc20 = 'ERC20',
  Erc721 = 'ERC721',
  Erc1155 = 'ERC1155',
  Native = 'Native'
}

export type Payment_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Payment_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Payment_Filter>>>;
  paymentToken?: InputMaybe<Scalars['Bytes']['input']>;
  paymentToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  paymentToken_gt?: InputMaybe<Scalars['Bytes']['input']>;
  paymentToken_gte?: InputMaybe<Scalars['Bytes']['input']>;
  paymentToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  paymentToken_lt?: InputMaybe<Scalars['Bytes']['input']>;
  paymentToken_lte?: InputMaybe<Scalars['Bytes']['input']>;
  paymentToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  paymentToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  paymentToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  paymentType?: InputMaybe<PaymentType>;
  paymentType_in?: InputMaybe<Array<PaymentType>>;
  paymentType_not?: InputMaybe<PaymentType>;
  paymentType_not_in?: InputMaybe<Array<PaymentType>>;
  price?: InputMaybe<Scalars['BigInt']['input']>;
  price_gt?: InputMaybe<Scalars['BigInt']['input']>;
  price_gte?: InputMaybe<Scalars['BigInt']['input']>;
  price_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  price_lt?: InputMaybe<Scalars['BigInt']['input']>;
  price_lte?: InputMaybe<Scalars['BigInt']['input']>;
  price_not?: InputMaybe<Scalars['BigInt']['input']>;
  price_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  recipient?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_contains?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_gt?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_gte?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  recipient_lt?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_lte?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_not?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sale?: InputMaybe<Scalars['String']['input']>;
  sale_?: InputMaybe<Sale_Filter>;
  sale_contains?: InputMaybe<Scalars['String']['input']>;
  sale_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_ends_with?: InputMaybe<Scalars['String']['input']>;
  sale_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_gt?: InputMaybe<Scalars['String']['input']>;
  sale_gte?: InputMaybe<Scalars['String']['input']>;
  sale_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sale_lt?: InputMaybe<Scalars['String']['input']>;
  sale_lte?: InputMaybe<Scalars['String']['input']>;
  sale_not?: InputMaybe<Scalars['String']['input']>;
  sale_not_contains?: InputMaybe<Scalars['String']['input']>;
  sale_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  sale_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sale_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  sale_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_starts_with?: InputMaybe<Scalars['String']['input']>;
  sale_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Payment_OrderBy {
  Id = 'id',
  PaymentToken = 'paymentToken',
  PaymentType = 'paymentType',
  Price = 'price',
  Recipient = 'recipient',
  Sale = 'sale',
  SaleBlockNumber = 'sale__blockNumber',
  SaleBlockTimestamp = 'sale__blockTimestamp',
  SaleBuyer = 'sale__buyer',
  SaleExchange = 'sale__exchange',
  SaleId = 'sale__id',
  SaleIsPrivate = 'sale__isPrivate',
  SaleSaleType = 'sale__saleType',
  SaleSeller = 'sale__seller',
  SaleSummaryTokensSold = 'sale__summaryTokensSold',
  SaleTxHash = 'sale__txHash'
}

export type Pmp = {
  __typename?: 'Pmp';
  /** Artist-configured string value, if configured */
  artistConfiguredValueString?: Maybe<Scalars['String']['output']>;
  configuredParamType: PmpParamTypes;
  /** Configured PMP value, bytes32 representation */
  configuredValue?: Maybe<Scalars['String']['output']>;
  /** Timestamp of creation */
  createdAt: Scalars['BigInt']['output'];
  /** Unique identifier made up of {PMP_Plugin_Address}-{tokenId}-{Key}-{tokenPMPNonce} */
  id: Scalars['ID']['output'];
  /** The key for this PMP */
  key: Scalars['String']['output'];
  /** Non-Artist configured string value, if configured */
  nonArtistConfiguredValueString?: Maybe<Scalars['String']['output']>;
  /** The token associated with this PMP */
  token?: Maybe<Token>;
  /** The token ID string, potentially available before token entity exists */
  tokenIdString: Scalars['String']['output'];
  /** Off-chain nonce incremented every time this pmp is updated */
  tokenPMPNonce: Scalars['BigInt']['output'];
};

export enum PmpAuthOptions {
  /** Contract address has authority to configure PMP */
  Address = 'Address',
  /** Artist has authority to configure PMP */
  Artist = 'Artist',
  /** Artist and contract address have authority to configure PMP */
  ArtistAndAddress = 'ArtistAndAddress',
  /** Artist and token owner have authority to configure PMP */
  ArtistAndTokenOwner = 'ArtistAndTokenOwner',
  /** Artist, token owner, and contract address have authority to configure PMP */
  ArtistAndTokenOwnerAndAddress = 'ArtistAndTokenOwnerAndAddress',
  /** Token owner has authority to configure PMP */
  TokenOwner = 'TokenOwner',
  /** Token owner and contract address have authority to configure PMP */
  TokenOwnerAndAddress = 'TokenOwnerAndAddress'
}

export type PmpConfig = {
  __typename?: 'PmpConfig';
  /** only populated if auth is type Address, null otherwise */
  authAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Auth option for this PMP config */
  authOption: PmpAuthOptions;
  /** Timestamp of creation */
  createdAt: Scalars['BigInt']['output'];
  /** Unique identifier made up of {PMP_Plugin_Address}-{ProjectId}-{Key} */
  id: Scalars['ID']['output'];
  /** Parameter key for this PMP config */
  key: Scalars['String']['output'];
  /** bytes32 representation of type's maximum allowed value, if applicible */
  maxRange?: Maybe<Scalars['String']['output']>;
  /** bytes32 representation of type's minimum allowed value, if applicible */
  minRange?: Maybe<Scalars['String']['output']>;
  /** Param type for this PMP config */
  paramType: PmpParamTypes;
  /** Timestamp after which updates are no longer possible to the PMP */
  pmpLockedAfterTimestamp: Scalars['BigInt']['output'];
  /** PMP Project config associated with this PMP config */
  pmpProjectConfig: PmpProjectConfig;
  /** options to choose from, if Select type */
  selectOptions: Array<Scalars['String']['output']>;
};

export type PmpConfig_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<PmpConfig_Filter>>>;
  authAddress?: InputMaybe<Scalars['Bytes']['input']>;
  authAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  authAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  authAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  authAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  authAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  authAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  authAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  authAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authOption?: InputMaybe<PmpAuthOptions>;
  authOption_in?: InputMaybe<Array<PmpAuthOptions>>;
  authOption_not?: InputMaybe<PmpAuthOptions>;
  authOption_not_in?: InputMaybe<Array<PmpAuthOptions>>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_contains?: InputMaybe<Scalars['String']['input']>;
  key_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  key_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  key_gt?: InputMaybe<Scalars['String']['input']>;
  key_gte?: InputMaybe<Scalars['String']['input']>;
  key_in?: InputMaybe<Array<Scalars['String']['input']>>;
  key_lt?: InputMaybe<Scalars['String']['input']>;
  key_lte?: InputMaybe<Scalars['String']['input']>;
  key_not?: InputMaybe<Scalars['String']['input']>;
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  key_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  key_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  key_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  key_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  key_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  maxRange?: InputMaybe<Scalars['String']['input']>;
  maxRange_contains?: InputMaybe<Scalars['String']['input']>;
  maxRange_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  maxRange_ends_with?: InputMaybe<Scalars['String']['input']>;
  maxRange_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  maxRange_gt?: InputMaybe<Scalars['String']['input']>;
  maxRange_gte?: InputMaybe<Scalars['String']['input']>;
  maxRange_in?: InputMaybe<Array<Scalars['String']['input']>>;
  maxRange_lt?: InputMaybe<Scalars['String']['input']>;
  maxRange_lte?: InputMaybe<Scalars['String']['input']>;
  maxRange_not?: InputMaybe<Scalars['String']['input']>;
  maxRange_not_contains?: InputMaybe<Scalars['String']['input']>;
  maxRange_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  maxRange_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  maxRange_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  maxRange_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  maxRange_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  maxRange_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  maxRange_starts_with?: InputMaybe<Scalars['String']['input']>;
  maxRange_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minRange?: InputMaybe<Scalars['String']['input']>;
  minRange_contains?: InputMaybe<Scalars['String']['input']>;
  minRange_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minRange_ends_with?: InputMaybe<Scalars['String']['input']>;
  minRange_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minRange_gt?: InputMaybe<Scalars['String']['input']>;
  minRange_gte?: InputMaybe<Scalars['String']['input']>;
  minRange_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minRange_lt?: InputMaybe<Scalars['String']['input']>;
  minRange_lte?: InputMaybe<Scalars['String']['input']>;
  minRange_not?: InputMaybe<Scalars['String']['input']>;
  minRange_not_contains?: InputMaybe<Scalars['String']['input']>;
  minRange_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minRange_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  minRange_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minRange_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minRange_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  minRange_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minRange_starts_with?: InputMaybe<Scalars['String']['input']>;
  minRange_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<PmpConfig_Filter>>>;
  paramType?: InputMaybe<PmpParamTypes>;
  paramType_in?: InputMaybe<Array<PmpParamTypes>>;
  paramType_not?: InputMaybe<PmpParamTypes>;
  paramType_not_in?: InputMaybe<Array<PmpParamTypes>>;
  pmpLockedAfterTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  pmpLockedAfterTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  pmpLockedAfterTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  pmpLockedAfterTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pmpLockedAfterTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  pmpLockedAfterTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  pmpLockedAfterTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  pmpLockedAfterTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pmpProjectConfig?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_?: InputMaybe<PmpProjectConfig_Filter>;
  pmpProjectConfig_contains?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_ends_with?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_gt?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_gte?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpProjectConfig_lt?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_lte?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_contains?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpProjectConfig_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_starts_with?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  selectOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  selectOptions_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  selectOptions_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  selectOptions_not?: InputMaybe<Array<Scalars['String']['input']>>;
  selectOptions_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  selectOptions_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PmpConfig_OrderBy {
  AuthAddress = 'authAddress',
  AuthOption = 'authOption',
  CreatedAt = 'createdAt',
  Id = 'id',
  Key = 'key',
  MaxRange = 'maxRange',
  MinRange = 'minRange',
  ParamType = 'paramType',
  PmpLockedAfterTimestamp = 'pmpLockedAfterTimestamp',
  PmpProjectConfig = 'pmpProjectConfig',
  PmpProjectConfigId = 'pmpProjectConfig__id',
  PmpProjectConfigPmpAddress = 'pmpProjectConfig__pmpAddress',
  PmpProjectConfigPmpConfigCount = 'pmpProjectConfig__pmpConfigCount',
  PmpProjectConfigUpdatedAt = 'pmpProjectConfig__updatedAt',
  SelectOptions = 'selectOptions'
}

export type PmpLatestState = {
  __typename?: 'PmpLatestState';
  /** Unique identifier made up of {PMP_Plugin_Address}-{tokenId}-{Key} */
  id: Scalars['ID']['output'];
  /** Latest off-chain nonce for this PMP, used for indexing PMP history */
  latestTokenPMPNonce: Scalars['BigInt']['output'];
};

export type PmpLatestState_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<PmpLatestState_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  latestTokenPMPNonce?: InputMaybe<Scalars['BigInt']['input']>;
  latestTokenPMPNonce_gt?: InputMaybe<Scalars['BigInt']['input']>;
  latestTokenPMPNonce_gte?: InputMaybe<Scalars['BigInt']['input']>;
  latestTokenPMPNonce_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  latestTokenPMPNonce_lt?: InputMaybe<Scalars['BigInt']['input']>;
  latestTokenPMPNonce_lte?: InputMaybe<Scalars['BigInt']['input']>;
  latestTokenPMPNonce_not?: InputMaybe<Scalars['BigInt']['input']>;
  latestTokenPMPNonce_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<PmpLatestState_Filter>>>;
};

export enum PmpLatestState_OrderBy {
  Id = 'id',
  LatestTokenPmpNonce = 'latestTokenPMPNonce'
}

export enum PmpParamTypes {
  /** Boolean value */
  Bool = 'Bool',
  /** Decimal range */
  DecimalRange = 'DecimalRange',
  /** Hex color */
  HexColor = 'HexColor',
  /** Int256 range */
  Int256Range = 'Int256Range',
  /** List of options */
  Select = 'Select',
  /** String */
  String = 'String',
  /** Timestamp */
  Timestamp = 'Timestamp',
  /** Uint256 range */
  Uint256Range = 'Uint256Range',
  /** Unconfigured by default, used to check if PMP is configured */
  Unconfigured = 'Unconfigured'
}

export type PmpProjectConfig = {
  __typename?: 'PmpProjectConfig';
  /** Unique identifier made up of {PMP_Plugin_Address}-{ProjectId} */
  id: Scalars['ID']['output'];
  /** PMP contract address */
  pmpAddress: Scalars['Bytes']['output'];
  /** Count of PMP configs for this project */
  pmpConfigCount: Scalars['BigInt']['output'];
  /** Array of keys for the current PMP configs */
  pmpConfigKeys: Array<Scalars['String']['output']>;
  /** List of PMP configs for this project */
  pmpConfigs: Array<PmpConfig>;
  /** Project associated with this PMP project config */
  project: Project;
  /** Timestamp of last update */
  updatedAt: Scalars['BigInt']['output'];
};


export type PmpProjectConfigPmpConfigsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PmpConfig_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PmpConfig_Filter>;
};

export type PmpProjectConfig_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<PmpProjectConfig_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<PmpProjectConfig_Filter>>>;
  pmpAddress?: InputMaybe<Scalars['Bytes']['input']>;
  pmpAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  pmpAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  pmpAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  pmpAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  pmpAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  pmpAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  pmpAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  pmpAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  pmpAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  pmpConfigCount?: InputMaybe<Scalars['BigInt']['input']>;
  pmpConfigCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  pmpConfigCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  pmpConfigCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pmpConfigCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  pmpConfigCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  pmpConfigCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  pmpConfigCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pmpConfigKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpConfigKeys_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpConfigKeys_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpConfigKeys_not?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpConfigKeys_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpConfigKeys_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpConfigs_?: InputMaybe<PmpConfig_Filter>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum PmpProjectConfig_OrderBy {
  Id = 'id',
  PmpAddress = 'pmpAddress',
  PmpConfigCount = 'pmpConfigCount',
  PmpConfigKeys = 'pmpConfigKeys',
  PmpConfigs = 'pmpConfigs',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website',
  UpdatedAt = 'updatedAt'
}

export type Pmp_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Pmp_Filter>>>;
  artistConfiguredValueString?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_contains?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_ends_with?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_gt?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_gte?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_in?: InputMaybe<Array<Scalars['String']['input']>>;
  artistConfiguredValueString_lt?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_lte?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_not?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_not_contains?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  artistConfiguredValueString_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_starts_with?: InputMaybe<Scalars['String']['input']>;
  artistConfiguredValueString_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  configuredParamType?: InputMaybe<PmpParamTypes>;
  configuredParamType_in?: InputMaybe<Array<PmpParamTypes>>;
  configuredParamType_not?: InputMaybe<PmpParamTypes>;
  configuredParamType_not_in?: InputMaybe<Array<PmpParamTypes>>;
  configuredValue?: InputMaybe<Scalars['String']['input']>;
  configuredValue_contains?: InputMaybe<Scalars['String']['input']>;
  configuredValue_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  configuredValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  configuredValue_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  configuredValue_gt?: InputMaybe<Scalars['String']['input']>;
  configuredValue_gte?: InputMaybe<Scalars['String']['input']>;
  configuredValue_in?: InputMaybe<Array<Scalars['String']['input']>>;
  configuredValue_lt?: InputMaybe<Scalars['String']['input']>;
  configuredValue_lte?: InputMaybe<Scalars['String']['input']>;
  configuredValue_not?: InputMaybe<Scalars['String']['input']>;
  configuredValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  configuredValue_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  configuredValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  configuredValue_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  configuredValue_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  configuredValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  configuredValue_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  configuredValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  configuredValue_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_contains?: InputMaybe<Scalars['String']['input']>;
  key_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  key_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  key_gt?: InputMaybe<Scalars['String']['input']>;
  key_gte?: InputMaybe<Scalars['String']['input']>;
  key_in?: InputMaybe<Array<Scalars['String']['input']>>;
  key_lt?: InputMaybe<Scalars['String']['input']>;
  key_lte?: InputMaybe<Scalars['String']['input']>;
  key_not?: InputMaybe<Scalars['String']['input']>;
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  key_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  key_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  key_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  key_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  key_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_contains?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_ends_with?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_gt?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_gte?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nonArtistConfiguredValueString_lt?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_lte?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_not?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_not_contains?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nonArtistConfiguredValueString_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_starts_with?: InputMaybe<Scalars['String']['input']>;
  nonArtistConfiguredValueString_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Pmp_Filter>>>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenIdString?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_contains?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_gt?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_gte?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIdString_lt?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_lte?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_not?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIdString_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenIdString_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenPMPNonce?: InputMaybe<Scalars['BigInt']['input']>;
  tokenPMPNonce_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenPMPNonce_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenPMPNonce_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenPMPNonce_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenPMPNonce_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenPMPNonce_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokenPMPNonce_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  token_?: InputMaybe<Token_Filter>;
  token_contains?: InputMaybe<Scalars['String']['input']>;
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_gt?: InputMaybe<Scalars['String']['input']>;
  token_gte?: InputMaybe<Scalars['String']['input']>;
  token_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_lt?: InputMaybe<Scalars['String']['input']>;
  token_lte?: InputMaybe<Scalars['String']['input']>;
  token_not?: InputMaybe<Scalars['String']['input']>;
  token_not_contains?: InputMaybe<Scalars['String']['input']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Pmp_OrderBy {
  ArtistConfiguredValueString = 'artistConfiguredValueString',
  ConfiguredParamType = 'configuredParamType',
  ConfiguredValue = 'configuredValue',
  CreatedAt = 'createdAt',
  Id = 'id',
  Key = 'key',
  NonArtistConfiguredValueString = 'nonArtistConfiguredValueString',
  Token = 'token',
  TokenIdString = 'tokenIdString',
  TokenPmpNonce = 'tokenPMPNonce',
  TokenCreatedAt = 'token__createdAt',
  TokenHash = 'token__hash',
  TokenId = 'token__id',
  TokenInvocation = 'token__invocation',
  TokenNextSaleId = 'token__nextSaleId',
  TokenTokenId = 'token__tokenId',
  TokenTransactionHash = 'token__transactionHash',
  TokenUpdatedAt = 'token__updatedAt',
  TokenUri = 'token__uri'
}

export type PrimaryPurchase = {
  __typename?: 'PrimaryPurchase';
  /** Address of currency used to purchase token */
  currencyAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Number of decimals used to get a currency's display representation (i.e. 18 for ETH) */
  currencyDecimals?: Maybe<Scalars['Int']['output']>;
  /** Symbol of currency used to purchase token */
  currencySymbol?: Maybe<Scalars['String']['output']>;
  /** Unique identifier made up of contract address and token id */
  id: Scalars['ID']['output'];
  /** Address of the minter used to mint token */
  minterAddress?: Maybe<Scalars['Bytes']['output']>;
  token: Token;
  /** Transaction hash of token purchase */
  transactionHash: Scalars['Bytes']['output'];
};

export type PrimaryPurchase_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<PrimaryPurchase_Filter>>>;
  currencyAddress?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  currencyAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  currencyDecimals?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_gt?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_gte?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencyDecimals_lt?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_lte?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_not?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_contains?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_gt?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_gte?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currencySymbol_lt?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_lte?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currencySymbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  minterAddress?: InputMaybe<Scalars['Bytes']['input']>;
  minterAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  minterAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  minterAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  minterAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  minterAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  minterAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  minterAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  minterAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  minterAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<PrimaryPurchase_Filter>>>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_?: InputMaybe<Token_Filter>;
  token_contains?: InputMaybe<Scalars['String']['input']>;
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_gt?: InputMaybe<Scalars['String']['input']>;
  token_gte?: InputMaybe<Scalars['String']['input']>;
  token_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_lt?: InputMaybe<Scalars['String']['input']>;
  token_lte?: InputMaybe<Scalars['String']['input']>;
  token_not?: InputMaybe<Scalars['String']['input']>;
  token_not_contains?: InputMaybe<Scalars['String']['input']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum PrimaryPurchase_OrderBy {
  CurrencyAddress = 'currencyAddress',
  CurrencyDecimals = 'currencyDecimals',
  CurrencySymbol = 'currencySymbol',
  Id = 'id',
  MinterAddress = 'minterAddress',
  Token = 'token',
  TokenCreatedAt = 'token__createdAt',
  TokenHash = 'token__hash',
  TokenId = 'token__id',
  TokenInvocation = 'token__invocation',
  TokenNextSaleId = 'token__nextSaleId',
  TokenTokenId = 'token__tokenId',
  TokenTransactionHash = 'token__transactionHash',
  TokenUpdatedAt = 'token__updatedAt',
  TokenUri = 'token__uri',
  TransactionHash = 'transactionHash'
}

export type PrivyAuthenticateInput = {
  ip?: InputMaybe<IpInfoInput>;
  mixpanelId?: InputMaybe<Scalars['String']['input']>;
  privyAccessToken: Scalars['String']['input'];
  publicAddress: Scalars['String']['input'];
  tosAcceptedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Project = {
  __typename?: 'Project';
  activatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Determines if the project should be visible to the public */
  active: Scalars['Boolean']['output'];
  /** Address to split primary sales with the artist */
  additionalPayee?: Maybe<Scalars['Bytes']['output']>;
  /** Percentage of artist's share of primary sales that goes to additional payee */
  additionalPayeePercentage?: Maybe<Scalars['BigInt']['output']>;
  /** Address to split Secondary sales with the artist */
  additionalPayeeSecondarySalesAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Percentage of artist's share of secondary sales that goes to additional payee */
  additionalPayeeSecondarySalesPercentage?: Maybe<Scalars['BigInt']['output']>;
  /** Artist that created the project */
  artist: Account;
  /** Wallet address of the artist */
  artistAddress: Scalars['Bytes']['output'];
  /** Artist name */
  artistName?: Maybe<Scalars['String']['output']>;
  /** Aspect ratio of the project (see `scriptJSON` if null) */
  aspectRatio?: Maybe<Scalars['String']['output']>;
  baseIpfsUri?: Maybe<Scalars['String']['output']>;
  baseUri?: Maybe<Scalars['String']['output']>;
  /** A project is complete when it has reached its maximum invocations */
  complete: Scalars['Boolean']['output'];
  /** Timestamp at which a project was completed */
  completedAt?: Maybe<Scalars['BigInt']['output']>;
  contract: Contract;
  createdAt: Scalars['BigInt']['output'];
  /** ERC-20 contract address if the project is purchasable via ERC-20 */
  currencyAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Number of decimals used to get a currency's display representation (i.e. 18 for ETH) */
  currencyDecimals?: Maybe<Scalars['Int']['output']>;
  /** Currency symbol for ERC-20 */
  currencySymbol?: Maybe<Scalars['String']['output']>;
  /** Artist description of the project */
  description?: Maybe<Scalars['String']['output']>;
  /** Is the project dynamic or a static image */
  dynamic: Scalars['Boolean']['output'];
  /** Address that receives secondary sales platform royalties (null for pre-V3 contracts, check Royalty Registry) */
  enginePlatformProviderSecondarySalesAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Basis points of secondary sales allocated to the platform (null for pre-V3 contracts, check Royalty Registry) */
  enginePlatformProviderSecondarySalesBPS?: Maybe<Scalars['BigInt']['output']>;
  /** ERC-2981 royalty splitter address, used on v3.2 and-on */
  erc2981SplitterAddress?: Maybe<Scalars['Bytes']['output']>;
  /** The active royalty splitter contract, used on v3.2 and-on */
  erc2981SplitterContract?: Maybe<RoyaltySplitterContract>;
  externalAssetDependencies: Array<ProjectExternalAssetDependency>;
  /** Once the project's external asset dependencies are locked they may never be modified again */
  externalAssetDependenciesLocked: Scalars['Boolean']['output'];
  /** The number of external asset dependencies stored on-chain */
  externalAssetDependencyCount: Scalars['BigInt']['output'];
  /** Unique identifier made up of contract address and project id */
  id: Scalars['ID']['output'];
  /** Number of times the project has been invoked - number of tokens of the project */
  invocations: Scalars['BigInt']['output'];
  ipfsHash?: Maybe<Scalars['String']['output']>;
  /** License for the project */
  license?: Maybe<Scalars['String']['output']>;
  /** For V3 and-on, this field is null, and projects lock 4 weeks after `completedAt`. Once the project is locked its script may never be updated again. */
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of invocations allowed for the project. Note that minter contracts may additionally limit a project's maxInvocations on a specific minter. */
  maxInvocations: Scalars['BigInt']['output'];
  /** Minter configuration for this project (not implemented prior to minter filters) */
  minterConfiguration?: Maybe<ProjectMinterConfiguration>;
  /** Project name */
  name?: Maybe<Scalars['String']['output']>;
  /** Accounts that own tokens of the project */
  owners?: Maybe<Array<AccountProject>>;
  /** Purchases paused */
  paused: Scalars['Boolean']['output'];
  /** PMP configuration for this project, if any */
  pmpProjectConfig?: Maybe<PmpProjectConfig>;
  pricePerTokenInWei: Scalars['BigInt']['output'];
  /** ID of the project on the contract */
  projectId: Scalars['BigInt']['output'];
  /** Proposed Artist addresses and payment split percentages */
  proposedArtistAddressesAndSplits?: Maybe<ProposedArtistAddressesAndSplit>;
  /** Receipts for this project, only on minters with settlement */
  receipts?: Maybe<Array<Receipt>>;
  /** Address that receives secondary sales render provider royalties (null for pre-V3 contracts, check Royalty Registry) */
  renderProviderSecondarySalesAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Basis points of secondary sales allocated to the render provider (null for pre-V3 contracts, check Royalty Registry) */
  renderProviderSecondarySalesBPS?: Maybe<Scalars['BigInt']['output']>;
  /** Artist/additional payee royalty percentage */
  royaltyPercentage?: Maybe<Scalars['BigInt']['output']>;
  /** Lookup table to get the Sale history of the project */
  saleLookupTables: Array<SaleLookupTable>;
  /** The full script composed of scripts */
  script?: Maybe<Scalars['String']['output']>;
  /** The number of scripts stored on-chain */
  scriptCount: Scalars['BigInt']['output'];
  /** Extra information about the script and rendering options */
  scriptJSON?: Maybe<Scalars['String']['output']>;
  /** Script type and version (see `scriptJSON` if null) */
  scriptTypeAndVersion?: Maybe<Scalars['String']['output']>;
  /** Script type and version override (override set on dependency registry) */
  scriptTypeAndVersionOverride?: Maybe<Scalars['String']['output']>;
  scriptUpdatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Parts of the project script */
  scripts?: Maybe<Array<ProjectScript>>;
  /** Tokens of the project */
  tokens?: Maybe<Array<Token>>;
  updatedAt: Scalars['BigInt']['output'];
  /** Does the project actually use the hash string */
  useHashString: Scalars['Boolean']['output'];
  /** Does the project use media from ipfs */
  useIpfs?: Maybe<Scalars['Boolean']['output']>;
  /** Artist or project website */
  website?: Maybe<Scalars['String']['output']>;
};


export type ProjectExternalAssetDependenciesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectExternalAssetDependency_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectExternalAssetDependency_Filter>;
};


export type ProjectOwnersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountProject_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountProject_Filter>;
};


export type ProjectReceiptsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Receipt_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Receipt_Filter>;
};


export type ProjectSaleLookupTablesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SaleLookupTable_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SaleLookupTable_Filter>;
};


export type ProjectScriptsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectScript_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectScript_Filter>;
};


export type ProjectTokensArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Token_Filter>;
};

export type ProjectExternalAssetDependency = {
  __typename?: 'ProjectExternalAssetDependency';
  /** Address of the bytecode storage contract for this asset if it is of type ONCHAIN */
  bytecodeAddress?: Maybe<Scalars['Bytes']['output']>;
  /** The dependency cid. This will be the CID of the dependency if IPFS or ARWEAVE, empty string of ONCHAIN, or a string representation of the Art Blocks Dependency Registry's `dependencyNameAndVersion` if ART_BLOCKS_DEPENDENCY_REGISTRY. */
  cid: Scalars['String']['output'];
  /** The asset data if it is onchain */
  data?: Maybe<Scalars['String']['output']>;
  /** The dependency type */
  dependencyType: ProjectExternalAssetDependencyType;
  /** Unique identifier made up of projectId-index */
  id: Scalars['ID']['output'];
  /** The dependency index */
  index: Scalars['BigInt']['output'];
  /** The associated project */
  project: Project;
};

export enum ProjectExternalAssetDependencyType {
  /** Asset defined on the Art Blocks Dependency Registry */
  ArtBlocksDependencyRegistry = 'ART_BLOCKS_DEPENDENCY_REGISTRY',
  /** Asset hosted on Arweave */
  Arweave = 'ARWEAVE',
  /** Asset hosted on IPFS */
  Ipfs = 'IPFS',
  /** Asset hosted on chain */
  Onchain = 'ONCHAIN'
}

export type ProjectExternalAssetDependency_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ProjectExternalAssetDependency_Filter>>>;
  bytecodeAddress?: InputMaybe<Scalars['Bytes']['input']>;
  bytecodeAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  bytecodeAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  bytecodeAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  bytecodeAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  bytecodeAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  bytecodeAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  bytecodeAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  bytecodeAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  bytecodeAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  cid?: InputMaybe<Scalars['String']['input']>;
  cid_contains?: InputMaybe<Scalars['String']['input']>;
  cid_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  cid_ends_with?: InputMaybe<Scalars['String']['input']>;
  cid_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  cid_gt?: InputMaybe<Scalars['String']['input']>;
  cid_gte?: InputMaybe<Scalars['String']['input']>;
  cid_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cid_lt?: InputMaybe<Scalars['String']['input']>;
  cid_lte?: InputMaybe<Scalars['String']['input']>;
  cid_not?: InputMaybe<Scalars['String']['input']>;
  cid_not_contains?: InputMaybe<Scalars['String']['input']>;
  cid_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  cid_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  cid_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  cid_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cid_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  cid_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  cid_starts_with?: InputMaybe<Scalars['String']['input']>;
  cid_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_contains?: InputMaybe<Scalars['String']['input']>;
  data_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  data_ends_with?: InputMaybe<Scalars['String']['input']>;
  data_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  data_gt?: InputMaybe<Scalars['String']['input']>;
  data_gte?: InputMaybe<Scalars['String']['input']>;
  data_in?: InputMaybe<Array<Scalars['String']['input']>>;
  data_lt?: InputMaybe<Scalars['String']['input']>;
  data_lte?: InputMaybe<Scalars['String']['input']>;
  data_not?: InputMaybe<Scalars['String']['input']>;
  data_not_contains?: InputMaybe<Scalars['String']['input']>;
  data_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  data_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  data_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  data_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  data_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  data_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  data_starts_with?: InputMaybe<Scalars['String']['input']>;
  data_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dependencyType?: InputMaybe<ProjectExternalAssetDependencyType>;
  dependencyType_in?: InputMaybe<Array<ProjectExternalAssetDependencyType>>;
  dependencyType_not?: InputMaybe<ProjectExternalAssetDependencyType>;
  dependencyType_not_in?: InputMaybe<Array<ProjectExternalAssetDependencyType>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ProjectExternalAssetDependency_Filter>>>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum ProjectExternalAssetDependency_OrderBy {
  BytecodeAddress = 'bytecodeAddress',
  Cid = 'cid',
  Data = 'data',
  DependencyType = 'dependencyType',
  Id = 'id',
  Index = 'index',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website'
}

export type ProjectMinterConfiguration = {
  __typename?: 'ProjectMinterConfiguration';
  /** price, or resting price of Duch auction, or minimum bid price in English auction, in wei */
  basePrice?: Maybe<Scalars['BigInt']['output']>;
  /** currency address as defined on minter - address(0) reserved for ether */
  currencyAddress: Scalars['Bytes']['output'];
  /** number of decimals used to get a currency's display representation (i.e. 18 for ETH) */
  currencyDecimals: Scalars['Int']['output'];
  /** currency symbol as defined on minter - ETH reserved for ether */
  currencySymbol: Scalars['String']['output'];
  /** Configuration details used by specific minter project configurations (json string) */
  extraMinterDetails: Scalars['String']['output'];
  /** Unique identifier made up of {minter contract address}-{core contract address}-{project number} */
  id: Scalars['ID']['output'];
  /** Maximum number of invocations allowed for the project (on the minter). If less than than a project's maximum invocations defined on a core contract, the minter contract will limit this project's maximum invocations */
  maxInvocations?: Maybe<Scalars['BigInt']['output']>;
  /** The associated minter */
  minter: Minter;
  /** true if project's token price has been configured on minter */
  priceIsConfigured: Scalars['Boolean']['output'];
  /** The associated project */
  project: Project;
  /** Defines if purchasing token to another is allowed */
  purchaseToDisabled: Scalars['Boolean']['output'];
};

export type ProjectMinterConfiguration_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ProjectMinterConfiguration_Filter>>>;
  basePrice?: InputMaybe<Scalars['BigInt']['input']>;
  basePrice_gt?: InputMaybe<Scalars['BigInt']['input']>;
  basePrice_gte?: InputMaybe<Scalars['BigInt']['input']>;
  basePrice_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  basePrice_lt?: InputMaybe<Scalars['BigInt']['input']>;
  basePrice_lte?: InputMaybe<Scalars['BigInt']['input']>;
  basePrice_not?: InputMaybe<Scalars['BigInt']['input']>;
  basePrice_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currencyAddress?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  currencyAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  currencyDecimals?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_gt?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_gte?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencyDecimals_lt?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_lte?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_not?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_contains?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_gt?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_gte?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currencySymbol_lt?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_lte?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currencySymbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_contains?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_ends_with?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_gt?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_gte?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extraMinterDetails_lt?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_lte?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_contains?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extraMinterDetails_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_starts_with?: InputMaybe<Scalars['String']['input']>;
  extraMinterDetails_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maxInvocations?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxInvocations_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minter?: InputMaybe<Scalars['String']['input']>;
  minter_?: InputMaybe<Minter_Filter>;
  minter_contains?: InputMaybe<Scalars['String']['input']>;
  minter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_ends_with?: InputMaybe<Scalars['String']['input']>;
  minter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_gt?: InputMaybe<Scalars['String']['input']>;
  minter_gte?: InputMaybe<Scalars['String']['input']>;
  minter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minter_lt?: InputMaybe<Scalars['String']['input']>;
  minter_lte?: InputMaybe<Scalars['String']['input']>;
  minter_not?: InputMaybe<Scalars['String']['input']>;
  minter_not_contains?: InputMaybe<Scalars['String']['input']>;
  minter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  minter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  minter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_starts_with?: InputMaybe<Scalars['String']['input']>;
  minter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<ProjectMinterConfiguration_Filter>>>;
  priceIsConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  priceIsConfigured_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  priceIsConfigured_not?: InputMaybe<Scalars['Boolean']['input']>;
  priceIsConfigured_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  purchaseToDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseToDisabled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  purchaseToDisabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseToDisabled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export enum ProjectMinterConfiguration_OrderBy {
  BasePrice = 'basePrice',
  CurrencyAddress = 'currencyAddress',
  CurrencyDecimals = 'currencyDecimals',
  CurrencySymbol = 'currencySymbol',
  ExtraMinterDetails = 'extraMinterDetails',
  Id = 'id',
  MaxInvocations = 'maxInvocations',
  Minter = 'minter',
  MinterExtraMinterDetails = 'minter__extraMinterDetails',
  MinterId = 'minter__id',
  MinterIsGloballyAllowlistedOnMinterFilter = 'minter__isGloballyAllowlistedOnMinterFilter',
  MinterType = 'minter__type',
  MinterUpdatedAt = 'minter__updatedAt',
  PriceIsConfigured = 'priceIsConfigured',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website',
  PurchaseToDisabled = 'purchaseToDisabled'
}

export type ProjectPage = {
  __typename?: 'ProjectPage';
  AuctionInfoRow?: Maybe<Array<Maybe<ComponentReleaseInfoReleaseInfo>>>;
  Quote?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  project: ComponentProjectMetadataProjectMetadata;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProjectPageAuctionInfoRowArgs = {
  filters?: InputMaybe<ComponentReleaseInfoReleaseInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProjectPageEntity = {
  __typename?: 'ProjectPageEntity';
  attributes?: Maybe<ProjectPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProjectPageEntityResponse = {
  __typename?: 'ProjectPageEntityResponse';
  data?: Maybe<ProjectPageEntity>;
};

export type ProjectPageEntityResponseCollection = {
  __typename?: 'ProjectPageEntityResponseCollection';
  data: Array<ProjectPageEntity>;
  meta: ResponseCollectionMeta;
};

export type ProjectPageFiltersInput = {
  AuctionInfoRow?: InputMaybe<ComponentReleaseInfoReleaseInfoFiltersInput>;
  Quote?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ProjectPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ProjectPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProjectPageFiltersInput>>>;
  project?: InputMaybe<ComponentProjectMetadataProjectMetadataFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProjectPageInput = {
  AuctionInfoRow?: InputMaybe<Array<InputMaybe<ComponentReleaseInfoReleaseInfoInput>>>;
  Quote?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<ComponentProjectMetadataProjectMetadataInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectScript = {
  __typename?: 'ProjectScript';
  id: Scalars['ID']['output'];
  index: Scalars['BigInt']['output'];
  project: Project;
  script: Scalars['String']['output'];
};

export type ProjectScript_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ProjectScript_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ProjectScript_Filter>>>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  script_contains?: InputMaybe<Scalars['String']['input']>;
  script_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  script_ends_with?: InputMaybe<Scalars['String']['input']>;
  script_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_gt?: InputMaybe<Scalars['String']['input']>;
  script_gte?: InputMaybe<Scalars['String']['input']>;
  script_in?: InputMaybe<Array<Scalars['String']['input']>>;
  script_lt?: InputMaybe<Scalars['String']['input']>;
  script_lte?: InputMaybe<Scalars['String']['input']>;
  script_not?: InputMaybe<Scalars['String']['input']>;
  script_not_contains?: InputMaybe<Scalars['String']['input']>;
  script_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  script_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  script_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  script_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  script_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_starts_with?: InputMaybe<Scalars['String']['input']>;
  script_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum ProjectScript_OrderBy {
  Id = 'id',
  Index = 'index',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website',
  Script = 'script'
}

export type Project_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  activatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  activatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  activatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  activatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  activatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  activatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  activatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  activatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  active_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  additionalPayee?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePercentage?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePercentage_gt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePercentage_gte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePercentage_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalPayeePercentage_lt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePercentage_lte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePercentage_not?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePercentage_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalPayeeSecondarySalesAddress?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  additionalPayeeSecondarySalesAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  additionalPayeeSecondarySalesPercentage?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_gt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_gte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalPayeeSecondarySalesPercentage_lt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_lte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_not?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalPayee_contains?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayee_gt?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayee_gte?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayee_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  additionalPayee_lt?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayee_lte?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayee_not?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayee_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayee_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Project_Filter>>>;
  artist?: InputMaybe<Scalars['String']['input']>;
  artistAddress?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  artistAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  artistName?: InputMaybe<Scalars['String']['input']>;
  artistName_contains?: InputMaybe<Scalars['String']['input']>;
  artistName_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  artistName_ends_with?: InputMaybe<Scalars['String']['input']>;
  artistName_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artistName_gt?: InputMaybe<Scalars['String']['input']>;
  artistName_gte?: InputMaybe<Scalars['String']['input']>;
  artistName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  artistName_lt?: InputMaybe<Scalars['String']['input']>;
  artistName_lte?: InputMaybe<Scalars['String']['input']>;
  artistName_not?: InputMaybe<Scalars['String']['input']>;
  artistName_not_contains?: InputMaybe<Scalars['String']['input']>;
  artistName_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  artistName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  artistName_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artistName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  artistName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  artistName_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artistName_starts_with?: InputMaybe<Scalars['String']['input']>;
  artistName_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artist_?: InputMaybe<Account_Filter>;
  artist_contains?: InputMaybe<Scalars['String']['input']>;
  artist_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  artist_ends_with?: InputMaybe<Scalars['String']['input']>;
  artist_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artist_gt?: InputMaybe<Scalars['String']['input']>;
  artist_gte?: InputMaybe<Scalars['String']['input']>;
  artist_in?: InputMaybe<Array<Scalars['String']['input']>>;
  artist_lt?: InputMaybe<Scalars['String']['input']>;
  artist_lte?: InputMaybe<Scalars['String']['input']>;
  artist_not?: InputMaybe<Scalars['String']['input']>;
  artist_not_contains?: InputMaybe<Scalars['String']['input']>;
  artist_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  artist_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  artist_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artist_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  artist_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  artist_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  artist_starts_with?: InputMaybe<Scalars['String']['input']>;
  artist_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_ends_with?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_gt?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_gte?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_in?: InputMaybe<Array<Scalars['String']['input']>>;
  aspectRatio_lt?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_lte?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  aspectRatio_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_starts_with?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_contains?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_ends_with?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_gt?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_gte?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_in?: InputMaybe<Array<Scalars['String']['input']>>;
  baseIpfsUri_lt?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_lte?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_not?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_not_contains?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  baseIpfsUri_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_starts_with?: InputMaybe<Scalars['String']['input']>;
  baseIpfsUri_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  baseUri?: InputMaybe<Scalars['String']['input']>;
  baseUri_contains?: InputMaybe<Scalars['String']['input']>;
  baseUri_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  baseUri_ends_with?: InputMaybe<Scalars['String']['input']>;
  baseUri_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  baseUri_gt?: InputMaybe<Scalars['String']['input']>;
  baseUri_gte?: InputMaybe<Scalars['String']['input']>;
  baseUri_in?: InputMaybe<Array<Scalars['String']['input']>>;
  baseUri_lt?: InputMaybe<Scalars['String']['input']>;
  baseUri_lte?: InputMaybe<Scalars['String']['input']>;
  baseUri_not?: InputMaybe<Scalars['String']['input']>;
  baseUri_not_contains?: InputMaybe<Scalars['String']['input']>;
  baseUri_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  baseUri_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  baseUri_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  baseUri_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  baseUri_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  baseUri_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  baseUri_starts_with?: InputMaybe<Scalars['String']['input']>;
  baseUri_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  complete_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  complete_not?: InputMaybe<Scalars['Boolean']['input']>;
  complete_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  completedAt?: InputMaybe<Scalars['BigInt']['input']>;
  completedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  completedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  completedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  completedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  completedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  completedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  completedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  contract?: InputMaybe<Scalars['String']['input']>;
  contract_?: InputMaybe<Contract_Filter>;
  contract_contains?: InputMaybe<Scalars['String']['input']>;
  contract_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_ends_with?: InputMaybe<Scalars['String']['input']>;
  contract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_gt?: InputMaybe<Scalars['String']['input']>;
  contract_gte?: InputMaybe<Scalars['String']['input']>;
  contract_in?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_lt?: InputMaybe<Scalars['String']['input']>;
  contract_lte?: InputMaybe<Scalars['String']['input']>;
  contract_not?: InputMaybe<Scalars['String']['input']>;
  contract_not_contains?: InputMaybe<Scalars['String']['input']>;
  contract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  contract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  contract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_starts_with?: InputMaybe<Scalars['String']['input']>;
  contract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currencyAddress?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  currencyAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  currencyAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  currencyDecimals?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_gt?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_gte?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencyDecimals_lt?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_lte?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_not?: InputMaybe<Scalars['Int']['input']>;
  currencyDecimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_contains?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_gt?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_gte?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currencySymbol_lt?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_lte?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currencySymbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  currencySymbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dynamic?: InputMaybe<Scalars['Boolean']['input']>;
  dynamic_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  dynamic_not?: InputMaybe<Scalars['Boolean']['input']>;
  dynamic_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  enginePlatformProviderSecondarySalesAddress?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderSecondarySalesAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderSecondarySalesAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderSecondarySalesAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderSecondarySalesAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  enginePlatformProviderSecondarySalesAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderSecondarySalesAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderSecondarySalesAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderSecondarySalesAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  enginePlatformProviderSecondarySalesAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  enginePlatformProviderSecondarySalesBPS?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderSecondarySalesBPS_gt?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderSecondarySalesBPS_gte?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderSecondarySalesBPS_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  enginePlatformProviderSecondarySalesBPS_lt?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderSecondarySalesBPS_lte?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderSecondarySalesBPS_not?: InputMaybe<Scalars['BigInt']['input']>;
  enginePlatformProviderSecondarySalesBPS_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  erc2981SplitterAddress?: InputMaybe<Scalars['Bytes']['input']>;
  erc2981SplitterAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  erc2981SplitterAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  erc2981SplitterAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  erc2981SplitterAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  erc2981SplitterAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  erc2981SplitterAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  erc2981SplitterAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  erc2981SplitterAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  erc2981SplitterAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  erc2981SplitterContract?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_?: InputMaybe<RoyaltySplitterContract_Filter>;
  erc2981SplitterContract_contains?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_ends_with?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_gt?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_gte?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_in?: InputMaybe<Array<Scalars['String']['input']>>;
  erc2981SplitterContract_lt?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_lte?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_not?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_not_contains?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  erc2981SplitterContract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_starts_with?: InputMaybe<Scalars['String']['input']>;
  erc2981SplitterContract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalAssetDependenciesLocked?: InputMaybe<Scalars['Boolean']['input']>;
  externalAssetDependenciesLocked_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  externalAssetDependenciesLocked_not?: InputMaybe<Scalars['Boolean']['input']>;
  externalAssetDependenciesLocked_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  externalAssetDependencies_?: InputMaybe<ProjectExternalAssetDependency_Filter>;
  externalAssetDependencyCount?: InputMaybe<Scalars['BigInt']['input']>;
  externalAssetDependencyCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  externalAssetDependencyCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  externalAssetDependencyCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  externalAssetDependencyCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  externalAssetDependencyCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  externalAssetDependencyCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  externalAssetDependencyCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  invocations?: InputMaybe<Scalars['BigInt']['input']>;
  invocations_gt?: InputMaybe<Scalars['BigInt']['input']>;
  invocations_gte?: InputMaybe<Scalars['BigInt']['input']>;
  invocations_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  invocations_lt?: InputMaybe<Scalars['BigInt']['input']>;
  invocations_lte?: InputMaybe<Scalars['BigInt']['input']>;
  invocations_not?: InputMaybe<Scalars['BigInt']['input']>;
  invocations_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ipfsHash?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_contains?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_ends_with?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_gt?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_gte?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ipfsHash_lt?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_lte?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_not?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ipfsHash_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_starts_with?: InputMaybe<Scalars['String']['input']>;
  ipfsHash_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  license_contains?: InputMaybe<Scalars['String']['input']>;
  license_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  license_ends_with?: InputMaybe<Scalars['String']['input']>;
  license_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  license_gt?: InputMaybe<Scalars['String']['input']>;
  license_gte?: InputMaybe<Scalars['String']['input']>;
  license_in?: InputMaybe<Array<Scalars['String']['input']>>;
  license_lt?: InputMaybe<Scalars['String']['input']>;
  license_lte?: InputMaybe<Scalars['String']['input']>;
  license_not?: InputMaybe<Scalars['String']['input']>;
  license_not_contains?: InputMaybe<Scalars['String']['input']>;
  license_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  license_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  license_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  license_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  license_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  license_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  license_starts_with?: InputMaybe<Scalars['String']['input']>;
  license_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  locked_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  locked_not?: InputMaybe<Scalars['Boolean']['input']>;
  locked_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  maxInvocations?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxInvocations_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxInvocations_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minterConfiguration?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_?: InputMaybe<ProjectMinterConfiguration_Filter>;
  minterConfiguration_contains?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_ends_with?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_gt?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_gte?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minterConfiguration_lt?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_lte?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_not?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_not_contains?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minterConfiguration_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_starts_with?: InputMaybe<Scalars['String']['input']>;
  minterConfiguration_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Project_Filter>>>;
  owners_?: InputMaybe<AccountProject_Filter>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  paused_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  paused_not?: InputMaybe<Scalars['Boolean']['input']>;
  paused_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  pmpProjectConfig?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_?: InputMaybe<PmpProjectConfig_Filter>;
  pmpProjectConfig_contains?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_ends_with?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_gt?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_gte?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpProjectConfig_lt?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_lte?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_contains?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pmpProjectConfig_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_starts_with?: InputMaybe<Scalars['String']['input']>;
  pmpProjectConfig_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pricePerTokenInWei?: InputMaybe<Scalars['BigInt']['input']>;
  pricePerTokenInWei_gt?: InputMaybe<Scalars['BigInt']['input']>;
  pricePerTokenInWei_gte?: InputMaybe<Scalars['BigInt']['input']>;
  pricePerTokenInWei_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pricePerTokenInWei_lt?: InputMaybe<Scalars['BigInt']['input']>;
  pricePerTokenInWei_lte?: InputMaybe<Scalars['BigInt']['input']>;
  pricePerTokenInWei_not?: InputMaybe<Scalars['BigInt']['input']>;
  pricePerTokenInWei_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  projectId?: InputMaybe<Scalars['BigInt']['input']>;
  projectId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  projectId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  projectId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  projectId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  projectId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  projectId_not?: InputMaybe<Scalars['BigInt']['input']>;
  projectId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  proposedArtistAddressesAndSplits?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_?: InputMaybe<ProposedArtistAddressesAndSplit_Filter>;
  proposedArtistAddressesAndSplits_contains?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_ends_with?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_gt?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_gte?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_in?: InputMaybe<Array<Scalars['String']['input']>>;
  proposedArtistAddressesAndSplits_lt?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_lte?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_not?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_not_contains?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  proposedArtistAddressesAndSplits_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_starts_with?: InputMaybe<Scalars['String']['input']>;
  proposedArtistAddressesAndSplits_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receipts_?: InputMaybe<Receipt_Filter>;
  renderProviderSecondarySalesAddress?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderSecondarySalesAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderSecondarySalesAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderSecondarySalesAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderSecondarySalesAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  renderProviderSecondarySalesAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderSecondarySalesAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderSecondarySalesAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderSecondarySalesAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  renderProviderSecondarySalesAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  renderProviderSecondarySalesBPS?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderSecondarySalesBPS_gt?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderSecondarySalesBPS_gte?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderSecondarySalesBPS_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  renderProviderSecondarySalesBPS_lt?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderSecondarySalesBPS_lte?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderSecondarySalesBPS_not?: InputMaybe<Scalars['BigInt']['input']>;
  renderProviderSecondarySalesBPS_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  royaltyPercentage?: InputMaybe<Scalars['BigInt']['input']>;
  royaltyPercentage_gt?: InputMaybe<Scalars['BigInt']['input']>;
  royaltyPercentage_gte?: InputMaybe<Scalars['BigInt']['input']>;
  royaltyPercentage_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  royaltyPercentage_lt?: InputMaybe<Scalars['BigInt']['input']>;
  royaltyPercentage_lte?: InputMaybe<Scalars['BigInt']['input']>;
  royaltyPercentage_not?: InputMaybe<Scalars['BigInt']['input']>;
  royaltyPercentage_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  saleLookupTables_?: InputMaybe<SaleLookupTable_Filter>;
  script?: InputMaybe<Scalars['String']['input']>;
  scriptCount?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  scriptCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  scriptCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  scriptJSON?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_contains?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_ends_with?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_gt?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_gte?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scriptJSON_lt?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_lte?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_not?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_not_contains?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scriptJSON_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_starts_with?: InputMaybe<Scalars['String']['input']>;
  scriptJSON_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_contains?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_ends_with?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_gt?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_gte?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scriptTypeAndVersionOverride_lt?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_lte?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_not?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_not_contains?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scriptTypeAndVersionOverride_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_starts_with?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersionOverride_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_contains?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_ends_with?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_gt?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_gte?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scriptTypeAndVersion_lt?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_lte?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_not?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_not_contains?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  scriptTypeAndVersion_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_starts_with?: InputMaybe<Scalars['String']['input']>;
  scriptTypeAndVersion_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scriptUpdatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  scriptUpdatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  scriptUpdatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  scriptUpdatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  scriptUpdatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  scriptUpdatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  scriptUpdatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  scriptUpdatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  script_contains?: InputMaybe<Scalars['String']['input']>;
  script_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  script_ends_with?: InputMaybe<Scalars['String']['input']>;
  script_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_gt?: InputMaybe<Scalars['String']['input']>;
  script_gte?: InputMaybe<Scalars['String']['input']>;
  script_in?: InputMaybe<Array<Scalars['String']['input']>>;
  script_lt?: InputMaybe<Scalars['String']['input']>;
  script_lte?: InputMaybe<Scalars['String']['input']>;
  script_not?: InputMaybe<Scalars['String']['input']>;
  script_not_contains?: InputMaybe<Scalars['String']['input']>;
  script_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  script_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  script_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  script_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  script_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  script_starts_with?: InputMaybe<Scalars['String']['input']>;
  script_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  scripts_?: InputMaybe<ProjectScript_Filter>;
  tokens_?: InputMaybe<Token_Filter>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  useHashString?: InputMaybe<Scalars['Boolean']['input']>;
  useHashString_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  useHashString_not?: InputMaybe<Scalars['Boolean']['input']>;
  useHashString_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  useIpfs?: InputMaybe<Scalars['Boolean']['input']>;
  useIpfs_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  useIpfs_not?: InputMaybe<Scalars['Boolean']['input']>;
  useIpfs_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  website?: InputMaybe<Scalars['String']['input']>;
  website_contains?: InputMaybe<Scalars['String']['input']>;
  website_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  website_ends_with?: InputMaybe<Scalars['String']['input']>;
  website_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  website_gt?: InputMaybe<Scalars['String']['input']>;
  website_gte?: InputMaybe<Scalars['String']['input']>;
  website_in?: InputMaybe<Array<Scalars['String']['input']>>;
  website_lt?: InputMaybe<Scalars['String']['input']>;
  website_lte?: InputMaybe<Scalars['String']['input']>;
  website_not?: InputMaybe<Scalars['String']['input']>;
  website_not_contains?: InputMaybe<Scalars['String']['input']>;
  website_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  website_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  website_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  website_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  website_starts_with?: InputMaybe<Scalars['String']['input']>;
  website_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Project_OrderBy {
  ActivatedAt = 'activatedAt',
  Active = 'active',
  AdditionalPayee = 'additionalPayee',
  AdditionalPayeePercentage = 'additionalPayeePercentage',
  AdditionalPayeeSecondarySalesAddress = 'additionalPayeeSecondarySalesAddress',
  AdditionalPayeeSecondarySalesPercentage = 'additionalPayeeSecondarySalesPercentage',
  Artist = 'artist',
  ArtistAddress = 'artistAddress',
  ArtistName = 'artistName',
  ArtistId = 'artist__id',
  AspectRatio = 'aspectRatio',
  BaseIpfsUri = 'baseIpfsUri',
  BaseUri = 'baseUri',
  Complete = 'complete',
  CompletedAt = 'completedAt',
  Contract = 'contract',
  ContractAdmin = 'contract__admin',
  ContractAutoApproveArtistSplitProposals = 'contract__autoApproveArtistSplitProposals',
  ContractCoreVersion = 'contract__coreVersion',
  ContractCreatedAt = 'contract__createdAt',
  ContractCurationRegistry = 'contract__curationRegistry',
  ContractDefaultEnginePlatformProviderSecondarySalesAddress = 'contract__defaultEnginePlatformProviderSecondarySalesAddress',
  ContractDefaultEnginePlatformProviderSecondarySalesBps = 'contract__defaultEnginePlatformProviderSecondarySalesBPS',
  ContractDefaultRenderProviderSecondarySalesAddress = 'contract__defaultRenderProviderSecondarySalesAddress',
  ContractDefaultRenderProviderSecondarySalesBps = 'contract__defaultRenderProviderSecondarySalesBPS',
  ContractEnginePlatformProviderAddress = 'contract__enginePlatformProviderAddress',
  ContractEnginePlatformProviderPercentage = 'contract__enginePlatformProviderPercentage',
  ContractId = 'contract__id',
  ContractNewProjectsForbidden = 'contract__newProjectsForbidden',
  ContractNextProjectId = 'contract__nextProjectId',
  ContractOnChainGenerator = 'contract__onChainGenerator',
  ContractPreferredArweaveGateway = 'contract__preferredArweaveGateway',
  ContractPreferredIpfsGateway = 'contract__preferredIPFSGateway',
  ContractRandomizerContract = 'contract__randomizerContract',
  ContractRenderProviderAddress = 'contract__renderProviderAddress',
  ContractRenderProviderPercentage = 'contract__renderProviderPercentage',
  ContractRoyaltySplitProvider = 'contract__royaltySplitProvider',
  ContractType = 'contract__type',
  ContractUpdatedAt = 'contract__updatedAt',
  CreatedAt = 'createdAt',
  CurrencyAddress = 'currencyAddress',
  CurrencyDecimals = 'currencyDecimals',
  CurrencySymbol = 'currencySymbol',
  Description = 'description',
  Dynamic = 'dynamic',
  EnginePlatformProviderSecondarySalesAddress = 'enginePlatformProviderSecondarySalesAddress',
  EnginePlatformProviderSecondarySalesBps = 'enginePlatformProviderSecondarySalesBPS',
  Erc2981SplitterAddress = 'erc2981SplitterAddress',
  Erc2981SplitterContract = 'erc2981SplitterContract',
  Erc2981SplitterContractCreatedAt = 'erc2981SplitterContract__createdAt',
  Erc2981SplitterContractId = 'erc2981SplitterContract__id',
  Erc2981SplitterContractSplitProviderCreator = 'erc2981SplitterContract__splitProviderCreator',
  Erc2981SplitterContractTotalAllocation = 'erc2981SplitterContract__totalAllocation',
  ExternalAssetDependencies = 'externalAssetDependencies',
  ExternalAssetDependenciesLocked = 'externalAssetDependenciesLocked',
  ExternalAssetDependencyCount = 'externalAssetDependencyCount',
  Id = 'id',
  Invocations = 'invocations',
  IpfsHash = 'ipfsHash',
  License = 'license',
  Locked = 'locked',
  MaxInvocations = 'maxInvocations',
  MinterConfiguration = 'minterConfiguration',
  MinterConfigurationBasePrice = 'minterConfiguration__basePrice',
  MinterConfigurationCurrencyAddress = 'minterConfiguration__currencyAddress',
  MinterConfigurationCurrencyDecimals = 'minterConfiguration__currencyDecimals',
  MinterConfigurationCurrencySymbol = 'minterConfiguration__currencySymbol',
  MinterConfigurationExtraMinterDetails = 'minterConfiguration__extraMinterDetails',
  MinterConfigurationId = 'minterConfiguration__id',
  MinterConfigurationMaxInvocations = 'minterConfiguration__maxInvocations',
  MinterConfigurationPriceIsConfigured = 'minterConfiguration__priceIsConfigured',
  MinterConfigurationPurchaseToDisabled = 'minterConfiguration__purchaseToDisabled',
  Name = 'name',
  Owners = 'owners',
  Paused = 'paused',
  PmpProjectConfig = 'pmpProjectConfig',
  PmpProjectConfigId = 'pmpProjectConfig__id',
  PmpProjectConfigPmpAddress = 'pmpProjectConfig__pmpAddress',
  PmpProjectConfigPmpConfigCount = 'pmpProjectConfig__pmpConfigCount',
  PmpProjectConfigUpdatedAt = 'pmpProjectConfig__updatedAt',
  PricePerTokenInWei = 'pricePerTokenInWei',
  ProjectId = 'projectId',
  ProposedArtistAddressesAndSplits = 'proposedArtistAddressesAndSplits',
  ProposedArtistAddressesAndSplitsAdditionalPayeePrimarySalesAddress = 'proposedArtistAddressesAndSplits__additionalPayeePrimarySalesAddress',
  ProposedArtistAddressesAndSplitsAdditionalPayeePrimarySalesPercentage = 'proposedArtistAddressesAndSplits__additionalPayeePrimarySalesPercentage',
  ProposedArtistAddressesAndSplitsAdditionalPayeeSecondarySalesAddress = 'proposedArtistAddressesAndSplits__additionalPayeeSecondarySalesAddress',
  ProposedArtistAddressesAndSplitsAdditionalPayeeSecondarySalesPercentage = 'proposedArtistAddressesAndSplits__additionalPayeeSecondarySalesPercentage',
  ProposedArtistAddressesAndSplitsArtistAddress = 'proposedArtistAddressesAndSplits__artistAddress',
  ProposedArtistAddressesAndSplitsCreatedAt = 'proposedArtistAddressesAndSplits__createdAt',
  ProposedArtistAddressesAndSplitsId = 'proposedArtistAddressesAndSplits__id',
  Receipts = 'receipts',
  RenderProviderSecondarySalesAddress = 'renderProviderSecondarySalesAddress',
  RenderProviderSecondarySalesBps = 'renderProviderSecondarySalesBPS',
  RoyaltyPercentage = 'royaltyPercentage',
  SaleLookupTables = 'saleLookupTables',
  Script = 'script',
  ScriptCount = 'scriptCount',
  ScriptJson = 'scriptJSON',
  ScriptTypeAndVersion = 'scriptTypeAndVersion',
  ScriptTypeAndVersionOverride = 'scriptTypeAndVersionOverride',
  ScriptUpdatedAt = 'scriptUpdatedAt',
  Scripts = 'scripts',
  Tokens = 'tokens',
  UpdatedAt = 'updatedAt',
  UseHashString = 'useHashString',
  UseIpfs = 'useIpfs',
  Website = 'website'
}

export type ProposedArtistAddressesAndSplit = {
  __typename?: 'ProposedArtistAddressesAndSplit';
  /** Proposed artist additional payee address for primary sales */
  additionalPayeePrimarySalesAddress: Scalars['Bytes']['output'];
  /** Proposed artist additional payee percentage for primary sales */
  additionalPayeePrimarySalesPercentage: Scalars['BigInt']['output'];
  /** Proposed artist additional payee address for secondary sales */
  additionalPayeeSecondarySalesAddress: Scalars['Bytes']['output'];
  /** Proposed artist additional payee percentage for secondary sales */
  additionalPayeeSecondarySalesPercentage: Scalars['BigInt']['output'];
  /** Proposed artist address */
  artistAddress: Scalars['Bytes']['output'];
  createdAt: Scalars['BigInt']['output'];
  /** Unique identifier made up of contract address and project id */
  id: Scalars['ID']['output'];
  /** Project associated with this proposed artist addresses and splits */
  project: Project;
};

export type ProposedArtistAddressesAndSplit_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  additionalPayeePrimarySalesAddress?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePrimarySalesAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePrimarySalesAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePrimarySalesAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePrimarySalesAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  additionalPayeePrimarySalesAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePrimarySalesAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePrimarySalesAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePrimarySalesAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeePrimarySalesAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  additionalPayeePrimarySalesPercentage?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePrimarySalesPercentage_gt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePrimarySalesPercentage_gte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePrimarySalesPercentage_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalPayeePrimarySalesPercentage_lt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePrimarySalesPercentage_lte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePrimarySalesPercentage_not?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeePrimarySalesPercentage_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalPayeeSecondarySalesAddress?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  additionalPayeeSecondarySalesAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  additionalPayeeSecondarySalesAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  additionalPayeeSecondarySalesPercentage?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_gt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_gte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  additionalPayeeSecondarySalesPercentage_lt?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_lte?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_not?: InputMaybe<Scalars['BigInt']['input']>;
  additionalPayeeSecondarySalesPercentage_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<ProposedArtistAddressesAndSplit_Filter>>>;
  artistAddress?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  artistAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  artistAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ProposedArtistAddressesAndSplit_Filter>>>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum ProposedArtistAddressesAndSplit_OrderBy {
  AdditionalPayeePrimarySalesAddress = 'additionalPayeePrimarySalesAddress',
  AdditionalPayeePrimarySalesPercentage = 'additionalPayeePrimarySalesPercentage',
  AdditionalPayeeSecondarySalesAddress = 'additionalPayeeSecondarySalesAddress',
  AdditionalPayeeSecondarySalesPercentage = 'additionalPayeeSecondarySalesPercentage',
  ArtistAddress = 'artistAddress',
  CreatedAt = 'createdAt',
  Id = 'id',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website'
}

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Receipt = {
  __typename?: 'Receipt';
  /** The associated account */
  account: Account;
  /** Unique identifier made up of {minter contract address}-{core contract address}-{project number}-{account address} */
  id: Scalars['ID']['output'];
  /** The associated minter */
  minter: Minter;
  /** The total net amount posted (sent to settlement contract) for tokens */
  netPosted: Scalars['BigInt']['output'];
  /** The total quantity of tokens purchased on the project */
  numPurchased: Scalars['BigInt']['output'];
  /** The associated project */
  project: Project;
  updatedAt: Scalars['BigInt']['output'];
};

export type Receipt_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<Receipt_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  minter?: InputMaybe<Scalars['String']['input']>;
  minter_?: InputMaybe<Minter_Filter>;
  minter_contains?: InputMaybe<Scalars['String']['input']>;
  minter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_ends_with?: InputMaybe<Scalars['String']['input']>;
  minter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_gt?: InputMaybe<Scalars['String']['input']>;
  minter_gte?: InputMaybe<Scalars['String']['input']>;
  minter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minter_lt?: InputMaybe<Scalars['String']['input']>;
  minter_lte?: InputMaybe<Scalars['String']['input']>;
  minter_not?: InputMaybe<Scalars['String']['input']>;
  minter_not_contains?: InputMaybe<Scalars['String']['input']>;
  minter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  minter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  minter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  minter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minter_starts_with?: InputMaybe<Scalars['String']['input']>;
  minter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  netPosted?: InputMaybe<Scalars['BigInt']['input']>;
  netPosted_gt?: InputMaybe<Scalars['BigInt']['input']>;
  netPosted_gte?: InputMaybe<Scalars['BigInt']['input']>;
  netPosted_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  netPosted_lt?: InputMaybe<Scalars['BigInt']['input']>;
  netPosted_lte?: InputMaybe<Scalars['BigInt']['input']>;
  netPosted_not?: InputMaybe<Scalars['BigInt']['input']>;
  netPosted_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numPurchased?: InputMaybe<Scalars['BigInt']['input']>;
  numPurchased_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numPurchased_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numPurchased_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numPurchased_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numPurchased_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numPurchased_not?: InputMaybe<Scalars['BigInt']['input']>;
  numPurchased_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Receipt_Filter>>>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Receipt_OrderBy {
  Account = 'account',
  AccountId = 'account__id',
  Id = 'id',
  Minter = 'minter',
  MinterExtraMinterDetails = 'minter__extraMinterDetails',
  MinterId = 'minter__id',
  MinterIsGloballyAllowlistedOnMinterFilter = 'minter__isGloballyAllowlistedOnMinterFilter',
  MinterType = 'minter__type',
  MinterUpdatedAt = 'minter__updatedAt',
  NetPosted = 'netPosted',
  NumPurchased = 'numPurchased',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website',
  UpdatedAt = 'updatedAt'
}

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type RoyaltySplitRecipient = {
  __typename?: 'RoyaltySplitRecipient';
  /** Allocation of the recipient on the split. Recipient receives allocation / totalAllocation of all funds sent to the splitter */
  allocation: Scalars['BigInt']['output'];
  /** unique identifier equal to {royalty splitter contract address}-{recipient address} */
  id: Scalars['ID']['output'];
  /** Address of the recipient of this split */
  recipientAddress: Scalars['Bytes']['output'];
  /** Royalty splitter contract that contains this split recipient */
  royaltySplitterContract: RoyaltySplitterContract;
};

export type RoyaltySplitRecipient_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  allocation?: InputMaybe<Scalars['BigInt']['input']>;
  allocation_gt?: InputMaybe<Scalars['BigInt']['input']>;
  allocation_gte?: InputMaybe<Scalars['BigInt']['input']>;
  allocation_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  allocation_lt?: InputMaybe<Scalars['BigInt']['input']>;
  allocation_lte?: InputMaybe<Scalars['BigInt']['input']>;
  allocation_not?: InputMaybe<Scalars['BigInt']['input']>;
  allocation_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<RoyaltySplitRecipient_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<RoyaltySplitRecipient_Filter>>>;
  recipientAddress?: InputMaybe<Scalars['Bytes']['input']>;
  recipientAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  recipientAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  recipientAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  recipientAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  recipientAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  recipientAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  recipientAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  recipientAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  recipientAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  royaltySplitterContract?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_?: InputMaybe<RoyaltySplitterContract_Filter>;
  royaltySplitterContract_contains?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_ends_with?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_gt?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_gte?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_in?: InputMaybe<Array<Scalars['String']['input']>>;
  royaltySplitterContract_lt?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_lte?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_not?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_not_contains?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  royaltySplitterContract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_starts_with?: InputMaybe<Scalars['String']['input']>;
  royaltySplitterContract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum RoyaltySplitRecipient_OrderBy {
  Allocation = 'allocation',
  Id = 'id',
  RecipientAddress = 'recipientAddress',
  RoyaltySplitterContract = 'royaltySplitterContract',
  RoyaltySplitterContractCreatedAt = 'royaltySplitterContract__createdAt',
  RoyaltySplitterContractId = 'royaltySplitterContract__id',
  RoyaltySplitterContractSplitProviderCreator = 'royaltySplitterContract__splitProviderCreator',
  RoyaltySplitterContractTotalAllocation = 'royaltySplitterContract__totalAllocation'
}

export type RoyaltySplitterContract = {
  __typename?: 'RoyaltySplitterContract';
  /** Core contract that this royalty splitter is associated with */
  coreContract: Contract;
  createdAt: Scalars['BigInt']['output'];
  /** unique identifier equal to royalty splitter's contract address */
  id: Scalars['ID']['output'];
  /** List of split atomic contract splits */
  royaltySplitRecipients: Array<RoyaltySplitRecipient>;
  /** split provider contract address that was used to create this contract */
  splitProviderCreator: Scalars['Bytes']['output'];
  /** Total allocation of all recipients on the contract */
  totalAllocation: Scalars['BigInt']['output'];
};


export type RoyaltySplitterContractRoyaltySplitRecipientsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RoyaltySplitRecipient_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoyaltySplitRecipient_Filter>;
};

export type RoyaltySplitterContract_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<RoyaltySplitterContract_Filter>>>;
  coreContract?: InputMaybe<Scalars['String']['input']>;
  coreContract_?: InputMaybe<Contract_Filter>;
  coreContract_contains?: InputMaybe<Scalars['String']['input']>;
  coreContract_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  coreContract_ends_with?: InputMaybe<Scalars['String']['input']>;
  coreContract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreContract_gt?: InputMaybe<Scalars['String']['input']>;
  coreContract_gte?: InputMaybe<Scalars['String']['input']>;
  coreContract_in?: InputMaybe<Array<Scalars['String']['input']>>;
  coreContract_lt?: InputMaybe<Scalars['String']['input']>;
  coreContract_lte?: InputMaybe<Scalars['String']['input']>;
  coreContract_not?: InputMaybe<Scalars['String']['input']>;
  coreContract_not_contains?: InputMaybe<Scalars['String']['input']>;
  coreContract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  coreContract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  coreContract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreContract_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  coreContract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  coreContract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  coreContract_starts_with?: InputMaybe<Scalars['String']['input']>;
  coreContract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<RoyaltySplitterContract_Filter>>>;
  royaltySplitRecipients_?: InputMaybe<RoyaltySplitRecipient_Filter>;
  splitProviderCreator?: InputMaybe<Scalars['Bytes']['input']>;
  splitProviderCreator_contains?: InputMaybe<Scalars['Bytes']['input']>;
  splitProviderCreator_gt?: InputMaybe<Scalars['Bytes']['input']>;
  splitProviderCreator_gte?: InputMaybe<Scalars['Bytes']['input']>;
  splitProviderCreator_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  splitProviderCreator_lt?: InputMaybe<Scalars['Bytes']['input']>;
  splitProviderCreator_lte?: InputMaybe<Scalars['Bytes']['input']>;
  splitProviderCreator_not?: InputMaybe<Scalars['Bytes']['input']>;
  splitProviderCreator_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  splitProviderCreator_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  totalAllocation?: InputMaybe<Scalars['BigInt']['input']>;
  totalAllocation_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAllocation_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAllocation_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalAllocation_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAllocation_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAllocation_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalAllocation_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum RoyaltySplitterContract_OrderBy {
  CoreContract = 'coreContract',
  CoreContractAdmin = 'coreContract__admin',
  CoreContractAutoApproveArtistSplitProposals = 'coreContract__autoApproveArtistSplitProposals',
  CoreContractCoreVersion = 'coreContract__coreVersion',
  CoreContractCreatedAt = 'coreContract__createdAt',
  CoreContractCurationRegistry = 'coreContract__curationRegistry',
  CoreContractDefaultEnginePlatformProviderSecondarySalesAddress = 'coreContract__defaultEnginePlatformProviderSecondarySalesAddress',
  CoreContractDefaultEnginePlatformProviderSecondarySalesBps = 'coreContract__defaultEnginePlatformProviderSecondarySalesBPS',
  CoreContractDefaultRenderProviderSecondarySalesAddress = 'coreContract__defaultRenderProviderSecondarySalesAddress',
  CoreContractDefaultRenderProviderSecondarySalesBps = 'coreContract__defaultRenderProviderSecondarySalesBPS',
  CoreContractEnginePlatformProviderAddress = 'coreContract__enginePlatformProviderAddress',
  CoreContractEnginePlatformProviderPercentage = 'coreContract__enginePlatformProviderPercentage',
  CoreContractId = 'coreContract__id',
  CoreContractNewProjectsForbidden = 'coreContract__newProjectsForbidden',
  CoreContractNextProjectId = 'coreContract__nextProjectId',
  CoreContractOnChainGenerator = 'coreContract__onChainGenerator',
  CoreContractPreferredArweaveGateway = 'coreContract__preferredArweaveGateway',
  CoreContractPreferredIpfsGateway = 'coreContract__preferredIPFSGateway',
  CoreContractRandomizerContract = 'coreContract__randomizerContract',
  CoreContractRenderProviderAddress = 'coreContract__renderProviderAddress',
  CoreContractRenderProviderPercentage = 'coreContract__renderProviderPercentage',
  CoreContractRoyaltySplitProvider = 'coreContract__royaltySplitProvider',
  CoreContractType = 'coreContract__type',
  CoreContractUpdatedAt = 'coreContract__updatedAt',
  CreatedAt = 'createdAt',
  Id = 'id',
  RoyaltySplitRecipients = 'royaltySplitRecipients',
  SplitProviderCreator = 'splitProviderCreator',
  TotalAllocation = 'totalAllocation'
}

export type Sale = {
  __typename?: 'Sale';
  /** The block number of the sale */
  blockNumber: Scalars['BigInt']['output'];
  /** The timestamp of the sale */
  blockTimestamp: Scalars['BigInt']['output'];
  /** The buyer address */
  buyer: Scalars['Bytes']['output'];
  /** The exchange used for this sale */
  exchange: Exchange;
  /** The sale id formated: tokenId - token.nextSaleId (using first token sold for bundles) for Opensea V1/V2, orderHash from sale event for Looksrare and Seaport */
  id: Scalars['ID']['output'];
  /** Private sales are flagged by this boolean */
  isPrivate: Scalars['Boolean']['output'];
  /** List of Payment tokens involved in this sale */
  payments: Array<Payment>;
  /** Lookup table to get the list of Tokens sold in this sale */
  saleLookupTables: Array<SaleLookupTable>;
  /** The sale type (Single | Bundle) */
  saleType: SaleType;
  /** The seller address */
  seller: Scalars['Bytes']['output'];
  /** A raw formated string of the token(s) sold (i.e TokenID1::TokenID2::TokenID3) */
  summaryTokensSold: Scalars['String']['output'];
  /** The hash of the transaction */
  txHash: Scalars['Bytes']['output'];
};


export type SalePaymentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Payment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Payment_Filter>;
};


export type SaleSaleLookupTablesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SaleLookupTable_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SaleLookupTable_Filter>;
};

export type SaleLookupTable = {
  __typename?: 'SaleLookupTable';
  /** The block number of the sale */
  blockNumber: Scalars['BigInt']['output'];
  /** Set to `Project Id::Token Id::Sale Id */
  id: Scalars['ID']['output'];
  /** The associated project */
  project: Project;
  /** The associated sale */
  sale: Sale;
  /** Timestamp of the sale */
  timestamp: Scalars['BigInt']['output'];
  /** The token sold */
  token: Token;
};

export type SaleLookupTable_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SaleLookupTable_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SaleLookupTable_Filter>>>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sale?: InputMaybe<Scalars['String']['input']>;
  sale_?: InputMaybe<Sale_Filter>;
  sale_contains?: InputMaybe<Scalars['String']['input']>;
  sale_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_ends_with?: InputMaybe<Scalars['String']['input']>;
  sale_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_gt?: InputMaybe<Scalars['String']['input']>;
  sale_gte?: InputMaybe<Scalars['String']['input']>;
  sale_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sale_lt?: InputMaybe<Scalars['String']['input']>;
  sale_lte?: InputMaybe<Scalars['String']['input']>;
  sale_not?: InputMaybe<Scalars['String']['input']>;
  sale_not_contains?: InputMaybe<Scalars['String']['input']>;
  sale_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  sale_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sale_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  sale_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sale_starts_with?: InputMaybe<Scalars['String']['input']>;
  sale_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_?: InputMaybe<Token_Filter>;
  token_contains?: InputMaybe<Scalars['String']['input']>;
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_gt?: InputMaybe<Scalars['String']['input']>;
  token_gte?: InputMaybe<Scalars['String']['input']>;
  token_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_lt?: InputMaybe<Scalars['String']['input']>;
  token_lte?: InputMaybe<Scalars['String']['input']>;
  token_not?: InputMaybe<Scalars['String']['input']>;
  token_not_contains?: InputMaybe<Scalars['String']['input']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum SaleLookupTable_OrderBy {
  BlockNumber = 'blockNumber',
  Id = 'id',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website',
  Sale = 'sale',
  SaleBlockNumber = 'sale__blockNumber',
  SaleBlockTimestamp = 'sale__blockTimestamp',
  SaleBuyer = 'sale__buyer',
  SaleExchange = 'sale__exchange',
  SaleId = 'sale__id',
  SaleIsPrivate = 'sale__isPrivate',
  SaleSaleType = 'sale__saleType',
  SaleSeller = 'sale__seller',
  SaleSummaryTokensSold = 'sale__summaryTokensSold',
  SaleTxHash = 'sale__txHash',
  Timestamp = 'timestamp',
  Token = 'token',
  TokenCreatedAt = 'token__createdAt',
  TokenHash = 'token__hash',
  TokenId = 'token__id',
  TokenInvocation = 'token__invocation',
  TokenNextSaleId = 'token__nextSaleId',
  TokenTokenId = 'token__tokenId',
  TokenTransactionHash = 'token__transactionHash',
  TokenUpdatedAt = 'token__updatedAt',
  TokenUri = 'token__uri'
}

export enum SaleType {
  Bundle = 'Bundle',
  Single = 'Single'
}

export type Sale_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Sale_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  buyer?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_contains?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_gt?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_gte?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  buyer_lt?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_lte?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_not?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  buyer_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  exchange?: InputMaybe<Exchange>;
  exchange_in?: InputMaybe<Array<Exchange>>;
  exchange_not?: InputMaybe<Exchange>;
  exchange_not_in?: InputMaybe<Array<Exchange>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPrivate_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Sale_Filter>>>;
  payments_?: InputMaybe<Payment_Filter>;
  saleLookupTables_?: InputMaybe<SaleLookupTable_Filter>;
  saleType?: InputMaybe<SaleType>;
  saleType_in?: InputMaybe<Array<SaleType>>;
  saleType_not?: InputMaybe<SaleType>;
  saleType_not_in?: InputMaybe<Array<SaleType>>;
  seller?: InputMaybe<Scalars['Bytes']['input']>;
  seller_contains?: InputMaybe<Scalars['Bytes']['input']>;
  seller_gt?: InputMaybe<Scalars['Bytes']['input']>;
  seller_gte?: InputMaybe<Scalars['Bytes']['input']>;
  seller_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  seller_lt?: InputMaybe<Scalars['Bytes']['input']>;
  seller_lte?: InputMaybe<Scalars['Bytes']['input']>;
  seller_not?: InputMaybe<Scalars['Bytes']['input']>;
  seller_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  seller_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  summaryTokensSold?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_contains?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_ends_with?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_gt?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_gte?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_in?: InputMaybe<Array<Scalars['String']['input']>>;
  summaryTokensSold_lt?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_lte?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_not?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_not_contains?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  summaryTokensSold_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_starts_with?: InputMaybe<Scalars['String']['input']>;
  summaryTokensSold_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  txHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum Sale_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Buyer = 'buyer',
  Exchange = 'exchange',
  Id = 'id',
  IsPrivate = 'isPrivate',
  Payments = 'payments',
  SaleLookupTables = 'saleLookupTables',
  SaleType = 'saleType',
  Seller = 'seller',
  SummaryTokensSold = 'summaryTokensSold',
  TxHash = 'txHash'
}

export type SplitAtomicContract = {
  __typename?: 'SplitAtomicContract';
  /** unique identifier equal to split atomic contract address */
  id: Scalars['ID']['output'];
  /** implementation contract address for this EIP-1167 minimal proxy */
  implementation: Scalars['Bytes']['output'];
  /** Split atomic factory that created this contract */
  splitAtomicFactory: SplitAtomicFactory;
  /** List of split atomic contract splits */
  splits: Array<SplitAtomicSplit>;
  /** type of split atomic contract */
  type: Scalars['String']['output'];
  updatedAt: Scalars['BigInt']['output'];
};


export type SplitAtomicContractSplitsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SplitAtomicSplit_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SplitAtomicSplit_Filter>;
};

export type SplitAtomicContract_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SplitAtomicContract_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  implementation?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_contains?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_gt?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_gte?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  implementation_lt?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_lte?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_not?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SplitAtomicContract_Filter>>>;
  splitAtomicFactory?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_?: InputMaybe<SplitAtomicFactory_Filter>;
  splitAtomicFactory_contains?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_ends_with?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_gt?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_gte?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_in?: InputMaybe<Array<Scalars['String']['input']>>;
  splitAtomicFactory_lt?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_lte?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_not?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_not_contains?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  splitAtomicFactory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_starts_with?: InputMaybe<Scalars['String']['input']>;
  splitAtomicFactory_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  splits_?: InputMaybe<SplitAtomicSplit_Filter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  type_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum SplitAtomicContract_OrderBy {
  Id = 'id',
  Implementation = 'implementation',
  SplitAtomicFactory = 'splitAtomicFactory',
  SplitAtomicFactoryAbandoned = 'splitAtomicFactory__abandoned',
  SplitAtomicFactoryId = 'splitAtomicFactory__id',
  SplitAtomicFactoryImplementation = 'splitAtomicFactory__implementation',
  SplitAtomicFactoryRequiredSplitAddress = 'splitAtomicFactory__requiredSplitAddress',
  SplitAtomicFactoryRequiredSplitBasisPoints = 'splitAtomicFactory__requiredSplitBasisPoints',
  SplitAtomicFactoryType = 'splitAtomicFactory__type',
  SplitAtomicFactoryUpdatedAt = 'splitAtomicFactory__updatedAt',
  Splits = 'splits',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type SplitAtomicFactory = {
  __typename?: 'SplitAtomicFactory';
  /** Boolean representing if the factory is abandoned (can no longer be used to create new contracts) */
  abandoned: Scalars['Boolean']['output'];
  /** unique identifier equal to split atomic factory contract address */
  id: Scalars['ID']['output'];
  /** implementation contract address for the created EIP-1167 minimal proxy contracts */
  implementation: Scalars['Bytes']['output'];
  /** Required split address for this factory */
  requiredSplitAddress?: Maybe<Scalars['Bytes']['output']>;
  /** Required split basis points for this factory */
  requiredSplitBasisPoints?: Maybe<Scalars['BigInt']['output']>;
  /** List of split atomic contracts created by this factory */
  splitAtomicContracts: Array<SplitAtomicContract>;
  /** type of split atomic factory */
  type: Scalars['String']['output'];
  updatedAt: Scalars['BigInt']['output'];
};


export type SplitAtomicFactorySplitAtomicContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SplitAtomicContract_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SplitAtomicContract_Filter>;
};

export type SplitAtomicFactory_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  abandoned?: InputMaybe<Scalars['Boolean']['input']>;
  abandoned_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  abandoned_not?: InputMaybe<Scalars['Boolean']['input']>;
  abandoned_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  and?: InputMaybe<Array<InputMaybe<SplitAtomicFactory_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  implementation?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_contains?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_gt?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_gte?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  implementation_lt?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_lte?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_not?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  implementation_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SplitAtomicFactory_Filter>>>;
  requiredSplitAddress?: InputMaybe<Scalars['Bytes']['input']>;
  requiredSplitAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  requiredSplitAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  requiredSplitAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  requiredSplitAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  requiredSplitAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  requiredSplitAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  requiredSplitAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  requiredSplitAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  requiredSplitAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  requiredSplitBasisPoints?: InputMaybe<Scalars['BigInt']['input']>;
  requiredSplitBasisPoints_gt?: InputMaybe<Scalars['BigInt']['input']>;
  requiredSplitBasisPoints_gte?: InputMaybe<Scalars['BigInt']['input']>;
  requiredSplitBasisPoints_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requiredSplitBasisPoints_lt?: InputMaybe<Scalars['BigInt']['input']>;
  requiredSplitBasisPoints_lte?: InputMaybe<Scalars['BigInt']['input']>;
  requiredSplitBasisPoints_not?: InputMaybe<Scalars['BigInt']['input']>;
  requiredSplitBasisPoints_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  splitAtomicContracts_?: InputMaybe<SplitAtomicContract_Filter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  type_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum SplitAtomicFactory_OrderBy {
  Abandoned = 'abandoned',
  Id = 'id',
  Implementation = 'implementation',
  RequiredSplitAddress = 'requiredSplitAddress',
  RequiredSplitBasisPoints = 'requiredSplitBasisPoints',
  SplitAtomicContracts = 'splitAtomicContracts',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type SplitAtomicSplit = {
  __typename?: 'SplitAtomicSplit';
  /** Basis points of the split */
  basisPoints: Scalars['BigInt']['output'];
  /** unique identifier equal to split atomic contract address + index */
  id: Scalars['ID']['output'];
  /** Index of this split */
  index: Scalars['BigInt']['output'];
  /** Address of the recipient of this split */
  recipient: Scalars['Bytes']['output'];
  /** Split atomic contract that created this split */
  splitAtomicContract: SplitAtomicContract;
};

export type SplitAtomicSplit_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SplitAtomicSplit_Filter>>>;
  basisPoints?: InputMaybe<Scalars['BigInt']['input']>;
  basisPoints_gt?: InputMaybe<Scalars['BigInt']['input']>;
  basisPoints_gte?: InputMaybe<Scalars['BigInt']['input']>;
  basisPoints_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  basisPoints_lt?: InputMaybe<Scalars['BigInt']['input']>;
  basisPoints_lte?: InputMaybe<Scalars['BigInt']['input']>;
  basisPoints_not?: InputMaybe<Scalars['BigInt']['input']>;
  basisPoints_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SplitAtomicSplit_Filter>>>;
  recipient?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_contains?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_gt?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_gte?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  recipient_lt?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_lte?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_not?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  recipient_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  splitAtomicContract?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_?: InputMaybe<SplitAtomicContract_Filter>;
  splitAtomicContract_contains?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_ends_with?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_gt?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_gte?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_in?: InputMaybe<Array<Scalars['String']['input']>>;
  splitAtomicContract_lt?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_lte?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_not?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_not_contains?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  splitAtomicContract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_starts_with?: InputMaybe<Scalars['String']['input']>;
  splitAtomicContract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum SplitAtomicSplit_OrderBy {
  BasisPoints = 'basisPoints',
  Id = 'id',
  Index = 'index',
  Recipient = 'recipient',
  SplitAtomicContract = 'splitAtomicContract',
  SplitAtomicContractId = 'splitAtomicContract__id',
  SplitAtomicContractImplementation = 'splitAtomicContract__implementation',
  SplitAtomicContractType = 'splitAtomicContract__type',
  SplitAtomicContractUpdatedAt = 'splitAtomicContract__updatedAt'
}

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilterInput_Remote_Rel_Projects_MetadataadditionalExhibition = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilterInput_Remote_Rel_Projects_Metadataarticle = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilterInput_Remote_Rel_Projects_MetadataartistPage = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilterInput_Remote_Rel_Projects_Metadataexhibition = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type Token = {
  __typename?: 'Token';
  /** Contract the token is on */
  contract: Contract;
  createdAt: Scalars['BigInt']['output'];
  /** Unique string used as input to the tokens project script */
  hash: Scalars['Bytes']['output'];
  /** Unique identifier made up of contract address and token id */
  id: Scalars['ID']['output'];
  /** Invocation number of the project */
  invocation: Scalars['BigInt']['output'];
  /** Next available sale id */
  nextSaleId: Scalars['BigInt']['output'];
  /** Current owner of the token */
  owner: Account;
  /** All PMPs associated with this token */
  pmps?: Maybe<Array<Pmp>>;
  primaryPurchaseDetails?: Maybe<PrimaryPurchase>;
  /** Project of the token */
  project: Project;
  /** Lookup table to get the Sale history */
  saleLookupTables: Array<SaleLookupTable>;
  /** ID of the token on the contract */
  tokenId: Scalars['BigInt']['output'];
  /** Transaction hash of token mint */
  transactionHash: Scalars['Bytes']['output'];
  transfers?: Maybe<Array<Transfer>>;
  updatedAt: Scalars['BigInt']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};


export type TokenPmpsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pmp_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Pmp_Filter>;
};


export type TokenSaleLookupTablesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SaleLookupTable_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SaleLookupTable_Filter>;
};


export type TokenTransfersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Transfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Transfer_Filter>;
};

export type Token_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  contract?: InputMaybe<Scalars['String']['input']>;
  contract_?: InputMaybe<Contract_Filter>;
  contract_contains?: InputMaybe<Scalars['String']['input']>;
  contract_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_ends_with?: InputMaybe<Scalars['String']['input']>;
  contract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_gt?: InputMaybe<Scalars['String']['input']>;
  contract_gte?: InputMaybe<Scalars['String']['input']>;
  contract_in?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_lt?: InputMaybe<Scalars['String']['input']>;
  contract_lte?: InputMaybe<Scalars['String']['input']>;
  contract_not?: InputMaybe<Scalars['String']['input']>;
  contract_not_contains?: InputMaybe<Scalars['String']['input']>;
  contract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  contract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  contract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_starts_with?: InputMaybe<Scalars['String']['input']>;
  contract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  hash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  hash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  hash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  hash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  hash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  hash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  hash_not?: InputMaybe<Scalars['Bytes']['input']>;
  hash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  hash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  invocation?: InputMaybe<Scalars['BigInt']['input']>;
  invocation_gt?: InputMaybe<Scalars['BigInt']['input']>;
  invocation_gte?: InputMaybe<Scalars['BigInt']['input']>;
  invocation_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  invocation_lt?: InputMaybe<Scalars['BigInt']['input']>;
  invocation_lte?: InputMaybe<Scalars['BigInt']['input']>;
  invocation_not?: InputMaybe<Scalars['BigInt']['input']>;
  invocation_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextSaleId?: InputMaybe<Scalars['BigInt']['input']>;
  nextSaleId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextSaleId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextSaleId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextSaleId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextSaleId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextSaleId_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextSaleId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  owner_?: InputMaybe<Account_Filter>;
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  owner_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  owner_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  owner_gt?: InputMaybe<Scalars['String']['input']>;
  owner_gte?: InputMaybe<Scalars['String']['input']>;
  owner_in?: InputMaybe<Array<Scalars['String']['input']>>;
  owner_lt?: InputMaybe<Scalars['String']['input']>;
  owner_lte?: InputMaybe<Scalars['String']['input']>;
  owner_not?: InputMaybe<Scalars['String']['input']>;
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  owner_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  owner_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  owner_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  owner_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pmps_?: InputMaybe<Pmp_Filter>;
  primaryPurchaseDetails?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_?: InputMaybe<PrimaryPurchase_Filter>;
  primaryPurchaseDetails_contains?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_ends_with?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_gt?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_gte?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_in?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryPurchaseDetails_lt?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_lte?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_not?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_not_contains?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryPurchaseDetails_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_starts_with?: InputMaybe<Scalars['String']['input']>;
  primaryPurchaseDetails_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  project_?: InputMaybe<Project_Filter>;
  project_contains?: InputMaybe<Scalars['String']['input']>;
  project_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_gt?: InputMaybe<Scalars['String']['input']>;
  project_gte?: InputMaybe<Scalars['String']['input']>;
  project_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_lt?: InputMaybe<Scalars['String']['input']>;
  project_lte?: InputMaybe<Scalars['String']['input']>;
  project_not?: InputMaybe<Scalars['String']['input']>;
  project_not_contains?: InputMaybe<Scalars['String']['input']>;
  project_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  project_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  project_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  project_starts_with?: InputMaybe<Scalars['String']['input']>;
  project_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  saleLookupTables_?: InputMaybe<SaleLookupTable_Filter>;
  tokenId?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transfers_?: InputMaybe<Transfer_Filter>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  uri?: InputMaybe<Scalars['String']['input']>;
  uri_contains?: InputMaybe<Scalars['String']['input']>;
  uri_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  uri_ends_with?: InputMaybe<Scalars['String']['input']>;
  uri_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  uri_gt?: InputMaybe<Scalars['String']['input']>;
  uri_gte?: InputMaybe<Scalars['String']['input']>;
  uri_in?: InputMaybe<Array<Scalars['String']['input']>>;
  uri_lt?: InputMaybe<Scalars['String']['input']>;
  uri_lte?: InputMaybe<Scalars['String']['input']>;
  uri_not?: InputMaybe<Scalars['String']['input']>;
  uri_not_contains?: InputMaybe<Scalars['String']['input']>;
  uri_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  uri_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  uri_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  uri_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  uri_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  uri_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  uri_starts_with?: InputMaybe<Scalars['String']['input']>;
  uri_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Token_OrderBy {
  Contract = 'contract',
  ContractAdmin = 'contract__admin',
  ContractAutoApproveArtistSplitProposals = 'contract__autoApproveArtistSplitProposals',
  ContractCoreVersion = 'contract__coreVersion',
  ContractCreatedAt = 'contract__createdAt',
  ContractCurationRegistry = 'contract__curationRegistry',
  ContractDefaultEnginePlatformProviderSecondarySalesAddress = 'contract__defaultEnginePlatformProviderSecondarySalesAddress',
  ContractDefaultEnginePlatformProviderSecondarySalesBps = 'contract__defaultEnginePlatformProviderSecondarySalesBPS',
  ContractDefaultRenderProviderSecondarySalesAddress = 'contract__defaultRenderProviderSecondarySalesAddress',
  ContractDefaultRenderProviderSecondarySalesBps = 'contract__defaultRenderProviderSecondarySalesBPS',
  ContractEnginePlatformProviderAddress = 'contract__enginePlatformProviderAddress',
  ContractEnginePlatformProviderPercentage = 'contract__enginePlatformProviderPercentage',
  ContractId = 'contract__id',
  ContractNewProjectsForbidden = 'contract__newProjectsForbidden',
  ContractNextProjectId = 'contract__nextProjectId',
  ContractOnChainGenerator = 'contract__onChainGenerator',
  ContractPreferredArweaveGateway = 'contract__preferredArweaveGateway',
  ContractPreferredIpfsGateway = 'contract__preferredIPFSGateway',
  ContractRandomizerContract = 'contract__randomizerContract',
  ContractRenderProviderAddress = 'contract__renderProviderAddress',
  ContractRenderProviderPercentage = 'contract__renderProviderPercentage',
  ContractRoyaltySplitProvider = 'contract__royaltySplitProvider',
  ContractType = 'contract__type',
  ContractUpdatedAt = 'contract__updatedAt',
  CreatedAt = 'createdAt',
  Hash = 'hash',
  Id = 'id',
  Invocation = 'invocation',
  NextSaleId = 'nextSaleId',
  Owner = 'owner',
  OwnerId = 'owner__id',
  Pmps = 'pmps',
  PrimaryPurchaseDetails = 'primaryPurchaseDetails',
  PrimaryPurchaseDetailsCurrencyAddress = 'primaryPurchaseDetails__currencyAddress',
  PrimaryPurchaseDetailsCurrencyDecimals = 'primaryPurchaseDetails__currencyDecimals',
  PrimaryPurchaseDetailsCurrencySymbol = 'primaryPurchaseDetails__currencySymbol',
  PrimaryPurchaseDetailsId = 'primaryPurchaseDetails__id',
  PrimaryPurchaseDetailsMinterAddress = 'primaryPurchaseDetails__minterAddress',
  PrimaryPurchaseDetailsTransactionHash = 'primaryPurchaseDetails__transactionHash',
  Project = 'project',
  ProjectActivatedAt = 'project__activatedAt',
  ProjectActive = 'project__active',
  ProjectAdditionalPayee = 'project__additionalPayee',
  ProjectAdditionalPayeePercentage = 'project__additionalPayeePercentage',
  ProjectAdditionalPayeeSecondarySalesAddress = 'project__additionalPayeeSecondarySalesAddress',
  ProjectAdditionalPayeeSecondarySalesPercentage = 'project__additionalPayeeSecondarySalesPercentage',
  ProjectArtistAddress = 'project__artistAddress',
  ProjectArtistName = 'project__artistName',
  ProjectAspectRatio = 'project__aspectRatio',
  ProjectBaseIpfsUri = 'project__baseIpfsUri',
  ProjectBaseUri = 'project__baseUri',
  ProjectComplete = 'project__complete',
  ProjectCompletedAt = 'project__completedAt',
  ProjectCreatedAt = 'project__createdAt',
  ProjectCurrencyAddress = 'project__currencyAddress',
  ProjectCurrencyDecimals = 'project__currencyDecimals',
  ProjectCurrencySymbol = 'project__currencySymbol',
  ProjectDescription = 'project__description',
  ProjectDynamic = 'project__dynamic',
  ProjectEnginePlatformProviderSecondarySalesAddress = 'project__enginePlatformProviderSecondarySalesAddress',
  ProjectEnginePlatformProviderSecondarySalesBps = 'project__enginePlatformProviderSecondarySalesBPS',
  ProjectErc2981SplitterAddress = 'project__erc2981SplitterAddress',
  ProjectExternalAssetDependenciesLocked = 'project__externalAssetDependenciesLocked',
  ProjectExternalAssetDependencyCount = 'project__externalAssetDependencyCount',
  ProjectId = 'project__id',
  ProjectInvocations = 'project__invocations',
  ProjectIpfsHash = 'project__ipfsHash',
  ProjectLicense = 'project__license',
  ProjectLocked = 'project__locked',
  ProjectMaxInvocations = 'project__maxInvocations',
  ProjectName = 'project__name',
  ProjectPaused = 'project__paused',
  ProjectPricePerTokenInWei = 'project__pricePerTokenInWei',
  ProjectProjectId = 'project__projectId',
  ProjectRenderProviderSecondarySalesAddress = 'project__renderProviderSecondarySalesAddress',
  ProjectRenderProviderSecondarySalesBps = 'project__renderProviderSecondarySalesBPS',
  ProjectRoyaltyPercentage = 'project__royaltyPercentage',
  ProjectScript = 'project__script',
  ProjectScriptCount = 'project__scriptCount',
  ProjectScriptJson = 'project__scriptJSON',
  ProjectScriptTypeAndVersion = 'project__scriptTypeAndVersion',
  ProjectScriptTypeAndVersionOverride = 'project__scriptTypeAndVersionOverride',
  ProjectScriptUpdatedAt = 'project__scriptUpdatedAt',
  ProjectUpdatedAt = 'project__updatedAt',
  ProjectUseHashString = 'project__useHashString',
  ProjectUseIpfs = 'project__useIpfs',
  ProjectWebsite = 'project__website',
  SaleLookupTables = 'saleLookupTables',
  TokenId = 'tokenId',
  TransactionHash = 'transactionHash',
  Transfers = 'transfers',
  UpdatedAt = 'updatedAt',
  Uri = 'uri'
}

export type Transfer = {
  __typename?: 'Transfer';
  blockHash: Scalars['Bytes']['output'];
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  from: Scalars['Bytes']['output'];
  id: Scalars['ID']['output'];
  to: Scalars['Bytes']['output'];
  token: Token;
  transactionHash: Scalars['Bytes']['output'];
};

export type Transfer_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Transfer_Filter>>>;
  blockHash?: InputMaybe<Scalars['Bytes']['input']>;
  blockHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  blockHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  blockHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  blockHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  blockHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  blockHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  from?: InputMaybe<Scalars['Bytes']['input']>;
  from_contains?: InputMaybe<Scalars['Bytes']['input']>;
  from_gt?: InputMaybe<Scalars['Bytes']['input']>;
  from_gte?: InputMaybe<Scalars['Bytes']['input']>;
  from_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  from_lt?: InputMaybe<Scalars['Bytes']['input']>;
  from_lte?: InputMaybe<Scalars['Bytes']['input']>;
  from_not?: InputMaybe<Scalars['Bytes']['input']>;
  from_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  from_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Transfer_Filter>>>;
  to?: InputMaybe<Scalars['Bytes']['input']>;
  to_contains?: InputMaybe<Scalars['Bytes']['input']>;
  to_gt?: InputMaybe<Scalars['Bytes']['input']>;
  to_gte?: InputMaybe<Scalars['Bytes']['input']>;
  to_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  to_lt?: InputMaybe<Scalars['Bytes']['input']>;
  to_lte?: InputMaybe<Scalars['Bytes']['input']>;
  to_not?: InputMaybe<Scalars['Bytes']['input']>;
  to_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  to_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_?: InputMaybe<Token_Filter>;
  token_contains?: InputMaybe<Scalars['String']['input']>;
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_gt?: InputMaybe<Scalars['String']['input']>;
  token_gte?: InputMaybe<Scalars['String']['input']>;
  token_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_lt?: InputMaybe<Scalars['String']['input']>;
  token_lte?: InputMaybe<Scalars['String']['input']>;
  token_not?: InputMaybe<Scalars['String']['input']>;
  token_not_contains?: InputMaybe<Scalars['String']['input']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum Transfer_OrderBy {
  BlockHash = 'blockHash',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  From = 'from',
  Id = 'id',
  To = 'to',
  Token = 'token',
  TokenCreatedAt = 'token__createdAt',
  TokenHash = 'token__hash',
  TokenId = 'token__id',
  TokenInvocation = 'token__invocation',
  TokenNextSaleId = 'token__nextSaleId',
  TokenTokenId = 'token__tokenId',
  TokenTransactionHash = 'token__transactionHash',
  TokenUpdatedAt = 'token__updatedAt',
  TokenUri = 'token__uri',
  TransactionHash = 'transactionHash'
}

export type UpdateFeaturesScriptOutput = {
  __typename?: 'UpdateFeaturesScriptOutput';
  project_id: Scalars['String']['output'];
};

export type UpdateProjectMediaScriptOutput = {
  __typename?: 'UpdateProjectMediaScriptOutput';
  project_id: Scalars['String']['output'];
};

export type UpdateTokenMediaScriptOutput = {
  __typename?: 'UpdateTokenMediaScriptOutput';
  token_ids: Array<Maybe<Scalars['String']['output']>>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type Whitelisting = {
  __typename?: 'Whitelisting';
  account: Account;
  contract: Contract;
  id: Scalars['ID']['output'];
};

export type Whitelisting_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<Whitelisting_Filter>>>;
  contract?: InputMaybe<Scalars['String']['input']>;
  contract_?: InputMaybe<Contract_Filter>;
  contract_contains?: InputMaybe<Scalars['String']['input']>;
  contract_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_ends_with?: InputMaybe<Scalars['String']['input']>;
  contract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_gt?: InputMaybe<Scalars['String']['input']>;
  contract_gte?: InputMaybe<Scalars['String']['input']>;
  contract_in?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_lt?: InputMaybe<Scalars['String']['input']>;
  contract_lte?: InputMaybe<Scalars['String']['input']>;
  contract_not?: InputMaybe<Scalars['String']['input']>;
  contract_not_contains?: InputMaybe<Scalars['String']['input']>;
  contract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  contract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  contract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  contract_starts_with?: InputMaybe<Scalars['String']['input']>;
  contract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Whitelisting_Filter>>>;
};

export enum Whitelisting_OrderBy {
  Account = 'account',
  AccountId = 'account__id',
  Contract = 'contract',
  ContractAdmin = 'contract__admin',
  ContractAutoApproveArtistSplitProposals = 'contract__autoApproveArtistSplitProposals',
  ContractCoreVersion = 'contract__coreVersion',
  ContractCreatedAt = 'contract__createdAt',
  ContractCurationRegistry = 'contract__curationRegistry',
  ContractDefaultEnginePlatformProviderSecondarySalesAddress = 'contract__defaultEnginePlatformProviderSecondarySalesAddress',
  ContractDefaultEnginePlatformProviderSecondarySalesBps = 'contract__defaultEnginePlatformProviderSecondarySalesBPS',
  ContractDefaultRenderProviderSecondarySalesAddress = 'contract__defaultRenderProviderSecondarySalesAddress',
  ContractDefaultRenderProviderSecondarySalesBps = 'contract__defaultRenderProviderSecondarySalesBPS',
  ContractEnginePlatformProviderAddress = 'contract__enginePlatformProviderAddress',
  ContractEnginePlatformProviderPercentage = 'contract__enginePlatformProviderPercentage',
  ContractId = 'contract__id',
  ContractNewProjectsForbidden = 'contract__newProjectsForbidden',
  ContractNextProjectId = 'contract__nextProjectId',
  ContractOnChainGenerator = 'contract__onChainGenerator',
  ContractPreferredArweaveGateway = 'contract__preferredArweaveGateway',
  ContractPreferredIpfsGateway = 'contract__preferredIPFSGateway',
  ContractRandomizerContract = 'contract__randomizerContract',
  ContractRenderProviderAddress = 'contract__renderProviderAddress',
  ContractRenderProviderPercentage = 'contract__renderProviderPercentage',
  ContractRoyaltySplitProvider = 'contract__royaltySplitProvider',
  ContractType = 'contract__type',
  ContractUpdatedAt = 'contract__updatedAt',
  Id = 'id'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

/** All Art Blocks artists. */
export type Artists = {
  __typename?: 'artists';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  is_ab_staff?: Maybe<Scalars['Boolean']['output']>;
  is_curator?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  most_recent_hosted_project?: Maybe<Projects_Metadata>;
  most_recent_hosted_project_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  most_recent_project?: Maybe<Projects_Metadata>;
  most_recent_project_id?: Maybe<Scalars['String']['output']>;
  nonce_offset?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  projects: Array<Projects_Metadata>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Metadata_Aggregate;
  public_address?: Maybe<Scalars['String']['output']>;
  tos_accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  viewed_warning_banner?: Maybe<Scalars['Boolean']['output']>;
};


/** All Art Blocks artists. */
export type ArtistsProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


/** All Art Blocks artists. */
export type ArtistsProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};

/** aggregated selection of "artists" */
export type Artists_Aggregate = {
  __typename?: 'artists_aggregate';
  aggregate?: Maybe<Artists_Aggregate_Fields>;
  nodes: Array<Artists>;
};

/** aggregate fields of "artists" */
export type Artists_Aggregate_Fields = {
  __typename?: 'artists_aggregate_fields';
  avg?: Maybe<Artists_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Artists_Max_Fields>;
  min?: Maybe<Artists_Min_Fields>;
  stddev?: Maybe<Artists_Stddev_Fields>;
  stddev_pop?: Maybe<Artists_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Artists_Stddev_Samp_Fields>;
  sum?: Maybe<Artists_Sum_Fields>;
  var_pop?: Maybe<Artists_Var_Pop_Fields>;
  var_samp?: Maybe<Artists_Var_Samp_Fields>;
  variance?: Maybe<Artists_Variance_Fields>;
};


/** aggregate fields of "artists" */
export type Artists_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Artists_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Artists_Avg_Fields = {
  __typename?: 'artists_avg_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "artists". All fields are combined with a logical 'AND'. */
export type Artists_Bool_Exp = {
  _and?: InputMaybe<Array<Artists_Bool_Exp>>;
  _not?: InputMaybe<Artists_Bool_Exp>;
  _or?: InputMaybe<Array<Artists_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_ab_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_curator?: InputMaybe<Boolean_Comparison_Exp>;
  most_recent_hosted_project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  most_recent_hosted_project_id?: InputMaybe<String_Comparison_Exp>;
  most_recent_project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  most_recent_project_id?: InputMaybe<String_Comparison_Exp>;
  nonce_offset?: InputMaybe<Int_Comparison_Exp>;
  projects?: InputMaybe<Projects_Metadata_Bool_Exp>;
  projects_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Bool_Exp>;
  public_address?: InputMaybe<String_Comparison_Exp>;
  tos_accepted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  viewed_warning_banner?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Artists_Max_Fields = {
  __typename?: 'artists_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  most_recent_hosted_project_id?: Maybe<Scalars['String']['output']>;
  most_recent_project_id?: Maybe<Scalars['String']['output']>;
  nonce_offset?: Maybe<Scalars['Int']['output']>;
  public_address?: Maybe<Scalars['String']['output']>;
  tos_accepted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Artists_Min_Fields = {
  __typename?: 'artists_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  most_recent_hosted_project_id?: Maybe<Scalars['String']['output']>;
  most_recent_project_id?: Maybe<Scalars['String']['output']>;
  nonce_offset?: Maybe<Scalars['Int']['output']>;
  public_address?: Maybe<Scalars['String']['output']>;
  tos_accepted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "artists". */
export type Artists_Order_By = {
  created_at?: InputMaybe<Order_By>;
  is_ab_staff?: InputMaybe<Order_By>;
  is_curator?: InputMaybe<Order_By>;
  most_recent_hosted_project?: InputMaybe<Projects_Metadata_Order_By>;
  most_recent_hosted_project_id?: InputMaybe<Order_By>;
  most_recent_project?: InputMaybe<Projects_Metadata_Order_By>;
  most_recent_project_id?: InputMaybe<Order_By>;
  nonce_offset?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Order_By>;
  public_address?: InputMaybe<Order_By>;
  tos_accepted_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  viewed_warning_banner?: InputMaybe<Order_By>;
};

/** select columns of table "artists" */
export enum Artists_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsAbStaff = 'is_ab_staff',
  /** column name */
  IsCurator = 'is_curator',
  /** column name */
  MostRecentHostedProjectId = 'most_recent_hosted_project_id',
  /** column name */
  MostRecentProjectId = 'most_recent_project_id',
  /** column name */
  NonceOffset = 'nonce_offset',
  /** column name */
  PublicAddress = 'public_address',
  /** column name */
  TosAcceptedAt = 'tos_accepted_at',
  /** column name */
  ViewedWarningBanner = 'viewed_warning_banner'
}

/** aggregate stddev on columns */
export type Artists_Stddev_Fields = {
  __typename?: 'artists_stddev_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Artists_Stddev_Pop_Fields = {
  __typename?: 'artists_stddev_pop_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Artists_Stddev_Samp_Fields = {
  __typename?: 'artists_stddev_samp_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "artists" */
export type Artists_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Artists_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Artists_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_ab_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_curator?: InputMaybe<Scalars['Boolean']['input']>;
  most_recent_hosted_project_id?: InputMaybe<Scalars['String']['input']>;
  most_recent_project_id?: InputMaybe<Scalars['String']['input']>;
  nonce_offset?: InputMaybe<Scalars['Int']['input']>;
  public_address?: InputMaybe<Scalars['String']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viewed_warning_banner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Artists_Sum_Fields = {
  __typename?: 'artists_sum_fields';
  nonce_offset?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Artists_Var_Pop_Fields = {
  __typename?: 'artists_var_pop_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Artists_Var_Samp_Fields = {
  __typename?: 'artists_var_samp_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Artists_Variance_Fields = {
  __typename?: 'artists_variance_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "bid_types" */
export type Bid_Types = {
  __typename?: 'bid_types';
  type: Scalars['String']['output'];
};

/** aggregated selection of "bid_types" */
export type Bid_Types_Aggregate = {
  __typename?: 'bid_types_aggregate';
  aggregate?: Maybe<Bid_Types_Aggregate_Fields>;
  nodes: Array<Bid_Types>;
};

/** aggregate fields of "bid_types" */
export type Bid_Types_Aggregate_Fields = {
  __typename?: 'bid_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Bid_Types_Max_Fields>;
  min?: Maybe<Bid_Types_Min_Fields>;
};


/** aggregate fields of "bid_types" */
export type Bid_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bid_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bid_types". All fields are combined with a logical 'AND'. */
export type Bid_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Bid_Types_Bool_Exp>>;
  _not?: InputMaybe<Bid_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Bid_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bid_types" */
export enum Bid_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  BidTypesPkey = 'bid_types_pkey'
}

export enum Bid_Types_Enum {
  Ram = 'RAM',
  Sea = 'SEA'
}

/** Boolean expression to compare columns of type "bid_types_enum". All fields are combined with logical 'AND'. */
export type Bid_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Bid_Types_Enum>;
  _in?: InputMaybe<Array<Bid_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Bid_Types_Enum>;
  _nin?: InputMaybe<Array<Bid_Types_Enum>>;
};

/** input type for inserting data into table "bid_types" */
export type Bid_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Bid_Types_Max_Fields = {
  __typename?: 'bid_types_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Bid_Types_Min_Fields = {
  __typename?: 'bid_types_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "bid_types" */
export type Bid_Types_Mutation_Response = {
  __typename?: 'bid_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bid_Types>;
};

/** on_conflict condition type for table "bid_types" */
export type Bid_Types_On_Conflict = {
  constraint: Bid_Types_Constraint;
  update_columns?: Array<Bid_Types_Update_Column>;
  where?: InputMaybe<Bid_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "bid_types". */
export type Bid_Types_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bid_types */
export type Bid_Types_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "bid_types" */
export enum Bid_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "bid_types" */
export type Bid_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bid_types" */
export type Bid_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bid_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bid_Types_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bid_types" */
export enum Bid_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type Bid_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bid_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bid_Types_Bool_Exp;
};

/** columns and relationships of "bids_metadata" */
export type Bids_Metadata = {
  __typename?: 'bids_metadata';
  bid_type: Bid_Types_Enum;
  bid_value: Scalars['String']['output'];
  bidder_address: Scalars['String']['output'];
  /** An object relationship */
  core_contract: Contracts_Metadata;
  core_contract_address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_removed?: Maybe<Scalars['Boolean']['output']>;
  log_index: Scalars['Int']['output'];
  /** An object relationship */
  minter: Minters_Metadata;
  minter_address: Scalars['String']['output'];
  /** An object relationship */
  project: Projects_Metadata;
  project_id: Scalars['String']['output'];
  ram_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['bigint']['output']>;
  settled?: Maybe<Scalars['Boolean']['output']>;
  slot_index?: Maybe<Scalars['bigint']['output']>;
  time_of_bid: Scalars['timestamptz']['output'];
  /** An object relationship */
  token?: Maybe<Tokens_Metadata>;
  token_id?: Maybe<Scalars['String']['output']>;
  tx_hash?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  winning_bid?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "bids_metadata" */
export type Bids_Metadata_Aggregate = {
  __typename?: 'bids_metadata_aggregate';
  aggregate?: Maybe<Bids_Metadata_Aggregate_Fields>;
  nodes: Array<Bids_Metadata>;
};

export type Bids_Metadata_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Bids_Metadata_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Bids_Metadata_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Bids_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Bids_Metadata_Aggregate_Bool_Exp_Bool_And = {
  arguments: Bids_Metadata_Select_Column_Bids_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Bids_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Bids_Metadata_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Bids_Metadata_Select_Column_Bids_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Bids_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Bids_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Bids_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "bids_metadata" */
export type Bids_Metadata_Aggregate_Fields = {
  __typename?: 'bids_metadata_aggregate_fields';
  avg?: Maybe<Bids_Metadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Bids_Metadata_Max_Fields>;
  min?: Maybe<Bids_Metadata_Min_Fields>;
  stddev?: Maybe<Bids_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Bids_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bids_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Bids_Metadata_Sum_Fields>;
  var_pop?: Maybe<Bids_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Bids_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Bids_Metadata_Variance_Fields>;
};


/** aggregate fields of "bids_metadata" */
export type Bids_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "bids_metadata" */
export type Bids_Metadata_Aggregate_Order_By = {
  avg?: InputMaybe<Bids_Metadata_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bids_Metadata_Max_Order_By>;
  min?: InputMaybe<Bids_Metadata_Min_Order_By>;
  stddev?: InputMaybe<Bids_Metadata_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bids_Metadata_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bids_Metadata_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bids_Metadata_Sum_Order_By>;
  var_pop?: InputMaybe<Bids_Metadata_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bids_Metadata_Var_Samp_Order_By>;
  variance?: InputMaybe<Bids_Metadata_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bids_metadata" */
export type Bids_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Bids_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bids_Metadata_On_Conflict>;
};

/** aggregate avg on columns */
export type Bids_Metadata_Avg_Fields = {
  __typename?: 'bids_metadata_avg_fields';
  log_index?: Maybe<Scalars['Float']['output']>;
  ram_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  slot_index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "bids_metadata" */
export type Bids_Metadata_Avg_Order_By = {
  log_index?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bids_metadata". All fields are combined with a logical 'AND'. */
export type Bids_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Bids_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Bids_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Bids_Metadata_Bool_Exp>>;
  bid_type?: InputMaybe<Bid_Types_Enum_Comparison_Exp>;
  bid_value?: InputMaybe<String_Comparison_Exp>;
  bidder_address?: InputMaybe<String_Comparison_Exp>;
  core_contract?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  core_contract_address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_removed?: InputMaybe<Boolean_Comparison_Exp>;
  log_index?: InputMaybe<Int_Comparison_Exp>;
  minter?: InputMaybe<Minters_Metadata_Bool_Exp>;
  minter_address?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  ram_id?: InputMaybe<Int_Comparison_Exp>;
  rank?: InputMaybe<Bigint_Comparison_Exp>;
  settled?: InputMaybe<Boolean_Comparison_Exp>;
  slot_index?: InputMaybe<Bigint_Comparison_Exp>;
  time_of_bid?: InputMaybe<Timestamptz_Comparison_Exp>;
  token?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  token_id?: InputMaybe<String_Comparison_Exp>;
  tx_hash?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  winning_bid?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "bids_metadata" */
export enum Bids_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  BidsMetadataPkey = 'bids_metadata_pkey'
}

/** input type for incrementing numeric columns in table "bids_metadata" */
export type Bids_Metadata_Inc_Input = {
  log_index?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['bigint']['input']>;
  slot_index?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "bids_metadata" */
export type Bids_Metadata_Insert_Input = {
  bid_type?: InputMaybe<Bid_Types_Enum>;
  bid_value?: InputMaybe<Scalars['String']['input']>;
  bidder_address?: InputMaybe<Scalars['String']['input']>;
  core_contract?: InputMaybe<Contracts_Metadata_Obj_Rel_Insert_Input>;
  core_contract_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  log_index?: InputMaybe<Scalars['Int']['input']>;
  minter?: InputMaybe<Minters_Metadata_Obj_Rel_Insert_Input>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['bigint']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  slot_index?: InputMaybe<Scalars['bigint']['input']>;
  time_of_bid?: InputMaybe<Scalars['timestamptz']['input']>;
  token?: InputMaybe<Tokens_Metadata_Obj_Rel_Insert_Input>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  tx_hash?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  winning_bid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Bids_Metadata_Max_Fields = {
  __typename?: 'bids_metadata_max_fields';
  bid_value?: Maybe<Scalars['String']['output']>;
  bidder_address?: Maybe<Scalars['String']['output']>;
  core_contract_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  log_index?: Maybe<Scalars['Int']['output']>;
  minter_address?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  ram_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['bigint']['output']>;
  slot_index?: Maybe<Scalars['bigint']['output']>;
  time_of_bid?: Maybe<Scalars['timestamptz']['output']>;
  token_id?: Maybe<Scalars['String']['output']>;
  tx_hash?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "bids_metadata" */
export type Bids_Metadata_Max_Order_By = {
  bid_value?: InputMaybe<Order_By>;
  bidder_address?: InputMaybe<Order_By>;
  core_contract_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  log_index?: InputMaybe<Order_By>;
  minter_address?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
  time_of_bid?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Bids_Metadata_Min_Fields = {
  __typename?: 'bids_metadata_min_fields';
  bid_value?: Maybe<Scalars['String']['output']>;
  bidder_address?: Maybe<Scalars['String']['output']>;
  core_contract_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  log_index?: Maybe<Scalars['Int']['output']>;
  minter_address?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  ram_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['bigint']['output']>;
  slot_index?: Maybe<Scalars['bigint']['output']>;
  time_of_bid?: Maybe<Scalars['timestamptz']['output']>;
  token_id?: Maybe<Scalars['String']['output']>;
  tx_hash?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "bids_metadata" */
export type Bids_Metadata_Min_Order_By = {
  bid_value?: InputMaybe<Order_By>;
  bidder_address?: InputMaybe<Order_By>;
  core_contract_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  log_index?: InputMaybe<Order_By>;
  minter_address?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
  time_of_bid?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "bids_metadata" */
export type Bids_Metadata_Mutation_Response = {
  __typename?: 'bids_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bids_Metadata>;
};

/** on_conflict condition type for table "bids_metadata" */
export type Bids_Metadata_On_Conflict = {
  constraint: Bids_Metadata_Constraint;
  update_columns?: Array<Bids_Metadata_Update_Column>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "bids_metadata". */
export type Bids_Metadata_Order_By = {
  bid_type?: InputMaybe<Order_By>;
  bid_value?: InputMaybe<Order_By>;
  bidder_address?: InputMaybe<Order_By>;
  core_contract?: InputMaybe<Contracts_Metadata_Order_By>;
  core_contract_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_removed?: InputMaybe<Order_By>;
  log_index?: InputMaybe<Order_By>;
  minter?: InputMaybe<Minters_Metadata_Order_By>;
  minter_address?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  settled?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
  time_of_bid?: InputMaybe<Order_By>;
  token?: InputMaybe<Tokens_Metadata_Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  winning_bid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bids_metadata */
export type Bids_Metadata_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "bids_metadata" */
export enum Bids_Metadata_Select_Column {
  /** column name */
  BidType = 'bid_type',
  /** column name */
  BidValue = 'bid_value',
  /** column name */
  BidderAddress = 'bidder_address',
  /** column name */
  CoreContractAddress = 'core_contract_address',
  /** column name */
  Id = 'id',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  LogIndex = 'log_index',
  /** column name */
  MinterAddress = 'minter_address',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RamId = 'ram_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Settled = 'settled',
  /** column name */
  SlotIndex = 'slot_index',
  /** column name */
  TimeOfBid = 'time_of_bid',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  WinningBid = 'winning_bid'
}

/** select "bids_metadata_aggregate_bool_exp_bool_and_arguments_columns" columns of table "bids_metadata" */
export enum Bids_Metadata_Select_Column_Bids_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  Settled = 'settled',
  /** column name */
  WinningBid = 'winning_bid'
}

/** select "bids_metadata_aggregate_bool_exp_bool_or_arguments_columns" columns of table "bids_metadata" */
export enum Bids_Metadata_Select_Column_Bids_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  Settled = 'settled',
  /** column name */
  WinningBid = 'winning_bid'
}

/** input type for updating data in table "bids_metadata" */
export type Bids_Metadata_Set_Input = {
  bid_type?: InputMaybe<Bid_Types_Enum>;
  bid_value?: InputMaybe<Scalars['String']['input']>;
  bidder_address?: InputMaybe<Scalars['String']['input']>;
  core_contract_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  log_index?: InputMaybe<Scalars['Int']['input']>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['bigint']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  slot_index?: InputMaybe<Scalars['bigint']['input']>;
  time_of_bid?: InputMaybe<Scalars['timestamptz']['input']>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  tx_hash?: InputMaybe<Scalars['String']['input']>;
  winning_bid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Bids_Metadata_Stddev_Fields = {
  __typename?: 'bids_metadata_stddev_fields';
  log_index?: Maybe<Scalars['Float']['output']>;
  ram_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  slot_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "bids_metadata" */
export type Bids_Metadata_Stddev_Order_By = {
  log_index?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bids_Metadata_Stddev_Pop_Fields = {
  __typename?: 'bids_metadata_stddev_pop_fields';
  log_index?: Maybe<Scalars['Float']['output']>;
  ram_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  slot_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "bids_metadata" */
export type Bids_Metadata_Stddev_Pop_Order_By = {
  log_index?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bids_Metadata_Stddev_Samp_Fields = {
  __typename?: 'bids_metadata_stddev_samp_fields';
  log_index?: Maybe<Scalars['Float']['output']>;
  ram_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  slot_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "bids_metadata" */
export type Bids_Metadata_Stddev_Samp_Order_By = {
  log_index?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "bids_metadata" */
export type Bids_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bids_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bids_Metadata_Stream_Cursor_Value_Input = {
  bid_type?: InputMaybe<Bid_Types_Enum>;
  bid_value?: InputMaybe<Scalars['String']['input']>;
  bidder_address?: InputMaybe<Scalars['String']['input']>;
  core_contract_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_removed?: InputMaybe<Scalars['Boolean']['input']>;
  log_index?: InputMaybe<Scalars['Int']['input']>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  ram_id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['bigint']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  slot_index?: InputMaybe<Scalars['bigint']['input']>;
  time_of_bid?: InputMaybe<Scalars['timestamptz']['input']>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  tx_hash?: InputMaybe<Scalars['String']['input']>;
  winning_bid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Bids_Metadata_Sum_Fields = {
  __typename?: 'bids_metadata_sum_fields';
  log_index?: Maybe<Scalars['Int']['output']>;
  ram_id?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['bigint']['output']>;
  slot_index?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "bids_metadata" */
export type Bids_Metadata_Sum_Order_By = {
  log_index?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
};

/** update columns of table "bids_metadata" */
export enum Bids_Metadata_Update_Column {
  /** column name */
  BidType = 'bid_type',
  /** column name */
  BidValue = 'bid_value',
  /** column name */
  BidderAddress = 'bidder_address',
  /** column name */
  CoreContractAddress = 'core_contract_address',
  /** column name */
  Id = 'id',
  /** column name */
  IsRemoved = 'is_removed',
  /** column name */
  LogIndex = 'log_index',
  /** column name */
  MinterAddress = 'minter_address',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Settled = 'settled',
  /** column name */
  SlotIndex = 'slot_index',
  /** column name */
  TimeOfBid = 'time_of_bid',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  WinningBid = 'winning_bid'
}

export type Bids_Metadata_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bids_Metadata_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bids_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bids_Metadata_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bids_Metadata_Var_Pop_Fields = {
  __typename?: 'bids_metadata_var_pop_fields';
  log_index?: Maybe<Scalars['Float']['output']>;
  ram_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  slot_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "bids_metadata" */
export type Bids_Metadata_Var_Pop_Order_By = {
  log_index?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bids_Metadata_Var_Samp_Fields = {
  __typename?: 'bids_metadata_var_samp_fields';
  log_index?: Maybe<Scalars['Float']['output']>;
  ram_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  slot_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "bids_metadata" */
export type Bids_Metadata_Var_Samp_Order_By = {
  log_index?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Bids_Metadata_Variance_Fields = {
  __typename?: 'bids_metadata_variance_fields';
  log_index?: Maybe<Scalars['Float']['output']>;
  ram_id?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  slot_index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "bids_metadata" */
export type Bids_Metadata_Variance_Order_By = {
  log_index?: InputMaybe<Order_By>;
  ram_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  slot_index?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  name: Scalars['String']['output'];
  /** An object relationship */
  project_vertical_category?: Maybe<Project_Vertical_Categories>;
};

/** aggregated selection of "categories" */
export type Categories_Aggregate = {
  __typename?: 'categories_aggregate';
  aggregate?: Maybe<Categories_Aggregate_Fields>;
  nodes: Array<Categories>;
};

/** aggregate fields of "categories" */
export type Categories_Aggregate_Fields = {
  __typename?: 'categories_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Categories_Max_Fields>;
  min?: Maybe<Categories_Min_Fields>;
};


/** aggregate fields of "categories" */
export type Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Categories_Bool_Exp>>;
  _not?: InputMaybe<Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Categories_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_vertical_category?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
};

/** unique or primary key constraints on table "categories" */
export enum Categories_Constraint {
  /** unique or primary key constraint on columns "name" */
  CategoriesPkey = 'categories_pkey'
}

export enum Categories_Enum {
  Collaborations = 'collaborations',
  Collections = 'collections',
  Engine = 'engine',
  Explorations = 'explorations',
  Unassigned = 'unassigned'
}

/** Boolean expression to compare columns of type "categories_enum". All fields are combined with logical 'AND'. */
export type Categories_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Categories_Enum>;
  _in?: InputMaybe<Array<Categories_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Categories_Enum>;
  _nin?: InputMaybe<Array<Categories_Enum>>;
};

/** input type for inserting data into table "categories" */
export type Categories_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  project_vertical_category?: InputMaybe<Project_Vertical_Categories_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Categories_Max_Fields = {
  __typename?: 'categories_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Categories_Min_Fields = {
  __typename?: 'categories_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "categories" */
export type Categories_Mutation_Response = {
  __typename?: 'categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Categories>;
};

/** input type for inserting object relation for remote table "categories" */
export type Categories_Obj_Rel_Insert_Input = {
  data: Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** on_conflict condition type for table "categories" */
export type Categories_On_Conflict = {
  constraint: Categories_Constraint;
  update_columns?: Array<Categories_Update_Column>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "categories". */
export type Categories_Order_By = {
  name?: InputMaybe<Order_By>;
  project_vertical_category?: InputMaybe<Project_Vertical_Categories_Order_By>;
};

/** primary key columns input for table: categories */
export type Categories_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "categories" */
export enum Categories_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "categories" */
export type Categories_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "categories" */
export type Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Categories_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "categories" */
export enum Categories_Update_Column {
  /** column name */
  Name = 'name'
}

export type Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Categories_Bool_Exp;
};

/** Users who have write-access to a given Art Blocks or Engine smart contract. */
export type Contract_Allowlistings = {
  __typename?: 'contract_allowlistings';
  /** An object relationship */
  contract?: Maybe<Contracts_Metadata>;
  contract_address: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_address: Scalars['String']['output'];
};

/** aggregated selection of "contract_allowlistings" */
export type Contract_Allowlistings_Aggregate = {
  __typename?: 'contract_allowlistings_aggregate';
  aggregate?: Maybe<Contract_Allowlistings_Aggregate_Fields>;
  nodes: Array<Contract_Allowlistings>;
};

export type Contract_Allowlistings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contract_Allowlistings_Aggregate_Bool_Exp_Count>;
};

export type Contract_Allowlistings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contract_allowlistings" */
export type Contract_Allowlistings_Aggregate_Fields = {
  __typename?: 'contract_allowlistings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contract_Allowlistings_Max_Fields>;
  min?: Maybe<Contract_Allowlistings_Min_Fields>;
};


/** aggregate fields of "contract_allowlistings" */
export type Contract_Allowlistings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "contract_allowlistings" */
export type Contract_Allowlistings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contract_Allowlistings_Max_Order_By>;
  min?: InputMaybe<Contract_Allowlistings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "contract_allowlistings" */
export type Contract_Allowlistings_Arr_Rel_Insert_Input = {
  data: Array<Contract_Allowlistings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Contract_Allowlistings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "contract_allowlistings". All fields are combined with a logical 'AND'. */
export type Contract_Allowlistings_Bool_Exp = {
  _and?: InputMaybe<Array<Contract_Allowlistings_Bool_Exp>>;
  _not?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
  _or?: InputMaybe<Array<Contract_Allowlistings_Bool_Exp>>;
  contract?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "contract_allowlistings" */
export enum Contract_Allowlistings_Constraint {
  /** unique or primary key constraint on columns "user_address", "contract_address" */
  ContractAllowlistingsPkey = 'contract_allowlistings_pkey',
  /** unique or primary key constraint on columns "user_address", "contract_address" */
  ContractAllowlistingsUserAddressContractAddressKey = 'contract_allowlistings_user_address_contract_address_key'
}

/** input type for inserting data into table "contract_allowlistings" */
export type Contract_Allowlistings_Insert_Input = {
  contract?: InputMaybe<Contracts_Metadata_Obj_Rel_Insert_Input>;
  contract_address?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Contract_Allowlistings_Max_Fields = {
  __typename?: 'contract_allowlistings_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "contract_allowlistings" */
export type Contract_Allowlistings_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contract_Allowlistings_Min_Fields = {
  __typename?: 'contract_allowlistings_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "contract_allowlistings" */
export type Contract_Allowlistings_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "contract_allowlistings" */
export type Contract_Allowlistings_Mutation_Response = {
  __typename?: 'contract_allowlistings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contract_Allowlistings>;
};

/** on_conflict condition type for table "contract_allowlistings" */
export type Contract_Allowlistings_On_Conflict = {
  constraint: Contract_Allowlistings_Constraint;
  update_columns?: Array<Contract_Allowlistings_Update_Column>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};

/** Ordering options when selecting data from "contract_allowlistings". */
export type Contract_Allowlistings_Order_By = {
  contract?: InputMaybe<Contracts_Metadata_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contract_allowlistings */
export type Contract_Allowlistings_Pk_Columns_Input = {
  contract_address: Scalars['String']['input'];
  user_address: Scalars['String']['input'];
};

/** select columns of table "contract_allowlistings" */
export enum Contract_Allowlistings_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  UserAddress = 'user_address'
}

/** input type for updating data in table "contract_allowlistings" */
export type Contract_Allowlistings_Set_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "contract_allowlistings" */
export type Contract_Allowlistings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contract_Allowlistings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contract_Allowlistings_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "contract_allowlistings" */
export enum Contract_Allowlistings_Update_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  UserAddress = 'user_address'
}

export type Contract_Allowlistings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contract_Allowlistings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contract_Allowlistings_Bool_Exp;
};

/** columns and relationships of "contract_type_names" */
export type Contract_Type_Names = {
  __typename?: 'contract_type_names';
  name: Scalars['String']['output'];
};

/** aggregated selection of "contract_type_names" */
export type Contract_Type_Names_Aggregate = {
  __typename?: 'contract_type_names_aggregate';
  aggregate?: Maybe<Contract_Type_Names_Aggregate_Fields>;
  nodes: Array<Contract_Type_Names>;
};

/** aggregate fields of "contract_type_names" */
export type Contract_Type_Names_Aggregate_Fields = {
  __typename?: 'contract_type_names_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contract_Type_Names_Max_Fields>;
  min?: Maybe<Contract_Type_Names_Min_Fields>;
};


/** aggregate fields of "contract_type_names" */
export type Contract_Type_Names_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contract_Type_Names_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "contract_type_names". All fields are combined with a logical 'AND'. */
export type Contract_Type_Names_Bool_Exp = {
  _and?: InputMaybe<Array<Contract_Type_Names_Bool_Exp>>;
  _not?: InputMaybe<Contract_Type_Names_Bool_Exp>;
  _or?: InputMaybe<Array<Contract_Type_Names_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "contract_type_names" */
export enum Contract_Type_Names_Constraint {
  /** unique or primary key constraint on columns "name" */
  ContractTypeNamesPkey = 'contract_type_names_pkey'
}

export enum Contract_Type_Names_Enum {
  GenArt721CoreV0 = 'GenArt721CoreV0',
  GenArt721CoreV1 = 'GenArt721CoreV1',
  GenArt721CoreV2EngineFlex = 'GenArt721CoreV2_ENGINE_FLEX',
  GenArt721CoreV2Pbab = 'GenArt721CoreV2_PBAB',
  GenArt721CoreV3 = 'GenArt721CoreV3',
  GenArt721CoreV3Engine = 'GenArt721CoreV3_Engine',
  GenArt721CoreV3EngineFlex = 'GenArt721CoreV3_Engine_Flex'
}

/** Boolean expression to compare columns of type "contract_type_names_enum". All fields are combined with logical 'AND'. */
export type Contract_Type_Names_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Contract_Type_Names_Enum>;
  _in?: InputMaybe<Array<Contract_Type_Names_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Contract_Type_Names_Enum>;
  _nin?: InputMaybe<Array<Contract_Type_Names_Enum>>;
};

/** input type for inserting data into table "contract_type_names" */
export type Contract_Type_Names_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Contract_Type_Names_Max_Fields = {
  __typename?: 'contract_type_names_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Contract_Type_Names_Min_Fields = {
  __typename?: 'contract_type_names_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "contract_type_names" */
export type Contract_Type_Names_Mutation_Response = {
  __typename?: 'contract_type_names_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contract_Type_Names>;
};

/** on_conflict condition type for table "contract_type_names" */
export type Contract_Type_Names_On_Conflict = {
  constraint: Contract_Type_Names_Constraint;
  update_columns?: Array<Contract_Type_Names_Update_Column>;
  where?: InputMaybe<Contract_Type_Names_Bool_Exp>;
};

/** Ordering options when selecting data from "contract_type_names". */
export type Contract_Type_Names_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contract_type_names */
export type Contract_Type_Names_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "contract_type_names" */
export enum Contract_Type_Names_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "contract_type_names" */
export type Contract_Type_Names_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "contract_type_names" */
export type Contract_Type_Names_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contract_Type_Names_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contract_Type_Names_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "contract_type_names" */
export enum Contract_Type_Names_Update_Column {
  /** column name */
  Name = 'name'
}

export type Contract_Type_Names_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contract_Type_Names_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contract_Type_Names_Bool_Exp;
};

/** columns and relationships of "contract_types" */
export type Contract_Types = {
  __typename?: 'contract_types';
  abi?: Maybe<Scalars['jsonb']['output']>;
  project_configuration_schema?: Maybe<Scalars['jsonb']['output']>;
  type: Contract_Type_Names_Enum;
};


/** columns and relationships of "contract_types" */
export type Contract_TypesAbiArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "contract_types" */
export type Contract_TypesProject_Configuration_SchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "contract_types" */
export type Contract_Types_Aggregate = {
  __typename?: 'contract_types_aggregate';
  aggregate?: Maybe<Contract_Types_Aggregate_Fields>;
  nodes: Array<Contract_Types>;
};

/** aggregate fields of "contract_types" */
export type Contract_Types_Aggregate_Fields = {
  __typename?: 'contract_types_aggregate_fields';
  count: Scalars['Int']['output'];
};


/** aggregate fields of "contract_types" */
export type Contract_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contract_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Contract_Types_Append_Input = {
  abi?: InputMaybe<Scalars['jsonb']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "contract_types". All fields are combined with a logical 'AND'. */
export type Contract_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Contract_Types_Bool_Exp>>;
  _not?: InputMaybe<Contract_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Contract_Types_Bool_Exp>>;
  abi?: InputMaybe<Jsonb_Comparison_Exp>;
  project_configuration_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<Contract_Type_Names_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "contract_types" */
export enum Contract_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  ContractTypesPkey = 'contract_types_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Contract_Types_Delete_At_Path_Input = {
  abi?: InputMaybe<Array<Scalars['String']['input']>>;
  project_configuration_schema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Contract_Types_Delete_Elem_Input = {
  abi?: InputMaybe<Scalars['Int']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Contract_Types_Delete_Key_Input = {
  abi?: InputMaybe<Scalars['String']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "contract_types" */
export type Contract_Types_Insert_Input = {
  abi?: InputMaybe<Scalars['jsonb']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Contract_Type_Names_Enum>;
};

/** response of any mutation on the table "contract_types" */
export type Contract_Types_Mutation_Response = {
  __typename?: 'contract_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contract_Types>;
};

/** input type for inserting object relation for remote table "contract_types" */
export type Contract_Types_Obj_Rel_Insert_Input = {
  data: Contract_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contract_Types_On_Conflict>;
};

/** on_conflict condition type for table "contract_types" */
export type Contract_Types_On_Conflict = {
  constraint: Contract_Types_Constraint;
  update_columns?: Array<Contract_Types_Update_Column>;
  where?: InputMaybe<Contract_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "contract_types". */
export type Contract_Types_Order_By = {
  abi?: InputMaybe<Order_By>;
  project_configuration_schema?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contract_types */
export type Contract_Types_Pk_Columns_Input = {
  type: Contract_Type_Names_Enum;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Contract_Types_Prepend_Input = {
  abi?: InputMaybe<Scalars['jsonb']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "contract_types" */
export enum Contract_Types_Select_Column {
  /** column name */
  Abi = 'abi',
  /** column name */
  ProjectConfigurationSchema = 'project_configuration_schema',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "contract_types" */
export type Contract_Types_Set_Input = {
  abi?: InputMaybe<Scalars['jsonb']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Contract_Type_Names_Enum>;
};

/** Streaming cursor of the table "contract_types" */
export type Contract_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contract_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contract_Types_Stream_Cursor_Value_Input = {
  abi?: InputMaybe<Scalars['jsonb']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Contract_Type_Names_Enum>;
};

/** update columns of table "contract_types" */
export enum Contract_Types_Update_Column {
  /** column name */
  Abi = 'abi',
  /** column name */
  ProjectConfigurationSchema = 'project_configuration_schema',
  /** column name */
  Type = 'type'
}

export type Contract_Types_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Contract_Types_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Contract_Types_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Contract_Types_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Contract_Types_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Contract_Types_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contract_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contract_Types_Bool_Exp;
};

/** This table details the contract deployments & metadata for Art Blocks and all Engine partners. Updates are made when a core contract is deployed. */
export type Contracts_Metadata = {
  __typename?: 'contracts_metadata';
  address: Scalars['String']['output'];
  admin?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  allowlisted_users: Array<Contract_Allowlistings>;
  /** An aggregate relationship */
  allowlisted_users_aggregate: Contract_Allowlistings_Aggregate;
  auto_approve_artist_split_proposals?: Maybe<Scalars['Boolean']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  contract_type: Contract_Type_Names_Enum;
  /** An object relationship */
  core_registry?: Maybe<Core_Registries_Metadata>;
  core_version?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  curation_registry_address?: Maybe<Scalars['String']['output']>;
  default_engine_platform_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  default_render_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  default_vertical?: Maybe<Project_Verticals>;
  default_vertical_name?: Maybe<Scalars['String']['output']>;
  dependency_registry_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Int']['output']>;
  generator_url?: Maybe<Scalars['String']['output']>;
  latest_dependency_registry_override_allowlisted_on?: Maybe<Scalars['String']['output']>;
  minter_address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  minter_filter?: Maybe<Minter_Filters_Metadata>;
  minter_filter_address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "new_projects_forbidden" */
  new_projects_forbidden?: Maybe<Scalars['Boolean']['output']>;
  new_projects_forbidden_offchain: Scalars['Boolean']['output'];
  new_projects_forbidden_onchain: Scalars['Boolean']['output'];
  next_project_id: Scalars['Int']['output'];
  on_chain_generator?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  partner?: Maybe<Partners>;
  partner_id?: Maybe<Scalars['Int']['output']>;
  preferred_arweave_gateway?: Maybe<Scalars['String']['output']>;
  preferred_ipfs_gateway?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  projects: Array<Projects_Metadata>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Metadata_Aggregate;
  randomizer_contract?: Maybe<Scalars['String']['output']>;
  registered_on?: Maybe<Scalars['String']['output']>;
  render_provider_address?: Maybe<Scalars['String']['output']>;
  render_provider_percentage?: Maybe<Scalars['Int']['output']>;
  royalty_split_provider?: Maybe<Scalars['String']['output']>;
  token_base_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  type?: Maybe<Contract_Types>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** A computed field, executes function "user_is_allowlisted" */
  user_is_allowlisted?: Maybe<Scalars['Boolean']['output']>;
};


/** This table details the contract deployments & metadata for Art Blocks and all Engine partners. Updates are made when a core contract is deployed. */
export type Contracts_MetadataAllowlisted_UsersArgs = {
  distinct_on?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Allowlistings_Order_By>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


/** This table details the contract deployments & metadata for Art Blocks and all Engine partners. Updates are made when a core contract is deployed. */
export type Contracts_MetadataAllowlisted_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Allowlistings_Order_By>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


/** This table details the contract deployments & metadata for Art Blocks and all Engine partners. Updates are made when a core contract is deployed. */
export type Contracts_MetadataProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


/** This table details the contract deployments & metadata for Art Blocks and all Engine partners. Updates are made when a core contract is deployed. */
export type Contracts_MetadataProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};

/** aggregated selection of "contracts_metadata" */
export type Contracts_Metadata_Aggregate = {
  __typename?: 'contracts_metadata_aggregate';
  aggregate?: Maybe<Contracts_Metadata_Aggregate_Fields>;
  nodes: Array<Contracts_Metadata>;
};

export type Contracts_Metadata_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Contracts_Metadata_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Contracts_Metadata_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Contracts_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Contracts_Metadata_Aggregate_Bool_Exp_Bool_And = {
  arguments: Contracts_Metadata_Select_Column_Contracts_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contracts_Metadata_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Contracts_Metadata_Select_Column_Contracts_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contracts_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contracts_metadata" */
export type Contracts_Metadata_Aggregate_Fields = {
  __typename?: 'contracts_metadata_aggregate_fields';
  avg?: Maybe<Contracts_Metadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Contracts_Metadata_Max_Fields>;
  min?: Maybe<Contracts_Metadata_Min_Fields>;
  stddev?: Maybe<Contracts_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Contracts_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contracts_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Contracts_Metadata_Sum_Fields>;
  var_pop?: Maybe<Contracts_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Contracts_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Contracts_Metadata_Variance_Fields>;
};


/** aggregate fields of "contracts_metadata" */
export type Contracts_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "contracts_metadata" */
export type Contracts_Metadata_Aggregate_Order_By = {
  avg?: InputMaybe<Contracts_Metadata_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contracts_Metadata_Max_Order_By>;
  min?: InputMaybe<Contracts_Metadata_Min_Order_By>;
  stddev?: InputMaybe<Contracts_Metadata_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Contracts_Metadata_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Contracts_Metadata_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Contracts_Metadata_Sum_Order_By>;
  var_pop?: InputMaybe<Contracts_Metadata_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Contracts_Metadata_Var_Samp_Order_By>;
  variance?: InputMaybe<Contracts_Metadata_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "contracts_metadata" */
export type Contracts_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Contracts_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Contracts_Metadata_On_Conflict>;
};

/** aggregate avg on columns */
export type Contracts_Metadata_Avg_Fields = {
  __typename?: 'contracts_metadata_avg_fields';
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Float']['output']>;
  next_project_id?: Maybe<Scalars['Float']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  render_provider_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Avg_Order_By = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "contracts_metadata". All fields are combined with a logical 'AND'. */
export type Contracts_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Contracts_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Contracts_Metadata_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  admin?: InputMaybe<String_Comparison_Exp>;
  allowlisted_users?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
  allowlisted_users_aggregate?: InputMaybe<Contract_Allowlistings_Aggregate_Bool_Exp>;
  auto_approve_artist_split_proposals?: InputMaybe<Boolean_Comparison_Exp>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  contract_type?: InputMaybe<Contract_Type_Names_Enum_Comparison_Exp>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
  core_version?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  curation_registry_address?: InputMaybe<String_Comparison_Exp>;
  default_engine_platform_provider_secondary_sales_address?: InputMaybe<String_Comparison_Exp>;
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Int_Comparison_Exp>;
  default_render_provider_secondary_sales_address?: InputMaybe<String_Comparison_Exp>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Int_Comparison_Exp>;
  default_vertical?: InputMaybe<Project_Verticals_Bool_Exp>;
  default_vertical_name?: InputMaybe<String_Comparison_Exp>;
  dependency_registry_address?: InputMaybe<String_Comparison_Exp>;
  engine_platform_provider_address?: InputMaybe<String_Comparison_Exp>;
  engine_platform_provider_percentage?: InputMaybe<Int_Comparison_Exp>;
  generator_url?: InputMaybe<String_Comparison_Exp>;
  latest_dependency_registry_override_allowlisted_on?: InputMaybe<String_Comparison_Exp>;
  minter_address?: InputMaybe<String_Comparison_Exp>;
  minter_filter?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
  minter_filter_address?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  new_projects_forbidden?: InputMaybe<Boolean_Comparison_Exp>;
  new_projects_forbidden_offchain?: InputMaybe<Boolean_Comparison_Exp>;
  new_projects_forbidden_onchain?: InputMaybe<Boolean_Comparison_Exp>;
  next_project_id?: InputMaybe<Int_Comparison_Exp>;
  on_chain_generator?: InputMaybe<String_Comparison_Exp>;
  partner?: InputMaybe<Partners_Bool_Exp>;
  partner_id?: InputMaybe<Int_Comparison_Exp>;
  preferred_arweave_gateway?: InputMaybe<String_Comparison_Exp>;
  preferred_ipfs_gateway?: InputMaybe<String_Comparison_Exp>;
  projects?: InputMaybe<Projects_Metadata_Bool_Exp>;
  projects_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Bool_Exp>;
  randomizer_contract?: InputMaybe<String_Comparison_Exp>;
  registered_on?: InputMaybe<String_Comparison_Exp>;
  render_provider_address?: InputMaybe<String_Comparison_Exp>;
  render_provider_percentage?: InputMaybe<Int_Comparison_Exp>;
  royalty_split_provider?: InputMaybe<String_Comparison_Exp>;
  token_base_url?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Contract_Types_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_is_allowlisted?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "contracts_metadata" */
export enum Contracts_Metadata_Constraint {
  /** unique or primary key constraint on columns "name" */
  ContractsMetadataNameKey = 'contracts_metadata_name_key',
  /** unique or primary key constraint on columns "address" */
  ContractsMetadataPkey = 'contracts_metadata_pkey'
}

/** input type for incrementing numeric columns in table "contracts_metadata" */
export type Contracts_Metadata_Inc_Input = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  engine_platform_provider_percentage?: InputMaybe<Scalars['Int']['input']>;
  next_project_id?: InputMaybe<Scalars['Int']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  render_provider_percentage?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "contracts_metadata" */
export type Contracts_Metadata_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  allowlisted_users?: InputMaybe<Contract_Allowlistings_Arr_Rel_Insert_Input>;
  auto_approve_artist_split_proposals?: InputMaybe<Scalars['Boolean']['input']>;
  bucket_name?: InputMaybe<Scalars['String']['input']>;
  contract_type?: InputMaybe<Contract_Type_Names_Enum>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Obj_Rel_Insert_Input>;
  core_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  curation_registry_address?: InputMaybe<Scalars['String']['input']>;
  default_engine_platform_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  default_render_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  default_vertical?: InputMaybe<Project_Verticals_Obj_Rel_Insert_Input>;
  default_vertical_name?: InputMaybe<Scalars['String']['input']>;
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_percentage?: InputMaybe<Scalars['Int']['input']>;
  generator_url?: InputMaybe<Scalars['String']['input']>;
  latest_dependency_registry_override_allowlisted_on?: InputMaybe<Scalars['String']['input']>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  minter_filter?: InputMaybe<Minter_Filters_Metadata_Obj_Rel_Insert_Input>;
  minter_filter_address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  new_projects_forbidden_offchain?: InputMaybe<Scalars['Boolean']['input']>;
  new_projects_forbidden_onchain?: InputMaybe<Scalars['Boolean']['input']>;
  next_project_id?: InputMaybe<Scalars['Int']['input']>;
  on_chain_generator?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Partners_Obj_Rel_Insert_Input>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  preferred_arweave_gateway?: InputMaybe<Scalars['String']['input']>;
  preferred_ipfs_gateway?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Projects_Metadata_Arr_Rel_Insert_Input>;
  randomizer_contract?: InputMaybe<Scalars['String']['input']>;
  registered_on?: InputMaybe<Scalars['String']['input']>;
  render_provider_address?: InputMaybe<Scalars['String']['input']>;
  render_provider_percentage?: InputMaybe<Scalars['Int']['input']>;
  royalty_split_provider?: InputMaybe<Scalars['String']['input']>;
  token_base_url?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Contract_Types_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Contracts_Metadata_Max_Fields = {
  __typename?: 'contracts_metadata_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  core_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  curation_registry_address?: Maybe<Scalars['String']['output']>;
  default_engine_platform_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  default_render_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  default_vertical_name?: Maybe<Scalars['String']['output']>;
  dependency_registry_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Int']['output']>;
  generator_url?: Maybe<Scalars['String']['output']>;
  latest_dependency_registry_override_allowlisted_on?: Maybe<Scalars['String']['output']>;
  minter_address?: Maybe<Scalars['String']['output']>;
  minter_filter_address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  next_project_id?: Maybe<Scalars['Int']['output']>;
  on_chain_generator?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['Int']['output']>;
  preferred_arweave_gateway?: Maybe<Scalars['String']['output']>;
  preferred_ipfs_gateway?: Maybe<Scalars['String']['output']>;
  randomizer_contract?: Maybe<Scalars['String']['output']>;
  registered_on?: Maybe<Scalars['String']['output']>;
  render_provider_address?: Maybe<Scalars['String']['output']>;
  render_provider_percentage?: Maybe<Scalars['Int']['output']>;
  royalty_split_provider?: Maybe<Scalars['String']['output']>;
  token_base_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  bucket_name?: InputMaybe<Order_By>;
  core_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  curation_registry_address?: InputMaybe<Order_By>;
  default_engine_platform_provider_secondary_sales_address?: InputMaybe<Order_By>;
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_address?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_vertical_name?: InputMaybe<Order_By>;
  dependency_registry_address?: InputMaybe<Order_By>;
  engine_platform_provider_address?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  generator_url?: InputMaybe<Order_By>;
  latest_dependency_registry_override_allowlisted_on?: InputMaybe<Order_By>;
  minter_address?: InputMaybe<Order_By>;
  minter_filter_address?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  on_chain_generator?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  preferred_arweave_gateway?: InputMaybe<Order_By>;
  preferred_ipfs_gateway?: InputMaybe<Order_By>;
  randomizer_contract?: InputMaybe<Order_By>;
  registered_on?: InputMaybe<Order_By>;
  render_provider_address?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
  royalty_split_provider?: InputMaybe<Order_By>;
  token_base_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contracts_Metadata_Min_Fields = {
  __typename?: 'contracts_metadata_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  admin?: Maybe<Scalars['String']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  core_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  curation_registry_address?: Maybe<Scalars['String']['output']>;
  default_engine_platform_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  default_render_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  default_vertical_name?: Maybe<Scalars['String']['output']>;
  dependency_registry_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Int']['output']>;
  generator_url?: Maybe<Scalars['String']['output']>;
  latest_dependency_registry_override_allowlisted_on?: Maybe<Scalars['String']['output']>;
  minter_address?: Maybe<Scalars['String']['output']>;
  minter_filter_address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  next_project_id?: Maybe<Scalars['Int']['output']>;
  on_chain_generator?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['Int']['output']>;
  preferred_arweave_gateway?: Maybe<Scalars['String']['output']>;
  preferred_ipfs_gateway?: Maybe<Scalars['String']['output']>;
  randomizer_contract?: Maybe<Scalars['String']['output']>;
  registered_on?: Maybe<Scalars['String']['output']>;
  render_provider_address?: Maybe<Scalars['String']['output']>;
  render_provider_percentage?: Maybe<Scalars['Int']['output']>;
  royalty_split_provider?: Maybe<Scalars['String']['output']>;
  token_base_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  bucket_name?: InputMaybe<Order_By>;
  core_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  curation_registry_address?: InputMaybe<Order_By>;
  default_engine_platform_provider_secondary_sales_address?: InputMaybe<Order_By>;
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_address?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_vertical_name?: InputMaybe<Order_By>;
  dependency_registry_address?: InputMaybe<Order_By>;
  engine_platform_provider_address?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  generator_url?: InputMaybe<Order_By>;
  latest_dependency_registry_override_allowlisted_on?: InputMaybe<Order_By>;
  minter_address?: InputMaybe<Order_By>;
  minter_filter_address?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  on_chain_generator?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  preferred_arweave_gateway?: InputMaybe<Order_By>;
  preferred_ipfs_gateway?: InputMaybe<Order_By>;
  randomizer_contract?: InputMaybe<Order_By>;
  registered_on?: InputMaybe<Order_By>;
  render_provider_address?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
  royalty_split_provider?: InputMaybe<Order_By>;
  token_base_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "contracts_metadata" */
export type Contracts_Metadata_Mutation_Response = {
  __typename?: 'contracts_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contracts_Metadata>;
};

/** input type for inserting object relation for remote table "contracts_metadata" */
export type Contracts_Metadata_Obj_Rel_Insert_Input = {
  data: Contracts_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contracts_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "contracts_metadata" */
export type Contracts_Metadata_On_Conflict = {
  constraint: Contracts_Metadata_Constraint;
  update_columns?: Array<Contracts_Metadata_Update_Column>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "contracts_metadata". */
export type Contracts_Metadata_Order_By = {
  address?: InputMaybe<Order_By>;
  admin?: InputMaybe<Order_By>;
  allowlisted_users_aggregate?: InputMaybe<Contract_Allowlistings_Aggregate_Order_By>;
  auto_approve_artist_split_proposals?: InputMaybe<Order_By>;
  bucket_name?: InputMaybe<Order_By>;
  contract_type?: InputMaybe<Order_By>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Order_By>;
  core_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  curation_registry_address?: InputMaybe<Order_By>;
  default_engine_platform_provider_secondary_sales_address?: InputMaybe<Order_By>;
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_address?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_vertical?: InputMaybe<Project_Verticals_Order_By>;
  default_vertical_name?: InputMaybe<Order_By>;
  dependency_registry_address?: InputMaybe<Order_By>;
  engine_platform_provider_address?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  generator_url?: InputMaybe<Order_By>;
  latest_dependency_registry_override_allowlisted_on?: InputMaybe<Order_By>;
  minter_address?: InputMaybe<Order_By>;
  minter_filter?: InputMaybe<Minter_Filters_Metadata_Order_By>;
  minter_filter_address?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  new_projects_forbidden?: InputMaybe<Order_By>;
  new_projects_forbidden_offchain?: InputMaybe<Order_By>;
  new_projects_forbidden_onchain?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  on_chain_generator?: InputMaybe<Order_By>;
  partner?: InputMaybe<Partners_Order_By>;
  partner_id?: InputMaybe<Order_By>;
  preferred_arweave_gateway?: InputMaybe<Order_By>;
  preferred_ipfs_gateway?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Order_By>;
  randomizer_contract?: InputMaybe<Order_By>;
  registered_on?: InputMaybe<Order_By>;
  render_provider_address?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
  royalty_split_provider?: InputMaybe<Order_By>;
  token_base_url?: InputMaybe<Order_By>;
  type?: InputMaybe<Contract_Types_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_is_allowlisted?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contracts_metadata */
export type Contracts_Metadata_Pk_Columns_Input = {
  address: Scalars['String']['input'];
};

/** select columns of table "contracts_metadata" */
export enum Contracts_Metadata_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  AutoApproveArtistSplitProposals = 'auto_approve_artist_split_proposals',
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  ContractType = 'contract_type',
  /** column name */
  CoreVersion = 'core_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurationRegistryAddress = 'curation_registry_address',
  /** column name */
  DefaultEnginePlatformProviderSecondarySalesAddress = 'default_engine_platform_provider_secondary_sales_address',
  /** column name */
  DefaultEnginePlatformProviderSecondarySalesBps = 'default_engine_platform_provider_secondary_sales_bps',
  /** column name */
  DefaultRenderProviderSecondarySalesAddress = 'default_render_provider_secondary_sales_address',
  /** column name */
  DefaultRenderProviderSecondarySalesBps = 'default_render_provider_secondary_sales_bps',
  /** column name */
  DefaultVerticalName = 'default_vertical_name',
  /** column name */
  DependencyRegistryAddress = 'dependency_registry_address',
  /** column name */
  EnginePlatformProviderAddress = 'engine_platform_provider_address',
  /** column name */
  EnginePlatformProviderPercentage = 'engine_platform_provider_percentage',
  /** column name */
  GeneratorUrl = 'generator_url',
  /** column name */
  LatestDependencyRegistryOverrideAllowlistedOn = 'latest_dependency_registry_override_allowlisted_on',
  /** column name */
  MinterAddress = 'minter_address',
  /** column name */
  MinterFilterAddress = 'minter_filter_address',
  /** column name */
  Name = 'name',
  /** column name */
  NewProjectsForbiddenOffchain = 'new_projects_forbidden_offchain',
  /** column name */
  NewProjectsForbiddenOnchain = 'new_projects_forbidden_onchain',
  /** column name */
  NextProjectId = 'next_project_id',
  /** column name */
  OnChainGenerator = 'on_chain_generator',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PreferredArweaveGateway = 'preferred_arweave_gateway',
  /** column name */
  PreferredIpfsGateway = 'preferred_ipfs_gateway',
  /** column name */
  RandomizerContract = 'randomizer_contract',
  /** column name */
  RegisteredOn = 'registered_on',
  /** column name */
  RenderProviderAddress = 'render_provider_address',
  /** column name */
  RenderProviderPercentage = 'render_provider_percentage',
  /** column name */
  RoyaltySplitProvider = 'royalty_split_provider',
  /** column name */
  TokenBaseUrl = 'token_base_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "contracts_metadata_aggregate_bool_exp_bool_and_arguments_columns" columns of table "contracts_metadata" */
export enum Contracts_Metadata_Select_Column_Contracts_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutoApproveArtistSplitProposals = 'auto_approve_artist_split_proposals',
  /** column name */
  NewProjectsForbiddenOffchain = 'new_projects_forbidden_offchain',
  /** column name */
  NewProjectsForbiddenOnchain = 'new_projects_forbidden_onchain'
}

/** select "contracts_metadata_aggregate_bool_exp_bool_or_arguments_columns" columns of table "contracts_metadata" */
export enum Contracts_Metadata_Select_Column_Contracts_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutoApproveArtistSplitProposals = 'auto_approve_artist_split_proposals',
  /** column name */
  NewProjectsForbiddenOffchain = 'new_projects_forbidden_offchain',
  /** column name */
  NewProjectsForbiddenOnchain = 'new_projects_forbidden_onchain'
}

/** input type for updating data in table "contracts_metadata" */
export type Contracts_Metadata_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  auto_approve_artist_split_proposals?: InputMaybe<Scalars['Boolean']['input']>;
  bucket_name?: InputMaybe<Scalars['String']['input']>;
  contract_type?: InputMaybe<Contract_Type_Names_Enum>;
  core_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  curation_registry_address?: InputMaybe<Scalars['String']['input']>;
  default_engine_platform_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  default_render_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  default_vertical_name?: InputMaybe<Scalars['String']['input']>;
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_percentage?: InputMaybe<Scalars['Int']['input']>;
  generator_url?: InputMaybe<Scalars['String']['input']>;
  latest_dependency_registry_override_allowlisted_on?: InputMaybe<Scalars['String']['input']>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  minter_filter_address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  new_projects_forbidden_offchain?: InputMaybe<Scalars['Boolean']['input']>;
  new_projects_forbidden_onchain?: InputMaybe<Scalars['Boolean']['input']>;
  next_project_id?: InputMaybe<Scalars['Int']['input']>;
  on_chain_generator?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  preferred_arweave_gateway?: InputMaybe<Scalars['String']['input']>;
  preferred_ipfs_gateway?: InputMaybe<Scalars['String']['input']>;
  randomizer_contract?: InputMaybe<Scalars['String']['input']>;
  registered_on?: InputMaybe<Scalars['String']['input']>;
  render_provider_address?: InputMaybe<Scalars['String']['input']>;
  render_provider_percentage?: InputMaybe<Scalars['Int']['input']>;
  royalty_split_provider?: InputMaybe<Scalars['String']['input']>;
  token_base_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Contracts_Metadata_Stddev_Fields = {
  __typename?: 'contracts_metadata_stddev_fields';
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Float']['output']>;
  next_project_id?: Maybe<Scalars['Float']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  render_provider_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Stddev_Order_By = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Contracts_Metadata_Stddev_Pop_Fields = {
  __typename?: 'contracts_metadata_stddev_pop_fields';
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Float']['output']>;
  next_project_id?: Maybe<Scalars['Float']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  render_provider_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Stddev_Pop_Order_By = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Contracts_Metadata_Stddev_Samp_Fields = {
  __typename?: 'contracts_metadata_stddev_samp_fields';
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Float']['output']>;
  next_project_id?: Maybe<Scalars['Float']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  render_provider_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Stddev_Samp_Order_By = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "contracts_metadata" */
export type Contracts_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contracts_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contracts_Metadata_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['String']['input']>;
  auto_approve_artist_split_proposals?: InputMaybe<Scalars['Boolean']['input']>;
  bucket_name?: InputMaybe<Scalars['String']['input']>;
  contract_type?: InputMaybe<Contract_Type_Names_Enum>;
  core_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  curation_registry_address?: InputMaybe<Scalars['String']['input']>;
  default_engine_platform_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  default_render_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  default_vertical_name?: InputMaybe<Scalars['String']['input']>;
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_percentage?: InputMaybe<Scalars['Int']['input']>;
  generator_url?: InputMaybe<Scalars['String']['input']>;
  latest_dependency_registry_override_allowlisted_on?: InputMaybe<Scalars['String']['input']>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  minter_filter_address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  new_projects_forbidden_offchain?: InputMaybe<Scalars['Boolean']['input']>;
  new_projects_forbidden_onchain?: InputMaybe<Scalars['Boolean']['input']>;
  next_project_id?: InputMaybe<Scalars['Int']['input']>;
  on_chain_generator?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['Int']['input']>;
  preferred_arweave_gateway?: InputMaybe<Scalars['String']['input']>;
  preferred_ipfs_gateway?: InputMaybe<Scalars['String']['input']>;
  randomizer_contract?: InputMaybe<Scalars['String']['input']>;
  registered_on?: InputMaybe<Scalars['String']['input']>;
  render_provider_address?: InputMaybe<Scalars['String']['input']>;
  render_provider_percentage?: InputMaybe<Scalars['Int']['input']>;
  royalty_split_provider?: InputMaybe<Scalars['String']['input']>;
  token_base_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Contracts_Metadata_Sum_Fields = {
  __typename?: 'contracts_metadata_sum_fields';
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Int']['output']>;
  next_project_id?: Maybe<Scalars['Int']['output']>;
  partner_id?: Maybe<Scalars['Int']['output']>;
  render_provider_percentage?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Sum_Order_By = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
};

/** update columns of table "contracts_metadata" */
export enum Contracts_Metadata_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Admin = 'admin',
  /** column name */
  AutoApproveArtistSplitProposals = 'auto_approve_artist_split_proposals',
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  ContractType = 'contract_type',
  /** column name */
  CoreVersion = 'core_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurationRegistryAddress = 'curation_registry_address',
  /** column name */
  DefaultEnginePlatformProviderSecondarySalesAddress = 'default_engine_platform_provider_secondary_sales_address',
  /** column name */
  DefaultEnginePlatformProviderSecondarySalesBps = 'default_engine_platform_provider_secondary_sales_bps',
  /** column name */
  DefaultRenderProviderSecondarySalesAddress = 'default_render_provider_secondary_sales_address',
  /** column name */
  DefaultRenderProviderSecondarySalesBps = 'default_render_provider_secondary_sales_bps',
  /** column name */
  DefaultVerticalName = 'default_vertical_name',
  /** column name */
  DependencyRegistryAddress = 'dependency_registry_address',
  /** column name */
  EnginePlatformProviderAddress = 'engine_platform_provider_address',
  /** column name */
  EnginePlatformProviderPercentage = 'engine_platform_provider_percentage',
  /** column name */
  GeneratorUrl = 'generator_url',
  /** column name */
  LatestDependencyRegistryOverrideAllowlistedOn = 'latest_dependency_registry_override_allowlisted_on',
  /** column name */
  MinterAddress = 'minter_address',
  /** column name */
  MinterFilterAddress = 'minter_filter_address',
  /** column name */
  Name = 'name',
  /** column name */
  NewProjectsForbiddenOffchain = 'new_projects_forbidden_offchain',
  /** column name */
  NewProjectsForbiddenOnchain = 'new_projects_forbidden_onchain',
  /** column name */
  NextProjectId = 'next_project_id',
  /** column name */
  OnChainGenerator = 'on_chain_generator',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PreferredArweaveGateway = 'preferred_arweave_gateway',
  /** column name */
  PreferredIpfsGateway = 'preferred_ipfs_gateway',
  /** column name */
  RandomizerContract = 'randomizer_contract',
  /** column name */
  RegisteredOn = 'registered_on',
  /** column name */
  RenderProviderAddress = 'render_provider_address',
  /** column name */
  RenderProviderPercentage = 'render_provider_percentage',
  /** column name */
  RoyaltySplitProvider = 'royalty_split_provider',
  /** column name */
  TokenBaseUrl = 'token_base_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Contracts_Metadata_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contracts_Metadata_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contracts_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contracts_Metadata_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contracts_Metadata_Var_Pop_Fields = {
  __typename?: 'contracts_metadata_var_pop_fields';
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Float']['output']>;
  next_project_id?: Maybe<Scalars['Float']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  render_provider_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Var_Pop_Order_By = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Contracts_Metadata_Var_Samp_Fields = {
  __typename?: 'contracts_metadata_var_samp_fields';
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Float']['output']>;
  next_project_id?: Maybe<Scalars['Float']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  render_provider_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Var_Samp_Order_By = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Contracts_Metadata_Variance_Fields = {
  __typename?: 'contracts_metadata_variance_fields';
  default_engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  default_render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_percentage?: Maybe<Scalars['Float']['output']>;
  next_project_id?: Maybe<Scalars['Float']['output']>;
  partner_id?: Maybe<Scalars['Float']['output']>;
  render_provider_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "contracts_metadata" */
export type Contracts_Metadata_Variance_Order_By = {
  default_engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  default_render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  engine_platform_provider_percentage?: InputMaybe<Order_By>;
  next_project_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  render_provider_percentage?: InputMaybe<Order_By>;
};

/** columns and relationships of "core_registries_metadata" */
export type Core_Registries_Metadata = {
  __typename?: 'core_registries_metadata';
  address: Scalars['String']['output'];
  /** An object relationship */
  dependency_registry?: Maybe<Dependency_Registries>;
  dependency_registry_address?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  minter_filters: Array<Minter_Filters_Metadata>;
  /** An aggregate relationship */
  minter_filters_aggregate: Minter_Filters_Metadata_Aggregate;
  /** An array relationship */
  registered_contracts: Array<Contracts_Metadata>;
  /** An aggregate relationship */
  registered_contracts_aggregate: Contracts_Metadata_Aggregate;
};


/** columns and relationships of "core_registries_metadata" */
export type Core_Registries_MetadataMinter_FiltersArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filters_Metadata_Order_By>>;
  where?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
};


/** columns and relationships of "core_registries_metadata" */
export type Core_Registries_MetadataMinter_Filters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filters_Metadata_Order_By>>;
  where?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
};


/** columns and relationships of "core_registries_metadata" */
export type Core_Registries_MetadataRegistered_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


/** columns and relationships of "core_registries_metadata" */
export type Core_Registries_MetadataRegistered_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};

/** aggregated selection of "core_registries_metadata" */
export type Core_Registries_Metadata_Aggregate = {
  __typename?: 'core_registries_metadata_aggregate';
  aggregate?: Maybe<Core_Registries_Metadata_Aggregate_Fields>;
  nodes: Array<Core_Registries_Metadata>;
};

/** aggregate fields of "core_registries_metadata" */
export type Core_Registries_Metadata_Aggregate_Fields = {
  __typename?: 'core_registries_metadata_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Core_Registries_Metadata_Max_Fields>;
  min?: Maybe<Core_Registries_Metadata_Min_Fields>;
};


/** aggregate fields of "core_registries_metadata" */
export type Core_Registries_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Core_Registries_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "core_registries_metadata". All fields are combined with a logical 'AND'. */
export type Core_Registries_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Core_Registries_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Core_Registries_Metadata_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  dependency_registry?: InputMaybe<Dependency_Registries_Bool_Exp>;
  dependency_registry_address?: InputMaybe<String_Comparison_Exp>;
  minter_filters?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
  minter_filters_aggregate?: InputMaybe<Minter_Filters_Metadata_Aggregate_Bool_Exp>;
  registered_contracts?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  registered_contracts_aggregate?: InputMaybe<Contracts_Metadata_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "core_registries_metadata" */
export enum Core_Registries_Metadata_Constraint {
  /** unique or primary key constraint on columns "address" */
  CoreRegistriesMetadataPkey = 'core_registries_metadata_pkey'
}

/** input type for inserting data into table "core_registries_metadata" */
export type Core_Registries_Metadata_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  dependency_registry?: InputMaybe<Dependency_Registries_Obj_Rel_Insert_Input>;
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
  minter_filters?: InputMaybe<Minter_Filters_Metadata_Arr_Rel_Insert_Input>;
  registered_contracts?: InputMaybe<Contracts_Metadata_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Core_Registries_Metadata_Max_Fields = {
  __typename?: 'core_registries_metadata_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  dependency_registry_address?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Core_Registries_Metadata_Min_Fields = {
  __typename?: 'core_registries_metadata_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  dependency_registry_address?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "core_registries_metadata" */
export type Core_Registries_Metadata_Mutation_Response = {
  __typename?: 'core_registries_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Core_Registries_Metadata>;
};

/** input type for inserting object relation for remote table "core_registries_metadata" */
export type Core_Registries_Metadata_Obj_Rel_Insert_Input = {
  data: Core_Registries_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Core_Registries_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "core_registries_metadata" */
export type Core_Registries_Metadata_On_Conflict = {
  constraint: Core_Registries_Metadata_Constraint;
  update_columns?: Array<Core_Registries_Metadata_Update_Column>;
  where?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "core_registries_metadata". */
export type Core_Registries_Metadata_Order_By = {
  address?: InputMaybe<Order_By>;
  dependency_registry?: InputMaybe<Dependency_Registries_Order_By>;
  dependency_registry_address?: InputMaybe<Order_By>;
  minter_filters_aggregate?: InputMaybe<Minter_Filters_Metadata_Aggregate_Order_By>;
  registered_contracts_aggregate?: InputMaybe<Contracts_Metadata_Aggregate_Order_By>;
};

/** primary key columns input for table: core_registries_metadata */
export type Core_Registries_Metadata_Pk_Columns_Input = {
  address: Scalars['String']['input'];
};

/** select columns of table "core_registries_metadata" */
export enum Core_Registries_Metadata_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  DependencyRegistryAddress = 'dependency_registry_address'
}

/** input type for updating data in table "core_registries_metadata" */
export type Core_Registries_Metadata_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "core_registries_metadata" */
export type Core_Registries_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Core_Registries_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Core_Registries_Metadata_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "core_registries_metadata" */
export enum Core_Registries_Metadata_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  DependencyRegistryAddress = 'dependency_registry_address'
}

export type Core_Registries_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Core_Registries_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Core_Registries_Metadata_Bool_Exp;
};

/** columns and relationships of "curation_statuses" */
export type Curation_Statuses = {
  __typename?: 'curation_statuses';
  value: Scalars['String']['output'];
};

/** aggregated selection of "curation_statuses" */
export type Curation_Statuses_Aggregate = {
  __typename?: 'curation_statuses_aggregate';
  aggregate?: Maybe<Curation_Statuses_Aggregate_Fields>;
  nodes: Array<Curation_Statuses>;
};

/** aggregate fields of "curation_statuses" */
export type Curation_Statuses_Aggregate_Fields = {
  __typename?: 'curation_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Curation_Statuses_Max_Fields>;
  min?: Maybe<Curation_Statuses_Min_Fields>;
};


/** aggregate fields of "curation_statuses" */
export type Curation_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Curation_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "curation_statuses". All fields are combined with a logical 'AND'. */
export type Curation_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Curation_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Curation_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Curation_Statuses_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "curation_statuses" */
export enum Curation_Statuses_Constraint {
  /** unique or primary key constraint on columns "value" */
  CurationStatusesPkey = 'curation_statuses_pkey'
}

export enum Curation_Statuses_Enum {
  Collaboration = 'collaboration',
  Curated = 'curated',
  Factory = 'factory',
  Playground = 'playground'
}

/** Boolean expression to compare columns of type "curation_statuses_enum". All fields are combined with logical 'AND'. */
export type Curation_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Curation_Statuses_Enum>;
  _in?: InputMaybe<Array<Curation_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Curation_Statuses_Enum>;
  _nin?: InputMaybe<Array<Curation_Statuses_Enum>>;
};

/** input type for inserting data into table "curation_statuses" */
export type Curation_Statuses_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Curation_Statuses_Max_Fields = {
  __typename?: 'curation_statuses_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Curation_Statuses_Min_Fields = {
  __typename?: 'curation_statuses_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "curation_statuses" */
export type Curation_Statuses_Mutation_Response = {
  __typename?: 'curation_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Curation_Statuses>;
};

/** on_conflict condition type for table "curation_statuses" */
export type Curation_Statuses_On_Conflict = {
  constraint: Curation_Statuses_Constraint;
  update_columns?: Array<Curation_Statuses_Update_Column>;
  where?: InputMaybe<Curation_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "curation_statuses". */
export type Curation_Statuses_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: curation_statuses */
export type Curation_Statuses_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "curation_statuses" */
export enum Curation_Statuses_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "curation_statuses" */
export type Curation_Statuses_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "curation_statuses" */
export type Curation_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Curation_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Curation_Statuses_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "curation_statuses" */
export enum Curation_Statuses_Update_Column {
  /** column name */
  Value = 'value'
}

export type Curation_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Curation_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Curation_Statuses_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "dependencies_metadata" */
export type Dependencies_Metadata = {
  __typename?: 'dependencies_metadata';
  /** An array relationship */
  additional_cdns: Array<Dependency_Additional_Cdns>;
  /** An aggregate relationship */
  additional_cdns_aggregate: Dependency_Additional_Cdns_Aggregate;
  /** An array relationship */
  additional_repositories: Array<Dependency_Additional_Repositories>;
  /** An aggregate relationship */
  additional_repositories_aggregate: Dependency_Additional_Repositories_Aggregate;
  /** An object relationship */
  dependency_registry: Dependency_Registries;
  dependency_registry_address: Scalars['String']['output'];
  license_type: Scalars['String']['output'];
  name_and_version: Scalars['String']['output'];
  preferred_cdn?: Maybe<Scalars['String']['output']>;
  preferred_repository?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  scripts: Array<Dependency_Scripts>;
  /** An aggregate relationship */
  scripts_aggregate: Dependency_Scripts_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  updated_onchain_at: Scalars['timestamptz']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "dependencies_metadata" */
export type Dependencies_MetadataAdditional_CdnsArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Cdns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Cdns_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
};


/** columns and relationships of "dependencies_metadata" */
export type Dependencies_MetadataAdditional_Cdns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Cdns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Cdns_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
};


/** columns and relationships of "dependencies_metadata" */
export type Dependencies_MetadataAdditional_RepositoriesArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Repositories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Repositories_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
};


/** columns and relationships of "dependencies_metadata" */
export type Dependencies_MetadataAdditional_Repositories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Repositories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Repositories_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
};


/** columns and relationships of "dependencies_metadata" */
export type Dependencies_MetadataScriptsArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Scripts_Order_By>>;
  where?: InputMaybe<Dependency_Scripts_Bool_Exp>;
};


/** columns and relationships of "dependencies_metadata" */
export type Dependencies_MetadataScripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Scripts_Order_By>>;
  where?: InputMaybe<Dependency_Scripts_Bool_Exp>;
};

/** aggregated selection of "dependencies_metadata" */
export type Dependencies_Metadata_Aggregate = {
  __typename?: 'dependencies_metadata_aggregate';
  aggregate?: Maybe<Dependencies_Metadata_Aggregate_Fields>;
  nodes: Array<Dependencies_Metadata>;
};

export type Dependencies_Metadata_Aggregate_Bool_Exp = {
  count?: InputMaybe<Dependencies_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Dependencies_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dependencies_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dependencies_metadata" */
export type Dependencies_Metadata_Aggregate_Fields = {
  __typename?: 'dependencies_metadata_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dependencies_Metadata_Max_Fields>;
  min?: Maybe<Dependencies_Metadata_Min_Fields>;
};


/** aggregate fields of "dependencies_metadata" */
export type Dependencies_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dependencies_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dependencies_metadata" */
export type Dependencies_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dependencies_Metadata_Max_Order_By>;
  min?: InputMaybe<Dependencies_Metadata_Min_Order_By>;
};

/** input type for inserting array relation for remote table "dependencies_metadata" */
export type Dependencies_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Dependencies_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dependencies_Metadata_On_Conflict>;
};

/** Boolean expression to filter rows from the table "dependencies_metadata". All fields are combined with a logical 'AND'. */
export type Dependencies_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Dependencies_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Dependencies_Metadata_Bool_Exp>>;
  additional_cdns?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
  additional_cdns_aggregate?: InputMaybe<Dependency_Additional_Cdns_Aggregate_Bool_Exp>;
  additional_repositories?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
  additional_repositories_aggregate?: InputMaybe<Dependency_Additional_Repositories_Aggregate_Bool_Exp>;
  dependency_registry?: InputMaybe<Dependency_Registries_Bool_Exp>;
  dependency_registry_address?: InputMaybe<String_Comparison_Exp>;
  license_type?: InputMaybe<String_Comparison_Exp>;
  name_and_version?: InputMaybe<String_Comparison_Exp>;
  preferred_cdn?: InputMaybe<String_Comparison_Exp>;
  preferred_repository?: InputMaybe<String_Comparison_Exp>;
  script?: InputMaybe<String_Comparison_Exp>;
  scripts?: InputMaybe<Dependency_Scripts_Bool_Exp>;
  scripts_aggregate?: InputMaybe<Dependency_Scripts_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_onchain_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dependencies_metadata" */
export enum Dependencies_Metadata_Constraint {
  /** unique or primary key constraint on columns "name_and_version" */
  DependenciesMetadataPkey = 'dependencies_metadata_pkey'
}

/** input type for inserting data into table "dependencies_metadata" */
export type Dependencies_Metadata_Insert_Input = {
  additional_cdns?: InputMaybe<Dependency_Additional_Cdns_Arr_Rel_Insert_Input>;
  additional_repositories?: InputMaybe<Dependency_Additional_Repositories_Arr_Rel_Insert_Input>;
  dependency_registry?: InputMaybe<Dependency_Registries_Obj_Rel_Insert_Input>;
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
  license_type?: InputMaybe<Scalars['String']['input']>;
  name_and_version?: InputMaybe<Scalars['String']['input']>;
  preferred_cdn?: InputMaybe<Scalars['String']['input']>;
  preferred_repository?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  scripts?: InputMaybe<Dependency_Scripts_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_onchain_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Dependencies_Metadata_Max_Fields = {
  __typename?: 'dependencies_metadata_max_fields';
  dependency_registry_address?: Maybe<Scalars['String']['output']>;
  license_type?: Maybe<Scalars['String']['output']>;
  name_and_version?: Maybe<Scalars['String']['output']>;
  preferred_cdn?: Maybe<Scalars['String']['output']>;
  preferred_repository?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_onchain_at?: Maybe<Scalars['timestamptz']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "dependencies_metadata" */
export type Dependencies_Metadata_Max_Order_By = {
  dependency_registry_address?: InputMaybe<Order_By>;
  license_type?: InputMaybe<Order_By>;
  name_and_version?: InputMaybe<Order_By>;
  preferred_cdn?: InputMaybe<Order_By>;
  preferred_repository?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_onchain_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dependencies_Metadata_Min_Fields = {
  __typename?: 'dependencies_metadata_min_fields';
  dependency_registry_address?: Maybe<Scalars['String']['output']>;
  license_type?: Maybe<Scalars['String']['output']>;
  name_and_version?: Maybe<Scalars['String']['output']>;
  preferred_cdn?: Maybe<Scalars['String']['output']>;
  preferred_repository?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_onchain_at?: Maybe<Scalars['timestamptz']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "dependencies_metadata" */
export type Dependencies_Metadata_Min_Order_By = {
  dependency_registry_address?: InputMaybe<Order_By>;
  license_type?: InputMaybe<Order_By>;
  name_and_version?: InputMaybe<Order_By>;
  preferred_cdn?: InputMaybe<Order_By>;
  preferred_repository?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_onchain_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dependencies_metadata" */
export type Dependencies_Metadata_Mutation_Response = {
  __typename?: 'dependencies_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dependencies_Metadata>;
};

/** input type for inserting object relation for remote table "dependencies_metadata" */
export type Dependencies_Metadata_Obj_Rel_Insert_Input = {
  data: Dependencies_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dependencies_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "dependencies_metadata" */
export type Dependencies_Metadata_On_Conflict = {
  constraint: Dependencies_Metadata_Constraint;
  update_columns?: Array<Dependencies_Metadata_Update_Column>;
  where?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "dependencies_metadata". */
export type Dependencies_Metadata_Order_By = {
  additional_cdns_aggregate?: InputMaybe<Dependency_Additional_Cdns_Aggregate_Order_By>;
  additional_repositories_aggregate?: InputMaybe<Dependency_Additional_Repositories_Aggregate_Order_By>;
  dependency_registry?: InputMaybe<Dependency_Registries_Order_By>;
  dependency_registry_address?: InputMaybe<Order_By>;
  license_type?: InputMaybe<Order_By>;
  name_and_version?: InputMaybe<Order_By>;
  preferred_cdn?: InputMaybe<Order_By>;
  preferred_repository?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
  scripts_aggregate?: InputMaybe<Dependency_Scripts_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_onchain_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dependencies_metadata */
export type Dependencies_Metadata_Pk_Columns_Input = {
  name_and_version: Scalars['String']['input'];
};

/** select columns of table "dependencies_metadata" */
export enum Dependencies_Metadata_Select_Column {
  /** column name */
  DependencyRegistryAddress = 'dependency_registry_address',
  /** column name */
  LicenseType = 'license_type',
  /** column name */
  NameAndVersion = 'name_and_version',
  /** column name */
  PreferredCdn = 'preferred_cdn',
  /** column name */
  PreferredRepository = 'preferred_repository',
  /** column name */
  Script = 'script',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedOnchainAt = 'updated_onchain_at',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "dependencies_metadata" */
export type Dependencies_Metadata_Set_Input = {
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
  license_type?: InputMaybe<Scalars['String']['input']>;
  name_and_version?: InputMaybe<Scalars['String']['input']>;
  preferred_cdn?: InputMaybe<Scalars['String']['input']>;
  preferred_repository?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_onchain_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "dependencies_metadata" */
export type Dependencies_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dependencies_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dependencies_Metadata_Stream_Cursor_Value_Input = {
  dependency_registry_address?: InputMaybe<Scalars['String']['input']>;
  license_type?: InputMaybe<Scalars['String']['input']>;
  name_and_version?: InputMaybe<Scalars['String']['input']>;
  preferred_cdn?: InputMaybe<Scalars['String']['input']>;
  preferred_repository?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_onchain_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dependencies_metadata" */
export enum Dependencies_Metadata_Update_Column {
  /** column name */
  DependencyRegistryAddress = 'dependency_registry_address',
  /** column name */
  LicenseType = 'license_type',
  /** column name */
  NameAndVersion = 'name_and_version',
  /** column name */
  PreferredCdn = 'preferred_cdn',
  /** column name */
  PreferredRepository = 'preferred_repository',
  /** column name */
  Script = 'script',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedOnchainAt = 'updated_onchain_at',
  /** column name */
  Website = 'website'
}

export type Dependencies_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dependencies_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dependencies_Metadata_Bool_Exp;
};

/** columns and relationships of "dependency_additional_cdns" */
export type Dependency_Additional_Cdns = {
  __typename?: 'dependency_additional_cdns';
  cdn: Scalars['String']['output'];
  dependency_name_and_version: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

/** aggregated selection of "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Aggregate = {
  __typename?: 'dependency_additional_cdns_aggregate';
  aggregate?: Maybe<Dependency_Additional_Cdns_Aggregate_Fields>;
  nodes: Array<Dependency_Additional_Cdns>;
};

export type Dependency_Additional_Cdns_Aggregate_Bool_Exp = {
  count?: InputMaybe<Dependency_Additional_Cdns_Aggregate_Bool_Exp_Count>;
};

export type Dependency_Additional_Cdns_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dependency_Additional_Cdns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Aggregate_Fields = {
  __typename?: 'dependency_additional_cdns_aggregate_fields';
  avg?: Maybe<Dependency_Additional_Cdns_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dependency_Additional_Cdns_Max_Fields>;
  min?: Maybe<Dependency_Additional_Cdns_Min_Fields>;
  stddev?: Maybe<Dependency_Additional_Cdns_Stddev_Fields>;
  stddev_pop?: Maybe<Dependency_Additional_Cdns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dependency_Additional_Cdns_Stddev_Samp_Fields>;
  sum?: Maybe<Dependency_Additional_Cdns_Sum_Fields>;
  var_pop?: Maybe<Dependency_Additional_Cdns_Var_Pop_Fields>;
  var_samp?: Maybe<Dependency_Additional_Cdns_Var_Samp_Fields>;
  variance?: Maybe<Dependency_Additional_Cdns_Variance_Fields>;
};


/** aggregate fields of "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dependency_Additional_Cdns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Aggregate_Order_By = {
  avg?: InputMaybe<Dependency_Additional_Cdns_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dependency_Additional_Cdns_Max_Order_By>;
  min?: InputMaybe<Dependency_Additional_Cdns_Min_Order_By>;
  stddev?: InputMaybe<Dependency_Additional_Cdns_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dependency_Additional_Cdns_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dependency_Additional_Cdns_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dependency_Additional_Cdns_Sum_Order_By>;
  var_pop?: InputMaybe<Dependency_Additional_Cdns_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dependency_Additional_Cdns_Var_Samp_Order_By>;
  variance?: InputMaybe<Dependency_Additional_Cdns_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Arr_Rel_Insert_Input = {
  data: Array<Dependency_Additional_Cdns_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dependency_Additional_Cdns_On_Conflict>;
};

/** aggregate avg on columns */
export type Dependency_Additional_Cdns_Avg_Fields = {
  __typename?: 'dependency_additional_cdns_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dependency_additional_cdns". All fields are combined with a logical 'AND'. */
export type Dependency_Additional_Cdns_Bool_Exp = {
  _and?: InputMaybe<Array<Dependency_Additional_Cdns_Bool_Exp>>;
  _not?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
  _or?: InputMaybe<Array<Dependency_Additional_Cdns_Bool_Exp>>;
  cdn?: InputMaybe<String_Comparison_Exp>;
  dependency_name_and_version?: InputMaybe<String_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "dependency_additional_cdns" */
export enum Dependency_Additional_Cdns_Constraint {
  /** unique or primary key constraint on columns "dependency_name_and_version", "index" */
  DependencyAdditionalCdnsPkey = 'dependency_additional_cdns_pkey'
}

/** input type for incrementing numeric columns in table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Insert_Input = {
  cdn?: InputMaybe<Scalars['String']['input']>;
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Dependency_Additional_Cdns_Max_Fields = {
  __typename?: 'dependency_additional_cdns_max_fields';
  cdn?: Maybe<Scalars['String']['output']>;
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Max_Order_By = {
  cdn?: InputMaybe<Order_By>;
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dependency_Additional_Cdns_Min_Fields = {
  __typename?: 'dependency_additional_cdns_min_fields';
  cdn?: Maybe<Scalars['String']['output']>;
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Min_Order_By = {
  cdn?: InputMaybe<Order_By>;
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Mutation_Response = {
  __typename?: 'dependency_additional_cdns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dependency_Additional_Cdns>;
};

/** on_conflict condition type for table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_On_Conflict = {
  constraint: Dependency_Additional_Cdns_Constraint;
  update_columns?: Array<Dependency_Additional_Cdns_Update_Column>;
  where?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
};

/** Ordering options when selecting data from "dependency_additional_cdns". */
export type Dependency_Additional_Cdns_Order_By = {
  cdn?: InputMaybe<Order_By>;
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dependency_additional_cdns */
export type Dependency_Additional_Cdns_Pk_Columns_Input = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

/** select columns of table "dependency_additional_cdns" */
export enum Dependency_Additional_Cdns_Select_Column {
  /** column name */
  Cdn = 'cdn',
  /** column name */
  DependencyNameAndVersion = 'dependency_name_and_version',
  /** column name */
  Index = 'index'
}

/** input type for updating data in table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Set_Input = {
  cdn?: InputMaybe<Scalars['String']['input']>;
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Dependency_Additional_Cdns_Stddev_Fields = {
  __typename?: 'dependency_additional_cdns_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Dependency_Additional_Cdns_Stddev_Pop_Fields = {
  __typename?: 'dependency_additional_cdns_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Dependency_Additional_Cdns_Stddev_Samp_Fields = {
  __typename?: 'dependency_additional_cdns_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dependency_Additional_Cdns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dependency_Additional_Cdns_Stream_Cursor_Value_Input = {
  cdn?: InputMaybe<Scalars['String']['input']>;
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Dependency_Additional_Cdns_Sum_Fields = {
  __typename?: 'dependency_additional_cdns_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** update columns of table "dependency_additional_cdns" */
export enum Dependency_Additional_Cdns_Update_Column {
  /** column name */
  Cdn = 'cdn',
  /** column name */
  DependencyNameAndVersion = 'dependency_name_and_version',
  /** column name */
  Index = 'index'
}

export type Dependency_Additional_Cdns_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dependency_Additional_Cdns_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dependency_Additional_Cdns_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dependency_Additional_Cdns_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Dependency_Additional_Cdns_Var_Pop_Fields = {
  __typename?: 'dependency_additional_cdns_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Dependency_Additional_Cdns_Var_Samp_Fields = {
  __typename?: 'dependency_additional_cdns_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Dependency_Additional_Cdns_Variance_Fields = {
  __typename?: 'dependency_additional_cdns_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "dependency_additional_cdns" */
export type Dependency_Additional_Cdns_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** columns and relationships of "dependency_additional_repositories" */
export type Dependency_Additional_Repositories = {
  __typename?: 'dependency_additional_repositories';
  dependency_name_and_version: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  repository: Scalars['String']['output'];
};

/** aggregated selection of "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Aggregate = {
  __typename?: 'dependency_additional_repositories_aggregate';
  aggregate?: Maybe<Dependency_Additional_Repositories_Aggregate_Fields>;
  nodes: Array<Dependency_Additional_Repositories>;
};

export type Dependency_Additional_Repositories_Aggregate_Bool_Exp = {
  count?: InputMaybe<Dependency_Additional_Repositories_Aggregate_Bool_Exp_Count>;
};

export type Dependency_Additional_Repositories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dependency_Additional_Repositories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Aggregate_Fields = {
  __typename?: 'dependency_additional_repositories_aggregate_fields';
  avg?: Maybe<Dependency_Additional_Repositories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dependency_Additional_Repositories_Max_Fields>;
  min?: Maybe<Dependency_Additional_Repositories_Min_Fields>;
  stddev?: Maybe<Dependency_Additional_Repositories_Stddev_Fields>;
  stddev_pop?: Maybe<Dependency_Additional_Repositories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dependency_Additional_Repositories_Stddev_Samp_Fields>;
  sum?: Maybe<Dependency_Additional_Repositories_Sum_Fields>;
  var_pop?: Maybe<Dependency_Additional_Repositories_Var_Pop_Fields>;
  var_samp?: Maybe<Dependency_Additional_Repositories_Var_Samp_Fields>;
  variance?: Maybe<Dependency_Additional_Repositories_Variance_Fields>;
};


/** aggregate fields of "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dependency_Additional_Repositories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Aggregate_Order_By = {
  avg?: InputMaybe<Dependency_Additional_Repositories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dependency_Additional_Repositories_Max_Order_By>;
  min?: InputMaybe<Dependency_Additional_Repositories_Min_Order_By>;
  stddev?: InputMaybe<Dependency_Additional_Repositories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dependency_Additional_Repositories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dependency_Additional_Repositories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dependency_Additional_Repositories_Sum_Order_By>;
  var_pop?: InputMaybe<Dependency_Additional_Repositories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dependency_Additional_Repositories_Var_Samp_Order_By>;
  variance?: InputMaybe<Dependency_Additional_Repositories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Arr_Rel_Insert_Input = {
  data: Array<Dependency_Additional_Repositories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dependency_Additional_Repositories_On_Conflict>;
};

/** aggregate avg on columns */
export type Dependency_Additional_Repositories_Avg_Fields = {
  __typename?: 'dependency_additional_repositories_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dependency_additional_repositories". All fields are combined with a logical 'AND'. */
export type Dependency_Additional_Repositories_Bool_Exp = {
  _and?: InputMaybe<Array<Dependency_Additional_Repositories_Bool_Exp>>;
  _not?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
  _or?: InputMaybe<Array<Dependency_Additional_Repositories_Bool_Exp>>;
  dependency_name_and_version?: InputMaybe<String_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  repository?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dependency_additional_repositories" */
export enum Dependency_Additional_Repositories_Constraint {
  /** unique or primary key constraint on columns "dependency_name_and_version", "index" */
  DependencyAdditionalRepositoriesPkey = 'dependency_additional_repositories_pkey'
}

/** input type for incrementing numeric columns in table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Insert_Input = {
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  repository?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Dependency_Additional_Repositories_Max_Fields = {
  __typename?: 'dependency_additional_repositories_max_fields';
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  repository?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Max_Order_By = {
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  repository?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dependency_Additional_Repositories_Min_Fields = {
  __typename?: 'dependency_additional_repositories_min_fields';
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  repository?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Min_Order_By = {
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  repository?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Mutation_Response = {
  __typename?: 'dependency_additional_repositories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dependency_Additional_Repositories>;
};

/** on_conflict condition type for table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_On_Conflict = {
  constraint: Dependency_Additional_Repositories_Constraint;
  update_columns?: Array<Dependency_Additional_Repositories_Update_Column>;
  where?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
};

/** Ordering options when selecting data from "dependency_additional_repositories". */
export type Dependency_Additional_Repositories_Order_By = {
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  repository?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dependency_additional_repositories */
export type Dependency_Additional_Repositories_Pk_Columns_Input = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

/** select columns of table "dependency_additional_repositories" */
export enum Dependency_Additional_Repositories_Select_Column {
  /** column name */
  DependencyNameAndVersion = 'dependency_name_and_version',
  /** column name */
  Index = 'index',
  /** column name */
  Repository = 'repository'
}

/** input type for updating data in table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Set_Input = {
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  repository?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Dependency_Additional_Repositories_Stddev_Fields = {
  __typename?: 'dependency_additional_repositories_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Dependency_Additional_Repositories_Stddev_Pop_Fields = {
  __typename?: 'dependency_additional_repositories_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Dependency_Additional_Repositories_Stddev_Samp_Fields = {
  __typename?: 'dependency_additional_repositories_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dependency_Additional_Repositories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dependency_Additional_Repositories_Stream_Cursor_Value_Input = {
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  repository?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Dependency_Additional_Repositories_Sum_Fields = {
  __typename?: 'dependency_additional_repositories_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** update columns of table "dependency_additional_repositories" */
export enum Dependency_Additional_Repositories_Update_Column {
  /** column name */
  DependencyNameAndVersion = 'dependency_name_and_version',
  /** column name */
  Index = 'index',
  /** column name */
  Repository = 'repository'
}

export type Dependency_Additional_Repositories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dependency_Additional_Repositories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dependency_Additional_Repositories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dependency_Additional_Repositories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Dependency_Additional_Repositories_Var_Pop_Fields = {
  __typename?: 'dependency_additional_repositories_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Dependency_Additional_Repositories_Var_Samp_Fields = {
  __typename?: 'dependency_additional_repositories_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Dependency_Additional_Repositories_Variance_Fields = {
  __typename?: 'dependency_additional_repositories_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "dependency_additional_repositories" */
export type Dependency_Additional_Repositories_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** columns and relationships of "dependency_registries" */
export type Dependency_Registries = {
  __typename?: 'dependency_registries';
  address: Scalars['String']['output'];
  /** An object relationship */
  core_registry?: Maybe<Core_Registries_Metadata>;
  core_registry_address?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  dependencies: Array<Dependencies_Metadata>;
  /** An aggregate relationship */
  dependencies_aggregate: Dependencies_Metadata_Aggregate;
  owner: Scalars['String']['output'];
  /** An array relationship */
  supported_core_contracts_override: Array<Contracts_Metadata>;
  /** An aggregate relationship */
  supported_core_contracts_override_aggregate: Contracts_Metadata_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  updated_onchain_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "dependency_registries" */
export type Dependency_RegistriesDependenciesArgs = {
  distinct_on?: InputMaybe<Array<Dependencies_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependencies_Metadata_Order_By>>;
  where?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
};


/** columns and relationships of "dependency_registries" */
export type Dependency_RegistriesDependencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependencies_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependencies_Metadata_Order_By>>;
  where?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
};


/** columns and relationships of "dependency_registries" */
export type Dependency_RegistriesSupported_Core_Contracts_OverrideArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


/** columns and relationships of "dependency_registries" */
export type Dependency_RegistriesSupported_Core_Contracts_Override_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};

/** aggregated selection of "dependency_registries" */
export type Dependency_Registries_Aggregate = {
  __typename?: 'dependency_registries_aggregate';
  aggregate?: Maybe<Dependency_Registries_Aggregate_Fields>;
  nodes: Array<Dependency_Registries>;
};

/** aggregate fields of "dependency_registries" */
export type Dependency_Registries_Aggregate_Fields = {
  __typename?: 'dependency_registries_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Dependency_Registries_Max_Fields>;
  min?: Maybe<Dependency_Registries_Min_Fields>;
};


/** aggregate fields of "dependency_registries" */
export type Dependency_Registries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dependency_Registries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "dependency_registries". All fields are combined with a logical 'AND'. */
export type Dependency_Registries_Bool_Exp = {
  _and?: InputMaybe<Array<Dependency_Registries_Bool_Exp>>;
  _not?: InputMaybe<Dependency_Registries_Bool_Exp>;
  _or?: InputMaybe<Array<Dependency_Registries_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
  core_registry_address?: InputMaybe<String_Comparison_Exp>;
  dependencies?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
  dependencies_aggregate?: InputMaybe<Dependencies_Metadata_Aggregate_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  supported_core_contracts_override?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  supported_core_contracts_override_aggregate?: InputMaybe<Contracts_Metadata_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_onchain_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dependency_registries" */
export enum Dependency_Registries_Constraint {
  /** unique or primary key constraint on columns "address" */
  DependencyRegistriesPkey = 'dependency_registries_pkey'
}

/** input type for inserting data into table "dependency_registries" */
export type Dependency_Registries_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Obj_Rel_Insert_Input>;
  core_registry_address?: InputMaybe<Scalars['String']['input']>;
  dependencies?: InputMaybe<Dependencies_Metadata_Arr_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']['input']>;
  supported_core_contracts_override?: InputMaybe<Contracts_Metadata_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_onchain_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Dependency_Registries_Max_Fields = {
  __typename?: 'dependency_registries_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  core_registry_address?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_onchain_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dependency_Registries_Min_Fields = {
  __typename?: 'dependency_registries_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  core_registry_address?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_onchain_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "dependency_registries" */
export type Dependency_Registries_Mutation_Response = {
  __typename?: 'dependency_registries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dependency_Registries>;
};

/** input type for inserting object relation for remote table "dependency_registries" */
export type Dependency_Registries_Obj_Rel_Insert_Input = {
  data: Dependency_Registries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dependency_Registries_On_Conflict>;
};

/** on_conflict condition type for table "dependency_registries" */
export type Dependency_Registries_On_Conflict = {
  constraint: Dependency_Registries_Constraint;
  update_columns?: Array<Dependency_Registries_Update_Column>;
  where?: InputMaybe<Dependency_Registries_Bool_Exp>;
};

/** Ordering options when selecting data from "dependency_registries". */
export type Dependency_Registries_Order_By = {
  address?: InputMaybe<Order_By>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Order_By>;
  core_registry_address?: InputMaybe<Order_By>;
  dependencies_aggregate?: InputMaybe<Dependencies_Metadata_Aggregate_Order_By>;
  owner?: InputMaybe<Order_By>;
  supported_core_contracts_override_aggregate?: InputMaybe<Contracts_Metadata_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_onchain_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dependency_registries */
export type Dependency_Registries_Pk_Columns_Input = {
  address: Scalars['String']['input'];
};

/** select columns of table "dependency_registries" */
export enum Dependency_Registries_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CoreRegistryAddress = 'core_registry_address',
  /** column name */
  Owner = 'owner',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedOnchainAt = 'updated_onchain_at'
}

/** input type for updating data in table "dependency_registries" */
export type Dependency_Registries_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_registry_address?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_onchain_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "dependency_registries" */
export type Dependency_Registries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dependency_Registries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dependency_Registries_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_registry_address?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_onchain_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "dependency_registries" */
export enum Dependency_Registries_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CoreRegistryAddress = 'core_registry_address',
  /** column name */
  Owner = 'owner',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedOnchainAt = 'updated_onchain_at'
}

export type Dependency_Registries_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dependency_Registries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dependency_Registries_Bool_Exp;
};

/** columns and relationships of "dependency_scripts" */
export type Dependency_Scripts = {
  __typename?: 'dependency_scripts';
  address: Scalars['String']['output'];
  dependency_name_and_version: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  script: Scalars['String']['output'];
};

/** aggregated selection of "dependency_scripts" */
export type Dependency_Scripts_Aggregate = {
  __typename?: 'dependency_scripts_aggregate';
  aggregate?: Maybe<Dependency_Scripts_Aggregate_Fields>;
  nodes: Array<Dependency_Scripts>;
};

export type Dependency_Scripts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Dependency_Scripts_Aggregate_Bool_Exp_Count>;
};

export type Dependency_Scripts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dependency_Scripts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Dependency_Scripts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dependency_scripts" */
export type Dependency_Scripts_Aggregate_Fields = {
  __typename?: 'dependency_scripts_aggregate_fields';
  avg?: Maybe<Dependency_Scripts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dependency_Scripts_Max_Fields>;
  min?: Maybe<Dependency_Scripts_Min_Fields>;
  stddev?: Maybe<Dependency_Scripts_Stddev_Fields>;
  stddev_pop?: Maybe<Dependency_Scripts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dependency_Scripts_Stddev_Samp_Fields>;
  sum?: Maybe<Dependency_Scripts_Sum_Fields>;
  var_pop?: Maybe<Dependency_Scripts_Var_Pop_Fields>;
  var_samp?: Maybe<Dependency_Scripts_Var_Samp_Fields>;
  variance?: Maybe<Dependency_Scripts_Variance_Fields>;
};


/** aggregate fields of "dependency_scripts" */
export type Dependency_Scripts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dependency_Scripts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dependency_scripts" */
export type Dependency_Scripts_Aggregate_Order_By = {
  avg?: InputMaybe<Dependency_Scripts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dependency_Scripts_Max_Order_By>;
  min?: InputMaybe<Dependency_Scripts_Min_Order_By>;
  stddev?: InputMaybe<Dependency_Scripts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dependency_Scripts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dependency_Scripts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dependency_Scripts_Sum_Order_By>;
  var_pop?: InputMaybe<Dependency_Scripts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dependency_Scripts_Var_Samp_Order_By>;
  variance?: InputMaybe<Dependency_Scripts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "dependency_scripts" */
export type Dependency_Scripts_Arr_Rel_Insert_Input = {
  data: Array<Dependency_Scripts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dependency_Scripts_On_Conflict>;
};

/** aggregate avg on columns */
export type Dependency_Scripts_Avg_Fields = {
  __typename?: 'dependency_scripts_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dependency_scripts". All fields are combined with a logical 'AND'. */
export type Dependency_Scripts_Bool_Exp = {
  _and?: InputMaybe<Array<Dependency_Scripts_Bool_Exp>>;
  _not?: InputMaybe<Dependency_Scripts_Bool_Exp>;
  _or?: InputMaybe<Array<Dependency_Scripts_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  dependency_name_and_version?: InputMaybe<String_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  script?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dependency_scripts" */
export enum Dependency_Scripts_Constraint {
  /** unique or primary key constraint on columns "dependency_name_and_version", "index" */
  DependencyScriptsPkey = 'dependency_scripts_pkey'
}

/** input type for incrementing numeric columns in table "dependency_scripts" */
export type Dependency_Scripts_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dependency_scripts" */
export type Dependency_Scripts_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Dependency_Scripts_Max_Fields = {
  __typename?: 'dependency_scripts_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  script?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dependency_Scripts_Min_Fields = {
  __typename?: 'dependency_scripts_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  script?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dependency_scripts" */
export type Dependency_Scripts_Mutation_Response = {
  __typename?: 'dependency_scripts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dependency_Scripts>;
};

/** on_conflict condition type for table "dependency_scripts" */
export type Dependency_Scripts_On_Conflict = {
  constraint: Dependency_Scripts_Constraint;
  update_columns?: Array<Dependency_Scripts_Update_Column>;
  where?: InputMaybe<Dependency_Scripts_Bool_Exp>;
};

/** Ordering options when selecting data from "dependency_scripts". */
export type Dependency_Scripts_Order_By = {
  address?: InputMaybe<Order_By>;
  dependency_name_and_version?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dependency_scripts */
export type Dependency_Scripts_Pk_Columns_Input = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

/** select columns of table "dependency_scripts" */
export enum Dependency_Scripts_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  DependencyNameAndVersion = 'dependency_name_and_version',
  /** column name */
  Index = 'index',
  /** column name */
  Script = 'script'
}

/** input type for updating data in table "dependency_scripts" */
export type Dependency_Scripts_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Dependency_Scripts_Stddev_Fields = {
  __typename?: 'dependency_scripts_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Dependency_Scripts_Stddev_Pop_Fields = {
  __typename?: 'dependency_scripts_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Dependency_Scripts_Stddev_Samp_Fields = {
  __typename?: 'dependency_scripts_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "dependency_scripts" */
export type Dependency_Scripts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dependency_Scripts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dependency_Scripts_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Dependency_Scripts_Sum_Fields = {
  __typename?: 'dependency_scripts_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** update columns of table "dependency_scripts" */
export enum Dependency_Scripts_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  DependencyNameAndVersion = 'dependency_name_and_version',
  /** column name */
  Index = 'index',
  /** column name */
  Script = 'script'
}

export type Dependency_Scripts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dependency_Scripts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dependency_Scripts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dependency_Scripts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Dependency_Scripts_Var_Pop_Fields = {
  __typename?: 'dependency_scripts_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Dependency_Scripts_Var_Samp_Fields = {
  __typename?: 'dependency_scripts_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Dependency_Scripts_Variance_Fields = {
  __typename?: 'dependency_scripts_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "dependency_scripts" */
export type Dependency_Scripts_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** This table stores rows of metadata tags associated with all projects. */
export type Entity_Tags = {
  __typename?: 'entity_tags';
  id: Scalars['Int']['output'];
  /** An object relationship */
  project?: Maybe<Projects_Metadata>;
  project_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tag?: Maybe<Tags>;
  tag_name: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "entity_tags" */
export type Entity_Tags_Aggregate = {
  __typename?: 'entity_tags_aggregate';
  aggregate?: Maybe<Entity_Tags_Aggregate_Fields>;
  nodes: Array<Entity_Tags>;
};

export type Entity_Tags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Entity_Tags_Aggregate_Bool_Exp_Count>;
};

export type Entity_Tags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Entity_Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_tags" */
export type Entity_Tags_Aggregate_Fields = {
  __typename?: 'entity_tags_aggregate_fields';
  avg?: Maybe<Entity_Tags_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Entity_Tags_Max_Fields>;
  min?: Maybe<Entity_Tags_Min_Fields>;
  stddev?: Maybe<Entity_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Entity_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Entity_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Entity_Tags_Sum_Fields>;
  var_pop?: Maybe<Entity_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Entity_Tags_Var_Samp_Fields>;
  variance?: Maybe<Entity_Tags_Variance_Fields>;
};


/** aggregate fields of "entity_tags" */
export type Entity_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "entity_tags" */
export type Entity_Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Entity_Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entity_Tags_Max_Order_By>;
  min?: InputMaybe<Entity_Tags_Min_Order_By>;
  stddev?: InputMaybe<Entity_Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Entity_Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Entity_Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Entity_Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Entity_Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Entity_Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Entity_Tags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "entity_tags" */
export type Entity_Tags_Arr_Rel_Insert_Input = {
  data: Array<Entity_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_Tags_On_Conflict>;
};

/** aggregate avg on columns */
export type Entity_Tags_Avg_Fields = {
  __typename?: 'entity_tags_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "entity_tags" */
export type Entity_Tags_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entity_tags". All fields are combined with a logical 'AND'. */
export type Entity_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_Tags_Bool_Exp>>;
  _not?: InputMaybe<Entity_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_Tags_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  tag?: InputMaybe<Tags_Bool_Exp>;
  tag_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_tags" */
export enum Entity_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityTagsPkey = 'entity_tags_pkey',
  /** unique or primary key constraint on columns "project_id", "tag_name" */
  UniqueProjectTag = 'unique_project_tag'
}

/** input type for incrementing numeric columns in table "entity_tags" */
export type Entity_Tags_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "entity_tags" */
export type Entity_Tags_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
  tag_name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Entity_Tags_Max_Fields = {
  __typename?: 'entity_tags_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  tag_name?: Maybe<Scalars['String']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "entity_tags" */
export type Entity_Tags_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  tag_name?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Entity_Tags_Min_Fields = {
  __typename?: 'entity_tags_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  tag_name?: Maybe<Scalars['String']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "entity_tags" */
export type Entity_Tags_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  tag_name?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_tags" */
export type Entity_Tags_Mutation_Response = {
  __typename?: 'entity_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity_Tags>;
};

/** on_conflict condition type for table "entity_tags" */
export type Entity_Tags_On_Conflict = {
  constraint: Entity_Tags_Constraint;
  update_columns?: Array<Entity_Tags_Update_Column>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_tags". */
export type Entity_Tags_Order_By = {
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tags_Order_By>;
  tag_name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_tags */
export type Entity_Tags_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "entity_tags" */
export enum Entity_Tags_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TagName = 'tag_name',
  /** column name */
  UserAddress = 'user_address'
}

/** input type for updating data in table "entity_tags" */
export type Entity_Tags_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  tag_name?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Entity_Tags_Stddev_Fields = {
  __typename?: 'entity_tags_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "entity_tags" */
export type Entity_Tags_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Entity_Tags_Stddev_Pop_Fields = {
  __typename?: 'entity_tags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "entity_tags" */
export type Entity_Tags_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Entity_Tags_Stddev_Samp_Fields = {
  __typename?: 'entity_tags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "entity_tags" */
export type Entity_Tags_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entity_tags" */
export type Entity_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_Tags_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  tag_name?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Entity_Tags_Sum_Fields = {
  __typename?: 'entity_tags_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "entity_tags" */
export type Entity_Tags_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "entity_tags" */
export enum Entity_Tags_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TagName = 'tag_name',
  /** column name */
  UserAddress = 'user_address'
}

export type Entity_Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Entity_Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Entity_Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Entity_Tags_Var_Pop_Fields = {
  __typename?: 'entity_tags_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "entity_tags" */
export type Entity_Tags_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Entity_Tags_Var_Samp_Fields = {
  __typename?: 'entity_tags_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "entity_tags" */
export type Entity_Tags_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Entity_Tags_Variance_Fields = {
  __typename?: 'entity_tags_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "entity_tags" */
export type Entity_Tags_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "environment_configuration" */
export type Environment_Configuration = {
  __typename?: 'environment_configuration';
  current_pmp_contract?: Maybe<Scalars['String']['output']>;
  id: Scalars['Boolean']['output'];
  media_proxy_url: Scalars['String']['output'];
  slippy_map_tile_storage_url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "environment_configuration" */
export type Environment_Configuration_Aggregate = {
  __typename?: 'environment_configuration_aggregate';
  aggregate?: Maybe<Environment_Configuration_Aggregate_Fields>;
  nodes: Array<Environment_Configuration>;
};

/** aggregate fields of "environment_configuration" */
export type Environment_Configuration_Aggregate_Fields = {
  __typename?: 'environment_configuration_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Environment_Configuration_Max_Fields>;
  min?: Maybe<Environment_Configuration_Min_Fields>;
};


/** aggregate fields of "environment_configuration" */
export type Environment_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Environment_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "environment_configuration". All fields are combined with a logical 'AND'. */
export type Environment_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Environment_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Environment_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Environment_Configuration_Bool_Exp>>;
  current_pmp_contract?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Boolean_Comparison_Exp>;
  media_proxy_url?: InputMaybe<String_Comparison_Exp>;
  slippy_map_tile_storage_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "environment_configuration" */
export enum Environment_Configuration_Constraint {
  /** unique or primary key constraint on columns "id" */
  EnvironmentConfigurationPkey = 'environment_configuration_pkey'
}

/** input type for inserting data into table "environment_configuration" */
export type Environment_Configuration_Insert_Input = {
  current_pmp_contract?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  media_proxy_url?: InputMaybe<Scalars['String']['input']>;
  slippy_map_tile_storage_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Environment_Configuration_Max_Fields = {
  __typename?: 'environment_configuration_max_fields';
  current_pmp_contract?: Maybe<Scalars['String']['output']>;
  media_proxy_url?: Maybe<Scalars['String']['output']>;
  slippy_map_tile_storage_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Environment_Configuration_Min_Fields = {
  __typename?: 'environment_configuration_min_fields';
  current_pmp_contract?: Maybe<Scalars['String']['output']>;
  media_proxy_url?: Maybe<Scalars['String']['output']>;
  slippy_map_tile_storage_url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "environment_configuration" */
export type Environment_Configuration_Mutation_Response = {
  __typename?: 'environment_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Environment_Configuration>;
};

/** on_conflict condition type for table "environment_configuration" */
export type Environment_Configuration_On_Conflict = {
  constraint: Environment_Configuration_Constraint;
  update_columns?: Array<Environment_Configuration_Update_Column>;
  where?: InputMaybe<Environment_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "environment_configuration". */
export type Environment_Configuration_Order_By = {
  current_pmp_contract?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_proxy_url?: InputMaybe<Order_By>;
  slippy_map_tile_storage_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: environment_configuration */
export type Environment_Configuration_Pk_Columns_Input = {
  id: Scalars['Boolean']['input'];
};

/** select columns of table "environment_configuration" */
export enum Environment_Configuration_Select_Column {
  /** column name */
  CurrentPmpContract = 'current_pmp_contract',
  /** column name */
  Id = 'id',
  /** column name */
  MediaProxyUrl = 'media_proxy_url',
  /** column name */
  SlippyMapTileStorageUrl = 'slippy_map_tile_storage_url'
}

/** input type for updating data in table "environment_configuration" */
export type Environment_Configuration_Set_Input = {
  current_pmp_contract?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  media_proxy_url?: InputMaybe<Scalars['String']['input']>;
  slippy_map_tile_storage_url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "environment_configuration" */
export type Environment_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Environment_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Environment_Configuration_Stream_Cursor_Value_Input = {
  current_pmp_contract?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  media_proxy_url?: InputMaybe<Scalars['String']['input']>;
  slippy_map_tile_storage_url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "environment_configuration" */
export enum Environment_Configuration_Update_Column {
  /** column name */
  CurrentPmpContract = 'current_pmp_contract',
  /** column name */
  Id = 'id',
  /** column name */
  MediaProxyUrl = 'media_proxy_url',
  /** column name */
  SlippyMapTileStorageUrl = 'slippy_map_tile_storage_url'
}

export type Environment_Configuration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Environment_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Environment_Configuration_Bool_Exp;
};

/** This table lists a users’ favorites (tokens, projects, other users) */
export type Favorites = {
  __typename?: 'favorites';
  favorited_project_id?: Maybe<Scalars['String']['output']>;
  favorited_token_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  favorited_user?: Maybe<Users>;
  favorited_user_address?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  project_metadata?: Maybe<Projects_Metadata>;
  /** An object relationship */
  token_metadata?: Maybe<Tokens_Metadata>;
  /** An object relationship */
  user: Users;
  user_public_address: Scalars['String']['output'];
};

/** aggregated selection of "favorites" */
export type Favorites_Aggregate = {
  __typename?: 'favorites_aggregate';
  aggregate?: Maybe<Favorites_Aggregate_Fields>;
  nodes: Array<Favorites>;
};

export type Favorites_Aggregate_Bool_Exp = {
  count?: InputMaybe<Favorites_Aggregate_Bool_Exp_Count>;
};

export type Favorites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Favorites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Favorites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "favorites" */
export type Favorites_Aggregate_Fields = {
  __typename?: 'favorites_aggregate_fields';
  avg?: Maybe<Favorites_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Favorites_Max_Fields>;
  min?: Maybe<Favorites_Min_Fields>;
  stddev?: Maybe<Favorites_Stddev_Fields>;
  stddev_pop?: Maybe<Favorites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Favorites_Stddev_Samp_Fields>;
  sum?: Maybe<Favorites_Sum_Fields>;
  var_pop?: Maybe<Favorites_Var_Pop_Fields>;
  var_samp?: Maybe<Favorites_Var_Samp_Fields>;
  variance?: Maybe<Favorites_Variance_Fields>;
};


/** aggregate fields of "favorites" */
export type Favorites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Favorites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "favorites" */
export type Favorites_Aggregate_Order_By = {
  avg?: InputMaybe<Favorites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Favorites_Max_Order_By>;
  min?: InputMaybe<Favorites_Min_Order_By>;
  stddev?: InputMaybe<Favorites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Favorites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Favorites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Favorites_Sum_Order_By>;
  var_pop?: InputMaybe<Favorites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Favorites_Var_Samp_Order_By>;
  variance?: InputMaybe<Favorites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "favorites" */
export type Favorites_Arr_Rel_Insert_Input = {
  data: Array<Favorites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Favorites_On_Conflict>;
};

/** aggregate avg on columns */
export type Favorites_Avg_Fields = {
  __typename?: 'favorites_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "favorites" */
export type Favorites_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "favorites". All fields are combined with a logical 'AND'. */
export type Favorites_Bool_Exp = {
  _and?: InputMaybe<Array<Favorites_Bool_Exp>>;
  _not?: InputMaybe<Favorites_Bool_Exp>;
  _or?: InputMaybe<Array<Favorites_Bool_Exp>>;
  favorited_project_id?: InputMaybe<String_Comparison_Exp>;
  favorited_token_id?: InputMaybe<String_Comparison_Exp>;
  favorited_user?: InputMaybe<Users_Bool_Exp>;
  favorited_user_address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  project_metadata?: InputMaybe<Projects_Metadata_Bool_Exp>;
  token_metadata?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_public_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "favorites" */
export enum Favorites_Constraint {
  /** unique or primary key constraint on columns "id" */
  FavoritesPkey = 'favorites_pkey'
}

/** input type for incrementing numeric columns in table "favorites" */
export type Favorites_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "favorites" */
export type Favorites_Insert_Input = {
  favorited_project_id?: InputMaybe<Scalars['String']['input']>;
  favorited_token_id?: InputMaybe<Scalars['String']['input']>;
  favorited_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  favorited_user_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  project_metadata?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  token_metadata?: InputMaybe<Tokens_Metadata_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_public_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Favorites_Max_Fields = {
  __typename?: 'favorites_max_fields';
  favorited_project_id?: Maybe<Scalars['String']['output']>;
  favorited_token_id?: Maybe<Scalars['String']['output']>;
  favorited_user_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_public_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "favorites" */
export type Favorites_Max_Order_By = {
  favorited_project_id?: InputMaybe<Order_By>;
  favorited_token_id?: InputMaybe<Order_By>;
  favorited_user_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_public_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Favorites_Min_Fields = {
  __typename?: 'favorites_min_fields';
  favorited_project_id?: Maybe<Scalars['String']['output']>;
  favorited_token_id?: Maybe<Scalars['String']['output']>;
  favorited_user_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_public_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "favorites" */
export type Favorites_Min_Order_By = {
  favorited_project_id?: InputMaybe<Order_By>;
  favorited_token_id?: InputMaybe<Order_By>;
  favorited_user_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_public_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "favorites" */
export type Favorites_Mutation_Response = {
  __typename?: 'favorites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Favorites>;
};

/** on_conflict condition type for table "favorites" */
export type Favorites_On_Conflict = {
  constraint: Favorites_Constraint;
  update_columns?: Array<Favorites_Update_Column>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};

/** Ordering options when selecting data from "favorites". */
export type Favorites_Order_By = {
  favorited_project_id?: InputMaybe<Order_By>;
  favorited_token_id?: InputMaybe<Order_By>;
  favorited_user?: InputMaybe<Users_Order_By>;
  favorited_user_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_metadata?: InputMaybe<Projects_Metadata_Order_By>;
  token_metadata?: InputMaybe<Tokens_Metadata_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_public_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: favorites */
export type Favorites_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "favorites" */
export enum Favorites_Select_Column {
  /** column name */
  FavoritedProjectId = 'favorited_project_id',
  /** column name */
  FavoritedTokenId = 'favorited_token_id',
  /** column name */
  FavoritedUserAddress = 'favorited_user_address',
  /** column name */
  Id = 'id',
  /** column name */
  UserPublicAddress = 'user_public_address'
}

/** input type for updating data in table "favorites" */
export type Favorites_Set_Input = {
  favorited_project_id?: InputMaybe<Scalars['String']['input']>;
  favorited_token_id?: InputMaybe<Scalars['String']['input']>;
  favorited_user_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_public_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Favorites_Stddev_Fields = {
  __typename?: 'favorites_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "favorites" */
export type Favorites_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Favorites_Stddev_Pop_Fields = {
  __typename?: 'favorites_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "favorites" */
export type Favorites_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Favorites_Stddev_Samp_Fields = {
  __typename?: 'favorites_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "favorites" */
export type Favorites_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "favorites" */
export type Favorites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Favorites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Favorites_Stream_Cursor_Value_Input = {
  favorited_project_id?: InputMaybe<Scalars['String']['input']>;
  favorited_token_id?: InputMaybe<Scalars['String']['input']>;
  favorited_user_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_public_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Favorites_Sum_Fields = {
  __typename?: 'favorites_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "favorites" */
export type Favorites_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "favorites" */
export enum Favorites_Update_Column {
  /** column name */
  FavoritedProjectId = 'favorited_project_id',
  /** column name */
  FavoritedTokenId = 'favorited_token_id',
  /** column name */
  FavoritedUserAddress = 'favorited_user_address',
  /** column name */
  Id = 'id',
  /** column name */
  UserPublicAddress = 'user_public_address'
}

export type Favorites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Favorites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Favorites_Set_Input>;
  /** filter the rows which have to be updated */
  where: Favorites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Favorites_Var_Pop_Fields = {
  __typename?: 'favorites_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "favorites" */
export type Favorites_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Favorites_Var_Samp_Fields = {
  __typename?: 'favorites_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "favorites" */
export type Favorites_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Favorites_Variance_Fields = {
  __typename?: 'favorites_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "favorites" */
export type Favorites_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "feature_flags" */
export type Feature_Flags = {
  __typename?: 'feature_flags';
  address_allowlist?: Maybe<Scalars['String']['output']>;
  flag_name: Scalars['String']['output'];
  globally_enabled: Scalars['Boolean']['output'];
};

/** aggregated selection of "feature_flags" */
export type Feature_Flags_Aggregate = {
  __typename?: 'feature_flags_aggregate';
  aggregate?: Maybe<Feature_Flags_Aggregate_Fields>;
  nodes: Array<Feature_Flags>;
};

/** aggregate fields of "feature_flags" */
export type Feature_Flags_Aggregate_Fields = {
  __typename?: 'feature_flags_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Feature_Flags_Max_Fields>;
  min?: Maybe<Feature_Flags_Min_Fields>;
};


/** aggregate fields of "feature_flags" */
export type Feature_Flags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "feature_flags". All fields are combined with a logical 'AND'. */
export type Feature_Flags_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Flags_Bool_Exp>>;
  _not?: InputMaybe<Feature_Flags_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Flags_Bool_Exp>>;
  address_allowlist?: InputMaybe<String_Comparison_Exp>;
  flag_name?: InputMaybe<String_Comparison_Exp>;
  globally_enabled?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_flags" */
export enum Feature_Flags_Constraint {
  /** unique or primary key constraint on columns "flag_name" */
  FeatureFlagsPkey = 'feature_flags_pkey'
}

/** input type for inserting data into table "feature_flags" */
export type Feature_Flags_Insert_Input = {
  address_allowlist?: InputMaybe<Scalars['String']['input']>;
  flag_name?: InputMaybe<Scalars['String']['input']>;
  globally_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Feature_Flags_Max_Fields = {
  __typename?: 'feature_flags_max_fields';
  address_allowlist?: Maybe<Scalars['String']['output']>;
  flag_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Feature_Flags_Min_Fields = {
  __typename?: 'feature_flags_min_fields';
  address_allowlist?: Maybe<Scalars['String']['output']>;
  flag_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "feature_flags" */
export type Feature_Flags_Mutation_Response = {
  __typename?: 'feature_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Flags>;
};

/** on_conflict condition type for table "feature_flags" */
export type Feature_Flags_On_Conflict = {
  constraint: Feature_Flags_Constraint;
  update_columns?: Array<Feature_Flags_Update_Column>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_flags". */
export type Feature_Flags_Order_By = {
  address_allowlist?: InputMaybe<Order_By>;
  flag_name?: InputMaybe<Order_By>;
  globally_enabled?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_flags */
export type Feature_Flags_Pk_Columns_Input = {
  flag_name: Scalars['String']['input'];
};

/** select columns of table "feature_flags" */
export enum Feature_Flags_Select_Column {
  /** column name */
  AddressAllowlist = 'address_allowlist',
  /** column name */
  FlagName = 'flag_name',
  /** column name */
  GloballyEnabled = 'globally_enabled'
}

/** input type for updating data in table "feature_flags" */
export type Feature_Flags_Set_Input = {
  address_allowlist?: InputMaybe<Scalars['String']['input']>;
  flag_name?: InputMaybe<Scalars['String']['input']>;
  globally_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "feature_flags" */
export type Feature_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Flags_Stream_Cursor_Value_Input = {
  address_allowlist?: InputMaybe<Scalars['String']['input']>;
  flag_name?: InputMaybe<Scalars['String']['input']>;
  globally_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "feature_flags" */
export enum Feature_Flags_Update_Column {
  /** column name */
  AddressAllowlist = 'address_allowlist',
  /** column name */
  FlagName = 'flag_name',
  /** column name */
  GloballyEnabled = 'globally_enabled'
}

export type Feature_Flags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Flags_Bool_Exp;
};

export type Featured_Token_Projects_Metadata_Args = {
  seed?: InputMaybe<Scalars['float8']['input']>;
};

export type Filter_Tokens_Metadata_By_Features_Args = {
  path?: InputMaybe<Scalars['jsonpath']['input']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export type List_Projects_Metadata_Random_Args = {
  seed?: InputMaybe<Scalars['seed_float']['input']>;
};

/** This table details the rendered image files, and all other media assets, for Art Blocks and all Engine partners. */
export type Media = {
  __typename?: 'media';
  bucket_name: Scalars['String']['output'];
  /** A computed field, executes function "media_extension" */
  extension?: Maybe<Scalars['String']['output']>;
  file_path: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "media_url" */
  url?: Maybe<Scalars['String']['output']>;
};


/** This table details the rendered image files, and all other media assets, for Art Blocks and all Engine partners. */
export type MediaMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "media" */
export type Media_Aggregate = {
  __typename?: 'media_aggregate';
  aggregate?: Maybe<Media_Aggregate_Fields>;
  nodes: Array<Media>;
};

/** aggregate fields of "media" */
export type Media_Aggregate_Fields = {
  __typename?: 'media_aggregate_fields';
  avg?: Maybe<Media_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Media_Max_Fields>;
  min?: Maybe<Media_Min_Fields>;
  stddev?: Maybe<Media_Stddev_Fields>;
  stddev_pop?: Maybe<Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Media_Stddev_Samp_Fields>;
  sum?: Maybe<Media_Sum_Fields>;
  var_pop?: Maybe<Media_Var_Pop_Fields>;
  var_samp?: Maybe<Media_Var_Samp_Fields>;
  variance?: Maybe<Media_Variance_Fields>;
};


/** aggregate fields of "media" */
export type Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Media_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Media_Avg_Fields = {
  __typename?: 'media_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "media". All fields are combined with a logical 'AND'. */
export type Media_Bool_Exp = {
  _and?: InputMaybe<Array<Media_Bool_Exp>>;
  _not?: InputMaybe<Media_Bool_Exp>;
  _or?: InputMaybe<Array<Media_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  file_path?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  owner_id?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "media" */
export enum Media_Constraint {
  /** unique or primary key constraint on columns "bucket_name", "file_path" */
  MediaBucketNameFilePathKey = 'media_bucket_name_file_path_key',
  /** unique or primary key constraint on columns "id" */
  MediaPkey = 'media_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Media_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Media_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Media_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "media" */
export type Media_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "media" */
export type Media_Insert_Input = {
  bucket_name?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Media_Max_Fields = {
  __typename?: 'media_max_fields';
  bucket_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "media_extension" */
  extension?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "media_url" */
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Media_Min_Fields = {
  __typename?: 'media_min_fields';
  bucket_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "media_extension" */
  extension?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "media_url" */
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "media" */
export type Media_Mutation_Response = {
  __typename?: 'media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Media>;
};

/** input type for inserting object relation for remote table "media" */
export type Media_Obj_Rel_Insert_Input = {
  data: Media_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Media_On_Conflict>;
};

/** on_conflict condition type for table "media" */
export type Media_On_Conflict = {
  constraint: Media_Constraint;
  update_columns?: Array<Media_Update_Column>;
  where?: InputMaybe<Media_Bool_Exp>;
};

/** Ordering options when selecting data from "media". */
export type Media_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  file_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: media */
export type Media_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Media_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "media" */
export enum Media_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FilePath = 'file_path',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OwnerId = 'owner_id'
}

/** input type for updating data in table "media" */
export type Media_Set_Input = {
  bucket_name?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Media_Stddev_Fields = {
  __typename?: 'media_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Media_Stddev_Pop_Fields = {
  __typename?: 'media_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Media_Stddev_Samp_Fields = {
  __typename?: 'media_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "media" */
export type Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Media_Stream_Cursor_Value_Input = {
  bucket_name?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Media_Sum_Fields = {
  __typename?: 'media_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "media" */
export enum Media_Update_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FilePath = 'file_path',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OwnerId = 'owner_id'
}

export type Media_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Media_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Media_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Media_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Media_Set_Input>;
  /** filter the rows which have to be updated */
  where: Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Media_Var_Pop_Fields = {
  __typename?: 'media_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Media_Var_Samp_Fields = {
  __typename?: 'media_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Media_Variance_Fields = {
  __typename?: 'media_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Enumeration of minter filter types */
export type Minter_Filter_Type_Names = {
  __typename?: 'minter_filter_type_names';
  name: Scalars['String']['output'];
};

/** aggregated selection of "minter_filter_type_names" */
export type Minter_Filter_Type_Names_Aggregate = {
  __typename?: 'minter_filter_type_names_aggregate';
  aggregate?: Maybe<Minter_Filter_Type_Names_Aggregate_Fields>;
  nodes: Array<Minter_Filter_Type_Names>;
};

/** aggregate fields of "minter_filter_type_names" */
export type Minter_Filter_Type_Names_Aggregate_Fields = {
  __typename?: 'minter_filter_type_names_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Minter_Filter_Type_Names_Max_Fields>;
  min?: Maybe<Minter_Filter_Type_Names_Min_Fields>;
};


/** aggregate fields of "minter_filter_type_names" */
export type Minter_Filter_Type_Names_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Minter_Filter_Type_Names_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "minter_filter_type_names". All fields are combined with a logical 'AND'. */
export type Minter_Filter_Type_Names_Bool_Exp = {
  _and?: InputMaybe<Array<Minter_Filter_Type_Names_Bool_Exp>>;
  _not?: InputMaybe<Minter_Filter_Type_Names_Bool_Exp>;
  _or?: InputMaybe<Array<Minter_Filter_Type_Names_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "minter_filter_type_names" */
export enum Minter_Filter_Type_Names_Constraint {
  /** unique or primary key constraint on columns "name" */
  MinterFilterTypeNamesPkey = 'minter_filter_type_names_pkey'
}

export enum Minter_Filter_Type_Names_Enum {
  MinterFilterV0 = 'MinterFilterV0',
  MinterFilterV1 = 'MinterFilterV1',
  MinterFilterV2 = 'MinterFilterV2',
  Unknown = 'UNKNOWN'
}

/** Boolean expression to compare columns of type "minter_filter_type_names_enum". All fields are combined with logical 'AND'. */
export type Minter_Filter_Type_Names_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Minter_Filter_Type_Names_Enum>;
  _in?: InputMaybe<Array<Minter_Filter_Type_Names_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Minter_Filter_Type_Names_Enum>;
  _nin?: InputMaybe<Array<Minter_Filter_Type_Names_Enum>>;
};

/** input type for inserting data into table "minter_filter_type_names" */
export type Minter_Filter_Type_Names_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Minter_Filter_Type_Names_Max_Fields = {
  __typename?: 'minter_filter_type_names_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Minter_Filter_Type_Names_Min_Fields = {
  __typename?: 'minter_filter_type_names_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "minter_filter_type_names" */
export type Minter_Filter_Type_Names_Mutation_Response = {
  __typename?: 'minter_filter_type_names_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Minter_Filter_Type_Names>;
};

/** on_conflict condition type for table "minter_filter_type_names" */
export type Minter_Filter_Type_Names_On_Conflict = {
  constraint: Minter_Filter_Type_Names_Constraint;
  update_columns?: Array<Minter_Filter_Type_Names_Update_Column>;
  where?: InputMaybe<Minter_Filter_Type_Names_Bool_Exp>;
};

/** Ordering options when selecting data from "minter_filter_type_names". */
export type Minter_Filter_Type_Names_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: minter_filter_type_names */
export type Minter_Filter_Type_Names_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "minter_filter_type_names" */
export enum Minter_Filter_Type_Names_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "minter_filter_type_names" */
export type Minter_Filter_Type_Names_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "minter_filter_type_names" */
export type Minter_Filter_Type_Names_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Minter_Filter_Type_Names_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Minter_Filter_Type_Names_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "minter_filter_type_names" */
export enum Minter_Filter_Type_Names_Update_Column {
  /** column name */
  Name = 'name'
}

export type Minter_Filter_Type_Names_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Minter_Filter_Type_Names_Set_Input>;
  /** filter the rows which have to be updated */
  where: Minter_Filter_Type_Names_Bool_Exp;
};

/** Newly-deployed minters (ie. Set Price minter, Dutch Auction with Settlement minter, etc) must be approved by the Art Blocks minter-filter contract before they may be included for purchasing on an artist’s project. This table tracks a minter-filter’s approved contracts. */
export type Minter_Filters_Metadata = {
  __typename?: 'minter_filters_metadata';
  address: Scalars['String']['output'];
  /** An object relationship */
  core_registry?: Maybe<Core_Registries_Metadata>;
  core_registry_address?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "select_minterfilter_allowed_minters" */
  globally_allowed_minters?: Maybe<Array<Minters_Metadata>>;
  /** An array relationship */
  known_minters: Array<Minters_Metadata>;
  /** An aggregate relationship */
  known_minters_aggregate: Minters_Metadata_Aggregate;
  type?: Maybe<Minter_Filter_Type_Names_Enum>;
};


/** Newly-deployed minters (ie. Set Price minter, Dutch Auction with Settlement minter, etc) must be approved by the Art Blocks minter-filter contract before they may be included for purchasing on an artist’s project. This table tracks a minter-filter’s approved contracts. */
export type Minter_Filters_MetadataGlobally_Allowed_MintersArgs = {
  distinct_on?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minters_Metadata_Order_By>>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};


/** Newly-deployed minters (ie. Set Price minter, Dutch Auction with Settlement minter, etc) must be approved by the Art Blocks minter-filter contract before they may be included for purchasing on an artist’s project. This table tracks a minter-filter’s approved contracts. */
export type Minter_Filters_MetadataKnown_MintersArgs = {
  distinct_on?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minters_Metadata_Order_By>>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};


/** Newly-deployed minters (ie. Set Price minter, Dutch Auction with Settlement minter, etc) must be approved by the Art Blocks minter-filter contract before they may be included for purchasing on an artist’s project. This table tracks a minter-filter’s approved contracts. */
export type Minter_Filters_MetadataKnown_Minters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minters_Metadata_Order_By>>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};

/** aggregated selection of "minter_filters_metadata" */
export type Minter_Filters_Metadata_Aggregate = {
  __typename?: 'minter_filters_metadata_aggregate';
  aggregate?: Maybe<Minter_Filters_Metadata_Aggregate_Fields>;
  nodes: Array<Minter_Filters_Metadata>;
};

export type Minter_Filters_Metadata_Aggregate_Bool_Exp = {
  count?: InputMaybe<Minter_Filters_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Minter_Filters_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Minter_Filters_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "minter_filters_metadata" */
export type Minter_Filters_Metadata_Aggregate_Fields = {
  __typename?: 'minter_filters_metadata_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Minter_Filters_Metadata_Max_Fields>;
  min?: Maybe<Minter_Filters_Metadata_Min_Fields>;
};


/** aggregate fields of "minter_filters_metadata" */
export type Minter_Filters_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Minter_Filters_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Minter_Filters_Metadata_Max_Order_By>;
  min?: InputMaybe<Minter_Filters_Metadata_Min_Order_By>;
};

/** input type for inserting array relation for remote table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Minter_Filters_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Minter_Filters_Metadata_On_Conflict>;
};

/** Boolean expression to filter rows from the table "minter_filters_metadata". All fields are combined with a logical 'AND'. */
export type Minter_Filters_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Minter_Filters_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Minter_Filters_Metadata_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
  core_registry_address?: InputMaybe<String_Comparison_Exp>;
  globally_allowed_minters?: InputMaybe<Minters_Metadata_Bool_Exp>;
  known_minters?: InputMaybe<Minters_Metadata_Bool_Exp>;
  known_minters_aggregate?: InputMaybe<Minters_Metadata_Aggregate_Bool_Exp>;
  type?: InputMaybe<Minter_Filter_Type_Names_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "minter_filters_metadata" */
export enum Minter_Filters_Metadata_Constraint {
  /** unique or primary key constraint on columns "address" */
  MinterFiltersMetadataPkey = 'minter_filters_metadata_pkey'
}

/** input type for inserting data into table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Obj_Rel_Insert_Input>;
  core_registry_address?: InputMaybe<Scalars['String']['input']>;
  known_minters?: InputMaybe<Minters_Metadata_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Minter_Filter_Type_Names_Enum>;
};

/** aggregate max on columns */
export type Minter_Filters_Metadata_Max_Fields = {
  __typename?: 'minter_filters_metadata_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  core_registry_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  core_registry_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Minter_Filters_Metadata_Min_Fields = {
  __typename?: 'minter_filters_metadata_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  core_registry_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  core_registry_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Mutation_Response = {
  __typename?: 'minter_filters_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Minter_Filters_Metadata>;
};

/** input type for inserting object relation for remote table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Obj_Rel_Insert_Input = {
  data: Minter_Filters_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Minter_Filters_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "minter_filters_metadata" */
export type Minter_Filters_Metadata_On_Conflict = {
  constraint: Minter_Filters_Metadata_Constraint;
  update_columns?: Array<Minter_Filters_Metadata_Update_Column>;
  where?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "minter_filters_metadata". */
export type Minter_Filters_Metadata_Order_By = {
  address?: InputMaybe<Order_By>;
  core_registry?: InputMaybe<Core_Registries_Metadata_Order_By>;
  core_registry_address?: InputMaybe<Order_By>;
  globally_allowed_minters_aggregate?: InputMaybe<Minters_Metadata_Aggregate_Order_By>;
  known_minters_aggregate?: InputMaybe<Minters_Metadata_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: minter_filters_metadata */
export type Minter_Filters_Metadata_Pk_Columns_Input = {
  address: Scalars['String']['input'];
};

/** select columns of table "minter_filters_metadata" */
export enum Minter_Filters_Metadata_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CoreRegistryAddress = 'core_registry_address',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_registry_address?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Minter_Filter_Type_Names_Enum>;
};

/** Streaming cursor of the table "minter_filters_metadata" */
export type Minter_Filters_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Minter_Filters_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Minter_Filters_Metadata_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_registry_address?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Minter_Filter_Type_Names_Enum>;
};

/** update columns of table "minter_filters_metadata" */
export enum Minter_Filters_Metadata_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CoreRegistryAddress = 'core_registry_address',
  /** column name */
  Type = 'type'
}

export type Minter_Filters_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Minter_Filters_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Minter_Filters_Metadata_Bool_Exp;
};

/** columns and relationships of "minter_type_names" */
export type Minter_Type_Names = {
  __typename?: 'minter_type_names';
  name: Scalars['String']['output'];
};

/** aggregated selection of "minter_type_names" */
export type Minter_Type_Names_Aggregate = {
  __typename?: 'minter_type_names_aggregate';
  aggregate?: Maybe<Minter_Type_Names_Aggregate_Fields>;
  nodes: Array<Minter_Type_Names>;
};

/** aggregate fields of "minter_type_names" */
export type Minter_Type_Names_Aggregate_Fields = {
  __typename?: 'minter_type_names_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Minter_Type_Names_Max_Fields>;
  min?: Maybe<Minter_Type_Names_Min_Fields>;
};


/** aggregate fields of "minter_type_names" */
export type Minter_Type_Names_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Minter_Type_Names_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "minter_type_names". All fields are combined with a logical 'AND'. */
export type Minter_Type_Names_Bool_Exp = {
  _and?: InputMaybe<Array<Minter_Type_Names_Bool_Exp>>;
  _not?: InputMaybe<Minter_Type_Names_Bool_Exp>;
  _or?: InputMaybe<Array<Minter_Type_Names_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "minter_type_names" */
export enum Minter_Type_Names_Constraint {
  /** unique or primary key constraint on columns "name" */
  MinterTypeNamesPkey = 'minter_type_names_pkey'
}

export enum Minter_Type_Names_Enum {
  MinterDaExpHolderV5 = 'MinterDAExpHolderV5',
  MinterDaExpSettlementV0 = 'MinterDAExpSettlementV0',
  MinterDaExpSettlementV1 = 'MinterDAExpSettlementV1',
  MinterDaExpSettlementV2 = 'MinterDAExpSettlementV2',
  MinterDaExpSettlementV3 = 'MinterDAExpSettlementV3',
  MinterDaExpV0 = 'MinterDAExpV0',
  MinterDaExpV1 = 'MinterDAExpV1',
  MinterDaExpV2 = 'MinterDAExpV2',
  MinterDaExpV4 = 'MinterDAExpV4',
  MinterDaExpV5 = 'MinterDAExpV5',
  MinterDaLinHolderV5 = 'MinterDALinHolderV5',
  MinterDaLinV0 = 'MinterDALinV0',
  MinterDaLinV1 = 'MinterDALinV1',
  MinterDaLinV2 = 'MinterDALinV2',
  MinterDaLinV4 = 'MinterDALinV4',
  MinterDaLinV5 = 'MinterDALinV5',
  MinterHolderV0 = 'MinterHolderV0',
  MinterHolderV1 = 'MinterHolderV1',
  MinterHolderV2 = 'MinterHolderV2',
  MinterHolderV4 = 'MinterHolderV4',
  MinterMerkleV0 = 'MinterMerkleV0',
  MinterMerkleV1 = 'MinterMerkleV1',
  MinterMerkleV2 = 'MinterMerkleV2',
  MinterMerkleV3 = 'MinterMerkleV3',
  MinterMerkleV5 = 'MinterMerkleV5',
  MinterMinPriceMerkleV0 = 'MinterMinPriceMerkleV0',
  MinterMinPriceV0 = 'MinterMinPriceV0',
  MinterPolyptychV0 = 'MinterPolyptychV0',
  MinterRamv0 = 'MinterRAMV0',
  MinterSeav0 = 'MinterSEAV0',
  MinterSeav1 = 'MinterSEAV1',
  MinterSetPriceErc20V0 = 'MinterSetPriceERC20V0',
  MinterSetPriceErc20V1 = 'MinterSetPriceERC20V1',
  MinterSetPriceErc20V2 = 'MinterSetPriceERC20V2',
  MinterSetPriceErc20V4 = 'MinterSetPriceERC20V4',
  MinterSetPriceErc20V5 = 'MinterSetPriceERC20V5',
  MinterSetPriceHolderV5 = 'MinterSetPriceHolderV5',
  MinterSetPriceMerkleV5 = 'MinterSetPriceMerkleV5',
  MinterSetPricePolyptychErc20V5 = 'MinterSetPricePolyptychERC20V5',
  MinterSetPricePolyptychV5 = 'MinterSetPricePolyptychV5',
  MinterSetPriceV0 = 'MinterSetPriceV0',
  MinterSetPriceV1 = 'MinterSetPriceV1',
  MinterSetPriceV2 = 'MinterSetPriceV2',
  MinterSetPriceV4 = 'MinterSetPriceV4',
  MinterSetPriceV5 = 'MinterSetPriceV5'
}

/** Boolean expression to compare columns of type "minter_type_names_enum". All fields are combined with logical 'AND'. */
export type Minter_Type_Names_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Minter_Type_Names_Enum>;
  _in?: InputMaybe<Array<Minter_Type_Names_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Minter_Type_Names_Enum>;
  _nin?: InputMaybe<Array<Minter_Type_Names_Enum>>;
};

/** input type for inserting data into table "minter_type_names" */
export type Minter_Type_Names_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Minter_Type_Names_Max_Fields = {
  __typename?: 'minter_type_names_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Minter_Type_Names_Min_Fields = {
  __typename?: 'minter_type_names_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "minter_type_names" */
export type Minter_Type_Names_Mutation_Response = {
  __typename?: 'minter_type_names_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Minter_Type_Names>;
};

/** on_conflict condition type for table "minter_type_names" */
export type Minter_Type_Names_On_Conflict = {
  constraint: Minter_Type_Names_Constraint;
  update_columns?: Array<Minter_Type_Names_Update_Column>;
  where?: InputMaybe<Minter_Type_Names_Bool_Exp>;
};

/** Ordering options when selecting data from "minter_type_names". */
export type Minter_Type_Names_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: minter_type_names */
export type Minter_Type_Names_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "minter_type_names" */
export enum Minter_Type_Names_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "minter_type_names" */
export type Minter_Type_Names_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "minter_type_names" */
export type Minter_Type_Names_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Minter_Type_Names_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Minter_Type_Names_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "minter_type_names" */
export enum Minter_Type_Names_Update_Column {
  /** column name */
  Name = 'name'
}

export type Minter_Type_Names_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Minter_Type_Names_Set_Input>;
  /** filter the rows which have to be updated */
  where: Minter_Type_Names_Bool_Exp;
};

/** Minters are versioned within this table, and the metadata (ie. labels & descriptions) describing the functionality/features of a particular minter version are listed here. Data is updated after the AB team deploys a new generic minter type to the blockchain and public subgraph. */
export type Minter_Types = {
  __typename?: 'minter_types';
  active: Scalars['Boolean']['output'];
  description_template: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  project_configuration_schema: Scalars['jsonb']['output'];
  type: Minter_Type_Names_Enum;
  /** A computed field, executes function "minter_type_unversioned" */
  unversioned_type?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};


/** Minters are versioned within this table, and the metadata (ie. labels & descriptions) describing the functionality/features of a particular minter version are listed here. Data is updated after the AB team deploys a new generic minter type to the blockchain and public subgraph. */
export type Minter_TypesProject_Configuration_SchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "minter_types" */
export type Minter_Types_Aggregate = {
  __typename?: 'minter_types_aggregate';
  aggregate?: Maybe<Minter_Types_Aggregate_Fields>;
  nodes: Array<Minter_Types>;
};

/** aggregate fields of "minter_types" */
export type Minter_Types_Aggregate_Fields = {
  __typename?: 'minter_types_aggregate_fields';
  avg?: Maybe<Minter_Types_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Minter_Types_Max_Fields>;
  min?: Maybe<Minter_Types_Min_Fields>;
  stddev?: Maybe<Minter_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Minter_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Minter_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Minter_Types_Sum_Fields>;
  var_pop?: Maybe<Minter_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Minter_Types_Var_Samp_Fields>;
  variance?: Maybe<Minter_Types_Variance_Fields>;
};


/** aggregate fields of "minter_types" */
export type Minter_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Minter_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Minter_Types_Append_Input = {
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Minter_Types_Avg_Fields = {
  __typename?: 'minter_types_avg_fields';
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "minter_types". All fields are combined with a logical 'AND'. */
export type Minter_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Minter_Types_Bool_Exp>>;
  _not?: InputMaybe<Minter_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Minter_Types_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  description_template?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  project_configuration_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<Minter_Type_Names_Enum_Comparison_Exp>;
  unversioned_type?: InputMaybe<String_Comparison_Exp>;
  version_number?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "minter_types" */
export enum Minter_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  MinterTypesPkey = 'minter_types_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Minter_Types_Delete_At_Path_Input = {
  project_configuration_schema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Minter_Types_Delete_Elem_Input = {
  project_configuration_schema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Minter_Types_Delete_Key_Input = {
  project_configuration_schema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "minter_types" */
export type Minter_Types_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description_template?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Minter_Type_Names_Enum>;
};

/** aggregate max on columns */
export type Minter_Types_Max_Fields = {
  __typename?: 'minter_types_max_fields';
  description_template?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "minter_type_unversioned" */
  unversioned_type?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Minter_Types_Min_Fields = {
  __typename?: 'minter_types_min_fields';
  description_template?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "minter_type_unversioned" */
  unversioned_type?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "minter_types" */
export type Minter_Types_Mutation_Response = {
  __typename?: 'minter_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Minter_Types>;
};

/** input type for inserting object relation for remote table "minter_types" */
export type Minter_Types_Obj_Rel_Insert_Input = {
  data: Minter_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Minter_Types_On_Conflict>;
};

/** on_conflict condition type for table "minter_types" */
export type Minter_Types_On_Conflict = {
  constraint: Minter_Types_Constraint;
  update_columns?: Array<Minter_Types_Update_Column>;
  where?: InputMaybe<Minter_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "minter_types". */
export type Minter_Types_Order_By = {
  active?: InputMaybe<Order_By>;
  description_template?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  project_configuration_schema?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unversioned_type?: InputMaybe<Order_By>;
  version_number?: InputMaybe<Order_By>;
};

/** primary key columns input for table: minter_types */
export type Minter_Types_Pk_Columns_Input = {
  type: Minter_Type_Names_Enum;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Minter_Types_Prepend_Input = {
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "minter_types" */
export enum Minter_Types_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  DescriptionTemplate = 'description_template',
  /** column name */
  Label = 'label',
  /** column name */
  ProjectConfigurationSchema = 'project_configuration_schema',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "minter_types" */
export type Minter_Types_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description_template?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Minter_Type_Names_Enum>;
};

/** aggregate stddev on columns */
export type Minter_Types_Stddev_Fields = {
  __typename?: 'minter_types_stddev_fields';
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** aggregate stddev_pop on columns */
export type Minter_Types_Stddev_Pop_Fields = {
  __typename?: 'minter_types_stddev_pop_fields';
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** aggregate stddev_samp on columns */
export type Minter_Types_Stddev_Samp_Fields = {
  __typename?: 'minter_types_stddev_samp_fields';
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** Streaming cursor of the table "minter_types" */
export type Minter_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Minter_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Minter_Types_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description_template?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  project_configuration_schema?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Minter_Type_Names_Enum>;
};

/** aggregate sum on columns */
export type Minter_Types_Sum_Fields = {
  __typename?: 'minter_types_sum_fields';
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "minter_types" */
export enum Minter_Types_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  DescriptionTemplate = 'description_template',
  /** column name */
  Label = 'label',
  /** column name */
  ProjectConfigurationSchema = 'project_configuration_schema',
  /** column name */
  Type = 'type'
}

export type Minter_Types_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Minter_Types_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Minter_Types_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Minter_Types_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Minter_Types_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Minter_Types_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Minter_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Minter_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Minter_Types_Var_Pop_Fields = {
  __typename?: 'minter_types_var_pop_fields';
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_samp on columns */
export type Minter_Types_Var_Samp_Fields = {
  __typename?: 'minter_types_var_samp_fields';
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** aggregate variance on columns */
export type Minter_Types_Variance_Fields = {
  __typename?: 'minter_types_variance_fields';
  /** A computed field, executes function "minter_type_version_number" */
  version_number?: Maybe<Scalars['Int']['output']>;
};

/** This table details the auction and metadata pertaining to Art Blocks “minters” - or, the varieties of purchasing mechanics available for projects. Data is updated after the AB team deploys a new generic minter type to the blockchain and public subgraph. */
export type Minters_Metadata = {
  __typename?: 'minters_metadata';
  address: Scalars['String']['output'];
  extra_minter_details?: Maybe<Scalars['jsonb']['output']>;
  is_globally_allowlisted_on_minter_filter: Scalars['Boolean']['output'];
  /** An object relationship */
  minter_filter?: Maybe<Minter_Filters_Metadata>;
  minter_filter_address: Scalars['String']['output'];
  minter_type: Minter_Type_Names_Enum;
  /** An array relationship */
  receipts: Array<Receipt_Metadata>;
  /** An aggregate relationship */
  receipts_aggregate: Receipt_Metadata_Aggregate;
  /** An object relationship */
  type?: Maybe<Minter_Types>;
};


/** This table details the auction and metadata pertaining to Art Blocks “minters” - or, the varieties of purchasing mechanics available for projects. Data is updated after the AB team deploys a new generic minter type to the blockchain and public subgraph. */
export type Minters_MetadataExtra_Minter_DetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** This table details the auction and metadata pertaining to Art Blocks “minters” - or, the varieties of purchasing mechanics available for projects. Data is updated after the AB team deploys a new generic minter type to the blockchain and public subgraph. */
export type Minters_MetadataReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


/** This table details the auction and metadata pertaining to Art Blocks “minters” - or, the varieties of purchasing mechanics available for projects. Data is updated after the AB team deploys a new generic minter type to the blockchain and public subgraph. */
export type Minters_MetadataReceipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};

/** aggregated selection of "minters_metadata" */
export type Minters_Metadata_Aggregate = {
  __typename?: 'minters_metadata_aggregate';
  aggregate?: Maybe<Minters_Metadata_Aggregate_Fields>;
  nodes: Array<Minters_Metadata>;
};

export type Minters_Metadata_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Minters_Metadata_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Minters_Metadata_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Minters_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Minters_Metadata_Aggregate_Bool_Exp_Bool_And = {
  arguments: Minters_Metadata_Select_Column_Minters_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Minters_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Minters_Metadata_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Minters_Metadata_Select_Column_Minters_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Minters_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Minters_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Minters_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "minters_metadata" */
export type Minters_Metadata_Aggregate_Fields = {
  __typename?: 'minters_metadata_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Minters_Metadata_Max_Fields>;
  min?: Maybe<Minters_Metadata_Min_Fields>;
};


/** aggregate fields of "minters_metadata" */
export type Minters_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "minters_metadata" */
export type Minters_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Minters_Metadata_Max_Order_By>;
  min?: InputMaybe<Minters_Metadata_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Minters_Metadata_Append_Input = {
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "minters_metadata" */
export type Minters_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Minters_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Minters_Metadata_On_Conflict>;
};

/** Boolean expression to filter rows from the table "minters_metadata". All fields are combined with a logical 'AND'. */
export type Minters_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Minters_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Minters_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Minters_Metadata_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  extra_minter_details?: InputMaybe<Jsonb_Comparison_Exp>;
  is_globally_allowlisted_on_minter_filter?: InputMaybe<Boolean_Comparison_Exp>;
  minter_filter?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
  minter_filter_address?: InputMaybe<String_Comparison_Exp>;
  minter_type?: InputMaybe<Minter_Type_Names_Enum_Comparison_Exp>;
  receipts?: InputMaybe<Receipt_Metadata_Bool_Exp>;
  receipts_aggregate?: InputMaybe<Receipt_Metadata_Aggregate_Bool_Exp>;
  type?: InputMaybe<Minter_Types_Bool_Exp>;
};

/** unique or primary key constraints on table "minters_metadata" */
export enum Minters_Metadata_Constraint {
  /** unique or primary key constraint on columns "address" */
  MintersMetadataPkey = 'minters_metadata_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Minters_Metadata_Delete_At_Path_Input = {
  extra_minter_details?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Minters_Metadata_Delete_Elem_Input = {
  extra_minter_details?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Minters_Metadata_Delete_Key_Input = {
  extra_minter_details?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "minters_metadata" */
export type Minters_Metadata_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  is_globally_allowlisted_on_minter_filter?: InputMaybe<Scalars['Boolean']['input']>;
  minter_filter?: InputMaybe<Minter_Filters_Metadata_Obj_Rel_Insert_Input>;
  minter_filter_address?: InputMaybe<Scalars['String']['input']>;
  minter_type?: InputMaybe<Minter_Type_Names_Enum>;
  receipts?: InputMaybe<Receipt_Metadata_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Minter_Types_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Minters_Metadata_Max_Fields = {
  __typename?: 'minters_metadata_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  minter_filter_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "minters_metadata" */
export type Minters_Metadata_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  minter_filter_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Minters_Metadata_Min_Fields = {
  __typename?: 'minters_metadata_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  minter_filter_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "minters_metadata" */
export type Minters_Metadata_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  minter_filter_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "minters_metadata" */
export type Minters_Metadata_Mutation_Response = {
  __typename?: 'minters_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Minters_Metadata>;
};

/** input type for inserting object relation for remote table "minters_metadata" */
export type Minters_Metadata_Obj_Rel_Insert_Input = {
  data: Minters_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Minters_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "minters_metadata" */
export type Minters_Metadata_On_Conflict = {
  constraint: Minters_Metadata_Constraint;
  update_columns?: Array<Minters_Metadata_Update_Column>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "minters_metadata". */
export type Minters_Metadata_Order_By = {
  address?: InputMaybe<Order_By>;
  extra_minter_details?: InputMaybe<Order_By>;
  is_globally_allowlisted_on_minter_filter?: InputMaybe<Order_By>;
  minter_filter?: InputMaybe<Minter_Filters_Metadata_Order_By>;
  minter_filter_address?: InputMaybe<Order_By>;
  minter_type?: InputMaybe<Order_By>;
  receipts_aggregate?: InputMaybe<Receipt_Metadata_Aggregate_Order_By>;
  type?: InputMaybe<Minter_Types_Order_By>;
};

/** primary key columns input for table: minters_metadata */
export type Minters_Metadata_Pk_Columns_Input = {
  address: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Minters_Metadata_Prepend_Input = {
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "minters_metadata" */
export enum Minters_Metadata_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ExtraMinterDetails = 'extra_minter_details',
  /** column name */
  IsGloballyAllowlistedOnMinterFilter = 'is_globally_allowlisted_on_minter_filter',
  /** column name */
  MinterFilterAddress = 'minter_filter_address',
  /** column name */
  MinterType = 'minter_type'
}

/** select "minters_metadata_aggregate_bool_exp_bool_and_arguments_columns" columns of table "minters_metadata" */
export enum Minters_Metadata_Select_Column_Minters_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsGloballyAllowlistedOnMinterFilter = 'is_globally_allowlisted_on_minter_filter'
}

/** select "minters_metadata_aggregate_bool_exp_bool_or_arguments_columns" columns of table "minters_metadata" */
export enum Minters_Metadata_Select_Column_Minters_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsGloballyAllowlistedOnMinterFilter = 'is_globally_allowlisted_on_minter_filter'
}

/** input type for updating data in table "minters_metadata" */
export type Minters_Metadata_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  is_globally_allowlisted_on_minter_filter?: InputMaybe<Scalars['Boolean']['input']>;
  minter_filter_address?: InputMaybe<Scalars['String']['input']>;
  minter_type?: InputMaybe<Minter_Type_Names_Enum>;
};

/** Streaming cursor of the table "minters_metadata" */
export type Minters_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Minters_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Minters_Metadata_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  is_globally_allowlisted_on_minter_filter?: InputMaybe<Scalars['Boolean']['input']>;
  minter_filter_address?: InputMaybe<Scalars['String']['input']>;
  minter_type?: InputMaybe<Minter_Type_Names_Enum>;
};

/** update columns of table "minters_metadata" */
export enum Minters_Metadata_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ExtraMinterDetails = 'extra_minter_details',
  /** column name */
  IsGloballyAllowlistedOnMinterFilter = 'is_globally_allowlisted_on_minter_filter',
  /** column name */
  MinterFilterAddress = 'minter_filter_address',
  /** column name */
  MinterType = 'minter_type'
}

export type Minters_Metadata_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Minters_Metadata_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Minters_Metadata_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Minters_Metadata_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Minters_Metadata_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Minters_Metadata_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Minters_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Minters_Metadata_Bool_Exp;
};

/** Mapping of Mixpanel distinct ids to hashed wallet addresses (highly sensitive, only for use by data team) */
export type Mixpanel_Lookup = {
  __typename?: 'mixpanel_lookup';
  hash: Scalars['String']['output'];
  mixpanel_id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "mixpanel_lookup" */
export type Mixpanel_Lookup_Aggregate = {
  __typename?: 'mixpanel_lookup_aggregate';
  aggregate?: Maybe<Mixpanel_Lookup_Aggregate_Fields>;
  nodes: Array<Mixpanel_Lookup>;
};

/** aggregate fields of "mixpanel_lookup" */
export type Mixpanel_Lookup_Aggregate_Fields = {
  __typename?: 'mixpanel_lookup_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Mixpanel_Lookup_Max_Fields>;
  min?: Maybe<Mixpanel_Lookup_Min_Fields>;
};


/** aggregate fields of "mixpanel_lookup" */
export type Mixpanel_Lookup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mixpanel_Lookup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mixpanel_lookup". All fields are combined with a logical 'AND'. */
export type Mixpanel_Lookup_Bool_Exp = {
  _and?: InputMaybe<Array<Mixpanel_Lookup_Bool_Exp>>;
  _not?: InputMaybe<Mixpanel_Lookup_Bool_Exp>;
  _or?: InputMaybe<Array<Mixpanel_Lookup_Bool_Exp>>;
  hash?: InputMaybe<String_Comparison_Exp>;
  mixpanel_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mixpanel_lookup" */
export enum Mixpanel_Lookup_Constraint {
  /** unique or primary key constraint on columns "hash", "mixpanel_id" */
  MixpanelLookupPkey = 'mixpanel_lookup_pkey'
}

/** input type for inserting data into table "mixpanel_lookup" */
export type Mixpanel_Lookup_Insert_Input = {
  hash?: InputMaybe<Scalars['String']['input']>;
  mixpanel_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Mixpanel_Lookup_Max_Fields = {
  __typename?: 'mixpanel_lookup_max_fields';
  hash?: Maybe<Scalars['String']['output']>;
  mixpanel_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mixpanel_Lookup_Min_Fields = {
  __typename?: 'mixpanel_lookup_min_fields';
  hash?: Maybe<Scalars['String']['output']>;
  mixpanel_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "mixpanel_lookup" */
export type Mixpanel_Lookup_Mutation_Response = {
  __typename?: 'mixpanel_lookup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mixpanel_Lookup>;
};

/** on_conflict condition type for table "mixpanel_lookup" */
export type Mixpanel_Lookup_On_Conflict = {
  constraint: Mixpanel_Lookup_Constraint;
  update_columns?: Array<Mixpanel_Lookup_Update_Column>;
  where?: InputMaybe<Mixpanel_Lookup_Bool_Exp>;
};

/** Ordering options when selecting data from "mixpanel_lookup". */
export type Mixpanel_Lookup_Order_By = {
  hash?: InputMaybe<Order_By>;
  mixpanel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mixpanel_lookup */
export type Mixpanel_Lookup_Pk_Columns_Input = {
  hash: Scalars['String']['input'];
  mixpanel_id: Scalars['String']['input'];
};

/** select columns of table "mixpanel_lookup" */
export enum Mixpanel_Lookup_Select_Column {
  /** column name */
  Hash = 'hash',
  /** column name */
  MixpanelId = 'mixpanel_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mixpanel_lookup" */
export type Mixpanel_Lookup_Set_Input = {
  hash?: InputMaybe<Scalars['String']['input']>;
  mixpanel_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mixpanel_lookup" */
export type Mixpanel_Lookup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mixpanel_Lookup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mixpanel_Lookup_Stream_Cursor_Value_Input = {
  hash?: InputMaybe<Scalars['String']['input']>;
  mixpanel_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mixpanel_lookup" */
export enum Mixpanel_Lookup_Update_Column {
  /** column name */
  Hash = 'hash',
  /** column name */
  MixpanelId = 'mixpanel_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mixpanel_Lookup_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mixpanel_Lookup_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mixpanel_Lookup_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  authenticate?: Maybe<AuthenticateOutput>;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createApplication?: Maybe<CreateApplicationOutput>;
  createArticle?: Maybe<ArticleEntityResponse>;
  createArtistEditorialPage?: Maybe<ArtistEditorialPageEntityResponse>;
  createExhibition?: Maybe<ExhibitionEntityResponse>;
  createHighlight?: Maybe<HighlightEntityResponse>;
  createMinterInfo?: Maybe<MinterInfoEntityResponse>;
  createProjectPage?: Maybe<ProjectPageEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteArticle?: Maybe<ArticleEntityResponse>;
  deleteArtistEditorialPage?: Maybe<ArtistEditorialPageEntityResponse>;
  deleteCuratedHomePage?: Maybe<CuratedHomePageEntityResponse>;
  deleteExhibition?: Maybe<ExhibitionEntityResponse>;
  deleteHighlight?: Maybe<HighlightEntityResponse>;
  deleteHomePage?: Maybe<HomePageEntityResponse>;
  deleteLandingPage?: Maybe<LandingPageEntityResponse>;
  deleteMinterInfo?: Maybe<MinterInfoEntityResponse>;
  deleteProjectPage?: Maybe<ProjectPageEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** delete data from the table: "bid_types" */
  delete_bid_types?: Maybe<Bid_Types_Mutation_Response>;
  /** delete single row from the table: "bid_types" */
  delete_bid_types_by_pk?: Maybe<Bid_Types>;
  /** delete data from the table: "bids_metadata" */
  delete_bids_metadata?: Maybe<Bids_Metadata_Mutation_Response>;
  /** delete single row from the table: "bids_metadata" */
  delete_bids_metadata_by_pk?: Maybe<Bids_Metadata>;
  /** delete data from the table: "categories" */
  delete_categories?: Maybe<Categories_Mutation_Response>;
  /** delete single row from the table: "categories" */
  delete_categories_by_pk?: Maybe<Categories>;
  /** delete data from the table: "contract_allowlistings" */
  delete_contract_allowlistings?: Maybe<Contract_Allowlistings_Mutation_Response>;
  /** delete single row from the table: "contract_allowlistings" */
  delete_contract_allowlistings_by_pk?: Maybe<Contract_Allowlistings>;
  /** delete data from the table: "contract_type_names" */
  delete_contract_type_names?: Maybe<Contract_Type_Names_Mutation_Response>;
  /** delete single row from the table: "contract_type_names" */
  delete_contract_type_names_by_pk?: Maybe<Contract_Type_Names>;
  /** delete data from the table: "contract_types" */
  delete_contract_types?: Maybe<Contract_Types_Mutation_Response>;
  /** delete single row from the table: "contract_types" */
  delete_contract_types_by_pk?: Maybe<Contract_Types>;
  /** delete data from the table: "contracts_metadata" */
  delete_contracts_metadata?: Maybe<Contracts_Metadata_Mutation_Response>;
  /** delete single row from the table: "contracts_metadata" */
  delete_contracts_metadata_by_pk?: Maybe<Contracts_Metadata>;
  /** delete data from the table: "core_registries_metadata" */
  delete_core_registries_metadata?: Maybe<Core_Registries_Metadata_Mutation_Response>;
  /** delete single row from the table: "core_registries_metadata" */
  delete_core_registries_metadata_by_pk?: Maybe<Core_Registries_Metadata>;
  /** delete data from the table: "curation_statuses" */
  delete_curation_statuses?: Maybe<Curation_Statuses_Mutation_Response>;
  /** delete single row from the table: "curation_statuses" */
  delete_curation_statuses_by_pk?: Maybe<Curation_Statuses>;
  /** delete data from the table: "dependencies_metadata" */
  delete_dependencies_metadata?: Maybe<Dependencies_Metadata_Mutation_Response>;
  /** delete single row from the table: "dependencies_metadata" */
  delete_dependencies_metadata_by_pk?: Maybe<Dependencies_Metadata>;
  /** delete data from the table: "dependency_additional_cdns" */
  delete_dependency_additional_cdns?: Maybe<Dependency_Additional_Cdns_Mutation_Response>;
  /** delete single row from the table: "dependency_additional_cdns" */
  delete_dependency_additional_cdns_by_pk?: Maybe<Dependency_Additional_Cdns>;
  /** delete data from the table: "dependency_additional_repositories" */
  delete_dependency_additional_repositories?: Maybe<Dependency_Additional_Repositories_Mutation_Response>;
  /** delete single row from the table: "dependency_additional_repositories" */
  delete_dependency_additional_repositories_by_pk?: Maybe<Dependency_Additional_Repositories>;
  /** delete data from the table: "dependency_registries" */
  delete_dependency_registries?: Maybe<Dependency_Registries_Mutation_Response>;
  /** delete single row from the table: "dependency_registries" */
  delete_dependency_registries_by_pk?: Maybe<Dependency_Registries>;
  /** delete data from the table: "dependency_scripts" */
  delete_dependency_scripts?: Maybe<Dependency_Scripts_Mutation_Response>;
  /** delete single row from the table: "dependency_scripts" */
  delete_dependency_scripts_by_pk?: Maybe<Dependency_Scripts>;
  /** delete data from the table: "entity_tags" */
  delete_entity_tags?: Maybe<Entity_Tags_Mutation_Response>;
  /** delete single row from the table: "entity_tags" */
  delete_entity_tags_by_pk?: Maybe<Entity_Tags>;
  /** delete data from the table: "environment_configuration" */
  delete_environment_configuration?: Maybe<Environment_Configuration_Mutation_Response>;
  /** delete single row from the table: "environment_configuration" */
  delete_environment_configuration_by_pk?: Maybe<Environment_Configuration>;
  /** delete data from the table: "favorites" */
  delete_favorites?: Maybe<Favorites_Mutation_Response>;
  /** delete single row from the table: "favorites" */
  delete_favorites_by_pk?: Maybe<Favorites>;
  /** delete data from the table: "feature_flags" */
  delete_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** delete single row from the table: "feature_flags" */
  delete_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** delete data from the table: "media" */
  delete_media?: Maybe<Media_Mutation_Response>;
  /** delete single row from the table: "media" */
  delete_media_by_pk?: Maybe<Media>;
  /** delete data from the table: "minter_filter_type_names" */
  delete_minter_filter_type_names?: Maybe<Minter_Filter_Type_Names_Mutation_Response>;
  /** delete single row from the table: "minter_filter_type_names" */
  delete_minter_filter_type_names_by_pk?: Maybe<Minter_Filter_Type_Names>;
  /** delete data from the table: "minter_filters_metadata" */
  delete_minter_filters_metadata?: Maybe<Minter_Filters_Metadata_Mutation_Response>;
  /** delete single row from the table: "minter_filters_metadata" */
  delete_minter_filters_metadata_by_pk?: Maybe<Minter_Filters_Metadata>;
  /** delete data from the table: "minter_type_names" */
  delete_minter_type_names?: Maybe<Minter_Type_Names_Mutation_Response>;
  /** delete single row from the table: "minter_type_names" */
  delete_minter_type_names_by_pk?: Maybe<Minter_Type_Names>;
  /** delete data from the table: "minter_types" */
  delete_minter_types?: Maybe<Minter_Types_Mutation_Response>;
  /** delete single row from the table: "minter_types" */
  delete_minter_types_by_pk?: Maybe<Minter_Types>;
  /** delete data from the table: "minters_metadata" */
  delete_minters_metadata?: Maybe<Minters_Metadata_Mutation_Response>;
  /** delete single row from the table: "minters_metadata" */
  delete_minters_metadata_by_pk?: Maybe<Minters_Metadata>;
  /** delete data from the table: "mixpanel_lookup" */
  delete_mixpanel_lookup?: Maybe<Mixpanel_Lookup_Mutation_Response>;
  /** delete single row from the table: "mixpanel_lookup" */
  delete_mixpanel_lookup_by_pk?: Maybe<Mixpanel_Lookup>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "oob_tokens_metadata" */
  delete_oob_tokens_metadata?: Maybe<Oob_Tokens_Metadata_Mutation_Response>;
  /** delete single row from the table: "oob_tokens_metadata" */
  delete_oob_tokens_metadata_by_pk?: Maybe<Oob_Tokens_Metadata>;
  /** delete data from the table: "partner_types" */
  delete_partner_types?: Maybe<Partner_Types_Mutation_Response>;
  /** delete single row from the table: "partner_types" */
  delete_partner_types_by_pk?: Maybe<Partner_Types>;
  /** delete data from the table: "partners" */
  delete_partners?: Maybe<Partners_Mutation_Response>;
  /** delete single row from the table: "partners" */
  delete_partners_by_pk?: Maybe<Partners>;
  /** delete data from the table: "pmp_auth_options" */
  delete_pmp_auth_options?: Maybe<Pmp_Auth_Options_Mutation_Response>;
  /** delete single row from the table: "pmp_auth_options" */
  delete_pmp_auth_options_by_pk?: Maybe<Pmp_Auth_Options>;
  /** delete data from the table: "pmp_configs" */
  delete_pmp_configs?: Maybe<Pmp_Configs_Mutation_Response>;
  /** delete single row from the table: "pmp_configs" */
  delete_pmp_configs_by_pk?: Maybe<Pmp_Configs>;
  /** delete data from the table: "pmp_param_types" */
  delete_pmp_param_types?: Maybe<Pmp_Param_Types_Mutation_Response>;
  /** delete single row from the table: "pmp_param_types" */
  delete_pmp_param_types_by_pk?: Maybe<Pmp_Param_Types>;
  /** delete data from the table: "pmp_project_configs" */
  delete_pmp_project_configs?: Maybe<Pmp_Project_Configs_Mutation_Response>;
  /** delete single row from the table: "pmp_project_configs" */
  delete_pmp_project_configs_by_pk?: Maybe<Pmp_Project_Configs>;
  /** delete data from the table: "pmps_metadata" */
  delete_pmps_metadata?: Maybe<Pmps_Metadata_Mutation_Response>;
  /** delete single row from the table: "pmps_metadata" */
  delete_pmps_metadata_by_pk?: Maybe<Pmps_Metadata>;
  /** delete data from the table: "primary_purchases" */
  delete_primary_purchases?: Maybe<Primary_Purchases_Mutation_Response>;
  /** delete single row from the table: "primary_purchases" */
  delete_primary_purchases_by_pk?: Maybe<Primary_Purchases>;
  /** delete data from the table: "processing_jobs" */
  delete_processing_jobs?: Maybe<Processing_Jobs_Mutation_Response>;
  /** delete single row from the table: "processing_jobs" */
  delete_processing_jobs_by_pk?: Maybe<Processing_Jobs>;
  /** delete data from the table: "processing_jobs_status_types" */
  delete_processing_jobs_status_types?: Maybe<Processing_Jobs_Status_Types_Mutation_Response>;
  /** delete single row from the table: "processing_jobs_status_types" */
  delete_processing_jobs_status_types_by_pk?: Maybe<Processing_Jobs_Status_Types>;
  /** delete data from the table: "project_external_asset_dependencies" */
  delete_project_external_asset_dependencies?: Maybe<Project_External_Asset_Dependencies_Mutation_Response>;
  /** delete single row from the table: "project_external_asset_dependencies" */
  delete_project_external_asset_dependencies_by_pk?: Maybe<Project_External_Asset_Dependencies>;
  /** delete data from the table: "project_external_asset_dependency_types" */
  delete_project_external_asset_dependency_types?: Maybe<Project_External_Asset_Dependency_Types_Mutation_Response>;
  /** delete single row from the table: "project_external_asset_dependency_types" */
  delete_project_external_asset_dependency_types_by_pk?: Maybe<Project_External_Asset_Dependency_Types>;
  /** delete data from the table: "project_minter_configurations" */
  delete_project_minter_configurations?: Maybe<Project_Minter_Configurations_Mutation_Response>;
  /** delete single row from the table: "project_minter_configurations" */
  delete_project_minter_configurations_by_pk?: Maybe<Project_Minter_Configurations>;
  /** delete data from the table: "project_scripts" */
  delete_project_scripts?: Maybe<Project_Scripts_Mutation_Response>;
  /** delete single row from the table: "project_scripts" */
  delete_project_scripts_by_pk?: Maybe<Project_Scripts>;
  /** delete data from the table: "project_series" */
  delete_project_series?: Maybe<Project_Series_Mutation_Response>;
  /** delete single row from the table: "project_series" */
  delete_project_series_by_pk?: Maybe<Project_Series>;
  /** delete data from the table: "project_vertical_categories" */
  delete_project_vertical_categories?: Maybe<Project_Vertical_Categories_Mutation_Response>;
  /** delete single row from the table: "project_vertical_categories" */
  delete_project_vertical_categories_by_pk?: Maybe<Project_Vertical_Categories>;
  /** delete data from the table: "project_verticals" */
  delete_project_verticals?: Maybe<Project_Verticals_Mutation_Response>;
  /** delete single row from the table: "project_verticals" */
  delete_project_verticals_by_pk?: Maybe<Project_Verticals>;
  /** delete data from the table: "projects_features" */
  delete_projects_features?: Maybe<Projects_Features_Mutation_Response>;
  /** delete single row from the table: "projects_features" */
  delete_projects_features_by_pk?: Maybe<Projects_Features>;
  /** delete data from the table: "projects_metadata" */
  delete_projects_metadata?: Maybe<Projects_Metadata_Mutation_Response>;
  /** delete single row from the table: "projects_metadata" */
  delete_projects_metadata_by_pk?: Maybe<Projects_Metadata>;
  /** delete data from the table: "proposed_artist_addresses_and_splits" */
  delete_proposed_artist_addresses_and_splits?: Maybe<Proposed_Artist_Addresses_And_Splits_Mutation_Response>;
  /** delete single row from the table: "proposed_artist_addresses_and_splits" */
  delete_proposed_artist_addresses_and_splits_by_pk?: Maybe<Proposed_Artist_Addresses_And_Splits>;
  /** delete data from the table: "receipt_metadata" */
  delete_receipt_metadata?: Maybe<Receipt_Metadata_Mutation_Response>;
  /** delete single row from the table: "receipt_metadata" */
  delete_receipt_metadata_by_pk?: Maybe<Receipt_Metadata>;
  /** delete data from the table: "refresh_asset_types" */
  delete_refresh_asset_types?: Maybe<Refresh_Asset_Types_Mutation_Response>;
  /** delete single row from the table: "refresh_asset_types" */
  delete_refresh_asset_types_by_pk?: Maybe<Refresh_Asset_Types>;
  /** delete data from the table: "refresh_request_types" */
  delete_refresh_request_types?: Maybe<Refresh_Request_Types_Mutation_Response>;
  /** delete single row from the table: "refresh_request_types" */
  delete_refresh_request_types_by_pk?: Maybe<Refresh_Request_Types>;
  /** delete data from the table: "refresh_requests" */
  delete_refresh_requests?: Maybe<Refresh_Requests_Mutation_Response>;
  /** delete single row from the table: "refresh_requests" */
  delete_refresh_requests_by_pk?: Maybe<Refresh_Requests>;
  /** delete data from the table: "render_types" */
  delete_render_types?: Maybe<Render_Types_Mutation_Response>;
  /** delete single row from the table: "render_types" */
  delete_render_types_by_pk?: Maybe<Render_Types>;
  /** delete data from the table: "royalty_split_recipients" */
  delete_royalty_split_recipients?: Maybe<Royalty_Split_Recipients_Mutation_Response>;
  /** delete single row from the table: "royalty_split_recipients" */
  delete_royalty_split_recipients_by_pk?: Maybe<Royalty_Split_Recipients>;
  /** delete data from the table: "royalty_splitter_contracts" */
  delete_royalty_splitter_contracts?: Maybe<Royalty_Splitter_Contracts_Mutation_Response>;
  /** delete single row from the table: "royalty_splitter_contracts" */
  delete_royalty_splitter_contracts_by_pk?: Maybe<Royalty_Splitter_Contracts>;
  /** delete data from the table: "screenings" */
  delete_screenings?: Maybe<Screenings_Mutation_Response>;
  /** delete single row from the table: "screenings" */
  delete_screenings_by_pk?: Maybe<Screenings>;
  /** delete data from the table: "split_atomic_contracts" */
  delete_split_atomic_contracts?: Maybe<Split_Atomic_Contracts_Mutation_Response>;
  /** delete single row from the table: "split_atomic_contracts" */
  delete_split_atomic_contracts_by_pk?: Maybe<Split_Atomic_Contracts>;
  /** delete data from the table: "split_atomic_factories" */
  delete_split_atomic_factories?: Maybe<Split_Atomic_Factories_Mutation_Response>;
  /** delete single row from the table: "split_atomic_factories" */
  delete_split_atomic_factories_by_pk?: Maybe<Split_Atomic_Factories>;
  /** delete data from the table: "split_payment_configurations" */
  delete_split_payment_configurations?: Maybe<Split_Payment_Configurations_Mutation_Response>;
  /** delete single row from the table: "split_payment_configurations" */
  delete_split_payment_configurations_by_pk?: Maybe<Split_Payment_Configurations>;
  /** delete data from the table: "sync_status" */
  delete_sync_status?: Maybe<Sync_Status_Mutation_Response>;
  /** delete single row from the table: "sync_status" */
  delete_sync_status_by_pk?: Maybe<Sync_Status>;
  /** delete data from the table: "tag_groupings" */
  delete_tag_groupings?: Maybe<Tag_Groupings_Mutation_Response>;
  /** delete single row from the table: "tag_groupings" */
  delete_tag_groupings_by_pk?: Maybe<Tag_Groupings>;
  /** delete data from the table: "tag_status" */
  delete_tag_status?: Maybe<Tag_Status_Mutation_Response>;
  /** delete single row from the table: "tag_status" */
  delete_tag_status_by_pk?: Maybe<Tag_Status>;
  /** delete data from the table: "tag_types" */
  delete_tag_types?: Maybe<Tag_Types_Mutation_Response>;
  /** delete single row from the table: "tag_types" */
  delete_tag_types_by_pk?: Maybe<Tag_Types>;
  /** delete data from the table: "tags" */
  delete_tags?: Maybe<Tags_Mutation_Response>;
  /** delete single row from the table: "tags" */
  delete_tags_by_pk?: Maybe<Tags>;
  /** delete data from the table: "tokens_metadata" */
  delete_tokens_metadata?: Maybe<Tokens_Metadata_Mutation_Response>;
  /** delete single row from the table: "tokens_metadata" */
  delete_tokens_metadata_by_pk?: Maybe<Tokens_Metadata>;
  /** delete data from the table: "user_profiles" */
  delete_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** delete single row from the table: "user_profiles" */
  delete_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "verticals" */
  delete_verticals?: Maybe<Verticals_Mutation_Response>;
  /** delete single row from the table: "verticals" */
  delete_verticals_by_pk?: Maybe<Verticals>;
  /** delete data from the table: "video_aspect_ratios" */
  delete_video_aspect_ratios?: Maybe<Video_Aspect_Ratios_Mutation_Response>;
  /** delete single row from the table: "video_aspect_ratios" */
  delete_video_aspect_ratios_by_pk?: Maybe<Video_Aspect_Ratios>;
  /** delete data from the table: "video_frame_rates" */
  delete_video_frame_rates?: Maybe<Video_Frame_Rates_Mutation_Response>;
  /** delete single row from the table: "video_frame_rates" */
  delete_video_frame_rates_by_pk?: Maybe<Video_Frame_Rates>;
  /** delete data from the table: "webflow_artist_info" */
  delete_webflow_artist_info?: Maybe<Webflow_Artist_Info_Mutation_Response>;
  /** delete single row from the table: "webflow_artist_info" */
  delete_webflow_artist_info_by_pk?: Maybe<Webflow_Artist_Info>;
  /** delete data from the table: "webflow_spectrum_articles" */
  delete_webflow_spectrum_articles?: Maybe<Webflow_Spectrum_Articles_Mutation_Response>;
  /** delete single row from the table: "webflow_spectrum_articles" */
  delete_webflow_spectrum_articles_by_pk?: Maybe<Webflow_Spectrum_Articles>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  /** insert data into the table: "bid_types" */
  insert_bid_types?: Maybe<Bid_Types_Mutation_Response>;
  /** insert a single row into the table: "bid_types" */
  insert_bid_types_one?: Maybe<Bid_Types>;
  /** insert data into the table: "bids_metadata" */
  insert_bids_metadata?: Maybe<Bids_Metadata_Mutation_Response>;
  /** insert a single row into the table: "bids_metadata" */
  insert_bids_metadata_one?: Maybe<Bids_Metadata>;
  /** insert data into the table: "categories" */
  insert_categories?: Maybe<Categories_Mutation_Response>;
  /** insert a single row into the table: "categories" */
  insert_categories_one?: Maybe<Categories>;
  /** insert data into the table: "contract_allowlistings" */
  insert_contract_allowlistings?: Maybe<Contract_Allowlistings_Mutation_Response>;
  /** insert a single row into the table: "contract_allowlistings" */
  insert_contract_allowlistings_one?: Maybe<Contract_Allowlistings>;
  /** insert data into the table: "contract_type_names" */
  insert_contract_type_names?: Maybe<Contract_Type_Names_Mutation_Response>;
  /** insert a single row into the table: "contract_type_names" */
  insert_contract_type_names_one?: Maybe<Contract_Type_Names>;
  /** insert data into the table: "contract_types" */
  insert_contract_types?: Maybe<Contract_Types_Mutation_Response>;
  /** insert a single row into the table: "contract_types" */
  insert_contract_types_one?: Maybe<Contract_Types>;
  /** insert data into the table: "contracts_metadata" */
  insert_contracts_metadata?: Maybe<Contracts_Metadata_Mutation_Response>;
  /** insert a single row into the table: "contracts_metadata" */
  insert_contracts_metadata_one?: Maybe<Contracts_Metadata>;
  /** insert data into the table: "core_registries_metadata" */
  insert_core_registries_metadata?: Maybe<Core_Registries_Metadata_Mutation_Response>;
  /** insert a single row into the table: "core_registries_metadata" */
  insert_core_registries_metadata_one?: Maybe<Core_Registries_Metadata>;
  /** insert data into the table: "curation_statuses" */
  insert_curation_statuses?: Maybe<Curation_Statuses_Mutation_Response>;
  /** insert a single row into the table: "curation_statuses" */
  insert_curation_statuses_one?: Maybe<Curation_Statuses>;
  /** insert data into the table: "dependencies_metadata" */
  insert_dependencies_metadata?: Maybe<Dependencies_Metadata_Mutation_Response>;
  /** insert a single row into the table: "dependencies_metadata" */
  insert_dependencies_metadata_one?: Maybe<Dependencies_Metadata>;
  /** insert data into the table: "dependency_additional_cdns" */
  insert_dependency_additional_cdns?: Maybe<Dependency_Additional_Cdns_Mutation_Response>;
  /** insert a single row into the table: "dependency_additional_cdns" */
  insert_dependency_additional_cdns_one?: Maybe<Dependency_Additional_Cdns>;
  /** insert data into the table: "dependency_additional_repositories" */
  insert_dependency_additional_repositories?: Maybe<Dependency_Additional_Repositories_Mutation_Response>;
  /** insert a single row into the table: "dependency_additional_repositories" */
  insert_dependency_additional_repositories_one?: Maybe<Dependency_Additional_Repositories>;
  /** insert data into the table: "dependency_registries" */
  insert_dependency_registries?: Maybe<Dependency_Registries_Mutation_Response>;
  /** insert a single row into the table: "dependency_registries" */
  insert_dependency_registries_one?: Maybe<Dependency_Registries>;
  /** insert data into the table: "dependency_scripts" */
  insert_dependency_scripts?: Maybe<Dependency_Scripts_Mutation_Response>;
  /** insert a single row into the table: "dependency_scripts" */
  insert_dependency_scripts_one?: Maybe<Dependency_Scripts>;
  /** insert data into the table: "entity_tags" */
  insert_entity_tags?: Maybe<Entity_Tags_Mutation_Response>;
  /** insert a single row into the table: "entity_tags" */
  insert_entity_tags_one?: Maybe<Entity_Tags>;
  /** insert data into the table: "environment_configuration" */
  insert_environment_configuration?: Maybe<Environment_Configuration_Mutation_Response>;
  /** insert a single row into the table: "environment_configuration" */
  insert_environment_configuration_one?: Maybe<Environment_Configuration>;
  /** insert data into the table: "favorites" */
  insert_favorites?: Maybe<Favorites_Mutation_Response>;
  /** insert a single row into the table: "favorites" */
  insert_favorites_one?: Maybe<Favorites>;
  /** insert data into the table: "feature_flags" */
  insert_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** insert a single row into the table: "feature_flags" */
  insert_feature_flags_one?: Maybe<Feature_Flags>;
  /** insert data into the table: "media" */
  insert_media?: Maybe<Media_Mutation_Response>;
  /** insert a single row into the table: "media" */
  insert_media_one?: Maybe<Media>;
  /** insert data into the table: "minter_filter_type_names" */
  insert_minter_filter_type_names?: Maybe<Minter_Filter_Type_Names_Mutation_Response>;
  /** insert a single row into the table: "minter_filter_type_names" */
  insert_minter_filter_type_names_one?: Maybe<Minter_Filter_Type_Names>;
  /** insert data into the table: "minter_filters_metadata" */
  insert_minter_filters_metadata?: Maybe<Minter_Filters_Metadata_Mutation_Response>;
  /** insert a single row into the table: "minter_filters_metadata" */
  insert_minter_filters_metadata_one?: Maybe<Minter_Filters_Metadata>;
  /** insert data into the table: "minter_type_names" */
  insert_minter_type_names?: Maybe<Minter_Type_Names_Mutation_Response>;
  /** insert a single row into the table: "minter_type_names" */
  insert_minter_type_names_one?: Maybe<Minter_Type_Names>;
  /** insert data into the table: "minter_types" */
  insert_minter_types?: Maybe<Minter_Types_Mutation_Response>;
  /** insert a single row into the table: "minter_types" */
  insert_minter_types_one?: Maybe<Minter_Types>;
  /** insert data into the table: "minters_metadata" */
  insert_minters_metadata?: Maybe<Minters_Metadata_Mutation_Response>;
  /** insert a single row into the table: "minters_metadata" */
  insert_minters_metadata_one?: Maybe<Minters_Metadata>;
  /** insert data into the table: "mixpanel_lookup" */
  insert_mixpanel_lookup?: Maybe<Mixpanel_Lookup_Mutation_Response>;
  /** insert a single row into the table: "mixpanel_lookup" */
  insert_mixpanel_lookup_one?: Maybe<Mixpanel_Lookup>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "oob_tokens_metadata" */
  insert_oob_tokens_metadata?: Maybe<Oob_Tokens_Metadata_Mutation_Response>;
  /** insert a single row into the table: "oob_tokens_metadata" */
  insert_oob_tokens_metadata_one?: Maybe<Oob_Tokens_Metadata>;
  /** insert data into the table: "partner_types" */
  insert_partner_types?: Maybe<Partner_Types_Mutation_Response>;
  /** insert a single row into the table: "partner_types" */
  insert_partner_types_one?: Maybe<Partner_Types>;
  /** insert data into the table: "partners" */
  insert_partners?: Maybe<Partners_Mutation_Response>;
  /** insert a single row into the table: "partners" */
  insert_partners_one?: Maybe<Partners>;
  /** insert data into the table: "pmp_auth_options" */
  insert_pmp_auth_options?: Maybe<Pmp_Auth_Options_Mutation_Response>;
  /** insert a single row into the table: "pmp_auth_options" */
  insert_pmp_auth_options_one?: Maybe<Pmp_Auth_Options>;
  /** insert data into the table: "pmp_configs" */
  insert_pmp_configs?: Maybe<Pmp_Configs_Mutation_Response>;
  /** insert a single row into the table: "pmp_configs" */
  insert_pmp_configs_one?: Maybe<Pmp_Configs>;
  /** insert data into the table: "pmp_param_types" */
  insert_pmp_param_types?: Maybe<Pmp_Param_Types_Mutation_Response>;
  /** insert a single row into the table: "pmp_param_types" */
  insert_pmp_param_types_one?: Maybe<Pmp_Param_Types>;
  /** insert data into the table: "pmp_project_configs" */
  insert_pmp_project_configs?: Maybe<Pmp_Project_Configs_Mutation_Response>;
  /** insert a single row into the table: "pmp_project_configs" */
  insert_pmp_project_configs_one?: Maybe<Pmp_Project_Configs>;
  /** insert data into the table: "pmps_metadata" */
  insert_pmps_metadata?: Maybe<Pmps_Metadata_Mutation_Response>;
  /** insert a single row into the table: "pmps_metadata" */
  insert_pmps_metadata_one?: Maybe<Pmps_Metadata>;
  /** insert data into the table: "primary_purchases" */
  insert_primary_purchases?: Maybe<Primary_Purchases_Mutation_Response>;
  /** insert a single row into the table: "primary_purchases" */
  insert_primary_purchases_one?: Maybe<Primary_Purchases>;
  /** insert data into the table: "processing_jobs" */
  insert_processing_jobs?: Maybe<Processing_Jobs_Mutation_Response>;
  /** insert a single row into the table: "processing_jobs" */
  insert_processing_jobs_one?: Maybe<Processing_Jobs>;
  /** insert data into the table: "processing_jobs_status_types" */
  insert_processing_jobs_status_types?: Maybe<Processing_Jobs_Status_Types_Mutation_Response>;
  /** insert a single row into the table: "processing_jobs_status_types" */
  insert_processing_jobs_status_types_one?: Maybe<Processing_Jobs_Status_Types>;
  /** insert data into the table: "project_external_asset_dependencies" */
  insert_project_external_asset_dependencies?: Maybe<Project_External_Asset_Dependencies_Mutation_Response>;
  /** insert a single row into the table: "project_external_asset_dependencies" */
  insert_project_external_asset_dependencies_one?: Maybe<Project_External_Asset_Dependencies>;
  /** insert data into the table: "project_external_asset_dependency_types" */
  insert_project_external_asset_dependency_types?: Maybe<Project_External_Asset_Dependency_Types_Mutation_Response>;
  /** insert a single row into the table: "project_external_asset_dependency_types" */
  insert_project_external_asset_dependency_types_one?: Maybe<Project_External_Asset_Dependency_Types>;
  /** insert data into the table: "project_minter_configurations" */
  insert_project_minter_configurations?: Maybe<Project_Minter_Configurations_Mutation_Response>;
  /** insert a single row into the table: "project_minter_configurations" */
  insert_project_minter_configurations_one?: Maybe<Project_Minter_Configurations>;
  /** insert data into the table: "project_scripts" */
  insert_project_scripts?: Maybe<Project_Scripts_Mutation_Response>;
  /** insert a single row into the table: "project_scripts" */
  insert_project_scripts_one?: Maybe<Project_Scripts>;
  /** insert data into the table: "project_series" */
  insert_project_series?: Maybe<Project_Series_Mutation_Response>;
  /** insert a single row into the table: "project_series" */
  insert_project_series_one?: Maybe<Project_Series>;
  /** insert data into the table: "project_vertical_categories" */
  insert_project_vertical_categories?: Maybe<Project_Vertical_Categories_Mutation_Response>;
  /** insert a single row into the table: "project_vertical_categories" */
  insert_project_vertical_categories_one?: Maybe<Project_Vertical_Categories>;
  /** insert data into the table: "project_verticals" */
  insert_project_verticals?: Maybe<Project_Verticals_Mutation_Response>;
  /** insert a single row into the table: "project_verticals" */
  insert_project_verticals_one?: Maybe<Project_Verticals>;
  /** insert data into the table: "projects_features" */
  insert_projects_features?: Maybe<Projects_Features_Mutation_Response>;
  /** insert a single row into the table: "projects_features" */
  insert_projects_features_one?: Maybe<Projects_Features>;
  /** insert data into the table: "projects_metadata" */
  insert_projects_metadata?: Maybe<Projects_Metadata_Mutation_Response>;
  /** insert a single row into the table: "projects_metadata" */
  insert_projects_metadata_one?: Maybe<Projects_Metadata>;
  /** insert data into the table: "proposed_artist_addresses_and_splits" */
  insert_proposed_artist_addresses_and_splits?: Maybe<Proposed_Artist_Addresses_And_Splits_Mutation_Response>;
  /** insert a single row into the table: "proposed_artist_addresses_and_splits" */
  insert_proposed_artist_addresses_and_splits_one?: Maybe<Proposed_Artist_Addresses_And_Splits>;
  /** insert data into the table: "receipt_metadata" */
  insert_receipt_metadata?: Maybe<Receipt_Metadata_Mutation_Response>;
  /** insert a single row into the table: "receipt_metadata" */
  insert_receipt_metadata_one?: Maybe<Receipt_Metadata>;
  /** insert data into the table: "refresh_asset_types" */
  insert_refresh_asset_types?: Maybe<Refresh_Asset_Types_Mutation_Response>;
  /** insert a single row into the table: "refresh_asset_types" */
  insert_refresh_asset_types_one?: Maybe<Refresh_Asset_Types>;
  /** insert data into the table: "refresh_request_types" */
  insert_refresh_request_types?: Maybe<Refresh_Request_Types_Mutation_Response>;
  /** insert a single row into the table: "refresh_request_types" */
  insert_refresh_request_types_one?: Maybe<Refresh_Request_Types>;
  /** insert data into the table: "refresh_requests" */
  insert_refresh_requests?: Maybe<Refresh_Requests_Mutation_Response>;
  /** insert a single row into the table: "refresh_requests" */
  insert_refresh_requests_one?: Maybe<Refresh_Requests>;
  /** insert data into the table: "render_types" */
  insert_render_types?: Maybe<Render_Types_Mutation_Response>;
  /** insert a single row into the table: "render_types" */
  insert_render_types_one?: Maybe<Render_Types>;
  /** insert data into the table: "royalty_split_recipients" */
  insert_royalty_split_recipients?: Maybe<Royalty_Split_Recipients_Mutation_Response>;
  /** insert a single row into the table: "royalty_split_recipients" */
  insert_royalty_split_recipients_one?: Maybe<Royalty_Split_Recipients>;
  /** insert data into the table: "royalty_splitter_contracts" */
  insert_royalty_splitter_contracts?: Maybe<Royalty_Splitter_Contracts_Mutation_Response>;
  /** insert a single row into the table: "royalty_splitter_contracts" */
  insert_royalty_splitter_contracts_one?: Maybe<Royalty_Splitter_Contracts>;
  /** insert data into the table: "screenings" */
  insert_screenings?: Maybe<Screenings_Mutation_Response>;
  /** insert a single row into the table: "screenings" */
  insert_screenings_one?: Maybe<Screenings>;
  /** insert data into the table: "split_atomic_contracts" */
  insert_split_atomic_contracts?: Maybe<Split_Atomic_Contracts_Mutation_Response>;
  /** insert a single row into the table: "split_atomic_contracts" */
  insert_split_atomic_contracts_one?: Maybe<Split_Atomic_Contracts>;
  /** insert data into the table: "split_atomic_factories" */
  insert_split_atomic_factories?: Maybe<Split_Atomic_Factories_Mutation_Response>;
  /** insert a single row into the table: "split_atomic_factories" */
  insert_split_atomic_factories_one?: Maybe<Split_Atomic_Factories>;
  /** insert data into the table: "split_payment_configurations" */
  insert_split_payment_configurations?: Maybe<Split_Payment_Configurations_Mutation_Response>;
  /** insert a single row into the table: "split_payment_configurations" */
  insert_split_payment_configurations_one?: Maybe<Split_Payment_Configurations>;
  /** insert data into the table: "sync_status" */
  insert_sync_status?: Maybe<Sync_Status_Mutation_Response>;
  /** insert a single row into the table: "sync_status" */
  insert_sync_status_one?: Maybe<Sync_Status>;
  /** insert data into the table: "tag_groupings" */
  insert_tag_groupings?: Maybe<Tag_Groupings_Mutation_Response>;
  /** insert a single row into the table: "tag_groupings" */
  insert_tag_groupings_one?: Maybe<Tag_Groupings>;
  /** insert data into the table: "tag_status" */
  insert_tag_status?: Maybe<Tag_Status_Mutation_Response>;
  /** insert a single row into the table: "tag_status" */
  insert_tag_status_one?: Maybe<Tag_Status>;
  /** insert data into the table: "tag_types" */
  insert_tag_types?: Maybe<Tag_Types_Mutation_Response>;
  /** insert a single row into the table: "tag_types" */
  insert_tag_types_one?: Maybe<Tag_Types>;
  /** insert data into the table: "tags" */
  insert_tags?: Maybe<Tags_Mutation_Response>;
  /** insert a single row into the table: "tags" */
  insert_tags_one?: Maybe<Tags>;
  /** insert data into the table: "tokens_metadata" */
  insert_tokens_metadata?: Maybe<Tokens_Metadata_Mutation_Response>;
  /** insert a single row into the table: "tokens_metadata" */
  insert_tokens_metadata_one?: Maybe<Tokens_Metadata>;
  /** insert data into the table: "user_profiles" */
  insert_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** insert a single row into the table: "user_profiles" */
  insert_user_profiles_one?: Maybe<User_Profiles>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "verticals" */
  insert_verticals?: Maybe<Verticals_Mutation_Response>;
  /** insert a single row into the table: "verticals" */
  insert_verticals_one?: Maybe<Verticals>;
  /** insert data into the table: "video_aspect_ratios" */
  insert_video_aspect_ratios?: Maybe<Video_Aspect_Ratios_Mutation_Response>;
  /** insert a single row into the table: "video_aspect_ratios" */
  insert_video_aspect_ratios_one?: Maybe<Video_Aspect_Ratios>;
  /** insert data into the table: "video_frame_rates" */
  insert_video_frame_rates?: Maybe<Video_Frame_Rates_Mutation_Response>;
  /** insert a single row into the table: "video_frame_rates" */
  insert_video_frame_rates_one?: Maybe<Video_Frame_Rates>;
  /** insert data into the table: "webflow_artist_info" */
  insert_webflow_artist_info?: Maybe<Webflow_Artist_Info_Mutation_Response>;
  /** insert a single row into the table: "webflow_artist_info" */
  insert_webflow_artist_info_one?: Maybe<Webflow_Artist_Info>;
  /** insert data into the table: "webflow_spectrum_articles" */
  insert_webflow_spectrum_articles?: Maybe<Webflow_Spectrum_Articles_Mutation_Response>;
  /** insert a single row into the table: "webflow_spectrum_articles" */
  insert_webflow_spectrum_articles_one?: Maybe<Webflow_Spectrum_Articles>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  privyAuthenticate?: Maybe<AuthenticateOutput>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateArticle?: Maybe<ArticleEntityResponse>;
  updateArtistEditorialPage?: Maybe<ArtistEditorialPageEntityResponse>;
  updateCuratedHomePage?: Maybe<CuratedHomePageEntityResponse>;
  updateExhibition?: Maybe<ExhibitionEntityResponse>;
  updateFeatures?: Maybe<UpdateFeaturesScriptOutput>;
  updateFileInfo: UploadFileEntityResponse;
  updateHighlight?: Maybe<HighlightEntityResponse>;
  updateHomePage?: Maybe<HomePageEntityResponse>;
  updateLandingPage?: Maybe<LandingPageEntityResponse>;
  updateMinterInfo?: Maybe<MinterInfoEntityResponse>;
  updateProjectMedia?: Maybe<UpdateProjectMediaScriptOutput>;
  updateProjectPage?: Maybe<ProjectPageEntityResponse>;
  updateTokenMedia?: Maybe<UpdateTokenMediaScriptOutput>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** update data of the table: "bid_types" */
  update_bid_types?: Maybe<Bid_Types_Mutation_Response>;
  /** update single row of the table: "bid_types" */
  update_bid_types_by_pk?: Maybe<Bid_Types>;
  /** update multiples rows of table: "bid_types" */
  update_bid_types_many?: Maybe<Array<Maybe<Bid_Types_Mutation_Response>>>;
  /** update data of the table: "bids_metadata" */
  update_bids_metadata?: Maybe<Bids_Metadata_Mutation_Response>;
  /** update single row of the table: "bids_metadata" */
  update_bids_metadata_by_pk?: Maybe<Bids_Metadata>;
  /** update multiples rows of table: "bids_metadata" */
  update_bids_metadata_many?: Maybe<Array<Maybe<Bids_Metadata_Mutation_Response>>>;
  /** update data of the table: "categories" */
  update_categories?: Maybe<Categories_Mutation_Response>;
  /** update single row of the table: "categories" */
  update_categories_by_pk?: Maybe<Categories>;
  /** update multiples rows of table: "categories" */
  update_categories_many?: Maybe<Array<Maybe<Categories_Mutation_Response>>>;
  /** update data of the table: "contract_allowlistings" */
  update_contract_allowlistings?: Maybe<Contract_Allowlistings_Mutation_Response>;
  /** update single row of the table: "contract_allowlistings" */
  update_contract_allowlistings_by_pk?: Maybe<Contract_Allowlistings>;
  /** update multiples rows of table: "contract_allowlistings" */
  update_contract_allowlistings_many?: Maybe<Array<Maybe<Contract_Allowlistings_Mutation_Response>>>;
  /** update data of the table: "contract_type_names" */
  update_contract_type_names?: Maybe<Contract_Type_Names_Mutation_Response>;
  /** update single row of the table: "contract_type_names" */
  update_contract_type_names_by_pk?: Maybe<Contract_Type_Names>;
  /** update multiples rows of table: "contract_type_names" */
  update_contract_type_names_many?: Maybe<Array<Maybe<Contract_Type_Names_Mutation_Response>>>;
  /** update data of the table: "contract_types" */
  update_contract_types?: Maybe<Contract_Types_Mutation_Response>;
  /** update single row of the table: "contract_types" */
  update_contract_types_by_pk?: Maybe<Contract_Types>;
  /** update multiples rows of table: "contract_types" */
  update_contract_types_many?: Maybe<Array<Maybe<Contract_Types_Mutation_Response>>>;
  /** update data of the table: "contracts_metadata" */
  update_contracts_metadata?: Maybe<Contracts_Metadata_Mutation_Response>;
  /** update single row of the table: "contracts_metadata" */
  update_contracts_metadata_by_pk?: Maybe<Contracts_Metadata>;
  /** update multiples rows of table: "contracts_metadata" */
  update_contracts_metadata_many?: Maybe<Array<Maybe<Contracts_Metadata_Mutation_Response>>>;
  /** update data of the table: "core_registries_metadata" */
  update_core_registries_metadata?: Maybe<Core_Registries_Metadata_Mutation_Response>;
  /** update single row of the table: "core_registries_metadata" */
  update_core_registries_metadata_by_pk?: Maybe<Core_Registries_Metadata>;
  /** update multiples rows of table: "core_registries_metadata" */
  update_core_registries_metadata_many?: Maybe<Array<Maybe<Core_Registries_Metadata_Mutation_Response>>>;
  /** update data of the table: "curation_statuses" */
  update_curation_statuses?: Maybe<Curation_Statuses_Mutation_Response>;
  /** update single row of the table: "curation_statuses" */
  update_curation_statuses_by_pk?: Maybe<Curation_Statuses>;
  /** update multiples rows of table: "curation_statuses" */
  update_curation_statuses_many?: Maybe<Array<Maybe<Curation_Statuses_Mutation_Response>>>;
  /** update data of the table: "dependencies_metadata" */
  update_dependencies_metadata?: Maybe<Dependencies_Metadata_Mutation_Response>;
  /** update single row of the table: "dependencies_metadata" */
  update_dependencies_metadata_by_pk?: Maybe<Dependencies_Metadata>;
  /** update multiples rows of table: "dependencies_metadata" */
  update_dependencies_metadata_many?: Maybe<Array<Maybe<Dependencies_Metadata_Mutation_Response>>>;
  /** update data of the table: "dependency_additional_cdns" */
  update_dependency_additional_cdns?: Maybe<Dependency_Additional_Cdns_Mutation_Response>;
  /** update single row of the table: "dependency_additional_cdns" */
  update_dependency_additional_cdns_by_pk?: Maybe<Dependency_Additional_Cdns>;
  /** update multiples rows of table: "dependency_additional_cdns" */
  update_dependency_additional_cdns_many?: Maybe<Array<Maybe<Dependency_Additional_Cdns_Mutation_Response>>>;
  /** update data of the table: "dependency_additional_repositories" */
  update_dependency_additional_repositories?: Maybe<Dependency_Additional_Repositories_Mutation_Response>;
  /** update single row of the table: "dependency_additional_repositories" */
  update_dependency_additional_repositories_by_pk?: Maybe<Dependency_Additional_Repositories>;
  /** update multiples rows of table: "dependency_additional_repositories" */
  update_dependency_additional_repositories_many?: Maybe<Array<Maybe<Dependency_Additional_Repositories_Mutation_Response>>>;
  /** update data of the table: "dependency_registries" */
  update_dependency_registries?: Maybe<Dependency_Registries_Mutation_Response>;
  /** update single row of the table: "dependency_registries" */
  update_dependency_registries_by_pk?: Maybe<Dependency_Registries>;
  /** update multiples rows of table: "dependency_registries" */
  update_dependency_registries_many?: Maybe<Array<Maybe<Dependency_Registries_Mutation_Response>>>;
  /** update data of the table: "dependency_scripts" */
  update_dependency_scripts?: Maybe<Dependency_Scripts_Mutation_Response>;
  /** update single row of the table: "dependency_scripts" */
  update_dependency_scripts_by_pk?: Maybe<Dependency_Scripts>;
  /** update multiples rows of table: "dependency_scripts" */
  update_dependency_scripts_many?: Maybe<Array<Maybe<Dependency_Scripts_Mutation_Response>>>;
  /** update data of the table: "entity_tags" */
  update_entity_tags?: Maybe<Entity_Tags_Mutation_Response>;
  /** update single row of the table: "entity_tags" */
  update_entity_tags_by_pk?: Maybe<Entity_Tags>;
  /** update multiples rows of table: "entity_tags" */
  update_entity_tags_many?: Maybe<Array<Maybe<Entity_Tags_Mutation_Response>>>;
  /** update data of the table: "environment_configuration" */
  update_environment_configuration?: Maybe<Environment_Configuration_Mutation_Response>;
  /** update single row of the table: "environment_configuration" */
  update_environment_configuration_by_pk?: Maybe<Environment_Configuration>;
  /** update multiples rows of table: "environment_configuration" */
  update_environment_configuration_many?: Maybe<Array<Maybe<Environment_Configuration_Mutation_Response>>>;
  /** update data of the table: "favorites" */
  update_favorites?: Maybe<Favorites_Mutation_Response>;
  /** update single row of the table: "favorites" */
  update_favorites_by_pk?: Maybe<Favorites>;
  /** update multiples rows of table: "favorites" */
  update_favorites_many?: Maybe<Array<Maybe<Favorites_Mutation_Response>>>;
  /** update data of the table: "feature_flags" */
  update_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** update single row of the table: "feature_flags" */
  update_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** update multiples rows of table: "feature_flags" */
  update_feature_flags_many?: Maybe<Array<Maybe<Feature_Flags_Mutation_Response>>>;
  /** update data of the table: "media" */
  update_media?: Maybe<Media_Mutation_Response>;
  /** update single row of the table: "media" */
  update_media_by_pk?: Maybe<Media>;
  /** update multiples rows of table: "media" */
  update_media_many?: Maybe<Array<Maybe<Media_Mutation_Response>>>;
  /** update data of the table: "minter_filter_type_names" */
  update_minter_filter_type_names?: Maybe<Minter_Filter_Type_Names_Mutation_Response>;
  /** update single row of the table: "minter_filter_type_names" */
  update_minter_filter_type_names_by_pk?: Maybe<Minter_Filter_Type_Names>;
  /** update multiples rows of table: "minter_filter_type_names" */
  update_minter_filter_type_names_many?: Maybe<Array<Maybe<Minter_Filter_Type_Names_Mutation_Response>>>;
  /** update data of the table: "minter_filters_metadata" */
  update_minter_filters_metadata?: Maybe<Minter_Filters_Metadata_Mutation_Response>;
  /** update single row of the table: "minter_filters_metadata" */
  update_minter_filters_metadata_by_pk?: Maybe<Minter_Filters_Metadata>;
  /** update multiples rows of table: "minter_filters_metadata" */
  update_minter_filters_metadata_many?: Maybe<Array<Maybe<Minter_Filters_Metadata_Mutation_Response>>>;
  /** update data of the table: "minter_type_names" */
  update_minter_type_names?: Maybe<Minter_Type_Names_Mutation_Response>;
  /** update single row of the table: "minter_type_names" */
  update_minter_type_names_by_pk?: Maybe<Minter_Type_Names>;
  /** update multiples rows of table: "minter_type_names" */
  update_minter_type_names_many?: Maybe<Array<Maybe<Minter_Type_Names_Mutation_Response>>>;
  /** update data of the table: "minter_types" */
  update_minter_types?: Maybe<Minter_Types_Mutation_Response>;
  /** update single row of the table: "minter_types" */
  update_minter_types_by_pk?: Maybe<Minter_Types>;
  /** update multiples rows of table: "minter_types" */
  update_minter_types_many?: Maybe<Array<Maybe<Minter_Types_Mutation_Response>>>;
  /** update data of the table: "minters_metadata" */
  update_minters_metadata?: Maybe<Minters_Metadata_Mutation_Response>;
  /** update single row of the table: "minters_metadata" */
  update_minters_metadata_by_pk?: Maybe<Minters_Metadata>;
  /** update multiples rows of table: "minters_metadata" */
  update_minters_metadata_many?: Maybe<Array<Maybe<Minters_Metadata_Mutation_Response>>>;
  /** update data of the table: "mixpanel_lookup" */
  update_mixpanel_lookup?: Maybe<Mixpanel_Lookup_Mutation_Response>;
  /** update single row of the table: "mixpanel_lookup" */
  update_mixpanel_lookup_by_pk?: Maybe<Mixpanel_Lookup>;
  /** update multiples rows of table: "mixpanel_lookup" */
  update_mixpanel_lookup_many?: Maybe<Array<Maybe<Mixpanel_Lookup_Mutation_Response>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update data of the table: "oob_tokens_metadata" */
  update_oob_tokens_metadata?: Maybe<Oob_Tokens_Metadata_Mutation_Response>;
  /** update single row of the table: "oob_tokens_metadata" */
  update_oob_tokens_metadata_by_pk?: Maybe<Oob_Tokens_Metadata>;
  /** update multiples rows of table: "oob_tokens_metadata" */
  update_oob_tokens_metadata_many?: Maybe<Array<Maybe<Oob_Tokens_Metadata_Mutation_Response>>>;
  /** update data of the table: "partner_types" */
  update_partner_types?: Maybe<Partner_Types_Mutation_Response>;
  /** update single row of the table: "partner_types" */
  update_partner_types_by_pk?: Maybe<Partner_Types>;
  /** update multiples rows of table: "partner_types" */
  update_partner_types_many?: Maybe<Array<Maybe<Partner_Types_Mutation_Response>>>;
  /** update data of the table: "partners" */
  update_partners?: Maybe<Partners_Mutation_Response>;
  /** update single row of the table: "partners" */
  update_partners_by_pk?: Maybe<Partners>;
  /** update multiples rows of table: "partners" */
  update_partners_many?: Maybe<Array<Maybe<Partners_Mutation_Response>>>;
  /** update data of the table: "pmp_auth_options" */
  update_pmp_auth_options?: Maybe<Pmp_Auth_Options_Mutation_Response>;
  /** update single row of the table: "pmp_auth_options" */
  update_pmp_auth_options_by_pk?: Maybe<Pmp_Auth_Options>;
  /** update multiples rows of table: "pmp_auth_options" */
  update_pmp_auth_options_many?: Maybe<Array<Maybe<Pmp_Auth_Options_Mutation_Response>>>;
  /** update data of the table: "pmp_configs" */
  update_pmp_configs?: Maybe<Pmp_Configs_Mutation_Response>;
  /** update single row of the table: "pmp_configs" */
  update_pmp_configs_by_pk?: Maybe<Pmp_Configs>;
  /** update multiples rows of table: "pmp_configs" */
  update_pmp_configs_many?: Maybe<Array<Maybe<Pmp_Configs_Mutation_Response>>>;
  /** update data of the table: "pmp_param_types" */
  update_pmp_param_types?: Maybe<Pmp_Param_Types_Mutation_Response>;
  /** update single row of the table: "pmp_param_types" */
  update_pmp_param_types_by_pk?: Maybe<Pmp_Param_Types>;
  /** update multiples rows of table: "pmp_param_types" */
  update_pmp_param_types_many?: Maybe<Array<Maybe<Pmp_Param_Types_Mutation_Response>>>;
  /** update data of the table: "pmp_project_configs" */
  update_pmp_project_configs?: Maybe<Pmp_Project_Configs_Mutation_Response>;
  /** update single row of the table: "pmp_project_configs" */
  update_pmp_project_configs_by_pk?: Maybe<Pmp_Project_Configs>;
  /** update multiples rows of table: "pmp_project_configs" */
  update_pmp_project_configs_many?: Maybe<Array<Maybe<Pmp_Project_Configs_Mutation_Response>>>;
  /** update data of the table: "pmps_metadata" */
  update_pmps_metadata?: Maybe<Pmps_Metadata_Mutation_Response>;
  /** update single row of the table: "pmps_metadata" */
  update_pmps_metadata_by_pk?: Maybe<Pmps_Metadata>;
  /** update multiples rows of table: "pmps_metadata" */
  update_pmps_metadata_many?: Maybe<Array<Maybe<Pmps_Metadata_Mutation_Response>>>;
  /** update data of the table: "primary_purchases" */
  update_primary_purchases?: Maybe<Primary_Purchases_Mutation_Response>;
  /** update single row of the table: "primary_purchases" */
  update_primary_purchases_by_pk?: Maybe<Primary_Purchases>;
  /** update multiples rows of table: "primary_purchases" */
  update_primary_purchases_many?: Maybe<Array<Maybe<Primary_Purchases_Mutation_Response>>>;
  /** update data of the table: "processing_jobs" */
  update_processing_jobs?: Maybe<Processing_Jobs_Mutation_Response>;
  /** update single row of the table: "processing_jobs" */
  update_processing_jobs_by_pk?: Maybe<Processing_Jobs>;
  /** update multiples rows of table: "processing_jobs" */
  update_processing_jobs_many?: Maybe<Array<Maybe<Processing_Jobs_Mutation_Response>>>;
  /** update data of the table: "processing_jobs_status_types" */
  update_processing_jobs_status_types?: Maybe<Processing_Jobs_Status_Types_Mutation_Response>;
  /** update single row of the table: "processing_jobs_status_types" */
  update_processing_jobs_status_types_by_pk?: Maybe<Processing_Jobs_Status_Types>;
  /** update multiples rows of table: "processing_jobs_status_types" */
  update_processing_jobs_status_types_many?: Maybe<Array<Maybe<Processing_Jobs_Status_Types_Mutation_Response>>>;
  /** update data of the table: "project_external_asset_dependencies" */
  update_project_external_asset_dependencies?: Maybe<Project_External_Asset_Dependencies_Mutation_Response>;
  /** update single row of the table: "project_external_asset_dependencies" */
  update_project_external_asset_dependencies_by_pk?: Maybe<Project_External_Asset_Dependencies>;
  /** update multiples rows of table: "project_external_asset_dependencies" */
  update_project_external_asset_dependencies_many?: Maybe<Array<Maybe<Project_External_Asset_Dependencies_Mutation_Response>>>;
  /** update data of the table: "project_external_asset_dependency_types" */
  update_project_external_asset_dependency_types?: Maybe<Project_External_Asset_Dependency_Types_Mutation_Response>;
  /** update single row of the table: "project_external_asset_dependency_types" */
  update_project_external_asset_dependency_types_by_pk?: Maybe<Project_External_Asset_Dependency_Types>;
  /** update multiples rows of table: "project_external_asset_dependency_types" */
  update_project_external_asset_dependency_types_many?: Maybe<Array<Maybe<Project_External_Asset_Dependency_Types_Mutation_Response>>>;
  /** update data of the table: "project_minter_configurations" */
  update_project_minter_configurations?: Maybe<Project_Minter_Configurations_Mutation_Response>;
  /** update single row of the table: "project_minter_configurations" */
  update_project_minter_configurations_by_pk?: Maybe<Project_Minter_Configurations>;
  /** update multiples rows of table: "project_minter_configurations" */
  update_project_minter_configurations_many?: Maybe<Array<Maybe<Project_Minter_Configurations_Mutation_Response>>>;
  /** update data of the table: "project_scripts" */
  update_project_scripts?: Maybe<Project_Scripts_Mutation_Response>;
  /** update single row of the table: "project_scripts" */
  update_project_scripts_by_pk?: Maybe<Project_Scripts>;
  /** update multiples rows of table: "project_scripts" */
  update_project_scripts_many?: Maybe<Array<Maybe<Project_Scripts_Mutation_Response>>>;
  /** update data of the table: "project_series" */
  update_project_series?: Maybe<Project_Series_Mutation_Response>;
  /** update single row of the table: "project_series" */
  update_project_series_by_pk?: Maybe<Project_Series>;
  /** update multiples rows of table: "project_series" */
  update_project_series_many?: Maybe<Array<Maybe<Project_Series_Mutation_Response>>>;
  /** update data of the table: "project_vertical_categories" */
  update_project_vertical_categories?: Maybe<Project_Vertical_Categories_Mutation_Response>;
  /** update single row of the table: "project_vertical_categories" */
  update_project_vertical_categories_by_pk?: Maybe<Project_Vertical_Categories>;
  /** update multiples rows of table: "project_vertical_categories" */
  update_project_vertical_categories_many?: Maybe<Array<Maybe<Project_Vertical_Categories_Mutation_Response>>>;
  /** update data of the table: "project_verticals" */
  update_project_verticals?: Maybe<Project_Verticals_Mutation_Response>;
  /** update single row of the table: "project_verticals" */
  update_project_verticals_by_pk?: Maybe<Project_Verticals>;
  /** update multiples rows of table: "project_verticals" */
  update_project_verticals_many?: Maybe<Array<Maybe<Project_Verticals_Mutation_Response>>>;
  /** update data of the table: "projects_features" */
  update_projects_features?: Maybe<Projects_Features_Mutation_Response>;
  /** update single row of the table: "projects_features" */
  update_projects_features_by_pk?: Maybe<Projects_Features>;
  /** update multiples rows of table: "projects_features" */
  update_projects_features_many?: Maybe<Array<Maybe<Projects_Features_Mutation_Response>>>;
  /** update data of the table: "projects_metadata" */
  update_projects_metadata?: Maybe<Projects_Metadata_Mutation_Response>;
  /** update single row of the table: "projects_metadata" */
  update_projects_metadata_by_pk?: Maybe<Projects_Metadata>;
  /** update multiples rows of table: "projects_metadata" */
  update_projects_metadata_many?: Maybe<Array<Maybe<Projects_Metadata_Mutation_Response>>>;
  /** update data of the table: "proposed_artist_addresses_and_splits" */
  update_proposed_artist_addresses_and_splits?: Maybe<Proposed_Artist_Addresses_And_Splits_Mutation_Response>;
  /** update single row of the table: "proposed_artist_addresses_and_splits" */
  update_proposed_artist_addresses_and_splits_by_pk?: Maybe<Proposed_Artist_Addresses_And_Splits>;
  /** update multiples rows of table: "proposed_artist_addresses_and_splits" */
  update_proposed_artist_addresses_and_splits_many?: Maybe<Array<Maybe<Proposed_Artist_Addresses_And_Splits_Mutation_Response>>>;
  /** update data of the table: "receipt_metadata" */
  update_receipt_metadata?: Maybe<Receipt_Metadata_Mutation_Response>;
  /** update single row of the table: "receipt_metadata" */
  update_receipt_metadata_by_pk?: Maybe<Receipt_Metadata>;
  /** update multiples rows of table: "receipt_metadata" */
  update_receipt_metadata_many?: Maybe<Array<Maybe<Receipt_Metadata_Mutation_Response>>>;
  /** update data of the table: "refresh_asset_types" */
  update_refresh_asset_types?: Maybe<Refresh_Asset_Types_Mutation_Response>;
  /** update single row of the table: "refresh_asset_types" */
  update_refresh_asset_types_by_pk?: Maybe<Refresh_Asset_Types>;
  /** update multiples rows of table: "refresh_asset_types" */
  update_refresh_asset_types_many?: Maybe<Array<Maybe<Refresh_Asset_Types_Mutation_Response>>>;
  /** update data of the table: "refresh_request_types" */
  update_refresh_request_types?: Maybe<Refresh_Request_Types_Mutation_Response>;
  /** update single row of the table: "refresh_request_types" */
  update_refresh_request_types_by_pk?: Maybe<Refresh_Request_Types>;
  /** update multiples rows of table: "refresh_request_types" */
  update_refresh_request_types_many?: Maybe<Array<Maybe<Refresh_Request_Types_Mutation_Response>>>;
  /** update data of the table: "refresh_requests" */
  update_refresh_requests?: Maybe<Refresh_Requests_Mutation_Response>;
  /** update single row of the table: "refresh_requests" */
  update_refresh_requests_by_pk?: Maybe<Refresh_Requests>;
  /** update multiples rows of table: "refresh_requests" */
  update_refresh_requests_many?: Maybe<Array<Maybe<Refresh_Requests_Mutation_Response>>>;
  /** update data of the table: "render_types" */
  update_render_types?: Maybe<Render_Types_Mutation_Response>;
  /** update single row of the table: "render_types" */
  update_render_types_by_pk?: Maybe<Render_Types>;
  /** update multiples rows of table: "render_types" */
  update_render_types_many?: Maybe<Array<Maybe<Render_Types_Mutation_Response>>>;
  /** update data of the table: "royalty_split_recipients" */
  update_royalty_split_recipients?: Maybe<Royalty_Split_Recipients_Mutation_Response>;
  /** update single row of the table: "royalty_split_recipients" */
  update_royalty_split_recipients_by_pk?: Maybe<Royalty_Split_Recipients>;
  /** update multiples rows of table: "royalty_split_recipients" */
  update_royalty_split_recipients_many?: Maybe<Array<Maybe<Royalty_Split_Recipients_Mutation_Response>>>;
  /** update data of the table: "royalty_splitter_contracts" */
  update_royalty_splitter_contracts?: Maybe<Royalty_Splitter_Contracts_Mutation_Response>;
  /** update single row of the table: "royalty_splitter_contracts" */
  update_royalty_splitter_contracts_by_pk?: Maybe<Royalty_Splitter_Contracts>;
  /** update multiples rows of table: "royalty_splitter_contracts" */
  update_royalty_splitter_contracts_many?: Maybe<Array<Maybe<Royalty_Splitter_Contracts_Mutation_Response>>>;
  /** update data of the table: "screenings" */
  update_screenings?: Maybe<Screenings_Mutation_Response>;
  /** update single row of the table: "screenings" */
  update_screenings_by_pk?: Maybe<Screenings>;
  /** update multiples rows of table: "screenings" */
  update_screenings_many?: Maybe<Array<Maybe<Screenings_Mutation_Response>>>;
  /** update data of the table: "split_atomic_contracts" */
  update_split_atomic_contracts?: Maybe<Split_Atomic_Contracts_Mutation_Response>;
  /** update single row of the table: "split_atomic_contracts" */
  update_split_atomic_contracts_by_pk?: Maybe<Split_Atomic_Contracts>;
  /** update multiples rows of table: "split_atomic_contracts" */
  update_split_atomic_contracts_many?: Maybe<Array<Maybe<Split_Atomic_Contracts_Mutation_Response>>>;
  /** update data of the table: "split_atomic_factories" */
  update_split_atomic_factories?: Maybe<Split_Atomic_Factories_Mutation_Response>;
  /** update single row of the table: "split_atomic_factories" */
  update_split_atomic_factories_by_pk?: Maybe<Split_Atomic_Factories>;
  /** update multiples rows of table: "split_atomic_factories" */
  update_split_atomic_factories_many?: Maybe<Array<Maybe<Split_Atomic_Factories_Mutation_Response>>>;
  /** update data of the table: "split_payment_configurations" */
  update_split_payment_configurations?: Maybe<Split_Payment_Configurations_Mutation_Response>;
  /** update single row of the table: "split_payment_configurations" */
  update_split_payment_configurations_by_pk?: Maybe<Split_Payment_Configurations>;
  /** update multiples rows of table: "split_payment_configurations" */
  update_split_payment_configurations_many?: Maybe<Array<Maybe<Split_Payment_Configurations_Mutation_Response>>>;
  /** update data of the table: "sync_status" */
  update_sync_status?: Maybe<Sync_Status_Mutation_Response>;
  /** update single row of the table: "sync_status" */
  update_sync_status_by_pk?: Maybe<Sync_Status>;
  /** update multiples rows of table: "sync_status" */
  update_sync_status_many?: Maybe<Array<Maybe<Sync_Status_Mutation_Response>>>;
  /** update data of the table: "tag_groupings" */
  update_tag_groupings?: Maybe<Tag_Groupings_Mutation_Response>;
  /** update single row of the table: "tag_groupings" */
  update_tag_groupings_by_pk?: Maybe<Tag_Groupings>;
  /** update multiples rows of table: "tag_groupings" */
  update_tag_groupings_many?: Maybe<Array<Maybe<Tag_Groupings_Mutation_Response>>>;
  /** update data of the table: "tag_status" */
  update_tag_status?: Maybe<Tag_Status_Mutation_Response>;
  /** update single row of the table: "tag_status" */
  update_tag_status_by_pk?: Maybe<Tag_Status>;
  /** update multiples rows of table: "tag_status" */
  update_tag_status_many?: Maybe<Array<Maybe<Tag_Status_Mutation_Response>>>;
  /** update data of the table: "tag_types" */
  update_tag_types?: Maybe<Tag_Types_Mutation_Response>;
  /** update single row of the table: "tag_types" */
  update_tag_types_by_pk?: Maybe<Tag_Types>;
  /** update multiples rows of table: "tag_types" */
  update_tag_types_many?: Maybe<Array<Maybe<Tag_Types_Mutation_Response>>>;
  /** update data of the table: "tags" */
  update_tags?: Maybe<Tags_Mutation_Response>;
  /** update single row of the table: "tags" */
  update_tags_by_pk?: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  update_tags_many?: Maybe<Array<Maybe<Tags_Mutation_Response>>>;
  /** update data of the table: "tokens_metadata" */
  update_tokens_metadata?: Maybe<Tokens_Metadata_Mutation_Response>;
  /** update single row of the table: "tokens_metadata" */
  update_tokens_metadata_by_pk?: Maybe<Tokens_Metadata>;
  /** update multiples rows of table: "tokens_metadata" */
  update_tokens_metadata_many?: Maybe<Array<Maybe<Tokens_Metadata_Mutation_Response>>>;
  /** update data of the table: "user_profiles" */
  update_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** update single row of the table: "user_profiles" */
  update_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** update multiples rows of table: "user_profiles" */
  update_user_profiles_many?: Maybe<Array<Maybe<User_Profiles_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "verticals" */
  update_verticals?: Maybe<Verticals_Mutation_Response>;
  /** update single row of the table: "verticals" */
  update_verticals_by_pk?: Maybe<Verticals>;
  /** update multiples rows of table: "verticals" */
  update_verticals_many?: Maybe<Array<Maybe<Verticals_Mutation_Response>>>;
  /** update data of the table: "video_aspect_ratios" */
  update_video_aspect_ratios?: Maybe<Video_Aspect_Ratios_Mutation_Response>;
  /** update single row of the table: "video_aspect_ratios" */
  update_video_aspect_ratios_by_pk?: Maybe<Video_Aspect_Ratios>;
  /** update multiples rows of table: "video_aspect_ratios" */
  update_video_aspect_ratios_many?: Maybe<Array<Maybe<Video_Aspect_Ratios_Mutation_Response>>>;
  /** update data of the table: "video_frame_rates" */
  update_video_frame_rates?: Maybe<Video_Frame_Rates_Mutation_Response>;
  /** update single row of the table: "video_frame_rates" */
  update_video_frame_rates_by_pk?: Maybe<Video_Frame_Rates>;
  /** update multiples rows of table: "video_frame_rates" */
  update_video_frame_rates_many?: Maybe<Array<Maybe<Video_Frame_Rates_Mutation_Response>>>;
  /** update data of the table: "webflow_artist_info" */
  update_webflow_artist_info?: Maybe<Webflow_Artist_Info_Mutation_Response>;
  /** update single row of the table: "webflow_artist_info" */
  update_webflow_artist_info_by_pk?: Maybe<Webflow_Artist_Info>;
  /** update multiples rows of table: "webflow_artist_info" */
  update_webflow_artist_info_many?: Maybe<Array<Maybe<Webflow_Artist_Info_Mutation_Response>>>;
  /** update data of the table: "webflow_spectrum_articles" */
  update_webflow_spectrum_articles?: Maybe<Webflow_Spectrum_Articles_Mutation_Response>;
  /** update single row of the table: "webflow_spectrum_articles" */
  update_webflow_spectrum_articles_by_pk?: Maybe<Webflow_Spectrum_Articles>;
  /** update multiples rows of table: "webflow_spectrum_articles" */
  update_webflow_spectrum_articles_many?: Maybe<Array<Maybe<Webflow_Spectrum_Articles_Mutation_Response>>>;
  upload: UploadFileEntityResponse;
};


/** mutation root */
export type Mutation_RootAuthenticateArgs = {
  input: AuthenticateInput;
};


/** mutation root */
export type Mutation_RootChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateApplicationArgs = {
  formData?: InputMaybe<CreateApplicationInput>;
};


/** mutation root */
export type Mutation_RootCreateArticleArgs = {
  data: ArticleInput;
};


/** mutation root */
export type Mutation_RootCreateArtistEditorialPageArgs = {
  data: ArtistEditorialPageInput;
};


/** mutation root */
export type Mutation_RootCreateExhibitionArgs = {
  data: ExhibitionInput;
};


/** mutation root */
export type Mutation_RootCreateHighlightArgs = {
  data: HighlightInput;
};


/** mutation root */
export type Mutation_RootCreateMinterInfoArgs = {
  data: MinterInfoInput;
};


/** mutation root */
export type Mutation_RootCreateProjectPageArgs = {
  data: ProjectPageInput;
};


/** mutation root */
export type Mutation_RootCreateUploadFileArgs = {
  data: UploadFileInput;
};


/** mutation root */
export type Mutation_RootCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


/** mutation root */
export type Mutation_RootCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


/** mutation root */
export type Mutation_RootCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


/** mutation root */
export type Mutation_RootDeleteArticleArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteArtistEditorialPageArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteExhibitionArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteHighlightArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteMinterInfoArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteProjectPageArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bid_TypesArgs = {
  where: Bid_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bid_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bids_MetadataArgs = {
  where: Bids_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bids_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CategoriesArgs = {
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Categories_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Contract_AllowlistingsArgs = {
  where: Contract_Allowlistings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contract_Allowlistings_By_PkArgs = {
  contract_address: Scalars['String']['input'];
  user_address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Contract_Type_NamesArgs = {
  where: Contract_Type_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contract_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Contract_TypesArgs = {
  where: Contract_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contract_Types_By_PkArgs = {
  type: Contract_Type_Names_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Contracts_MetadataArgs = {
  where: Contracts_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contracts_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Core_Registries_MetadataArgs = {
  where: Core_Registries_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Core_Registries_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Curation_StatusesArgs = {
  where: Curation_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Curation_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dependencies_MetadataArgs = {
  where: Dependencies_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dependencies_Metadata_By_PkArgs = {
  name_and_version: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dependency_Additional_CdnsArgs = {
  where: Dependency_Additional_Cdns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dependency_Additional_Cdns_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dependency_Additional_RepositoriesArgs = {
  where: Dependency_Additional_Repositories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dependency_Additional_Repositories_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dependency_RegistriesArgs = {
  where: Dependency_Registries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dependency_Registries_By_PkArgs = {
  address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Dependency_ScriptsArgs = {
  where: Dependency_Scripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dependency_Scripts_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Entity_TagsArgs = {
  where: Entity_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_Tags_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Environment_ConfigurationArgs = {
  where: Environment_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Environment_Configuration_By_PkArgs = {
  id: Scalars['Boolean']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FavoritesArgs = {
  where: Favorites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Favorites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_FlagsArgs = {
  where: Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Flags_By_PkArgs = {
  flag_name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MediaArgs = {
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Media_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Minter_Filter_Type_NamesArgs = {
  where: Minter_Filter_Type_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Minter_Filter_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Minter_Filters_MetadataArgs = {
  where: Minter_Filters_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Minter_Filters_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Minter_Type_NamesArgs = {
  where: Minter_Type_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Minter_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Minter_TypesArgs = {
  where: Minter_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Minter_Types_By_PkArgs = {
  type: Minter_Type_Names_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Minters_MetadataArgs = {
  where: Minters_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Minters_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mixpanel_LookupArgs = {
  where: Mixpanel_Lookup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mixpanel_Lookup_By_PkArgs = {
  hash: Scalars['String']['input'];
  mixpanel_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notifications_By_PkArgs = {
  trigger_key: Scalars['String']['input'];
  trigger_time: Scalars['timestamptz']['input'];
  user_address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Oob_Tokens_MetadataArgs = {
  where: Oob_Tokens_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Oob_Tokens_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Partner_TypesArgs = {
  where: Partner_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PartnersArgs = {
  where: Partners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partners_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pmp_Auth_OptionsArgs = {
  where: Pmp_Auth_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pmp_Auth_Options_By_PkArgs = {
  option: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pmp_ConfigsArgs = {
  where: Pmp_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pmp_Configs_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pmp_Param_TypesArgs = {
  where: Pmp_Param_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pmp_Param_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pmp_Project_ConfigsArgs = {
  where: Pmp_Project_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pmp_Project_Configs_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pmps_MetadataArgs = {
  where: Pmps_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pmps_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Primary_PurchasesArgs = {
  where: Primary_Purchases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Primary_Purchases_By_PkArgs = {
  token_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Processing_JobsArgs = {
  where: Processing_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Processing_Jobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Processing_Jobs_Status_TypesArgs = {
  where: Processing_Jobs_Status_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Processing_Jobs_Status_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_External_Asset_DependenciesArgs = {
  where: Project_External_Asset_Dependencies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_External_Asset_Dependencies_By_PkArgs = {
  index: Scalars['Int']['input'];
  project_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_External_Asset_Dependency_TypesArgs = {
  where: Project_External_Asset_Dependency_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_External_Asset_Dependency_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Minter_ConfigurationsArgs = {
  where: Project_Minter_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Minter_Configurations_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_ScriptsArgs = {
  where: Project_Scripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Scripts_By_PkArgs = {
  index: Scalars['Int']['input'];
  project_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_SeriesArgs = {
  where: Project_Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Series_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Vertical_CategoriesArgs = {
  where: Project_Vertical_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Vertical_Categories_By_PkArgs = {
  name: Categories_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Project_VerticalsArgs = {
  where: Project_Verticals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Verticals_By_PkArgs = {
  name: Verticals_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Projects_FeaturesArgs = {
  where: Projects_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Projects_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Projects_MetadataArgs = {
  where: Projects_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Projects_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Proposed_Artist_Addresses_And_SplitsArgs = {
  where: Proposed_Artist_Addresses_And_Splits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Proposed_Artist_Addresses_And_Splits_By_PkArgs = {
  project_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Receipt_MetadataArgs = {
  where: Receipt_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Receipt_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Refresh_Asset_TypesArgs = {
  where: Refresh_Asset_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refresh_Asset_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Refresh_Request_TypesArgs = {
  where: Refresh_Request_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refresh_Request_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Refresh_RequestsArgs = {
  where: Refresh_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refresh_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Render_TypesArgs = {
  where: Render_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Render_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Royalty_Split_RecipientsArgs = {
  where: Royalty_Split_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Royalty_Split_Recipients_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Royalty_Splitter_ContractsArgs = {
  where: Royalty_Splitter_Contracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Royalty_Splitter_Contracts_By_PkArgs = {
  address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ScreeningsArgs = {
  where: Screenings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Screenings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Split_Atomic_ContractsArgs = {
  where: Split_Atomic_Contracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Split_Atomic_Contracts_By_PkArgs = {
  address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Split_Atomic_FactoriesArgs = {
  where: Split_Atomic_Factories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Split_Atomic_Factories_By_PkArgs = {
  address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Split_Payment_ConfigurationsArgs = {
  where: Split_Payment_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Split_Payment_Configurations_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sync_StatusArgs = {
  where: Sync_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sync_Status_By_PkArgs = {
  id: Scalars['Boolean']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_GroupingsArgs = {
  where: Tag_Groupings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Groupings_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_StatusArgs = {
  where: Tag_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_TypesArgs = {
  where: Tag_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TagsArgs = {
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tags_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tokens_MetadataArgs = {
  where: Tokens_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tokens_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProfilesArgs = {
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profiles_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  public_address: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VerticalsArgs = {
  where: Verticals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Verticals_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Video_Aspect_RatiosArgs = {
  where: Video_Aspect_Ratios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Video_Aspect_Ratios_By_PkArgs = {
  value: Scalars['numeric']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Video_Frame_RatesArgs = {
  where: Video_Frame_Rates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Video_Frame_Rates_By_PkArgs = {
  value: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Webflow_Artist_InfoArgs = {
  where: Webflow_Artist_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Webflow_Artist_Info_By_PkArgs = {
  webflow_item_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Webflow_Spectrum_ArticlesArgs = {
  where: Webflow_Spectrum_Articles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Webflow_Spectrum_Articles_By_PkArgs = {
  webflow_item_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Bid_TypesArgs = {
  objects: Array<Bid_Types_Insert_Input>;
  on_conflict?: InputMaybe<Bid_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bid_Types_OneArgs = {
  object: Bid_Types_Insert_Input;
  on_conflict?: InputMaybe<Bid_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bids_MetadataArgs = {
  objects: Array<Bids_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Bids_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bids_Metadata_OneArgs = {
  object: Bids_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Bids_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoriesArgs = {
  objects: Array<Categories_Insert_Input>;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Categories_OneArgs = {
  object: Categories_Insert_Input;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contract_AllowlistingsArgs = {
  objects: Array<Contract_Allowlistings_Insert_Input>;
  on_conflict?: InputMaybe<Contract_Allowlistings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contract_Allowlistings_OneArgs = {
  object: Contract_Allowlistings_Insert_Input;
  on_conflict?: InputMaybe<Contract_Allowlistings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contract_Type_NamesArgs = {
  objects: Array<Contract_Type_Names_Insert_Input>;
  on_conflict?: InputMaybe<Contract_Type_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contract_Type_Names_OneArgs = {
  object: Contract_Type_Names_Insert_Input;
  on_conflict?: InputMaybe<Contract_Type_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contract_TypesArgs = {
  objects: Array<Contract_Types_Insert_Input>;
  on_conflict?: InputMaybe<Contract_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contract_Types_OneArgs = {
  object: Contract_Types_Insert_Input;
  on_conflict?: InputMaybe<Contract_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contracts_MetadataArgs = {
  objects: Array<Contracts_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Contracts_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contracts_Metadata_OneArgs = {
  object: Contracts_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Contracts_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Core_Registries_MetadataArgs = {
  objects: Array<Core_Registries_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Core_Registries_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Core_Registries_Metadata_OneArgs = {
  object: Core_Registries_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Core_Registries_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Curation_StatusesArgs = {
  objects: Array<Curation_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Curation_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Curation_Statuses_OneArgs = {
  object: Curation_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Curation_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependencies_MetadataArgs = {
  objects: Array<Dependencies_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Dependencies_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependencies_Metadata_OneArgs = {
  object: Dependencies_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Dependencies_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependency_Additional_CdnsArgs = {
  objects: Array<Dependency_Additional_Cdns_Insert_Input>;
  on_conflict?: InputMaybe<Dependency_Additional_Cdns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependency_Additional_Cdns_OneArgs = {
  object: Dependency_Additional_Cdns_Insert_Input;
  on_conflict?: InputMaybe<Dependency_Additional_Cdns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependency_Additional_RepositoriesArgs = {
  objects: Array<Dependency_Additional_Repositories_Insert_Input>;
  on_conflict?: InputMaybe<Dependency_Additional_Repositories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependency_Additional_Repositories_OneArgs = {
  object: Dependency_Additional_Repositories_Insert_Input;
  on_conflict?: InputMaybe<Dependency_Additional_Repositories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependency_RegistriesArgs = {
  objects: Array<Dependency_Registries_Insert_Input>;
  on_conflict?: InputMaybe<Dependency_Registries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependency_Registries_OneArgs = {
  object: Dependency_Registries_Insert_Input;
  on_conflict?: InputMaybe<Dependency_Registries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependency_ScriptsArgs = {
  objects: Array<Dependency_Scripts_Insert_Input>;
  on_conflict?: InputMaybe<Dependency_Scripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dependency_Scripts_OneArgs = {
  object: Dependency_Scripts_Insert_Input;
  on_conflict?: InputMaybe<Dependency_Scripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_TagsArgs = {
  objects: Array<Entity_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Entity_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_Tags_OneArgs = {
  object: Entity_Tags_Insert_Input;
  on_conflict?: InputMaybe<Entity_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Environment_ConfigurationArgs = {
  objects: Array<Environment_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Environment_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Environment_Configuration_OneArgs = {
  object: Environment_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Environment_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FavoritesArgs = {
  objects: Array<Favorites_Insert_Input>;
  on_conflict?: InputMaybe<Favorites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Favorites_OneArgs = {
  object: Favorites_Insert_Input;
  on_conflict?: InputMaybe<Favorites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_FlagsArgs = {
  objects: Array<Feature_Flags_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Flags_OneArgs = {
  object: Feature_Flags_Insert_Input;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MediaArgs = {
  objects: Array<Media_Insert_Input>;
  on_conflict?: InputMaybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Media_OneArgs = {
  object: Media_Insert_Input;
  on_conflict?: InputMaybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minter_Filter_Type_NamesArgs = {
  objects: Array<Minter_Filter_Type_Names_Insert_Input>;
  on_conflict?: InputMaybe<Minter_Filter_Type_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minter_Filter_Type_Names_OneArgs = {
  object: Minter_Filter_Type_Names_Insert_Input;
  on_conflict?: InputMaybe<Minter_Filter_Type_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minter_Filters_MetadataArgs = {
  objects: Array<Minter_Filters_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Minter_Filters_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minter_Filters_Metadata_OneArgs = {
  object: Minter_Filters_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Minter_Filters_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minter_Type_NamesArgs = {
  objects: Array<Minter_Type_Names_Insert_Input>;
  on_conflict?: InputMaybe<Minter_Type_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minter_Type_Names_OneArgs = {
  object: Minter_Type_Names_Insert_Input;
  on_conflict?: InputMaybe<Minter_Type_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minter_TypesArgs = {
  objects: Array<Minter_Types_Insert_Input>;
  on_conflict?: InputMaybe<Minter_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minter_Types_OneArgs = {
  object: Minter_Types_Insert_Input;
  on_conflict?: InputMaybe<Minter_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minters_MetadataArgs = {
  objects: Array<Minters_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Minters_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Minters_Metadata_OneArgs = {
  object: Minters_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Minters_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mixpanel_LookupArgs = {
  objects: Array<Mixpanel_Lookup_Insert_Input>;
  on_conflict?: InputMaybe<Mixpanel_Lookup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mixpanel_Lookup_OneArgs = {
  object: Mixpanel_Lookup_Insert_Input;
  on_conflict?: InputMaybe<Mixpanel_Lookup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notifications_OneArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oob_Tokens_MetadataArgs = {
  objects: Array<Oob_Tokens_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Oob_Tokens_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Oob_Tokens_Metadata_OneArgs = {
  object: Oob_Tokens_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Oob_Tokens_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_TypesArgs = {
  objects: Array<Partner_Types_Insert_Input>;
  on_conflict?: InputMaybe<Partner_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Types_OneArgs = {
  object: Partner_Types_Insert_Input;
  on_conflict?: InputMaybe<Partner_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnersArgs = {
  objects: Array<Partners_Insert_Input>;
  on_conflict?: InputMaybe<Partners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partners_OneArgs = {
  object: Partners_Insert_Input;
  on_conflict?: InputMaybe<Partners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmp_Auth_OptionsArgs = {
  objects: Array<Pmp_Auth_Options_Insert_Input>;
  on_conflict?: InputMaybe<Pmp_Auth_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmp_Auth_Options_OneArgs = {
  object: Pmp_Auth_Options_Insert_Input;
  on_conflict?: InputMaybe<Pmp_Auth_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmp_ConfigsArgs = {
  objects: Array<Pmp_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Pmp_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmp_Configs_OneArgs = {
  object: Pmp_Configs_Insert_Input;
  on_conflict?: InputMaybe<Pmp_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmp_Param_TypesArgs = {
  objects: Array<Pmp_Param_Types_Insert_Input>;
  on_conflict?: InputMaybe<Pmp_Param_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmp_Param_Types_OneArgs = {
  object: Pmp_Param_Types_Insert_Input;
  on_conflict?: InputMaybe<Pmp_Param_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmp_Project_ConfigsArgs = {
  objects: Array<Pmp_Project_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Pmp_Project_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmp_Project_Configs_OneArgs = {
  object: Pmp_Project_Configs_Insert_Input;
  on_conflict?: InputMaybe<Pmp_Project_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmps_MetadataArgs = {
  objects: Array<Pmps_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Pmps_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pmps_Metadata_OneArgs = {
  object: Pmps_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Pmps_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Primary_PurchasesArgs = {
  objects: Array<Primary_Purchases_Insert_Input>;
  on_conflict?: InputMaybe<Primary_Purchases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Primary_Purchases_OneArgs = {
  object: Primary_Purchases_Insert_Input;
  on_conflict?: InputMaybe<Primary_Purchases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Processing_JobsArgs = {
  objects: Array<Processing_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Processing_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Processing_Jobs_OneArgs = {
  object: Processing_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Processing_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Processing_Jobs_Status_TypesArgs = {
  objects: Array<Processing_Jobs_Status_Types_Insert_Input>;
  on_conflict?: InputMaybe<Processing_Jobs_Status_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Processing_Jobs_Status_Types_OneArgs = {
  object: Processing_Jobs_Status_Types_Insert_Input;
  on_conflict?: InputMaybe<Processing_Jobs_Status_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_External_Asset_DependenciesArgs = {
  objects: Array<Project_External_Asset_Dependencies_Insert_Input>;
  on_conflict?: InputMaybe<Project_External_Asset_Dependencies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_External_Asset_Dependencies_OneArgs = {
  object: Project_External_Asset_Dependencies_Insert_Input;
  on_conflict?: InputMaybe<Project_External_Asset_Dependencies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_External_Asset_Dependency_TypesArgs = {
  objects: Array<Project_External_Asset_Dependency_Types_Insert_Input>;
  on_conflict?: InputMaybe<Project_External_Asset_Dependency_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_External_Asset_Dependency_Types_OneArgs = {
  object: Project_External_Asset_Dependency_Types_Insert_Input;
  on_conflict?: InputMaybe<Project_External_Asset_Dependency_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Minter_ConfigurationsArgs = {
  objects: Array<Project_Minter_Configurations_Insert_Input>;
  on_conflict?: InputMaybe<Project_Minter_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Minter_Configurations_OneArgs = {
  object: Project_Minter_Configurations_Insert_Input;
  on_conflict?: InputMaybe<Project_Minter_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ScriptsArgs = {
  objects: Array<Project_Scripts_Insert_Input>;
  on_conflict?: InputMaybe<Project_Scripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Scripts_OneArgs = {
  object: Project_Scripts_Insert_Input;
  on_conflict?: InputMaybe<Project_Scripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_SeriesArgs = {
  objects: Array<Project_Series_Insert_Input>;
  on_conflict?: InputMaybe<Project_Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Series_OneArgs = {
  object: Project_Series_Insert_Input;
  on_conflict?: InputMaybe<Project_Series_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Vertical_CategoriesArgs = {
  objects: Array<Project_Vertical_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Project_Vertical_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Vertical_Categories_OneArgs = {
  object: Project_Vertical_Categories_Insert_Input;
  on_conflict?: InputMaybe<Project_Vertical_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_VerticalsArgs = {
  objects: Array<Project_Verticals_Insert_Input>;
  on_conflict?: InputMaybe<Project_Verticals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Verticals_OneArgs = {
  object: Project_Verticals_Insert_Input;
  on_conflict?: InputMaybe<Project_Verticals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_FeaturesArgs = {
  objects: Array<Projects_Features_Insert_Input>;
  on_conflict?: InputMaybe<Projects_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_Features_OneArgs = {
  object: Projects_Features_Insert_Input;
  on_conflict?: InputMaybe<Projects_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_MetadataArgs = {
  objects: Array<Projects_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Projects_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_Metadata_OneArgs = {
  object: Projects_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Projects_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Proposed_Artist_Addresses_And_SplitsArgs = {
  objects: Array<Proposed_Artist_Addresses_And_Splits_Insert_Input>;
  on_conflict?: InputMaybe<Proposed_Artist_Addresses_And_Splits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Proposed_Artist_Addresses_And_Splits_OneArgs = {
  object: Proposed_Artist_Addresses_And_Splits_Insert_Input;
  on_conflict?: InputMaybe<Proposed_Artist_Addresses_And_Splits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Receipt_MetadataArgs = {
  objects: Array<Receipt_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Receipt_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Receipt_Metadata_OneArgs = {
  object: Receipt_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Receipt_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_Asset_TypesArgs = {
  objects: Array<Refresh_Asset_Types_Insert_Input>;
  on_conflict?: InputMaybe<Refresh_Asset_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_Asset_Types_OneArgs = {
  object: Refresh_Asset_Types_Insert_Input;
  on_conflict?: InputMaybe<Refresh_Asset_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_Request_TypesArgs = {
  objects: Array<Refresh_Request_Types_Insert_Input>;
  on_conflict?: InputMaybe<Refresh_Request_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_Request_Types_OneArgs = {
  object: Refresh_Request_Types_Insert_Input;
  on_conflict?: InputMaybe<Refresh_Request_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_RequestsArgs = {
  objects: Array<Refresh_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Refresh_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_Requests_OneArgs = {
  object: Refresh_Requests_Insert_Input;
  on_conflict?: InputMaybe<Refresh_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Render_TypesArgs = {
  objects: Array<Render_Types_Insert_Input>;
  on_conflict?: InputMaybe<Render_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Render_Types_OneArgs = {
  object: Render_Types_Insert_Input;
  on_conflict?: InputMaybe<Render_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Royalty_Split_RecipientsArgs = {
  objects: Array<Royalty_Split_Recipients_Insert_Input>;
  on_conflict?: InputMaybe<Royalty_Split_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Royalty_Split_Recipients_OneArgs = {
  object: Royalty_Split_Recipients_Insert_Input;
  on_conflict?: InputMaybe<Royalty_Split_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Royalty_Splitter_ContractsArgs = {
  objects: Array<Royalty_Splitter_Contracts_Insert_Input>;
  on_conflict?: InputMaybe<Royalty_Splitter_Contracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Royalty_Splitter_Contracts_OneArgs = {
  object: Royalty_Splitter_Contracts_Insert_Input;
  on_conflict?: InputMaybe<Royalty_Splitter_Contracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScreeningsArgs = {
  objects: Array<Screenings_Insert_Input>;
  on_conflict?: InputMaybe<Screenings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Screenings_OneArgs = {
  object: Screenings_Insert_Input;
  on_conflict?: InputMaybe<Screenings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Split_Atomic_ContractsArgs = {
  objects: Array<Split_Atomic_Contracts_Insert_Input>;
  on_conflict?: InputMaybe<Split_Atomic_Contracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Split_Atomic_Contracts_OneArgs = {
  object: Split_Atomic_Contracts_Insert_Input;
  on_conflict?: InputMaybe<Split_Atomic_Contracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Split_Atomic_FactoriesArgs = {
  objects: Array<Split_Atomic_Factories_Insert_Input>;
  on_conflict?: InputMaybe<Split_Atomic_Factories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Split_Atomic_Factories_OneArgs = {
  object: Split_Atomic_Factories_Insert_Input;
  on_conflict?: InputMaybe<Split_Atomic_Factories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Split_Payment_ConfigurationsArgs = {
  objects: Array<Split_Payment_Configurations_Insert_Input>;
  on_conflict?: InputMaybe<Split_Payment_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Split_Payment_Configurations_OneArgs = {
  object: Split_Payment_Configurations_Insert_Input;
  on_conflict?: InputMaybe<Split_Payment_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sync_StatusArgs = {
  objects: Array<Sync_Status_Insert_Input>;
  on_conflict?: InputMaybe<Sync_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sync_Status_OneArgs = {
  object: Sync_Status_Insert_Input;
  on_conflict?: InputMaybe<Sync_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_GroupingsArgs = {
  objects: Array<Tag_Groupings_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Groupings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Groupings_OneArgs = {
  object: Tag_Groupings_Insert_Input;
  on_conflict?: InputMaybe<Tag_Groupings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_StatusArgs = {
  objects: Array<Tag_Status_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Status_OneArgs = {
  object: Tag_Status_Insert_Input;
  on_conflict?: InputMaybe<Tag_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_TypesArgs = {
  objects: Array<Tag_Types_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Types_OneArgs = {
  object: Tag_Types_Insert_Input;
  on_conflict?: InputMaybe<Tag_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagsArgs = {
  objects: Array<Tags_Insert_Input>;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tags_OneArgs = {
  object: Tags_Insert_Input;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tokens_MetadataArgs = {
  objects: Array<Tokens_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Tokens_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tokens_Metadata_OneArgs = {
  object: Tokens_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Tokens_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProfilesArgs = {
  objects: Array<User_Profiles_Insert_Input>;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profiles_OneArgs = {
  object: User_Profiles_Insert_Input;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VerticalsArgs = {
  objects: Array<Verticals_Insert_Input>;
  on_conflict?: InputMaybe<Verticals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Verticals_OneArgs = {
  object: Verticals_Insert_Input;
  on_conflict?: InputMaybe<Verticals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Video_Aspect_RatiosArgs = {
  objects: Array<Video_Aspect_Ratios_Insert_Input>;
  on_conflict?: InputMaybe<Video_Aspect_Ratios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Video_Aspect_Ratios_OneArgs = {
  object: Video_Aspect_Ratios_Insert_Input;
  on_conflict?: InputMaybe<Video_Aspect_Ratios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Video_Frame_RatesArgs = {
  objects: Array<Video_Frame_Rates_Insert_Input>;
  on_conflict?: InputMaybe<Video_Frame_Rates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Video_Frame_Rates_OneArgs = {
  object: Video_Frame_Rates_Insert_Input;
  on_conflict?: InputMaybe<Video_Frame_Rates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webflow_Artist_InfoArgs = {
  objects: Array<Webflow_Artist_Info_Insert_Input>;
  on_conflict?: InputMaybe<Webflow_Artist_Info_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webflow_Artist_Info_OneArgs = {
  object: Webflow_Artist_Info_Insert_Input;
  on_conflict?: InputMaybe<Webflow_Artist_Info_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webflow_Spectrum_ArticlesArgs = {
  objects: Array<Webflow_Spectrum_Articles_Insert_Input>;
  on_conflict?: InputMaybe<Webflow_Spectrum_Articles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webflow_Spectrum_Articles_OneArgs = {
  object: Webflow_Spectrum_Articles_Insert_Input;
  on_conflict?: InputMaybe<Webflow_Spectrum_Articles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLoginArgs = {
  input: UsersPermissionsLoginInput;
};


/** mutation root */
export type Mutation_RootMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


/** mutation root */
export type Mutation_RootPrivyAuthenticateArgs = {
  input: PrivyAuthenticateInput;
};


/** mutation root */
export type Mutation_RootRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


/** mutation root */
export type Mutation_RootRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateArticleArgs = {
  data: ArticleInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateArtistEditorialPageArgs = {
  data: ArtistEditorialPageInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateCuratedHomePageArgs = {
  data: CuratedHomePageInput;
};


/** mutation root */
export type Mutation_RootUpdateExhibitionArgs = {
  data: ExhibitionInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateFeaturesArgs = {
  featureFields: Scalars['jsonb']['input'];
  featuresScript: Scalars['String']['input'];
  generate?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


/** mutation root */
export type Mutation_RootUpdateHighlightArgs = {
  data: HighlightInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateHomePageArgs = {
  data: HomePageInput;
};


/** mutation root */
export type Mutation_RootUpdateLandingPageArgs = {
  data: LandingPageInput;
};


/** mutation root */
export type Mutation_RootUpdateMinterInfoArgs = {
  data: MinterInfoInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateProjectMediaArgs = {
  features?: InputMaybe<Scalars['Boolean']['input']>;
  oob?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['String']['input'];
  render?: InputMaybe<Scalars['Boolean']['input']>;
  renderVideo?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateProjectPageArgs = {
  data: ProjectPageInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateTokenMediaArgs = {
  features?: InputMaybe<Scalars['Boolean']['input']>;
  render?: InputMaybe<Scalars['Boolean']['input']>;
  renderVideo?: InputMaybe<Scalars['Boolean']['input']>;
  tokenIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** mutation root */
export type Mutation_RootUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_Bid_TypesArgs = {
  _set?: InputMaybe<Bid_Types_Set_Input>;
  where: Bid_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bid_Types_By_PkArgs = {
  _set?: InputMaybe<Bid_Types_Set_Input>;
  pk_columns: Bid_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bid_Types_ManyArgs = {
  updates: Array<Bid_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bids_MetadataArgs = {
  _inc?: InputMaybe<Bids_Metadata_Inc_Input>;
  _set?: InputMaybe<Bids_Metadata_Set_Input>;
  where: Bids_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bids_Metadata_By_PkArgs = {
  _inc?: InputMaybe<Bids_Metadata_Inc_Input>;
  _set?: InputMaybe<Bids_Metadata_Set_Input>;
  pk_columns: Bids_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bids_Metadata_ManyArgs = {
  updates: Array<Bids_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CategoriesArgs = {
  _set?: InputMaybe<Categories_Set_Input>;
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Categories_By_PkArgs = {
  _set?: InputMaybe<Categories_Set_Input>;
  pk_columns: Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Categories_ManyArgs = {
  updates: Array<Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_AllowlistingsArgs = {
  _set?: InputMaybe<Contract_Allowlistings_Set_Input>;
  where: Contract_Allowlistings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_Allowlistings_By_PkArgs = {
  _set?: InputMaybe<Contract_Allowlistings_Set_Input>;
  pk_columns: Contract_Allowlistings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_Allowlistings_ManyArgs = {
  updates: Array<Contract_Allowlistings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_Type_NamesArgs = {
  _set?: InputMaybe<Contract_Type_Names_Set_Input>;
  where: Contract_Type_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_Type_Names_By_PkArgs = {
  _set?: InputMaybe<Contract_Type_Names_Set_Input>;
  pk_columns: Contract_Type_Names_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_Type_Names_ManyArgs = {
  updates: Array<Contract_Type_Names_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_TypesArgs = {
  _append?: InputMaybe<Contract_Types_Append_Input>;
  _delete_at_path?: InputMaybe<Contract_Types_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contract_Types_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contract_Types_Delete_Key_Input>;
  _prepend?: InputMaybe<Contract_Types_Prepend_Input>;
  _set?: InputMaybe<Contract_Types_Set_Input>;
  where: Contract_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_Types_By_PkArgs = {
  _append?: InputMaybe<Contract_Types_Append_Input>;
  _delete_at_path?: InputMaybe<Contract_Types_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contract_Types_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contract_Types_Delete_Key_Input>;
  _prepend?: InputMaybe<Contract_Types_Prepend_Input>;
  _set?: InputMaybe<Contract_Types_Set_Input>;
  pk_columns: Contract_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contract_Types_ManyArgs = {
  updates: Array<Contract_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contracts_MetadataArgs = {
  _inc?: InputMaybe<Contracts_Metadata_Inc_Input>;
  _set?: InputMaybe<Contracts_Metadata_Set_Input>;
  where: Contracts_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contracts_Metadata_By_PkArgs = {
  _inc?: InputMaybe<Contracts_Metadata_Inc_Input>;
  _set?: InputMaybe<Contracts_Metadata_Set_Input>;
  pk_columns: Contracts_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contracts_Metadata_ManyArgs = {
  updates: Array<Contracts_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Core_Registries_MetadataArgs = {
  _set?: InputMaybe<Core_Registries_Metadata_Set_Input>;
  where: Core_Registries_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Core_Registries_Metadata_By_PkArgs = {
  _set?: InputMaybe<Core_Registries_Metadata_Set_Input>;
  pk_columns: Core_Registries_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Core_Registries_Metadata_ManyArgs = {
  updates: Array<Core_Registries_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Curation_StatusesArgs = {
  _set?: InputMaybe<Curation_Statuses_Set_Input>;
  where: Curation_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Curation_Statuses_By_PkArgs = {
  _set?: InputMaybe<Curation_Statuses_Set_Input>;
  pk_columns: Curation_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Curation_Statuses_ManyArgs = {
  updates: Array<Curation_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dependencies_MetadataArgs = {
  _set?: InputMaybe<Dependencies_Metadata_Set_Input>;
  where: Dependencies_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dependencies_Metadata_By_PkArgs = {
  _set?: InputMaybe<Dependencies_Metadata_Set_Input>;
  pk_columns: Dependencies_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dependencies_Metadata_ManyArgs = {
  updates: Array<Dependencies_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Additional_CdnsArgs = {
  _inc?: InputMaybe<Dependency_Additional_Cdns_Inc_Input>;
  _set?: InputMaybe<Dependency_Additional_Cdns_Set_Input>;
  where: Dependency_Additional_Cdns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Additional_Cdns_By_PkArgs = {
  _inc?: InputMaybe<Dependency_Additional_Cdns_Inc_Input>;
  _set?: InputMaybe<Dependency_Additional_Cdns_Set_Input>;
  pk_columns: Dependency_Additional_Cdns_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Additional_Cdns_ManyArgs = {
  updates: Array<Dependency_Additional_Cdns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Additional_RepositoriesArgs = {
  _inc?: InputMaybe<Dependency_Additional_Repositories_Inc_Input>;
  _set?: InputMaybe<Dependency_Additional_Repositories_Set_Input>;
  where: Dependency_Additional_Repositories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Additional_Repositories_By_PkArgs = {
  _inc?: InputMaybe<Dependency_Additional_Repositories_Inc_Input>;
  _set?: InputMaybe<Dependency_Additional_Repositories_Set_Input>;
  pk_columns: Dependency_Additional_Repositories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Additional_Repositories_ManyArgs = {
  updates: Array<Dependency_Additional_Repositories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_RegistriesArgs = {
  _set?: InputMaybe<Dependency_Registries_Set_Input>;
  where: Dependency_Registries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Registries_By_PkArgs = {
  _set?: InputMaybe<Dependency_Registries_Set_Input>;
  pk_columns: Dependency_Registries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Registries_ManyArgs = {
  updates: Array<Dependency_Registries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_ScriptsArgs = {
  _inc?: InputMaybe<Dependency_Scripts_Inc_Input>;
  _set?: InputMaybe<Dependency_Scripts_Set_Input>;
  where: Dependency_Scripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Scripts_By_PkArgs = {
  _inc?: InputMaybe<Dependency_Scripts_Inc_Input>;
  _set?: InputMaybe<Dependency_Scripts_Set_Input>;
  pk_columns: Dependency_Scripts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dependency_Scripts_ManyArgs = {
  updates: Array<Dependency_Scripts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_TagsArgs = {
  _inc?: InputMaybe<Entity_Tags_Inc_Input>;
  _set?: InputMaybe<Entity_Tags_Set_Input>;
  where: Entity_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Tags_By_PkArgs = {
  _inc?: InputMaybe<Entity_Tags_Inc_Input>;
  _set?: InputMaybe<Entity_Tags_Set_Input>;
  pk_columns: Entity_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Tags_ManyArgs = {
  updates: Array<Entity_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Environment_ConfigurationArgs = {
  _set?: InputMaybe<Environment_Configuration_Set_Input>;
  where: Environment_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Environment_Configuration_By_PkArgs = {
  _set?: InputMaybe<Environment_Configuration_Set_Input>;
  pk_columns: Environment_Configuration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Environment_Configuration_ManyArgs = {
  updates: Array<Environment_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FavoritesArgs = {
  _inc?: InputMaybe<Favorites_Inc_Input>;
  _set?: InputMaybe<Favorites_Set_Input>;
  where: Favorites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Favorites_By_PkArgs = {
  _inc?: InputMaybe<Favorites_Inc_Input>;
  _set?: InputMaybe<Favorites_Set_Input>;
  pk_columns: Favorites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Favorites_ManyArgs = {
  updates: Array<Favorites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_FlagsArgs = {
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  where: Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flags_By_PkArgs = {
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  pk_columns: Feature_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flags_ManyArgs = {
  updates: Array<Feature_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MediaArgs = {
  _append?: InputMaybe<Media_Append_Input>;
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  _inc?: InputMaybe<Media_Inc_Input>;
  _prepend?: InputMaybe<Media_Prepend_Input>;
  _set?: InputMaybe<Media_Set_Input>;
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Media_By_PkArgs = {
  _append?: InputMaybe<Media_Append_Input>;
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  _inc?: InputMaybe<Media_Inc_Input>;
  _prepend?: InputMaybe<Media_Prepend_Input>;
  _set?: InputMaybe<Media_Set_Input>;
  pk_columns: Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Media_ManyArgs = {
  updates: Array<Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Filter_Type_NamesArgs = {
  _set?: InputMaybe<Minter_Filter_Type_Names_Set_Input>;
  where: Minter_Filter_Type_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Filter_Type_Names_By_PkArgs = {
  _set?: InputMaybe<Minter_Filter_Type_Names_Set_Input>;
  pk_columns: Minter_Filter_Type_Names_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Filter_Type_Names_ManyArgs = {
  updates: Array<Minter_Filter_Type_Names_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Filters_MetadataArgs = {
  _set?: InputMaybe<Minter_Filters_Metadata_Set_Input>;
  where: Minter_Filters_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Filters_Metadata_By_PkArgs = {
  _set?: InputMaybe<Minter_Filters_Metadata_Set_Input>;
  pk_columns: Minter_Filters_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Filters_Metadata_ManyArgs = {
  updates: Array<Minter_Filters_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Type_NamesArgs = {
  _set?: InputMaybe<Minter_Type_Names_Set_Input>;
  where: Minter_Type_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Type_Names_By_PkArgs = {
  _set?: InputMaybe<Minter_Type_Names_Set_Input>;
  pk_columns: Minter_Type_Names_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Type_Names_ManyArgs = {
  updates: Array<Minter_Type_Names_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_TypesArgs = {
  _append?: InputMaybe<Minter_Types_Append_Input>;
  _delete_at_path?: InputMaybe<Minter_Types_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Minter_Types_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Minter_Types_Delete_Key_Input>;
  _prepend?: InputMaybe<Minter_Types_Prepend_Input>;
  _set?: InputMaybe<Minter_Types_Set_Input>;
  where: Minter_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Types_By_PkArgs = {
  _append?: InputMaybe<Minter_Types_Append_Input>;
  _delete_at_path?: InputMaybe<Minter_Types_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Minter_Types_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Minter_Types_Delete_Key_Input>;
  _prepend?: InputMaybe<Minter_Types_Prepend_Input>;
  _set?: InputMaybe<Minter_Types_Set_Input>;
  pk_columns: Minter_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Minter_Types_ManyArgs = {
  updates: Array<Minter_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Minters_MetadataArgs = {
  _append?: InputMaybe<Minters_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Minters_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Minters_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Minters_Metadata_Delete_Key_Input>;
  _prepend?: InputMaybe<Minters_Metadata_Prepend_Input>;
  _set?: InputMaybe<Minters_Metadata_Set_Input>;
  where: Minters_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Minters_Metadata_By_PkArgs = {
  _append?: InputMaybe<Minters_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Minters_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Minters_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Minters_Metadata_Delete_Key_Input>;
  _prepend?: InputMaybe<Minters_Metadata_Prepend_Input>;
  _set?: InputMaybe<Minters_Metadata_Set_Input>;
  pk_columns: Minters_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Minters_Metadata_ManyArgs = {
  updates: Array<Minters_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mixpanel_LookupArgs = {
  _set?: InputMaybe<Mixpanel_Lookup_Set_Input>;
  where: Mixpanel_Lookup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mixpanel_Lookup_By_PkArgs = {
  _set?: InputMaybe<Mixpanel_Lookup_Set_Input>;
  pk_columns: Mixpanel_Lookup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mixpanel_Lookup_ManyArgs = {
  updates: Array<Mixpanel_Lookup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationsArgs = {
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_By_PkArgs = {
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Oob_Tokens_MetadataArgs = {
  _inc?: InputMaybe<Oob_Tokens_Metadata_Inc_Input>;
  _set?: InputMaybe<Oob_Tokens_Metadata_Set_Input>;
  where: Oob_Tokens_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Oob_Tokens_Metadata_By_PkArgs = {
  _inc?: InputMaybe<Oob_Tokens_Metadata_Inc_Input>;
  _set?: InputMaybe<Oob_Tokens_Metadata_Set_Input>;
  pk_columns: Oob_Tokens_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Oob_Tokens_Metadata_ManyArgs = {
  updates: Array<Oob_Tokens_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_TypesArgs = {
  _set?: InputMaybe<Partner_Types_Set_Input>;
  where: Partner_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Types_By_PkArgs = {
  _set?: InputMaybe<Partner_Types_Set_Input>;
  pk_columns: Partner_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Types_ManyArgs = {
  updates: Array<Partner_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PartnersArgs = {
  _append?: InputMaybe<Partners_Append_Input>;
  _delete_at_path?: InputMaybe<Partners_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Partners_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Partners_Delete_Key_Input>;
  _inc?: InputMaybe<Partners_Inc_Input>;
  _prepend?: InputMaybe<Partners_Prepend_Input>;
  _set?: InputMaybe<Partners_Set_Input>;
  where: Partners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partners_By_PkArgs = {
  _append?: InputMaybe<Partners_Append_Input>;
  _delete_at_path?: InputMaybe<Partners_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Partners_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Partners_Delete_Key_Input>;
  _inc?: InputMaybe<Partners_Inc_Input>;
  _prepend?: InputMaybe<Partners_Prepend_Input>;
  _set?: InputMaybe<Partners_Set_Input>;
  pk_columns: Partners_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partners_ManyArgs = {
  updates: Array<Partners_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Auth_OptionsArgs = {
  _set?: InputMaybe<Pmp_Auth_Options_Set_Input>;
  where: Pmp_Auth_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Auth_Options_By_PkArgs = {
  _set?: InputMaybe<Pmp_Auth_Options_Set_Input>;
  pk_columns: Pmp_Auth_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Auth_Options_ManyArgs = {
  updates: Array<Pmp_Auth_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_ConfigsArgs = {
  _set?: InputMaybe<Pmp_Configs_Set_Input>;
  where: Pmp_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Configs_By_PkArgs = {
  _set?: InputMaybe<Pmp_Configs_Set_Input>;
  pk_columns: Pmp_Configs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Configs_ManyArgs = {
  updates: Array<Pmp_Configs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Param_TypesArgs = {
  _set?: InputMaybe<Pmp_Param_Types_Set_Input>;
  where: Pmp_Param_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Param_Types_By_PkArgs = {
  _set?: InputMaybe<Pmp_Param_Types_Set_Input>;
  pk_columns: Pmp_Param_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Param_Types_ManyArgs = {
  updates: Array<Pmp_Param_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Project_ConfigsArgs = {
  _set?: InputMaybe<Pmp_Project_Configs_Set_Input>;
  where: Pmp_Project_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Project_Configs_By_PkArgs = {
  _set?: InputMaybe<Pmp_Project_Configs_Set_Input>;
  pk_columns: Pmp_Project_Configs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pmp_Project_Configs_ManyArgs = {
  updates: Array<Pmp_Project_Configs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pmps_MetadataArgs = {
  _inc?: InputMaybe<Pmps_Metadata_Inc_Input>;
  _set?: InputMaybe<Pmps_Metadata_Set_Input>;
  where: Pmps_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pmps_Metadata_By_PkArgs = {
  _inc?: InputMaybe<Pmps_Metadata_Inc_Input>;
  _set?: InputMaybe<Pmps_Metadata_Set_Input>;
  pk_columns: Pmps_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pmps_Metadata_ManyArgs = {
  updates: Array<Pmps_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_PurchasesArgs = {
  _set?: InputMaybe<Primary_Purchases_Set_Input>;
  where: Primary_Purchases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_Purchases_By_PkArgs = {
  _set?: InputMaybe<Primary_Purchases_Set_Input>;
  pk_columns: Primary_Purchases_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_Purchases_ManyArgs = {
  updates: Array<Primary_Purchases_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Processing_JobsArgs = {
  _set?: InputMaybe<Processing_Jobs_Set_Input>;
  where: Processing_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Processing_Jobs_By_PkArgs = {
  _set?: InputMaybe<Processing_Jobs_Set_Input>;
  pk_columns: Processing_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Processing_Jobs_ManyArgs = {
  updates: Array<Processing_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Processing_Jobs_Status_TypesArgs = {
  _set?: InputMaybe<Processing_Jobs_Status_Types_Set_Input>;
  where: Processing_Jobs_Status_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Processing_Jobs_Status_Types_By_PkArgs = {
  _set?: InputMaybe<Processing_Jobs_Status_Types_Set_Input>;
  pk_columns: Processing_Jobs_Status_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Processing_Jobs_Status_Types_ManyArgs = {
  updates: Array<Processing_Jobs_Status_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_External_Asset_DependenciesArgs = {
  _inc?: InputMaybe<Project_External_Asset_Dependencies_Inc_Input>;
  _set?: InputMaybe<Project_External_Asset_Dependencies_Set_Input>;
  where: Project_External_Asset_Dependencies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_External_Asset_Dependencies_By_PkArgs = {
  _inc?: InputMaybe<Project_External_Asset_Dependencies_Inc_Input>;
  _set?: InputMaybe<Project_External_Asset_Dependencies_Set_Input>;
  pk_columns: Project_External_Asset_Dependencies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_External_Asset_Dependencies_ManyArgs = {
  updates: Array<Project_External_Asset_Dependencies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_External_Asset_Dependency_TypesArgs = {
  _set?: InputMaybe<Project_External_Asset_Dependency_Types_Set_Input>;
  where: Project_External_Asset_Dependency_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_External_Asset_Dependency_Types_By_PkArgs = {
  _set?: InputMaybe<Project_External_Asset_Dependency_Types_Set_Input>;
  pk_columns: Project_External_Asset_Dependency_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_External_Asset_Dependency_Types_ManyArgs = {
  updates: Array<Project_External_Asset_Dependency_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Minter_ConfigurationsArgs = {
  _append?: InputMaybe<Project_Minter_Configurations_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Minter_Configurations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Minter_Configurations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Minter_Configurations_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Minter_Configurations_Inc_Input>;
  _prepend?: InputMaybe<Project_Minter_Configurations_Prepend_Input>;
  _set?: InputMaybe<Project_Minter_Configurations_Set_Input>;
  where: Project_Minter_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Minter_Configurations_By_PkArgs = {
  _append?: InputMaybe<Project_Minter_Configurations_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Minter_Configurations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Minter_Configurations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Minter_Configurations_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Minter_Configurations_Inc_Input>;
  _prepend?: InputMaybe<Project_Minter_Configurations_Prepend_Input>;
  _set?: InputMaybe<Project_Minter_Configurations_Set_Input>;
  pk_columns: Project_Minter_Configurations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Minter_Configurations_ManyArgs = {
  updates: Array<Project_Minter_Configurations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ScriptsArgs = {
  _inc?: InputMaybe<Project_Scripts_Inc_Input>;
  _set?: InputMaybe<Project_Scripts_Set_Input>;
  where: Project_Scripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Scripts_By_PkArgs = {
  _inc?: InputMaybe<Project_Scripts_Inc_Input>;
  _set?: InputMaybe<Project_Scripts_Set_Input>;
  pk_columns: Project_Scripts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Scripts_ManyArgs = {
  updates: Array<Project_Scripts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_SeriesArgs = {
  _inc?: InputMaybe<Project_Series_Inc_Input>;
  _set?: InputMaybe<Project_Series_Set_Input>;
  where: Project_Series_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Series_By_PkArgs = {
  _inc?: InputMaybe<Project_Series_Inc_Input>;
  _set?: InputMaybe<Project_Series_Set_Input>;
  pk_columns: Project_Series_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Series_ManyArgs = {
  updates: Array<Project_Series_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Vertical_CategoriesArgs = {
  _set?: InputMaybe<Project_Vertical_Categories_Set_Input>;
  where: Project_Vertical_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Vertical_Categories_By_PkArgs = {
  _set?: InputMaybe<Project_Vertical_Categories_Set_Input>;
  pk_columns: Project_Vertical_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Vertical_Categories_ManyArgs = {
  updates: Array<Project_Vertical_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_VerticalsArgs = {
  _set?: InputMaybe<Project_Verticals_Set_Input>;
  where: Project_Verticals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Verticals_By_PkArgs = {
  _set?: InputMaybe<Project_Verticals_Set_Input>;
  pk_columns: Project_Verticals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Verticals_ManyArgs = {
  updates: Array<Project_Verticals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_FeaturesArgs = {
  _append?: InputMaybe<Projects_Features_Append_Input>;
  _delete_at_path?: InputMaybe<Projects_Features_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Projects_Features_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Projects_Features_Delete_Key_Input>;
  _inc?: InputMaybe<Projects_Features_Inc_Input>;
  _prepend?: InputMaybe<Projects_Features_Prepend_Input>;
  _set?: InputMaybe<Projects_Features_Set_Input>;
  where: Projects_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_Features_By_PkArgs = {
  _append?: InputMaybe<Projects_Features_Append_Input>;
  _delete_at_path?: InputMaybe<Projects_Features_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Projects_Features_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Projects_Features_Delete_Key_Input>;
  _inc?: InputMaybe<Projects_Features_Inc_Input>;
  _prepend?: InputMaybe<Projects_Features_Prepend_Input>;
  _set?: InputMaybe<Projects_Features_Set_Input>;
  pk_columns: Projects_Features_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_Features_ManyArgs = {
  updates: Array<Projects_Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_MetadataArgs = {
  _append?: InputMaybe<Projects_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Projects_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Projects_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Projects_Metadata_Delete_Key_Input>;
  _inc?: InputMaybe<Projects_Metadata_Inc_Input>;
  _prepend?: InputMaybe<Projects_Metadata_Prepend_Input>;
  _set?: InputMaybe<Projects_Metadata_Set_Input>;
  where: Projects_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_Metadata_By_PkArgs = {
  _append?: InputMaybe<Projects_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Projects_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Projects_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Projects_Metadata_Delete_Key_Input>;
  _inc?: InputMaybe<Projects_Metadata_Inc_Input>;
  _prepend?: InputMaybe<Projects_Metadata_Prepend_Input>;
  _set?: InputMaybe<Projects_Metadata_Set_Input>;
  pk_columns: Projects_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_Metadata_ManyArgs = {
  updates: Array<Projects_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Proposed_Artist_Addresses_And_SplitsArgs = {
  _inc?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Inc_Input>;
  _set?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Set_Input>;
  where: Proposed_Artist_Addresses_And_Splits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Proposed_Artist_Addresses_And_Splits_By_PkArgs = {
  _inc?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Inc_Input>;
  _set?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Set_Input>;
  pk_columns: Proposed_Artist_Addresses_And_Splits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Proposed_Artist_Addresses_And_Splits_ManyArgs = {
  updates: Array<Proposed_Artist_Addresses_And_Splits_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Receipt_MetadataArgs = {
  _set?: InputMaybe<Receipt_Metadata_Set_Input>;
  where: Receipt_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Receipt_Metadata_By_PkArgs = {
  _set?: InputMaybe<Receipt_Metadata_Set_Input>;
  pk_columns: Receipt_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Receipt_Metadata_ManyArgs = {
  updates: Array<Receipt_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Asset_TypesArgs = {
  _set?: InputMaybe<Refresh_Asset_Types_Set_Input>;
  where: Refresh_Asset_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Asset_Types_By_PkArgs = {
  _set?: InputMaybe<Refresh_Asset_Types_Set_Input>;
  pk_columns: Refresh_Asset_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Asset_Types_ManyArgs = {
  updates: Array<Refresh_Asset_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Request_TypesArgs = {
  _set?: InputMaybe<Refresh_Request_Types_Set_Input>;
  where: Refresh_Request_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Request_Types_By_PkArgs = {
  _set?: InputMaybe<Refresh_Request_Types_Set_Input>;
  pk_columns: Refresh_Request_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Request_Types_ManyArgs = {
  updates: Array<Refresh_Request_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_RequestsArgs = {
  _append?: InputMaybe<Refresh_Requests_Append_Input>;
  _delete_at_path?: InputMaybe<Refresh_Requests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Refresh_Requests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Refresh_Requests_Delete_Key_Input>;
  _prepend?: InputMaybe<Refresh_Requests_Prepend_Input>;
  _set?: InputMaybe<Refresh_Requests_Set_Input>;
  where: Refresh_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Requests_By_PkArgs = {
  _append?: InputMaybe<Refresh_Requests_Append_Input>;
  _delete_at_path?: InputMaybe<Refresh_Requests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Refresh_Requests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Refresh_Requests_Delete_Key_Input>;
  _prepend?: InputMaybe<Refresh_Requests_Prepend_Input>;
  _set?: InputMaybe<Refresh_Requests_Set_Input>;
  pk_columns: Refresh_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Requests_ManyArgs = {
  updates: Array<Refresh_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Render_TypesArgs = {
  _set?: InputMaybe<Render_Types_Set_Input>;
  where: Render_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Render_Types_By_PkArgs = {
  _set?: InputMaybe<Render_Types_Set_Input>;
  pk_columns: Render_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Render_Types_ManyArgs = {
  updates: Array<Render_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Royalty_Split_RecipientsArgs = {
  _inc?: InputMaybe<Royalty_Split_Recipients_Inc_Input>;
  _set?: InputMaybe<Royalty_Split_Recipients_Set_Input>;
  where: Royalty_Split_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Royalty_Split_Recipients_By_PkArgs = {
  _inc?: InputMaybe<Royalty_Split_Recipients_Inc_Input>;
  _set?: InputMaybe<Royalty_Split_Recipients_Set_Input>;
  pk_columns: Royalty_Split_Recipients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Royalty_Split_Recipients_ManyArgs = {
  updates: Array<Royalty_Split_Recipients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Royalty_Splitter_ContractsArgs = {
  _inc?: InputMaybe<Royalty_Splitter_Contracts_Inc_Input>;
  _set?: InputMaybe<Royalty_Splitter_Contracts_Set_Input>;
  where: Royalty_Splitter_Contracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Royalty_Splitter_Contracts_By_PkArgs = {
  _inc?: InputMaybe<Royalty_Splitter_Contracts_Inc_Input>;
  _set?: InputMaybe<Royalty_Splitter_Contracts_Set_Input>;
  pk_columns: Royalty_Splitter_Contracts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Royalty_Splitter_Contracts_ManyArgs = {
  updates: Array<Royalty_Splitter_Contracts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScreeningsArgs = {
  _inc?: InputMaybe<Screenings_Inc_Input>;
  _set?: InputMaybe<Screenings_Set_Input>;
  where: Screenings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Screenings_By_PkArgs = {
  _inc?: InputMaybe<Screenings_Inc_Input>;
  _set?: InputMaybe<Screenings_Set_Input>;
  pk_columns: Screenings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Screenings_ManyArgs = {
  updates: Array<Screenings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Atomic_ContractsArgs = {
  _set?: InputMaybe<Split_Atomic_Contracts_Set_Input>;
  where: Split_Atomic_Contracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Atomic_Contracts_By_PkArgs = {
  _set?: InputMaybe<Split_Atomic_Contracts_Set_Input>;
  pk_columns: Split_Atomic_Contracts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Atomic_Contracts_ManyArgs = {
  updates: Array<Split_Atomic_Contracts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Atomic_FactoriesArgs = {
  _inc?: InputMaybe<Split_Atomic_Factories_Inc_Input>;
  _set?: InputMaybe<Split_Atomic_Factories_Set_Input>;
  where: Split_Atomic_Factories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Atomic_Factories_By_PkArgs = {
  _inc?: InputMaybe<Split_Atomic_Factories_Inc_Input>;
  _set?: InputMaybe<Split_Atomic_Factories_Set_Input>;
  pk_columns: Split_Atomic_Factories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Atomic_Factories_ManyArgs = {
  updates: Array<Split_Atomic_Factories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Payment_ConfigurationsArgs = {
  _inc?: InputMaybe<Split_Payment_Configurations_Inc_Input>;
  _set?: InputMaybe<Split_Payment_Configurations_Set_Input>;
  where: Split_Payment_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Payment_Configurations_By_PkArgs = {
  _inc?: InputMaybe<Split_Payment_Configurations_Inc_Input>;
  _set?: InputMaybe<Split_Payment_Configurations_Set_Input>;
  pk_columns: Split_Payment_Configurations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Split_Payment_Configurations_ManyArgs = {
  updates: Array<Split_Payment_Configurations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sync_StatusArgs = {
  _set?: InputMaybe<Sync_Status_Set_Input>;
  where: Sync_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sync_Status_By_PkArgs = {
  _set?: InputMaybe<Sync_Status_Set_Input>;
  pk_columns: Sync_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sync_Status_ManyArgs = {
  updates: Array<Sync_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_GroupingsArgs = {
  _set?: InputMaybe<Tag_Groupings_Set_Input>;
  where: Tag_Groupings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Groupings_By_PkArgs = {
  _set?: InputMaybe<Tag_Groupings_Set_Input>;
  pk_columns: Tag_Groupings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Groupings_ManyArgs = {
  updates: Array<Tag_Groupings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_StatusArgs = {
  _set?: InputMaybe<Tag_Status_Set_Input>;
  where: Tag_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Status_By_PkArgs = {
  _set?: InputMaybe<Tag_Status_Set_Input>;
  pk_columns: Tag_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Status_ManyArgs = {
  updates: Array<Tag_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_TypesArgs = {
  _set?: InputMaybe<Tag_Types_Set_Input>;
  where: Tag_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Types_By_PkArgs = {
  _set?: InputMaybe<Tag_Types_Set_Input>;
  pk_columns: Tag_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Types_ManyArgs = {
  updates: Array<Tag_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagsArgs = {
  _set?: InputMaybe<Tags_Set_Input>;
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_By_PkArgs = {
  _set?: InputMaybe<Tags_Set_Input>;
  pk_columns: Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_ManyArgs = {
  updates: Array<Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tokens_MetadataArgs = {
  _append?: InputMaybe<Tokens_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Tokens_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tokens_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tokens_Metadata_Delete_Key_Input>;
  _inc?: InputMaybe<Tokens_Metadata_Inc_Input>;
  _prepend?: InputMaybe<Tokens_Metadata_Prepend_Input>;
  _set?: InputMaybe<Tokens_Metadata_Set_Input>;
  where: Tokens_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tokens_Metadata_By_PkArgs = {
  _append?: InputMaybe<Tokens_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Tokens_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tokens_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tokens_Metadata_Delete_Key_Input>;
  _inc?: InputMaybe<Tokens_Metadata_Inc_Input>;
  _prepend?: InputMaybe<Tokens_Metadata_Prepend_Input>;
  _set?: InputMaybe<Tokens_Metadata_Set_Input>;
  pk_columns: Tokens_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tokens_Metadata_ManyArgs = {
  updates: Array<Tokens_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfilesArgs = {
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_By_PkArgs = {
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  pk_columns: User_Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_ManyArgs = {
  updates: Array<User_Profiles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VerticalsArgs = {
  _set?: InputMaybe<Verticals_Set_Input>;
  where: Verticals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Verticals_By_PkArgs = {
  _set?: InputMaybe<Verticals_Set_Input>;
  pk_columns: Verticals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Verticals_ManyArgs = {
  updates: Array<Verticals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Video_Aspect_RatiosArgs = {
  _inc?: InputMaybe<Video_Aspect_Ratios_Inc_Input>;
  _set?: InputMaybe<Video_Aspect_Ratios_Set_Input>;
  where: Video_Aspect_Ratios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Video_Aspect_Ratios_By_PkArgs = {
  _inc?: InputMaybe<Video_Aspect_Ratios_Inc_Input>;
  _set?: InputMaybe<Video_Aspect_Ratios_Set_Input>;
  pk_columns: Video_Aspect_Ratios_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Video_Aspect_Ratios_ManyArgs = {
  updates: Array<Video_Aspect_Ratios_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Video_Frame_RatesArgs = {
  _inc?: InputMaybe<Video_Frame_Rates_Inc_Input>;
  _set?: InputMaybe<Video_Frame_Rates_Set_Input>;
  where: Video_Frame_Rates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Video_Frame_Rates_By_PkArgs = {
  _inc?: InputMaybe<Video_Frame_Rates_Inc_Input>;
  _set?: InputMaybe<Video_Frame_Rates_Set_Input>;
  pk_columns: Video_Frame_Rates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Video_Frame_Rates_ManyArgs = {
  updates: Array<Video_Frame_Rates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Webflow_Artist_InfoArgs = {
  _append?: InputMaybe<Webflow_Artist_Info_Append_Input>;
  _delete_at_path?: InputMaybe<Webflow_Artist_Info_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Webflow_Artist_Info_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Webflow_Artist_Info_Delete_Key_Input>;
  _prepend?: InputMaybe<Webflow_Artist_Info_Prepend_Input>;
  _set?: InputMaybe<Webflow_Artist_Info_Set_Input>;
  where: Webflow_Artist_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Webflow_Artist_Info_By_PkArgs = {
  _append?: InputMaybe<Webflow_Artist_Info_Append_Input>;
  _delete_at_path?: InputMaybe<Webflow_Artist_Info_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Webflow_Artist_Info_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Webflow_Artist_Info_Delete_Key_Input>;
  _prepend?: InputMaybe<Webflow_Artist_Info_Prepend_Input>;
  _set?: InputMaybe<Webflow_Artist_Info_Set_Input>;
  pk_columns: Webflow_Artist_Info_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Webflow_Artist_Info_ManyArgs = {
  updates: Array<Webflow_Artist_Info_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Webflow_Spectrum_ArticlesArgs = {
  _append?: InputMaybe<Webflow_Spectrum_Articles_Append_Input>;
  _delete_at_path?: InputMaybe<Webflow_Spectrum_Articles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Webflow_Spectrum_Articles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Webflow_Spectrum_Articles_Delete_Key_Input>;
  _prepend?: InputMaybe<Webflow_Spectrum_Articles_Prepend_Input>;
  _set?: InputMaybe<Webflow_Spectrum_Articles_Set_Input>;
  where: Webflow_Spectrum_Articles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Webflow_Spectrum_Articles_By_PkArgs = {
  _append?: InputMaybe<Webflow_Spectrum_Articles_Append_Input>;
  _delete_at_path?: InputMaybe<Webflow_Spectrum_Articles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Webflow_Spectrum_Articles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Webflow_Spectrum_Articles_Delete_Key_Input>;
  _prepend?: InputMaybe<Webflow_Spectrum_Articles_Prepend_Input>;
  _set?: InputMaybe<Webflow_Spectrum_Articles_Set_Input>;
  pk_columns: Webflow_Spectrum_Articles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Webflow_Spectrum_Articles_ManyArgs = {
  updates: Array<Webflow_Spectrum_Articles_Updates>;
};


/** mutation root */
export type Mutation_RootUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

/** columns and relationships of "notifications" */
export type Notifications = {
  __typename?: 'notifications';
  action_text?: Maybe<Scalars['String']['output']>;
  action_url?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  dismissed: Scalars['Boolean']['output'];
  /** An object relationship */
  image?: Maybe<Media>;
  image_id?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  trigger_key: Scalars['String']['output'];
  trigger_time: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_address: Scalars['String']['output'];
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

export type Notifications_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Notifications_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Notifications_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Notifications_Aggregate_Bool_Exp_Count>;
};

export type Notifications_Aggregate_Bool_Exp_Bool_And = {
  arguments: Notifications_Select_Column_Notifications_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notifications_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notifications_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Notifications_Select_Column_Notifications_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notifications_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notifications_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notifications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  avg?: Maybe<Notifications_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
  stddev?: Maybe<Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Notifications_Sum_Fields>;
  var_pop?: Maybe<Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Notifications_Var_Samp_Fields>;
  variance?: Maybe<Notifications_Variance_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notifications" */
export type Notifications_Aggregate_Order_By = {
  avg?: InputMaybe<Notifications_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notifications_Max_Order_By>;
  min?: InputMaybe<Notifications_Min_Order_By>;
  stddev?: InputMaybe<Notifications_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notifications_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notifications_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notifications_Sum_Order_By>;
  var_pop?: InputMaybe<Notifications_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notifications_Var_Samp_Order_By>;
  variance?: InputMaybe<Notifications_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notifications" */
export type Notifications_Arr_Rel_Insert_Input = {
  data: Array<Notifications_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};

/** aggregate avg on columns */
export type Notifications_Avg_Fields = {
  __typename?: 'notifications_avg_fields';
  image_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notifications" */
export type Notifications_Avg_Order_By = {
  image_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  action_text?: InputMaybe<String_Comparison_Exp>;
  action_url?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  dismissed?: InputMaybe<Boolean_Comparison_Exp>;
  image?: InputMaybe<Media_Bool_Exp>;
  image_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  trigger_key?: InputMaybe<String_Comparison_Exp>;
  trigger_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "user_address", "trigger_key", "trigger_time" */
  NotificationsPkey = 'notifications_pkey'
}

/** input type for incrementing numeric columns in table "notifications" */
export type Notifications_Inc_Input = {
  image_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "notifications" */
export type Notifications_Insert_Input = {
  action_text?: InputMaybe<Scalars['String']['input']>;
  action_url?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trigger_key?: InputMaybe<Scalars['String']['input']>;
  trigger_time?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  action_text?: Maybe<Scalars['String']['output']>;
  action_url?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  image_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trigger_key?: Maybe<Scalars['String']['output']>;
  trigger_time?: Maybe<Scalars['timestamptz']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "notifications" */
export type Notifications_Max_Order_By = {
  action_text?: InputMaybe<Order_By>;
  action_url?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  trigger_key?: InputMaybe<Order_By>;
  trigger_time?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  action_text?: Maybe<Scalars['String']['output']>;
  action_url?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  image_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trigger_key?: Maybe<Scalars['String']['output']>;
  trigger_time?: Maybe<Scalars['timestamptz']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "notifications" */
export type Notifications_Min_Order_By = {
  action_text?: InputMaybe<Order_By>;
  action_url?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  trigger_key?: InputMaybe<Order_By>;
  trigger_time?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  action_text?: InputMaybe<Order_By>;
  action_url?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  dismissed?: InputMaybe<Order_By>;
  image?: InputMaybe<Media_Order_By>;
  image_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  trigger_key?: InputMaybe<Order_By>;
  trigger_time?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notifications */
export type Notifications_Pk_Columns_Input = {
  trigger_key: Scalars['String']['input'];
  trigger_time: Scalars['timestamptz']['input'];
  user_address: Scalars['String']['input'];
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  ActionText = 'action_text',
  /** column name */
  ActionUrl = 'action_url',
  /** column name */
  Body = 'body',
  /** column name */
  Dismissed = 'dismissed',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  Title = 'title',
  /** column name */
  TriggerKey = 'trigger_key',
  /** column name */
  TriggerTime = 'trigger_time',
  /** column name */
  UserAddress = 'user_address'
}

/** select "notifications_aggregate_bool_exp_bool_and_arguments_columns" columns of table "notifications" */
export enum Notifications_Select_Column_Notifications_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Dismissed = 'dismissed'
}

/** select "notifications_aggregate_bool_exp_bool_or_arguments_columns" columns of table "notifications" */
export enum Notifications_Select_Column_Notifications_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Dismissed = 'dismissed'
}

/** input type for updating data in table "notifications" */
export type Notifications_Set_Input = {
  action_text?: InputMaybe<Scalars['String']['input']>;
  action_url?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trigger_key?: InputMaybe<Scalars['String']['input']>;
  trigger_time?: InputMaybe<Scalars['timestamptz']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Notifications_Stddev_Fields = {
  __typename?: 'notifications_stddev_fields';
  image_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notifications" */
export type Notifications_Stddev_Order_By = {
  image_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notifications_Stddev_Pop_Fields = {
  __typename?: 'notifications_stddev_pop_fields';
  image_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "notifications" */
export type Notifications_Stddev_Pop_Order_By = {
  image_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notifications_Stddev_Samp_Fields = {
  __typename?: 'notifications_stddev_samp_fields';
  image_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "notifications" */
export type Notifications_Stddev_Samp_Order_By = {
  image_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  action_text?: InputMaybe<Scalars['String']['input']>;
  action_url?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trigger_key?: InputMaybe<Scalars['String']['input']>;
  trigger_time?: InputMaybe<Scalars['timestamptz']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Notifications_Sum_Fields = {
  __typename?: 'notifications_sum_fields';
  image_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "notifications" */
export type Notifications_Sum_Order_By = {
  image_id?: InputMaybe<Order_By>;
};

/** update columns of table "notifications" */
export enum Notifications_Update_Column {
  /** column name */
  ActionText = 'action_text',
  /** column name */
  ActionUrl = 'action_url',
  /** column name */
  Body = 'body',
  /** column name */
  Dismissed = 'dismissed',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  Title = 'title',
  /** column name */
  TriggerKey = 'trigger_key',
  /** column name */
  TriggerTime = 'trigger_time',
  /** column name */
  UserAddress = 'user_address'
}

export type Notifications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notifications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notifications_Var_Pop_Fields = {
  __typename?: 'notifications_var_pop_fields';
  image_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "notifications" */
export type Notifications_Var_Pop_Order_By = {
  image_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notifications_Var_Samp_Fields = {
  __typename?: 'notifications_var_samp_fields';
  image_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "notifications" */
export type Notifications_Var_Samp_Order_By = {
  image_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notifications_Variance_Fields = {
  __typename?: 'notifications_variance_fields';
  image_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notifications" */
export type Notifications_Variance_Order_By = {
  image_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** Table for out-of-bounds tokens created for previewing upcoming projects */
export type Oob_Tokens_Metadata = {
  __typename?: 'oob_tokens_metadata';
  /** An object relationship */
  contract: Contracts_Metadata;
  contract_address: Scalars['String']['output'];
  /** An object relationship */
  gif?: Maybe<Media>;
  gif_id?: Maybe<Scalars['Int']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  image?: Maybe<Media>;
  image_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "oob_live_view_path" */
  live_view_path?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_live_view_url" */
  live_view_url?: Maybe<Scalars['String']['output']>;
  /** a computed field that returns the media proxy url for this OOB token's statically rendered image */
  media_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_preview_asset_url" */
  preview_asset_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_primary_asset_url" */
  primary_asset_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project: Projects_Metadata;
  project_id: Scalars['String']['output'];
  token_id: Scalars['Int']['output'];
  /** An object relationship */
  video?: Maybe<Media>;
  video_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Aggregate = {
  __typename?: 'oob_tokens_metadata_aggregate';
  aggregate?: Maybe<Oob_Tokens_Metadata_Aggregate_Fields>;
  nodes: Array<Oob_Tokens_Metadata>;
};

export type Oob_Tokens_Metadata_Aggregate_Bool_Exp = {
  count?: InputMaybe<Oob_Tokens_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Oob_Tokens_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Aggregate_Fields = {
  __typename?: 'oob_tokens_metadata_aggregate_fields';
  avg?: Maybe<Oob_Tokens_Metadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Oob_Tokens_Metadata_Max_Fields>;
  min?: Maybe<Oob_Tokens_Metadata_Min_Fields>;
  stddev?: Maybe<Oob_Tokens_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Oob_Tokens_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Oob_Tokens_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Oob_Tokens_Metadata_Sum_Fields>;
  var_pop?: Maybe<Oob_Tokens_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Oob_Tokens_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Oob_Tokens_Metadata_Variance_Fields>;
};


/** aggregate fields of "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Aggregate_Order_By = {
  avg?: InputMaybe<Oob_Tokens_Metadata_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Oob_Tokens_Metadata_Max_Order_By>;
  min?: InputMaybe<Oob_Tokens_Metadata_Min_Order_By>;
  stddev?: InputMaybe<Oob_Tokens_Metadata_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Oob_Tokens_Metadata_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Oob_Tokens_Metadata_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Oob_Tokens_Metadata_Sum_Order_By>;
  var_pop?: InputMaybe<Oob_Tokens_Metadata_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Oob_Tokens_Metadata_Var_Samp_Order_By>;
  variance?: InputMaybe<Oob_Tokens_Metadata_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Oob_Tokens_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Oob_Tokens_Metadata_On_Conflict>;
};

/** aggregate avg on columns */
export type Oob_Tokens_Metadata_Avg_Fields = {
  __typename?: 'oob_tokens_metadata_avg_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Avg_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "oob_tokens_metadata". All fields are combined with a logical 'AND'. */
export type Oob_Tokens_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Oob_Tokens_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Oob_Tokens_Metadata_Bool_Exp>>;
  contract?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  gif?: InputMaybe<Media_Bool_Exp>;
  gif_id?: InputMaybe<Int_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  image?: InputMaybe<Media_Bool_Exp>;
  image_id?: InputMaybe<Int_Comparison_Exp>;
  live_view_path?: InputMaybe<String_Comparison_Exp>;
  live_view_url?: InputMaybe<String_Comparison_Exp>;
  media_url?: InputMaybe<String_Comparison_Exp>;
  preview_asset_url?: InputMaybe<String_Comparison_Exp>;
  primary_asset_url?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  token_id?: InputMaybe<Int_Comparison_Exp>;
  video?: InputMaybe<Media_Bool_Exp>;
  video_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "oob_tokens_metadata" */
export enum Oob_Tokens_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  OobTokensMetadataPkey = 'oob_tokens_metadata_pkey'
}

/** input type for incrementing numeric columns in table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Inc_Input = {
  gif_id?: InputMaybe<Scalars['Int']['input']>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  token_id?: InputMaybe<Scalars['Int']['input']>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Insert_Input = {
  contract?: InputMaybe<Contracts_Metadata_Obj_Rel_Insert_Input>;
  contract_address?: InputMaybe<Scalars['String']['input']>;
  gif?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  gif_id?: InputMaybe<Scalars['Int']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['Int']['input']>;
  video?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Oob_Tokens_Metadata_Max_Fields = {
  __typename?: 'oob_tokens_metadata_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  gif_id?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "oob_live_view_path" */
  live_view_path?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_live_view_url" */
  live_view_url?: Maybe<Scalars['String']['output']>;
  /** a computed field that returns the media proxy url for this OOB token's statically rendered image */
  media_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_preview_asset_url" */
  preview_asset_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_primary_asset_url" */
  primary_asset_url?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['Int']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  gif_id?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Oob_Tokens_Metadata_Min_Fields = {
  __typename?: 'oob_tokens_metadata_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  gif_id?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "oob_live_view_path" */
  live_view_path?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_live_view_url" */
  live_view_url?: Maybe<Scalars['String']['output']>;
  /** a computed field that returns the media proxy url for this OOB token's statically rendered image */
  media_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_preview_asset_url" */
  preview_asset_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "oob_primary_asset_url" */
  primary_asset_url?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['Int']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  gif_id?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Mutation_Response = {
  __typename?: 'oob_tokens_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Oob_Tokens_Metadata>;
};

/** on_conflict condition type for table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_On_Conflict = {
  constraint: Oob_Tokens_Metadata_Constraint;
  update_columns?: Array<Oob_Tokens_Metadata_Update_Column>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "oob_tokens_metadata". */
export type Oob_Tokens_Metadata_Order_By = {
  contract?: InputMaybe<Contracts_Metadata_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  gif?: InputMaybe<Media_Order_By>;
  gif_id?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Media_Order_By>;
  image_id?: InputMaybe<Order_By>;
  live_view_path?: InputMaybe<Order_By>;
  live_view_url?: InputMaybe<Order_By>;
  media_url?: InputMaybe<Order_By>;
  preview_asset_url?: InputMaybe<Order_By>;
  primary_asset_url?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video?: InputMaybe<Media_Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: oob_tokens_metadata */
export type Oob_Tokens_Metadata_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "oob_tokens_metadata" */
export enum Oob_Tokens_Metadata_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  GifId = 'gif_id',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  VideoId = 'video_id'
}

/** input type for updating data in table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Set_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  gif_id?: InputMaybe<Scalars['Int']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['Int']['input']>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Oob_Tokens_Metadata_Stddev_Fields = {
  __typename?: 'oob_tokens_metadata_stddev_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Stddev_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Oob_Tokens_Metadata_Stddev_Pop_Fields = {
  __typename?: 'oob_tokens_metadata_stddev_pop_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Stddev_Pop_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Oob_Tokens_Metadata_Stddev_Samp_Fields = {
  __typename?: 'oob_tokens_metadata_stddev_samp_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Stddev_Samp_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Oob_Tokens_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Oob_Tokens_Metadata_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  gif_id?: InputMaybe<Scalars['Int']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['Int']['input']>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Oob_Tokens_Metadata_Sum_Fields = {
  __typename?: 'oob_tokens_metadata_sum_fields';
  gif_id?: Maybe<Scalars['Int']['output']>;
  image_id?: Maybe<Scalars['Int']['output']>;
  token_id?: Maybe<Scalars['Int']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Sum_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** update columns of table "oob_tokens_metadata" */
export enum Oob_Tokens_Metadata_Update_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  GifId = 'gif_id',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  VideoId = 'video_id'
}

export type Oob_Tokens_Metadata_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Oob_Tokens_Metadata_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Oob_Tokens_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Oob_Tokens_Metadata_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Oob_Tokens_Metadata_Var_Pop_Fields = {
  __typename?: 'oob_tokens_metadata_var_pop_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Var_Pop_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Oob_Tokens_Metadata_Var_Samp_Fields = {
  __typename?: 'oob_tokens_metadata_var_samp_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Var_Samp_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Oob_Tokens_Metadata_Variance_Fields = {
  __typename?: 'oob_tokens_metadata_variance_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  token_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "oob_tokens_metadata" */
export type Oob_Tokens_Metadata_Variance_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "partner_types" */
export type Partner_Types = {
  __typename?: 'partner_types';
  type: Scalars['String']['output'];
};

/** aggregated selection of "partner_types" */
export type Partner_Types_Aggregate = {
  __typename?: 'partner_types_aggregate';
  aggregate?: Maybe<Partner_Types_Aggregate_Fields>;
  nodes: Array<Partner_Types>;
};

/** aggregate fields of "partner_types" */
export type Partner_Types_Aggregate_Fields = {
  __typename?: 'partner_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Partner_Types_Max_Fields>;
  min?: Maybe<Partner_Types_Min_Fields>;
};


/** aggregate fields of "partner_types" */
export type Partner_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partner_types". All fields are combined with a logical 'AND'. */
export type Partner_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Types_Bool_Exp>>;
  _not?: InputMaybe<Partner_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partner_types" */
export enum Partner_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  PartnerTypesPkey = 'partner_types_pkey'
}

export enum Partner_Types_Enum {
  Default = 'DEFAULT',
  StudioArtist = 'STUDIO_ARTIST'
}

/** Boolean expression to compare columns of type "partner_types_enum". All fields are combined with logical 'AND'. */
export type Partner_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Partner_Types_Enum>;
  _in?: InputMaybe<Array<Partner_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Partner_Types_Enum>;
  _nin?: InputMaybe<Array<Partner_Types_Enum>>;
};

/** input type for inserting data into table "partner_types" */
export type Partner_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partner_Types_Max_Fields = {
  __typename?: 'partner_types_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Partner_Types_Min_Fields = {
  __typename?: 'partner_types_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partner_types" */
export type Partner_Types_Mutation_Response = {
  __typename?: 'partner_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Types>;
};

/** on_conflict condition type for table "partner_types" */
export type Partner_Types_On_Conflict = {
  constraint: Partner_Types_Constraint;
  update_columns?: Array<Partner_Types_Update_Column>;
  where?: InputMaybe<Partner_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "partner_types". */
export type Partner_Types_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partner_types */
export type Partner_Types_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "partner_types" */
export enum Partner_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "partner_types" */
export type Partner_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partner_types" */
export type Partner_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Types_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partner_types" */
export enum Partner_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type Partner_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Types_Bool_Exp;
};

/** columns and relationships of "partners" */
export type Partners = {
  __typename?: 'partners';
  ab_royalty_percentage?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  contracts: Array<Contracts_Metadata>;
  /** An aggregate relationship */
  contracts_aggregate: Contracts_Metadata_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  discord?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagram_handle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  profile_picture?: Maybe<Media>;
  profile_picture_id?: Maybe<Scalars['Int']['output']>;
  properties_updated_at: Scalars['jsonb']['output'];
  twitter_handle?: Maybe<Scalars['String']['output']>;
  type: Partner_Types_Enum;
  website?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "partners" */
export type PartnersContractsArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


/** columns and relationships of "partners" */
export type PartnersContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


/** columns and relationships of "partners" */
export type PartnersProperties_Updated_AtArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "partners" */
export type Partners_Aggregate = {
  __typename?: 'partners_aggregate';
  aggregate?: Maybe<Partners_Aggregate_Fields>;
  nodes: Array<Partners>;
};

/** aggregate fields of "partners" */
export type Partners_Aggregate_Fields = {
  __typename?: 'partners_aggregate_fields';
  avg?: Maybe<Partners_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Partners_Max_Fields>;
  min?: Maybe<Partners_Min_Fields>;
  stddev?: Maybe<Partners_Stddev_Fields>;
  stddev_pop?: Maybe<Partners_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Partners_Stddev_Samp_Fields>;
  sum?: Maybe<Partners_Sum_Fields>;
  var_pop?: Maybe<Partners_Var_Pop_Fields>;
  var_samp?: Maybe<Partners_Var_Samp_Fields>;
  variance?: Maybe<Partners_Variance_Fields>;
};


/** aggregate fields of "partners" */
export type Partners_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Partners_Append_Input = {
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Partners_Avg_Fields = {
  __typename?: 'partners_avg_fields';
  ab_royalty_percentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "partners". All fields are combined with a logical 'AND'. */
export type Partners_Bool_Exp = {
  _and?: InputMaybe<Array<Partners_Bool_Exp>>;
  _not?: InputMaybe<Partners_Bool_Exp>;
  _or?: InputMaybe<Array<Partners_Bool_Exp>>;
  ab_royalty_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  contracts?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  contracts_aggregate?: InputMaybe<Contracts_Metadata_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discord?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  instagram_handle?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  profile_picture?: InputMaybe<Media_Bool_Exp>;
  profile_picture_id?: InputMaybe<Int_Comparison_Exp>;
  properties_updated_at?: InputMaybe<Jsonb_Comparison_Exp>;
  twitter_handle?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Partner_Types_Enum_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partners" */
export enum Partners_Constraint {
  /** unique or primary key constraint on columns "name" */
  PartnersNameKey = 'partners_name_key',
  /** unique or primary key constraint on columns "id" */
  PartnersPkey = 'partners_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Partners_Delete_At_Path_Input = {
  properties_updated_at?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Partners_Delete_Elem_Input = {
  properties_updated_at?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Partners_Delete_Key_Input = {
  properties_updated_at?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "partners" */
export type Partners_Inc_Input = {
  ab_royalty_percentage?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  profile_picture_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "partners" */
export type Partners_Insert_Input = {
  ab_royalty_percentage?: InputMaybe<Scalars['numeric']['input']>;
  contracts?: InputMaybe<Contracts_Metadata_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  discord?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagram_handle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile_picture?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  profile_picture_id?: InputMaybe<Scalars['Int']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  twitter_handle?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Partner_Types_Enum>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Partners_Max_Fields = {
  __typename?: 'partners_max_fields';
  ab_royalty_percentage?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discord?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  instagram_handle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile_picture_id?: Maybe<Scalars['Int']['output']>;
  twitter_handle?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Partners_Min_Fields = {
  __typename?: 'partners_min_fields';
  ab_royalty_percentage?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discord?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  instagram_handle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile_picture_id?: Maybe<Scalars['Int']['output']>;
  twitter_handle?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partners" */
export type Partners_Mutation_Response = {
  __typename?: 'partners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Partners>;
};

/** input type for inserting object relation for remote table "partners" */
export type Partners_Obj_Rel_Insert_Input = {
  data: Partners_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partners_On_Conflict>;
};

/** on_conflict condition type for table "partners" */
export type Partners_On_Conflict = {
  constraint: Partners_Constraint;
  update_columns?: Array<Partners_Update_Column>;
  where?: InputMaybe<Partners_Bool_Exp>;
};

/** Ordering options when selecting data from "partners". */
export type Partners_Order_By = {
  ab_royalty_percentage?: InputMaybe<Order_By>;
  contracts_aggregate?: InputMaybe<Contracts_Metadata_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  discord?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram_handle?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  profile_picture?: InputMaybe<Media_Order_By>;
  profile_picture_id?: InputMaybe<Order_By>;
  properties_updated_at?: InputMaybe<Order_By>;
  twitter_handle?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partners */
export type Partners_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Partners_Prepend_Input = {
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "partners" */
export enum Partners_Select_Column {
  /** column name */
  AbRoyaltyPercentage = 'ab_royalty_percentage',
  /** column name */
  Description = 'description',
  /** column name */
  Discord = 'discord',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramHandle = 'instagram_handle',
  /** column name */
  Name = 'name',
  /** column name */
  ProfilePictureId = 'profile_picture_id',
  /** column name */
  PropertiesUpdatedAt = 'properties_updated_at',
  /** column name */
  TwitterHandle = 'twitter_handle',
  /** column name */
  Type = 'type',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "partners" */
export type Partners_Set_Input = {
  ab_royalty_percentage?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discord?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagram_handle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile_picture_id?: InputMaybe<Scalars['Int']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  twitter_handle?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Partner_Types_Enum>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Partners_Stddev_Fields = {
  __typename?: 'partners_stddev_fields';
  ab_royalty_percentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Partners_Stddev_Pop_Fields = {
  __typename?: 'partners_stddev_pop_fields';
  ab_royalty_percentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Partners_Stddev_Samp_Fields = {
  __typename?: 'partners_stddev_samp_fields';
  ab_royalty_percentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "partners" */
export type Partners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partners_Stream_Cursor_Value_Input = {
  ab_royalty_percentage?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discord?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagram_handle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile_picture_id?: InputMaybe<Scalars['Int']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  twitter_handle?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Partner_Types_Enum>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Partners_Sum_Fields = {
  __typename?: 'partners_sum_fields';
  ab_royalty_percentage?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  profile_picture_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "partners" */
export enum Partners_Update_Column {
  /** column name */
  AbRoyaltyPercentage = 'ab_royalty_percentage',
  /** column name */
  Description = 'description',
  /** column name */
  Discord = 'discord',
  /** column name */
  Id = 'id',
  /** column name */
  InstagramHandle = 'instagram_handle',
  /** column name */
  Name = 'name',
  /** column name */
  ProfilePictureId = 'profile_picture_id',
  /** column name */
  PropertiesUpdatedAt = 'properties_updated_at',
  /** column name */
  TwitterHandle = 'twitter_handle',
  /** column name */
  Type = 'type',
  /** column name */
  Website = 'website'
}

export type Partners_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Partners_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Partners_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Partners_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Partners_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Partners_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Partners_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partners_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partners_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Partners_Var_Pop_Fields = {
  __typename?: 'partners_var_pop_fields';
  ab_royalty_percentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Partners_Var_Samp_Fields = {
  __typename?: 'partners_var_samp_fields';
  ab_royalty_percentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Partners_Variance_Fields = {
  __typename?: 'partners_variance_fields';
  ab_royalty_percentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** enum of auth options that may be configured on a post mint parameter */
export type Pmp_Auth_Options = {
  __typename?: 'pmp_auth_options';
  option: Scalars['String']['output'];
};

/** aggregated selection of "pmp_auth_options" */
export type Pmp_Auth_Options_Aggregate = {
  __typename?: 'pmp_auth_options_aggregate';
  aggregate?: Maybe<Pmp_Auth_Options_Aggregate_Fields>;
  nodes: Array<Pmp_Auth_Options>;
};

/** aggregate fields of "pmp_auth_options" */
export type Pmp_Auth_Options_Aggregate_Fields = {
  __typename?: 'pmp_auth_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pmp_Auth_Options_Max_Fields>;
  min?: Maybe<Pmp_Auth_Options_Min_Fields>;
};


/** aggregate fields of "pmp_auth_options" */
export type Pmp_Auth_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pmp_Auth_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pmp_auth_options". All fields are combined with a logical 'AND'. */
export type Pmp_Auth_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Pmp_Auth_Options_Bool_Exp>>;
  _not?: InputMaybe<Pmp_Auth_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Pmp_Auth_Options_Bool_Exp>>;
  option?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pmp_auth_options" */
export enum Pmp_Auth_Options_Constraint {
  /** unique or primary key constraint on columns "option" */
  PmpAuthOptionsPkey = 'pmp_auth_options_pkey'
}

export enum Pmp_Auth_Options_Enum {
  Address = 'Address',
  Artist = 'Artist',
  ArtistAndAddress = 'ArtistAndAddress',
  ArtistAndTokenOwner = 'ArtistAndTokenOwner',
  ArtistAndTokenOwnerAndAddress = 'ArtistAndTokenOwnerAndAddress',
  TokenOwner = 'TokenOwner',
  TokenOwnerAndAddress = 'TokenOwnerAndAddress'
}

/** Boolean expression to compare columns of type "pmp_auth_options_enum". All fields are combined with logical 'AND'. */
export type Pmp_Auth_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Pmp_Auth_Options_Enum>;
  _in?: InputMaybe<Array<Pmp_Auth_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Pmp_Auth_Options_Enum>;
  _nin?: InputMaybe<Array<Pmp_Auth_Options_Enum>>;
};

/** input type for inserting data into table "pmp_auth_options" */
export type Pmp_Auth_Options_Insert_Input = {
  option?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pmp_Auth_Options_Max_Fields = {
  __typename?: 'pmp_auth_options_max_fields';
  option?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pmp_Auth_Options_Min_Fields = {
  __typename?: 'pmp_auth_options_min_fields';
  option?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "pmp_auth_options" */
export type Pmp_Auth_Options_Mutation_Response = {
  __typename?: 'pmp_auth_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pmp_Auth_Options>;
};

/** on_conflict condition type for table "pmp_auth_options" */
export type Pmp_Auth_Options_On_Conflict = {
  constraint: Pmp_Auth_Options_Constraint;
  update_columns?: Array<Pmp_Auth_Options_Update_Column>;
  where?: InputMaybe<Pmp_Auth_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "pmp_auth_options". */
export type Pmp_Auth_Options_Order_By = {
  option?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pmp_auth_options */
export type Pmp_Auth_Options_Pk_Columns_Input = {
  option: Scalars['String']['input'];
};

/** select columns of table "pmp_auth_options" */
export enum Pmp_Auth_Options_Select_Column {
  /** column name */
  Option = 'option'
}

/** input type for updating data in table "pmp_auth_options" */
export type Pmp_Auth_Options_Set_Input = {
  option?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "pmp_auth_options" */
export type Pmp_Auth_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pmp_Auth_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pmp_Auth_Options_Stream_Cursor_Value_Input = {
  option?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "pmp_auth_options" */
export enum Pmp_Auth_Options_Update_Column {
  /** column name */
  Option = 'option'
}

export type Pmp_Auth_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pmp_Auth_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pmp_Auth_Options_Bool_Exp;
};

/** active post mint parameter configurations for specific parameters on a project. */
export type Pmp_Configs = {
  __typename?: 'pmp_configs';
  auth_address?: Maybe<Scalars['String']['output']>;
  auth_option: Pmp_Auth_Options_Enum;
  created_at: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  max_range?: Maybe<Scalars['String']['output']>;
  min_range?: Maybe<Scalars['String']['output']>;
  param_type: Pmp_Param_Types_Enum;
  pmp_locked_after_timestamp?: Maybe<Scalars['timestamp']['output']>;
  pmp_project_config: Scalars['String']['output'];
  /** An object relationship */
  pmp_project_config_parent: Pmp_Project_Configs;
  select_options?: Maybe<Array<Scalars['String']['output']>>;
};

/** aggregated selection of "pmp_configs" */
export type Pmp_Configs_Aggregate = {
  __typename?: 'pmp_configs_aggregate';
  aggregate?: Maybe<Pmp_Configs_Aggregate_Fields>;
  nodes: Array<Pmp_Configs>;
};

export type Pmp_Configs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Pmp_Configs_Aggregate_Bool_Exp_Count>;
};

export type Pmp_Configs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pmp_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pmp_Configs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pmp_configs" */
export type Pmp_Configs_Aggregate_Fields = {
  __typename?: 'pmp_configs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pmp_Configs_Max_Fields>;
  min?: Maybe<Pmp_Configs_Min_Fields>;
};


/** aggregate fields of "pmp_configs" */
export type Pmp_Configs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pmp_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pmp_configs" */
export type Pmp_Configs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pmp_Configs_Max_Order_By>;
  min?: InputMaybe<Pmp_Configs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "pmp_configs" */
export type Pmp_Configs_Arr_Rel_Insert_Input = {
  data: Array<Pmp_Configs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pmp_Configs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "pmp_configs". All fields are combined with a logical 'AND'. */
export type Pmp_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Pmp_Configs_Bool_Exp>>;
  _not?: InputMaybe<Pmp_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Pmp_Configs_Bool_Exp>>;
  auth_address?: InputMaybe<String_Comparison_Exp>;
  auth_option?: InputMaybe<Pmp_Auth_Options_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  max_range?: InputMaybe<String_Comparison_Exp>;
  min_range?: InputMaybe<String_Comparison_Exp>;
  param_type?: InputMaybe<Pmp_Param_Types_Enum_Comparison_Exp>;
  pmp_locked_after_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  pmp_project_config?: InputMaybe<String_Comparison_Exp>;
  pmp_project_config_parent?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
  select_options?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "pmp_configs" */
export enum Pmp_Configs_Constraint {
  /** unique or primary key constraint on columns "id" */
  PmpConfigsPkey = 'pmp_configs_pkey'
}

/** input type for inserting data into table "pmp_configs" */
export type Pmp_Configs_Insert_Input = {
  auth_address?: InputMaybe<Scalars['String']['input']>;
  auth_option?: InputMaybe<Pmp_Auth_Options_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  max_range?: InputMaybe<Scalars['String']['input']>;
  min_range?: InputMaybe<Scalars['String']['input']>;
  param_type?: InputMaybe<Pmp_Param_Types_Enum>;
  pmp_locked_after_timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  pmp_project_config?: InputMaybe<Scalars['String']['input']>;
  pmp_project_config_parent?: InputMaybe<Pmp_Project_Configs_Obj_Rel_Insert_Input>;
  select_options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate max on columns */
export type Pmp_Configs_Max_Fields = {
  __typename?: 'pmp_configs_max_fields';
  auth_address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  max_range?: Maybe<Scalars['String']['output']>;
  min_range?: Maybe<Scalars['String']['output']>;
  pmp_locked_after_timestamp?: Maybe<Scalars['timestamp']['output']>;
  pmp_project_config?: Maybe<Scalars['String']['output']>;
  select_options?: Maybe<Array<Scalars['String']['output']>>;
};

/** order by max() on columns of table "pmp_configs" */
export type Pmp_Configs_Max_Order_By = {
  auth_address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  max_range?: InputMaybe<Order_By>;
  min_range?: InputMaybe<Order_By>;
  pmp_locked_after_timestamp?: InputMaybe<Order_By>;
  pmp_project_config?: InputMaybe<Order_By>;
  select_options?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pmp_Configs_Min_Fields = {
  __typename?: 'pmp_configs_min_fields';
  auth_address?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  max_range?: Maybe<Scalars['String']['output']>;
  min_range?: Maybe<Scalars['String']['output']>;
  pmp_locked_after_timestamp?: Maybe<Scalars['timestamp']['output']>;
  pmp_project_config?: Maybe<Scalars['String']['output']>;
  select_options?: Maybe<Array<Scalars['String']['output']>>;
};

/** order by min() on columns of table "pmp_configs" */
export type Pmp_Configs_Min_Order_By = {
  auth_address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  max_range?: InputMaybe<Order_By>;
  min_range?: InputMaybe<Order_By>;
  pmp_locked_after_timestamp?: InputMaybe<Order_By>;
  pmp_project_config?: InputMaybe<Order_By>;
  select_options?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pmp_configs" */
export type Pmp_Configs_Mutation_Response = {
  __typename?: 'pmp_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pmp_Configs>;
};

/** on_conflict condition type for table "pmp_configs" */
export type Pmp_Configs_On_Conflict = {
  constraint: Pmp_Configs_Constraint;
  update_columns?: Array<Pmp_Configs_Update_Column>;
  where?: InputMaybe<Pmp_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "pmp_configs". */
export type Pmp_Configs_Order_By = {
  auth_address?: InputMaybe<Order_By>;
  auth_option?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  max_range?: InputMaybe<Order_By>;
  min_range?: InputMaybe<Order_By>;
  param_type?: InputMaybe<Order_By>;
  pmp_locked_after_timestamp?: InputMaybe<Order_By>;
  pmp_project_config?: InputMaybe<Order_By>;
  pmp_project_config_parent?: InputMaybe<Pmp_Project_Configs_Order_By>;
  select_options?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pmp_configs */
export type Pmp_Configs_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "pmp_configs" */
export enum Pmp_Configs_Select_Column {
  /** column name */
  AuthAddress = 'auth_address',
  /** column name */
  AuthOption = 'auth_option',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  MaxRange = 'max_range',
  /** column name */
  MinRange = 'min_range',
  /** column name */
  ParamType = 'param_type',
  /** column name */
  PmpLockedAfterTimestamp = 'pmp_locked_after_timestamp',
  /** column name */
  PmpProjectConfig = 'pmp_project_config',
  /** column name */
  SelectOptions = 'select_options'
}

/** input type for updating data in table "pmp_configs" */
export type Pmp_Configs_Set_Input = {
  auth_address?: InputMaybe<Scalars['String']['input']>;
  auth_option?: InputMaybe<Pmp_Auth_Options_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  max_range?: InputMaybe<Scalars['String']['input']>;
  min_range?: InputMaybe<Scalars['String']['input']>;
  param_type?: InputMaybe<Pmp_Param_Types_Enum>;
  pmp_locked_after_timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  pmp_project_config?: InputMaybe<Scalars['String']['input']>;
  select_options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Streaming cursor of the table "pmp_configs" */
export type Pmp_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pmp_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pmp_Configs_Stream_Cursor_Value_Input = {
  auth_address?: InputMaybe<Scalars['String']['input']>;
  auth_option?: InputMaybe<Pmp_Auth_Options_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  max_range?: InputMaybe<Scalars['String']['input']>;
  min_range?: InputMaybe<Scalars['String']['input']>;
  param_type?: InputMaybe<Pmp_Param_Types_Enum>;
  pmp_locked_after_timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  pmp_project_config?: InputMaybe<Scalars['String']['input']>;
  select_options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** update columns of table "pmp_configs" */
export enum Pmp_Configs_Update_Column {
  /** column name */
  AuthAddress = 'auth_address',
  /** column name */
  AuthOption = 'auth_option',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  MaxRange = 'max_range',
  /** column name */
  MinRange = 'min_range',
  /** column name */
  ParamType = 'param_type',
  /** column name */
  PmpLockedAfterTimestamp = 'pmp_locked_after_timestamp',
  /** column name */
  PmpProjectConfig = 'pmp_project_config',
  /** column name */
  SelectOptions = 'select_options'
}

export type Pmp_Configs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pmp_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pmp_Configs_Bool_Exp;
};

/** enum of supported pmp parameter types */
export type Pmp_Param_Types = {
  __typename?: 'pmp_param_types';
  type: Scalars['String']['output'];
};

/** aggregated selection of "pmp_param_types" */
export type Pmp_Param_Types_Aggregate = {
  __typename?: 'pmp_param_types_aggregate';
  aggregate?: Maybe<Pmp_Param_Types_Aggregate_Fields>;
  nodes: Array<Pmp_Param_Types>;
};

/** aggregate fields of "pmp_param_types" */
export type Pmp_Param_Types_Aggregate_Fields = {
  __typename?: 'pmp_param_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pmp_Param_Types_Max_Fields>;
  min?: Maybe<Pmp_Param_Types_Min_Fields>;
};


/** aggregate fields of "pmp_param_types" */
export type Pmp_Param_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pmp_Param_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pmp_param_types". All fields are combined with a logical 'AND'. */
export type Pmp_Param_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Pmp_Param_Types_Bool_Exp>>;
  _not?: InputMaybe<Pmp_Param_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Pmp_Param_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pmp_param_types" */
export enum Pmp_Param_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  PmpParamTypesPkey = 'pmp_param_types_pkey'
}

export enum Pmp_Param_Types_Enum {
  Bool = 'Bool',
  DecimalRange = 'DecimalRange',
  HexColor = 'HexColor',
  Int256Range = 'Int256Range',
  Select = 'Select',
  String = 'String',
  Timestamp = 'Timestamp',
  Uint256Range = 'Uint256Range',
  Unconfigured = 'Unconfigured'
}

/** Boolean expression to compare columns of type "pmp_param_types_enum". All fields are combined with logical 'AND'. */
export type Pmp_Param_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Pmp_Param_Types_Enum>;
  _in?: InputMaybe<Array<Pmp_Param_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Pmp_Param_Types_Enum>;
  _nin?: InputMaybe<Array<Pmp_Param_Types_Enum>>;
};

/** input type for inserting data into table "pmp_param_types" */
export type Pmp_Param_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pmp_Param_Types_Max_Fields = {
  __typename?: 'pmp_param_types_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pmp_Param_Types_Min_Fields = {
  __typename?: 'pmp_param_types_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "pmp_param_types" */
export type Pmp_Param_Types_Mutation_Response = {
  __typename?: 'pmp_param_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pmp_Param_Types>;
};

/** on_conflict condition type for table "pmp_param_types" */
export type Pmp_Param_Types_On_Conflict = {
  constraint: Pmp_Param_Types_Constraint;
  update_columns?: Array<Pmp_Param_Types_Update_Column>;
  where?: InputMaybe<Pmp_Param_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "pmp_param_types". */
export type Pmp_Param_Types_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pmp_param_types */
export type Pmp_Param_Types_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "pmp_param_types" */
export enum Pmp_Param_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "pmp_param_types" */
export type Pmp_Param_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "pmp_param_types" */
export type Pmp_Param_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pmp_Param_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pmp_Param_Types_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "pmp_param_types" */
export enum Pmp_Param_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type Pmp_Param_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pmp_Param_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pmp_Param_Types_Bool_Exp;
};

/** post mint parameter project configuration for a specific pmp contract */
export type Pmp_Project_Configs = {
  __typename?: 'pmp_project_configs';
  id: Scalars['String']['output'];
  pmp_address?: Maybe<Scalars['String']['output']>;
  pmp_config_keys?: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  pmp_configs: Array<Pmp_Configs>;
  /** An aggregate relationship */
  pmp_configs_aggregate: Pmp_Configs_Aggregate;
  project_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project_metadata?: Maybe<Projects_Metadata>;
  updated_at: Scalars['timestamp']['output'];
};


/** post mint parameter project configuration for a specific pmp contract */
export type Pmp_Project_ConfigsPmp_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Configs_Bool_Exp>;
};


/** post mint parameter project configuration for a specific pmp contract */
export type Pmp_Project_ConfigsPmp_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Configs_Bool_Exp>;
};

/** aggregated selection of "pmp_project_configs" */
export type Pmp_Project_Configs_Aggregate = {
  __typename?: 'pmp_project_configs_aggregate';
  aggregate?: Maybe<Pmp_Project_Configs_Aggregate_Fields>;
  nodes: Array<Pmp_Project_Configs>;
};

export type Pmp_Project_Configs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Pmp_Project_Configs_Aggregate_Bool_Exp_Count>;
};

export type Pmp_Project_Configs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pmp_Project_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pmp_project_configs" */
export type Pmp_Project_Configs_Aggregate_Fields = {
  __typename?: 'pmp_project_configs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pmp_Project_Configs_Max_Fields>;
  min?: Maybe<Pmp_Project_Configs_Min_Fields>;
};


/** aggregate fields of "pmp_project_configs" */
export type Pmp_Project_Configs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pmp_Project_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pmp_project_configs" */
export type Pmp_Project_Configs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pmp_Project_Configs_Max_Order_By>;
  min?: InputMaybe<Pmp_Project_Configs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "pmp_project_configs" */
export type Pmp_Project_Configs_Arr_Rel_Insert_Input = {
  data: Array<Pmp_Project_Configs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pmp_Project_Configs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "pmp_project_configs". All fields are combined with a logical 'AND'. */
export type Pmp_Project_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Pmp_Project_Configs_Bool_Exp>>;
  _not?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Pmp_Project_Configs_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  pmp_address?: InputMaybe<String_Comparison_Exp>;
  pmp_config_keys?: InputMaybe<String_Array_Comparison_Exp>;
  pmp_configs?: InputMaybe<Pmp_Configs_Bool_Exp>;
  pmp_configs_aggregate?: InputMaybe<Pmp_Configs_Aggregate_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_metadata?: InputMaybe<Projects_Metadata_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "pmp_project_configs" */
export enum Pmp_Project_Configs_Constraint {
  /** unique or primary key constraint on columns "id" */
  PmpProjectConfigsPkey = 'pmp_project_configs_pkey'
}

/** input type for inserting data into table "pmp_project_configs" */
export type Pmp_Project_Configs_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  pmp_address?: InputMaybe<Scalars['String']['input']>;
  pmp_config_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  pmp_configs?: InputMaybe<Pmp_Configs_Arr_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_metadata?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Pmp_Project_Configs_Max_Fields = {
  __typename?: 'pmp_project_configs_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  pmp_address?: Maybe<Scalars['String']['output']>;
  pmp_config_keys?: Maybe<Array<Scalars['String']['output']>>;
  project_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "pmp_project_configs" */
export type Pmp_Project_Configs_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  pmp_address?: InputMaybe<Order_By>;
  pmp_config_keys?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pmp_Project_Configs_Min_Fields = {
  __typename?: 'pmp_project_configs_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  pmp_address?: Maybe<Scalars['String']['output']>;
  pmp_config_keys?: Maybe<Array<Scalars['String']['output']>>;
  project_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "pmp_project_configs" */
export type Pmp_Project_Configs_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  pmp_address?: InputMaybe<Order_By>;
  pmp_config_keys?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pmp_project_configs" */
export type Pmp_Project_Configs_Mutation_Response = {
  __typename?: 'pmp_project_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pmp_Project_Configs>;
};

/** input type for inserting object relation for remote table "pmp_project_configs" */
export type Pmp_Project_Configs_Obj_Rel_Insert_Input = {
  data: Pmp_Project_Configs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pmp_Project_Configs_On_Conflict>;
};

/** on_conflict condition type for table "pmp_project_configs" */
export type Pmp_Project_Configs_On_Conflict = {
  constraint: Pmp_Project_Configs_Constraint;
  update_columns?: Array<Pmp_Project_Configs_Update_Column>;
  where?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "pmp_project_configs". */
export type Pmp_Project_Configs_Order_By = {
  id?: InputMaybe<Order_By>;
  pmp_address?: InputMaybe<Order_By>;
  pmp_config_keys?: InputMaybe<Order_By>;
  pmp_configs_aggregate?: InputMaybe<Pmp_Configs_Aggregate_Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_metadata?: InputMaybe<Projects_Metadata_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pmp_project_configs */
export type Pmp_Project_Configs_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "pmp_project_configs" */
export enum Pmp_Project_Configs_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PmpAddress = 'pmp_address',
  /** column name */
  PmpConfigKeys = 'pmp_config_keys',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pmp_project_configs" */
export type Pmp_Project_Configs_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  pmp_address?: InputMaybe<Scalars['String']['input']>;
  pmp_config_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "pmp_project_configs" */
export type Pmp_Project_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pmp_Project_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pmp_Project_Configs_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  pmp_address?: InputMaybe<Scalars['String']['input']>;
  pmp_config_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "pmp_project_configs" */
export enum Pmp_Project_Configs_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PmpAddress = 'pmp_address',
  /** column name */
  PmpConfigKeys = 'pmp_config_keys',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pmp_Project_Configs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pmp_Project_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pmp_Project_Configs_Bool_Exp;
};

/** post mint parameter values for individual tokens */
export type Pmps_Metadata = {
  __typename?: 'pmps_metadata';
  artist_configured_value_string?: Maybe<Scalars['String']['output']>;
  configured_param_type: Pmp_Param_Types_Enum;
  configured_value?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  non_artist_configured_value_string?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  token_pmp_nonce: Scalars['Int']['output'];
  /** An object relationship */
  tokens_metadata?: Maybe<Tokens_Metadata>;
};

/** aggregated selection of "pmps_metadata" */
export type Pmps_Metadata_Aggregate = {
  __typename?: 'pmps_metadata_aggregate';
  aggregate?: Maybe<Pmps_Metadata_Aggregate_Fields>;
  nodes: Array<Pmps_Metadata>;
};

export type Pmps_Metadata_Aggregate_Bool_Exp = {
  count?: InputMaybe<Pmps_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Pmps_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pmps_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pmps_metadata" */
export type Pmps_Metadata_Aggregate_Fields = {
  __typename?: 'pmps_metadata_aggregate_fields';
  avg?: Maybe<Pmps_Metadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pmps_Metadata_Max_Fields>;
  min?: Maybe<Pmps_Metadata_Min_Fields>;
  stddev?: Maybe<Pmps_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Pmps_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pmps_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Pmps_Metadata_Sum_Fields>;
  var_pop?: Maybe<Pmps_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Pmps_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Pmps_Metadata_Variance_Fields>;
};


/** aggregate fields of "pmps_metadata" */
export type Pmps_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pmps_metadata" */
export type Pmps_Metadata_Aggregate_Order_By = {
  avg?: InputMaybe<Pmps_Metadata_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pmps_Metadata_Max_Order_By>;
  min?: InputMaybe<Pmps_Metadata_Min_Order_By>;
  stddev?: InputMaybe<Pmps_Metadata_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pmps_Metadata_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pmps_Metadata_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pmps_Metadata_Sum_Order_By>;
  var_pop?: InputMaybe<Pmps_Metadata_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pmps_Metadata_Var_Samp_Order_By>;
  variance?: InputMaybe<Pmps_Metadata_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pmps_metadata" */
export type Pmps_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Pmps_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pmps_Metadata_On_Conflict>;
};

/** aggregate avg on columns */
export type Pmps_Metadata_Avg_Fields = {
  __typename?: 'pmps_metadata_avg_fields';
  token_pmp_nonce?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Avg_Order_By = {
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pmps_metadata". All fields are combined with a logical 'AND'. */
export type Pmps_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Pmps_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Pmps_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Pmps_Metadata_Bool_Exp>>;
  artist_configured_value_string?: InputMaybe<String_Comparison_Exp>;
  configured_param_type?: InputMaybe<Pmp_Param_Types_Enum_Comparison_Exp>;
  configured_value?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  non_artist_configured_value_string?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  token_pmp_nonce?: InputMaybe<Int_Comparison_Exp>;
  tokens_metadata?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};

/** unique or primary key constraints on table "pmps_metadata" */
export enum Pmps_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  PmpsMetadataPkey = 'pmps_metadata_pkey'
}

/** input type for incrementing numeric columns in table "pmps_metadata" */
export type Pmps_Metadata_Inc_Input = {
  token_pmp_nonce?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "pmps_metadata" */
export type Pmps_Metadata_Insert_Input = {
  artist_configured_value_string?: InputMaybe<Scalars['String']['input']>;
  configured_param_type?: InputMaybe<Pmp_Param_Types_Enum>;
  configured_value?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  non_artist_configured_value_string?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_pmp_nonce?: InputMaybe<Scalars['Int']['input']>;
  tokens_metadata?: InputMaybe<Tokens_Metadata_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pmps_Metadata_Max_Fields = {
  __typename?: 'pmps_metadata_max_fields';
  artist_configured_value_string?: Maybe<Scalars['String']['output']>;
  configured_value?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  non_artist_configured_value_string?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_pmp_nonce?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Max_Order_By = {
  artist_configured_value_string?: InputMaybe<Order_By>;
  configured_value?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  non_artist_configured_value_string?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pmps_Metadata_Min_Fields = {
  __typename?: 'pmps_metadata_min_fields';
  artist_configured_value_string?: Maybe<Scalars['String']['output']>;
  configured_value?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  non_artist_configured_value_string?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  token_pmp_nonce?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Min_Order_By = {
  artist_configured_value_string?: InputMaybe<Order_By>;
  configured_value?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  non_artist_configured_value_string?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pmps_metadata" */
export type Pmps_Metadata_Mutation_Response = {
  __typename?: 'pmps_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pmps_Metadata>;
};

/** on_conflict condition type for table "pmps_metadata" */
export type Pmps_Metadata_On_Conflict = {
  constraint: Pmps_Metadata_Constraint;
  update_columns?: Array<Pmps_Metadata_Update_Column>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "pmps_metadata". */
export type Pmps_Metadata_Order_By = {
  artist_configured_value_string?: InputMaybe<Order_By>;
  configured_param_type?: InputMaybe<Order_By>;
  configured_value?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  non_artist_configured_value_string?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  token_pmp_nonce?: InputMaybe<Order_By>;
  tokens_metadata?: InputMaybe<Tokens_Metadata_Order_By>;
};

/** primary key columns input for table: pmps_metadata */
export type Pmps_Metadata_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "pmps_metadata" */
export enum Pmps_Metadata_Select_Column {
  /** column name */
  ArtistConfiguredValueString = 'artist_configured_value_string',
  /** column name */
  ConfiguredParamType = 'configured_param_type',
  /** column name */
  ConfiguredValue = 'configured_value',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  NonArtistConfiguredValueString = 'non_artist_configured_value_string',
  /** column name */
  Token = 'token',
  /** column name */
  TokenPmpNonce = 'token_pmp_nonce'
}

/** input type for updating data in table "pmps_metadata" */
export type Pmps_Metadata_Set_Input = {
  artist_configured_value_string?: InputMaybe<Scalars['String']['input']>;
  configured_param_type?: InputMaybe<Pmp_Param_Types_Enum>;
  configured_value?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  non_artist_configured_value_string?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_pmp_nonce?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Pmps_Metadata_Stddev_Fields = {
  __typename?: 'pmps_metadata_stddev_fields';
  token_pmp_nonce?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Stddev_Order_By = {
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pmps_Metadata_Stddev_Pop_Fields = {
  __typename?: 'pmps_metadata_stddev_pop_fields';
  token_pmp_nonce?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Stddev_Pop_Order_By = {
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pmps_Metadata_Stddev_Samp_Fields = {
  __typename?: 'pmps_metadata_stddev_samp_fields';
  token_pmp_nonce?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Stddev_Samp_Order_By = {
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pmps_metadata" */
export type Pmps_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pmps_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pmps_Metadata_Stream_Cursor_Value_Input = {
  artist_configured_value_string?: InputMaybe<Scalars['String']['input']>;
  configured_param_type?: InputMaybe<Pmp_Param_Types_Enum>;
  configured_value?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  non_artist_configured_value_string?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_pmp_nonce?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Pmps_Metadata_Sum_Fields = {
  __typename?: 'pmps_metadata_sum_fields';
  token_pmp_nonce?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Sum_Order_By = {
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** update columns of table "pmps_metadata" */
export enum Pmps_Metadata_Update_Column {
  /** column name */
  ArtistConfiguredValueString = 'artist_configured_value_string',
  /** column name */
  ConfiguredParamType = 'configured_param_type',
  /** column name */
  ConfiguredValue = 'configured_value',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  NonArtistConfiguredValueString = 'non_artist_configured_value_string',
  /** column name */
  Token = 'token',
  /** column name */
  TokenPmpNonce = 'token_pmp_nonce'
}

export type Pmps_Metadata_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pmps_Metadata_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pmps_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pmps_Metadata_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pmps_Metadata_Var_Pop_Fields = {
  __typename?: 'pmps_metadata_var_pop_fields';
  token_pmp_nonce?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Var_Pop_Order_By = {
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pmps_Metadata_Var_Samp_Fields = {
  __typename?: 'pmps_metadata_var_samp_fields';
  token_pmp_nonce?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Var_Samp_Order_By = {
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pmps_Metadata_Variance_Fields = {
  __typename?: 'pmps_metadata_variance_fields';
  token_pmp_nonce?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "pmps_metadata" */
export type Pmps_Metadata_Variance_Order_By = {
  token_pmp_nonce?: InputMaybe<Order_By>;
};

/** Stores details about a token's primary purchase */
export type Primary_Purchases = {
  __typename?: 'primary_purchases';
  currency_address?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  minter_address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  token: Tokens_Metadata;
  token_id: Scalars['String']['output'];
  transaction_hash: Scalars['String']['output'];
};

/** aggregated selection of "primary_purchases" */
export type Primary_Purchases_Aggregate = {
  __typename?: 'primary_purchases_aggregate';
  aggregate?: Maybe<Primary_Purchases_Aggregate_Fields>;
  nodes: Array<Primary_Purchases>;
};

/** aggregate fields of "primary_purchases" */
export type Primary_Purchases_Aggregate_Fields = {
  __typename?: 'primary_purchases_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Primary_Purchases_Max_Fields>;
  min?: Maybe<Primary_Purchases_Min_Fields>;
};


/** aggregate fields of "primary_purchases" */
export type Primary_Purchases_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Primary_Purchases_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "primary_purchases". All fields are combined with a logical 'AND'. */
export type Primary_Purchases_Bool_Exp = {
  _and?: InputMaybe<Array<Primary_Purchases_Bool_Exp>>;
  _not?: InputMaybe<Primary_Purchases_Bool_Exp>;
  _or?: InputMaybe<Array<Primary_Purchases_Bool_Exp>>;
  currency_address?: InputMaybe<String_Comparison_Exp>;
  currency_symbol?: InputMaybe<String_Comparison_Exp>;
  minter_address?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  token_id?: InputMaybe<String_Comparison_Exp>;
  transaction_hash?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "primary_purchases" */
export enum Primary_Purchases_Constraint {
  /** unique or primary key constraint on columns "token_id" */
  PrimaryPurchasesPkey = 'primary_purchases_pkey'
}

/** input type for inserting data into table "primary_purchases" */
export type Primary_Purchases_Insert_Input = {
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Tokens_Metadata_Obj_Rel_Insert_Input>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  transaction_hash?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Primary_Purchases_Max_Fields = {
  __typename?: 'primary_purchases_max_fields';
  currency_address?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  minter_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['String']['output']>;
  transaction_hash?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Primary_Purchases_Min_Fields = {
  __typename?: 'primary_purchases_min_fields';
  currency_address?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  minter_address?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['String']['output']>;
  transaction_hash?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "primary_purchases" */
export type Primary_Purchases_Mutation_Response = {
  __typename?: 'primary_purchases_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Primary_Purchases>;
};

/** input type for inserting object relation for remote table "primary_purchases" */
export type Primary_Purchases_Obj_Rel_Insert_Input = {
  data: Primary_Purchases_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Primary_Purchases_On_Conflict>;
};

/** on_conflict condition type for table "primary_purchases" */
export type Primary_Purchases_On_Conflict = {
  constraint: Primary_Purchases_Constraint;
  update_columns?: Array<Primary_Purchases_Update_Column>;
  where?: InputMaybe<Primary_Purchases_Bool_Exp>;
};

/** Ordering options when selecting data from "primary_purchases". */
export type Primary_Purchases_Order_By = {
  currency_address?: InputMaybe<Order_By>;
  currency_symbol?: InputMaybe<Order_By>;
  minter_address?: InputMaybe<Order_By>;
  token?: InputMaybe<Tokens_Metadata_Order_By>;
  token_id?: InputMaybe<Order_By>;
  transaction_hash?: InputMaybe<Order_By>;
};

/** primary key columns input for table: primary_purchases */
export type Primary_Purchases_Pk_Columns_Input = {
  token_id: Scalars['String']['input'];
};

/** select columns of table "primary_purchases" */
export enum Primary_Purchases_Select_Column {
  /** column name */
  CurrencyAddress = 'currency_address',
  /** column name */
  CurrencySymbol = 'currency_symbol',
  /** column name */
  MinterAddress = 'minter_address',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TransactionHash = 'transaction_hash'
}

/** input type for updating data in table "primary_purchases" */
export type Primary_Purchases_Set_Input = {
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  transaction_hash?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "primary_purchases" */
export type Primary_Purchases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Primary_Purchases_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Primary_Purchases_Stream_Cursor_Value_Input = {
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  minter_address?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  transaction_hash?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "primary_purchases" */
export enum Primary_Purchases_Update_Column {
  /** column name */
  CurrencyAddress = 'currency_address',
  /** column name */
  CurrencySymbol = 'currency_symbol',
  /** column name */
  MinterAddress = 'minter_address',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TransactionHash = 'transaction_hash'
}

export type Primary_Purchases_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Primary_Purchases_Set_Input>;
  /** filter the rows which have to be updated */
  where: Primary_Purchases_Bool_Exp;
};

/** This table tracks pending & completed "processing jobs" which are a batch of 40 tokens or less. Any given refresh request consists of one or many processing jobs. */
export type Processing_Jobs = {
  __typename?: 'processing_jobs';
  asset_type?: Maybe<Refresh_Asset_Types_Enum>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  refresh_request_id: Scalars['uuid']['output'];
  status: Processing_Jobs_Status_Types_Enum;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "processing_jobs" */
export type Processing_Jobs_Aggregate = {
  __typename?: 'processing_jobs_aggregate';
  aggregate?: Maybe<Processing_Jobs_Aggregate_Fields>;
  nodes: Array<Processing_Jobs>;
};

export type Processing_Jobs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Processing_Jobs_Aggregate_Bool_Exp_Count>;
};

export type Processing_Jobs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Processing_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Processing_Jobs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "processing_jobs" */
export type Processing_Jobs_Aggregate_Fields = {
  __typename?: 'processing_jobs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Processing_Jobs_Max_Fields>;
  min?: Maybe<Processing_Jobs_Min_Fields>;
};


/** aggregate fields of "processing_jobs" */
export type Processing_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Processing_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "processing_jobs" */
export type Processing_Jobs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Processing_Jobs_Max_Order_By>;
  min?: InputMaybe<Processing_Jobs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "processing_jobs" */
export type Processing_Jobs_Arr_Rel_Insert_Input = {
  data: Array<Processing_Jobs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Processing_Jobs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "processing_jobs". All fields are combined with a logical 'AND'. */
export type Processing_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Processing_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Processing_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Processing_Jobs_Bool_Exp>>;
  asset_type?: InputMaybe<Refresh_Asset_Types_Enum_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  refresh_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Processing_Jobs_Status_Types_Enum_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "processing_jobs" */
export enum Processing_Jobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProcessingJobsPkey = 'processing_jobs_pkey'
}

/** input type for inserting data into table "processing_jobs" */
export type Processing_Jobs_Insert_Input = {
  asset_type?: InputMaybe<Refresh_Asset_Types_Enum>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refresh_request_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Processing_Jobs_Status_Types_Enum>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Processing_Jobs_Max_Fields = {
  __typename?: 'processing_jobs_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refresh_request_id?: Maybe<Scalars['uuid']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "processing_jobs" */
export type Processing_Jobs_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  refresh_request_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Processing_Jobs_Min_Fields = {
  __typename?: 'processing_jobs_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refresh_request_id?: Maybe<Scalars['uuid']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "processing_jobs" */
export type Processing_Jobs_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  refresh_request_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "processing_jobs" */
export type Processing_Jobs_Mutation_Response = {
  __typename?: 'processing_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Processing_Jobs>;
};

/** on_conflict condition type for table "processing_jobs" */
export type Processing_Jobs_On_Conflict = {
  constraint: Processing_Jobs_Constraint;
  update_columns?: Array<Processing_Jobs_Update_Column>;
  where?: InputMaybe<Processing_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "processing_jobs". */
export type Processing_Jobs_Order_By = {
  asset_type?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  refresh_request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: processing_jobs */
export type Processing_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "processing_jobs" */
export enum Processing_Jobs_Select_Column {
  /** column name */
  AssetType = 'asset_type',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RefreshRequestId = 'refresh_request_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubmittedAt = 'submitted_at'
}

/** input type for updating data in table "processing_jobs" */
export type Processing_Jobs_Set_Input = {
  asset_type?: InputMaybe<Refresh_Asset_Types_Enum>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refresh_request_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Processing_Jobs_Status_Types_Enum>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types = {
  __typename?: 'processing_jobs_status_types';
  value: Scalars['String']['output'];
};

/** aggregated selection of "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types_Aggregate = {
  __typename?: 'processing_jobs_status_types_aggregate';
  aggregate?: Maybe<Processing_Jobs_Status_Types_Aggregate_Fields>;
  nodes: Array<Processing_Jobs_Status_Types>;
};

/** aggregate fields of "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types_Aggregate_Fields = {
  __typename?: 'processing_jobs_status_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Processing_Jobs_Status_Types_Max_Fields>;
  min?: Maybe<Processing_Jobs_Status_Types_Min_Fields>;
};


/** aggregate fields of "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Processing_Jobs_Status_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "processing_jobs_status_types". All fields are combined with a logical 'AND'. */
export type Processing_Jobs_Status_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Processing_Jobs_Status_Types_Bool_Exp>>;
  _not?: InputMaybe<Processing_Jobs_Status_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Processing_Jobs_Status_Types_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "processing_jobs_status_types" */
export enum Processing_Jobs_Status_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProcessingJobsStatusTypesPkey = 'processing_jobs_status_types_pkey'
}

export enum Processing_Jobs_Status_Types_Enum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

/** Boolean expression to compare columns of type "processing_jobs_status_types_enum". All fields are combined with logical 'AND'. */
export type Processing_Jobs_Status_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Processing_Jobs_Status_Types_Enum>;
  _in?: InputMaybe<Array<Processing_Jobs_Status_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Processing_Jobs_Status_Types_Enum>;
  _nin?: InputMaybe<Array<Processing_Jobs_Status_Types_Enum>>;
};

/** input type for inserting data into table "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Processing_Jobs_Status_Types_Max_Fields = {
  __typename?: 'processing_jobs_status_types_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Processing_Jobs_Status_Types_Min_Fields = {
  __typename?: 'processing_jobs_status_types_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types_Mutation_Response = {
  __typename?: 'processing_jobs_status_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Processing_Jobs_Status_Types>;
};

/** on_conflict condition type for table "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types_On_Conflict = {
  constraint: Processing_Jobs_Status_Types_Constraint;
  update_columns?: Array<Processing_Jobs_Status_Types_Update_Column>;
  where?: InputMaybe<Processing_Jobs_Status_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "processing_jobs_status_types". */
export type Processing_Jobs_Status_Types_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: processing_jobs_status_types */
export type Processing_Jobs_Status_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "processing_jobs_status_types" */
export enum Processing_Jobs_Status_Types_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "processing_jobs_status_types" */
export type Processing_Jobs_Status_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Processing_Jobs_Status_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Processing_Jobs_Status_Types_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "processing_jobs_status_types" */
export enum Processing_Jobs_Status_Types_Update_Column {
  /** column name */
  Value = 'value'
}

export type Processing_Jobs_Status_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Processing_Jobs_Status_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Processing_Jobs_Status_Types_Bool_Exp;
};

/** Streaming cursor of the table "processing_jobs" */
export type Processing_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Processing_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Processing_Jobs_Stream_Cursor_Value_Input = {
  asset_type?: InputMaybe<Refresh_Asset_Types_Enum>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refresh_request_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Processing_Jobs_Status_Types_Enum>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "processing_jobs" */
export enum Processing_Jobs_Update_Column {
  /** column name */
  AssetType = 'asset_type',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RefreshRequestId = 'refresh_request_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubmittedAt = 'submitted_at'
}

export type Processing_Jobs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Processing_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Processing_Jobs_Bool_Exp;
};

/** This table stores metadata for accessing an external dependency for any given Engine Flex project. */
export type Project_External_Asset_Dependencies = {
  __typename?: 'project_external_asset_dependencies';
  bytecode_address?: Maybe<Scalars['String']['output']>;
  cid: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  dependency_metadata?: Maybe<Dependencies_Metadata>;
  dependency_type: Project_External_Asset_Dependency_Types_Enum;
  index: Scalars['Int']['output'];
  /** An object relationship */
  project: Projects_Metadata;
  project_id: Scalars['String']['output'];
};

/** aggregated selection of "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Aggregate = {
  __typename?: 'project_external_asset_dependencies_aggregate';
  aggregate?: Maybe<Project_External_Asset_Dependencies_Aggregate_Fields>;
  nodes: Array<Project_External_Asset_Dependencies>;
};

export type Project_External_Asset_Dependencies_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_External_Asset_Dependencies_Aggregate_Bool_Exp_Count>;
};

export type Project_External_Asset_Dependencies_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_External_Asset_Dependencies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Aggregate_Fields = {
  __typename?: 'project_external_asset_dependencies_aggregate_fields';
  avg?: Maybe<Project_External_Asset_Dependencies_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_External_Asset_Dependencies_Max_Fields>;
  min?: Maybe<Project_External_Asset_Dependencies_Min_Fields>;
  stddev?: Maybe<Project_External_Asset_Dependencies_Stddev_Fields>;
  stddev_pop?: Maybe<Project_External_Asset_Dependencies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_External_Asset_Dependencies_Stddev_Samp_Fields>;
  sum?: Maybe<Project_External_Asset_Dependencies_Sum_Fields>;
  var_pop?: Maybe<Project_External_Asset_Dependencies_Var_Pop_Fields>;
  var_samp?: Maybe<Project_External_Asset_Dependencies_Var_Samp_Fields>;
  variance?: Maybe<Project_External_Asset_Dependencies_Variance_Fields>;
};


/** aggregate fields of "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_External_Asset_Dependencies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Aggregate_Order_By = {
  avg?: InputMaybe<Project_External_Asset_Dependencies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_External_Asset_Dependencies_Max_Order_By>;
  min?: InputMaybe<Project_External_Asset_Dependencies_Min_Order_By>;
  stddev?: InputMaybe<Project_External_Asset_Dependencies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_External_Asset_Dependencies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_External_Asset_Dependencies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_External_Asset_Dependencies_Sum_Order_By>;
  var_pop?: InputMaybe<Project_External_Asset_Dependencies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_External_Asset_Dependencies_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_External_Asset_Dependencies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Arr_Rel_Insert_Input = {
  data: Array<Project_External_Asset_Dependencies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_External_Asset_Dependencies_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_External_Asset_Dependencies_Avg_Fields = {
  __typename?: 'project_external_asset_dependencies_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_external_asset_dependencies". All fields are combined with a logical 'AND'. */
export type Project_External_Asset_Dependencies_Bool_Exp = {
  _and?: InputMaybe<Array<Project_External_Asset_Dependencies_Bool_Exp>>;
  _not?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
  _or?: InputMaybe<Array<Project_External_Asset_Dependencies_Bool_Exp>>;
  bytecode_address?: InputMaybe<String_Comparison_Exp>;
  cid?: InputMaybe<String_Comparison_Exp>;
  data?: InputMaybe<String_Comparison_Exp>;
  dependency_metadata?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
  dependency_type?: InputMaybe<Project_External_Asset_Dependency_Types_Enum_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_external_asset_dependencies" */
export enum Project_External_Asset_Dependencies_Constraint {
  /** unique or primary key constraint on columns "index", "project_id" */
  ProjectExternalAssetDependenciesPkey = 'project_external_asset_dependencies_pkey'
}

/** input type for incrementing numeric columns in table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Insert_Input = {
  bytecode_address?: InputMaybe<Scalars['String']['input']>;
  cid?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  dependency_metadata?: InputMaybe<Dependencies_Metadata_Obj_Rel_Insert_Input>;
  dependency_type?: InputMaybe<Project_External_Asset_Dependency_Types_Enum>;
  index?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_External_Asset_Dependencies_Max_Fields = {
  __typename?: 'project_external_asset_dependencies_max_fields';
  bytecode_address?: Maybe<Scalars['String']['output']>;
  cid?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Max_Order_By = {
  bytecode_address?: InputMaybe<Order_By>;
  cid?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_External_Asset_Dependencies_Min_Fields = {
  __typename?: 'project_external_asset_dependencies_min_fields';
  bytecode_address?: Maybe<Scalars['String']['output']>;
  cid?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Min_Order_By = {
  bytecode_address?: InputMaybe<Order_By>;
  cid?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Mutation_Response = {
  __typename?: 'project_external_asset_dependencies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_External_Asset_Dependencies>;
};

/** on_conflict condition type for table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_On_Conflict = {
  constraint: Project_External_Asset_Dependencies_Constraint;
  update_columns?: Array<Project_External_Asset_Dependencies_Update_Column>;
  where?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
};

/** Ordering options when selecting data from "project_external_asset_dependencies". */
export type Project_External_Asset_Dependencies_Order_By = {
  bytecode_address?: InputMaybe<Order_By>;
  cid?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  dependency_metadata?: InputMaybe<Dependencies_Metadata_Order_By>;
  dependency_type?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_external_asset_dependencies */
export type Project_External_Asset_Dependencies_Pk_Columns_Input = {
  index: Scalars['Int']['input'];
  project_id: Scalars['String']['input'];
};

/** select columns of table "project_external_asset_dependencies" */
export enum Project_External_Asset_Dependencies_Select_Column {
  /** column name */
  BytecodeAddress = 'bytecode_address',
  /** column name */
  Cid = 'cid',
  /** column name */
  Data = 'data',
  /** column name */
  DependencyType = 'dependency_type',
  /** column name */
  Index = 'index',
  /** column name */
  ProjectId = 'project_id'
}

/** input type for updating data in table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Set_Input = {
  bytecode_address?: InputMaybe<Scalars['String']['input']>;
  cid?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  dependency_type?: InputMaybe<Project_External_Asset_Dependency_Types_Enum>;
  index?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Project_External_Asset_Dependencies_Stddev_Fields = {
  __typename?: 'project_external_asset_dependencies_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_External_Asset_Dependencies_Stddev_Pop_Fields = {
  __typename?: 'project_external_asset_dependencies_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_External_Asset_Dependencies_Stddev_Samp_Fields = {
  __typename?: 'project_external_asset_dependencies_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_External_Asset_Dependencies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_External_Asset_Dependencies_Stream_Cursor_Value_Input = {
  bytecode_address?: InputMaybe<Scalars['String']['input']>;
  cid?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  dependency_type?: InputMaybe<Project_External_Asset_Dependency_Types_Enum>;
  index?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Project_External_Asset_Dependencies_Sum_Fields = {
  __typename?: 'project_external_asset_dependencies_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** update columns of table "project_external_asset_dependencies" */
export enum Project_External_Asset_Dependencies_Update_Column {
  /** column name */
  BytecodeAddress = 'bytecode_address',
  /** column name */
  Cid = 'cid',
  /** column name */
  Data = 'data',
  /** column name */
  DependencyType = 'dependency_type',
  /** column name */
  Index = 'index',
  /** column name */
  ProjectId = 'project_id'
}

export type Project_External_Asset_Dependencies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_External_Asset_Dependencies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_External_Asset_Dependencies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_External_Asset_Dependencies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_External_Asset_Dependencies_Var_Pop_Fields = {
  __typename?: 'project_external_asset_dependencies_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_External_Asset_Dependencies_Var_Samp_Fields = {
  __typename?: 'project_external_asset_dependencies_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_External_Asset_Dependencies_Variance_Fields = {
  __typename?: 'project_external_asset_dependencies_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_external_asset_dependencies" */
export type Project_External_Asset_Dependencies_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types = {
  __typename?: 'project_external_asset_dependency_types';
  type: Scalars['String']['output'];
};

/** aggregated selection of "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types_Aggregate = {
  __typename?: 'project_external_asset_dependency_types_aggregate';
  aggregate?: Maybe<Project_External_Asset_Dependency_Types_Aggregate_Fields>;
  nodes: Array<Project_External_Asset_Dependency_Types>;
};

/** aggregate fields of "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types_Aggregate_Fields = {
  __typename?: 'project_external_asset_dependency_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_External_Asset_Dependency_Types_Max_Fields>;
  min?: Maybe<Project_External_Asset_Dependency_Types_Min_Fields>;
};


/** aggregate fields of "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_external_asset_dependency_types". All fields are combined with a logical 'AND'. */
export type Project_External_Asset_Dependency_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Bool_Exp>>;
  _not?: InputMaybe<Project_External_Asset_Dependency_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_external_asset_dependency_types" */
export enum Project_External_Asset_Dependency_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  ProjectExternalAssetDependencyTypesPkey = 'project_external_asset_dependency_types_pkey'
}

export enum Project_External_Asset_Dependency_Types_Enum {
  ArtBlocksDependencyRegistry = 'ART_BLOCKS_DEPENDENCY_REGISTRY',
  Arweave = 'ARWEAVE',
  Ipfs = 'IPFS',
  Onchain = 'ONCHAIN'
}

/** Boolean expression to compare columns of type "project_external_asset_dependency_types_enum". All fields are combined with logical 'AND'. */
export type Project_External_Asset_Dependency_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_External_Asset_Dependency_Types_Enum>;
  _in?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_External_Asset_Dependency_Types_Enum>;
  _nin?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Enum>>;
};

/** input type for inserting data into table "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_External_Asset_Dependency_Types_Max_Fields = {
  __typename?: 'project_external_asset_dependency_types_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_External_Asset_Dependency_Types_Min_Fields = {
  __typename?: 'project_external_asset_dependency_types_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types_Mutation_Response = {
  __typename?: 'project_external_asset_dependency_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_External_Asset_Dependency_Types>;
};

/** on_conflict condition type for table "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types_On_Conflict = {
  constraint: Project_External_Asset_Dependency_Types_Constraint;
  update_columns?: Array<Project_External_Asset_Dependency_Types_Update_Column>;
  where?: InputMaybe<Project_External_Asset_Dependency_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "project_external_asset_dependency_types". */
export type Project_External_Asset_Dependency_Types_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_external_asset_dependency_types */
export type Project_External_Asset_Dependency_Types_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "project_external_asset_dependency_types" */
export enum Project_External_Asset_Dependency_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_external_asset_dependency_types" */
export type Project_External_Asset_Dependency_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_External_Asset_Dependency_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_External_Asset_Dependency_Types_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_external_asset_dependency_types" */
export enum Project_External_Asset_Dependency_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type Project_External_Asset_Dependency_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_External_Asset_Dependency_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_External_Asset_Dependency_Types_Bool_Exp;
};

/** This table holds metadata related to a minter that’s been configured by an artist for their project. Rows are added when an artist selects & assigns a minter type to their project that they’ve not previously used for the project in question. */
export type Project_Minter_Configurations = {
  __typename?: 'project_minter_configurations';
  /** A computed field, executes function "project_minter_config_auction_end_time" */
  auction_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "project_minter_config_auction_start_time" */
  auction_start_time?: Maybe<Scalars['timestamptz']['output']>;
  base_price?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_minter_configuration_complete" */
  complete?: Maybe<Scalars['Boolean']['output']>;
  currency_address: Scalars['String']['output'];
  currency_symbol: Scalars['String']['output'];
  extra_minter_details?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['String']['output'];
  max_invocations?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  minter?: Maybe<Minters_Metadata>;
  minter_id: Scalars['String']['output'];
  offchain_extra_minter_details?: Maybe<Scalars['jsonb']['output']>;
  price_is_configured: Scalars['Boolean']['output'];
  /** An object relationship */
  project?: Maybe<Projects_Metadata>;
  project_id: Scalars['String']['output'];
  properties_updated_at: Scalars['jsonb']['output'];
  purchase_to_disabled: Scalars['Boolean']['output'];
};


/** This table holds metadata related to a minter that’s been configured by an artist for their project. Rows are added when an artist selects & assigns a minter type to their project that they’ve not previously used for the project in question. */
export type Project_Minter_ConfigurationsExtra_Minter_DetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** This table holds metadata related to a minter that’s been configured by an artist for their project. Rows are added when an artist selects & assigns a minter type to their project that they’ve not previously used for the project in question. */
export type Project_Minter_ConfigurationsOffchain_Extra_Minter_DetailsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** This table holds metadata related to a minter that’s been configured by an artist for their project. Rows are added when an artist selects & assigns a minter type to their project that they’ve not previously used for the project in question. */
export type Project_Minter_ConfigurationsProperties_Updated_AtArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "project_minter_configurations" */
export type Project_Minter_Configurations_Aggregate = {
  __typename?: 'project_minter_configurations_aggregate';
  aggregate?: Maybe<Project_Minter_Configurations_Aggregate_Fields>;
  nodes: Array<Project_Minter_Configurations>;
};

/** aggregate fields of "project_minter_configurations" */
export type Project_Minter_Configurations_Aggregate_Fields = {
  __typename?: 'project_minter_configurations_aggregate_fields';
  avg?: Maybe<Project_Minter_Configurations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Minter_Configurations_Max_Fields>;
  min?: Maybe<Project_Minter_Configurations_Min_Fields>;
  stddev?: Maybe<Project_Minter_Configurations_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Minter_Configurations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Minter_Configurations_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Minter_Configurations_Sum_Fields>;
  var_pop?: Maybe<Project_Minter_Configurations_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Minter_Configurations_Var_Samp_Fields>;
  variance?: Maybe<Project_Minter_Configurations_Variance_Fields>;
};


/** aggregate fields of "project_minter_configurations" */
export type Project_Minter_Configurations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Minter_Configurations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Minter_Configurations_Append_Input = {
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  offchain_extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Project_Minter_Configurations_Avg_Fields = {
  __typename?: 'project_minter_configurations_avg_fields';
  max_invocations?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_minter_configurations". All fields are combined with a logical 'AND'. */
export type Project_Minter_Configurations_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Minter_Configurations_Bool_Exp>>;
  _not?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Minter_Configurations_Bool_Exp>>;
  auction_end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  auction_start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  base_price?: InputMaybe<String_Comparison_Exp>;
  complete?: InputMaybe<Boolean_Comparison_Exp>;
  currency_address?: InputMaybe<String_Comparison_Exp>;
  currency_symbol?: InputMaybe<String_Comparison_Exp>;
  extra_minter_details?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  max_invocations?: InputMaybe<Int_Comparison_Exp>;
  minter?: InputMaybe<Minters_Metadata_Bool_Exp>;
  minter_id?: InputMaybe<String_Comparison_Exp>;
  offchain_extra_minter_details?: InputMaybe<Jsonb_Comparison_Exp>;
  price_is_configured?: InputMaybe<Boolean_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  properties_updated_at?: InputMaybe<Jsonb_Comparison_Exp>;
  purchase_to_disabled?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_minter_configurations" */
export enum Project_Minter_Configurations_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectMinterConfigurationsPkey = 'project_minter_configurations_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Minter_Configurations_Delete_At_Path_Input = {
  extra_minter_details?: InputMaybe<Array<Scalars['String']['input']>>;
  offchain_extra_minter_details?: InputMaybe<Array<Scalars['String']['input']>>;
  properties_updated_at?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Minter_Configurations_Delete_Elem_Input = {
  extra_minter_details?: InputMaybe<Scalars['Int']['input']>;
  offchain_extra_minter_details?: InputMaybe<Scalars['Int']['input']>;
  properties_updated_at?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Minter_Configurations_Delete_Key_Input = {
  extra_minter_details?: InputMaybe<Scalars['String']['input']>;
  offchain_extra_minter_details?: InputMaybe<Scalars['String']['input']>;
  properties_updated_at?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "project_minter_configurations" */
export type Project_Minter_Configurations_Inc_Input = {
  max_invocations?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_minter_configurations" */
export type Project_Minter_Configurations_Insert_Input = {
  base_price?: InputMaybe<Scalars['String']['input']>;
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  max_invocations?: InputMaybe<Scalars['Int']['input']>;
  minter?: InputMaybe<Minters_Metadata_Obj_Rel_Insert_Input>;
  minter_id?: InputMaybe<Scalars['String']['input']>;
  offchain_extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  price_is_configured?: InputMaybe<Scalars['Boolean']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  purchase_to_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Project_Minter_Configurations_Max_Fields = {
  __typename?: 'project_minter_configurations_max_fields';
  /** A computed field, executes function "project_minter_config_auction_end_time" */
  auction_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "project_minter_config_auction_start_time" */
  auction_start_time?: Maybe<Scalars['timestamptz']['output']>;
  base_price?: Maybe<Scalars['String']['output']>;
  currency_address?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  max_invocations?: Maybe<Scalars['Int']['output']>;
  minter_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Minter_Configurations_Min_Fields = {
  __typename?: 'project_minter_configurations_min_fields';
  /** A computed field, executes function "project_minter_config_auction_end_time" */
  auction_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "project_minter_config_auction_start_time" */
  auction_start_time?: Maybe<Scalars['timestamptz']['output']>;
  base_price?: Maybe<Scalars['String']['output']>;
  currency_address?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  max_invocations?: Maybe<Scalars['Int']['output']>;
  minter_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_minter_configurations" */
export type Project_Minter_Configurations_Mutation_Response = {
  __typename?: 'project_minter_configurations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Minter_Configurations>;
};

/** input type for inserting object relation for remote table "project_minter_configurations" */
export type Project_Minter_Configurations_Obj_Rel_Insert_Input = {
  data: Project_Minter_Configurations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Minter_Configurations_On_Conflict>;
};

/** on_conflict condition type for table "project_minter_configurations" */
export type Project_Minter_Configurations_On_Conflict = {
  constraint: Project_Minter_Configurations_Constraint;
  update_columns?: Array<Project_Minter_Configurations_Update_Column>;
  where?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
};

/** Ordering options when selecting data from "project_minter_configurations". */
export type Project_Minter_Configurations_Order_By = {
  auction_end_time?: InputMaybe<Order_By>;
  auction_start_time?: InputMaybe<Order_By>;
  base_price?: InputMaybe<Order_By>;
  complete?: InputMaybe<Order_By>;
  currency_address?: InputMaybe<Order_By>;
  currency_symbol?: InputMaybe<Order_By>;
  extra_minter_details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  minter?: InputMaybe<Minters_Metadata_Order_By>;
  minter_id?: InputMaybe<Order_By>;
  offchain_extra_minter_details?: InputMaybe<Order_By>;
  price_is_configured?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
  properties_updated_at?: InputMaybe<Order_By>;
  purchase_to_disabled?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_minter_configurations */
export type Project_Minter_Configurations_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Minter_Configurations_Prepend_Input = {
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  offchain_extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_minter_configurations" */
export enum Project_Minter_Configurations_Select_Column {
  /** column name */
  BasePrice = 'base_price',
  /** column name */
  CurrencyAddress = 'currency_address',
  /** column name */
  CurrencySymbol = 'currency_symbol',
  /** column name */
  ExtraMinterDetails = 'extra_minter_details',
  /** column name */
  Id = 'id',
  /** column name */
  MaxInvocations = 'max_invocations',
  /** column name */
  MinterId = 'minter_id',
  /** column name */
  OffchainExtraMinterDetails = 'offchain_extra_minter_details',
  /** column name */
  PriceIsConfigured = 'price_is_configured',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PropertiesUpdatedAt = 'properties_updated_at',
  /** column name */
  PurchaseToDisabled = 'purchase_to_disabled'
}

/** input type for updating data in table "project_minter_configurations" */
export type Project_Minter_Configurations_Set_Input = {
  base_price?: InputMaybe<Scalars['String']['input']>;
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  max_invocations?: InputMaybe<Scalars['Int']['input']>;
  minter_id?: InputMaybe<Scalars['String']['input']>;
  offchain_extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  price_is_configured?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  purchase_to_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Project_Minter_Configurations_Stddev_Fields = {
  __typename?: 'project_minter_configurations_stddev_fields';
  max_invocations?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Project_Minter_Configurations_Stddev_Pop_Fields = {
  __typename?: 'project_minter_configurations_stddev_pop_fields';
  max_invocations?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Project_Minter_Configurations_Stddev_Samp_Fields = {
  __typename?: 'project_minter_configurations_stddev_samp_fields';
  max_invocations?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "project_minter_configurations" */
export type Project_Minter_Configurations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Minter_Configurations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Minter_Configurations_Stream_Cursor_Value_Input = {
  base_price?: InputMaybe<Scalars['String']['input']>;
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  max_invocations?: InputMaybe<Scalars['Int']['input']>;
  minter_id?: InputMaybe<Scalars['String']['input']>;
  offchain_extra_minter_details?: InputMaybe<Scalars['jsonb']['input']>;
  price_is_configured?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  purchase_to_disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Project_Minter_Configurations_Sum_Fields = {
  __typename?: 'project_minter_configurations_sum_fields';
  max_invocations?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "project_minter_configurations" */
export enum Project_Minter_Configurations_Update_Column {
  /** column name */
  BasePrice = 'base_price',
  /** column name */
  CurrencyAddress = 'currency_address',
  /** column name */
  CurrencySymbol = 'currency_symbol',
  /** column name */
  ExtraMinterDetails = 'extra_minter_details',
  /** column name */
  Id = 'id',
  /** column name */
  MaxInvocations = 'max_invocations',
  /** column name */
  MinterId = 'minter_id',
  /** column name */
  OffchainExtraMinterDetails = 'offchain_extra_minter_details',
  /** column name */
  PriceIsConfigured = 'price_is_configured',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PropertiesUpdatedAt = 'properties_updated_at',
  /** column name */
  PurchaseToDisabled = 'purchase_to_disabled'
}

export type Project_Minter_Configurations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Minter_Configurations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Minter_Configurations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Minter_Configurations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Minter_Configurations_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Minter_Configurations_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Minter_Configurations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Minter_Configurations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Minter_Configurations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Minter_Configurations_Var_Pop_Fields = {
  __typename?: 'project_minter_configurations_var_pop_fields';
  max_invocations?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Project_Minter_Configurations_Var_Samp_Fields = {
  __typename?: 'project_minter_configurations_var_samp_fields';
  max_invocations?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Project_Minter_Configurations_Variance_Fields = {
  __typename?: 'project_minter_configurations_variance_fields';
  max_invocations?: Maybe<Scalars['Float']['output']>;
};

export type Project_Ranked_Bids_Args = {
  project?: InputMaybe<Scalars['String']['input']>;
};

/** This table holds the artist script files used for all projects (all scripts are primarily stored on-chain, and this table exists here for convenience purposes). Note that multiple scripts are combined when multiple indexes exist for a given projectID. This table is updated when an artist uploads, edits, or deletes a script in their project shell. */
export type Project_Scripts = {
  __typename?: 'project_scripts';
  index: Scalars['Int']['output'];
  /** An object relationship */
  project?: Maybe<Projects_Metadata>;
  project_id: Scalars['String']['output'];
  script: Scalars['String']['output'];
};

/** aggregated selection of "project_scripts" */
export type Project_Scripts_Aggregate = {
  __typename?: 'project_scripts_aggregate';
  aggregate?: Maybe<Project_Scripts_Aggregate_Fields>;
  nodes: Array<Project_Scripts>;
};

export type Project_Scripts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Scripts_Aggregate_Bool_Exp_Count>;
};

export type Project_Scripts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Scripts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Scripts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_scripts" */
export type Project_Scripts_Aggregate_Fields = {
  __typename?: 'project_scripts_aggregate_fields';
  avg?: Maybe<Project_Scripts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Scripts_Max_Fields>;
  min?: Maybe<Project_Scripts_Min_Fields>;
  stddev?: Maybe<Project_Scripts_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Scripts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Scripts_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Scripts_Sum_Fields>;
  var_pop?: Maybe<Project_Scripts_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Scripts_Var_Samp_Fields>;
  variance?: Maybe<Project_Scripts_Variance_Fields>;
};


/** aggregate fields of "project_scripts" */
export type Project_Scripts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Scripts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_scripts" */
export type Project_Scripts_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Scripts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Scripts_Max_Order_By>;
  min?: InputMaybe<Project_Scripts_Min_Order_By>;
  stddev?: InputMaybe<Project_Scripts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Scripts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Scripts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Scripts_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Scripts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Scripts_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Scripts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_scripts" */
export type Project_Scripts_Arr_Rel_Insert_Input = {
  data: Array<Project_Scripts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Scripts_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Scripts_Avg_Fields = {
  __typename?: 'project_scripts_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_scripts" */
export type Project_Scripts_Avg_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_scripts". All fields are combined with a logical 'AND'. */
export type Project_Scripts_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Scripts_Bool_Exp>>;
  _not?: InputMaybe<Project_Scripts_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Scripts_Bool_Exp>>;
  index?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  script?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_scripts" */
export enum Project_Scripts_Constraint {
  /** unique or primary key constraint on columns "index", "project_id" */
  ProjectScriptsPkey = 'project_scripts_pkey'
}

/** input type for incrementing numeric columns in table "project_scripts" */
export type Project_Scripts_Inc_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_scripts" */
export type Project_Scripts_Insert_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_Scripts_Max_Fields = {
  __typename?: 'project_scripts_max_fields';
  index?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "project_scripts" */
export type Project_Scripts_Max_Order_By = {
  index?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Scripts_Min_Fields = {
  __typename?: 'project_scripts_min_fields';
  index?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "project_scripts" */
export type Project_Scripts_Min_Order_By = {
  index?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_scripts" */
export type Project_Scripts_Mutation_Response = {
  __typename?: 'project_scripts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Scripts>;
};

/** on_conflict condition type for table "project_scripts" */
export type Project_Scripts_On_Conflict = {
  constraint: Project_Scripts_Constraint;
  update_columns?: Array<Project_Scripts_Update_Column>;
  where?: InputMaybe<Project_Scripts_Bool_Exp>;
};

/** Ordering options when selecting data from "project_scripts". */
export type Project_Scripts_Order_By = {
  index?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_scripts */
export type Project_Scripts_Pk_Columns_Input = {
  index: Scalars['Int']['input'];
  project_id: Scalars['String']['input'];
};

/** select columns of table "project_scripts" */
export enum Project_Scripts_Select_Column {
  /** column name */
  Index = 'index',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Script = 'script'
}

/** input type for updating data in table "project_scripts" */
export type Project_Scripts_Set_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Project_Scripts_Stddev_Fields = {
  __typename?: 'project_scripts_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_scripts" */
export type Project_Scripts_Stddev_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Scripts_Stddev_Pop_Fields = {
  __typename?: 'project_scripts_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_scripts" */
export type Project_Scripts_Stddev_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Scripts_Stddev_Samp_Fields = {
  __typename?: 'project_scripts_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_scripts" */
export type Project_Scripts_Stddev_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_scripts" */
export type Project_Scripts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Scripts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Scripts_Stream_Cursor_Value_Input = {
  index?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Project_Scripts_Sum_Fields = {
  __typename?: 'project_scripts_sum_fields';
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "project_scripts" */
export type Project_Scripts_Sum_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** update columns of table "project_scripts" */
export enum Project_Scripts_Update_Column {
  /** column name */
  Index = 'index',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Script = 'script'
}

export type Project_Scripts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Scripts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Scripts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Scripts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Scripts_Var_Pop_Fields = {
  __typename?: 'project_scripts_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_scripts" */
export type Project_Scripts_Var_Pop_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Scripts_Var_Samp_Fields = {
  __typename?: 'project_scripts_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_scripts" */
export type Project_Scripts_Var_Samp_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Scripts_Variance_Fields = {
  __typename?: 'project_scripts_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_scripts" */
export type Project_Scripts_Variance_Order_By = {
  index?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_series" */
export type Project_Series = {
  __typename?: 'project_series';
  id: Scalars['Int']['output'];
  /** An array relationship */
  projects: Array<Projects_Metadata>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Metadata_Aggregate;
};


/** columns and relationships of "project_series" */
export type Project_SeriesProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


/** columns and relationships of "project_series" */
export type Project_SeriesProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};

/** aggregated selection of "project_series" */
export type Project_Series_Aggregate = {
  __typename?: 'project_series_aggregate';
  aggregate?: Maybe<Project_Series_Aggregate_Fields>;
  nodes: Array<Project_Series>;
};

/** aggregate fields of "project_series" */
export type Project_Series_Aggregate_Fields = {
  __typename?: 'project_series_aggregate_fields';
  avg?: Maybe<Project_Series_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Series_Max_Fields>;
  min?: Maybe<Project_Series_Min_Fields>;
  stddev?: Maybe<Project_Series_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Series_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Series_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Series_Sum_Fields>;
  var_pop?: Maybe<Project_Series_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Series_Var_Samp_Fields>;
  variance?: Maybe<Project_Series_Variance_Fields>;
};


/** aggregate fields of "project_series" */
export type Project_Series_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Series_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Project_Series_Avg_Fields = {
  __typename?: 'project_series_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_series". All fields are combined with a logical 'AND'. */
export type Project_Series_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Series_Bool_Exp>>;
  _not?: InputMaybe<Project_Series_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Series_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  projects?: InputMaybe<Projects_Metadata_Bool_Exp>;
  projects_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "project_series" */
export enum Project_Series_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectSeriesPkey = 'project_series_pkey'
}

/** input type for incrementing numeric columns in table "project_series" */
export type Project_Series_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_series" */
export type Project_Series_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  projects?: InputMaybe<Projects_Metadata_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Series_Max_Fields = {
  __typename?: 'project_series_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Project_Series_Min_Fields = {
  __typename?: 'project_series_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "project_series" */
export type Project_Series_Mutation_Response = {
  __typename?: 'project_series_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Series>;
};

/** input type for inserting object relation for remote table "project_series" */
export type Project_Series_Obj_Rel_Insert_Input = {
  data: Project_Series_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Series_On_Conflict>;
};

/** on_conflict condition type for table "project_series" */
export type Project_Series_On_Conflict = {
  constraint: Project_Series_Constraint;
  update_columns?: Array<Project_Series_Update_Column>;
  where?: InputMaybe<Project_Series_Bool_Exp>;
};

/** Ordering options when selecting data from "project_series". */
export type Project_Series_Order_By = {
  id?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Order_By>;
};

/** primary key columns input for table: project_series */
export type Project_Series_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "project_series" */
export enum Project_Series_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "project_series" */
export type Project_Series_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Project_Series_Stddev_Fields = {
  __typename?: 'project_series_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Project_Series_Stddev_Pop_Fields = {
  __typename?: 'project_series_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Project_Series_Stddev_Samp_Fields = {
  __typename?: 'project_series_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "project_series" */
export type Project_Series_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Series_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Series_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Project_Series_Sum_Fields = {
  __typename?: 'project_series_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "project_series" */
export enum Project_Series_Update_Column {
  /** column name */
  Id = 'id'
}

export type Project_Series_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Series_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Series_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Series_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Series_Var_Pop_Fields = {
  __typename?: 'project_series_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Project_Series_Var_Samp_Fields = {
  __typename?: 'project_series_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Project_Series_Variance_Fields = {
  __typename?: 'project_series_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "project_vertical_categories" */
export type Project_Vertical_Categories = {
  __typename?: 'project_vertical_categories';
  /** An object relationship */
  category: Categories;
  hosted: Scalars['Boolean']['output'];
  is_artblocks?: Maybe<Scalars['Boolean']['output']>;
  name: Categories_Enum;
  /** An array relationship */
  verticals: Array<Project_Verticals>;
  /** An aggregate relationship */
  verticals_aggregate: Project_Verticals_Aggregate;
};


/** columns and relationships of "project_vertical_categories" */
export type Project_Vertical_CategoriesVerticalsArgs = {
  distinct_on?: InputMaybe<Array<Project_Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Verticals_Order_By>>;
  where?: InputMaybe<Project_Verticals_Bool_Exp>;
};


/** columns and relationships of "project_vertical_categories" */
export type Project_Vertical_CategoriesVerticals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Verticals_Order_By>>;
  where?: InputMaybe<Project_Verticals_Bool_Exp>;
};

/** aggregated selection of "project_vertical_categories" */
export type Project_Vertical_Categories_Aggregate = {
  __typename?: 'project_vertical_categories_aggregate';
  aggregate?: Maybe<Project_Vertical_Categories_Aggregate_Fields>;
  nodes: Array<Project_Vertical_Categories>;
};

/** aggregate fields of "project_vertical_categories" */
export type Project_Vertical_Categories_Aggregate_Fields = {
  __typename?: 'project_vertical_categories_aggregate_fields';
  count: Scalars['Int']['output'];
};


/** aggregate fields of "project_vertical_categories" */
export type Project_Vertical_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Vertical_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_vertical_categories". All fields are combined with a logical 'AND'. */
export type Project_Vertical_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Vertical_Categories_Bool_Exp>>;
  _not?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Vertical_Categories_Bool_Exp>>;
  category?: InputMaybe<Categories_Bool_Exp>;
  hosted?: InputMaybe<Boolean_Comparison_Exp>;
  is_artblocks?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<Categories_Enum_Comparison_Exp>;
  verticals?: InputMaybe<Project_Verticals_Bool_Exp>;
  verticals_aggregate?: InputMaybe<Project_Verticals_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "project_vertical_categories" */
export enum Project_Vertical_Categories_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProjectVerticalCategoriesPkey = 'project_vertical_categories_pkey'
}

/** input type for inserting data into table "project_vertical_categories" */
export type Project_Vertical_Categories_Insert_Input = {
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  hosted?: InputMaybe<Scalars['Boolean']['input']>;
  is_artblocks?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Categories_Enum>;
  verticals?: InputMaybe<Project_Verticals_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "project_vertical_categories" */
export type Project_Vertical_Categories_Mutation_Response = {
  __typename?: 'project_vertical_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Vertical_Categories>;
};

/** input type for inserting object relation for remote table "project_vertical_categories" */
export type Project_Vertical_Categories_Obj_Rel_Insert_Input = {
  data: Project_Vertical_Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Vertical_Categories_On_Conflict>;
};

/** on_conflict condition type for table "project_vertical_categories" */
export type Project_Vertical_Categories_On_Conflict = {
  constraint: Project_Vertical_Categories_Constraint;
  update_columns?: Array<Project_Vertical_Categories_Update_Column>;
  where?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "project_vertical_categories". */
export type Project_Vertical_Categories_Order_By = {
  category?: InputMaybe<Categories_Order_By>;
  hosted?: InputMaybe<Order_By>;
  is_artblocks?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  verticals_aggregate?: InputMaybe<Project_Verticals_Aggregate_Order_By>;
};

/** primary key columns input for table: project_vertical_categories */
export type Project_Vertical_Categories_Pk_Columns_Input = {
  name: Categories_Enum;
};

/** select columns of table "project_vertical_categories" */
export enum Project_Vertical_Categories_Select_Column {
  /** column name */
  Hosted = 'hosted',
  /** column name */
  IsArtblocks = 'is_artblocks',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "project_vertical_categories" */
export type Project_Vertical_Categories_Set_Input = {
  hosted?: InputMaybe<Scalars['Boolean']['input']>;
  is_artblocks?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Categories_Enum>;
};

/** Streaming cursor of the table "project_vertical_categories" */
export type Project_Vertical_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Vertical_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Vertical_Categories_Stream_Cursor_Value_Input = {
  hosted?: InputMaybe<Scalars['Boolean']['input']>;
  is_artblocks?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Categories_Enum>;
};

/** update columns of table "project_vertical_categories" */
export enum Project_Vertical_Categories_Update_Column {
  /** column name */
  Hosted = 'hosted',
  /** column name */
  IsArtblocks = 'is_artblocks',
  /** column name */
  Name = 'name'
}

export type Project_Vertical_Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Vertical_Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Vertical_Categories_Bool_Exp;
};

/** columns and relationships of "project_verticals" */
export type Project_Verticals = {
  __typename?: 'project_verticals';
  active: Scalars['Boolean']['output'];
  /** An object relationship */
  category: Project_Vertical_Categories;
  category_name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  name: Verticals_Enum;
  /** An array relationship */
  projects: Array<Projects_Metadata>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Metadata_Aggregate;
  /** An object relationship */
  vertical: Verticals;
};


/** columns and relationships of "project_verticals" */
export type Project_VerticalsProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


/** columns and relationships of "project_verticals" */
export type Project_VerticalsProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};

/** aggregated selection of "project_verticals" */
export type Project_Verticals_Aggregate = {
  __typename?: 'project_verticals_aggregate';
  aggregate?: Maybe<Project_Verticals_Aggregate_Fields>;
  nodes: Array<Project_Verticals>;
};

export type Project_Verticals_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Verticals_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Verticals_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Verticals_Aggregate_Bool_Exp_Count>;
};

export type Project_Verticals_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Verticals_Select_Column_Project_Verticals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Verticals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Verticals_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Verticals_Select_Column_Project_Verticals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Verticals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Verticals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Verticals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Verticals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_verticals" */
export type Project_Verticals_Aggregate_Fields = {
  __typename?: 'project_verticals_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Verticals_Max_Fields>;
  min?: Maybe<Project_Verticals_Min_Fields>;
};


/** aggregate fields of "project_verticals" */
export type Project_Verticals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Verticals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_verticals" */
export type Project_Verticals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Verticals_Max_Order_By>;
  min?: InputMaybe<Project_Verticals_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_verticals" */
export type Project_Verticals_Arr_Rel_Insert_Input = {
  data: Array<Project_Verticals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Verticals_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_verticals". All fields are combined with a logical 'AND'. */
export type Project_Verticals_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Verticals_Bool_Exp>>;
  _not?: InputMaybe<Project_Verticals_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Verticals_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  category?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
  category_name?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<Verticals_Enum_Comparison_Exp>;
  projects?: InputMaybe<Projects_Metadata_Bool_Exp>;
  projects_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Bool_Exp>;
  vertical?: InputMaybe<Verticals_Bool_Exp>;
};

/** unique or primary key constraints on table "project_verticals" */
export enum Project_Verticals_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProjectVerticalsPkey = 'project_verticals_pkey'
}

/** input type for inserting data into table "project_verticals" */
export type Project_Verticals_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Project_Vertical_Categories_Obj_Rel_Insert_Input>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Verticals_Enum>;
  projects?: InputMaybe<Projects_Metadata_Arr_Rel_Insert_Input>;
  vertical?: InputMaybe<Verticals_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Verticals_Max_Fields = {
  __typename?: 'project_verticals_max_fields';
  category_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "project_verticals" */
export type Project_Verticals_Max_Order_By = {
  category_name?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Verticals_Min_Fields = {
  __typename?: 'project_verticals_min_fields';
  category_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "project_verticals" */
export type Project_Verticals_Min_Order_By = {
  category_name?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_verticals" */
export type Project_Verticals_Mutation_Response = {
  __typename?: 'project_verticals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Verticals>;
};

/** input type for inserting object relation for remote table "project_verticals" */
export type Project_Verticals_Obj_Rel_Insert_Input = {
  data: Project_Verticals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Verticals_On_Conflict>;
};

/** on_conflict condition type for table "project_verticals" */
export type Project_Verticals_On_Conflict = {
  constraint: Project_Verticals_Constraint;
  update_columns?: Array<Project_Verticals_Update_Column>;
  where?: InputMaybe<Project_Verticals_Bool_Exp>;
};

/** Ordering options when selecting data from "project_verticals". */
export type Project_Verticals_Order_By = {
  active?: InputMaybe<Order_By>;
  category?: InputMaybe<Project_Vertical_Categories_Order_By>;
  category_name?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Order_By>;
  vertical?: InputMaybe<Verticals_Order_By>;
};

/** primary key columns input for table: project_verticals */
export type Project_Verticals_Pk_Columns_Input = {
  name: Verticals_Enum;
};

/** select columns of table "project_verticals" */
export enum Project_Verticals_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

/** select "project_verticals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_verticals" */
export enum Project_Verticals_Select_Column_Project_Verticals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "project_verticals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_verticals" */
export enum Project_Verticals_Select_Column_Project_Verticals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "project_verticals" */
export type Project_Verticals_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Verticals_Enum>;
};

/** Streaming cursor of the table "project_verticals" */
export type Project_Verticals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Verticals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Verticals_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Verticals_Enum>;
};

/** update columns of table "project_verticals" */
export enum Project_Verticals_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name'
}

export type Project_Verticals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Verticals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Verticals_Bool_Exp;
};

/** Artists may choose to name arbitrary traits & patterns (“features”) within the outputs of their project. These features are listed here and calculated via the features_script. This table is updated when an artist uploads, edits, or deletes a feature in their project shell. */
export type Projects_Features = {
  __typename?: 'projects_features';
  enable_artist_update_after_completion: Scalars['Boolean']['output'];
  feature_fields?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "projects_features_feature_fields_counts" */
  feature_fields_counts?: Maybe<Scalars['jsonb']['output']>;
  features_generating: Scalars['Boolean']['output'];
  features_script?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  project: Projects_Metadata;
  project_id: Scalars['String']['output'];
};


/** Artists may choose to name arbitrary traits & patterns (“features”) within the outputs of their project. These features are listed here and calculated via the features_script. This table is updated when an artist uploads, edits, or deletes a feature in their project shell. */
export type Projects_FeaturesFeature_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Artists may choose to name arbitrary traits & patterns (“features”) within the outputs of their project. These features are listed here and calculated via the features_script. This table is updated when an artist uploads, edits, or deletes a feature in their project shell. */
export type Projects_FeaturesFeature_Fields_CountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "projects_features" */
export type Projects_Features_Aggregate = {
  __typename?: 'projects_features_aggregate';
  aggregate?: Maybe<Projects_Features_Aggregate_Fields>;
  nodes: Array<Projects_Features>;
};

/** aggregate fields of "projects_features" */
export type Projects_Features_Aggregate_Fields = {
  __typename?: 'projects_features_aggregate_fields';
  avg?: Maybe<Projects_Features_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Projects_Features_Max_Fields>;
  min?: Maybe<Projects_Features_Min_Fields>;
  stddev?: Maybe<Projects_Features_Stddev_Fields>;
  stddev_pop?: Maybe<Projects_Features_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projects_Features_Stddev_Samp_Fields>;
  sum?: Maybe<Projects_Features_Sum_Fields>;
  var_pop?: Maybe<Projects_Features_Var_Pop_Fields>;
  var_samp?: Maybe<Projects_Features_Var_Samp_Fields>;
  variance?: Maybe<Projects_Features_Variance_Fields>;
};


/** aggregate fields of "projects_features" */
export type Projects_Features_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Projects_Features_Append_Input = {
  feature_fields?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Projects_Features_Avg_Fields = {
  __typename?: 'projects_features_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "projects_features". All fields are combined with a logical 'AND'. */
export type Projects_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Features_Bool_Exp>>;
  _not?: InputMaybe<Projects_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Features_Bool_Exp>>;
  enable_artist_update_after_completion?: InputMaybe<Boolean_Comparison_Exp>;
  feature_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  feature_fields_counts?: InputMaybe<Jsonb_Comparison_Exp>;
  features_generating?: InputMaybe<Boolean_Comparison_Exp>;
  features_script?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "projects_features" */
export enum Projects_Features_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectsFeaturesPkey = 'projects_features_pkey',
  /** unique or primary key constraint on columns "project_id" */
  ProjectsFeaturesProjectIdKey = 'projects_features_project_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Projects_Features_Delete_At_Path_Input = {
  feature_fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Projects_Features_Delete_Elem_Input = {
  feature_fields?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Projects_Features_Delete_Key_Input = {
  feature_fields?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "projects_features" */
export type Projects_Features_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "projects_features" */
export type Projects_Features_Insert_Input = {
  enable_artist_update_after_completion?: InputMaybe<Scalars['Boolean']['input']>;
  feature_fields?: InputMaybe<Scalars['jsonb']['input']>;
  features_generating?: InputMaybe<Scalars['Boolean']['input']>;
  features_script?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Projects_Features_Max_Fields = {
  __typename?: 'projects_features_max_fields';
  features_script?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Projects_Features_Min_Fields = {
  __typename?: 'projects_features_min_fields';
  features_script?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "projects_features" */
export type Projects_Features_Mutation_Response = {
  __typename?: 'projects_features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects_Features>;
};

/** input type for inserting object relation for remote table "projects_features" */
export type Projects_Features_Obj_Rel_Insert_Input = {
  data: Projects_Features_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_Features_On_Conflict>;
};

/** on_conflict condition type for table "projects_features" */
export type Projects_Features_On_Conflict = {
  constraint: Projects_Features_Constraint;
  update_columns?: Array<Projects_Features_Update_Column>;
  where?: InputMaybe<Projects_Features_Bool_Exp>;
};

/** Ordering options when selecting data from "projects_features". */
export type Projects_Features_Order_By = {
  enable_artist_update_after_completion?: InputMaybe<Order_By>;
  feature_fields?: InputMaybe<Order_By>;
  feature_fields_counts?: InputMaybe<Order_By>;
  features_generating?: InputMaybe<Order_By>;
  features_script?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: projects_features */
export type Projects_Features_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Projects_Features_Prepend_Input = {
  feature_fields?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "projects_features" */
export enum Projects_Features_Select_Column {
  /** column name */
  EnableArtistUpdateAfterCompletion = 'enable_artist_update_after_completion',
  /** column name */
  FeatureFields = 'feature_fields',
  /** column name */
  FeaturesGenerating = 'features_generating',
  /** column name */
  FeaturesScript = 'features_script',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id'
}

/** input type for updating data in table "projects_features" */
export type Projects_Features_Set_Input = {
  enable_artist_update_after_completion?: InputMaybe<Scalars['Boolean']['input']>;
  feature_fields?: InputMaybe<Scalars['jsonb']['input']>;
  features_generating?: InputMaybe<Scalars['Boolean']['input']>;
  features_script?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Projects_Features_Stddev_Fields = {
  __typename?: 'projects_features_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Projects_Features_Stddev_Pop_Fields = {
  __typename?: 'projects_features_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Projects_Features_Stddev_Samp_Fields = {
  __typename?: 'projects_features_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projects_features" */
export type Projects_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_Features_Stream_Cursor_Value_Input = {
  enable_artist_update_after_completion?: InputMaybe<Scalars['Boolean']['input']>;
  feature_fields?: InputMaybe<Scalars['jsonb']['input']>;
  features_generating?: InputMaybe<Scalars['Boolean']['input']>;
  features_script?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Projects_Features_Sum_Fields = {
  __typename?: 'projects_features_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "projects_features" */
export enum Projects_Features_Update_Column {
  /** column name */
  EnableArtistUpdateAfterCompletion = 'enable_artist_update_after_completion',
  /** column name */
  FeatureFields = 'feature_fields',
  /** column name */
  FeaturesGenerating = 'features_generating',
  /** column name */
  FeaturesScript = 'features_script',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id'
}

export type Projects_Features_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Projects_Features_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Projects_Features_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Projects_Features_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Projects_Features_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Projects_Features_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Projects_Features_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Projects_Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: Projects_Features_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Projects_Features_Var_Pop_Fields = {
  __typename?: 'projects_features_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Projects_Features_Var_Samp_Fields = {
  __typename?: 'projects_features_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Projects_Features_Variance_Fields = {
  __typename?: 'projects_features_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** This table holds entries for every project and information on all project-related settings. */
export type Projects_Metadata = {
  __typename?: 'projects_metadata';
  activated_at?: Maybe<Scalars['timestamptz']['output']>;
  active: Scalars['Boolean']['output'];
  additionalExhibition?: Maybe<ExhibitionEntityResponseCollection>;
  additional_payee?: Maybe<Scalars['String']['output']>;
  additional_payee_percentage?: Maybe<Scalars['Int']['output']>;
  additional_payee_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  additional_payee_splitter?: Maybe<Split_Atomic_Contracts>;
  article?: Maybe<ArticleEntityResponseCollection>;
  /** An object relationship */
  artist: Users;
  artistPage?: Maybe<ArtistEditorialPageEntityResponseCollection>;
  artist_address: Scalars['String']['output'];
  artist_display_notes?: Maybe<Scalars['String']['output']>;
  artist_featured_token_id?: Maybe<Scalars['String']['output']>;
  artist_interview?: Maybe<Scalars['String']['output']>;
  artist_name?: Maybe<Scalars['String']['output']>;
  aspect_ratio: Scalars['numeric']['output'];
  /** A computed field, executes function "project_auction_end_time" */
  auction_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "project_auction_start_time" */
  auction_start_time?: Maybe<Scalars['timestamptz']['output']>;
  base_uri?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  bids: Array<Bids_Metadata>;
  /** An aggregate relationship */
  bids_aggregate: Bids_Metadata_Aggregate;
  canvas_mode?: Maybe<Scalars['Boolean']['output']>;
  charitable_giving_details?: Maybe<Scalars['String']['output']>;
  complete: Scalars['Boolean']['output'];
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  contract: Contracts_Metadata;
  contract_address: Scalars['String']['output'];
  creative_credit?: Maybe<Scalars['String']['output']>;
  curation_status: Curation_Statuses_Enum;
  /** A computed field, executes function "curation_status_display" */
  curation_status_display?: Maybe<Scalars['String']['output']>;
  curation_status_override?: Maybe<Curation_Statuses_Enum>;
  currency_address?: Maybe<Scalars['String']['output']>;
  currency_decimals?: Maybe<Scalars['Int']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  dependency?: Maybe<Dependencies_Metadata>;
  /** Returns 'script_type_and_version_override' for the project if available; otherwise, falls back to 'script_type_and_version' */
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disable_auto_image_format?: Maybe<Scalars['Boolean']['output']>;
  disable_sample_generator: Scalars['Boolean']['output'];
  display_static: Scalars['Boolean']['output'];
  engine_platform_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  erc2981_splitter_address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  erc2981_splitter_contract?: Maybe<Royalty_Splitter_Contracts>;
  exhibition?: Maybe<ExhibitionEntityResponseCollection>;
  /** An array relationship */
  external_asset_dependencies: Array<Project_External_Asset_Dependencies>;
  /** An aggregate relationship */
  external_asset_dependencies_aggregate: Project_External_Asset_Dependencies_Aggregate;
  external_asset_dependencies_locked?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_favorited_by_user" */
  favorited_by_user?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  favorites: Array<Favorites>;
  /** An aggregate relationship */
  favorites_aggregate: Favorites_Aggregate;
  /** A computed field, executes function "project_featured_token" */
  featured_token?: Maybe<Array<Tokens_Metadata>>;
  /** An object relationship */
  features?: Maybe<Projects_Features>;
  /** A computed field, executes function "first_token_minted_at" */
  first_token_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  generate_video_assets: Scalars['Boolean']['output'];
  /** A computed field, executes function "project_heritage_status" */
  heritage_curation_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  ipfs_hash?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_is_flagship" */
  is_artblocks?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  link_to_license?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "calc_locked" */
  locked?: Maybe<Scalars['Boolean']['output']>;
  locked_pre_v3?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations: Scalars['Int']['output'];
  /** An object relationship */
  minter_configuration?: Maybe<Project_Minter_Configurations>;
  minter_configuration_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offchain_script?: Maybe<Scalars['String']['output']>;
  /** Number of OOB tokens to generate */
  oob_count: Scalars['Int']['output'];
  /** An array relationship */
  oob_tokens: Array<Oob_Tokens_Metadata>;
  /** An aggregate relationship */
  oob_tokens_aggregate: Oob_Tokens_Metadata_Aggregate;
  open_for_review: Scalars['Boolean']['output'];
  paused: Scalars['Boolean']['output'];
  /** An array relationship */
  pmp_project_configs: Array<Pmp_Project_Configs>;
  /** An aggregate relationship */
  pmp_project_configs_aggregate: Pmp_Project_Configs_Aggregate;
  preview_render_type: Render_Types_Enum;
  price_per_token_in_wei?: Maybe<Scalars['String']['output']>;
  primary_render_type: Render_Types_Enum;
  project?: Maybe<Project>;
  project_id: Scalars['String']['output'];
  properties_updated_at: Scalars['jsonb']['output'];
  /** An object relationship */
  proposed_artist_addresses_and_split?: Maybe<Proposed_Artist_Addresses_And_Splits>;
  proposed_artists_and_splits_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_random_oob_token" */
  random_oob_token?: Maybe<Array<Oob_Tokens_Metadata>>;
  /** A computed field, executes function "project_random_token" */
  random_token?: Maybe<Array<Tokens_Metadata>>;
  read_only_addresses?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  receipts: Array<Receipt_Metadata>;
  /** An aggregate relationship */
  receipts_aggregate: Receipt_Metadata_Aggregate;
  /** An array relationship */
  refresh_requests: Array<Refresh_Requests>;
  /** An aggregate relationship */
  refresh_requests_aggregate: Refresh_Requests_Aggregate;
  /** A computed field, executes function "project_render_complete" */
  render_complete?: Maybe<Scalars['Boolean']['output']>;
  render_delay?: Maybe<Scalars['Int']['output']>;
  render_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  render_with_gpu?: Maybe<Scalars['Boolean']['output']>;
  royalty_percentage?: Maybe<Scalars['Int']['output']>;
  sales_notes?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  script_json?: Maybe<Scalars['jsonb']['output']>;
  /** Indicates the script type and version (e.g., p5@1.0.0) assigned to the project on its core contract */
  script_type_and_version?: Maybe<Scalars['String']['output']>;
  /** Specifies the script type and version override for the project, as set on the Art Blocks dependency registry contract */
  script_type_and_version_override?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  scripts: Array<Project_Scripts>;
  /** An aggregate relationship */
  scripts_aggregate: Project_Scripts_Aggregate;
  /** A computed field, executes function "second_token_minted_at" */
  second_token_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  series?: Maybe<Project_Series>;
  series_id?: Maybe<Scalars['Int']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Int']['output']>;
  slippy_map_tiles_generated: Scalars['Boolean']['output'];
  /** Returns the URL for accessing this project's slippy map tiles (compatible with OpenSeadragon viewer) if they have been generated, otherwise returns null. */
  slippy_map_tiles_url?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  tags: Array<Entity_Tags>;
  /** An aggregate relationship */
  tags_aggregate: Entity_Tags_Aggregate;
  testnet_project_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tokens: Array<Tokens_Metadata>;
  /** An aggregate relationship */
  tokens_aggregate: Tokens_Metadata_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** A computed field, executes function "user_is_artist" */
  user_is_artist?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  vertical: Project_Verticals;
  vertical_name: Scalars['String']['output'];
  video_aspect_ratio?: Maybe<Scalars['numeric']['output']>;
  video_duration?: Maybe<Scalars['Int']['output']>;
  video_fps?: Maybe<Scalars['Int']['output']>;
  video_render_delay?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataAdditionalExhibitionArgs = {
  filters?: InputMaybe<ExhibitionFiltersInput_Remote_Rel_Projects_MetadataadditionalExhibition>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataArticleArgs = {
  filters?: InputMaybe<ArticleFiltersInput_Remote_Rel_Projects_Metadataarticle>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataArtistPageArgs = {
  filters?: InputMaybe<ArtistEditorialPageFiltersInput_Remote_Rel_Projects_MetadataartistPage>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataExhibitionArgs = {
  filters?: InputMaybe<ExhibitionFiltersInput_Remote_Rel_Projects_Metadataexhibition>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataExternal_Asset_DependenciesArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependencies_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataExternal_Asset_Dependencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependencies_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataFavoritesArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataFavorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataFeatured_TokenArgs = {
  args?: InputMaybe<Featured_Token_Projects_Metadata_Args>;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataOob_TokensArgs = {
  distinct_on?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oob_Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataOob_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oob_Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataPmp_Project_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Project_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Project_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataPmp_Project_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Project_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Project_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataProjectArgs = {
  block?: InputMaybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataProperties_Updated_AtArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataRandom_Oob_TokenArgs = {
  args?: InputMaybe<Random_Oob_Token_Projects_Metadata_Args>;
  distinct_on?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oob_Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataRandom_TokenArgs = {
  args?: InputMaybe<Random_Token_Projects_Metadata_Args>;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataRead_Only_AddressesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataReceipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataRefresh_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Requests_Order_By>>;
  where?: InputMaybe<Refresh_Requests_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataRefresh_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Requests_Order_By>>;
  where?: InputMaybe<Refresh_Requests_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataScript_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataScriptsArgs = {
  distinct_on?: InputMaybe<Array<Project_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Scripts_Order_By>>;
  where?: InputMaybe<Project_Scripts_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataScripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Scripts_Order_By>>;
  where?: InputMaybe<Project_Scripts_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataTagsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataTokensArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


/** This table holds entries for every project and information on all project-related settings. */
export type Projects_MetadataTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};

/** aggregated selection of "projects_metadata" */
export type Projects_Metadata_Aggregate = {
  __typename?: 'projects_metadata_aggregate';
  aggregate?: Maybe<Projects_Metadata_Aggregate_Fields>;
  nodes: Array<Projects_Metadata>;
};

export type Projects_Metadata_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Projects_Metadata_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Projects_Metadata_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Projects_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Projects_Metadata_Aggregate_Bool_Exp_Bool_And = {
  arguments: Projects_Metadata_Select_Column_Projects_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Projects_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Projects_Metadata_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Projects_Metadata_Select_Column_Projects_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Projects_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Projects_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Projects_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "projects_metadata" */
export type Projects_Metadata_Aggregate_Fields = {
  __typename?: 'projects_metadata_aggregate_fields';
  avg?: Maybe<Projects_Metadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Projects_Metadata_Max_Fields>;
  min?: Maybe<Projects_Metadata_Min_Fields>;
  stddev?: Maybe<Projects_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Projects_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projects_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Projects_Metadata_Sum_Fields>;
  var_pop?: Maybe<Projects_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Projects_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Projects_Metadata_Variance_Fields>;
};


/** aggregate fields of "projects_metadata" */
export type Projects_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "projects_metadata" */
export type Projects_Metadata_Aggregate_Order_By = {
  avg?: InputMaybe<Projects_Metadata_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projects_Metadata_Max_Order_By>;
  min?: InputMaybe<Projects_Metadata_Min_Order_By>;
  stddev?: InputMaybe<Projects_Metadata_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Projects_Metadata_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Projects_Metadata_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Projects_Metadata_Sum_Order_By>;
  var_pop?: InputMaybe<Projects_Metadata_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Projects_Metadata_Var_Samp_Order_By>;
  variance?: InputMaybe<Projects_Metadata_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Projects_Metadata_Append_Input = {
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  read_only_addresses?: InputMaybe<Scalars['jsonb']['input']>;
  script_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "projects_metadata" */
export type Projects_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Projects_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_Metadata_On_Conflict>;
};

/** aggregate avg on columns */
export type Projects_Metadata_Avg_Fields = {
  __typename?: 'projects_metadata_avg_fields';
  additional_payee_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  currency_decimals?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Float']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Float']['output']>;
  render_delay?: Maybe<Scalars['Float']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  royalty_percentage?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  series_id?: Maybe<Scalars['Float']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Float']['output']>;
  video_aspect_ratio?: Maybe<Scalars['Float']['output']>;
  video_duration?: Maybe<Scalars['Float']['output']>;
  video_fps?: Maybe<Scalars['Float']['output']>;
  video_render_delay?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "projects_metadata" */
export type Projects_Metadata_Avg_Order_By = {
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "projects_metadata". All fields are combined with a logical 'AND'. */
export type Projects_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Projects_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Metadata_Bool_Exp>>;
  activated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  additional_payee?: InputMaybe<String_Comparison_Exp>;
  additional_payee_percentage?: InputMaybe<Int_Comparison_Exp>;
  additional_payee_secondary_sales_address?: InputMaybe<String_Comparison_Exp>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Int_Comparison_Exp>;
  additional_payee_splitter?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
  artist?: InputMaybe<Users_Bool_Exp>;
  artist_address?: InputMaybe<String_Comparison_Exp>;
  artist_display_notes?: InputMaybe<String_Comparison_Exp>;
  artist_featured_token_id?: InputMaybe<String_Comparison_Exp>;
  artist_interview?: InputMaybe<String_Comparison_Exp>;
  artist_name?: InputMaybe<String_Comparison_Exp>;
  aspect_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  auction_end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  auction_start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  base_uri?: InputMaybe<String_Comparison_Exp>;
  bids?: InputMaybe<Bids_Metadata_Bool_Exp>;
  bids_aggregate?: InputMaybe<Bids_Metadata_Aggregate_Bool_Exp>;
  canvas_mode?: InputMaybe<Boolean_Comparison_Exp>;
  charitable_giving_details?: InputMaybe<String_Comparison_Exp>;
  complete?: InputMaybe<Boolean_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  contract?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  creative_credit?: InputMaybe<String_Comparison_Exp>;
  curation_status?: InputMaybe<Curation_Statuses_Enum_Comparison_Exp>;
  curation_status_display?: InputMaybe<String_Comparison_Exp>;
  curation_status_override?: InputMaybe<Curation_Statuses_Enum_Comparison_Exp>;
  currency_address?: InputMaybe<String_Comparison_Exp>;
  currency_decimals?: InputMaybe<Int_Comparison_Exp>;
  currency_symbol?: InputMaybe<String_Comparison_Exp>;
  dependency?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
  dependency_name_and_version?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disable_auto_image_format?: InputMaybe<Boolean_Comparison_Exp>;
  disable_sample_generator?: InputMaybe<Boolean_Comparison_Exp>;
  display_static?: InputMaybe<Boolean_Comparison_Exp>;
  engine_platform_provider_secondary_sales_address?: InputMaybe<String_Comparison_Exp>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Int_Comparison_Exp>;
  erc2981_splitter_address?: InputMaybe<String_Comparison_Exp>;
  erc2981_splitter_contract?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
  external_asset_dependencies?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
  external_asset_dependencies_aggregate?: InputMaybe<Project_External_Asset_Dependencies_Aggregate_Bool_Exp>;
  external_asset_dependencies_locked?: InputMaybe<Boolean_Comparison_Exp>;
  external_asset_dependency_count?: InputMaybe<Bigint_Comparison_Exp>;
  favorited_by_user?: InputMaybe<Boolean_Comparison_Exp>;
  favorites?: InputMaybe<Favorites_Bool_Exp>;
  favorites_aggregate?: InputMaybe<Favorites_Aggregate_Bool_Exp>;
  features?: InputMaybe<Projects_Features_Bool_Exp>;
  first_token_minted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  generate_video_assets?: InputMaybe<Boolean_Comparison_Exp>;
  heritage_curation_status?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  invocations?: InputMaybe<Bigint_Comparison_Exp>;
  ipfs_hash?: InputMaybe<String_Comparison_Exp>;
  is_artblocks?: InputMaybe<Boolean_Comparison_Exp>;
  license?: InputMaybe<String_Comparison_Exp>;
  link_to_license?: InputMaybe<String_Comparison_Exp>;
  locked?: InputMaybe<Boolean_Comparison_Exp>;
  locked_pre_v3?: InputMaybe<Boolean_Comparison_Exp>;
  lowest_listing?: InputMaybe<Float8_Comparison_Exp>;
  max_invocations?: InputMaybe<Int_Comparison_Exp>;
  minter_configuration?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
  minter_configuration_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  offchain_script?: InputMaybe<String_Comparison_Exp>;
  oob_count?: InputMaybe<Int_Comparison_Exp>;
  oob_tokens?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
  oob_tokens_aggregate?: InputMaybe<Oob_Tokens_Metadata_Aggregate_Bool_Exp>;
  open_for_review?: InputMaybe<Boolean_Comparison_Exp>;
  paused?: InputMaybe<Boolean_Comparison_Exp>;
  pmp_project_configs?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
  pmp_project_configs_aggregate?: InputMaybe<Pmp_Project_Configs_Aggregate_Bool_Exp>;
  preview_render_type?: InputMaybe<Render_Types_Enum_Comparison_Exp>;
  price_per_token_in_wei?: InputMaybe<String_Comparison_Exp>;
  primary_render_type?: InputMaybe<Render_Types_Enum_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  properties_updated_at?: InputMaybe<Jsonb_Comparison_Exp>;
  proposed_artist_addresses_and_split?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Bool_Exp>;
  proposed_artists_and_splits_id?: InputMaybe<String_Comparison_Exp>;
  read_only_addresses?: InputMaybe<Jsonb_Comparison_Exp>;
  receipts?: InputMaybe<Receipt_Metadata_Bool_Exp>;
  receipts_aggregate?: InputMaybe<Receipt_Metadata_Aggregate_Bool_Exp>;
  refresh_requests?: InputMaybe<Refresh_Requests_Bool_Exp>;
  refresh_requests_aggregate?: InputMaybe<Refresh_Requests_Aggregate_Bool_Exp>;
  render_complete?: InputMaybe<Boolean_Comparison_Exp>;
  render_delay?: InputMaybe<Int_Comparison_Exp>;
  render_provider_secondary_sales_address?: InputMaybe<String_Comparison_Exp>;
  render_provider_secondary_sales_bps?: InputMaybe<Int_Comparison_Exp>;
  render_with_gpu?: InputMaybe<Boolean_Comparison_Exp>;
  royalty_percentage?: InputMaybe<Int_Comparison_Exp>;
  sales_notes?: InputMaybe<String_Comparison_Exp>;
  script?: InputMaybe<String_Comparison_Exp>;
  script_count?: InputMaybe<Bigint_Comparison_Exp>;
  script_json?: InputMaybe<Jsonb_Comparison_Exp>;
  script_type_and_version?: InputMaybe<String_Comparison_Exp>;
  script_type_and_version_override?: InputMaybe<String_Comparison_Exp>;
  scripts?: InputMaybe<Project_Scripts_Bool_Exp>;
  scripts_aggregate?: InputMaybe<Project_Scripts_Aggregate_Bool_Exp>;
  second_token_minted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  series?: InputMaybe<Project_Series_Bool_Exp>;
  series_id?: InputMaybe<Int_Comparison_Exp>;
  slippy_map_grid_column_count?: InputMaybe<Int_Comparison_Exp>;
  slippy_map_tiles_generated?: InputMaybe<Boolean_Comparison_Exp>;
  slippy_map_tiles_url?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  tags?: InputMaybe<Entity_Tags_Bool_Exp>;
  tags_aggregate?: InputMaybe<Entity_Tags_Aggregate_Bool_Exp>;
  testnet_project_id?: InputMaybe<String_Comparison_Exp>;
  tokens?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  tokens_aggregate?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_is_artist?: InputMaybe<Boolean_Comparison_Exp>;
  vertical?: InputMaybe<Project_Verticals_Bool_Exp>;
  vertical_name?: InputMaybe<String_Comparison_Exp>;
  video_aspect_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  video_duration?: InputMaybe<Int_Comparison_Exp>;
  video_fps?: InputMaybe<Int_Comparison_Exp>;
  video_render_delay?: InputMaybe<Int_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "projects_metadata" */
export enum Projects_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectsMetaPkey = 'projects_meta_pkey',
  /** unique or primary key constraint on columns "project_id", "contract_address" */
  ProjectsMetadataProjectIdContractAddressKey = 'projects_metadata_project_id_contract_address_key',
  /** unique or primary key constraint on columns "proposed_artists_and_splits_id" */
  ProjectsMetadataProposedArtistsAndSplitsIdKey = 'projects_metadata_proposed_artists_and_splits_id_key',
  /** unique or primary key constraint on columns "slug" */
  UniqueSlug = 'unique_slug'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Projects_Metadata_Delete_At_Path_Input = {
  properties_updated_at?: InputMaybe<Array<Scalars['String']['input']>>;
  read_only_addresses?: InputMaybe<Array<Scalars['String']['input']>>;
  script_json?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Projects_Metadata_Delete_Elem_Input = {
  properties_updated_at?: InputMaybe<Scalars['Int']['input']>;
  read_only_addresses?: InputMaybe<Scalars['Int']['input']>;
  script_json?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Projects_Metadata_Delete_Key_Input = {
  properties_updated_at?: InputMaybe<Scalars['String']['input']>;
  read_only_addresses?: InputMaybe<Scalars['String']['input']>;
  script_json?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "projects_metadata" */
export type Projects_Metadata_Inc_Input = {
  additional_payee_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  aspect_ratio?: InputMaybe<Scalars['numeric']['input']>;
  currency_decimals?: InputMaybe<Scalars['Int']['input']>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  max_invocations?: InputMaybe<Scalars['Int']['input']>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Scalars['Int']['input']>;
  render_delay?: InputMaybe<Scalars['Int']['input']>;
  render_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  royalty_percentage?: InputMaybe<Scalars['Int']['input']>;
  series_id?: InputMaybe<Scalars['Int']['input']>;
  slippy_map_grid_column_count?: InputMaybe<Scalars['Int']['input']>;
  video_aspect_ratio?: InputMaybe<Scalars['numeric']['input']>;
  video_duration?: InputMaybe<Scalars['Int']['input']>;
  video_fps?: InputMaybe<Scalars['Int']['input']>;
  video_render_delay?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "projects_metadata" */
export type Projects_Metadata_Insert_Input = {
  activated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additional_payee?: InputMaybe<Scalars['String']['input']>;
  additional_payee_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_splitter?: InputMaybe<Split_Atomic_Contracts_Obj_Rel_Insert_Input>;
  artist?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  artist_address?: InputMaybe<Scalars['String']['input']>;
  artist_display_notes?: InputMaybe<Scalars['String']['input']>;
  artist_featured_token_id?: InputMaybe<Scalars['String']['input']>;
  artist_interview?: InputMaybe<Scalars['String']['input']>;
  artist_name?: InputMaybe<Scalars['String']['input']>;
  aspect_ratio?: InputMaybe<Scalars['numeric']['input']>;
  base_uri?: InputMaybe<Scalars['String']['input']>;
  bids?: InputMaybe<Bids_Metadata_Arr_Rel_Insert_Input>;
  canvas_mode?: InputMaybe<Scalars['Boolean']['input']>;
  charitable_giving_details?: InputMaybe<Scalars['String']['input']>;
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contract?: InputMaybe<Contracts_Metadata_Obj_Rel_Insert_Input>;
  contract_address?: InputMaybe<Scalars['String']['input']>;
  creative_credit?: InputMaybe<Scalars['String']['input']>;
  curation_status?: InputMaybe<Curation_Statuses_Enum>;
  curation_status_override?: InputMaybe<Curation_Statuses_Enum>;
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_decimals?: InputMaybe<Scalars['Int']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  dependency?: InputMaybe<Dependencies_Metadata_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable_auto_image_format?: InputMaybe<Scalars['Boolean']['input']>;
  disable_sample_generator?: InputMaybe<Scalars['Boolean']['input']>;
  display_static?: InputMaybe<Scalars['Boolean']['input']>;
  engine_platform_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  erc2981_splitter_address?: InputMaybe<Scalars['String']['input']>;
  erc2981_splitter_contract?: InputMaybe<Royalty_Splitter_Contracts_Obj_Rel_Insert_Input>;
  external_asset_dependencies?: InputMaybe<Project_External_Asset_Dependencies_Arr_Rel_Insert_Input>;
  external_asset_dependencies_locked?: InputMaybe<Scalars['Boolean']['input']>;
  favorites?: InputMaybe<Favorites_Arr_Rel_Insert_Input>;
  features?: InputMaybe<Projects_Features_Obj_Rel_Insert_Input>;
  generate_video_assets?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  ipfs_hash?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  link_to_license?: InputMaybe<Scalars['String']['input']>;
  locked_pre_v3?: InputMaybe<Scalars['Boolean']['input']>;
  max_invocations?: InputMaybe<Scalars['Int']['input']>;
  minter_configuration?: InputMaybe<Project_Minter_Configurations_Obj_Rel_Insert_Input>;
  minter_configuration_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offchain_script?: InputMaybe<Scalars['String']['input']>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Scalars['Int']['input']>;
  oob_tokens?: InputMaybe<Oob_Tokens_Metadata_Arr_Rel_Insert_Input>;
  open_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  pmp_project_configs?: InputMaybe<Pmp_Project_Configs_Arr_Rel_Insert_Input>;
  preview_render_type?: InputMaybe<Render_Types_Enum>;
  price_per_token_in_wei?: InputMaybe<Scalars['String']['input']>;
  primary_render_type?: InputMaybe<Render_Types_Enum>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  proposed_artist_addresses_and_split?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Obj_Rel_Insert_Input>;
  proposed_artists_and_splits_id?: InputMaybe<Scalars['String']['input']>;
  read_only_addresses?: InputMaybe<Scalars['jsonb']['input']>;
  receipts?: InputMaybe<Receipt_Metadata_Arr_Rel_Insert_Input>;
  refresh_requests?: InputMaybe<Refresh_Requests_Arr_Rel_Insert_Input>;
  render_delay?: InputMaybe<Scalars['Int']['input']>;
  render_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  render_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  render_with_gpu?: InputMaybe<Scalars['Boolean']['input']>;
  royalty_percentage?: InputMaybe<Scalars['Int']['input']>;
  sales_notes?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  script_json?: InputMaybe<Scalars['jsonb']['input']>;
  /** Indicates the script type and version (e.g., p5@1.0.0) assigned to the project on its core contract */
  script_type_and_version?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the script type and version override for the project, as set on the Art Blocks dependency registry contract */
  script_type_and_version_override?: InputMaybe<Scalars['String']['input']>;
  scripts?: InputMaybe<Project_Scripts_Arr_Rel_Insert_Input>;
  series?: InputMaybe<Project_Series_Obj_Rel_Insert_Input>;
  series_id?: InputMaybe<Scalars['Int']['input']>;
  slippy_map_grid_column_count?: InputMaybe<Scalars['Int']['input']>;
  slippy_map_tiles_generated?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  tags?: InputMaybe<Entity_Tags_Arr_Rel_Insert_Input>;
  testnet_project_id?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Tokens_Metadata_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  vertical?: InputMaybe<Project_Verticals_Obj_Rel_Insert_Input>;
  vertical_name?: InputMaybe<Scalars['String']['input']>;
  video_aspect_ratio?: InputMaybe<Scalars['numeric']['input']>;
  video_duration?: InputMaybe<Scalars['Int']['input']>;
  video_fps?: InputMaybe<Scalars['Int']['input']>;
  video_render_delay?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Projects_Metadata_Max_Fields = {
  __typename?: 'projects_metadata_max_fields';
  activated_at?: Maybe<Scalars['timestamptz']['output']>;
  additional_payee?: Maybe<Scalars['String']['output']>;
  additional_payee_percentage?: Maybe<Scalars['Int']['output']>;
  additional_payee_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  artist_address?: Maybe<Scalars['String']['output']>;
  artist_display_notes?: Maybe<Scalars['String']['output']>;
  artist_featured_token_id?: Maybe<Scalars['String']['output']>;
  artist_interview?: Maybe<Scalars['String']['output']>;
  artist_name?: Maybe<Scalars['String']['output']>;
  aspect_ratio?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "project_auction_end_time" */
  auction_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "project_auction_start_time" */
  auction_start_time?: Maybe<Scalars['timestamptz']['output']>;
  base_uri?: Maybe<Scalars['String']['output']>;
  charitable_giving_details?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  contract_address?: Maybe<Scalars['String']['output']>;
  creative_credit?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "curation_status_display" */
  curation_status_display?: Maybe<Scalars['String']['output']>;
  currency_address?: Maybe<Scalars['String']['output']>;
  currency_decimals?: Maybe<Scalars['Int']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  /** Returns 'script_type_and_version_override' for the project if available; otherwise, falls back to 'script_type_and_version' */
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  erc2981_splitter_address?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "first_token_minted_at" */
  first_token_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "project_heritage_status" */
  heritage_curation_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  ipfs_hash?: Maybe<Scalars['String']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  link_to_license?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Int']['output']>;
  minter_configuration_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offchain_script?: Maybe<Scalars['String']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Int']['output']>;
  price_per_token_in_wei?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  proposed_artists_and_splits_id?: Maybe<Scalars['String']['output']>;
  render_delay?: Maybe<Scalars['Int']['output']>;
  render_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  royalty_percentage?: Maybe<Scalars['Int']['output']>;
  sales_notes?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  /** Indicates the script type and version (e.g., p5@1.0.0) assigned to the project on its core contract */
  script_type_and_version?: Maybe<Scalars['String']['output']>;
  /** Specifies the script type and version override for the project, as set on the Art Blocks dependency registry contract */
  script_type_and_version_override?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "second_token_minted_at" */
  second_token_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  series_id?: Maybe<Scalars['Int']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Int']['output']>;
  /** Returns the URL for accessing this project's slippy map tiles (compatible with OpenSeadragon viewer) if they have been generated, otherwise returns null. */
  slippy_map_tiles_url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  testnet_project_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  vertical_name?: Maybe<Scalars['String']['output']>;
  video_aspect_ratio?: Maybe<Scalars['numeric']['output']>;
  video_duration?: Maybe<Scalars['Int']['output']>;
  video_fps?: Maybe<Scalars['Int']['output']>;
  video_render_delay?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "projects_metadata" */
export type Projects_Metadata_Max_Order_By = {
  activated_at?: InputMaybe<Order_By>;
  additional_payee?: InputMaybe<Order_By>;
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_address?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  artist_address?: InputMaybe<Order_By>;
  artist_display_notes?: InputMaybe<Order_By>;
  artist_featured_token_id?: InputMaybe<Order_By>;
  artist_interview?: InputMaybe<Order_By>;
  artist_name?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  base_uri?: InputMaybe<Order_By>;
  charitable_giving_details?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  contract_address?: InputMaybe<Order_By>;
  creative_credit?: InputMaybe<Order_By>;
  currency_address?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  currency_symbol?: InputMaybe<Order_By>;
  /** Returns 'script_type_and_version_override' for the project if available; otherwise, falls back to 'script_type_and_version' */
  dependency_name_and_version?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_address?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  erc2981_splitter_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  ipfs_hash?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  link_to_license?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  minter_configuration_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offchain_script?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  price_per_token_in_wei?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  proposed_artists_and_splits_id?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_address?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  sales_notes?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
  /** Indicates the script type and version (e.g., p5@1.0.0) assigned to the project on its core contract */
  script_type_and_version?: InputMaybe<Order_By>;
  /** Specifies the script type and version override for the project, as set on the Art Blocks dependency registry contract */
  script_type_and_version_override?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  testnet_project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vertical_name?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Projects_Metadata_Min_Fields = {
  __typename?: 'projects_metadata_min_fields';
  activated_at?: Maybe<Scalars['timestamptz']['output']>;
  additional_payee?: Maybe<Scalars['String']['output']>;
  additional_payee_percentage?: Maybe<Scalars['Int']['output']>;
  additional_payee_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  artist_address?: Maybe<Scalars['String']['output']>;
  artist_display_notes?: Maybe<Scalars['String']['output']>;
  artist_featured_token_id?: Maybe<Scalars['String']['output']>;
  artist_interview?: Maybe<Scalars['String']['output']>;
  artist_name?: Maybe<Scalars['String']['output']>;
  aspect_ratio?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "project_auction_end_time" */
  auction_end_time?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "project_auction_start_time" */
  auction_start_time?: Maybe<Scalars['timestamptz']['output']>;
  base_uri?: Maybe<Scalars['String']['output']>;
  charitable_giving_details?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  contract_address?: Maybe<Scalars['String']['output']>;
  creative_credit?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "curation_status_display" */
  curation_status_display?: Maybe<Scalars['String']['output']>;
  currency_address?: Maybe<Scalars['String']['output']>;
  currency_decimals?: Maybe<Scalars['Int']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  /** Returns 'script_type_and_version_override' for the project if available; otherwise, falls back to 'script_type_and_version' */
  dependency_name_and_version?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  erc2981_splitter_address?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "first_token_minted_at" */
  first_token_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "project_heritage_status" */
  heritage_curation_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  ipfs_hash?: Maybe<Scalars['String']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  link_to_license?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Int']['output']>;
  minter_configuration_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offchain_script?: Maybe<Scalars['String']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Int']['output']>;
  price_per_token_in_wei?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  proposed_artists_and_splits_id?: Maybe<Scalars['String']['output']>;
  render_delay?: Maybe<Scalars['Int']['output']>;
  render_provider_secondary_sales_address?: Maybe<Scalars['String']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  royalty_percentage?: Maybe<Scalars['Int']['output']>;
  sales_notes?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  /** Indicates the script type and version (e.g., p5@1.0.0) assigned to the project on its core contract */
  script_type_and_version?: Maybe<Scalars['String']['output']>;
  /** Specifies the script type and version override for the project, as set on the Art Blocks dependency registry contract */
  script_type_and_version_override?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "second_token_minted_at" */
  second_token_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  series_id?: Maybe<Scalars['Int']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Int']['output']>;
  /** Returns the URL for accessing this project's slippy map tiles (compatible with OpenSeadragon viewer) if they have been generated, otherwise returns null. */
  slippy_map_tiles_url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  testnet_project_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  vertical_name?: Maybe<Scalars['String']['output']>;
  video_aspect_ratio?: Maybe<Scalars['numeric']['output']>;
  video_duration?: Maybe<Scalars['Int']['output']>;
  video_fps?: Maybe<Scalars['Int']['output']>;
  video_render_delay?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "projects_metadata" */
export type Projects_Metadata_Min_Order_By = {
  activated_at?: InputMaybe<Order_By>;
  additional_payee?: InputMaybe<Order_By>;
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_address?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  artist_address?: InputMaybe<Order_By>;
  artist_display_notes?: InputMaybe<Order_By>;
  artist_featured_token_id?: InputMaybe<Order_By>;
  artist_interview?: InputMaybe<Order_By>;
  artist_name?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  base_uri?: InputMaybe<Order_By>;
  charitable_giving_details?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  contract_address?: InputMaybe<Order_By>;
  creative_credit?: InputMaybe<Order_By>;
  currency_address?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  currency_symbol?: InputMaybe<Order_By>;
  /** Returns 'script_type_and_version_override' for the project if available; otherwise, falls back to 'script_type_and_version' */
  dependency_name_and_version?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_address?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  erc2981_splitter_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  ipfs_hash?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  link_to_license?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  minter_configuration_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offchain_script?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  price_per_token_in_wei?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  proposed_artists_and_splits_id?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_address?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  sales_notes?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
  /** Indicates the script type and version (e.g., p5@1.0.0) assigned to the project on its core contract */
  script_type_and_version?: InputMaybe<Order_By>;
  /** Specifies the script type and version override for the project, as set on the Art Blocks dependency registry contract */
  script_type_and_version_override?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  testnet_project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vertical_name?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "projects_metadata" */
export type Projects_Metadata_Mutation_Response = {
  __typename?: 'projects_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects_Metadata>;
};

/** input type for inserting object relation for remote table "projects_metadata" */
export type Projects_Metadata_Obj_Rel_Insert_Input = {
  data: Projects_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "projects_metadata" */
export type Projects_Metadata_On_Conflict = {
  constraint: Projects_Metadata_Constraint;
  update_columns?: Array<Projects_Metadata_Update_Column>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "projects_metadata". */
export type Projects_Metadata_Order_By = {
  activated_at?: InputMaybe<Order_By>;
  active?: InputMaybe<Order_By>;
  additional_payee?: InputMaybe<Order_By>;
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_address?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  additional_payee_splitter?: InputMaybe<Split_Atomic_Contracts_Order_By>;
  artist?: InputMaybe<Users_Order_By>;
  artist_address?: InputMaybe<Order_By>;
  artist_display_notes?: InputMaybe<Order_By>;
  artist_featured_token_id?: InputMaybe<Order_By>;
  artist_interview?: InputMaybe<Order_By>;
  artist_name?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  auction_end_time?: InputMaybe<Order_By>;
  auction_start_time?: InputMaybe<Order_By>;
  base_uri?: InputMaybe<Order_By>;
  bids_aggregate?: InputMaybe<Bids_Metadata_Aggregate_Order_By>;
  canvas_mode?: InputMaybe<Order_By>;
  charitable_giving_details?: InputMaybe<Order_By>;
  complete?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  contract?: InputMaybe<Contracts_Metadata_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  creative_credit?: InputMaybe<Order_By>;
  curation_status?: InputMaybe<Order_By>;
  curation_status_display?: InputMaybe<Order_By>;
  curation_status_override?: InputMaybe<Order_By>;
  currency_address?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  currency_symbol?: InputMaybe<Order_By>;
  dependency?: InputMaybe<Dependencies_Metadata_Order_By>;
  dependency_name_and_version?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disable_auto_image_format?: InputMaybe<Order_By>;
  disable_sample_generator?: InputMaybe<Order_By>;
  display_static?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_address?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  erc2981_splitter_address?: InputMaybe<Order_By>;
  erc2981_splitter_contract?: InputMaybe<Royalty_Splitter_Contracts_Order_By>;
  external_asset_dependencies_aggregate?: InputMaybe<Project_External_Asset_Dependencies_Aggregate_Order_By>;
  external_asset_dependencies_locked?: InputMaybe<Order_By>;
  external_asset_dependency_count?: InputMaybe<Order_By>;
  favorited_by_user?: InputMaybe<Order_By>;
  favorites_aggregate?: InputMaybe<Favorites_Aggregate_Order_By>;
  features?: InputMaybe<Projects_Features_Order_By>;
  first_token_minted_at?: InputMaybe<Order_By>;
  generate_video_assets?: InputMaybe<Order_By>;
  heritage_curation_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  invocations?: InputMaybe<Order_By>;
  ipfs_hash?: InputMaybe<Order_By>;
  is_artblocks?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  link_to_license?: InputMaybe<Order_By>;
  locked?: InputMaybe<Order_By>;
  locked_pre_v3?: InputMaybe<Order_By>;
  lowest_listing?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  minter_configuration?: InputMaybe<Project_Minter_Configurations_Order_By>;
  minter_configuration_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offchain_script?: InputMaybe<Order_By>;
  oob_count?: InputMaybe<Order_By>;
  oob_tokens_aggregate?: InputMaybe<Oob_Tokens_Metadata_Aggregate_Order_By>;
  open_for_review?: InputMaybe<Order_By>;
  paused?: InputMaybe<Order_By>;
  pmp_project_configs_aggregate?: InputMaybe<Pmp_Project_Configs_Aggregate_Order_By>;
  preview_render_type?: InputMaybe<Order_By>;
  price_per_token_in_wei?: InputMaybe<Order_By>;
  primary_render_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  properties_updated_at?: InputMaybe<Order_By>;
  proposed_artist_addresses_and_split?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Order_By>;
  proposed_artists_and_splits_id?: InputMaybe<Order_By>;
  read_only_addresses?: InputMaybe<Order_By>;
  receipts_aggregate?: InputMaybe<Receipt_Metadata_Aggregate_Order_By>;
  refresh_requests_aggregate?: InputMaybe<Refresh_Requests_Aggregate_Order_By>;
  render_complete?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_address?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  render_with_gpu?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  sales_notes?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
  script_count?: InputMaybe<Order_By>;
  script_json?: InputMaybe<Order_By>;
  script_type_and_version?: InputMaybe<Order_By>;
  script_type_and_version_override?: InputMaybe<Order_By>;
  scripts_aggregate?: InputMaybe<Project_Scripts_Aggregate_Order_By>;
  second_token_minted_at?: InputMaybe<Order_By>;
  series?: InputMaybe<Project_Series_Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  slippy_map_tiles_generated?: InputMaybe<Order_By>;
  slippy_map_tiles_url?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  tags_aggregate?: InputMaybe<Entity_Tags_Aggregate_Order_By>;
  testnet_project_id?: InputMaybe<Order_By>;
  tokens_aggregate?: InputMaybe<Tokens_Metadata_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_is_artist?: InputMaybe<Order_By>;
  vertical?: InputMaybe<Project_Verticals_Order_By>;
  vertical_name?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: projects_metadata */
export type Projects_Metadata_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Projects_Metadata_Prepend_Input = {
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  read_only_addresses?: InputMaybe<Scalars['jsonb']['input']>;
  script_json?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "projects_metadata" */
export enum Projects_Metadata_Select_Column {
  /** column name */
  ActivatedAt = 'activated_at',
  /** column name */
  Active = 'active',
  /** column name */
  AdditionalPayee = 'additional_payee',
  /** column name */
  AdditionalPayeePercentage = 'additional_payee_percentage',
  /** column name */
  AdditionalPayeeSecondarySalesAddress = 'additional_payee_secondary_sales_address',
  /** column name */
  AdditionalPayeeSecondarySalesPercentage = 'additional_payee_secondary_sales_percentage',
  /** column name */
  ArtistAddress = 'artist_address',
  /** column name */
  ArtistDisplayNotes = 'artist_display_notes',
  /** column name */
  ArtistFeaturedTokenId = 'artist_featured_token_id',
  /** column name */
  ArtistInterview = 'artist_interview',
  /** column name */
  ArtistName = 'artist_name',
  /** column name */
  AspectRatio = 'aspect_ratio',
  /** column name */
  BaseUri = 'base_uri',
  /** column name */
  CanvasMode = 'canvas_mode',
  /** column name */
  CharitableGivingDetails = 'charitable_giving_details',
  /** column name */
  Complete = 'complete',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  CreativeCredit = 'creative_credit',
  /** column name */
  CurationStatus = 'curation_status',
  /** column name */
  CurationStatusOverride = 'curation_status_override',
  /** column name */
  CurrencyAddress = 'currency_address',
  /** column name */
  CurrencyDecimals = 'currency_decimals',
  /** column name */
  CurrencySymbol = 'currency_symbol',
  /** column name */
  DependencyNameAndVersion = 'dependency_name_and_version',
  /** column name */
  Description = 'description',
  /** column name */
  DisableAutoImageFormat = 'disable_auto_image_format',
  /** column name */
  DisableSampleGenerator = 'disable_sample_generator',
  /** column name */
  DisplayStatic = 'display_static',
  /** column name */
  EnginePlatformProviderSecondarySalesAddress = 'engine_platform_provider_secondary_sales_address',
  /** column name */
  EnginePlatformProviderSecondarySalesBps = 'engine_platform_provider_secondary_sales_bps',
  /** column name */
  Erc2981SplitterAddress = 'erc2981_splitter_address',
  /** column name */
  ExternalAssetDependenciesLocked = 'external_asset_dependencies_locked',
  /** column name */
  GenerateVideoAssets = 'generate_video_assets',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  IpfsHash = 'ipfs_hash',
  /** column name */
  License = 'license',
  /** column name */
  LinkToLicense = 'link_to_license',
  /** column name */
  LockedPreV3 = 'locked_pre_v3',
  /** column name */
  MaxInvocations = 'max_invocations',
  /** column name */
  MinterConfigurationId = 'minter_configuration_id',
  /** column name */
  Name = 'name',
  /** column name */
  OffchainScript = 'offchain_script',
  /** column name */
  OobCount = 'oob_count',
  /** column name */
  OpenForReview = 'open_for_review',
  /** column name */
  Paused = 'paused',
  /** column name */
  PreviewRenderType = 'preview_render_type',
  /** column name */
  PricePerTokenInWei = 'price_per_token_in_wei',
  /** column name */
  PrimaryRenderType = 'primary_render_type',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PropertiesUpdatedAt = 'properties_updated_at',
  /** column name */
  ProposedArtistsAndSplitsId = 'proposed_artists_and_splits_id',
  /** column name */
  ReadOnlyAddresses = 'read_only_addresses',
  /** column name */
  RenderDelay = 'render_delay',
  /** column name */
  RenderProviderSecondarySalesAddress = 'render_provider_secondary_sales_address',
  /** column name */
  RenderProviderSecondarySalesBps = 'render_provider_secondary_sales_bps',
  /** column name */
  RenderWithGpu = 'render_with_gpu',
  /** column name */
  RoyaltyPercentage = 'royalty_percentage',
  /** column name */
  SalesNotes = 'sales_notes',
  /** column name */
  Script = 'script',
  /** column name */
  ScriptJson = 'script_json',
  /** column name */
  ScriptTypeAndVersion = 'script_type_and_version',
  /** column name */
  ScriptTypeAndVersionOverride = 'script_type_and_version_override',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SlippyMapGridColumnCount = 'slippy_map_grid_column_count',
  /** column name */
  SlippyMapTilesGenerated = 'slippy_map_tiles_generated',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  TestnetProjectId = 'testnet_project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerticalName = 'vertical_name',
  /** column name */
  VideoAspectRatio = 'video_aspect_ratio',
  /** column name */
  VideoDuration = 'video_duration',
  /** column name */
  VideoFps = 'video_fps',
  /** column name */
  VideoRenderDelay = 'video_render_delay',
  /** column name */
  Website = 'website'
}

/** select "projects_metadata_aggregate_bool_exp_bool_and_arguments_columns" columns of table "projects_metadata" */
export enum Projects_Metadata_Select_Column_Projects_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  CanvasMode = 'canvas_mode',
  /** column name */
  Complete = 'complete',
  /** column name */
  DisableAutoImageFormat = 'disable_auto_image_format',
  /** column name */
  DisableSampleGenerator = 'disable_sample_generator',
  /** column name */
  DisplayStatic = 'display_static',
  /** column name */
  ExternalAssetDependenciesLocked = 'external_asset_dependencies_locked',
  /** column name */
  GenerateVideoAssets = 'generate_video_assets',
  /** column name */
  LockedPreV3 = 'locked_pre_v3',
  /** column name */
  OpenForReview = 'open_for_review',
  /** column name */
  Paused = 'paused',
  /** column name */
  RenderWithGpu = 'render_with_gpu',
  /** column name */
  SlippyMapTilesGenerated = 'slippy_map_tiles_generated'
}

/** select "projects_metadata_aggregate_bool_exp_bool_or_arguments_columns" columns of table "projects_metadata" */
export enum Projects_Metadata_Select_Column_Projects_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  CanvasMode = 'canvas_mode',
  /** column name */
  Complete = 'complete',
  /** column name */
  DisableAutoImageFormat = 'disable_auto_image_format',
  /** column name */
  DisableSampleGenerator = 'disable_sample_generator',
  /** column name */
  DisplayStatic = 'display_static',
  /** column name */
  ExternalAssetDependenciesLocked = 'external_asset_dependencies_locked',
  /** column name */
  GenerateVideoAssets = 'generate_video_assets',
  /** column name */
  LockedPreV3 = 'locked_pre_v3',
  /** column name */
  OpenForReview = 'open_for_review',
  /** column name */
  Paused = 'paused',
  /** column name */
  RenderWithGpu = 'render_with_gpu',
  /** column name */
  SlippyMapTilesGenerated = 'slippy_map_tiles_generated'
}

/** input type for updating data in table "projects_metadata" */
export type Projects_Metadata_Set_Input = {
  activated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additional_payee?: InputMaybe<Scalars['String']['input']>;
  additional_payee_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  artist_address?: InputMaybe<Scalars['String']['input']>;
  artist_display_notes?: InputMaybe<Scalars['String']['input']>;
  artist_featured_token_id?: InputMaybe<Scalars['String']['input']>;
  artist_interview?: InputMaybe<Scalars['String']['input']>;
  artist_name?: InputMaybe<Scalars['String']['input']>;
  aspect_ratio?: InputMaybe<Scalars['numeric']['input']>;
  base_uri?: InputMaybe<Scalars['String']['input']>;
  canvas_mode?: InputMaybe<Scalars['Boolean']['input']>;
  charitable_giving_details?: InputMaybe<Scalars['String']['input']>;
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contract_address?: InputMaybe<Scalars['String']['input']>;
  creative_credit?: InputMaybe<Scalars['String']['input']>;
  curation_status?: InputMaybe<Curation_Statuses_Enum>;
  curation_status_override?: InputMaybe<Curation_Statuses_Enum>;
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_decimals?: InputMaybe<Scalars['Int']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable_auto_image_format?: InputMaybe<Scalars['Boolean']['input']>;
  disable_sample_generator?: InputMaybe<Scalars['Boolean']['input']>;
  display_static?: InputMaybe<Scalars['Boolean']['input']>;
  engine_platform_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  erc2981_splitter_address?: InputMaybe<Scalars['String']['input']>;
  external_asset_dependencies_locked?: InputMaybe<Scalars['Boolean']['input']>;
  generate_video_assets?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  ipfs_hash?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  link_to_license?: InputMaybe<Scalars['String']['input']>;
  locked_pre_v3?: InputMaybe<Scalars['Boolean']['input']>;
  max_invocations?: InputMaybe<Scalars['Int']['input']>;
  minter_configuration_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offchain_script?: InputMaybe<Scalars['String']['input']>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Scalars['Int']['input']>;
  open_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  preview_render_type?: InputMaybe<Render_Types_Enum>;
  price_per_token_in_wei?: InputMaybe<Scalars['String']['input']>;
  primary_render_type?: InputMaybe<Render_Types_Enum>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  proposed_artists_and_splits_id?: InputMaybe<Scalars['String']['input']>;
  read_only_addresses?: InputMaybe<Scalars['jsonb']['input']>;
  render_delay?: InputMaybe<Scalars['Int']['input']>;
  render_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  render_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  render_with_gpu?: InputMaybe<Scalars['Boolean']['input']>;
  royalty_percentage?: InputMaybe<Scalars['Int']['input']>;
  sales_notes?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  script_json?: InputMaybe<Scalars['jsonb']['input']>;
  /** Indicates the script type and version (e.g., p5@1.0.0) assigned to the project on its core contract */
  script_type_and_version?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the script type and version override for the project, as set on the Art Blocks dependency registry contract */
  script_type_and_version_override?: InputMaybe<Scalars['String']['input']>;
  series_id?: InputMaybe<Scalars['Int']['input']>;
  slippy_map_grid_column_count?: InputMaybe<Scalars['Int']['input']>;
  slippy_map_tiles_generated?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  testnet_project_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  vertical_name?: InputMaybe<Scalars['String']['input']>;
  video_aspect_ratio?: InputMaybe<Scalars['numeric']['input']>;
  video_duration?: InputMaybe<Scalars['Int']['input']>;
  video_fps?: InputMaybe<Scalars['Int']['input']>;
  video_render_delay?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Projects_Metadata_Stddev_Fields = {
  __typename?: 'projects_metadata_stddev_fields';
  additional_payee_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  currency_decimals?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Float']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Float']['output']>;
  render_delay?: Maybe<Scalars['Float']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  royalty_percentage?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  series_id?: Maybe<Scalars['Float']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Float']['output']>;
  video_aspect_ratio?: Maybe<Scalars['Float']['output']>;
  video_duration?: Maybe<Scalars['Float']['output']>;
  video_fps?: Maybe<Scalars['Float']['output']>;
  video_render_delay?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "projects_metadata" */
export type Projects_Metadata_Stddev_Order_By = {
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Projects_Metadata_Stddev_Pop_Fields = {
  __typename?: 'projects_metadata_stddev_pop_fields';
  additional_payee_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  currency_decimals?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Float']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Float']['output']>;
  render_delay?: Maybe<Scalars['Float']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  royalty_percentage?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  series_id?: Maybe<Scalars['Float']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Float']['output']>;
  video_aspect_ratio?: Maybe<Scalars['Float']['output']>;
  video_duration?: Maybe<Scalars['Float']['output']>;
  video_fps?: Maybe<Scalars['Float']['output']>;
  video_render_delay?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "projects_metadata" */
export type Projects_Metadata_Stddev_Pop_Order_By = {
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Projects_Metadata_Stddev_Samp_Fields = {
  __typename?: 'projects_metadata_stddev_samp_fields';
  additional_payee_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  currency_decimals?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Float']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Float']['output']>;
  render_delay?: Maybe<Scalars['Float']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  royalty_percentage?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  series_id?: Maybe<Scalars['Float']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Float']['output']>;
  video_aspect_ratio?: Maybe<Scalars['Float']['output']>;
  video_duration?: Maybe<Scalars['Float']['output']>;
  video_fps?: Maybe<Scalars['Float']['output']>;
  video_render_delay?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "projects_metadata" */
export type Projects_Metadata_Stddev_Samp_Order_By = {
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projects_metadata" */
export type Projects_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_Metadata_Stream_Cursor_Value_Input = {
  activated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additional_payee?: InputMaybe<Scalars['String']['input']>;
  additional_payee_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  artist_address?: InputMaybe<Scalars['String']['input']>;
  artist_display_notes?: InputMaybe<Scalars['String']['input']>;
  artist_featured_token_id?: InputMaybe<Scalars['String']['input']>;
  artist_interview?: InputMaybe<Scalars['String']['input']>;
  artist_name?: InputMaybe<Scalars['String']['input']>;
  aspect_ratio?: InputMaybe<Scalars['numeric']['input']>;
  base_uri?: InputMaybe<Scalars['String']['input']>;
  canvas_mode?: InputMaybe<Scalars['Boolean']['input']>;
  charitable_giving_details?: InputMaybe<Scalars['String']['input']>;
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  contract_address?: InputMaybe<Scalars['String']['input']>;
  creative_credit?: InputMaybe<Scalars['String']['input']>;
  curation_status?: InputMaybe<Curation_Statuses_Enum>;
  curation_status_override?: InputMaybe<Curation_Statuses_Enum>;
  currency_address?: InputMaybe<Scalars['String']['input']>;
  currency_decimals?: InputMaybe<Scalars['Int']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  /** Returns 'script_type_and_version_override' for the project if available; otherwise, falls back to 'script_type_and_version' */
  dependency_name_and_version?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable_auto_image_format?: InputMaybe<Scalars['Boolean']['input']>;
  disable_sample_generator?: InputMaybe<Scalars['Boolean']['input']>;
  display_static?: InputMaybe<Scalars['Boolean']['input']>;
  engine_platform_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  erc2981_splitter_address?: InputMaybe<Scalars['String']['input']>;
  external_asset_dependencies_locked?: InputMaybe<Scalars['Boolean']['input']>;
  generate_video_assets?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  ipfs_hash?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  link_to_license?: InputMaybe<Scalars['String']['input']>;
  locked_pre_v3?: InputMaybe<Scalars['Boolean']['input']>;
  max_invocations?: InputMaybe<Scalars['Int']['input']>;
  minter_configuration_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offchain_script?: InputMaybe<Scalars['String']['input']>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Scalars['Int']['input']>;
  open_for_review?: InputMaybe<Scalars['Boolean']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  preview_render_type?: InputMaybe<Render_Types_Enum>;
  price_per_token_in_wei?: InputMaybe<Scalars['String']['input']>;
  primary_render_type?: InputMaybe<Render_Types_Enum>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  properties_updated_at?: InputMaybe<Scalars['jsonb']['input']>;
  proposed_artists_and_splits_id?: InputMaybe<Scalars['String']['input']>;
  read_only_addresses?: InputMaybe<Scalars['jsonb']['input']>;
  render_delay?: InputMaybe<Scalars['Int']['input']>;
  render_provider_secondary_sales_address?: InputMaybe<Scalars['String']['input']>;
  render_provider_secondary_sales_bps?: InputMaybe<Scalars['Int']['input']>;
  render_with_gpu?: InputMaybe<Scalars['Boolean']['input']>;
  royalty_percentage?: InputMaybe<Scalars['Int']['input']>;
  sales_notes?: InputMaybe<Scalars['String']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  script_json?: InputMaybe<Scalars['jsonb']['input']>;
  /** Indicates the script type and version (e.g., p5@1.0.0) assigned to the project on its core contract */
  script_type_and_version?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the script type and version override for the project, as set on the Art Blocks dependency registry contract */
  script_type_and_version_override?: InputMaybe<Scalars['String']['input']>;
  series_id?: InputMaybe<Scalars['Int']['input']>;
  slippy_map_grid_column_count?: InputMaybe<Scalars['Int']['input']>;
  slippy_map_tiles_generated?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  testnet_project_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  vertical_name?: InputMaybe<Scalars['String']['input']>;
  video_aspect_ratio?: InputMaybe<Scalars['numeric']['input']>;
  video_duration?: InputMaybe<Scalars['Int']['input']>;
  video_fps?: InputMaybe<Scalars['Int']['input']>;
  video_render_delay?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Projects_Metadata_Sum_Fields = {
  __typename?: 'projects_metadata_sum_fields';
  additional_payee_percentage?: Maybe<Scalars['Int']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  aspect_ratio?: Maybe<Scalars['numeric']['output']>;
  currency_decimals?: Maybe<Scalars['Int']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Int']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Int']['output']>;
  render_delay?: Maybe<Scalars['Int']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Int']['output']>;
  royalty_percentage?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  series_id?: Maybe<Scalars['Int']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Int']['output']>;
  video_aspect_ratio?: Maybe<Scalars['numeric']['output']>;
  video_duration?: Maybe<Scalars['Int']['output']>;
  video_fps?: Maybe<Scalars['Int']['output']>;
  video_render_delay?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "projects_metadata" */
export type Projects_Metadata_Sum_Order_By = {
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
};

/** update columns of table "projects_metadata" */
export enum Projects_Metadata_Update_Column {
  /** column name */
  ActivatedAt = 'activated_at',
  /** column name */
  Active = 'active',
  /** column name */
  AdditionalPayee = 'additional_payee',
  /** column name */
  AdditionalPayeePercentage = 'additional_payee_percentage',
  /** column name */
  AdditionalPayeeSecondarySalesAddress = 'additional_payee_secondary_sales_address',
  /** column name */
  AdditionalPayeeSecondarySalesPercentage = 'additional_payee_secondary_sales_percentage',
  /** column name */
  ArtistAddress = 'artist_address',
  /** column name */
  ArtistDisplayNotes = 'artist_display_notes',
  /** column name */
  ArtistFeaturedTokenId = 'artist_featured_token_id',
  /** column name */
  ArtistInterview = 'artist_interview',
  /** column name */
  ArtistName = 'artist_name',
  /** column name */
  AspectRatio = 'aspect_ratio',
  /** column name */
  BaseUri = 'base_uri',
  /** column name */
  CanvasMode = 'canvas_mode',
  /** column name */
  CharitableGivingDetails = 'charitable_giving_details',
  /** column name */
  Complete = 'complete',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  CreativeCredit = 'creative_credit',
  /** column name */
  CurationStatus = 'curation_status',
  /** column name */
  CurationStatusOverride = 'curation_status_override',
  /** column name */
  CurrencyAddress = 'currency_address',
  /** column name */
  CurrencyDecimals = 'currency_decimals',
  /** column name */
  CurrencySymbol = 'currency_symbol',
  /** column name */
  Description = 'description',
  /** column name */
  DisableAutoImageFormat = 'disable_auto_image_format',
  /** column name */
  DisableSampleGenerator = 'disable_sample_generator',
  /** column name */
  DisplayStatic = 'display_static',
  /** column name */
  EnginePlatformProviderSecondarySalesAddress = 'engine_platform_provider_secondary_sales_address',
  /** column name */
  EnginePlatformProviderSecondarySalesBps = 'engine_platform_provider_secondary_sales_bps',
  /** column name */
  Erc2981SplitterAddress = 'erc2981_splitter_address',
  /** column name */
  ExternalAssetDependenciesLocked = 'external_asset_dependencies_locked',
  /** column name */
  GenerateVideoAssets = 'generate_video_assets',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  IpfsHash = 'ipfs_hash',
  /** column name */
  License = 'license',
  /** column name */
  LinkToLicense = 'link_to_license',
  /** column name */
  LockedPreV3 = 'locked_pre_v3',
  /** column name */
  MaxInvocations = 'max_invocations',
  /** column name */
  MinterConfigurationId = 'minter_configuration_id',
  /** column name */
  Name = 'name',
  /** column name */
  OffchainScript = 'offchain_script',
  /** column name */
  OobCount = 'oob_count',
  /** column name */
  OpenForReview = 'open_for_review',
  /** column name */
  Paused = 'paused',
  /** column name */
  PreviewRenderType = 'preview_render_type',
  /** column name */
  PricePerTokenInWei = 'price_per_token_in_wei',
  /** column name */
  PrimaryRenderType = 'primary_render_type',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PropertiesUpdatedAt = 'properties_updated_at',
  /** column name */
  ProposedArtistsAndSplitsId = 'proposed_artists_and_splits_id',
  /** column name */
  ReadOnlyAddresses = 'read_only_addresses',
  /** column name */
  RenderDelay = 'render_delay',
  /** column name */
  RenderProviderSecondarySalesAddress = 'render_provider_secondary_sales_address',
  /** column name */
  RenderProviderSecondarySalesBps = 'render_provider_secondary_sales_bps',
  /** column name */
  RenderWithGpu = 'render_with_gpu',
  /** column name */
  RoyaltyPercentage = 'royalty_percentage',
  /** column name */
  SalesNotes = 'sales_notes',
  /** column name */
  Script = 'script',
  /** column name */
  ScriptJson = 'script_json',
  /** column name */
  ScriptTypeAndVersion = 'script_type_and_version',
  /** column name */
  ScriptTypeAndVersionOverride = 'script_type_and_version_override',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  SlippyMapGridColumnCount = 'slippy_map_grid_column_count',
  /** column name */
  SlippyMapTilesGenerated = 'slippy_map_tiles_generated',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  TestnetProjectId = 'testnet_project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerticalName = 'vertical_name',
  /** column name */
  VideoAspectRatio = 'video_aspect_ratio',
  /** column name */
  VideoDuration = 'video_duration',
  /** column name */
  VideoFps = 'video_fps',
  /** column name */
  VideoRenderDelay = 'video_render_delay',
  /** column name */
  Website = 'website'
}

export type Projects_Metadata_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Projects_Metadata_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Projects_Metadata_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Projects_Metadata_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Projects_Metadata_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Projects_Metadata_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Projects_Metadata_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Projects_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Projects_Metadata_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Projects_Metadata_Var_Pop_Fields = {
  __typename?: 'projects_metadata_var_pop_fields';
  additional_payee_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  currency_decimals?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Float']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Float']['output']>;
  render_delay?: Maybe<Scalars['Float']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  royalty_percentage?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  series_id?: Maybe<Scalars['Float']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Float']['output']>;
  video_aspect_ratio?: Maybe<Scalars['Float']['output']>;
  video_duration?: Maybe<Scalars['Float']['output']>;
  video_fps?: Maybe<Scalars['Float']['output']>;
  video_render_delay?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "projects_metadata" */
export type Projects_Metadata_Var_Pop_Order_By = {
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Projects_Metadata_Var_Samp_Fields = {
  __typename?: 'projects_metadata_var_samp_fields';
  additional_payee_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  currency_decimals?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Float']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Float']['output']>;
  render_delay?: Maybe<Scalars['Float']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  royalty_percentage?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  series_id?: Maybe<Scalars['Float']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Float']['output']>;
  video_aspect_ratio?: Maybe<Scalars['Float']['output']>;
  video_duration?: Maybe<Scalars['Float']['output']>;
  video_fps?: Maybe<Scalars['Float']['output']>;
  video_render_delay?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "projects_metadata" */
export type Projects_Metadata_Var_Samp_Order_By = {
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Projects_Metadata_Variance_Fields = {
  __typename?: 'projects_metadata_variance_fields';
  additional_payee_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  aspect_ratio?: Maybe<Scalars['Float']['output']>;
  currency_decimals?: Maybe<Scalars['Float']['output']>;
  engine_platform_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_external_asset_dependency_count" */
  external_asset_dependency_count?: Maybe<Scalars['bigint']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_invocations" */
  invocations?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "project_lowest_listing" */
  lowest_listing?: Maybe<Scalars['float8']['output']>;
  max_invocations?: Maybe<Scalars['Float']['output']>;
  /** Number of OOB tokens to generate */
  oob_count?: Maybe<Scalars['Float']['output']>;
  render_delay?: Maybe<Scalars['Float']['output']>;
  render_provider_secondary_sales_bps?: Maybe<Scalars['Float']['output']>;
  royalty_percentage?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "project_script_count" */
  script_count?: Maybe<Scalars['bigint']['output']>;
  series_id?: Maybe<Scalars['Float']['output']>;
  slippy_map_grid_column_count?: Maybe<Scalars['Float']['output']>;
  video_aspect_ratio?: Maybe<Scalars['Float']['output']>;
  video_duration?: Maybe<Scalars['Float']['output']>;
  video_fps?: Maybe<Scalars['Float']['output']>;
  video_render_delay?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "projects_metadata" */
export type Projects_Metadata_Variance_Order_By = {
  additional_payee_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  currency_decimals?: InputMaybe<Order_By>;
  engine_platform_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  max_invocations?: InputMaybe<Order_By>;
  /** Number of OOB tokens to generate */
  oob_count?: InputMaybe<Order_By>;
  render_delay?: InputMaybe<Order_By>;
  render_provider_secondary_sales_bps?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  series_id?: InputMaybe<Order_By>;
  slippy_map_grid_column_count?: InputMaybe<Order_By>;
  video_aspect_ratio?: InputMaybe<Order_By>;
  video_duration?: InputMaybe<Order_By>;
  video_fps?: InputMaybe<Order_By>;
  video_render_delay?: InputMaybe<Order_By>;
};

/** Currently proposed artist and address splits */
export type Proposed_Artist_Addresses_And_Splits = {
  __typename?: 'proposed_artist_addresses_and_splits';
  additional_payee_primary_sales: Scalars['String']['output'];
  additional_payee_primary_sales_percentage: Scalars['Int']['output'];
  additional_payee_secondary_sales: Scalars['String']['output'];
  additional_payee_secondary_sales_percentage: Scalars['Int']['output'];
  /** An object relationship */
  additional_payee_splitter?: Maybe<Split_Atomic_Contracts>;
  artist_address: Scalars['String']['output'];
  /** An object relationship */
  project: Projects_Metadata;
  project_id: Scalars['String']['output'];
};

/** aggregated selection of "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Aggregate = {
  __typename?: 'proposed_artist_addresses_and_splits_aggregate';
  aggregate?: Maybe<Proposed_Artist_Addresses_And_Splits_Aggregate_Fields>;
  nodes: Array<Proposed_Artist_Addresses_And_Splits>;
};

/** aggregate fields of "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Aggregate_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_aggregate_fields';
  avg?: Maybe<Proposed_Artist_Addresses_And_Splits_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Proposed_Artist_Addresses_And_Splits_Max_Fields>;
  min?: Maybe<Proposed_Artist_Addresses_And_Splits_Min_Fields>;
  stddev?: Maybe<Proposed_Artist_Addresses_And_Splits_Stddev_Fields>;
  stddev_pop?: Maybe<Proposed_Artist_Addresses_And_Splits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Proposed_Artist_Addresses_And_Splits_Stddev_Samp_Fields>;
  sum?: Maybe<Proposed_Artist_Addresses_And_Splits_Sum_Fields>;
  var_pop?: Maybe<Proposed_Artist_Addresses_And_Splits_Var_Pop_Fields>;
  var_samp?: Maybe<Proposed_Artist_Addresses_And_Splits_Var_Samp_Fields>;
  variance?: Maybe<Proposed_Artist_Addresses_And_Splits_Variance_Fields>;
};


/** aggregate fields of "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Proposed_Artist_Addresses_And_Splits_Avg_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_avg_fields';
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "proposed_artist_addresses_and_splits". All fields are combined with a logical 'AND'. */
export type Proposed_Artist_Addresses_And_Splits_Bool_Exp = {
  _and?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Bool_Exp>>;
  _not?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Bool_Exp>;
  _or?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Bool_Exp>>;
  additional_payee_primary_sales?: InputMaybe<String_Comparison_Exp>;
  additional_payee_primary_sales_percentage?: InputMaybe<Int_Comparison_Exp>;
  additional_payee_secondary_sales?: InputMaybe<String_Comparison_Exp>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Int_Comparison_Exp>;
  additional_payee_splitter?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
  artist_address?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "proposed_artist_addresses_and_splits" */
export enum Proposed_Artist_Addresses_And_Splits_Constraint {
  /** unique or primary key constraint on columns "project_id" */
  ProposedArtistAddressesAndSplitsPkey = 'proposed_artist_addresses_and_splits_pkey'
}

/** input type for incrementing numeric columns in table "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Inc_Input = {
  additional_payee_primary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Insert_Input = {
  additional_payee_primary_sales?: InputMaybe<Scalars['String']['input']>;
  additional_payee_primary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_secondary_sales?: InputMaybe<Scalars['String']['input']>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_splitter?: InputMaybe<Split_Atomic_Contracts_Obj_Rel_Insert_Input>;
  artist_address?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Proposed_Artist_Addresses_And_Splits_Max_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_max_fields';
  additional_payee_primary_sales?: Maybe<Scalars['String']['output']>;
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  additional_payee_secondary_sales?: Maybe<Scalars['String']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  artist_address?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Proposed_Artist_Addresses_And_Splits_Min_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_min_fields';
  additional_payee_primary_sales?: Maybe<Scalars['String']['output']>;
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  additional_payee_secondary_sales?: Maybe<Scalars['String']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  artist_address?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Mutation_Response = {
  __typename?: 'proposed_artist_addresses_and_splits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Proposed_Artist_Addresses_And_Splits>;
};

/** input type for inserting object relation for remote table "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Obj_Rel_Insert_Input = {
  data: Proposed_Artist_Addresses_And_Splits_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Proposed_Artist_Addresses_And_Splits_On_Conflict>;
};

/** on_conflict condition type for table "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_On_Conflict = {
  constraint: Proposed_Artist_Addresses_And_Splits_Constraint;
  update_columns?: Array<Proposed_Artist_Addresses_And_Splits_Update_Column>;
  where?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Bool_Exp>;
};

/** Ordering options when selecting data from "proposed_artist_addresses_and_splits". */
export type Proposed_Artist_Addresses_And_Splits_Order_By = {
  additional_payee_primary_sales?: InputMaybe<Order_By>;
  additional_payee_primary_sales_percentage?: InputMaybe<Order_By>;
  additional_payee_secondary_sales?: InputMaybe<Order_By>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Order_By>;
  additional_payee_splitter?: InputMaybe<Split_Atomic_Contracts_Order_By>;
  artist_address?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: proposed_artist_addresses_and_splits */
export type Proposed_Artist_Addresses_And_Splits_Pk_Columns_Input = {
  project_id: Scalars['String']['input'];
};

/** select columns of table "proposed_artist_addresses_and_splits" */
export enum Proposed_Artist_Addresses_And_Splits_Select_Column {
  /** column name */
  AdditionalPayeePrimarySales = 'additional_payee_primary_sales',
  /** column name */
  AdditionalPayeePrimarySalesPercentage = 'additional_payee_primary_sales_percentage',
  /** column name */
  AdditionalPayeeSecondarySales = 'additional_payee_secondary_sales',
  /** column name */
  AdditionalPayeeSecondarySalesPercentage = 'additional_payee_secondary_sales_percentage',
  /** column name */
  ArtistAddress = 'artist_address',
  /** column name */
  ProjectId = 'project_id'
}

/** input type for updating data in table "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Set_Input = {
  additional_payee_primary_sales?: InputMaybe<Scalars['String']['input']>;
  additional_payee_primary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_secondary_sales?: InputMaybe<Scalars['String']['input']>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  artist_address?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Proposed_Artist_Addresses_And_Splits_Stddev_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_stddev_fields';
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Proposed_Artist_Addresses_And_Splits_Stddev_Pop_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_stddev_pop_fields';
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Proposed_Artist_Addresses_And_Splits_Stddev_Samp_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_stddev_samp_fields';
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "proposed_artist_addresses_and_splits" */
export type Proposed_Artist_Addresses_And_Splits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Proposed_Artist_Addresses_And_Splits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Proposed_Artist_Addresses_And_Splits_Stream_Cursor_Value_Input = {
  additional_payee_primary_sales?: InputMaybe<Scalars['String']['input']>;
  additional_payee_primary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  additional_payee_secondary_sales?: InputMaybe<Scalars['String']['input']>;
  additional_payee_secondary_sales_percentage?: InputMaybe<Scalars['Int']['input']>;
  artist_address?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Proposed_Artist_Addresses_And_Splits_Sum_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_sum_fields';
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Int']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "proposed_artist_addresses_and_splits" */
export enum Proposed_Artist_Addresses_And_Splits_Update_Column {
  /** column name */
  AdditionalPayeePrimarySales = 'additional_payee_primary_sales',
  /** column name */
  AdditionalPayeePrimarySalesPercentage = 'additional_payee_primary_sales_percentage',
  /** column name */
  AdditionalPayeeSecondarySales = 'additional_payee_secondary_sales',
  /** column name */
  AdditionalPayeeSecondarySalesPercentage = 'additional_payee_secondary_sales_percentage',
  /** column name */
  ArtistAddress = 'artist_address',
  /** column name */
  ProjectId = 'project_id'
}

export type Proposed_Artist_Addresses_And_Splits_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Set_Input>;
  /** filter the rows which have to be updated */
  where: Proposed_Artist_Addresses_And_Splits_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Proposed_Artist_Addresses_And_Splits_Var_Pop_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_var_pop_fields';
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Proposed_Artist_Addresses_And_Splits_Var_Samp_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_var_samp_fields';
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Proposed_Artist_Addresses_And_Splits_Variance_Fields = {
  __typename?: 'proposed_artist_addresses_and_splits_variance_fields';
  additional_payee_primary_sales_percentage?: Maybe<Scalars['Float']['output']>;
  additional_payee_secondary_sales_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  account?: Maybe<Account>;
  accountProject?: Maybe<AccountProject>;
  accountProjects: Array<AccountProject>;
  accounts: Array<Account>;
  article?: Maybe<ArticleEntityResponse>;
  articles?: Maybe<ArticleEntityResponseCollection>;
  artistEditorialPage?: Maybe<ArtistEditorialPageEntityResponse>;
  artistEditorialPages?: Maybe<ArtistEditorialPageEntityResponseCollection>;
  /** fetch data from the table: "artists" */
  artists: Array<Artists>;
  /** fetch aggregated fields from the table: "artists" */
  artists_aggregate: Artists_Aggregate;
  bid?: Maybe<Bid>;
  /** fetch data from the table: "bid_types" */
  bid_types: Array<Bid_Types>;
  /** fetch aggregated fields from the table: "bid_types" */
  bid_types_aggregate: Bid_Types_Aggregate;
  /** fetch data from the table: "bid_types" using primary key columns */
  bid_types_by_pk?: Maybe<Bid_Types>;
  bids: Array<Bid>;
  /** fetch data from the table: "bids_metadata" */
  bids_metadata: Array<Bids_Metadata>;
  /** fetch aggregated fields from the table: "bids_metadata" */
  bids_metadata_aggregate: Bids_Metadata_Aggregate;
  /** fetch data from the table: "bids_metadata" using primary key columns */
  bids_metadata_by_pk?: Maybe<Bids_Metadata>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  contract?: Maybe<Contract>;
  /** fetch data from the table: "contract_allowlistings" */
  contract_allowlistings: Array<Contract_Allowlistings>;
  /** fetch aggregated fields from the table: "contract_allowlistings" */
  contract_allowlistings_aggregate: Contract_Allowlistings_Aggregate;
  /** fetch data from the table: "contract_allowlistings" using primary key columns */
  contract_allowlistings_by_pk?: Maybe<Contract_Allowlistings>;
  /** fetch data from the table: "contract_type_names" */
  contract_type_names: Array<Contract_Type_Names>;
  /** fetch aggregated fields from the table: "contract_type_names" */
  contract_type_names_aggregate: Contract_Type_Names_Aggregate;
  /** fetch data from the table: "contract_type_names" using primary key columns */
  contract_type_names_by_pk?: Maybe<Contract_Type_Names>;
  /** fetch data from the table: "contract_types" */
  contract_types: Array<Contract_Types>;
  /** fetch aggregated fields from the table: "contract_types" */
  contract_types_aggregate: Contract_Types_Aggregate;
  /** fetch data from the table: "contract_types" using primary key columns */
  contract_types_by_pk?: Maybe<Contract_Types>;
  contracts: Array<Contract>;
  /** fetch data from the table: "contracts_metadata" */
  contracts_metadata: Array<Contracts_Metadata>;
  /** fetch aggregated fields from the table: "contracts_metadata" */
  contracts_metadata_aggregate: Contracts_Metadata_Aggregate;
  /** fetch data from the table: "contracts_metadata" using primary key columns */
  contracts_metadata_by_pk?: Maybe<Contracts_Metadata>;
  coreRegistries: Array<CoreRegistry>;
  coreRegistry?: Maybe<CoreRegistry>;
  /** fetch data from the table: "core_registries_metadata" */
  core_registries_metadata: Array<Core_Registries_Metadata>;
  /** fetch aggregated fields from the table: "core_registries_metadata" */
  core_registries_metadata_aggregate: Core_Registries_Metadata_Aggregate;
  /** fetch data from the table: "core_registries_metadata" using primary key columns */
  core_registries_metadata_by_pk?: Maybe<Core_Registries_Metadata>;
  curatedHomePage?: Maybe<CuratedHomePageEntityResponse>;
  /** fetch data from the table: "curation_statuses" */
  curation_statuses: Array<Curation_Statuses>;
  /** fetch aggregated fields from the table: "curation_statuses" */
  curation_statuses_aggregate: Curation_Statuses_Aggregate;
  /** fetch data from the table: "curation_statuses" using primary key columns */
  curation_statuses_by_pk?: Maybe<Curation_Statuses>;
  dependencies: Array<Dependency>;
  /** fetch data from the table: "dependencies_metadata" */
  dependencies_metadata: Array<Dependencies_Metadata>;
  /** fetch aggregated fields from the table: "dependencies_metadata" */
  dependencies_metadata_aggregate: Dependencies_Metadata_Aggregate;
  /** fetch data from the table: "dependencies_metadata" using primary key columns */
  dependencies_metadata_by_pk?: Maybe<Dependencies_Metadata>;
  dependency?: Maybe<Dependency>;
  dependencyAdditionalCDN?: Maybe<DependencyAdditionalCdn>;
  dependencyAdditionalCDNs: Array<DependencyAdditionalCdn>;
  dependencyAdditionalRepositories: Array<DependencyAdditionalRepository>;
  dependencyAdditionalRepository?: Maybe<DependencyAdditionalRepository>;
  dependencyRegistries: Array<DependencyRegistry>;
  dependencyRegistry?: Maybe<DependencyRegistry>;
  dependencyScript?: Maybe<DependencyScript>;
  dependencyScripts: Array<DependencyScript>;
  /** fetch data from the table: "dependency_additional_cdns" */
  dependency_additional_cdns: Array<Dependency_Additional_Cdns>;
  /** fetch aggregated fields from the table: "dependency_additional_cdns" */
  dependency_additional_cdns_aggregate: Dependency_Additional_Cdns_Aggregate;
  /** fetch data from the table: "dependency_additional_cdns" using primary key columns */
  dependency_additional_cdns_by_pk?: Maybe<Dependency_Additional_Cdns>;
  /** fetch data from the table: "dependency_additional_repositories" */
  dependency_additional_repositories: Array<Dependency_Additional_Repositories>;
  /** fetch aggregated fields from the table: "dependency_additional_repositories" */
  dependency_additional_repositories_aggregate: Dependency_Additional_Repositories_Aggregate;
  /** fetch data from the table: "dependency_additional_repositories" using primary key columns */
  dependency_additional_repositories_by_pk?: Maybe<Dependency_Additional_Repositories>;
  /** fetch data from the table: "dependency_registries" */
  dependency_registries: Array<Dependency_Registries>;
  /** fetch aggregated fields from the table: "dependency_registries" */
  dependency_registries_aggregate: Dependency_Registries_Aggregate;
  /** fetch data from the table: "dependency_registries" using primary key columns */
  dependency_registries_by_pk?: Maybe<Dependency_Registries>;
  /** fetch data from the table: "dependency_scripts" */
  dependency_scripts: Array<Dependency_Scripts>;
  /** fetch aggregated fields from the table: "dependency_scripts" */
  dependency_scripts_aggregate: Dependency_Scripts_Aggregate;
  /** fetch data from the table: "dependency_scripts" using primary key columns */
  dependency_scripts_by_pk?: Maybe<Dependency_Scripts>;
  /** An array relationship */
  entity_tags: Array<Entity_Tags>;
  /** An aggregate relationship */
  entity_tags_aggregate: Entity_Tags_Aggregate;
  /** fetch data from the table: "entity_tags" using primary key columns */
  entity_tags_by_pk?: Maybe<Entity_Tags>;
  /** fetch data from the table: "environment_configuration" */
  environment_configuration: Array<Environment_Configuration>;
  /** fetch aggregated fields from the table: "environment_configuration" */
  environment_configuration_aggregate: Environment_Configuration_Aggregate;
  /** fetch data from the table: "environment_configuration" using primary key columns */
  environment_configuration_by_pk?: Maybe<Environment_Configuration>;
  exhibition?: Maybe<ExhibitionEntityResponse>;
  exhibitions?: Maybe<ExhibitionEntityResponseCollection>;
  /** An array relationship */
  favorites: Array<Favorites>;
  /** An aggregate relationship */
  favorites_aggregate: Favorites_Aggregate;
  /** fetch data from the table: "favorites" using primary key columns */
  favorites_by_pk?: Maybe<Favorites>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<Feature_Flags>;
  /** fetch aggregated fields from the table: "feature_flags" */
  feature_flags_aggregate: Feature_Flags_Aggregate;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** execute function "filter_tokens_metadata_by_features" which returns "tokens_metadata" */
  filter_tokens_metadata_by_features: Array<Tokens_Metadata>;
  /** execute function "filter_tokens_metadata_by_features" and query aggregates on result of table type "tokens_metadata" */
  filter_tokens_metadata_by_features_aggregate: Tokens_Metadata_Aggregate;
  getAllowlistUploadUrl?: Maybe<AllowlistUploadUrlData>;
  getAuthMessage?: Maybe<AuthMessageOutput>;
  getOpenseaCollectionURL?: Maybe<OpenseaCollectionData>;
  highlight?: Maybe<HighlightEntityResponse>;
  highlights?: Maybe<HighlightEntityResponseCollection>;
  homePage?: Maybe<HomePageEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  isTokenFlagged?: Maybe<Scalars['Boolean']['output']>;
  landingPage?: Maybe<LandingPageEntityResponse>;
  license?: Maybe<License>;
  licenses: Array<License>;
  /** execute function "list_projects_metadata_random" which returns "projects_metadata" */
  list_projects_metadata_random: Array<Projects_Metadata>;
  /** execute function "list_projects_metadata_random" and query aggregates on result of table type "projects_metadata" */
  list_projects_metadata_random_aggregate: Projects_Metadata_Aggregate;
  me?: Maybe<UsersPermissionsMe>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  minter?: Maybe<Minter>;
  minterFilter?: Maybe<MinterFilter>;
  minterFilterContractAllowlist?: Maybe<MinterFilterContractAllowlist>;
  minterFilterContractAllowlists: Array<MinterFilterContractAllowlist>;
  minterFilters: Array<MinterFilter>;
  minterInfo?: Maybe<MinterInfoEntityResponse>;
  minterInfos?: Maybe<MinterInfoEntityResponseCollection>;
  /** fetch data from the table: "minter_filter_type_names" */
  minter_filter_type_names: Array<Minter_Filter_Type_Names>;
  /** fetch aggregated fields from the table: "minter_filter_type_names" */
  minter_filter_type_names_aggregate: Minter_Filter_Type_Names_Aggregate;
  /** fetch data from the table: "minter_filter_type_names" using primary key columns */
  minter_filter_type_names_by_pk?: Maybe<Minter_Filter_Type_Names>;
  /** fetch data from the table: "minter_filters_metadata" */
  minter_filters_metadata: Array<Minter_Filters_Metadata>;
  /** fetch aggregated fields from the table: "minter_filters_metadata" */
  minter_filters_metadata_aggregate: Minter_Filters_Metadata_Aggregate;
  /** fetch data from the table: "minter_filters_metadata" using primary key columns */
  minter_filters_metadata_by_pk?: Maybe<Minter_Filters_Metadata>;
  /** fetch data from the table: "minter_type_names" */
  minter_type_names: Array<Minter_Type_Names>;
  /** fetch aggregated fields from the table: "minter_type_names" */
  minter_type_names_aggregate: Minter_Type_Names_Aggregate;
  /** fetch data from the table: "minter_type_names" using primary key columns */
  minter_type_names_by_pk?: Maybe<Minter_Type_Names>;
  /** fetch data from the table: "minter_types" */
  minter_types: Array<Minter_Types>;
  /** fetch aggregated fields from the table: "minter_types" */
  minter_types_aggregate: Minter_Types_Aggregate;
  /** fetch data from the table: "minter_types" using primary key columns */
  minter_types_by_pk?: Maybe<Minter_Types>;
  minters: Array<Minter>;
  /** fetch data from the table: "minters_metadata" */
  minters_metadata: Array<Minters_Metadata>;
  /** fetch aggregated fields from the table: "minters_metadata" */
  minters_metadata_aggregate: Minters_Metadata_Aggregate;
  /** fetch data from the table: "minters_metadata" using primary key columns */
  minters_metadata_by_pk?: Maybe<Minters_Metadata>;
  /** fetch data from the table: "mixpanel_lookup" */
  mixpanel_lookup: Array<Mixpanel_Lookup>;
  /** fetch aggregated fields from the table: "mixpanel_lookup" */
  mixpanel_lookup_aggregate: Mixpanel_Lookup_Aggregate;
  /** fetch data from the table: "mixpanel_lookup" using primary key columns */
  mixpanel_lookup_by_pk?: Maybe<Mixpanel_Lookup>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "oob_tokens_metadata" */
  oob_tokens_metadata: Array<Oob_Tokens_Metadata>;
  /** fetch aggregated fields from the table: "oob_tokens_metadata" */
  oob_tokens_metadata_aggregate: Oob_Tokens_Metadata_Aggregate;
  /** fetch data from the table: "oob_tokens_metadata" using primary key columns */
  oob_tokens_metadata_by_pk?: Maybe<Oob_Tokens_Metadata>;
  /** fetch data from the table: "partner_types" */
  partner_types: Array<Partner_Types>;
  /** fetch aggregated fields from the table: "partner_types" */
  partner_types_aggregate: Partner_Types_Aggregate;
  /** fetch data from the table: "partner_types" using primary key columns */
  partner_types_by_pk?: Maybe<Partner_Types>;
  /** fetch data from the table: "partners" */
  partners: Array<Partners>;
  /** fetch aggregated fields from the table: "partners" */
  partners_aggregate: Partners_Aggregate;
  /** fetch data from the table: "partners" using primary key columns */
  partners_by_pk?: Maybe<Partners>;
  payment?: Maybe<Payment>;
  payments: Array<Payment>;
  pmp?: Maybe<Pmp>;
  pmpConfig?: Maybe<PmpConfig>;
  pmpConfigs: Array<PmpConfig>;
  pmpLatestState?: Maybe<PmpLatestState>;
  pmpLatestStates: Array<PmpLatestState>;
  pmpProjectConfig?: Maybe<PmpProjectConfig>;
  pmpProjectConfigs: Array<PmpProjectConfig>;
  /** fetch data from the table: "pmp_auth_options" */
  pmp_auth_options: Array<Pmp_Auth_Options>;
  /** fetch aggregated fields from the table: "pmp_auth_options" */
  pmp_auth_options_aggregate: Pmp_Auth_Options_Aggregate;
  /** fetch data from the table: "pmp_auth_options" using primary key columns */
  pmp_auth_options_by_pk?: Maybe<Pmp_Auth_Options>;
  /** An array relationship */
  pmp_configs: Array<Pmp_Configs>;
  /** An aggregate relationship */
  pmp_configs_aggregate: Pmp_Configs_Aggregate;
  /** fetch data from the table: "pmp_configs" using primary key columns */
  pmp_configs_by_pk?: Maybe<Pmp_Configs>;
  /** fetch data from the table: "pmp_param_types" */
  pmp_param_types: Array<Pmp_Param_Types>;
  /** fetch aggregated fields from the table: "pmp_param_types" */
  pmp_param_types_aggregate: Pmp_Param_Types_Aggregate;
  /** fetch data from the table: "pmp_param_types" using primary key columns */
  pmp_param_types_by_pk?: Maybe<Pmp_Param_Types>;
  /** An array relationship */
  pmp_project_configs: Array<Pmp_Project_Configs>;
  /** An aggregate relationship */
  pmp_project_configs_aggregate: Pmp_Project_Configs_Aggregate;
  /** fetch data from the table: "pmp_project_configs" using primary key columns */
  pmp_project_configs_by_pk?: Maybe<Pmp_Project_Configs>;
  pmps: Array<Pmp>;
  /** fetch data from the table: "pmps_metadata" */
  pmps_metadata: Array<Pmps_Metadata>;
  /** fetch aggregated fields from the table: "pmps_metadata" */
  pmps_metadata_aggregate: Pmps_Metadata_Aggregate;
  /** fetch data from the table: "pmps_metadata" using primary key columns */
  pmps_metadata_by_pk?: Maybe<Pmps_Metadata>;
  primaryPurchase?: Maybe<PrimaryPurchase>;
  primaryPurchases: Array<PrimaryPurchase>;
  /** fetch data from the table: "primary_purchases" */
  primary_purchases: Array<Primary_Purchases>;
  /** fetch aggregated fields from the table: "primary_purchases" */
  primary_purchases_aggregate: Primary_Purchases_Aggregate;
  /** fetch data from the table: "primary_purchases" using primary key columns */
  primary_purchases_by_pk?: Maybe<Primary_Purchases>;
  /** An array relationship */
  processing_jobs: Array<Processing_Jobs>;
  /** An aggregate relationship */
  processing_jobs_aggregate: Processing_Jobs_Aggregate;
  /** fetch data from the table: "processing_jobs" using primary key columns */
  processing_jobs_by_pk?: Maybe<Processing_Jobs>;
  /** fetch data from the table: "processing_jobs_status_types" */
  processing_jobs_status_types: Array<Processing_Jobs_Status_Types>;
  /** fetch aggregated fields from the table: "processing_jobs_status_types" */
  processing_jobs_status_types_aggregate: Processing_Jobs_Status_Types_Aggregate;
  /** fetch data from the table: "processing_jobs_status_types" using primary key columns */
  processing_jobs_status_types_by_pk?: Maybe<Processing_Jobs_Status_Types>;
  project?: Maybe<Project>;
  projectExternalAssetDependencies: Array<ProjectExternalAssetDependency>;
  projectExternalAssetDependency?: Maybe<ProjectExternalAssetDependency>;
  projectMinterConfiguration?: Maybe<ProjectMinterConfiguration>;
  projectMinterConfigurations: Array<ProjectMinterConfiguration>;
  projectPage?: Maybe<ProjectPageEntityResponse>;
  projectPages?: Maybe<ProjectPageEntityResponseCollection>;
  projectScript?: Maybe<ProjectScript>;
  projectScripts: Array<ProjectScript>;
  /** fetch data from the table: "project_external_asset_dependencies" */
  project_external_asset_dependencies: Array<Project_External_Asset_Dependencies>;
  /** fetch aggregated fields from the table: "project_external_asset_dependencies" */
  project_external_asset_dependencies_aggregate: Project_External_Asset_Dependencies_Aggregate;
  /** fetch data from the table: "project_external_asset_dependencies" using primary key columns */
  project_external_asset_dependencies_by_pk?: Maybe<Project_External_Asset_Dependencies>;
  /** fetch data from the table: "project_external_asset_dependency_types" */
  project_external_asset_dependency_types: Array<Project_External_Asset_Dependency_Types>;
  /** fetch aggregated fields from the table: "project_external_asset_dependency_types" */
  project_external_asset_dependency_types_aggregate: Project_External_Asset_Dependency_Types_Aggregate;
  /** fetch data from the table: "project_external_asset_dependency_types" using primary key columns */
  project_external_asset_dependency_types_by_pk?: Maybe<Project_External_Asset_Dependency_Types>;
  /** fetch data from the table: "project_minter_configurations" */
  project_minter_configurations: Array<Project_Minter_Configurations>;
  /** fetch aggregated fields from the table: "project_minter_configurations" */
  project_minter_configurations_aggregate: Project_Minter_Configurations_Aggregate;
  /** fetch data from the table: "project_minter_configurations" using primary key columns */
  project_minter_configurations_by_pk?: Maybe<Project_Minter_Configurations>;
  /** execute function "project_ranked_bids" which returns "bids_metadata" */
  project_ranked_bids: Array<Bids_Metadata>;
  /** execute function "project_ranked_bids" and query aggregates on result of table type "bids_metadata" */
  project_ranked_bids_aggregate: Bids_Metadata_Aggregate;
  /** fetch data from the table: "project_scripts" */
  project_scripts: Array<Project_Scripts>;
  /** fetch aggregated fields from the table: "project_scripts" */
  project_scripts_aggregate: Project_Scripts_Aggregate;
  /** fetch data from the table: "project_scripts" using primary key columns */
  project_scripts_by_pk?: Maybe<Project_Scripts>;
  /** fetch data from the table: "project_series" */
  project_series: Array<Project_Series>;
  /** fetch aggregated fields from the table: "project_series" */
  project_series_aggregate: Project_Series_Aggregate;
  /** fetch data from the table: "project_series" using primary key columns */
  project_series_by_pk?: Maybe<Project_Series>;
  /** fetch data from the table: "project_vertical_categories" */
  project_vertical_categories: Array<Project_Vertical_Categories>;
  /** fetch aggregated fields from the table: "project_vertical_categories" */
  project_vertical_categories_aggregate: Project_Vertical_Categories_Aggregate;
  /** fetch data from the table: "project_vertical_categories" using primary key columns */
  project_vertical_categories_by_pk?: Maybe<Project_Vertical_Categories>;
  /** fetch data from the table: "project_verticals" */
  project_verticals: Array<Project_Verticals>;
  /** fetch aggregated fields from the table: "project_verticals" */
  project_verticals_aggregate: Project_Verticals_Aggregate;
  /** fetch data from the table: "project_verticals" using primary key columns */
  project_verticals_by_pk?: Maybe<Project_Verticals>;
  projects: Array<Project>;
  /** fetch data from the table: "projects_features" */
  projects_features: Array<Projects_Features>;
  /** fetch aggregated fields from the table: "projects_features" */
  projects_features_aggregate: Projects_Features_Aggregate;
  /** fetch data from the table: "projects_features" using primary key columns */
  projects_features_by_pk?: Maybe<Projects_Features>;
  /** fetch data from the table: "projects_metadata" */
  projects_metadata: Array<Projects_Metadata>;
  /** fetch aggregated fields from the table: "projects_metadata" */
  projects_metadata_aggregate: Projects_Metadata_Aggregate;
  /** fetch data from the table: "projects_metadata" using primary key columns */
  projects_metadata_by_pk?: Maybe<Projects_Metadata>;
  proposedArtistAddressesAndSplit?: Maybe<ProposedArtistAddressesAndSplit>;
  proposedArtistAddressesAndSplits: Array<ProposedArtistAddressesAndSplit>;
  /** fetch data from the table: "proposed_artist_addresses_and_splits" */
  proposed_artist_addresses_and_splits: Array<Proposed_Artist_Addresses_And_Splits>;
  /** fetch aggregated fields from the table: "proposed_artist_addresses_and_splits" */
  proposed_artist_addresses_and_splits_aggregate: Proposed_Artist_Addresses_And_Splits_Aggregate;
  /** fetch data from the table: "proposed_artist_addresses_and_splits" using primary key columns */
  proposed_artist_addresses_and_splits_by_pk?: Maybe<Proposed_Artist_Addresses_And_Splits>;
  receipt?: Maybe<Receipt>;
  /** fetch data from the table: "receipt_metadata" */
  receipt_metadata: Array<Receipt_Metadata>;
  /** fetch aggregated fields from the table: "receipt_metadata" */
  receipt_metadata_aggregate: Receipt_Metadata_Aggregate;
  /** fetch data from the table: "receipt_metadata" using primary key columns */
  receipt_metadata_by_pk?: Maybe<Receipt_Metadata>;
  receipts: Array<Receipt>;
  /** fetch data from the table: "refresh_asset_types" */
  refresh_asset_types: Array<Refresh_Asset_Types>;
  /** fetch aggregated fields from the table: "refresh_asset_types" */
  refresh_asset_types_aggregate: Refresh_Asset_Types_Aggregate;
  /** fetch data from the table: "refresh_asset_types" using primary key columns */
  refresh_asset_types_by_pk?: Maybe<Refresh_Asset_Types>;
  /** fetch data from the table: "refresh_request_types" */
  refresh_request_types: Array<Refresh_Request_Types>;
  /** fetch aggregated fields from the table: "refresh_request_types" */
  refresh_request_types_aggregate: Refresh_Request_Types_Aggregate;
  /** fetch data from the table: "refresh_request_types" using primary key columns */
  refresh_request_types_by_pk?: Maybe<Refresh_Request_Types>;
  /** An array relationship */
  refresh_requests: Array<Refresh_Requests>;
  /** An aggregate relationship */
  refresh_requests_aggregate: Refresh_Requests_Aggregate;
  /** fetch data from the table: "refresh_requests" using primary key columns */
  refresh_requests_by_pk?: Maybe<Refresh_Requests>;
  /** fetch data from the table: "render_types" */
  render_types: Array<Render_Types>;
  /** fetch aggregated fields from the table: "render_types" */
  render_types_aggregate: Render_Types_Aggregate;
  /** fetch data from the table: "render_types" using primary key columns */
  render_types_by_pk?: Maybe<Render_Types>;
  royaltySplitRecipient?: Maybe<RoyaltySplitRecipient>;
  royaltySplitRecipients: Array<RoyaltySplitRecipient>;
  royaltySplitterContract?: Maybe<RoyaltySplitterContract>;
  royaltySplitterContracts: Array<RoyaltySplitterContract>;
  /** An array relationship */
  royalty_split_recipients: Array<Royalty_Split_Recipients>;
  /** An aggregate relationship */
  royalty_split_recipients_aggregate: Royalty_Split_Recipients_Aggregate;
  /** fetch data from the table: "royalty_split_recipients" using primary key columns */
  royalty_split_recipients_by_pk?: Maybe<Royalty_Split_Recipients>;
  /** fetch data from the table: "royalty_splitter_contracts" */
  royalty_splitter_contracts: Array<Royalty_Splitter_Contracts>;
  /** fetch aggregated fields from the table: "royalty_splitter_contracts" */
  royalty_splitter_contracts_aggregate: Royalty_Splitter_Contracts_Aggregate;
  /** fetch data from the table: "royalty_splitter_contracts" using primary key columns */
  royalty_splitter_contracts_by_pk?: Maybe<Royalty_Splitter_Contracts>;
  sale?: Maybe<Sale>;
  saleLookupTable?: Maybe<SaleLookupTable>;
  saleLookupTables: Array<SaleLookupTable>;
  sales: Array<Sale>;
  /** fetch data from the table: "screenings" */
  screenings: Array<Screenings>;
  /** fetch aggregated fields from the table: "screenings" */
  screenings_aggregate: Screenings_Aggregate;
  /** fetch data from the table: "screenings" using primary key columns */
  screenings_by_pk?: Maybe<Screenings>;
  /** execute function "search_projects" which returns "projects_metadata" */
  search_projects: Array<Projects_Metadata>;
  /** execute function "search_projects" and query aggregates on result of table type "projects_metadata" */
  search_projects_aggregate: Projects_Metadata_Aggregate;
  /** execute function "search_tags" which returns "tags" */
  search_tags: Array<Tags>;
  /** execute function "search_tags" and query aggregates on result of table type "tags" */
  search_tags_aggregate: Tags_Aggregate;
  /** execute function "search_tokens" which returns "tokens_metadata" */
  search_tokens: Array<Tokens_Metadata>;
  /** execute function "search_tokens" and query aggregates on result of table type "tokens_metadata" */
  search_tokens_aggregate: Tokens_Metadata_Aggregate;
  /** execute function "search_users" which returns "user_profiles" */
  search_users: Array<User_Profiles>;
  /** execute function "search_users" and query aggregates on result of table type "user_profiles" */
  search_users_aggregate: User_Profiles_Aggregate;
  splitAtomicContract?: Maybe<SplitAtomicContract>;
  splitAtomicContracts: Array<SplitAtomicContract>;
  splitAtomicFactories: Array<SplitAtomicFactory>;
  splitAtomicFactory?: Maybe<SplitAtomicFactory>;
  splitAtomicSplit?: Maybe<SplitAtomicSplit>;
  splitAtomicSplits: Array<SplitAtomicSplit>;
  /** An array relationship */
  split_atomic_contracts: Array<Split_Atomic_Contracts>;
  /** An aggregate relationship */
  split_atomic_contracts_aggregate: Split_Atomic_Contracts_Aggregate;
  /** fetch data from the table: "split_atomic_contracts" using primary key columns */
  split_atomic_contracts_by_pk?: Maybe<Split_Atomic_Contracts>;
  /** fetch data from the table: "split_atomic_factories" */
  split_atomic_factories: Array<Split_Atomic_Factories>;
  /** fetch aggregated fields from the table: "split_atomic_factories" */
  split_atomic_factories_aggregate: Split_Atomic_Factories_Aggregate;
  /** fetch data from the table: "split_atomic_factories" using primary key columns */
  split_atomic_factories_by_pk?: Maybe<Split_Atomic_Factories>;
  /** fetch data from the table: "split_payment_configurations" */
  split_payment_configurations: Array<Split_Payment_Configurations>;
  /** fetch aggregated fields from the table: "split_payment_configurations" */
  split_payment_configurations_aggregate: Split_Payment_Configurations_Aggregate;
  /** fetch data from the table: "split_payment_configurations" using primary key columns */
  split_payment_configurations_by_pk?: Maybe<Split_Payment_Configurations>;
  /** fetch data from the table: "sync_status" */
  sync_status: Array<Sync_Status>;
  /** fetch aggregated fields from the table: "sync_status" */
  sync_status_aggregate: Sync_Status_Aggregate;
  /** fetch data from the table: "sync_status" using primary key columns */
  sync_status_by_pk?: Maybe<Sync_Status>;
  /** fetch data from the table: "tag_groupings" */
  tag_groupings: Array<Tag_Groupings>;
  /** fetch aggregated fields from the table: "tag_groupings" */
  tag_groupings_aggregate: Tag_Groupings_Aggregate;
  /** fetch data from the table: "tag_groupings" using primary key columns */
  tag_groupings_by_pk?: Maybe<Tag_Groupings>;
  /** fetch data from the table: "tag_status" */
  tag_status: Array<Tag_Status>;
  /** fetch aggregated fields from the table: "tag_status" */
  tag_status_aggregate: Tag_Status_Aggregate;
  /** fetch data from the table: "tag_status" using primary key columns */
  tag_status_by_pk?: Maybe<Tag_Status>;
  /** fetch data from the table: "tag_types" */
  tag_types: Array<Tag_Types>;
  /** fetch aggregated fields from the table: "tag_types" */
  tag_types_aggregate: Tag_Types_Aggregate;
  /** fetch data from the table: "tag_types" using primary key columns */
  tag_types_by_pk?: Maybe<Tag_Types>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  /** fetch data from the table: "tokens_metadata" */
  tokens_metadata: Array<Tokens_Metadata>;
  /** fetch aggregated fields from the table: "tokens_metadata" */
  tokens_metadata_aggregate: Tokens_Metadata_Aggregate;
  /** fetch data from the table: "tokens_metadata" using primary key columns */
  tokens_metadata_by_pk?: Maybe<Tokens_Metadata>;
  transfer?: Maybe<Transfer>;
  transfers: Array<Transfer>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "verticals" */
  verticals: Array<Verticals>;
  /** fetch aggregated fields from the table: "verticals" */
  verticals_aggregate: Verticals_Aggregate;
  /** fetch data from the table: "verticals" using primary key columns */
  verticals_by_pk?: Maybe<Verticals>;
  /** fetch data from the table: "video_aspect_ratios" */
  video_aspect_ratios: Array<Video_Aspect_Ratios>;
  /** fetch aggregated fields from the table: "video_aspect_ratios" */
  video_aspect_ratios_aggregate: Video_Aspect_Ratios_Aggregate;
  /** fetch data from the table: "video_aspect_ratios" using primary key columns */
  video_aspect_ratios_by_pk?: Maybe<Video_Aspect_Ratios>;
  /** fetch data from the table: "video_frame_rates" */
  video_frame_rates: Array<Video_Frame_Rates>;
  /** fetch aggregated fields from the table: "video_frame_rates" */
  video_frame_rates_aggregate: Video_Frame_Rates_Aggregate;
  /** fetch data from the table: "video_frame_rates" using primary key columns */
  video_frame_rates_by_pk?: Maybe<Video_Frame_Rates>;
  /** fetch data from the table: "webflow_artist_info" */
  webflow_artist_info: Array<Webflow_Artist_Info>;
  /** fetch aggregated fields from the table: "webflow_artist_info" */
  webflow_artist_info_aggregate: Webflow_Artist_Info_Aggregate;
  /** fetch data from the table: "webflow_artist_info" using primary key columns */
  webflow_artist_info_by_pk?: Maybe<Webflow_Artist_Info>;
  /** fetch data from the table: "webflow_spectrum_articles" */
  webflow_spectrum_articles: Array<Webflow_Spectrum_Articles>;
  /** fetch aggregated fields from the table: "webflow_spectrum_articles" */
  webflow_spectrum_articles_aggregate: Webflow_Spectrum_Articles_Aggregate;
  /** fetch data from the table: "webflow_spectrum_articles" using primary key columns */
  webflow_spectrum_articles_by_pk?: Maybe<Webflow_Spectrum_Articles>;
  whitelisting?: Maybe<Whitelisting>;
  whitelistings: Array<Whitelisting>;
};


export type Query_Root_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type Query_RootAccountArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootAccountProjectArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootAccountProjectsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountProject_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AccountProject_Filter>;
};


export type Query_RootAccountsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Account_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Account_Filter>;
};


export type Query_RootArticleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootArtistEditorialPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootArtistEditorialPagesArgs = {
  filters?: InputMaybe<ArtistEditorialPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootArtistsArgs = {
  distinct_on?: InputMaybe<Array<Artists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artists_Order_By>>;
  where?: InputMaybe<Artists_Bool_Exp>;
};


export type Query_RootArtists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artists_Order_By>>;
  where?: InputMaybe<Artists_Bool_Exp>;
};


export type Query_RootBidArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootBid_TypesArgs = {
  distinct_on?: InputMaybe<Array<Bid_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bid_Types_Order_By>>;
  where?: InputMaybe<Bid_Types_Bool_Exp>;
};


export type Query_RootBid_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bid_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bid_Types_Order_By>>;
  where?: InputMaybe<Bid_Types_Bool_Exp>;
};


export type Query_RootBid_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootBidsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Bid_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bid_Filter>;
};


export type Query_RootBids_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Query_RootBids_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Query_RootBids_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Query_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Query_RootCategories_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootContractArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootContract_AllowlistingsArgs = {
  distinct_on?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Allowlistings_Order_By>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


export type Query_RootContract_Allowlistings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Allowlistings_Order_By>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


export type Query_RootContract_Allowlistings_By_PkArgs = {
  contract_address: Scalars['String']['input'];
  user_address: Scalars['String']['input'];
};


export type Query_RootContract_Type_NamesArgs = {
  distinct_on?: InputMaybe<Array<Contract_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Type_Names_Order_By>>;
  where?: InputMaybe<Contract_Type_Names_Bool_Exp>;
};


export type Query_RootContract_Type_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Type_Names_Order_By>>;
  where?: InputMaybe<Contract_Type_Names_Bool_Exp>;
};


export type Query_RootContract_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootContract_TypesArgs = {
  distinct_on?: InputMaybe<Array<Contract_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Types_Order_By>>;
  where?: InputMaybe<Contract_Types_Bool_Exp>;
};


export type Query_RootContract_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Types_Order_By>>;
  where?: InputMaybe<Contract_Types_Bool_Exp>;
};


export type Query_RootContract_Types_By_PkArgs = {
  type: Contract_Type_Names_Enum;
};


export type Query_RootContractsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Contract_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Contract_Filter>;
};


export type Query_RootContracts_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


export type Query_RootContracts_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


export type Query_RootContracts_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootCoreRegistriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CoreRegistry_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<CoreRegistry_Filter>;
};


export type Query_RootCoreRegistryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootCore_Registries_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Core_Registries_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Core_Registries_Metadata_Order_By>>;
  where?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
};


export type Query_RootCore_Registries_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Core_Registries_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Core_Registries_Metadata_Order_By>>;
  where?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
};


export type Query_RootCore_Registries_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootCuratedHomePageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_RootCuration_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Curation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Curation_Statuses_Order_By>>;
  where?: InputMaybe<Curation_Statuses_Bool_Exp>;
};


export type Query_RootCuration_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Curation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Curation_Statuses_Order_By>>;
  where?: InputMaybe<Curation_Statuses_Bool_Exp>;
};


export type Query_RootCuration_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDependenciesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Dependency_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Dependency_Filter>;
};


export type Query_RootDependencies_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Dependencies_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependencies_Metadata_Order_By>>;
  where?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
};


export type Query_RootDependencies_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependencies_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependencies_Metadata_Order_By>>;
  where?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
};


export type Query_RootDependencies_Metadata_By_PkArgs = {
  name_and_version: Scalars['String']['input'];
};


export type Query_RootDependencyArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootDependencyAdditionalCdnArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootDependencyAdditionalCdNsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DependencyAdditionalCdn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DependencyAdditionalCdn_Filter>;
};


export type Query_RootDependencyAdditionalRepositoriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DependencyAdditionalRepository_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DependencyAdditionalRepository_Filter>;
};


export type Query_RootDependencyAdditionalRepositoryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootDependencyRegistriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DependencyRegistry_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DependencyRegistry_Filter>;
};


export type Query_RootDependencyRegistryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootDependencyScriptArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootDependencyScriptsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DependencyScript_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DependencyScript_Filter>;
};


export type Query_RootDependency_Additional_CdnsArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Cdns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Cdns_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
};


export type Query_RootDependency_Additional_Cdns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Cdns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Cdns_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
};


export type Query_RootDependency_Additional_Cdns_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


export type Query_RootDependency_Additional_RepositoriesArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Repositories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Repositories_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
};


export type Query_RootDependency_Additional_Repositories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Repositories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Repositories_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
};


export type Query_RootDependency_Additional_Repositories_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


export type Query_RootDependency_RegistriesArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Registries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Registries_Order_By>>;
  where?: InputMaybe<Dependency_Registries_Bool_Exp>;
};


export type Query_RootDependency_Registries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Registries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Registries_Order_By>>;
  where?: InputMaybe<Dependency_Registries_Bool_Exp>;
};


export type Query_RootDependency_Registries_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootDependency_ScriptsArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Scripts_Order_By>>;
  where?: InputMaybe<Dependency_Scripts_Bool_Exp>;
};


export type Query_RootDependency_Scripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Scripts_Order_By>>;
  where?: InputMaybe<Dependency_Scripts_Bool_Exp>;
};


export type Query_RootDependency_Scripts_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


export type Query_RootEntity_TagsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


export type Query_RootEntity_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


export type Query_RootEntity_Tags_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEnvironment_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Environment_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Environment_Configuration_Order_By>>;
  where?: InputMaybe<Environment_Configuration_Bool_Exp>;
};


export type Query_RootEnvironment_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Environment_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Environment_Configuration_Order_By>>;
  where?: InputMaybe<Environment_Configuration_Bool_Exp>;
};


export type Query_RootEnvironment_Configuration_By_PkArgs = {
  id: Scalars['Boolean']['input'];
};


export type Query_RootExhibitionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootExhibitionsArgs = {
  filters?: InputMaybe<ExhibitionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootFavoritesArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


export type Query_RootFavorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


export type Query_RootFavorites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Query_RootFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Query_RootFeature_Flags_By_PkArgs = {
  flag_name: Scalars['String']['input'];
};


export type Query_RootFilter_Tokens_Metadata_By_FeaturesArgs = {
  args: Filter_Tokens_Metadata_By_Features_Args;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Query_RootFilter_Tokens_Metadata_By_Features_AggregateArgs = {
  args: Filter_Tokens_Metadata_By_Features_Args;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Query_RootGetAllowlistUploadUrlArgs = {
  projectId: Scalars['String']['input'];
};


export type Query_RootGetAuthMessageArgs = {
  domain: Scalars['String']['input'];
  publicAddress: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};


export type Query_RootGetOpenseaCollectionUrlArgs = {
  contractAddress: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type Query_RootHighlightArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootHighlightsArgs = {
  filters?: InputMaybe<HighlightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootHomePageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_RootI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootIsTokenFlaggedArgs = {
  contractAddress: Scalars['String']['input'];
  tokenId: Scalars['String']['input'];
};


export type Query_RootLandingPageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_RootLicenseArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootLicensesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<License_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<License_Filter>;
};


export type Query_RootList_Projects_Metadata_RandomArgs = {
  args?: InputMaybe<List_Projects_Metadata_Random_Args>;
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Query_RootList_Projects_Metadata_Random_AggregateArgs = {
  args?: InputMaybe<List_Projects_Metadata_Random_Args>;
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Query_RootMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Query_RootMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Query_RootMedia_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMinterArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootMinterFilterArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootMinterFilterContractAllowlistArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootMinterFilterContractAllowlistsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MinterFilterContractAllowlist_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MinterFilterContractAllowlist_Filter>;
};


export type Query_RootMinterFiltersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MinterFilter_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MinterFilter_Filter>;
};


export type Query_RootMinterInfoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootMinterInfosArgs = {
  filters?: InputMaybe<MinterInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootMinter_Filter_Type_NamesArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filter_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filter_Type_Names_Order_By>>;
  where?: InputMaybe<Minter_Filter_Type_Names_Bool_Exp>;
};


export type Query_RootMinter_Filter_Type_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filter_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filter_Type_Names_Order_By>>;
  where?: InputMaybe<Minter_Filter_Type_Names_Bool_Exp>;
};


export type Query_RootMinter_Filter_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootMinter_Filters_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filters_Metadata_Order_By>>;
  where?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
};


export type Query_RootMinter_Filters_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filters_Metadata_Order_By>>;
  where?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
};


export type Query_RootMinter_Filters_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootMinter_Type_NamesArgs = {
  distinct_on?: InputMaybe<Array<Minter_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Type_Names_Order_By>>;
  where?: InputMaybe<Minter_Type_Names_Bool_Exp>;
};


export type Query_RootMinter_Type_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Type_Names_Order_By>>;
  where?: InputMaybe<Minter_Type_Names_Bool_Exp>;
};


export type Query_RootMinter_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootMinter_TypesArgs = {
  distinct_on?: InputMaybe<Array<Minter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Types_Order_By>>;
  where?: InputMaybe<Minter_Types_Bool_Exp>;
};


export type Query_RootMinter_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Types_Order_By>>;
  where?: InputMaybe<Minter_Types_Bool_Exp>;
};


export type Query_RootMinter_Types_By_PkArgs = {
  type: Minter_Type_Names_Enum;
};


export type Query_RootMintersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Minter_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Minter_Filter>;
};


export type Query_RootMinters_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minters_Metadata_Order_By>>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};


export type Query_RootMinters_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minters_Metadata_Order_By>>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};


export type Query_RootMinters_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootMixpanel_LookupArgs = {
  distinct_on?: InputMaybe<Array<Mixpanel_Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mixpanel_Lookup_Order_By>>;
  where?: InputMaybe<Mixpanel_Lookup_Bool_Exp>;
};


export type Query_RootMixpanel_Lookup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mixpanel_Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mixpanel_Lookup_Order_By>>;
  where?: InputMaybe<Mixpanel_Lookup_Bool_Exp>;
};


export type Query_RootMixpanel_Lookup_By_PkArgs = {
  hash: Scalars['String']['input'];
  mixpanel_id: Scalars['String']['input'];
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  trigger_key: Scalars['String']['input'];
  trigger_time: Scalars['timestamptz']['input'];
  user_address: Scalars['String']['input'];
};


export type Query_RootOob_Tokens_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oob_Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};


export type Query_RootOob_Tokens_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oob_Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};


export type Query_RootOob_Tokens_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootPartner_TypesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Types_Order_By>>;
  where?: InputMaybe<Partner_Types_Bool_Exp>;
};


export type Query_RootPartner_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Types_Order_By>>;
  where?: InputMaybe<Partner_Types_Bool_Exp>;
};


export type Query_RootPartner_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootPartnersArgs = {
  distinct_on?: InputMaybe<Array<Partners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partners_Order_By>>;
  where?: InputMaybe<Partners_Bool_Exp>;
};


export type Query_RootPartners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partners_Order_By>>;
  where?: InputMaybe<Partners_Bool_Exp>;
};


export type Query_RootPartners_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPaymentArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootPaymentsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Payment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Payment_Filter>;
};


export type Query_RootPmpArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootPmpConfigArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootPmpConfigsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PmpConfig_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PmpConfig_Filter>;
};


export type Query_RootPmpLatestStateArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootPmpLatestStatesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PmpLatestState_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PmpLatestState_Filter>;
};


export type Query_RootPmpProjectConfigArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootPmpProjectConfigsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PmpProjectConfig_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PmpProjectConfig_Filter>;
};


export type Query_RootPmp_Auth_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Auth_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Auth_Options_Order_By>>;
  where?: InputMaybe<Pmp_Auth_Options_Bool_Exp>;
};


export type Query_RootPmp_Auth_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Auth_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Auth_Options_Order_By>>;
  where?: InputMaybe<Pmp_Auth_Options_Bool_Exp>;
};


export type Query_RootPmp_Auth_Options_By_PkArgs = {
  option: Scalars['String']['input'];
};


export type Query_RootPmp_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Configs_Bool_Exp>;
};


export type Query_RootPmp_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Configs_Bool_Exp>;
};


export type Query_RootPmp_Configs_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootPmp_Param_TypesArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Param_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Param_Types_Order_By>>;
  where?: InputMaybe<Pmp_Param_Types_Bool_Exp>;
};


export type Query_RootPmp_Param_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Param_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Param_Types_Order_By>>;
  where?: InputMaybe<Pmp_Param_Types_Bool_Exp>;
};


export type Query_RootPmp_Param_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootPmp_Project_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Project_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Project_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
};


export type Query_RootPmp_Project_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Project_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Project_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
};


export type Query_RootPmp_Project_Configs_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootPmpsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pmp_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Pmp_Filter>;
};


export type Query_RootPmps_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmps_Metadata_Order_By>>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};


export type Query_RootPmps_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmps_Metadata_Order_By>>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};


export type Query_RootPmps_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootPrimaryPurchaseArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootPrimaryPurchasesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PrimaryPurchase_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PrimaryPurchase_Filter>;
};


export type Query_RootPrimary_PurchasesArgs = {
  distinct_on?: InputMaybe<Array<Primary_Purchases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Primary_Purchases_Order_By>>;
  where?: InputMaybe<Primary_Purchases_Bool_Exp>;
};


export type Query_RootPrimary_Purchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Primary_Purchases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Primary_Purchases_Order_By>>;
  where?: InputMaybe<Primary_Purchases_Bool_Exp>;
};


export type Query_RootPrimary_Purchases_By_PkArgs = {
  token_id: Scalars['String']['input'];
};


export type Query_RootProcessing_JobsArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Bool_Exp>;
};


export type Query_RootProcessing_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Bool_Exp>;
};


export type Query_RootProcessing_Jobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProcessing_Jobs_Status_TypesArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Status_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Status_Types_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Status_Types_Bool_Exp>;
};


export type Query_RootProcessing_Jobs_Status_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Status_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Status_Types_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Status_Types_Bool_Exp>;
};


export type Query_RootProcessing_Jobs_Status_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProjectArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootProjectExternalAssetDependenciesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectExternalAssetDependency_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProjectExternalAssetDependency_Filter>;
};


export type Query_RootProjectExternalAssetDependencyArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootProjectMinterConfigurationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootProjectMinterConfigurationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectMinterConfiguration_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProjectMinterConfiguration_Filter>;
};


export type Query_RootProjectPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootProjectPagesArgs = {
  filters?: InputMaybe<ProjectPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootProjectScriptArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootProjectScriptsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectScript_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProjectScript_Filter>;
};


export type Query_RootProject_External_Asset_DependenciesArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependencies_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
};


export type Query_RootProject_External_Asset_Dependencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependencies_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
};


export type Query_RootProject_External_Asset_Dependencies_By_PkArgs = {
  index: Scalars['Int']['input'];
  project_id: Scalars['String']['input'];
};


export type Query_RootProject_External_Asset_Dependency_TypesArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependency_Types_Bool_Exp>;
};


export type Query_RootProject_External_Asset_Dependency_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependency_Types_Bool_Exp>;
};


export type Query_RootProject_External_Asset_Dependency_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootProject_Minter_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Minter_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Minter_Configurations_Order_By>>;
  where?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
};


export type Query_RootProject_Minter_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Minter_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Minter_Configurations_Order_By>>;
  where?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
};


export type Query_RootProject_Minter_Configurations_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootProject_Ranked_BidsArgs = {
  args: Project_Ranked_Bids_Args;
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Query_RootProject_Ranked_Bids_AggregateArgs = {
  args: Project_Ranked_Bids_Args;
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Query_RootProject_ScriptsArgs = {
  distinct_on?: InputMaybe<Array<Project_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Scripts_Order_By>>;
  where?: InputMaybe<Project_Scripts_Bool_Exp>;
};


export type Query_RootProject_Scripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Scripts_Order_By>>;
  where?: InputMaybe<Project_Scripts_Bool_Exp>;
};


export type Query_RootProject_Scripts_By_PkArgs = {
  index: Scalars['Int']['input'];
  project_id: Scalars['String']['input'];
};


export type Query_RootProject_SeriesArgs = {
  distinct_on?: InputMaybe<Array<Project_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Series_Order_By>>;
  where?: InputMaybe<Project_Series_Bool_Exp>;
};


export type Query_RootProject_Series_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Series_Order_By>>;
  where?: InputMaybe<Project_Series_Bool_Exp>;
};


export type Query_RootProject_Series_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProject_Vertical_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Project_Vertical_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Vertical_Categories_Order_By>>;
  where?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
};


export type Query_RootProject_Vertical_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Vertical_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Vertical_Categories_Order_By>>;
  where?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
};


export type Query_RootProject_Vertical_Categories_By_PkArgs = {
  name: Categories_Enum;
};


export type Query_RootProject_VerticalsArgs = {
  distinct_on?: InputMaybe<Array<Project_Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Verticals_Order_By>>;
  where?: InputMaybe<Project_Verticals_Bool_Exp>;
};


export type Query_RootProject_Verticals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Verticals_Order_By>>;
  where?: InputMaybe<Project_Verticals_Bool_Exp>;
};


export type Query_RootProject_Verticals_By_PkArgs = {
  name: Verticals_Enum;
};


export type Query_RootProjectsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Project_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Project_Filter>;
};


export type Query_RootProjects_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Projects_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Features_Order_By>>;
  where?: InputMaybe<Projects_Features_Bool_Exp>;
};


export type Query_RootProjects_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Features_Order_By>>;
  where?: InputMaybe<Projects_Features_Bool_Exp>;
};


export type Query_RootProjects_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProjects_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Query_RootProjects_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Query_RootProjects_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootProposedArtistAddressesAndSplitArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootProposedArtistAddressesAndSplitsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposedArtistAddressesAndSplit_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProposedArtistAddressesAndSplit_Filter>;
};


export type Query_RootProposed_Artist_Addresses_And_SplitsArgs = {
  distinct_on?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Order_By>>;
  where?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Bool_Exp>;
};


export type Query_RootProposed_Artist_Addresses_And_Splits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Order_By>>;
  where?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Bool_Exp>;
};


export type Query_RootProposed_Artist_Addresses_And_Splits_By_PkArgs = {
  project_id: Scalars['String']['input'];
};


export type Query_RootReceiptArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootReceipt_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


export type Query_RootReceipt_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


export type Query_RootReceipt_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootReceiptsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Receipt_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Receipt_Filter>;
};


export type Query_RootRefresh_Asset_TypesArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Asset_Types_Order_By>>;
  where?: InputMaybe<Refresh_Asset_Types_Bool_Exp>;
};


export type Query_RootRefresh_Asset_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Asset_Types_Order_By>>;
  where?: InputMaybe<Refresh_Asset_Types_Bool_Exp>;
};


export type Query_RootRefresh_Asset_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootRefresh_Request_TypesArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Request_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Request_Types_Order_By>>;
  where?: InputMaybe<Refresh_Request_Types_Bool_Exp>;
};


export type Query_RootRefresh_Request_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Request_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Request_Types_Order_By>>;
  where?: InputMaybe<Refresh_Request_Types_Bool_Exp>;
};


export type Query_RootRefresh_Request_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootRefresh_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Requests_Order_By>>;
  where?: InputMaybe<Refresh_Requests_Bool_Exp>;
};


export type Query_RootRefresh_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Requests_Order_By>>;
  where?: InputMaybe<Refresh_Requests_Bool_Exp>;
};


export type Query_RootRefresh_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRender_TypesArgs = {
  distinct_on?: InputMaybe<Array<Render_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Render_Types_Order_By>>;
  where?: InputMaybe<Render_Types_Bool_Exp>;
};


export type Query_RootRender_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Render_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Render_Types_Order_By>>;
  where?: InputMaybe<Render_Types_Bool_Exp>;
};


export type Query_RootRender_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootRoyaltySplitRecipientArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootRoyaltySplitRecipientsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RoyaltySplitRecipient_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RoyaltySplitRecipient_Filter>;
};


export type Query_RootRoyaltySplitterContractArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootRoyaltySplitterContractsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RoyaltySplitterContract_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RoyaltySplitterContract_Filter>;
};


export type Query_RootRoyalty_Split_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Split_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Split_Recipients_Order_By>>;
  where?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
};


export type Query_RootRoyalty_Split_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Split_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Split_Recipients_Order_By>>;
  where?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
};


export type Query_RootRoyalty_Split_Recipients_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootRoyalty_Splitter_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Splitter_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Splitter_Contracts_Order_By>>;
  where?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
};


export type Query_RootRoyalty_Splitter_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Splitter_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Splitter_Contracts_Order_By>>;
  where?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
};


export type Query_RootRoyalty_Splitter_Contracts_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootSaleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootSaleLookupTableArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootSaleLookupTablesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SaleLookupTable_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SaleLookupTable_Filter>;
};


export type Query_RootSalesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Sale_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Sale_Filter>;
};


export type Query_RootScreeningsArgs = {
  distinct_on?: InputMaybe<Array<Screenings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screenings_Order_By>>;
  where?: InputMaybe<Screenings_Bool_Exp>;
};


export type Query_RootScreenings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Screenings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screenings_Order_By>>;
  where?: InputMaybe<Screenings_Bool_Exp>;
};


export type Query_RootScreenings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSearch_ProjectsArgs = {
  args: Search_Projects_Args;
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Query_RootSearch_Projects_AggregateArgs = {
  args: Search_Projects_Args;
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Query_RootSearch_TagsArgs = {
  args: Search_Tags_Args;
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootSearch_Tags_AggregateArgs = {
  args: Search_Tags_Args;
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootSearch_TokensArgs = {
  args: Search_Tokens_Args;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Query_RootSearch_Tokens_AggregateArgs = {
  args: Search_Tokens_Args;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Query_RootSearch_UsersArgs = {
  args: Search_Users_Args;
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootSearch_Users_AggregateArgs = {
  args: Search_Users_Args;
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootSplitAtomicContractArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootSplitAtomicContractsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SplitAtomicContract_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SplitAtomicContract_Filter>;
};


export type Query_RootSplitAtomicFactoriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SplitAtomicFactory_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SplitAtomicFactory_Filter>;
};


export type Query_RootSplitAtomicFactoryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootSplitAtomicSplitArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootSplitAtomicSplitsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SplitAtomicSplit_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SplitAtomicSplit_Filter>;
};


export type Query_RootSplit_Atomic_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Contracts_Order_By>>;
  where?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
};


export type Query_RootSplit_Atomic_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Contracts_Order_By>>;
  where?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
};


export type Query_RootSplit_Atomic_Contracts_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootSplit_Atomic_FactoriesArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Factories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Factories_Order_By>>;
  where?: InputMaybe<Split_Atomic_Factories_Bool_Exp>;
};


export type Query_RootSplit_Atomic_Factories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Factories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Factories_Order_By>>;
  where?: InputMaybe<Split_Atomic_Factories_Bool_Exp>;
};


export type Query_RootSplit_Atomic_Factories_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootSplit_Payment_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Split_Payment_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Payment_Configurations_Order_By>>;
  where?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
};


export type Query_RootSplit_Payment_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Split_Payment_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Payment_Configurations_Order_By>>;
  where?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
};


export type Query_RootSplit_Payment_Configurations_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootSync_StatusArgs = {
  distinct_on?: InputMaybe<Array<Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sync_Status_Order_By>>;
  where?: InputMaybe<Sync_Status_Bool_Exp>;
};


export type Query_RootSync_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sync_Status_Order_By>>;
  where?: InputMaybe<Sync_Status_Bool_Exp>;
};


export type Query_RootSync_Status_By_PkArgs = {
  id: Scalars['Boolean']['input'];
};


export type Query_RootTag_GroupingsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Groupings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Groupings_Order_By>>;
  where?: InputMaybe<Tag_Groupings_Bool_Exp>;
};


export type Query_RootTag_Groupings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Groupings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Groupings_Order_By>>;
  where?: InputMaybe<Tag_Groupings_Bool_Exp>;
};


export type Query_RootTag_Groupings_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootTag_StatusArgs = {
  distinct_on?: InputMaybe<Array<Tag_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Status_Order_By>>;
  where?: InputMaybe<Tag_Status_Bool_Exp>;
};


export type Query_RootTag_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Status_Order_By>>;
  where?: InputMaybe<Tag_Status_Bool_Exp>;
};


export type Query_RootTag_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTag_TypesArgs = {
  distinct_on?: InputMaybe<Array<Tag_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Types_Order_By>>;
  where?: InputMaybe<Tag_Types_Bool_Exp>;
};


export type Query_RootTag_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Types_Order_By>>;
  where?: InputMaybe<Tag_Types_Bool_Exp>;
};


export type Query_RootTag_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};


export type Query_RootTokens_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Query_RootTokens_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Query_RootTokens_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Transfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Transfer_Filter>;
};


export type Query_RootUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootUser_Profiles_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type Query_RootUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  public_address: Scalars['String']['input'];
};


export type Query_RootVerticalsArgs = {
  distinct_on?: InputMaybe<Array<Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verticals_Order_By>>;
  where?: InputMaybe<Verticals_Bool_Exp>;
};


export type Query_RootVerticals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verticals_Order_By>>;
  where?: InputMaybe<Verticals_Bool_Exp>;
};


export type Query_RootVerticals_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootVideo_Aspect_RatiosArgs = {
  distinct_on?: InputMaybe<Array<Video_Aspect_Ratios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Aspect_Ratios_Order_By>>;
  where?: InputMaybe<Video_Aspect_Ratios_Bool_Exp>;
};


export type Query_RootVideo_Aspect_Ratios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Video_Aspect_Ratios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Aspect_Ratios_Order_By>>;
  where?: InputMaybe<Video_Aspect_Ratios_Bool_Exp>;
};


export type Query_RootVideo_Aspect_Ratios_By_PkArgs = {
  value: Scalars['numeric']['input'];
};


export type Query_RootVideo_Frame_RatesArgs = {
  distinct_on?: InputMaybe<Array<Video_Frame_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Frame_Rates_Order_By>>;
  where?: InputMaybe<Video_Frame_Rates_Bool_Exp>;
};


export type Query_RootVideo_Frame_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Video_Frame_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Frame_Rates_Order_By>>;
  where?: InputMaybe<Video_Frame_Rates_Bool_Exp>;
};


export type Query_RootVideo_Frame_Rates_By_PkArgs = {
  value: Scalars['Int']['input'];
};


export type Query_RootWebflow_Artist_InfoArgs = {
  distinct_on?: InputMaybe<Array<Webflow_Artist_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webflow_Artist_Info_Order_By>>;
  where?: InputMaybe<Webflow_Artist_Info_Bool_Exp>;
};


export type Query_RootWebflow_Artist_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Webflow_Artist_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webflow_Artist_Info_Order_By>>;
  where?: InputMaybe<Webflow_Artist_Info_Bool_Exp>;
};


export type Query_RootWebflow_Artist_Info_By_PkArgs = {
  webflow_item_id: Scalars['String']['input'];
};


export type Query_RootWebflow_Spectrum_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Webflow_Spectrum_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webflow_Spectrum_Articles_Order_By>>;
  where?: InputMaybe<Webflow_Spectrum_Articles_Bool_Exp>;
};


export type Query_RootWebflow_Spectrum_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Webflow_Spectrum_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webflow_Spectrum_Articles_Order_By>>;
  where?: InputMaybe<Webflow_Spectrum_Articles_Bool_Exp>;
};


export type Query_RootWebflow_Spectrum_Articles_By_PkArgs = {
  webflow_item_id: Scalars['String']['input'];
};


export type Query_RootWhitelistingArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_RootWhitelistingsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Whitelisting_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Whitelisting_Filter>;
};

export type Random_Oob_Token_Projects_Metadata_Args = {
  seed?: InputMaybe<Scalars['float8']['input']>;
};

export type Random_Token_Projects_Metadata_Args = {
  seed?: InputMaybe<Scalars['float8']['input']>;
};

/** indexed data from subgraph Receipt entity, used by settlment minters */
export type Receipt_Metadata = {
  __typename?: 'receipt_metadata';
  /** Computed field defining approximate excess settlement funds available to be reclaimed on a given receipt, given latest purchase price on minter. May have minor rounding errors after 15 decimals. */
  excess_settlement_funds?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** An object relationship */
  minter: Minters_Metadata;
  minter_id: Scalars['String']['output'];
  net_posted: Scalars['String']['output'];
  num_purchased: Scalars['String']['output'];
  /** An object relationship */
  project: Projects_Metadata;
  project_id: Scalars['String']['output'];
  /** An object relationship */
  project_minter_configuration?: Maybe<Project_Minter_Configurations>;
  /** An object relationship */
  user: Users;
  user_address: Scalars['String']['output'];
};

/** aggregated selection of "receipt_metadata" */
export type Receipt_Metadata_Aggregate = {
  __typename?: 'receipt_metadata_aggregate';
  aggregate?: Maybe<Receipt_Metadata_Aggregate_Fields>;
  nodes: Array<Receipt_Metadata>;
};

export type Receipt_Metadata_Aggregate_Bool_Exp = {
  count?: InputMaybe<Receipt_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Receipt_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Receipt_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "receipt_metadata" */
export type Receipt_Metadata_Aggregate_Fields = {
  __typename?: 'receipt_metadata_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Receipt_Metadata_Max_Fields>;
  min?: Maybe<Receipt_Metadata_Min_Fields>;
};


/** aggregate fields of "receipt_metadata" */
export type Receipt_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "receipt_metadata" */
export type Receipt_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Receipt_Metadata_Max_Order_By>;
  min?: InputMaybe<Receipt_Metadata_Min_Order_By>;
};

/** input type for inserting array relation for remote table "receipt_metadata" */
export type Receipt_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Receipt_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Receipt_Metadata_On_Conflict>;
};

/** Boolean expression to filter rows from the table "receipt_metadata". All fields are combined with a logical 'AND'. */
export type Receipt_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Receipt_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Receipt_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Receipt_Metadata_Bool_Exp>>;
  excess_settlement_funds?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  minter?: InputMaybe<Minters_Metadata_Bool_Exp>;
  minter_id?: InputMaybe<String_Comparison_Exp>;
  net_posted?: InputMaybe<String_Comparison_Exp>;
  num_purchased?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_minter_configuration?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "receipt_metadata" */
export enum Receipt_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReceiptMetadataPkey = 'receipt_metadata_pkey'
}

/** input type for inserting data into table "receipt_metadata" */
export type Receipt_Metadata_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  minter?: InputMaybe<Minters_Metadata_Obj_Rel_Insert_Input>;
  minter_id?: InputMaybe<Scalars['String']['input']>;
  net_posted?: InputMaybe<Scalars['String']['input']>;
  num_purchased?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_minter_configuration?: InputMaybe<Project_Minter_Configurations_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Receipt_Metadata_Max_Fields = {
  __typename?: 'receipt_metadata_max_fields';
  /** Computed field defining approximate excess settlement funds available to be reclaimed on a given receipt, given latest purchase price on minter. May have minor rounding errors after 15 decimals. */
  excess_settlement_funds?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  minter_id?: Maybe<Scalars['String']['output']>;
  net_posted?: Maybe<Scalars['String']['output']>;
  num_purchased?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "receipt_metadata" */
export type Receipt_Metadata_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  minter_id?: InputMaybe<Order_By>;
  net_posted?: InputMaybe<Order_By>;
  num_purchased?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Receipt_Metadata_Min_Fields = {
  __typename?: 'receipt_metadata_min_fields';
  /** Computed field defining approximate excess settlement funds available to be reclaimed on a given receipt, given latest purchase price on minter. May have minor rounding errors after 15 decimals. */
  excess_settlement_funds?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  minter_id?: Maybe<Scalars['String']['output']>;
  net_posted?: Maybe<Scalars['String']['output']>;
  num_purchased?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "receipt_metadata" */
export type Receipt_Metadata_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  minter_id?: InputMaybe<Order_By>;
  net_posted?: InputMaybe<Order_By>;
  num_purchased?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "receipt_metadata" */
export type Receipt_Metadata_Mutation_Response = {
  __typename?: 'receipt_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Receipt_Metadata>;
};

/** on_conflict condition type for table "receipt_metadata" */
export type Receipt_Metadata_On_Conflict = {
  constraint: Receipt_Metadata_Constraint;
  update_columns?: Array<Receipt_Metadata_Update_Column>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "receipt_metadata". */
export type Receipt_Metadata_Order_By = {
  excess_settlement_funds?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minter?: InputMaybe<Minters_Metadata_Order_By>;
  minter_id?: InputMaybe<Order_By>;
  net_posted?: InputMaybe<Order_By>;
  num_purchased?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_minter_configuration?: InputMaybe<Project_Minter_Configurations_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: receipt_metadata */
export type Receipt_Metadata_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "receipt_metadata" */
export enum Receipt_Metadata_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MinterId = 'minter_id',
  /** column name */
  NetPosted = 'net_posted',
  /** column name */
  NumPurchased = 'num_purchased',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UserAddress = 'user_address'
}

/** input type for updating data in table "receipt_metadata" */
export type Receipt_Metadata_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  minter_id?: InputMaybe<Scalars['String']['input']>;
  net_posted?: InputMaybe<Scalars['String']['input']>;
  num_purchased?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "receipt_metadata" */
export type Receipt_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Receipt_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Receipt_Metadata_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  minter_id?: InputMaybe<Scalars['String']['input']>;
  net_posted?: InputMaybe<Scalars['String']['input']>;
  num_purchased?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "receipt_metadata" */
export enum Receipt_Metadata_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MinterId = 'minter_id',
  /** column name */
  NetPosted = 'net_posted',
  /** column name */
  NumPurchased = 'num_purchased',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UserAddress = 'user_address'
}

export type Receipt_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Receipt_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Receipt_Metadata_Bool_Exp;
};

/** columns and relationships of "refresh_asset_types" */
export type Refresh_Asset_Types = {
  __typename?: 'refresh_asset_types';
  value: Scalars['String']['output'];
};

/** aggregated selection of "refresh_asset_types" */
export type Refresh_Asset_Types_Aggregate = {
  __typename?: 'refresh_asset_types_aggregate';
  aggregate?: Maybe<Refresh_Asset_Types_Aggregate_Fields>;
  nodes: Array<Refresh_Asset_Types>;
};

/** aggregate fields of "refresh_asset_types" */
export type Refresh_Asset_Types_Aggregate_Fields = {
  __typename?: 'refresh_asset_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Refresh_Asset_Types_Max_Fields>;
  min?: Maybe<Refresh_Asset_Types_Min_Fields>;
};


/** aggregate fields of "refresh_asset_types" */
export type Refresh_Asset_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refresh_Asset_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "refresh_asset_types". All fields are combined with a logical 'AND'. */
export type Refresh_Asset_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Refresh_Asset_Types_Bool_Exp>>;
  _not?: InputMaybe<Refresh_Asset_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Refresh_Asset_Types_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "refresh_asset_types" */
export enum Refresh_Asset_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefreshAssetTypesPkey = 'refresh_asset_types_pkey'
}

export enum Refresh_Asset_Types_Enum {
  Image = 'Image',
  None = 'None',
  Video = 'Video'
}

/** Boolean expression to compare columns of type "refresh_asset_types_enum". All fields are combined with logical 'AND'. */
export type Refresh_Asset_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Refresh_Asset_Types_Enum>;
  _in?: InputMaybe<Array<Refresh_Asset_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Refresh_Asset_Types_Enum>;
  _nin?: InputMaybe<Array<Refresh_Asset_Types_Enum>>;
};

/** input type for inserting data into table "refresh_asset_types" */
export type Refresh_Asset_Types_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Refresh_Asset_Types_Max_Fields = {
  __typename?: 'refresh_asset_types_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Refresh_Asset_Types_Min_Fields = {
  __typename?: 'refresh_asset_types_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "refresh_asset_types" */
export type Refresh_Asset_Types_Mutation_Response = {
  __typename?: 'refresh_asset_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refresh_Asset_Types>;
};

/** on_conflict condition type for table "refresh_asset_types" */
export type Refresh_Asset_Types_On_Conflict = {
  constraint: Refresh_Asset_Types_Constraint;
  update_columns?: Array<Refresh_Asset_Types_Update_Column>;
  where?: InputMaybe<Refresh_Asset_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "refresh_asset_types". */
export type Refresh_Asset_Types_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refresh_asset_types */
export type Refresh_Asset_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "refresh_asset_types" */
export enum Refresh_Asset_Types_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "refresh_asset_types" */
export type Refresh_Asset_Types_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "refresh_asset_types" */
export type Refresh_Asset_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refresh_Asset_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refresh_Asset_Types_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "refresh_asset_types" */
export enum Refresh_Asset_Types_Update_Column {
  /** column name */
  Value = 'value'
}

export type Refresh_Asset_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refresh_Asset_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refresh_Asset_Types_Bool_Exp;
};

/** columns and relationships of "refresh_request_types" */
export type Refresh_Request_Types = {
  __typename?: 'refresh_request_types';
  value: Scalars['String']['output'];
};

/** aggregated selection of "refresh_request_types" */
export type Refresh_Request_Types_Aggregate = {
  __typename?: 'refresh_request_types_aggregate';
  aggregate?: Maybe<Refresh_Request_Types_Aggregate_Fields>;
  nodes: Array<Refresh_Request_Types>;
};

/** aggregate fields of "refresh_request_types" */
export type Refresh_Request_Types_Aggregate_Fields = {
  __typename?: 'refresh_request_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Refresh_Request_Types_Max_Fields>;
  min?: Maybe<Refresh_Request_Types_Min_Fields>;
};


/** aggregate fields of "refresh_request_types" */
export type Refresh_Request_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refresh_Request_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "refresh_request_types". All fields are combined with a logical 'AND'. */
export type Refresh_Request_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Refresh_Request_Types_Bool_Exp>>;
  _not?: InputMaybe<Refresh_Request_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Refresh_Request_Types_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "refresh_request_types" */
export enum Refresh_Request_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefreshRequestTypesPkey = 'refresh_request_types_pkey'
}

export enum Refresh_Request_Types_Enum {
  Project = 'Project',
  Token = 'Token'
}

/** Boolean expression to compare columns of type "refresh_request_types_enum". All fields are combined with logical 'AND'. */
export type Refresh_Request_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Refresh_Request_Types_Enum>;
  _in?: InputMaybe<Array<Refresh_Request_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Refresh_Request_Types_Enum>;
  _nin?: InputMaybe<Array<Refresh_Request_Types_Enum>>;
};

/** input type for inserting data into table "refresh_request_types" */
export type Refresh_Request_Types_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Refresh_Request_Types_Max_Fields = {
  __typename?: 'refresh_request_types_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Refresh_Request_Types_Min_Fields = {
  __typename?: 'refresh_request_types_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "refresh_request_types" */
export type Refresh_Request_Types_Mutation_Response = {
  __typename?: 'refresh_request_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refresh_Request_Types>;
};

/** on_conflict condition type for table "refresh_request_types" */
export type Refresh_Request_Types_On_Conflict = {
  constraint: Refresh_Request_Types_Constraint;
  update_columns?: Array<Refresh_Request_Types_Update_Column>;
  where?: InputMaybe<Refresh_Request_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "refresh_request_types". */
export type Refresh_Request_Types_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refresh_request_types */
export type Refresh_Request_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "refresh_request_types" */
export enum Refresh_Request_Types_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "refresh_request_types" */
export type Refresh_Request_Types_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "refresh_request_types" */
export type Refresh_Request_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refresh_Request_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refresh_Request_Types_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "refresh_request_types" */
export enum Refresh_Request_Types_Update_Column {
  /** column name */
  Value = 'value'
}

export type Refresh_Request_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refresh_Request_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refresh_Request_Types_Bool_Exp;
};

/** This table tracks pending & completed requests to refresh the media assets for a project or token. Artists and staff may re-render the .png, .mp4 and .gif files for a collection of NFTs and this table maintains those requests. */
export type Refresh_Requests = {
  __typename?: 'refresh_requests';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  oob: Scalars['Boolean']['output'];
  /** An array relationship */
  processing_jobs: Array<Processing_Jobs>;
  /** An aggregate relationship */
  processing_jobs_aggregate: Processing_Jobs_Aggregate;
  project_id: Scalars['String']['output'];
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
  request_type: Refresh_Request_Types_Enum;
  submitted_at: Scalars['timestamptz']['output'];
  token_ids?: Maybe<Scalars['jsonb']['output']>;
};


/** This table tracks pending & completed requests to refresh the media assets for a project or token. Artists and staff may re-render the .png, .mp4 and .gif files for a collection of NFTs and this table maintains those requests. */
export type Refresh_RequestsProcessing_JobsArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Bool_Exp>;
};


/** This table tracks pending & completed requests to refresh the media assets for a project or token. Artists and staff may re-render the .png, .mp4 and .gif files for a collection of NFTs and this table maintains those requests. */
export type Refresh_RequestsProcessing_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Bool_Exp>;
};


/** This table tracks pending & completed requests to refresh the media assets for a project or token. Artists and staff may re-render the .png, .mp4 and .gif files for a collection of NFTs and this table maintains those requests. */
export type Refresh_RequestsToken_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "refresh_requests" */
export type Refresh_Requests_Aggregate = {
  __typename?: 'refresh_requests_aggregate';
  aggregate?: Maybe<Refresh_Requests_Aggregate_Fields>;
  nodes: Array<Refresh_Requests>;
};

export type Refresh_Requests_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Refresh_Requests_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Refresh_Requests_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Refresh_Requests_Aggregate_Bool_Exp_Count>;
};

export type Refresh_Requests_Aggregate_Bool_Exp_Bool_And = {
  arguments: Refresh_Requests_Select_Column_Refresh_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refresh_Requests_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Refresh_Requests_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Refresh_Requests_Select_Column_Refresh_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refresh_Requests_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Refresh_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Refresh_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refresh_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "refresh_requests" */
export type Refresh_Requests_Aggregate_Fields = {
  __typename?: 'refresh_requests_aggregate_fields';
  avg?: Maybe<Refresh_Requests_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Refresh_Requests_Max_Fields>;
  min?: Maybe<Refresh_Requests_Min_Fields>;
  stddev?: Maybe<Refresh_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Refresh_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Refresh_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Refresh_Requests_Sum_Fields>;
  var_pop?: Maybe<Refresh_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Refresh_Requests_Var_Samp_Fields>;
  variance?: Maybe<Refresh_Requests_Variance_Fields>;
};


/** aggregate fields of "refresh_requests" */
export type Refresh_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refresh_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "refresh_requests" */
export type Refresh_Requests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Refresh_Requests_Max_Order_By>;
  min?: InputMaybe<Refresh_Requests_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Refresh_Requests_Append_Input = {
  token_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "refresh_requests" */
export type Refresh_Requests_Arr_Rel_Insert_Input = {
  data: Array<Refresh_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Refresh_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Refresh_Requests_Avg_Fields = {
  __typename?: 'refresh_requests_avg_fields';
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the table "refresh_requests". All fields are combined with a logical 'AND'. */
export type Refresh_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Refresh_Requests_Bool_Exp>>;
  _not?: InputMaybe<Refresh_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Refresh_Requests_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  oob?: InputMaybe<Boolean_Comparison_Exp>;
  processing_jobs?: InputMaybe<Processing_Jobs_Bool_Exp>;
  processing_jobs_aggregate?: InputMaybe<Processing_Jobs_Aggregate_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  queue_weight?: InputMaybe<Bigint_Comparison_Exp>;
  request_type?: InputMaybe<Refresh_Request_Types_Enum_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  token_ids?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "refresh_requests" */
export enum Refresh_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefreshRequestsPkey = 'refresh_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Refresh_Requests_Delete_At_Path_Input = {
  token_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Refresh_Requests_Delete_Elem_Input = {
  token_ids?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Refresh_Requests_Delete_Key_Input = {
  token_ids?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "refresh_requests" */
export type Refresh_Requests_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  oob?: InputMaybe<Scalars['Boolean']['input']>;
  processing_jobs?: InputMaybe<Processing_Jobs_Arr_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  request_type?: InputMaybe<Refresh_Request_Types_Enum>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  token_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Refresh_Requests_Max_Fields = {
  __typename?: 'refresh_requests_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "refresh_requests" */
export type Refresh_Requests_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Refresh_Requests_Min_Fields = {
  __typename?: 'refresh_requests_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "refresh_requests" */
export type Refresh_Requests_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "refresh_requests" */
export type Refresh_Requests_Mutation_Response = {
  __typename?: 'refresh_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refresh_Requests>;
};

/** on_conflict condition type for table "refresh_requests" */
export type Refresh_Requests_On_Conflict = {
  constraint: Refresh_Requests_Constraint;
  update_columns?: Array<Refresh_Requests_Update_Column>;
  where?: InputMaybe<Refresh_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "refresh_requests". */
export type Refresh_Requests_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oob?: InputMaybe<Order_By>;
  processing_jobs_aggregate?: InputMaybe<Processing_Jobs_Aggregate_Order_By>;
  project_id?: InputMaybe<Order_By>;
  queue_weight?: InputMaybe<Order_By>;
  request_type?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  token_ids?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refresh_requests */
export type Refresh_Requests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Refresh_Requests_Prepend_Input = {
  token_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "refresh_requests" */
export enum Refresh_Requests_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Oob = 'oob',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RequestType = 'request_type',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  TokenIds = 'token_ids'
}

/** select "refresh_requests_aggregate_bool_exp_bool_and_arguments_columns" columns of table "refresh_requests" */
export enum Refresh_Requests_Select_Column_Refresh_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Oob = 'oob'
}

/** select "refresh_requests_aggregate_bool_exp_bool_or_arguments_columns" columns of table "refresh_requests" */
export enum Refresh_Requests_Select_Column_Refresh_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Oob = 'oob'
}

/** input type for updating data in table "refresh_requests" */
export type Refresh_Requests_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  oob?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  request_type?: InputMaybe<Refresh_Request_Types_Enum>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  token_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Refresh_Requests_Stddev_Fields = {
  __typename?: 'refresh_requests_stddev_fields';
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate stddev_pop on columns */
export type Refresh_Requests_Stddev_Pop_Fields = {
  __typename?: 'refresh_requests_stddev_pop_fields';
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate stddev_samp on columns */
export type Refresh_Requests_Stddev_Samp_Fields = {
  __typename?: 'refresh_requests_stddev_samp_fields';
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
};

/** Streaming cursor of the table "refresh_requests" */
export type Refresh_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refresh_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refresh_Requests_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  oob?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  request_type?: InputMaybe<Refresh_Request_Types_Enum>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  token_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Refresh_Requests_Sum_Fields = {
  __typename?: 'refresh_requests_sum_fields';
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "refresh_requests" */
export enum Refresh_Requests_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  Id = 'id',
  /** column name */
  Oob = 'oob',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  RequestType = 'request_type',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  TokenIds = 'token_ids'
}

export type Refresh_Requests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Refresh_Requests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Refresh_Requests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Refresh_Requests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Refresh_Requests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Refresh_Requests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refresh_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refresh_Requests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Refresh_Requests_Var_Pop_Fields = {
  __typename?: 'refresh_requests_var_pop_fields';
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_samp on columns */
export type Refresh_Requests_Var_Samp_Fields = {
  __typename?: 'refresh_requests_var_samp_fields';
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate variance on columns */
export type Refresh_Requests_Variance_Fields = {
  __typename?: 'refresh_requests_variance_fields';
  /** A computed field, executes function "refresh_requests_queue_weight" */
  queue_weight?: Maybe<Scalars['bigint']['output']>;
};

/** columns and relationships of "render_types" */
export type Render_Types = {
  __typename?: 'render_types';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "render_types" */
export type Render_Types_Aggregate = {
  __typename?: 'render_types_aggregate';
  aggregate?: Maybe<Render_Types_Aggregate_Fields>;
  nodes: Array<Render_Types>;
};

/** aggregate fields of "render_types" */
export type Render_Types_Aggregate_Fields = {
  __typename?: 'render_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Render_Types_Max_Fields>;
  min?: Maybe<Render_Types_Min_Fields>;
};


/** aggregate fields of "render_types" */
export type Render_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Render_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "render_types". All fields are combined with a logical 'AND'. */
export type Render_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Render_Types_Bool_Exp>>;
  _not?: InputMaybe<Render_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Render_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "render_types" */
export enum Render_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  RenderTypesPkey = 'render_types_pkey',
  /** unique or primary key constraint on columns "label" */
  VideoRenderTypesLabelKey = 'video_render_types_label_key'
}

export enum Render_Types_Enum {
  /** gif */
  Gif = 'gif',
  /** png */
  Image = 'image',
  /** generator live view */
  Live = 'live',
  /** mp4 */
  Video = 'video'
}

/** Boolean expression to compare columns of type "render_types_enum". All fields are combined with logical 'AND'. */
export type Render_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Render_Types_Enum>;
  _in?: InputMaybe<Array<Render_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Render_Types_Enum>;
  _nin?: InputMaybe<Array<Render_Types_Enum>>;
};

/** input type for inserting data into table "render_types" */
export type Render_Types_Insert_Input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Render_Types_Max_Fields = {
  __typename?: 'render_types_max_fields';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Render_Types_Min_Fields = {
  __typename?: 'render_types_min_fields';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "render_types" */
export type Render_Types_Mutation_Response = {
  __typename?: 'render_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Render_Types>;
};

/** on_conflict condition type for table "render_types" */
export type Render_Types_On_Conflict = {
  constraint: Render_Types_Constraint;
  update_columns?: Array<Render_Types_Update_Column>;
  where?: InputMaybe<Render_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "render_types". */
export type Render_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: render_types */
export type Render_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "render_types" */
export enum Render_Types_Select_Column {
  /** column name */
  Label = 'label',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "render_types" */
export type Render_Types_Set_Input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "render_types" */
export type Render_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Render_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Render_Types_Stream_Cursor_Value_Input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "render_types" */
export enum Render_Types_Update_Column {
  /** column name */
  Label = 'label',
  /** column name */
  Value = 'value'
}

export type Render_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Render_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Render_Types_Bool_Exp;
};

/** Entries that represent individual splitter recipients from royalty_splitter_contract entries. */
export type Royalty_Split_Recipients = {
  __typename?: 'royalty_split_recipients';
  allocation: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  recipient_address: Scalars['String']['output'];
  /** An object relationship */
  royalty_splitter_contract: Royalty_Splitter_Contracts;
  royalty_splitter_contract_address: Scalars['String']['output'];
};

/** aggregated selection of "royalty_split_recipients" */
export type Royalty_Split_Recipients_Aggregate = {
  __typename?: 'royalty_split_recipients_aggregate';
  aggregate?: Maybe<Royalty_Split_Recipients_Aggregate_Fields>;
  nodes: Array<Royalty_Split_Recipients>;
};

export type Royalty_Split_Recipients_Aggregate_Bool_Exp = {
  count?: InputMaybe<Royalty_Split_Recipients_Aggregate_Bool_Exp_Count>;
};

export type Royalty_Split_Recipients_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Royalty_Split_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "royalty_split_recipients" */
export type Royalty_Split_Recipients_Aggregate_Fields = {
  __typename?: 'royalty_split_recipients_aggregate_fields';
  avg?: Maybe<Royalty_Split_Recipients_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Royalty_Split_Recipients_Max_Fields>;
  min?: Maybe<Royalty_Split_Recipients_Min_Fields>;
  stddev?: Maybe<Royalty_Split_Recipients_Stddev_Fields>;
  stddev_pop?: Maybe<Royalty_Split_Recipients_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Royalty_Split_Recipients_Stddev_Samp_Fields>;
  sum?: Maybe<Royalty_Split_Recipients_Sum_Fields>;
  var_pop?: Maybe<Royalty_Split_Recipients_Var_Pop_Fields>;
  var_samp?: Maybe<Royalty_Split_Recipients_Var_Samp_Fields>;
  variance?: Maybe<Royalty_Split_Recipients_Variance_Fields>;
};


/** aggregate fields of "royalty_split_recipients" */
export type Royalty_Split_Recipients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Royalty_Split_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Aggregate_Order_By = {
  avg?: InputMaybe<Royalty_Split_Recipients_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Royalty_Split_Recipients_Max_Order_By>;
  min?: InputMaybe<Royalty_Split_Recipients_Min_Order_By>;
  stddev?: InputMaybe<Royalty_Split_Recipients_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Royalty_Split_Recipients_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Royalty_Split_Recipients_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Royalty_Split_Recipients_Sum_Order_By>;
  var_pop?: InputMaybe<Royalty_Split_Recipients_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Royalty_Split_Recipients_Var_Samp_Order_By>;
  variance?: InputMaybe<Royalty_Split_Recipients_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Arr_Rel_Insert_Input = {
  data: Array<Royalty_Split_Recipients_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Royalty_Split_Recipients_On_Conflict>;
};

/** aggregate avg on columns */
export type Royalty_Split_Recipients_Avg_Fields = {
  __typename?: 'royalty_split_recipients_avg_fields';
  allocation?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Avg_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "royalty_split_recipients". All fields are combined with a logical 'AND'. */
export type Royalty_Split_Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Royalty_Split_Recipients_Bool_Exp>>;
  _not?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
  _or?: InputMaybe<Array<Royalty_Split_Recipients_Bool_Exp>>;
  allocation?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  recipient_address?: InputMaybe<String_Comparison_Exp>;
  royalty_splitter_contract?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
  royalty_splitter_contract_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "royalty_split_recipients" */
export enum Royalty_Split_Recipients_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoyaltySplitRecipientsPkey = 'royalty_split_recipients_pkey'
}

/** input type for incrementing numeric columns in table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Inc_Input = {
  allocation?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Insert_Input = {
  allocation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  recipient_address?: InputMaybe<Scalars['String']['input']>;
  royalty_splitter_contract?: InputMaybe<Royalty_Splitter_Contracts_Obj_Rel_Insert_Input>;
  royalty_splitter_contract_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Royalty_Split_Recipients_Max_Fields = {
  __typename?: 'royalty_split_recipients_max_fields';
  allocation?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  recipient_address?: Maybe<Scalars['String']['output']>;
  royalty_splitter_contract_address?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Max_Order_By = {
  allocation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipient_address?: InputMaybe<Order_By>;
  royalty_splitter_contract_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Royalty_Split_Recipients_Min_Fields = {
  __typename?: 'royalty_split_recipients_min_fields';
  allocation?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  recipient_address?: Maybe<Scalars['String']['output']>;
  royalty_splitter_contract_address?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Min_Order_By = {
  allocation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipient_address?: InputMaybe<Order_By>;
  royalty_splitter_contract_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Mutation_Response = {
  __typename?: 'royalty_split_recipients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Royalty_Split_Recipients>;
};

/** on_conflict condition type for table "royalty_split_recipients" */
export type Royalty_Split_Recipients_On_Conflict = {
  constraint: Royalty_Split_Recipients_Constraint;
  update_columns?: Array<Royalty_Split_Recipients_Update_Column>;
  where?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
};

/** Ordering options when selecting data from "royalty_split_recipients". */
export type Royalty_Split_Recipients_Order_By = {
  allocation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipient_address?: InputMaybe<Order_By>;
  royalty_splitter_contract?: InputMaybe<Royalty_Splitter_Contracts_Order_By>;
  royalty_splitter_contract_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: royalty_split_recipients */
export type Royalty_Split_Recipients_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "royalty_split_recipients" */
export enum Royalty_Split_Recipients_Select_Column {
  /** column name */
  Allocation = 'allocation',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientAddress = 'recipient_address',
  /** column name */
  RoyaltySplitterContractAddress = 'royalty_splitter_contract_address'
}

/** input type for updating data in table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Set_Input = {
  allocation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  recipient_address?: InputMaybe<Scalars['String']['input']>;
  royalty_splitter_contract_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Royalty_Split_Recipients_Stddev_Fields = {
  __typename?: 'royalty_split_recipients_stddev_fields';
  allocation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Stddev_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Royalty_Split_Recipients_Stddev_Pop_Fields = {
  __typename?: 'royalty_split_recipients_stddev_pop_fields';
  allocation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Stddev_Pop_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Royalty_Split_Recipients_Stddev_Samp_Fields = {
  __typename?: 'royalty_split_recipients_stddev_samp_fields';
  allocation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Stddev_Samp_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Royalty_Split_Recipients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Royalty_Split_Recipients_Stream_Cursor_Value_Input = {
  allocation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  recipient_address?: InputMaybe<Scalars['String']['input']>;
  royalty_splitter_contract_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Royalty_Split_Recipients_Sum_Fields = {
  __typename?: 'royalty_split_recipients_sum_fields';
  allocation?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Sum_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** update columns of table "royalty_split_recipients" */
export enum Royalty_Split_Recipients_Update_Column {
  /** column name */
  Allocation = 'allocation',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientAddress = 'recipient_address',
  /** column name */
  RoyaltySplitterContractAddress = 'royalty_splitter_contract_address'
}

export type Royalty_Split_Recipients_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Royalty_Split_Recipients_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Royalty_Split_Recipients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Royalty_Split_Recipients_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Royalty_Split_Recipients_Var_Pop_Fields = {
  __typename?: 'royalty_split_recipients_var_pop_fields';
  allocation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Var_Pop_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Royalty_Split_Recipients_Var_Samp_Fields = {
  __typename?: 'royalty_split_recipients_var_samp_fields';
  allocation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Var_Samp_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Royalty_Split_Recipients_Variance_Fields = {
  __typename?: 'royalty_split_recipients_variance_fields';
  allocation?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "royalty_split_recipients" */
export type Royalty_Split_Recipients_Variance_Order_By = {
  allocation?: InputMaybe<Order_By>;
};

/** table containing secondary royalty splitter contracts used by core contracts */
export type Royalty_Splitter_Contracts = {
  __typename?: 'royalty_splitter_contracts';
  address: Scalars['String']['output'];
  /** An object relationship */
  core_contract: Contracts_Metadata;
  core_contract_address: Scalars['String']['output'];
  /** An array relationship */
  royalty_split_recipients: Array<Royalty_Split_Recipients>;
  /** An aggregate relationship */
  royalty_split_recipients_aggregate: Royalty_Split_Recipients_Aggregate;
  split_provider_creator: Scalars['String']['output'];
  total_allocation: Scalars['Int']['output'];
};


/** table containing secondary royalty splitter contracts used by core contracts */
export type Royalty_Splitter_ContractsRoyalty_Split_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Split_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Split_Recipients_Order_By>>;
  where?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
};


/** table containing secondary royalty splitter contracts used by core contracts */
export type Royalty_Splitter_ContractsRoyalty_Split_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Split_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Split_Recipients_Order_By>>;
  where?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
};

/** aggregated selection of "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Aggregate = {
  __typename?: 'royalty_splitter_contracts_aggregate';
  aggregate?: Maybe<Royalty_Splitter_Contracts_Aggregate_Fields>;
  nodes: Array<Royalty_Splitter_Contracts>;
};

/** aggregate fields of "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Aggregate_Fields = {
  __typename?: 'royalty_splitter_contracts_aggregate_fields';
  avg?: Maybe<Royalty_Splitter_Contracts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Royalty_Splitter_Contracts_Max_Fields>;
  min?: Maybe<Royalty_Splitter_Contracts_Min_Fields>;
  stddev?: Maybe<Royalty_Splitter_Contracts_Stddev_Fields>;
  stddev_pop?: Maybe<Royalty_Splitter_Contracts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Royalty_Splitter_Contracts_Stddev_Samp_Fields>;
  sum?: Maybe<Royalty_Splitter_Contracts_Sum_Fields>;
  var_pop?: Maybe<Royalty_Splitter_Contracts_Var_Pop_Fields>;
  var_samp?: Maybe<Royalty_Splitter_Contracts_Var_Samp_Fields>;
  variance?: Maybe<Royalty_Splitter_Contracts_Variance_Fields>;
};


/** aggregate fields of "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Royalty_Splitter_Contracts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Royalty_Splitter_Contracts_Avg_Fields = {
  __typename?: 'royalty_splitter_contracts_avg_fields';
  total_allocation?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "royalty_splitter_contracts". All fields are combined with a logical 'AND'. */
export type Royalty_Splitter_Contracts_Bool_Exp = {
  _and?: InputMaybe<Array<Royalty_Splitter_Contracts_Bool_Exp>>;
  _not?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
  _or?: InputMaybe<Array<Royalty_Splitter_Contracts_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  core_contract?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  core_contract_address?: InputMaybe<String_Comparison_Exp>;
  royalty_split_recipients?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
  royalty_split_recipients_aggregate?: InputMaybe<Royalty_Split_Recipients_Aggregate_Bool_Exp>;
  split_provider_creator?: InputMaybe<String_Comparison_Exp>;
  total_allocation?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "royalty_splitter_contracts" */
export enum Royalty_Splitter_Contracts_Constraint {
  /** unique or primary key constraint on columns "address" */
  RoyaltySplitterContractsPkey = 'royalty_splitter_contracts_pkey'
}

/** input type for incrementing numeric columns in table "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Inc_Input = {
  total_allocation?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_contract?: InputMaybe<Contracts_Metadata_Obj_Rel_Insert_Input>;
  core_contract_address?: InputMaybe<Scalars['String']['input']>;
  royalty_split_recipients?: InputMaybe<Royalty_Split_Recipients_Arr_Rel_Insert_Input>;
  split_provider_creator?: InputMaybe<Scalars['String']['input']>;
  total_allocation?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Royalty_Splitter_Contracts_Max_Fields = {
  __typename?: 'royalty_splitter_contracts_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  core_contract_address?: Maybe<Scalars['String']['output']>;
  split_provider_creator?: Maybe<Scalars['String']['output']>;
  total_allocation?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Royalty_Splitter_Contracts_Min_Fields = {
  __typename?: 'royalty_splitter_contracts_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  core_contract_address?: Maybe<Scalars['String']['output']>;
  split_provider_creator?: Maybe<Scalars['String']['output']>;
  total_allocation?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Mutation_Response = {
  __typename?: 'royalty_splitter_contracts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Royalty_Splitter_Contracts>;
};

/** input type for inserting object relation for remote table "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Obj_Rel_Insert_Input = {
  data: Royalty_Splitter_Contracts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Royalty_Splitter_Contracts_On_Conflict>;
};

/** on_conflict condition type for table "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_On_Conflict = {
  constraint: Royalty_Splitter_Contracts_Constraint;
  update_columns?: Array<Royalty_Splitter_Contracts_Update_Column>;
  where?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
};

/** Ordering options when selecting data from "royalty_splitter_contracts". */
export type Royalty_Splitter_Contracts_Order_By = {
  address?: InputMaybe<Order_By>;
  core_contract?: InputMaybe<Contracts_Metadata_Order_By>;
  core_contract_address?: InputMaybe<Order_By>;
  royalty_split_recipients_aggregate?: InputMaybe<Royalty_Split_Recipients_Aggregate_Order_By>;
  split_provider_creator?: InputMaybe<Order_By>;
  total_allocation?: InputMaybe<Order_By>;
};

/** primary key columns input for table: royalty_splitter_contracts */
export type Royalty_Splitter_Contracts_Pk_Columns_Input = {
  address: Scalars['String']['input'];
};

/** select columns of table "royalty_splitter_contracts" */
export enum Royalty_Splitter_Contracts_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CoreContractAddress = 'core_contract_address',
  /** column name */
  SplitProviderCreator = 'split_provider_creator',
  /** column name */
  TotalAllocation = 'total_allocation'
}

/** input type for updating data in table "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_contract_address?: InputMaybe<Scalars['String']['input']>;
  split_provider_creator?: InputMaybe<Scalars['String']['input']>;
  total_allocation?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Royalty_Splitter_Contracts_Stddev_Fields = {
  __typename?: 'royalty_splitter_contracts_stddev_fields';
  total_allocation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Royalty_Splitter_Contracts_Stddev_Pop_Fields = {
  __typename?: 'royalty_splitter_contracts_stddev_pop_fields';
  total_allocation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Royalty_Splitter_Contracts_Stddev_Samp_Fields = {
  __typename?: 'royalty_splitter_contracts_stddev_samp_fields';
  total_allocation?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "royalty_splitter_contracts" */
export type Royalty_Splitter_Contracts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Royalty_Splitter_Contracts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Royalty_Splitter_Contracts_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  core_contract_address?: InputMaybe<Scalars['String']['input']>;
  split_provider_creator?: InputMaybe<Scalars['String']['input']>;
  total_allocation?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Royalty_Splitter_Contracts_Sum_Fields = {
  __typename?: 'royalty_splitter_contracts_sum_fields';
  total_allocation?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "royalty_splitter_contracts" */
export enum Royalty_Splitter_Contracts_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CoreContractAddress = 'core_contract_address',
  /** column name */
  SplitProviderCreator = 'split_provider_creator',
  /** column name */
  TotalAllocation = 'total_allocation'
}

export type Royalty_Splitter_Contracts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Royalty_Splitter_Contracts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Royalty_Splitter_Contracts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Royalty_Splitter_Contracts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Royalty_Splitter_Contracts_Var_Pop_Fields = {
  __typename?: 'royalty_splitter_contracts_var_pop_fields';
  total_allocation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Royalty_Splitter_Contracts_Var_Samp_Fields = {
  __typename?: 'royalty_splitter_contracts_var_samp_fields';
  total_allocation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Royalty_Splitter_Contracts_Variance_Fields = {
  __typename?: 'royalty_splitter_contracts_variance_fields';
  total_allocation?: Maybe<Scalars['Float']['output']>;
};

/** This is the results of the wallet and ip screenings we've performed */
export type Screenings = {
  __typename?: 'screenings';
  blocked: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  /** A computed field, that runs the "screening_is_valid" function that calculates if the attached screening is still valid. */
  is_valid?: Maybe<Scalars['Boolean']['output']>;
  last_checked: Scalars['timestamptz']['output'];
  wallet_address?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "screenings" */
export type Screenings_Aggregate = {
  __typename?: 'screenings_aggregate';
  aggregate?: Maybe<Screenings_Aggregate_Fields>;
  nodes: Array<Screenings>;
};

/** aggregate fields of "screenings" */
export type Screenings_Aggregate_Fields = {
  __typename?: 'screenings_aggregate_fields';
  avg?: Maybe<Screenings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Screenings_Max_Fields>;
  min?: Maybe<Screenings_Min_Fields>;
  stddev?: Maybe<Screenings_Stddev_Fields>;
  stddev_pop?: Maybe<Screenings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Screenings_Stddev_Samp_Fields>;
  sum?: Maybe<Screenings_Sum_Fields>;
  var_pop?: Maybe<Screenings_Var_Pop_Fields>;
  var_samp?: Maybe<Screenings_Var_Samp_Fields>;
  variance?: Maybe<Screenings_Variance_Fields>;
};


/** aggregate fields of "screenings" */
export type Screenings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Screenings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Screenings_Avg_Fields = {
  __typename?: 'screenings_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "screenings". All fields are combined with a logical 'AND'. */
export type Screenings_Bool_Exp = {
  _and?: InputMaybe<Array<Screenings_Bool_Exp>>;
  _not?: InputMaybe<Screenings_Bool_Exp>;
  _or?: InputMaybe<Array<Screenings_Bool_Exp>>;
  blocked?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  is_valid?: InputMaybe<Boolean_Comparison_Exp>;
  last_checked?: InputMaybe<Timestamptz_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "screenings" */
export enum Screenings_Constraint {
  /** unique or primary key constraint on columns "ip_address" */
  ScreeningsIpAddressKey = 'screenings_ip_address_key',
  /** unique or primary key constraint on columns "id" */
  ScreeningsPkey = 'screenings_pkey',
  /** unique or primary key constraint on columns "wallet_address" */
  ScreeningsWalletAddressKey = 'screenings_wallet_address_key'
}

/** input type for incrementing numeric columns in table "screenings" */
export type Screenings_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "screenings" */
export type Screenings_Insert_Input = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  last_checked?: InputMaybe<Scalars['timestamptz']['input']>;
  wallet_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Screenings_Max_Fields = {
  __typename?: 'screenings_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  last_checked?: Maybe<Scalars['timestamptz']['output']>;
  wallet_address?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Screenings_Min_Fields = {
  __typename?: 'screenings_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  last_checked?: Maybe<Scalars['timestamptz']['output']>;
  wallet_address?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "screenings" */
export type Screenings_Mutation_Response = {
  __typename?: 'screenings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Screenings>;
};

/** on_conflict condition type for table "screenings" */
export type Screenings_On_Conflict = {
  constraint: Screenings_Constraint;
  update_columns?: Array<Screenings_Update_Column>;
  where?: InputMaybe<Screenings_Bool_Exp>;
};

/** Ordering options when selecting data from "screenings". */
export type Screenings_Order_By = {
  blocked?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  is_valid?: InputMaybe<Order_By>;
  last_checked?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: screenings */
export type Screenings_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "screenings" */
export enum Screenings_Select_Column {
  /** column name */
  Blocked = 'blocked',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  LastChecked = 'last_checked',
  /** column name */
  WalletAddress = 'wallet_address'
}

/** input type for updating data in table "screenings" */
export type Screenings_Set_Input = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  last_checked?: InputMaybe<Scalars['timestamptz']['input']>;
  wallet_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Screenings_Stddev_Fields = {
  __typename?: 'screenings_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Screenings_Stddev_Pop_Fields = {
  __typename?: 'screenings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Screenings_Stddev_Samp_Fields = {
  __typename?: 'screenings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "screenings" */
export type Screenings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Screenings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Screenings_Stream_Cursor_Value_Input = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  last_checked?: InputMaybe<Scalars['timestamptz']['input']>;
  wallet_address?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Screenings_Sum_Fields = {
  __typename?: 'screenings_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "screenings" */
export enum Screenings_Update_Column {
  /** column name */
  Blocked = 'blocked',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  LastChecked = 'last_checked',
  /** column name */
  WalletAddress = 'wallet_address'
}

export type Screenings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Screenings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Screenings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Screenings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Screenings_Var_Pop_Fields = {
  __typename?: 'screenings_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Screenings_Var_Samp_Fields = {
  __typename?: 'screenings_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Screenings_Variance_Fields = {
  __typename?: 'screenings_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Search_Projects_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Tags_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Tokens_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Users_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Table for all indexed split atomic contracts */
export type Split_Atomic_Contracts = {
  __typename?: 'split_atomic_contracts';
  address: Scalars['String']['output'];
  implementation: Scalars['String']['output'];
  split_atomic_factory: Scalars['String']['output'];
  /** An array relationship */
  splits: Array<Split_Payment_Configurations>;
  /** An aggregate relationship */
  splits_aggregate: Split_Payment_Configurations_Aggregate;
  type: Scalars['String']['output'];
};


/** Table for all indexed split atomic contracts */
export type Split_Atomic_ContractsSplitsArgs = {
  distinct_on?: InputMaybe<Array<Split_Payment_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Payment_Configurations_Order_By>>;
  where?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
};


/** Table for all indexed split atomic contracts */
export type Split_Atomic_ContractsSplits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Split_Payment_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Payment_Configurations_Order_By>>;
  where?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
};

/** aggregated selection of "split_atomic_contracts" */
export type Split_Atomic_Contracts_Aggregate = {
  __typename?: 'split_atomic_contracts_aggregate';
  aggregate?: Maybe<Split_Atomic_Contracts_Aggregate_Fields>;
  nodes: Array<Split_Atomic_Contracts>;
};

export type Split_Atomic_Contracts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Split_Atomic_Contracts_Aggregate_Bool_Exp_Count>;
};

export type Split_Atomic_Contracts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Split_Atomic_Contracts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "split_atomic_contracts" */
export type Split_Atomic_Contracts_Aggregate_Fields = {
  __typename?: 'split_atomic_contracts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Split_Atomic_Contracts_Max_Fields>;
  min?: Maybe<Split_Atomic_Contracts_Min_Fields>;
};


/** aggregate fields of "split_atomic_contracts" */
export type Split_Atomic_Contracts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Split_Atomic_Contracts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Split_Atomic_Contracts_Max_Order_By>;
  min?: InputMaybe<Split_Atomic_Contracts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Arr_Rel_Insert_Input = {
  data: Array<Split_Atomic_Contracts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Split_Atomic_Contracts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "split_atomic_contracts". All fields are combined with a logical 'AND'. */
export type Split_Atomic_Contracts_Bool_Exp = {
  _and?: InputMaybe<Array<Split_Atomic_Contracts_Bool_Exp>>;
  _not?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
  _or?: InputMaybe<Array<Split_Atomic_Contracts_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  implementation?: InputMaybe<String_Comparison_Exp>;
  split_atomic_factory?: InputMaybe<String_Comparison_Exp>;
  splits?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
  splits_aggregate?: InputMaybe<Split_Payment_Configurations_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "split_atomic_contracts" */
export enum Split_Atomic_Contracts_Constraint {
  /** unique or primary key constraint on columns "address" */
  SplitAtomicContractsPkey = 'split_atomic_contracts_pkey'
}

/** input type for inserting data into table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  implementation?: InputMaybe<Scalars['String']['input']>;
  split_atomic_factory?: InputMaybe<Scalars['String']['input']>;
  splits?: InputMaybe<Split_Payment_Configurations_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Split_Atomic_Contracts_Max_Fields = {
  __typename?: 'split_atomic_contracts_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  implementation?: Maybe<Scalars['String']['output']>;
  split_atomic_factory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  implementation?: InputMaybe<Order_By>;
  split_atomic_factory?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Split_Atomic_Contracts_Min_Fields = {
  __typename?: 'split_atomic_contracts_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  implementation?: Maybe<Scalars['String']['output']>;
  split_atomic_factory?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  implementation?: InputMaybe<Order_By>;
  split_atomic_factory?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Mutation_Response = {
  __typename?: 'split_atomic_contracts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Split_Atomic_Contracts>;
};

/** input type for inserting object relation for remote table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Obj_Rel_Insert_Input = {
  data: Split_Atomic_Contracts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Split_Atomic_Contracts_On_Conflict>;
};

/** on_conflict condition type for table "split_atomic_contracts" */
export type Split_Atomic_Contracts_On_Conflict = {
  constraint: Split_Atomic_Contracts_Constraint;
  update_columns?: Array<Split_Atomic_Contracts_Update_Column>;
  where?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
};

/** Ordering options when selecting data from "split_atomic_contracts". */
export type Split_Atomic_Contracts_Order_By = {
  address?: InputMaybe<Order_By>;
  implementation?: InputMaybe<Order_By>;
  split_atomic_factory?: InputMaybe<Order_By>;
  splits_aggregate?: InputMaybe<Split_Payment_Configurations_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: split_atomic_contracts */
export type Split_Atomic_Contracts_Pk_Columns_Input = {
  address: Scalars['String']['input'];
};

/** select columns of table "split_atomic_contracts" */
export enum Split_Atomic_Contracts_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Implementation = 'implementation',
  /** column name */
  SplitAtomicFactory = 'split_atomic_factory',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  implementation?: InputMaybe<Scalars['String']['input']>;
  split_atomic_factory?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "split_atomic_contracts" */
export type Split_Atomic_Contracts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Split_Atomic_Contracts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Split_Atomic_Contracts_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  implementation?: InputMaybe<Scalars['String']['input']>;
  split_atomic_factory?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "split_atomic_contracts" */
export enum Split_Atomic_Contracts_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Implementation = 'implementation',
  /** column name */
  SplitAtomicFactory = 'split_atomic_factory',
  /** column name */
  Type = 'type'
}

export type Split_Atomic_Contracts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Split_Atomic_Contracts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Split_Atomic_Contracts_Bool_Exp;
};

/** Contains all indexed split atomic factory contracts */
export type Split_Atomic_Factories = {
  __typename?: 'split_atomic_factories';
  abandoned: Scalars['Boolean']['output'];
  address: Scalars['String']['output'];
  implementation: Scalars['String']['output'];
  required_split_address?: Maybe<Scalars['String']['output']>;
  required_split_basis_points?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  split_atomic_contracts: Array<Split_Atomic_Contracts>;
  /** An aggregate relationship */
  split_atomic_contracts_aggregate: Split_Atomic_Contracts_Aggregate;
  type: Scalars['String']['output'];
};


/** Contains all indexed split atomic factory contracts */
export type Split_Atomic_FactoriesSplit_Atomic_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Contracts_Order_By>>;
  where?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
};


/** Contains all indexed split atomic factory contracts */
export type Split_Atomic_FactoriesSplit_Atomic_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Contracts_Order_By>>;
  where?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
};

/** aggregated selection of "split_atomic_factories" */
export type Split_Atomic_Factories_Aggregate = {
  __typename?: 'split_atomic_factories_aggregate';
  aggregate?: Maybe<Split_Atomic_Factories_Aggregate_Fields>;
  nodes: Array<Split_Atomic_Factories>;
};

/** aggregate fields of "split_atomic_factories" */
export type Split_Atomic_Factories_Aggregate_Fields = {
  __typename?: 'split_atomic_factories_aggregate_fields';
  avg?: Maybe<Split_Atomic_Factories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Split_Atomic_Factories_Max_Fields>;
  min?: Maybe<Split_Atomic_Factories_Min_Fields>;
  stddev?: Maybe<Split_Atomic_Factories_Stddev_Fields>;
  stddev_pop?: Maybe<Split_Atomic_Factories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Split_Atomic_Factories_Stddev_Samp_Fields>;
  sum?: Maybe<Split_Atomic_Factories_Sum_Fields>;
  var_pop?: Maybe<Split_Atomic_Factories_Var_Pop_Fields>;
  var_samp?: Maybe<Split_Atomic_Factories_Var_Samp_Fields>;
  variance?: Maybe<Split_Atomic_Factories_Variance_Fields>;
};


/** aggregate fields of "split_atomic_factories" */
export type Split_Atomic_Factories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Split_Atomic_Factories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Split_Atomic_Factories_Avg_Fields = {
  __typename?: 'split_atomic_factories_avg_fields';
  required_split_basis_points?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "split_atomic_factories". All fields are combined with a logical 'AND'. */
export type Split_Atomic_Factories_Bool_Exp = {
  _and?: InputMaybe<Array<Split_Atomic_Factories_Bool_Exp>>;
  _not?: InputMaybe<Split_Atomic_Factories_Bool_Exp>;
  _or?: InputMaybe<Array<Split_Atomic_Factories_Bool_Exp>>;
  abandoned?: InputMaybe<Boolean_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  implementation?: InputMaybe<String_Comparison_Exp>;
  required_split_address?: InputMaybe<String_Comparison_Exp>;
  required_split_basis_points?: InputMaybe<Numeric_Comparison_Exp>;
  split_atomic_contracts?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
  split_atomic_contracts_aggregate?: InputMaybe<Split_Atomic_Contracts_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "split_atomic_factories" */
export enum Split_Atomic_Factories_Constraint {
  /** unique or primary key constraint on columns "address" */
  SplitAtomicFactoriesPkey = 'split_atomic_factories_pkey'
}

/** input type for incrementing numeric columns in table "split_atomic_factories" */
export type Split_Atomic_Factories_Inc_Input = {
  required_split_basis_points?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "split_atomic_factories" */
export type Split_Atomic_Factories_Insert_Input = {
  abandoned?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  implementation?: InputMaybe<Scalars['String']['input']>;
  required_split_address?: InputMaybe<Scalars['String']['input']>;
  required_split_basis_points?: InputMaybe<Scalars['numeric']['input']>;
  split_atomic_contracts?: InputMaybe<Split_Atomic_Contracts_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Split_Atomic_Factories_Max_Fields = {
  __typename?: 'split_atomic_factories_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  implementation?: Maybe<Scalars['String']['output']>;
  required_split_address?: Maybe<Scalars['String']['output']>;
  required_split_basis_points?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Split_Atomic_Factories_Min_Fields = {
  __typename?: 'split_atomic_factories_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  implementation?: Maybe<Scalars['String']['output']>;
  required_split_address?: Maybe<Scalars['String']['output']>;
  required_split_basis_points?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "split_atomic_factories" */
export type Split_Atomic_Factories_Mutation_Response = {
  __typename?: 'split_atomic_factories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Split_Atomic_Factories>;
};

/** on_conflict condition type for table "split_atomic_factories" */
export type Split_Atomic_Factories_On_Conflict = {
  constraint: Split_Atomic_Factories_Constraint;
  update_columns?: Array<Split_Atomic_Factories_Update_Column>;
  where?: InputMaybe<Split_Atomic_Factories_Bool_Exp>;
};

/** Ordering options when selecting data from "split_atomic_factories". */
export type Split_Atomic_Factories_Order_By = {
  abandoned?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  implementation?: InputMaybe<Order_By>;
  required_split_address?: InputMaybe<Order_By>;
  required_split_basis_points?: InputMaybe<Order_By>;
  split_atomic_contracts_aggregate?: InputMaybe<Split_Atomic_Contracts_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: split_atomic_factories */
export type Split_Atomic_Factories_Pk_Columns_Input = {
  address: Scalars['String']['input'];
};

/** select columns of table "split_atomic_factories" */
export enum Split_Atomic_Factories_Select_Column {
  /** column name */
  Abandoned = 'abandoned',
  /** column name */
  Address = 'address',
  /** column name */
  Implementation = 'implementation',
  /** column name */
  RequiredSplitAddress = 'required_split_address',
  /** column name */
  RequiredSplitBasisPoints = 'required_split_basis_points',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "split_atomic_factories" */
export type Split_Atomic_Factories_Set_Input = {
  abandoned?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  implementation?: InputMaybe<Scalars['String']['input']>;
  required_split_address?: InputMaybe<Scalars['String']['input']>;
  required_split_basis_points?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Split_Atomic_Factories_Stddev_Fields = {
  __typename?: 'split_atomic_factories_stddev_fields';
  required_split_basis_points?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Split_Atomic_Factories_Stddev_Pop_Fields = {
  __typename?: 'split_atomic_factories_stddev_pop_fields';
  required_split_basis_points?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Split_Atomic_Factories_Stddev_Samp_Fields = {
  __typename?: 'split_atomic_factories_stddev_samp_fields';
  required_split_basis_points?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "split_atomic_factories" */
export type Split_Atomic_Factories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Split_Atomic_Factories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Split_Atomic_Factories_Stream_Cursor_Value_Input = {
  abandoned?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  implementation?: InputMaybe<Scalars['String']['input']>;
  required_split_address?: InputMaybe<Scalars['String']['input']>;
  required_split_basis_points?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Split_Atomic_Factories_Sum_Fields = {
  __typename?: 'split_atomic_factories_sum_fields';
  required_split_basis_points?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "split_atomic_factories" */
export enum Split_Atomic_Factories_Update_Column {
  /** column name */
  Abandoned = 'abandoned',
  /** column name */
  Address = 'address',
  /** column name */
  Implementation = 'implementation',
  /** column name */
  RequiredSplitAddress = 'required_split_address',
  /** column name */
  RequiredSplitBasisPoints = 'required_split_basis_points',
  /** column name */
  Type = 'type'
}

export type Split_Atomic_Factories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Split_Atomic_Factories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Split_Atomic_Factories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Split_Atomic_Factories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Split_Atomic_Factories_Var_Pop_Fields = {
  __typename?: 'split_atomic_factories_var_pop_fields';
  required_split_basis_points?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Split_Atomic_Factories_Var_Samp_Fields = {
  __typename?: 'split_atomic_factories_var_samp_fields';
  required_split_basis_points?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Split_Atomic_Factories_Variance_Fields = {
  __typename?: 'split_atomic_factories_variance_fields';
  required_split_basis_points?: Maybe<Scalars['Float']['output']>;
};

/** Table of all individual splits used by indexed split atomic contracts */
export type Split_Payment_Configurations = {
  __typename?: 'split_payment_configurations';
  basis_points: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  recipient: Scalars['String']['output'];
  split_atomic_contract: Scalars['String']['output'];
};

/** aggregated selection of "split_payment_configurations" */
export type Split_Payment_Configurations_Aggregate = {
  __typename?: 'split_payment_configurations_aggregate';
  aggregate?: Maybe<Split_Payment_Configurations_Aggregate_Fields>;
  nodes: Array<Split_Payment_Configurations>;
};

export type Split_Payment_Configurations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Split_Payment_Configurations_Aggregate_Bool_Exp_Count>;
};

export type Split_Payment_Configurations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Split_Payment_Configurations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "split_payment_configurations" */
export type Split_Payment_Configurations_Aggregate_Fields = {
  __typename?: 'split_payment_configurations_aggregate_fields';
  avg?: Maybe<Split_Payment_Configurations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Split_Payment_Configurations_Max_Fields>;
  min?: Maybe<Split_Payment_Configurations_Min_Fields>;
  stddev?: Maybe<Split_Payment_Configurations_Stddev_Fields>;
  stddev_pop?: Maybe<Split_Payment_Configurations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Split_Payment_Configurations_Stddev_Samp_Fields>;
  sum?: Maybe<Split_Payment_Configurations_Sum_Fields>;
  var_pop?: Maybe<Split_Payment_Configurations_Var_Pop_Fields>;
  var_samp?: Maybe<Split_Payment_Configurations_Var_Samp_Fields>;
  variance?: Maybe<Split_Payment_Configurations_Variance_Fields>;
};


/** aggregate fields of "split_payment_configurations" */
export type Split_Payment_Configurations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Split_Payment_Configurations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "split_payment_configurations" */
export type Split_Payment_Configurations_Aggregate_Order_By = {
  avg?: InputMaybe<Split_Payment_Configurations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Split_Payment_Configurations_Max_Order_By>;
  min?: InputMaybe<Split_Payment_Configurations_Min_Order_By>;
  stddev?: InputMaybe<Split_Payment_Configurations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Split_Payment_Configurations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Split_Payment_Configurations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Split_Payment_Configurations_Sum_Order_By>;
  var_pop?: InputMaybe<Split_Payment_Configurations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Split_Payment_Configurations_Var_Samp_Order_By>;
  variance?: InputMaybe<Split_Payment_Configurations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "split_payment_configurations" */
export type Split_Payment_Configurations_Arr_Rel_Insert_Input = {
  data: Array<Split_Payment_Configurations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Split_Payment_Configurations_On_Conflict>;
};

/** aggregate avg on columns */
export type Split_Payment_Configurations_Avg_Fields = {
  __typename?: 'split_payment_configurations_avg_fields';
  basis_points?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Avg_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "split_payment_configurations". All fields are combined with a logical 'AND'. */
export type Split_Payment_Configurations_Bool_Exp = {
  _and?: InputMaybe<Array<Split_Payment_Configurations_Bool_Exp>>;
  _not?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
  _or?: InputMaybe<Array<Split_Payment_Configurations_Bool_Exp>>;
  basis_points?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  recipient?: InputMaybe<String_Comparison_Exp>;
  split_atomic_contract?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "split_payment_configurations" */
export enum Split_Payment_Configurations_Constraint {
  /** unique or primary key constraint on columns "id" */
  SplitPaymentConfigurationsPkey = 'split_payment_configurations_pkey'
}

/** input type for incrementing numeric columns in table "split_payment_configurations" */
export type Split_Payment_Configurations_Inc_Input = {
  basis_points?: InputMaybe<Scalars['Int']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "split_payment_configurations" */
export type Split_Payment_Configurations_Insert_Input = {
  basis_points?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  split_atomic_contract?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Split_Payment_Configurations_Max_Fields = {
  __typename?: 'split_payment_configurations_max_fields';
  basis_points?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  split_atomic_contract?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Max_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  split_atomic_contract?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Split_Payment_Configurations_Min_Fields = {
  __typename?: 'split_payment_configurations_min_fields';
  basis_points?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  split_atomic_contract?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Min_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  split_atomic_contract?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "split_payment_configurations" */
export type Split_Payment_Configurations_Mutation_Response = {
  __typename?: 'split_payment_configurations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Split_Payment_Configurations>;
};

/** on_conflict condition type for table "split_payment_configurations" */
export type Split_Payment_Configurations_On_Conflict = {
  constraint: Split_Payment_Configurations_Constraint;
  update_columns?: Array<Split_Payment_Configurations_Update_Column>;
  where?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
};

/** Ordering options when selecting data from "split_payment_configurations". */
export type Split_Payment_Configurations_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  split_atomic_contract?: InputMaybe<Order_By>;
};

/** primary key columns input for table: split_payment_configurations */
export type Split_Payment_Configurations_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "split_payment_configurations" */
export enum Split_Payment_Configurations_Select_Column {
  /** column name */
  BasisPoints = 'basis_points',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  SplitAtomicContract = 'split_atomic_contract'
}

/** input type for updating data in table "split_payment_configurations" */
export type Split_Payment_Configurations_Set_Input = {
  basis_points?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  split_atomic_contract?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Split_Payment_Configurations_Stddev_Fields = {
  __typename?: 'split_payment_configurations_stddev_fields';
  basis_points?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Stddev_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Split_Payment_Configurations_Stddev_Pop_Fields = {
  __typename?: 'split_payment_configurations_stddev_pop_fields';
  basis_points?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Stddev_Pop_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Split_Payment_Configurations_Stddev_Samp_Fields = {
  __typename?: 'split_payment_configurations_stddev_samp_fields';
  basis_points?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Stddev_Samp_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "split_payment_configurations" */
export type Split_Payment_Configurations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Split_Payment_Configurations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Split_Payment_Configurations_Stream_Cursor_Value_Input = {
  basis_points?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  split_atomic_contract?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Split_Payment_Configurations_Sum_Fields = {
  __typename?: 'split_payment_configurations_sum_fields';
  basis_points?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Sum_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** update columns of table "split_payment_configurations" */
export enum Split_Payment_Configurations_Update_Column {
  /** column name */
  BasisPoints = 'basis_points',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  SplitAtomicContract = 'split_atomic_contract'
}

export type Split_Payment_Configurations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Split_Payment_Configurations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Split_Payment_Configurations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Split_Payment_Configurations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Split_Payment_Configurations_Var_Pop_Fields = {
  __typename?: 'split_payment_configurations_var_pop_fields';
  basis_points?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Var_Pop_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Split_Payment_Configurations_Var_Samp_Fields = {
  __typename?: 'split_payment_configurations_var_samp_fields';
  basis_points?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Var_Samp_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Split_Payment_Configurations_Variance_Fields = {
  __typename?: 'split_payment_configurations_variance_fields';
  basis_points?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "split_payment_configurations" */
export type Split_Payment_Configurations_Variance_Order_By = {
  basis_points?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "artists" */
  artists: Array<Artists>;
  /** fetch aggregated fields from the table: "artists" */
  artists_aggregate: Artists_Aggregate;
  /** fetch data from the table in a streaming manner: "artists" */
  artists_stream: Array<Artists>;
  /** fetch data from the table: "bid_types" */
  bid_types: Array<Bid_Types>;
  /** fetch aggregated fields from the table: "bid_types" */
  bid_types_aggregate: Bid_Types_Aggregate;
  /** fetch data from the table: "bid_types" using primary key columns */
  bid_types_by_pk?: Maybe<Bid_Types>;
  /** fetch data from the table in a streaming manner: "bid_types" */
  bid_types_stream: Array<Bid_Types>;
  /** fetch data from the table: "bids_metadata" */
  bids_metadata: Array<Bids_Metadata>;
  /** fetch aggregated fields from the table: "bids_metadata" */
  bids_metadata_aggregate: Bids_Metadata_Aggregate;
  /** fetch data from the table: "bids_metadata" using primary key columns */
  bids_metadata_by_pk?: Maybe<Bids_Metadata>;
  /** fetch data from the table in a streaming manner: "bids_metadata" */
  bids_metadata_stream: Array<Bids_Metadata>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table in a streaming manner: "categories" */
  categories_stream: Array<Categories>;
  /** fetch data from the table: "contract_allowlistings" */
  contract_allowlistings: Array<Contract_Allowlistings>;
  /** fetch aggregated fields from the table: "contract_allowlistings" */
  contract_allowlistings_aggregate: Contract_Allowlistings_Aggregate;
  /** fetch data from the table: "contract_allowlistings" using primary key columns */
  contract_allowlistings_by_pk?: Maybe<Contract_Allowlistings>;
  /** fetch data from the table in a streaming manner: "contract_allowlistings" */
  contract_allowlistings_stream: Array<Contract_Allowlistings>;
  /** fetch data from the table: "contract_type_names" */
  contract_type_names: Array<Contract_Type_Names>;
  /** fetch aggregated fields from the table: "contract_type_names" */
  contract_type_names_aggregate: Contract_Type_Names_Aggregate;
  /** fetch data from the table: "contract_type_names" using primary key columns */
  contract_type_names_by_pk?: Maybe<Contract_Type_Names>;
  /** fetch data from the table in a streaming manner: "contract_type_names" */
  contract_type_names_stream: Array<Contract_Type_Names>;
  /** fetch data from the table: "contract_types" */
  contract_types: Array<Contract_Types>;
  /** fetch aggregated fields from the table: "contract_types" */
  contract_types_aggregate: Contract_Types_Aggregate;
  /** fetch data from the table: "contract_types" using primary key columns */
  contract_types_by_pk?: Maybe<Contract_Types>;
  /** fetch data from the table in a streaming manner: "contract_types" */
  contract_types_stream: Array<Contract_Types>;
  /** fetch data from the table: "contracts_metadata" */
  contracts_metadata: Array<Contracts_Metadata>;
  /** fetch aggregated fields from the table: "contracts_metadata" */
  contracts_metadata_aggregate: Contracts_Metadata_Aggregate;
  /** fetch data from the table: "contracts_metadata" using primary key columns */
  contracts_metadata_by_pk?: Maybe<Contracts_Metadata>;
  /** fetch data from the table in a streaming manner: "contracts_metadata" */
  contracts_metadata_stream: Array<Contracts_Metadata>;
  /** fetch data from the table: "core_registries_metadata" */
  core_registries_metadata: Array<Core_Registries_Metadata>;
  /** fetch aggregated fields from the table: "core_registries_metadata" */
  core_registries_metadata_aggregate: Core_Registries_Metadata_Aggregate;
  /** fetch data from the table: "core_registries_metadata" using primary key columns */
  core_registries_metadata_by_pk?: Maybe<Core_Registries_Metadata>;
  /** fetch data from the table in a streaming manner: "core_registries_metadata" */
  core_registries_metadata_stream: Array<Core_Registries_Metadata>;
  /** fetch data from the table: "curation_statuses" */
  curation_statuses: Array<Curation_Statuses>;
  /** fetch aggregated fields from the table: "curation_statuses" */
  curation_statuses_aggregate: Curation_Statuses_Aggregate;
  /** fetch data from the table: "curation_statuses" using primary key columns */
  curation_statuses_by_pk?: Maybe<Curation_Statuses>;
  /** fetch data from the table in a streaming manner: "curation_statuses" */
  curation_statuses_stream: Array<Curation_Statuses>;
  /** fetch data from the table: "dependencies_metadata" */
  dependencies_metadata: Array<Dependencies_Metadata>;
  /** fetch aggregated fields from the table: "dependencies_metadata" */
  dependencies_metadata_aggregate: Dependencies_Metadata_Aggregate;
  /** fetch data from the table: "dependencies_metadata" using primary key columns */
  dependencies_metadata_by_pk?: Maybe<Dependencies_Metadata>;
  /** fetch data from the table in a streaming manner: "dependencies_metadata" */
  dependencies_metadata_stream: Array<Dependencies_Metadata>;
  /** fetch data from the table: "dependency_additional_cdns" */
  dependency_additional_cdns: Array<Dependency_Additional_Cdns>;
  /** fetch aggregated fields from the table: "dependency_additional_cdns" */
  dependency_additional_cdns_aggregate: Dependency_Additional_Cdns_Aggregate;
  /** fetch data from the table: "dependency_additional_cdns" using primary key columns */
  dependency_additional_cdns_by_pk?: Maybe<Dependency_Additional_Cdns>;
  /** fetch data from the table in a streaming manner: "dependency_additional_cdns" */
  dependency_additional_cdns_stream: Array<Dependency_Additional_Cdns>;
  /** fetch data from the table: "dependency_additional_repositories" */
  dependency_additional_repositories: Array<Dependency_Additional_Repositories>;
  /** fetch aggregated fields from the table: "dependency_additional_repositories" */
  dependency_additional_repositories_aggregate: Dependency_Additional_Repositories_Aggregate;
  /** fetch data from the table: "dependency_additional_repositories" using primary key columns */
  dependency_additional_repositories_by_pk?: Maybe<Dependency_Additional_Repositories>;
  /** fetch data from the table in a streaming manner: "dependency_additional_repositories" */
  dependency_additional_repositories_stream: Array<Dependency_Additional_Repositories>;
  /** fetch data from the table: "dependency_registries" */
  dependency_registries: Array<Dependency_Registries>;
  /** fetch aggregated fields from the table: "dependency_registries" */
  dependency_registries_aggregate: Dependency_Registries_Aggregate;
  /** fetch data from the table: "dependency_registries" using primary key columns */
  dependency_registries_by_pk?: Maybe<Dependency_Registries>;
  /** fetch data from the table in a streaming manner: "dependency_registries" */
  dependency_registries_stream: Array<Dependency_Registries>;
  /** fetch data from the table: "dependency_scripts" */
  dependency_scripts: Array<Dependency_Scripts>;
  /** fetch aggregated fields from the table: "dependency_scripts" */
  dependency_scripts_aggregate: Dependency_Scripts_Aggregate;
  /** fetch data from the table: "dependency_scripts" using primary key columns */
  dependency_scripts_by_pk?: Maybe<Dependency_Scripts>;
  /** fetch data from the table in a streaming manner: "dependency_scripts" */
  dependency_scripts_stream: Array<Dependency_Scripts>;
  /** An array relationship */
  entity_tags: Array<Entity_Tags>;
  /** An aggregate relationship */
  entity_tags_aggregate: Entity_Tags_Aggregate;
  /** fetch data from the table: "entity_tags" using primary key columns */
  entity_tags_by_pk?: Maybe<Entity_Tags>;
  /** fetch data from the table in a streaming manner: "entity_tags" */
  entity_tags_stream: Array<Entity_Tags>;
  /** fetch data from the table: "environment_configuration" */
  environment_configuration: Array<Environment_Configuration>;
  /** fetch aggregated fields from the table: "environment_configuration" */
  environment_configuration_aggregate: Environment_Configuration_Aggregate;
  /** fetch data from the table: "environment_configuration" using primary key columns */
  environment_configuration_by_pk?: Maybe<Environment_Configuration>;
  /** fetch data from the table in a streaming manner: "environment_configuration" */
  environment_configuration_stream: Array<Environment_Configuration>;
  /** An array relationship */
  favorites: Array<Favorites>;
  /** An aggregate relationship */
  favorites_aggregate: Favorites_Aggregate;
  /** fetch data from the table: "favorites" using primary key columns */
  favorites_by_pk?: Maybe<Favorites>;
  /** fetch data from the table in a streaming manner: "favorites" */
  favorites_stream: Array<Favorites>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<Feature_Flags>;
  /** fetch aggregated fields from the table: "feature_flags" */
  feature_flags_aggregate: Feature_Flags_Aggregate;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** fetch data from the table in a streaming manner: "feature_flags" */
  feature_flags_stream: Array<Feature_Flags>;
  /** execute function "filter_tokens_metadata_by_features" which returns "tokens_metadata" */
  filter_tokens_metadata_by_features: Array<Tokens_Metadata>;
  /** execute function "filter_tokens_metadata_by_features" and query aggregates on result of table type "tokens_metadata" */
  filter_tokens_metadata_by_features_aggregate: Tokens_Metadata_Aggregate;
  /** execute function "list_projects_metadata_random" which returns "projects_metadata" */
  list_projects_metadata_random: Array<Projects_Metadata>;
  /** execute function "list_projects_metadata_random" and query aggregates on result of table type "projects_metadata" */
  list_projects_metadata_random_aggregate: Projects_Metadata_Aggregate;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  /** fetch data from the table in a streaming manner: "media" */
  media_stream: Array<Media>;
  /** fetch data from the table: "minter_filter_type_names" */
  minter_filter_type_names: Array<Minter_Filter_Type_Names>;
  /** fetch aggregated fields from the table: "minter_filter_type_names" */
  minter_filter_type_names_aggregate: Minter_Filter_Type_Names_Aggregate;
  /** fetch data from the table: "minter_filter_type_names" using primary key columns */
  minter_filter_type_names_by_pk?: Maybe<Minter_Filter_Type_Names>;
  /** fetch data from the table in a streaming manner: "minter_filter_type_names" */
  minter_filter_type_names_stream: Array<Minter_Filter_Type_Names>;
  /** fetch data from the table: "minter_filters_metadata" */
  minter_filters_metadata: Array<Minter_Filters_Metadata>;
  /** fetch aggregated fields from the table: "minter_filters_metadata" */
  minter_filters_metadata_aggregate: Minter_Filters_Metadata_Aggregate;
  /** fetch data from the table: "minter_filters_metadata" using primary key columns */
  minter_filters_metadata_by_pk?: Maybe<Minter_Filters_Metadata>;
  /** fetch data from the table in a streaming manner: "minter_filters_metadata" */
  minter_filters_metadata_stream: Array<Minter_Filters_Metadata>;
  /** fetch data from the table: "minter_type_names" */
  minter_type_names: Array<Minter_Type_Names>;
  /** fetch aggregated fields from the table: "minter_type_names" */
  minter_type_names_aggregate: Minter_Type_Names_Aggregate;
  /** fetch data from the table: "minter_type_names" using primary key columns */
  minter_type_names_by_pk?: Maybe<Minter_Type_Names>;
  /** fetch data from the table in a streaming manner: "minter_type_names" */
  minter_type_names_stream: Array<Minter_Type_Names>;
  /** fetch data from the table: "minter_types" */
  minter_types: Array<Minter_Types>;
  /** fetch aggregated fields from the table: "minter_types" */
  minter_types_aggregate: Minter_Types_Aggregate;
  /** fetch data from the table: "minter_types" using primary key columns */
  minter_types_by_pk?: Maybe<Minter_Types>;
  /** fetch data from the table in a streaming manner: "minter_types" */
  minter_types_stream: Array<Minter_Types>;
  /** fetch data from the table: "minters_metadata" */
  minters_metadata: Array<Minters_Metadata>;
  /** fetch aggregated fields from the table: "minters_metadata" */
  minters_metadata_aggregate: Minters_Metadata_Aggregate;
  /** fetch data from the table: "minters_metadata" using primary key columns */
  minters_metadata_by_pk?: Maybe<Minters_Metadata>;
  /** fetch data from the table in a streaming manner: "minters_metadata" */
  minters_metadata_stream: Array<Minters_Metadata>;
  /** fetch data from the table: "mixpanel_lookup" */
  mixpanel_lookup: Array<Mixpanel_Lookup>;
  /** fetch aggregated fields from the table: "mixpanel_lookup" */
  mixpanel_lookup_aggregate: Mixpanel_Lookup_Aggregate;
  /** fetch data from the table: "mixpanel_lookup" using primary key columns */
  mixpanel_lookup_by_pk?: Maybe<Mixpanel_Lookup>;
  /** fetch data from the table in a streaming manner: "mixpanel_lookup" */
  mixpanel_lookup_stream: Array<Mixpanel_Lookup>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "oob_tokens_metadata" */
  oob_tokens_metadata: Array<Oob_Tokens_Metadata>;
  /** fetch aggregated fields from the table: "oob_tokens_metadata" */
  oob_tokens_metadata_aggregate: Oob_Tokens_Metadata_Aggregate;
  /** fetch data from the table: "oob_tokens_metadata" using primary key columns */
  oob_tokens_metadata_by_pk?: Maybe<Oob_Tokens_Metadata>;
  /** fetch data from the table in a streaming manner: "oob_tokens_metadata" */
  oob_tokens_metadata_stream: Array<Oob_Tokens_Metadata>;
  /** fetch data from the table: "partner_types" */
  partner_types: Array<Partner_Types>;
  /** fetch aggregated fields from the table: "partner_types" */
  partner_types_aggregate: Partner_Types_Aggregate;
  /** fetch data from the table: "partner_types" using primary key columns */
  partner_types_by_pk?: Maybe<Partner_Types>;
  /** fetch data from the table in a streaming manner: "partner_types" */
  partner_types_stream: Array<Partner_Types>;
  /** fetch data from the table: "partners" */
  partners: Array<Partners>;
  /** fetch aggregated fields from the table: "partners" */
  partners_aggregate: Partners_Aggregate;
  /** fetch data from the table: "partners" using primary key columns */
  partners_by_pk?: Maybe<Partners>;
  /** fetch data from the table in a streaming manner: "partners" */
  partners_stream: Array<Partners>;
  /** fetch data from the table: "pmp_auth_options" */
  pmp_auth_options: Array<Pmp_Auth_Options>;
  /** fetch aggregated fields from the table: "pmp_auth_options" */
  pmp_auth_options_aggregate: Pmp_Auth_Options_Aggregate;
  /** fetch data from the table: "pmp_auth_options" using primary key columns */
  pmp_auth_options_by_pk?: Maybe<Pmp_Auth_Options>;
  /** fetch data from the table in a streaming manner: "pmp_auth_options" */
  pmp_auth_options_stream: Array<Pmp_Auth_Options>;
  /** An array relationship */
  pmp_configs: Array<Pmp_Configs>;
  /** An aggregate relationship */
  pmp_configs_aggregate: Pmp_Configs_Aggregate;
  /** fetch data from the table: "pmp_configs" using primary key columns */
  pmp_configs_by_pk?: Maybe<Pmp_Configs>;
  /** fetch data from the table in a streaming manner: "pmp_configs" */
  pmp_configs_stream: Array<Pmp_Configs>;
  /** fetch data from the table: "pmp_param_types" */
  pmp_param_types: Array<Pmp_Param_Types>;
  /** fetch aggregated fields from the table: "pmp_param_types" */
  pmp_param_types_aggregate: Pmp_Param_Types_Aggregate;
  /** fetch data from the table: "pmp_param_types" using primary key columns */
  pmp_param_types_by_pk?: Maybe<Pmp_Param_Types>;
  /** fetch data from the table in a streaming manner: "pmp_param_types" */
  pmp_param_types_stream: Array<Pmp_Param_Types>;
  /** An array relationship */
  pmp_project_configs: Array<Pmp_Project_Configs>;
  /** An aggregate relationship */
  pmp_project_configs_aggregate: Pmp_Project_Configs_Aggregate;
  /** fetch data from the table: "pmp_project_configs" using primary key columns */
  pmp_project_configs_by_pk?: Maybe<Pmp_Project_Configs>;
  /** fetch data from the table in a streaming manner: "pmp_project_configs" */
  pmp_project_configs_stream: Array<Pmp_Project_Configs>;
  /** fetch data from the table: "pmps_metadata" */
  pmps_metadata: Array<Pmps_Metadata>;
  /** fetch aggregated fields from the table: "pmps_metadata" */
  pmps_metadata_aggregate: Pmps_Metadata_Aggregate;
  /** fetch data from the table: "pmps_metadata" using primary key columns */
  pmps_metadata_by_pk?: Maybe<Pmps_Metadata>;
  /** fetch data from the table in a streaming manner: "pmps_metadata" */
  pmps_metadata_stream: Array<Pmps_Metadata>;
  /** fetch data from the table: "primary_purchases" */
  primary_purchases: Array<Primary_Purchases>;
  /** fetch aggregated fields from the table: "primary_purchases" */
  primary_purchases_aggregate: Primary_Purchases_Aggregate;
  /** fetch data from the table: "primary_purchases" using primary key columns */
  primary_purchases_by_pk?: Maybe<Primary_Purchases>;
  /** fetch data from the table in a streaming manner: "primary_purchases" */
  primary_purchases_stream: Array<Primary_Purchases>;
  /** An array relationship */
  processing_jobs: Array<Processing_Jobs>;
  /** An aggregate relationship */
  processing_jobs_aggregate: Processing_Jobs_Aggregate;
  /** fetch data from the table: "processing_jobs" using primary key columns */
  processing_jobs_by_pk?: Maybe<Processing_Jobs>;
  /** fetch data from the table: "processing_jobs_status_types" */
  processing_jobs_status_types: Array<Processing_Jobs_Status_Types>;
  /** fetch aggregated fields from the table: "processing_jobs_status_types" */
  processing_jobs_status_types_aggregate: Processing_Jobs_Status_Types_Aggregate;
  /** fetch data from the table: "processing_jobs_status_types" using primary key columns */
  processing_jobs_status_types_by_pk?: Maybe<Processing_Jobs_Status_Types>;
  /** fetch data from the table in a streaming manner: "processing_jobs_status_types" */
  processing_jobs_status_types_stream: Array<Processing_Jobs_Status_Types>;
  /** fetch data from the table in a streaming manner: "processing_jobs" */
  processing_jobs_stream: Array<Processing_Jobs>;
  /** fetch data from the table: "project_external_asset_dependencies" */
  project_external_asset_dependencies: Array<Project_External_Asset_Dependencies>;
  /** fetch aggregated fields from the table: "project_external_asset_dependencies" */
  project_external_asset_dependencies_aggregate: Project_External_Asset_Dependencies_Aggregate;
  /** fetch data from the table: "project_external_asset_dependencies" using primary key columns */
  project_external_asset_dependencies_by_pk?: Maybe<Project_External_Asset_Dependencies>;
  /** fetch data from the table in a streaming manner: "project_external_asset_dependencies" */
  project_external_asset_dependencies_stream: Array<Project_External_Asset_Dependencies>;
  /** fetch data from the table: "project_external_asset_dependency_types" */
  project_external_asset_dependency_types: Array<Project_External_Asset_Dependency_Types>;
  /** fetch aggregated fields from the table: "project_external_asset_dependency_types" */
  project_external_asset_dependency_types_aggregate: Project_External_Asset_Dependency_Types_Aggregate;
  /** fetch data from the table: "project_external_asset_dependency_types" using primary key columns */
  project_external_asset_dependency_types_by_pk?: Maybe<Project_External_Asset_Dependency_Types>;
  /** fetch data from the table in a streaming manner: "project_external_asset_dependency_types" */
  project_external_asset_dependency_types_stream: Array<Project_External_Asset_Dependency_Types>;
  /** fetch data from the table: "project_minter_configurations" */
  project_minter_configurations: Array<Project_Minter_Configurations>;
  /** fetch aggregated fields from the table: "project_minter_configurations" */
  project_minter_configurations_aggregate: Project_Minter_Configurations_Aggregate;
  /** fetch data from the table: "project_minter_configurations" using primary key columns */
  project_minter_configurations_by_pk?: Maybe<Project_Minter_Configurations>;
  /** fetch data from the table in a streaming manner: "project_minter_configurations" */
  project_minter_configurations_stream: Array<Project_Minter_Configurations>;
  /** execute function "project_ranked_bids" which returns "bids_metadata" */
  project_ranked_bids: Array<Bids_Metadata>;
  /** execute function "project_ranked_bids" and query aggregates on result of table type "bids_metadata" */
  project_ranked_bids_aggregate: Bids_Metadata_Aggregate;
  /** fetch data from the table: "project_scripts" */
  project_scripts: Array<Project_Scripts>;
  /** fetch aggregated fields from the table: "project_scripts" */
  project_scripts_aggregate: Project_Scripts_Aggregate;
  /** fetch data from the table: "project_scripts" using primary key columns */
  project_scripts_by_pk?: Maybe<Project_Scripts>;
  /** fetch data from the table in a streaming manner: "project_scripts" */
  project_scripts_stream: Array<Project_Scripts>;
  /** fetch data from the table: "project_series" */
  project_series: Array<Project_Series>;
  /** fetch aggregated fields from the table: "project_series" */
  project_series_aggregate: Project_Series_Aggregate;
  /** fetch data from the table: "project_series" using primary key columns */
  project_series_by_pk?: Maybe<Project_Series>;
  /** fetch data from the table in a streaming manner: "project_series" */
  project_series_stream: Array<Project_Series>;
  /** fetch data from the table: "project_vertical_categories" */
  project_vertical_categories: Array<Project_Vertical_Categories>;
  /** fetch aggregated fields from the table: "project_vertical_categories" */
  project_vertical_categories_aggregate: Project_Vertical_Categories_Aggregate;
  /** fetch data from the table: "project_vertical_categories" using primary key columns */
  project_vertical_categories_by_pk?: Maybe<Project_Vertical_Categories>;
  /** fetch data from the table in a streaming manner: "project_vertical_categories" */
  project_vertical_categories_stream: Array<Project_Vertical_Categories>;
  /** fetch data from the table: "project_verticals" */
  project_verticals: Array<Project_Verticals>;
  /** fetch aggregated fields from the table: "project_verticals" */
  project_verticals_aggregate: Project_Verticals_Aggregate;
  /** fetch data from the table: "project_verticals" using primary key columns */
  project_verticals_by_pk?: Maybe<Project_Verticals>;
  /** fetch data from the table in a streaming manner: "project_verticals" */
  project_verticals_stream: Array<Project_Verticals>;
  /** fetch data from the table: "projects_features" */
  projects_features: Array<Projects_Features>;
  /** fetch aggregated fields from the table: "projects_features" */
  projects_features_aggregate: Projects_Features_Aggregate;
  /** fetch data from the table: "projects_features" using primary key columns */
  projects_features_by_pk?: Maybe<Projects_Features>;
  /** fetch data from the table in a streaming manner: "projects_features" */
  projects_features_stream: Array<Projects_Features>;
  /** fetch data from the table: "projects_metadata" */
  projects_metadata: Array<Projects_Metadata>;
  /** fetch aggregated fields from the table: "projects_metadata" */
  projects_metadata_aggregate: Projects_Metadata_Aggregate;
  /** fetch data from the table: "projects_metadata" using primary key columns */
  projects_metadata_by_pk?: Maybe<Projects_Metadata>;
  /** fetch data from the table in a streaming manner: "projects_metadata" */
  projects_metadata_stream: Array<Projects_Metadata>;
  /** fetch data from the table: "proposed_artist_addresses_and_splits" */
  proposed_artist_addresses_and_splits: Array<Proposed_Artist_Addresses_And_Splits>;
  /** fetch aggregated fields from the table: "proposed_artist_addresses_and_splits" */
  proposed_artist_addresses_and_splits_aggregate: Proposed_Artist_Addresses_And_Splits_Aggregate;
  /** fetch data from the table: "proposed_artist_addresses_and_splits" using primary key columns */
  proposed_artist_addresses_and_splits_by_pk?: Maybe<Proposed_Artist_Addresses_And_Splits>;
  /** fetch data from the table in a streaming manner: "proposed_artist_addresses_and_splits" */
  proposed_artist_addresses_and_splits_stream: Array<Proposed_Artist_Addresses_And_Splits>;
  /** fetch data from the table: "receipt_metadata" */
  receipt_metadata: Array<Receipt_Metadata>;
  /** fetch aggregated fields from the table: "receipt_metadata" */
  receipt_metadata_aggregate: Receipt_Metadata_Aggregate;
  /** fetch data from the table: "receipt_metadata" using primary key columns */
  receipt_metadata_by_pk?: Maybe<Receipt_Metadata>;
  /** fetch data from the table in a streaming manner: "receipt_metadata" */
  receipt_metadata_stream: Array<Receipt_Metadata>;
  /** fetch data from the table: "refresh_asset_types" */
  refresh_asset_types: Array<Refresh_Asset_Types>;
  /** fetch aggregated fields from the table: "refresh_asset_types" */
  refresh_asset_types_aggregate: Refresh_Asset_Types_Aggregate;
  /** fetch data from the table: "refresh_asset_types" using primary key columns */
  refresh_asset_types_by_pk?: Maybe<Refresh_Asset_Types>;
  /** fetch data from the table in a streaming manner: "refresh_asset_types" */
  refresh_asset_types_stream: Array<Refresh_Asset_Types>;
  /** fetch data from the table: "refresh_request_types" */
  refresh_request_types: Array<Refresh_Request_Types>;
  /** fetch aggregated fields from the table: "refresh_request_types" */
  refresh_request_types_aggregate: Refresh_Request_Types_Aggregate;
  /** fetch data from the table: "refresh_request_types" using primary key columns */
  refresh_request_types_by_pk?: Maybe<Refresh_Request_Types>;
  /** fetch data from the table in a streaming manner: "refresh_request_types" */
  refresh_request_types_stream: Array<Refresh_Request_Types>;
  /** An array relationship */
  refresh_requests: Array<Refresh_Requests>;
  /** An aggregate relationship */
  refresh_requests_aggregate: Refresh_Requests_Aggregate;
  /** fetch data from the table: "refresh_requests" using primary key columns */
  refresh_requests_by_pk?: Maybe<Refresh_Requests>;
  /** fetch data from the table in a streaming manner: "refresh_requests" */
  refresh_requests_stream: Array<Refresh_Requests>;
  /** fetch data from the table: "render_types" */
  render_types: Array<Render_Types>;
  /** fetch aggregated fields from the table: "render_types" */
  render_types_aggregate: Render_Types_Aggregate;
  /** fetch data from the table: "render_types" using primary key columns */
  render_types_by_pk?: Maybe<Render_Types>;
  /** fetch data from the table in a streaming manner: "render_types" */
  render_types_stream: Array<Render_Types>;
  /** An array relationship */
  royalty_split_recipients: Array<Royalty_Split_Recipients>;
  /** An aggregate relationship */
  royalty_split_recipients_aggregate: Royalty_Split_Recipients_Aggregate;
  /** fetch data from the table: "royalty_split_recipients" using primary key columns */
  royalty_split_recipients_by_pk?: Maybe<Royalty_Split_Recipients>;
  /** fetch data from the table in a streaming manner: "royalty_split_recipients" */
  royalty_split_recipients_stream: Array<Royalty_Split_Recipients>;
  /** fetch data from the table: "royalty_splitter_contracts" */
  royalty_splitter_contracts: Array<Royalty_Splitter_Contracts>;
  /** fetch aggregated fields from the table: "royalty_splitter_contracts" */
  royalty_splitter_contracts_aggregate: Royalty_Splitter_Contracts_Aggregate;
  /** fetch data from the table: "royalty_splitter_contracts" using primary key columns */
  royalty_splitter_contracts_by_pk?: Maybe<Royalty_Splitter_Contracts>;
  /** fetch data from the table in a streaming manner: "royalty_splitter_contracts" */
  royalty_splitter_contracts_stream: Array<Royalty_Splitter_Contracts>;
  /** fetch data from the table: "screenings" */
  screenings: Array<Screenings>;
  /** fetch aggregated fields from the table: "screenings" */
  screenings_aggregate: Screenings_Aggregate;
  /** fetch data from the table: "screenings" using primary key columns */
  screenings_by_pk?: Maybe<Screenings>;
  /** fetch data from the table in a streaming manner: "screenings" */
  screenings_stream: Array<Screenings>;
  /** execute function "search_projects" which returns "projects_metadata" */
  search_projects: Array<Projects_Metadata>;
  /** execute function "search_projects" and query aggregates on result of table type "projects_metadata" */
  search_projects_aggregate: Projects_Metadata_Aggregate;
  /** execute function "search_tags" which returns "tags" */
  search_tags: Array<Tags>;
  /** execute function "search_tags" and query aggregates on result of table type "tags" */
  search_tags_aggregate: Tags_Aggregate;
  /** execute function "search_tokens" which returns "tokens_metadata" */
  search_tokens: Array<Tokens_Metadata>;
  /** execute function "search_tokens" and query aggregates on result of table type "tokens_metadata" */
  search_tokens_aggregate: Tokens_Metadata_Aggregate;
  /** execute function "search_users" which returns "user_profiles" */
  search_users: Array<User_Profiles>;
  /** execute function "search_users" and query aggregates on result of table type "user_profiles" */
  search_users_aggregate: User_Profiles_Aggregate;
  /** An array relationship */
  split_atomic_contracts: Array<Split_Atomic_Contracts>;
  /** An aggregate relationship */
  split_atomic_contracts_aggregate: Split_Atomic_Contracts_Aggregate;
  /** fetch data from the table: "split_atomic_contracts" using primary key columns */
  split_atomic_contracts_by_pk?: Maybe<Split_Atomic_Contracts>;
  /** fetch data from the table in a streaming manner: "split_atomic_contracts" */
  split_atomic_contracts_stream: Array<Split_Atomic_Contracts>;
  /** fetch data from the table: "split_atomic_factories" */
  split_atomic_factories: Array<Split_Atomic_Factories>;
  /** fetch aggregated fields from the table: "split_atomic_factories" */
  split_atomic_factories_aggregate: Split_Atomic_Factories_Aggregate;
  /** fetch data from the table: "split_atomic_factories" using primary key columns */
  split_atomic_factories_by_pk?: Maybe<Split_Atomic_Factories>;
  /** fetch data from the table in a streaming manner: "split_atomic_factories" */
  split_atomic_factories_stream: Array<Split_Atomic_Factories>;
  /** fetch data from the table: "split_payment_configurations" */
  split_payment_configurations: Array<Split_Payment_Configurations>;
  /** fetch aggregated fields from the table: "split_payment_configurations" */
  split_payment_configurations_aggregate: Split_Payment_Configurations_Aggregate;
  /** fetch data from the table: "split_payment_configurations" using primary key columns */
  split_payment_configurations_by_pk?: Maybe<Split_Payment_Configurations>;
  /** fetch data from the table in a streaming manner: "split_payment_configurations" */
  split_payment_configurations_stream: Array<Split_Payment_Configurations>;
  /** fetch data from the table: "sync_status" */
  sync_status: Array<Sync_Status>;
  /** fetch aggregated fields from the table: "sync_status" */
  sync_status_aggregate: Sync_Status_Aggregate;
  /** fetch data from the table: "sync_status" using primary key columns */
  sync_status_by_pk?: Maybe<Sync_Status>;
  /** fetch data from the table in a streaming manner: "sync_status" */
  sync_status_stream: Array<Sync_Status>;
  /** fetch data from the table: "tag_groupings" */
  tag_groupings: Array<Tag_Groupings>;
  /** fetch aggregated fields from the table: "tag_groupings" */
  tag_groupings_aggregate: Tag_Groupings_Aggregate;
  /** fetch data from the table: "tag_groupings" using primary key columns */
  tag_groupings_by_pk?: Maybe<Tag_Groupings>;
  /** fetch data from the table in a streaming manner: "tag_groupings" */
  tag_groupings_stream: Array<Tag_Groupings>;
  /** fetch data from the table: "tag_status" */
  tag_status: Array<Tag_Status>;
  /** fetch aggregated fields from the table: "tag_status" */
  tag_status_aggregate: Tag_Status_Aggregate;
  /** fetch data from the table: "tag_status" using primary key columns */
  tag_status_by_pk?: Maybe<Tag_Status>;
  /** fetch data from the table in a streaming manner: "tag_status" */
  tag_status_stream: Array<Tag_Status>;
  /** fetch data from the table: "tag_types" */
  tag_types: Array<Tag_Types>;
  /** fetch aggregated fields from the table: "tag_types" */
  tag_types_aggregate: Tag_Types_Aggregate;
  /** fetch data from the table: "tag_types" using primary key columns */
  tag_types_by_pk?: Maybe<Tag_Types>;
  /** fetch data from the table in a streaming manner: "tag_types" */
  tag_types_stream: Array<Tag_Types>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table in a streaming manner: "tags" */
  tags_stream: Array<Tags>;
  /** fetch data from the table: "tokens_metadata" */
  tokens_metadata: Array<Tokens_Metadata>;
  /** fetch aggregated fields from the table: "tokens_metadata" */
  tokens_metadata_aggregate: Tokens_Metadata_Aggregate;
  /** fetch data from the table: "tokens_metadata" using primary key columns */
  tokens_metadata_by_pk?: Maybe<Tokens_Metadata>;
  /** fetch data from the table in a streaming manner: "tokens_metadata" */
  tokens_metadata_stream: Array<Tokens_Metadata>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table in a streaming manner: "user_profiles" */
  user_profiles_stream: Array<User_Profiles>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "verticals" */
  verticals: Array<Verticals>;
  /** fetch aggregated fields from the table: "verticals" */
  verticals_aggregate: Verticals_Aggregate;
  /** fetch data from the table: "verticals" using primary key columns */
  verticals_by_pk?: Maybe<Verticals>;
  /** fetch data from the table in a streaming manner: "verticals" */
  verticals_stream: Array<Verticals>;
  /** fetch data from the table: "video_aspect_ratios" */
  video_aspect_ratios: Array<Video_Aspect_Ratios>;
  /** fetch aggregated fields from the table: "video_aspect_ratios" */
  video_aspect_ratios_aggregate: Video_Aspect_Ratios_Aggregate;
  /** fetch data from the table: "video_aspect_ratios" using primary key columns */
  video_aspect_ratios_by_pk?: Maybe<Video_Aspect_Ratios>;
  /** fetch data from the table in a streaming manner: "video_aspect_ratios" */
  video_aspect_ratios_stream: Array<Video_Aspect_Ratios>;
  /** fetch data from the table: "video_frame_rates" */
  video_frame_rates: Array<Video_Frame_Rates>;
  /** fetch aggregated fields from the table: "video_frame_rates" */
  video_frame_rates_aggregate: Video_Frame_Rates_Aggregate;
  /** fetch data from the table: "video_frame_rates" using primary key columns */
  video_frame_rates_by_pk?: Maybe<Video_Frame_Rates>;
  /** fetch data from the table in a streaming manner: "video_frame_rates" */
  video_frame_rates_stream: Array<Video_Frame_Rates>;
  /** fetch data from the table: "webflow_artist_info" */
  webflow_artist_info: Array<Webflow_Artist_Info>;
  /** fetch aggregated fields from the table: "webflow_artist_info" */
  webflow_artist_info_aggregate: Webflow_Artist_Info_Aggregate;
  /** fetch data from the table: "webflow_artist_info" using primary key columns */
  webflow_artist_info_by_pk?: Maybe<Webflow_Artist_Info>;
  /** fetch data from the table in a streaming manner: "webflow_artist_info" */
  webflow_artist_info_stream: Array<Webflow_Artist_Info>;
  /** fetch data from the table: "webflow_spectrum_articles" */
  webflow_spectrum_articles: Array<Webflow_Spectrum_Articles>;
  /** fetch aggregated fields from the table: "webflow_spectrum_articles" */
  webflow_spectrum_articles_aggregate: Webflow_Spectrum_Articles_Aggregate;
  /** fetch data from the table: "webflow_spectrum_articles" using primary key columns */
  webflow_spectrum_articles_by_pk?: Maybe<Webflow_Spectrum_Articles>;
  /** fetch data from the table in a streaming manner: "webflow_spectrum_articles" */
  webflow_spectrum_articles_stream: Array<Webflow_Spectrum_Articles>;
};


export type Subscription_RootArtistsArgs = {
  distinct_on?: InputMaybe<Array<Artists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artists_Order_By>>;
  where?: InputMaybe<Artists_Bool_Exp>;
};


export type Subscription_RootArtists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artists_Order_By>>;
  where?: InputMaybe<Artists_Bool_Exp>;
};


export type Subscription_RootArtists_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Artists_Stream_Cursor_Input>>;
  where?: InputMaybe<Artists_Bool_Exp>;
};


export type Subscription_RootBid_TypesArgs = {
  distinct_on?: InputMaybe<Array<Bid_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bid_Types_Order_By>>;
  where?: InputMaybe<Bid_Types_Bool_Exp>;
};


export type Subscription_RootBid_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bid_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bid_Types_Order_By>>;
  where?: InputMaybe<Bid_Types_Bool_Exp>;
};


export type Subscription_RootBid_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootBid_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bid_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Bid_Types_Bool_Exp>;
};


export type Subscription_RootBids_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Subscription_RootBids_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Subscription_RootBids_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBids_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bids_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Subscription_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategories_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootCategories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootContract_AllowlistingsArgs = {
  distinct_on?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Allowlistings_Order_By>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


export type Subscription_RootContract_Allowlistings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Allowlistings_Order_By>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


export type Subscription_RootContract_Allowlistings_By_PkArgs = {
  contract_address: Scalars['String']['input'];
  user_address: Scalars['String']['input'];
};


export type Subscription_RootContract_Allowlistings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contract_Allowlistings_Stream_Cursor_Input>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


export type Subscription_RootContract_Type_NamesArgs = {
  distinct_on?: InputMaybe<Array<Contract_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Type_Names_Order_By>>;
  where?: InputMaybe<Contract_Type_Names_Bool_Exp>;
};


export type Subscription_RootContract_Type_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Type_Names_Order_By>>;
  where?: InputMaybe<Contract_Type_Names_Bool_Exp>;
};


export type Subscription_RootContract_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootContract_Type_Names_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contract_Type_Names_Stream_Cursor_Input>>;
  where?: InputMaybe<Contract_Type_Names_Bool_Exp>;
};


export type Subscription_RootContract_TypesArgs = {
  distinct_on?: InputMaybe<Array<Contract_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Types_Order_By>>;
  where?: InputMaybe<Contract_Types_Bool_Exp>;
};


export type Subscription_RootContract_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Types_Order_By>>;
  where?: InputMaybe<Contract_Types_Bool_Exp>;
};


export type Subscription_RootContract_Types_By_PkArgs = {
  type: Contract_Type_Names_Enum;
};


export type Subscription_RootContract_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contract_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Contract_Types_Bool_Exp>;
};


export type Subscription_RootContracts_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


export type Subscription_RootContracts_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Metadata_Order_By>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


export type Subscription_RootContracts_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Subscription_RootContracts_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contracts_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Contracts_Metadata_Bool_Exp>;
};


export type Subscription_RootCore_Registries_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Core_Registries_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Core_Registries_Metadata_Order_By>>;
  where?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
};


export type Subscription_RootCore_Registries_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Core_Registries_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Core_Registries_Metadata_Order_By>>;
  where?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
};


export type Subscription_RootCore_Registries_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Subscription_RootCore_Registries_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Core_Registries_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Core_Registries_Metadata_Bool_Exp>;
};


export type Subscription_RootCuration_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Curation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Curation_Statuses_Order_By>>;
  where?: InputMaybe<Curation_Statuses_Bool_Exp>;
};


export type Subscription_RootCuration_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Curation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Curation_Statuses_Order_By>>;
  where?: InputMaybe<Curation_Statuses_Bool_Exp>;
};


export type Subscription_RootCuration_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCuration_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Curation_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Curation_Statuses_Bool_Exp>;
};


export type Subscription_RootDependencies_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Dependencies_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependencies_Metadata_Order_By>>;
  where?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
};


export type Subscription_RootDependencies_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependencies_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependencies_Metadata_Order_By>>;
  where?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
};


export type Subscription_RootDependencies_Metadata_By_PkArgs = {
  name_and_version: Scalars['String']['input'];
};


export type Subscription_RootDependencies_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dependencies_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Dependencies_Metadata_Bool_Exp>;
};


export type Subscription_RootDependency_Additional_CdnsArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Cdns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Cdns_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
};


export type Subscription_RootDependency_Additional_Cdns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Cdns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Cdns_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
};


export type Subscription_RootDependency_Additional_Cdns_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


export type Subscription_RootDependency_Additional_Cdns_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dependency_Additional_Cdns_Stream_Cursor_Input>>;
  where?: InputMaybe<Dependency_Additional_Cdns_Bool_Exp>;
};


export type Subscription_RootDependency_Additional_RepositoriesArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Repositories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Repositories_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
};


export type Subscription_RootDependency_Additional_Repositories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Additional_Repositories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Additional_Repositories_Order_By>>;
  where?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
};


export type Subscription_RootDependency_Additional_Repositories_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


export type Subscription_RootDependency_Additional_Repositories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dependency_Additional_Repositories_Stream_Cursor_Input>>;
  where?: InputMaybe<Dependency_Additional_Repositories_Bool_Exp>;
};


export type Subscription_RootDependency_RegistriesArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Registries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Registries_Order_By>>;
  where?: InputMaybe<Dependency_Registries_Bool_Exp>;
};


export type Subscription_RootDependency_Registries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Registries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Registries_Order_By>>;
  where?: InputMaybe<Dependency_Registries_Bool_Exp>;
};


export type Subscription_RootDependency_Registries_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Subscription_RootDependency_Registries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dependency_Registries_Stream_Cursor_Input>>;
  where?: InputMaybe<Dependency_Registries_Bool_Exp>;
};


export type Subscription_RootDependency_ScriptsArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Scripts_Order_By>>;
  where?: InputMaybe<Dependency_Scripts_Bool_Exp>;
};


export type Subscription_RootDependency_Scripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dependency_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dependency_Scripts_Order_By>>;
  where?: InputMaybe<Dependency_Scripts_Bool_Exp>;
};


export type Subscription_RootDependency_Scripts_By_PkArgs = {
  dependency_name_and_version: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};


export type Subscription_RootDependency_Scripts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dependency_Scripts_Stream_Cursor_Input>>;
  where?: InputMaybe<Dependency_Scripts_Bool_Exp>;
};


export type Subscription_RootEntity_TagsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


export type Subscription_RootEntity_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


export type Subscription_RootEntity_Tags_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEntity_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Entity_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


export type Subscription_RootEnvironment_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Environment_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Environment_Configuration_Order_By>>;
  where?: InputMaybe<Environment_Configuration_Bool_Exp>;
};


export type Subscription_RootEnvironment_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Environment_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Environment_Configuration_Order_By>>;
  where?: InputMaybe<Environment_Configuration_Bool_Exp>;
};


export type Subscription_RootEnvironment_Configuration_By_PkArgs = {
  id: Scalars['Boolean']['input'];
};


export type Subscription_RootEnvironment_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Environment_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Environment_Configuration_Bool_Exp>;
};


export type Subscription_RootFavoritesArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


export type Subscription_RootFavorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


export type Subscription_RootFavorites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFavorites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Favorites_Stream_Cursor_Input>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


export type Subscription_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_By_PkArgs = {
  flag_name: Scalars['String']['input'];
};


export type Subscription_RootFeature_Flags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Feature_Flags_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFilter_Tokens_Metadata_By_FeaturesArgs = {
  args: Filter_Tokens_Metadata_By_Features_Args;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootFilter_Tokens_Metadata_By_Features_AggregateArgs = {
  args: Filter_Tokens_Metadata_By_Features_Args;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootList_Projects_Metadata_RandomArgs = {
  args?: InputMaybe<List_Projects_Metadata_Random_Args>;
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Subscription_RootList_Projects_Metadata_Random_AggregateArgs = {
  args?: InputMaybe<List_Projects_Metadata_Random_Args>;
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Subscription_RootMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMedia_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMinter_Filter_Type_NamesArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filter_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filter_Type_Names_Order_By>>;
  where?: InputMaybe<Minter_Filter_Type_Names_Bool_Exp>;
};


export type Subscription_RootMinter_Filter_Type_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filter_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filter_Type_Names_Order_By>>;
  where?: InputMaybe<Minter_Filter_Type_Names_Bool_Exp>;
};


export type Subscription_RootMinter_Filter_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootMinter_Filter_Type_Names_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Minter_Filter_Type_Names_Stream_Cursor_Input>>;
  where?: InputMaybe<Minter_Filter_Type_Names_Bool_Exp>;
};


export type Subscription_RootMinter_Filters_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filters_Metadata_Order_By>>;
  where?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
};


export type Subscription_RootMinter_Filters_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Filters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Filters_Metadata_Order_By>>;
  where?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
};


export type Subscription_RootMinter_Filters_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Subscription_RootMinter_Filters_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Minter_Filters_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Minter_Filters_Metadata_Bool_Exp>;
};


export type Subscription_RootMinter_Type_NamesArgs = {
  distinct_on?: InputMaybe<Array<Minter_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Type_Names_Order_By>>;
  where?: InputMaybe<Minter_Type_Names_Bool_Exp>;
};


export type Subscription_RootMinter_Type_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Type_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Type_Names_Order_By>>;
  where?: InputMaybe<Minter_Type_Names_Bool_Exp>;
};


export type Subscription_RootMinter_Type_Names_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootMinter_Type_Names_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Minter_Type_Names_Stream_Cursor_Input>>;
  where?: InputMaybe<Minter_Type_Names_Bool_Exp>;
};


export type Subscription_RootMinter_TypesArgs = {
  distinct_on?: InputMaybe<Array<Minter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Types_Order_By>>;
  where?: InputMaybe<Minter_Types_Bool_Exp>;
};


export type Subscription_RootMinter_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minter_Types_Order_By>>;
  where?: InputMaybe<Minter_Types_Bool_Exp>;
};


export type Subscription_RootMinter_Types_By_PkArgs = {
  type: Minter_Type_Names_Enum;
};


export type Subscription_RootMinter_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Minter_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Minter_Types_Bool_Exp>;
};


export type Subscription_RootMinters_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minters_Metadata_Order_By>>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};


export type Subscription_RootMinters_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Minters_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Minters_Metadata_Order_By>>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};


export type Subscription_RootMinters_Metadata_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Subscription_RootMinters_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Minters_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Minters_Metadata_Bool_Exp>;
};


export type Subscription_RootMixpanel_LookupArgs = {
  distinct_on?: InputMaybe<Array<Mixpanel_Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mixpanel_Lookup_Order_By>>;
  where?: InputMaybe<Mixpanel_Lookup_Bool_Exp>;
};


export type Subscription_RootMixpanel_Lookup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mixpanel_Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mixpanel_Lookup_Order_By>>;
  where?: InputMaybe<Mixpanel_Lookup_Bool_Exp>;
};


export type Subscription_RootMixpanel_Lookup_By_PkArgs = {
  hash: Scalars['String']['input'];
  mixpanel_id: Scalars['String']['input'];
};


export type Subscription_RootMixpanel_Lookup_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mixpanel_Lookup_Stream_Cursor_Input>>;
  where?: InputMaybe<Mixpanel_Lookup_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  trigger_key: Scalars['String']['input'];
  trigger_time: Scalars['timestamptz']['input'];
  user_address: Scalars['String']['input'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootOob_Tokens_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oob_Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootOob_Tokens_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Oob_Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Oob_Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootOob_Tokens_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootOob_Tokens_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Oob_Tokens_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Oob_Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootPartner_TypesArgs = {
  distinct_on?: InputMaybe<Array<Partner_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Types_Order_By>>;
  where?: InputMaybe<Partner_Types_Bool_Exp>;
};


export type Subscription_RootPartner_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partner_Types_Order_By>>;
  where?: InputMaybe<Partner_Types_Bool_Exp>;
};


export type Subscription_RootPartner_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootPartner_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partner_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Types_Bool_Exp>;
};


export type Subscription_RootPartnersArgs = {
  distinct_on?: InputMaybe<Array<Partners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partners_Order_By>>;
  where?: InputMaybe<Partners_Bool_Exp>;
};


export type Subscription_RootPartners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Partners_Order_By>>;
  where?: InputMaybe<Partners_Bool_Exp>;
};


export type Subscription_RootPartners_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPartners_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Partners_Stream_Cursor_Input>>;
  where?: InputMaybe<Partners_Bool_Exp>;
};


export type Subscription_RootPmp_Auth_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Auth_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Auth_Options_Order_By>>;
  where?: InputMaybe<Pmp_Auth_Options_Bool_Exp>;
};


export type Subscription_RootPmp_Auth_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Auth_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Auth_Options_Order_By>>;
  where?: InputMaybe<Pmp_Auth_Options_Bool_Exp>;
};


export type Subscription_RootPmp_Auth_Options_By_PkArgs = {
  option: Scalars['String']['input'];
};


export type Subscription_RootPmp_Auth_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pmp_Auth_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Pmp_Auth_Options_Bool_Exp>;
};


export type Subscription_RootPmp_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Configs_Bool_Exp>;
};


export type Subscription_RootPmp_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Configs_Bool_Exp>;
};


export type Subscription_RootPmp_Configs_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootPmp_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pmp_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Pmp_Configs_Bool_Exp>;
};


export type Subscription_RootPmp_Param_TypesArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Param_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Param_Types_Order_By>>;
  where?: InputMaybe<Pmp_Param_Types_Bool_Exp>;
};


export type Subscription_RootPmp_Param_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Param_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Param_Types_Order_By>>;
  where?: InputMaybe<Pmp_Param_Types_Bool_Exp>;
};


export type Subscription_RootPmp_Param_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootPmp_Param_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pmp_Param_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Pmp_Param_Types_Bool_Exp>;
};


export type Subscription_RootPmp_Project_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Project_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Project_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
};


export type Subscription_RootPmp_Project_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmp_Project_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmp_Project_Configs_Order_By>>;
  where?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
};


export type Subscription_RootPmp_Project_Configs_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootPmp_Project_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pmp_Project_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Pmp_Project_Configs_Bool_Exp>;
};


export type Subscription_RootPmps_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmps_Metadata_Order_By>>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};


export type Subscription_RootPmps_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmps_Metadata_Order_By>>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};


export type Subscription_RootPmps_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootPmps_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pmps_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};


export type Subscription_RootPrimary_PurchasesArgs = {
  distinct_on?: InputMaybe<Array<Primary_Purchases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Primary_Purchases_Order_By>>;
  where?: InputMaybe<Primary_Purchases_Bool_Exp>;
};


export type Subscription_RootPrimary_Purchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Primary_Purchases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Primary_Purchases_Order_By>>;
  where?: InputMaybe<Primary_Purchases_Bool_Exp>;
};


export type Subscription_RootPrimary_Purchases_By_PkArgs = {
  token_id: Scalars['String']['input'];
};


export type Subscription_RootPrimary_Purchases_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Primary_Purchases_Stream_Cursor_Input>>;
  where?: InputMaybe<Primary_Purchases_Bool_Exp>;
};


export type Subscription_RootProcessing_JobsArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Bool_Exp>;
};


export type Subscription_RootProcessing_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Bool_Exp>;
};


export type Subscription_RootProcessing_Jobs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProcessing_Jobs_Status_TypesArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Status_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Status_Types_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Status_Types_Bool_Exp>;
};


export type Subscription_RootProcessing_Jobs_Status_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Processing_Jobs_Status_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Processing_Jobs_Status_Types_Order_By>>;
  where?: InputMaybe<Processing_Jobs_Status_Types_Bool_Exp>;
};


export type Subscription_RootProcessing_Jobs_Status_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProcessing_Jobs_Status_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Processing_Jobs_Status_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Processing_Jobs_Status_Types_Bool_Exp>;
};


export type Subscription_RootProcessing_Jobs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Processing_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Processing_Jobs_Bool_Exp>;
};


export type Subscription_RootProject_External_Asset_DependenciesArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependencies_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
};


export type Subscription_RootProject_External_Asset_Dependencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependencies_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
};


export type Subscription_RootProject_External_Asset_Dependencies_By_PkArgs = {
  index: Scalars['Int']['input'];
  project_id: Scalars['String']['input'];
};


export type Subscription_RootProject_External_Asset_Dependencies_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_External_Asset_Dependencies_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_External_Asset_Dependencies_Bool_Exp>;
};


export type Subscription_RootProject_External_Asset_Dependency_TypesArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependency_Types_Bool_Exp>;
};


export type Subscription_RootProject_External_Asset_Dependency_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_External_Asset_Dependency_Types_Order_By>>;
  where?: InputMaybe<Project_External_Asset_Dependency_Types_Bool_Exp>;
};


export type Subscription_RootProject_External_Asset_Dependency_Types_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootProject_External_Asset_Dependency_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_External_Asset_Dependency_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_External_Asset_Dependency_Types_Bool_Exp>;
};


export type Subscription_RootProject_Minter_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Minter_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Minter_Configurations_Order_By>>;
  where?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
};


export type Subscription_RootProject_Minter_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Minter_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Minter_Configurations_Order_By>>;
  where?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
};


export type Subscription_RootProject_Minter_Configurations_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootProject_Minter_Configurations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Minter_Configurations_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Minter_Configurations_Bool_Exp>;
};


export type Subscription_RootProject_Ranked_BidsArgs = {
  args: Project_Ranked_Bids_Args;
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Subscription_RootProject_Ranked_Bids_AggregateArgs = {
  args: Project_Ranked_Bids_Args;
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


export type Subscription_RootProject_ScriptsArgs = {
  distinct_on?: InputMaybe<Array<Project_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Scripts_Order_By>>;
  where?: InputMaybe<Project_Scripts_Bool_Exp>;
};


export type Subscription_RootProject_Scripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Scripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Scripts_Order_By>>;
  where?: InputMaybe<Project_Scripts_Bool_Exp>;
};


export type Subscription_RootProject_Scripts_By_PkArgs = {
  index: Scalars['Int']['input'];
  project_id: Scalars['String']['input'];
};


export type Subscription_RootProject_Scripts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Scripts_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Scripts_Bool_Exp>;
};


export type Subscription_RootProject_SeriesArgs = {
  distinct_on?: InputMaybe<Array<Project_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Series_Order_By>>;
  where?: InputMaybe<Project_Series_Bool_Exp>;
};


export type Subscription_RootProject_Series_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Series_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Series_Order_By>>;
  where?: InputMaybe<Project_Series_Bool_Exp>;
};


export type Subscription_RootProject_Series_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProject_Series_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Series_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Series_Bool_Exp>;
};


export type Subscription_RootProject_Vertical_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Project_Vertical_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Vertical_Categories_Order_By>>;
  where?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
};


export type Subscription_RootProject_Vertical_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Vertical_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Vertical_Categories_Order_By>>;
  where?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
};


export type Subscription_RootProject_Vertical_Categories_By_PkArgs = {
  name: Categories_Enum;
};


export type Subscription_RootProject_Vertical_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Vertical_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Vertical_Categories_Bool_Exp>;
};


export type Subscription_RootProject_VerticalsArgs = {
  distinct_on?: InputMaybe<Array<Project_Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Verticals_Order_By>>;
  where?: InputMaybe<Project_Verticals_Bool_Exp>;
};


export type Subscription_RootProject_Verticals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Verticals_Order_By>>;
  where?: InputMaybe<Project_Verticals_Bool_Exp>;
};


export type Subscription_RootProject_Verticals_By_PkArgs = {
  name: Verticals_Enum;
};


export type Subscription_RootProject_Verticals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Verticals_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Verticals_Bool_Exp>;
};


export type Subscription_RootProjects_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Projects_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Features_Order_By>>;
  where?: InputMaybe<Projects_Features_Bool_Exp>;
};


export type Subscription_RootProjects_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Features_Order_By>>;
  where?: InputMaybe<Projects_Features_Bool_Exp>;
};


export type Subscription_RootProjects_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProjects_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Projects_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_Features_Bool_Exp>;
};


export type Subscription_RootProjects_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Subscription_RootProjects_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Subscription_RootProjects_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootProjects_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Projects_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Subscription_RootProposed_Artist_Addresses_And_SplitsArgs = {
  distinct_on?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Order_By>>;
  where?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Bool_Exp>;
};


export type Subscription_RootProposed_Artist_Addresses_And_Splits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Proposed_Artist_Addresses_And_Splits_Order_By>>;
  where?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Bool_Exp>;
};


export type Subscription_RootProposed_Artist_Addresses_And_Splits_By_PkArgs = {
  project_id: Scalars['String']['input'];
};


export type Subscription_RootProposed_Artist_Addresses_And_Splits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Proposed_Artist_Addresses_And_Splits_Stream_Cursor_Input>>;
  where?: InputMaybe<Proposed_Artist_Addresses_And_Splits_Bool_Exp>;
};


export type Subscription_RootReceipt_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


export type Subscription_RootReceipt_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


export type Subscription_RootReceipt_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootReceipt_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Receipt_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


export type Subscription_RootRefresh_Asset_TypesArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Asset_Types_Order_By>>;
  where?: InputMaybe<Refresh_Asset_Types_Bool_Exp>;
};


export type Subscription_RootRefresh_Asset_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Asset_Types_Order_By>>;
  where?: InputMaybe<Refresh_Asset_Types_Bool_Exp>;
};


export type Subscription_RootRefresh_Asset_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootRefresh_Asset_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refresh_Asset_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Refresh_Asset_Types_Bool_Exp>;
};


export type Subscription_RootRefresh_Request_TypesArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Request_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Request_Types_Order_By>>;
  where?: InputMaybe<Refresh_Request_Types_Bool_Exp>;
};


export type Subscription_RootRefresh_Request_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Request_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Request_Types_Order_By>>;
  where?: InputMaybe<Refresh_Request_Types_Bool_Exp>;
};


export type Subscription_RootRefresh_Request_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootRefresh_Request_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refresh_Request_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Refresh_Request_Types_Bool_Exp>;
};


export type Subscription_RootRefresh_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Requests_Order_By>>;
  where?: InputMaybe<Refresh_Requests_Bool_Exp>;
};


export type Subscription_RootRefresh_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refresh_Requests_Order_By>>;
  where?: InputMaybe<Refresh_Requests_Bool_Exp>;
};


export type Subscription_RootRefresh_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRefresh_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refresh_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Refresh_Requests_Bool_Exp>;
};


export type Subscription_RootRender_TypesArgs = {
  distinct_on?: InputMaybe<Array<Render_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Render_Types_Order_By>>;
  where?: InputMaybe<Render_Types_Bool_Exp>;
};


export type Subscription_RootRender_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Render_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Render_Types_Order_By>>;
  where?: InputMaybe<Render_Types_Bool_Exp>;
};


export type Subscription_RootRender_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootRender_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Render_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Render_Types_Bool_Exp>;
};


export type Subscription_RootRoyalty_Split_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Split_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Split_Recipients_Order_By>>;
  where?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
};


export type Subscription_RootRoyalty_Split_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Split_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Split_Recipients_Order_By>>;
  where?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
};


export type Subscription_RootRoyalty_Split_Recipients_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootRoyalty_Split_Recipients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Royalty_Split_Recipients_Stream_Cursor_Input>>;
  where?: InputMaybe<Royalty_Split_Recipients_Bool_Exp>;
};


export type Subscription_RootRoyalty_Splitter_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Splitter_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Splitter_Contracts_Order_By>>;
  where?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
};


export type Subscription_RootRoyalty_Splitter_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Royalty_Splitter_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Royalty_Splitter_Contracts_Order_By>>;
  where?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
};


export type Subscription_RootRoyalty_Splitter_Contracts_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Subscription_RootRoyalty_Splitter_Contracts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Royalty_Splitter_Contracts_Stream_Cursor_Input>>;
  where?: InputMaybe<Royalty_Splitter_Contracts_Bool_Exp>;
};


export type Subscription_RootScreeningsArgs = {
  distinct_on?: InputMaybe<Array<Screenings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screenings_Order_By>>;
  where?: InputMaybe<Screenings_Bool_Exp>;
};


export type Subscription_RootScreenings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Screenings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screenings_Order_By>>;
  where?: InputMaybe<Screenings_Bool_Exp>;
};


export type Subscription_RootScreenings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootScreenings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Screenings_Stream_Cursor_Input>>;
  where?: InputMaybe<Screenings_Bool_Exp>;
};


export type Subscription_RootSearch_ProjectsArgs = {
  args: Search_Projects_Args;
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Subscription_RootSearch_Projects_AggregateArgs = {
  args: Search_Projects_Args;
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


export type Subscription_RootSearch_TagsArgs = {
  args: Search_Tags_Args;
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootSearch_Tags_AggregateArgs = {
  args: Search_Tags_Args;
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootSearch_TokensArgs = {
  args: Search_Tokens_Args;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootSearch_Tokens_AggregateArgs = {
  args: Search_Tokens_Args;
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootSearch_UsersArgs = {
  args: Search_Users_Args;
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootSearch_Users_AggregateArgs = {
  args: Search_Users_Args;
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootSplit_Atomic_ContractsArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Contracts_Order_By>>;
  where?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
};


export type Subscription_RootSplit_Atomic_Contracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Contracts_Order_By>>;
  where?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
};


export type Subscription_RootSplit_Atomic_Contracts_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Subscription_RootSplit_Atomic_Contracts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Split_Atomic_Contracts_Stream_Cursor_Input>>;
  where?: InputMaybe<Split_Atomic_Contracts_Bool_Exp>;
};


export type Subscription_RootSplit_Atomic_FactoriesArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Factories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Factories_Order_By>>;
  where?: InputMaybe<Split_Atomic_Factories_Bool_Exp>;
};


export type Subscription_RootSplit_Atomic_Factories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Split_Atomic_Factories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Atomic_Factories_Order_By>>;
  where?: InputMaybe<Split_Atomic_Factories_Bool_Exp>;
};


export type Subscription_RootSplit_Atomic_Factories_By_PkArgs = {
  address: Scalars['String']['input'];
};


export type Subscription_RootSplit_Atomic_Factories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Split_Atomic_Factories_Stream_Cursor_Input>>;
  where?: InputMaybe<Split_Atomic_Factories_Bool_Exp>;
};


export type Subscription_RootSplit_Payment_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Split_Payment_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Payment_Configurations_Order_By>>;
  where?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
};


export type Subscription_RootSplit_Payment_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Split_Payment_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Split_Payment_Configurations_Order_By>>;
  where?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
};


export type Subscription_RootSplit_Payment_Configurations_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootSplit_Payment_Configurations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Split_Payment_Configurations_Stream_Cursor_Input>>;
  where?: InputMaybe<Split_Payment_Configurations_Bool_Exp>;
};


export type Subscription_RootSync_StatusArgs = {
  distinct_on?: InputMaybe<Array<Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sync_Status_Order_By>>;
  where?: InputMaybe<Sync_Status_Bool_Exp>;
};


export type Subscription_RootSync_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sync_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sync_Status_Order_By>>;
  where?: InputMaybe<Sync_Status_Bool_Exp>;
};


export type Subscription_RootSync_Status_By_PkArgs = {
  id: Scalars['Boolean']['input'];
};


export type Subscription_RootSync_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sync_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Sync_Status_Bool_Exp>;
};


export type Subscription_RootTag_GroupingsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Groupings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Groupings_Order_By>>;
  where?: InputMaybe<Tag_Groupings_Bool_Exp>;
};


export type Subscription_RootTag_Groupings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Groupings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Groupings_Order_By>>;
  where?: InputMaybe<Tag_Groupings_Bool_Exp>;
};


export type Subscription_RootTag_Groupings_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootTag_Groupings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Groupings_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Groupings_Bool_Exp>;
};


export type Subscription_RootTag_StatusArgs = {
  distinct_on?: InputMaybe<Array<Tag_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Status_Order_By>>;
  where?: InputMaybe<Tag_Status_Bool_Exp>;
};


export type Subscription_RootTag_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Status_Order_By>>;
  where?: InputMaybe<Tag_Status_Bool_Exp>;
};


export type Subscription_RootTag_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTag_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Status_Bool_Exp>;
};


export type Subscription_RootTag_TypesArgs = {
  distinct_on?: InputMaybe<Array<Tag_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Types_Order_By>>;
  where?: InputMaybe<Tag_Types_Bool_Exp>;
};


export type Subscription_RootTag_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Types_Order_By>>;
  where?: InputMaybe<Tag_Types_Bool_Exp>;
};


export type Subscription_RootTag_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTag_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Types_Bool_Exp>;
};


export type Subscription_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootTags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTokens_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootTokens_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootTokens_Metadata_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTokens_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tokens_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


export type Subscription_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Profiles_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUser_Profiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Profiles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  public_address: Scalars['String']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVerticalsArgs = {
  distinct_on?: InputMaybe<Array<Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verticals_Order_By>>;
  where?: InputMaybe<Verticals_Bool_Exp>;
};


export type Subscription_RootVerticals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verticals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verticals_Order_By>>;
  where?: InputMaybe<Verticals_Bool_Exp>;
};


export type Subscription_RootVerticals_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootVerticals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Verticals_Stream_Cursor_Input>>;
  where?: InputMaybe<Verticals_Bool_Exp>;
};


export type Subscription_RootVideo_Aspect_RatiosArgs = {
  distinct_on?: InputMaybe<Array<Video_Aspect_Ratios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Aspect_Ratios_Order_By>>;
  where?: InputMaybe<Video_Aspect_Ratios_Bool_Exp>;
};


export type Subscription_RootVideo_Aspect_Ratios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Video_Aspect_Ratios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Aspect_Ratios_Order_By>>;
  where?: InputMaybe<Video_Aspect_Ratios_Bool_Exp>;
};


export type Subscription_RootVideo_Aspect_Ratios_By_PkArgs = {
  value: Scalars['numeric']['input'];
};


export type Subscription_RootVideo_Aspect_Ratios_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Video_Aspect_Ratios_Stream_Cursor_Input>>;
  where?: InputMaybe<Video_Aspect_Ratios_Bool_Exp>;
};


export type Subscription_RootVideo_Frame_RatesArgs = {
  distinct_on?: InputMaybe<Array<Video_Frame_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Frame_Rates_Order_By>>;
  where?: InputMaybe<Video_Frame_Rates_Bool_Exp>;
};


export type Subscription_RootVideo_Frame_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Video_Frame_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Frame_Rates_Order_By>>;
  where?: InputMaybe<Video_Frame_Rates_Bool_Exp>;
};


export type Subscription_RootVideo_Frame_Rates_By_PkArgs = {
  value: Scalars['Int']['input'];
};


export type Subscription_RootVideo_Frame_Rates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Video_Frame_Rates_Stream_Cursor_Input>>;
  where?: InputMaybe<Video_Frame_Rates_Bool_Exp>;
};


export type Subscription_RootWebflow_Artist_InfoArgs = {
  distinct_on?: InputMaybe<Array<Webflow_Artist_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webflow_Artist_Info_Order_By>>;
  where?: InputMaybe<Webflow_Artist_Info_Bool_Exp>;
};


export type Subscription_RootWebflow_Artist_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Webflow_Artist_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webflow_Artist_Info_Order_By>>;
  where?: InputMaybe<Webflow_Artist_Info_Bool_Exp>;
};


export type Subscription_RootWebflow_Artist_Info_By_PkArgs = {
  webflow_item_id: Scalars['String']['input'];
};


export type Subscription_RootWebflow_Artist_Info_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Webflow_Artist_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Webflow_Artist_Info_Bool_Exp>;
};


export type Subscription_RootWebflow_Spectrum_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Webflow_Spectrum_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webflow_Spectrum_Articles_Order_By>>;
  where?: InputMaybe<Webflow_Spectrum_Articles_Bool_Exp>;
};


export type Subscription_RootWebflow_Spectrum_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Webflow_Spectrum_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webflow_Spectrum_Articles_Order_By>>;
  where?: InputMaybe<Webflow_Spectrum_Articles_Bool_Exp>;
};


export type Subscription_RootWebflow_Spectrum_Articles_By_PkArgs = {
  webflow_item_id: Scalars['String']['input'];
};


export type Subscription_RootWebflow_Spectrum_Articles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Webflow_Spectrum_Articles_Stream_Cursor_Input>>;
  where?: InputMaybe<Webflow_Spectrum_Articles_Bool_Exp>;
};

/** columns and relationships of "sync_status" */
export type Sync_Status = {
  __typename?: 'sync_status';
  id: Scalars['Boolean']['output'];
  last_bid_updated_at: Scalars['timestamptz']['output'];
  last_contract_updated_at: Scalars['timestamptz']['output'];
  last_dependency_registry_updated_at: Scalars['timestamptz']['output'];
  last_dependency_updated_at: Scalars['timestamptz']['output'];
  last_minter_filter_updated_at: Scalars['timestamptz']['output'];
  last_minter_updated_at: Scalars['timestamptz']['output'];
  last_pmp_config_updated_at: Scalars['timestamptz']['output'];
  last_pmp_project_config_updated_at: Scalars['timestamptz']['output'];
  last_pmp_updated_at: Scalars['timestamptz']['output'];
  last_project_updated_at: Scalars['timestamptz']['output'];
  last_receipt_updated_at: Scalars['timestamptz']['output'];
  last_secondary_updated_at: Scalars['timestamptz']['output'];
  last_split_atomic_contract_updated_at: Scalars['timestamptz']['output'];
  last_split_atomic_factory_updated_at: Scalars['timestamptz']['output'];
  last_token_updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "sync_status" */
export type Sync_Status_Aggregate = {
  __typename?: 'sync_status_aggregate';
  aggregate?: Maybe<Sync_Status_Aggregate_Fields>;
  nodes: Array<Sync_Status>;
};

/** aggregate fields of "sync_status" */
export type Sync_Status_Aggregate_Fields = {
  __typename?: 'sync_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sync_Status_Max_Fields>;
  min?: Maybe<Sync_Status_Min_Fields>;
};


/** aggregate fields of "sync_status" */
export type Sync_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sync_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sync_status". All fields are combined with a logical 'AND'. */
export type Sync_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Sync_Status_Bool_Exp>>;
  _not?: InputMaybe<Sync_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Sync_Status_Bool_Exp>>;
  id?: InputMaybe<Boolean_Comparison_Exp>;
  last_bid_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_contract_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_dependency_registry_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_dependency_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_minter_filter_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_minter_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_pmp_config_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_pmp_project_config_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_pmp_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_project_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_receipt_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_secondary_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_split_atomic_contract_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_split_atomic_factory_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_token_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sync_status" */
export enum Sync_Status_Constraint {
  /** unique or primary key constraint on columns "id" */
  SyncStatusPkey = 'sync_status_pkey'
}

/** input type for inserting data into table "sync_status" */
export type Sync_Status_Insert_Input = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_bid_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_contract_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_dependency_registry_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_dependency_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_minter_filter_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_minter_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_config_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_project_config_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_project_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_receipt_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_secondary_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_split_atomic_contract_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_split_atomic_factory_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_token_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sync_Status_Max_Fields = {
  __typename?: 'sync_status_max_fields';
  last_bid_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_contract_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_dependency_registry_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_dependency_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_minter_filter_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_minter_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_pmp_config_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_pmp_project_config_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_pmp_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_project_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_receipt_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_secondary_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_split_atomic_contract_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_split_atomic_factory_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_token_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Sync_Status_Min_Fields = {
  __typename?: 'sync_status_min_fields';
  last_bid_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_contract_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_dependency_registry_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_dependency_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_minter_filter_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_minter_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_pmp_config_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_pmp_project_config_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_pmp_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_project_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_receipt_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_secondary_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_split_atomic_contract_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_split_atomic_factory_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  last_token_updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "sync_status" */
export type Sync_Status_Mutation_Response = {
  __typename?: 'sync_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sync_Status>;
};

/** on_conflict condition type for table "sync_status" */
export type Sync_Status_On_Conflict = {
  constraint: Sync_Status_Constraint;
  update_columns?: Array<Sync_Status_Update_Column>;
  where?: InputMaybe<Sync_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "sync_status". */
export type Sync_Status_Order_By = {
  id?: InputMaybe<Order_By>;
  last_bid_updated_at?: InputMaybe<Order_By>;
  last_contract_updated_at?: InputMaybe<Order_By>;
  last_dependency_registry_updated_at?: InputMaybe<Order_By>;
  last_dependency_updated_at?: InputMaybe<Order_By>;
  last_minter_filter_updated_at?: InputMaybe<Order_By>;
  last_minter_updated_at?: InputMaybe<Order_By>;
  last_pmp_config_updated_at?: InputMaybe<Order_By>;
  last_pmp_project_config_updated_at?: InputMaybe<Order_By>;
  last_pmp_updated_at?: InputMaybe<Order_By>;
  last_project_updated_at?: InputMaybe<Order_By>;
  last_receipt_updated_at?: InputMaybe<Order_By>;
  last_secondary_updated_at?: InputMaybe<Order_By>;
  last_split_atomic_contract_updated_at?: InputMaybe<Order_By>;
  last_split_atomic_factory_updated_at?: InputMaybe<Order_By>;
  last_token_updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sync_status */
export type Sync_Status_Pk_Columns_Input = {
  id: Scalars['Boolean']['input'];
};

/** select columns of table "sync_status" */
export enum Sync_Status_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LastBidUpdatedAt = 'last_bid_updated_at',
  /** column name */
  LastContractUpdatedAt = 'last_contract_updated_at',
  /** column name */
  LastDependencyRegistryUpdatedAt = 'last_dependency_registry_updated_at',
  /** column name */
  LastDependencyUpdatedAt = 'last_dependency_updated_at',
  /** column name */
  LastMinterFilterUpdatedAt = 'last_minter_filter_updated_at',
  /** column name */
  LastMinterUpdatedAt = 'last_minter_updated_at',
  /** column name */
  LastPmpConfigUpdatedAt = 'last_pmp_config_updated_at',
  /** column name */
  LastPmpProjectConfigUpdatedAt = 'last_pmp_project_config_updated_at',
  /** column name */
  LastPmpUpdatedAt = 'last_pmp_updated_at',
  /** column name */
  LastProjectUpdatedAt = 'last_project_updated_at',
  /** column name */
  LastReceiptUpdatedAt = 'last_receipt_updated_at',
  /** column name */
  LastSecondaryUpdatedAt = 'last_secondary_updated_at',
  /** column name */
  LastSplitAtomicContractUpdatedAt = 'last_split_atomic_contract_updated_at',
  /** column name */
  LastSplitAtomicFactoryUpdatedAt = 'last_split_atomic_factory_updated_at',
  /** column name */
  LastTokenUpdatedAt = 'last_token_updated_at'
}

/** input type for updating data in table "sync_status" */
export type Sync_Status_Set_Input = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_bid_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_contract_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_dependency_registry_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_dependency_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_minter_filter_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_minter_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_config_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_project_config_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_project_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_receipt_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_secondary_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_split_atomic_contract_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_split_atomic_factory_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_token_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "sync_status" */
export type Sync_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sync_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sync_Status_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_bid_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_contract_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_dependency_registry_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_dependency_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_minter_filter_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_minter_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_config_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_project_config_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_pmp_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_project_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_receipt_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_secondary_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_split_atomic_contract_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_split_atomic_factory_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_token_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "sync_status" */
export enum Sync_Status_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LastBidUpdatedAt = 'last_bid_updated_at',
  /** column name */
  LastContractUpdatedAt = 'last_contract_updated_at',
  /** column name */
  LastDependencyRegistryUpdatedAt = 'last_dependency_registry_updated_at',
  /** column name */
  LastDependencyUpdatedAt = 'last_dependency_updated_at',
  /** column name */
  LastMinterFilterUpdatedAt = 'last_minter_filter_updated_at',
  /** column name */
  LastMinterUpdatedAt = 'last_minter_updated_at',
  /** column name */
  LastPmpConfigUpdatedAt = 'last_pmp_config_updated_at',
  /** column name */
  LastPmpProjectConfigUpdatedAt = 'last_pmp_project_config_updated_at',
  /** column name */
  LastPmpUpdatedAt = 'last_pmp_updated_at',
  /** column name */
  LastProjectUpdatedAt = 'last_project_updated_at',
  /** column name */
  LastReceiptUpdatedAt = 'last_receipt_updated_at',
  /** column name */
  LastSecondaryUpdatedAt = 'last_secondary_updated_at',
  /** column name */
  LastSplitAtomicContractUpdatedAt = 'last_split_atomic_contract_updated_at',
  /** column name */
  LastSplitAtomicFactoryUpdatedAt = 'last_split_atomic_factory_updated_at',
  /** column name */
  LastTokenUpdatedAt = 'last_token_updated_at'
}

export type Sync_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sync_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sync_Status_Bool_Exp;
};

/** columns and relationships of "tag_groupings" */
export type Tag_Groupings = {
  __typename?: 'tag_groupings';
  name: Scalars['String']['output'];
};

/** aggregated selection of "tag_groupings" */
export type Tag_Groupings_Aggregate = {
  __typename?: 'tag_groupings_aggregate';
  aggregate?: Maybe<Tag_Groupings_Aggregate_Fields>;
  nodes: Array<Tag_Groupings>;
};

/** aggregate fields of "tag_groupings" */
export type Tag_Groupings_Aggregate_Fields = {
  __typename?: 'tag_groupings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tag_Groupings_Max_Fields>;
  min?: Maybe<Tag_Groupings_Min_Fields>;
};


/** aggregate fields of "tag_groupings" */
export type Tag_Groupings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Groupings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tag_groupings". All fields are combined with a logical 'AND'. */
export type Tag_Groupings_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Groupings_Bool_Exp>>;
  _not?: InputMaybe<Tag_Groupings_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Groupings_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag_groupings" */
export enum Tag_Groupings_Constraint {
  /** unique or primary key constraint on columns "name" */
  TagGroupingsPkey = 'tag_groupings_pkey'
}

export enum Tag_Groupings_Enum {
  Heritage = 'heritage',
  Presentation = 'presentation',
  Social = 'social',
  Unassigned = 'unassigned'
}

/** Boolean expression to compare columns of type "tag_groupings_enum". All fields are combined with logical 'AND'. */
export type Tag_Groupings_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tag_Groupings_Enum>;
  _in?: InputMaybe<Array<Tag_Groupings_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tag_Groupings_Enum>;
  _nin?: InputMaybe<Array<Tag_Groupings_Enum>>;
};

/** input type for inserting data into table "tag_groupings" */
export type Tag_Groupings_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tag_Groupings_Max_Fields = {
  __typename?: 'tag_groupings_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tag_Groupings_Min_Fields = {
  __typename?: 'tag_groupings_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tag_groupings" */
export type Tag_Groupings_Mutation_Response = {
  __typename?: 'tag_groupings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Groupings>;
};

/** on_conflict condition type for table "tag_groupings" */
export type Tag_Groupings_On_Conflict = {
  constraint: Tag_Groupings_Constraint;
  update_columns?: Array<Tag_Groupings_Update_Column>;
  where?: InputMaybe<Tag_Groupings_Bool_Exp>;
};

/** Ordering options when selecting data from "tag_groupings". */
export type Tag_Groupings_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag_groupings */
export type Tag_Groupings_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "tag_groupings" */
export enum Tag_Groupings_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "tag_groupings" */
export type Tag_Groupings_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tag_groupings" */
export type Tag_Groupings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Groupings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Groupings_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tag_groupings" */
export enum Tag_Groupings_Update_Column {
  /** column name */
  Name = 'name'
}

export type Tag_Groupings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Groupings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Groupings_Bool_Exp;
};

/** columns and relationships of "tag_status" */
export type Tag_Status = {
  __typename?: 'tag_status';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "tag_status" */
export type Tag_Status_Aggregate = {
  __typename?: 'tag_status_aggregate';
  aggregate?: Maybe<Tag_Status_Aggregate_Fields>;
  nodes: Array<Tag_Status>;
};

/** aggregate fields of "tag_status" */
export type Tag_Status_Aggregate_Fields = {
  __typename?: 'tag_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tag_Status_Max_Fields>;
  min?: Maybe<Tag_Status_Min_Fields>;
};


/** aggregate fields of "tag_status" */
export type Tag_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tag_status". All fields are combined with a logical 'AND'. */
export type Tag_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Status_Bool_Exp>>;
  _not?: InputMaybe<Tag_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag_status" */
export enum Tag_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  TagStatusEnumPkey = 'tag_status_enum_pkey'
}

export enum Tag_Status_Enum {
  /** private status */
  Private = 'private',
  /** public status */
  Public = 'public'
}

/** Boolean expression to compare columns of type "tag_status_enum". All fields are combined with logical 'AND'. */
export type Tag_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tag_Status_Enum>;
  _in?: InputMaybe<Array<Tag_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tag_Status_Enum>;
  _nin?: InputMaybe<Array<Tag_Status_Enum>>;
};

/** input type for inserting data into table "tag_status" */
export type Tag_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tag_Status_Max_Fields = {
  __typename?: 'tag_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tag_Status_Min_Fields = {
  __typename?: 'tag_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tag_status" */
export type Tag_Status_Mutation_Response = {
  __typename?: 'tag_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Status>;
};

/** input type for inserting object relation for remote table "tag_status" */
export type Tag_Status_Obj_Rel_Insert_Input = {
  data: Tag_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Status_On_Conflict>;
};

/** on_conflict condition type for table "tag_status" */
export type Tag_Status_On_Conflict = {
  constraint: Tag_Status_Constraint;
  update_columns?: Array<Tag_Status_Update_Column>;
  where?: InputMaybe<Tag_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "tag_status". */
export type Tag_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag_status */
export type Tag_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "tag_status" */
export enum Tag_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tag_status" */
export type Tag_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tag_status" */
export type Tag_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tag_status" */
export enum Tag_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Tag_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Status_Bool_Exp;
};

/** columns and relationships of "tag_types" */
export type Tag_Types = {
  __typename?: 'tag_types';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "tag_types" */
export type Tag_Types_Aggregate = {
  __typename?: 'tag_types_aggregate';
  aggregate?: Maybe<Tag_Types_Aggregate_Fields>;
  nodes: Array<Tag_Types>;
};

/** aggregate fields of "tag_types" */
export type Tag_Types_Aggregate_Fields = {
  __typename?: 'tag_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tag_Types_Max_Fields>;
  min?: Maybe<Tag_Types_Min_Fields>;
};


/** aggregate fields of "tag_types" */
export type Tag_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tag_types". All fields are combined with a logical 'AND'. */
export type Tag_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Types_Bool_Exp>>;
  _not?: InputMaybe<Tag_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Types_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag_types" */
export enum Tag_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  TagTypesEnumPkey = 'tag_types_enum_pkey'
}

export enum Tag_Types_Enum {
  /** tag type of project */
  Project = 'project',
  /** tag type of user */
  User = 'user'
}

/** Boolean expression to compare columns of type "tag_types_enum". All fields are combined with logical 'AND'. */
export type Tag_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tag_Types_Enum>;
  _in?: InputMaybe<Array<Tag_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tag_Types_Enum>;
  _nin?: InputMaybe<Array<Tag_Types_Enum>>;
};

/** input type for inserting data into table "tag_types" */
export type Tag_Types_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tag_Types_Max_Fields = {
  __typename?: 'tag_types_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tag_Types_Min_Fields = {
  __typename?: 'tag_types_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tag_types" */
export type Tag_Types_Mutation_Response = {
  __typename?: 'tag_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Types>;
};

/** input type for inserting object relation for remote table "tag_types" */
export type Tag_Types_Obj_Rel_Insert_Input = {
  data: Tag_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Types_On_Conflict>;
};

/** on_conflict condition type for table "tag_types" */
export type Tag_Types_On_Conflict = {
  constraint: Tag_Types_Constraint;
  update_columns?: Array<Tag_Types_Update_Column>;
  where?: InputMaybe<Tag_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "tag_types". */
export type Tag_Types_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag_types */
export type Tag_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "tag_types" */
export enum Tag_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tag_types" */
export type Tag_Types_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tag_types" */
export type Tag_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Types_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tag_types" */
export enum Tag_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Tag_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Types_Bool_Exp;
};

/** Each variety of metadata tag used for projects. */
export type Tags = {
  __typename?: 'tags';
  description?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  /** An array relationship */
  entity_tags: Array<Entity_Tags>;
  /** An aggregate relationship */
  entity_tags_aggregate: Entity_Tags_Aggregate;
  grouping_name: Tag_Groupings_Enum;
  name: Scalars['String']['output'];
  status: Tag_Status_Enum;
  /** An object relationship */
  status_enum: Tag_Status;
  tagline?: Maybe<Scalars['String']['output']>;
  type: Tag_Types_Enum;
  /** An object relationship */
  type_enum: Tag_Types;
};


/** Each variety of metadata tag used for projects. */
export type TagsEntity_TagsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


/** Each variety of metadata tag used for projects. */
export type TagsEntity_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};

export type Tags_Aggregate = {
  __typename?: 'tags_aggregate';
  aggregate?: Maybe<Tags_Aggregate_Fields>;
  nodes: Array<Tags>;
};

/** aggregate fields of "tags" */
export type Tags_Aggregate_Fields = {
  __typename?: 'tags_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tags_Max_Fields>;
  min?: Maybe<Tags_Min_Fields>;
};


/** aggregate fields of "tags" */
export type Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Tags_Bool_Exp>>;
  _not?: InputMaybe<Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Tags_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  entity_tags?: InputMaybe<Entity_Tags_Bool_Exp>;
  entity_tags_aggregate?: InputMaybe<Entity_Tags_Aggregate_Bool_Exp>;
  grouping_name?: InputMaybe<Tag_Groupings_Enum_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Tag_Status_Enum_Comparison_Exp>;
  status_enum?: InputMaybe<Tag_Status_Bool_Exp>;
  tagline?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Tag_Types_Enum_Comparison_Exp>;
  type_enum?: InputMaybe<Tag_Types_Bool_Exp>;
};

/** unique or primary key constraints on table "tags" */
export enum Tags_Constraint {
  /** unique or primary key constraint on columns "name" */
  TagsPkey = 'tags_pkey'
}

/** input type for inserting data into table "tags" */
export type Tags_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  entity_tags?: InputMaybe<Entity_Tags_Arr_Rel_Insert_Input>;
  grouping_name?: InputMaybe<Tag_Groupings_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Tag_Status_Enum>;
  status_enum?: InputMaybe<Tag_Status_Obj_Rel_Insert_Input>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tag_Types_Enum>;
  type_enum?: InputMaybe<Tag_Types_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tags_Max_Fields = {
  __typename?: 'tags_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tags_Min_Fields = {
  __typename?: 'tags_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tags" */
export type Tags_Mutation_Response = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type Tags_Obj_Rel_Insert_Input = {
  data: Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** on_conflict condition type for table "tags" */
export type Tags_On_Conflict = {
  constraint: Tags_Constraint;
  update_columns?: Array<Tags_Update_Column>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "tags". */
export type Tags_Order_By = {
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  entity_tags_aggregate?: InputMaybe<Entity_Tags_Aggregate_Order_By>;
  grouping_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_enum?: InputMaybe<Tag_Status_Order_By>;
  tagline?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  type_enum?: InputMaybe<Tag_Types_Order_By>;
};

/** primary key columns input for table: tags */
export type Tags_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "tags" */
export enum Tags_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GroupingName = 'grouping_name',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "tags" */
export type Tags_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  grouping_name?: InputMaybe<Tag_Groupings_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Tag_Status_Enum>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tag_Types_Enum>;
};

/** Streaming cursor of the table "tags" */
export type Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tags_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  grouping_name?: InputMaybe<Tag_Groupings_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Tag_Status_Enum>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Tag_Types_Enum>;
};

/** update columns of table "tags" */
export enum Tags_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GroupingName = 'grouping_name',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  Type = 'type'
}

export type Tags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tags_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_Metadata = {
  __typename?: 'tokens_metadata';
  /** all active pmps_metadata for a token, considering the current pmp project config */
  active_pmps?: Maybe<Array<Pmps_Metadata>>;
  /** An array relationship */
  bids: Array<Bids_Metadata>;
  /** An aggregate relationship */
  bids_aggregate: Bids_Metadata_Aggregate;
  /** An object relationship */
  contract?: Maybe<Contracts_Metadata>;
  contract_address: Scalars['String']['output'];
  /** A computed field, executes function "token_favorited_by_user" */
  favorited_by_user?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  favorites: Array<Favorites>;
  /** An aggregate relationship */
  favorites_aggregate: Favorites_Aggregate;
  features: Scalars['jsonb']['output'];
  /** An object relationship */
  gif?: Maybe<Media>;
  gif_id?: Maybe<Scalars['Int']['output']>;
  hash: Scalars['String']['output'];
  /** An object relationship */
  high_res_image?: Maybe<Media>;
  high_res_image_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** An object relationship */
  image?: Maybe<Media>;
  image_id?: Maybe<Scalars['Int']['output']>;
  invocation: Scalars['Int']['output'];
  is_flagged: Scalars['Boolean']['output'];
  last_refreshed?: Maybe<Scalars['timestamptz']['output']>;
  list_creation_date?: Maybe<Scalars['timestamptz']['output']>;
  list_currency_address?: Maybe<Scalars['String']['output']>;
  list_currency_symbol?: Maybe<Scalars['String']['output']>;
  list_eth_price?: Maybe<Scalars['float8']['output']>;
  list_expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  list_platform?: Maybe<Scalars['String']['output']>;
  list_price?: Maybe<Scalars['float8']['output']>;
  list_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "live_view_path" */
  live_view_path?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "live_view_url" */
  live_view_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  low_res_image?: Maybe<Media>;
  low_res_image_id?: Maybe<Scalars['Int']['output']>;
  /** a computed field that returns the media proxy url for this token's statically rendered image */
  media_url?: Maybe<Scalars['String']['output']>;
  mint_transaction_hash?: Maybe<Scalars['String']['output']>;
  minted_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  owner?: Maybe<Users>;
  owner_address: Scalars['String']['output'];
  /** An array relationship */
  pmps: Array<Pmps_Metadata>;
  /** An aggregate relationship */
  pmps_aggregate: Pmps_Metadata_Aggregate;
  /** returns the preview asset url based on preview_render_type and availability */
  preview_asset_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "primary_asset_url" */
  primary_asset_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  primary_purchase_details?: Maybe<Primary_Purchases>;
  primary_purchase_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project: Projects_Metadata;
  project_id: Scalars['String']['output'];
  project_name?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Token>;
  token_id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  video?: Maybe<Media>;
  video_id?: Maybe<Scalars['Int']['output']>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataActive_PmpsArgs = {
  distinct_on?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmps_Metadata_Order_By>>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataFavoritesArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataFavorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataFeaturesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataPmpsArgs = {
  distinct_on?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmps_Metadata_Order_By>>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataPmps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pmps_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pmps_Metadata_Order_By>>;
  where?: InputMaybe<Pmps_Metadata_Bool_Exp>;
};


/** All token details are added here after a new Art Blocks token is minted. Data will be updated upon a listing, sale, or transfer of the token. */
export type Tokens_MetadataTokenArgs = {
  block?: InputMaybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
};

/** aggregated selection of "tokens_metadata" */
export type Tokens_Metadata_Aggregate = {
  __typename?: 'tokens_metadata_aggregate';
  aggregate?: Maybe<Tokens_Metadata_Aggregate_Fields>;
  nodes: Array<Tokens_Metadata>;
};

export type Tokens_Metadata_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp_Var_Samp>;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Avg = {
  arguments: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Corr = {
  arguments: Tokens_Metadata_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Tokens_Metadata_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Max = {
  arguments: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Min = {
  arguments: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Sum = {
  arguments: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Tokens_Metadata_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "tokens_metadata" */
export type Tokens_Metadata_Aggregate_Fields = {
  __typename?: 'tokens_metadata_aggregate_fields';
  avg?: Maybe<Tokens_Metadata_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tokens_Metadata_Max_Fields>;
  min?: Maybe<Tokens_Metadata_Min_Fields>;
  stddev?: Maybe<Tokens_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Tokens_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tokens_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Tokens_Metadata_Sum_Fields>;
  var_pop?: Maybe<Tokens_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Tokens_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Tokens_Metadata_Variance_Fields>;
};


/** aggregate fields of "tokens_metadata" */
export type Tokens_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tokens_metadata" */
export type Tokens_Metadata_Aggregate_Order_By = {
  avg?: InputMaybe<Tokens_Metadata_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tokens_Metadata_Max_Order_By>;
  min?: InputMaybe<Tokens_Metadata_Min_Order_By>;
  stddev?: InputMaybe<Tokens_Metadata_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tokens_Metadata_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tokens_Metadata_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tokens_Metadata_Sum_Order_By>;
  var_pop?: InputMaybe<Tokens_Metadata_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tokens_Metadata_Var_Samp_Order_By>;
  variance?: InputMaybe<Tokens_Metadata_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tokens_Metadata_Append_Input = {
  features?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "tokens_metadata" */
export type Tokens_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Tokens_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tokens_Metadata_On_Conflict>;
};

/** aggregate avg on columns */
export type Tokens_Metadata_Avg_Fields = {
  __typename?: 'tokens_metadata_avg_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  high_res_image_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  invocation?: Maybe<Scalars['Float']['output']>;
  list_eth_price?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['Float']['output']>;
  low_res_image_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Avg_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tokens_metadata". All fields are combined with a logical 'AND'. */
export type Tokens_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Tokens_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Tokens_Metadata_Bool_Exp>>;
  active_pmps?: InputMaybe<Pmps_Metadata_Bool_Exp>;
  bids?: InputMaybe<Bids_Metadata_Bool_Exp>;
  bids_aggregate?: InputMaybe<Bids_Metadata_Aggregate_Bool_Exp>;
  contract?: InputMaybe<Contracts_Metadata_Bool_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  favorited_by_user?: InputMaybe<Boolean_Comparison_Exp>;
  favorites?: InputMaybe<Favorites_Bool_Exp>;
  favorites_aggregate?: InputMaybe<Favorites_Aggregate_Bool_Exp>;
  features?: InputMaybe<Jsonb_Comparison_Exp>;
  gif?: InputMaybe<Media_Bool_Exp>;
  gif_id?: InputMaybe<Int_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  high_res_image?: InputMaybe<Media_Bool_Exp>;
  high_res_image_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  image?: InputMaybe<Media_Bool_Exp>;
  image_id?: InputMaybe<Int_Comparison_Exp>;
  invocation?: InputMaybe<Int_Comparison_Exp>;
  is_flagged?: InputMaybe<Boolean_Comparison_Exp>;
  last_refreshed?: InputMaybe<Timestamptz_Comparison_Exp>;
  list_creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  list_currency_address?: InputMaybe<String_Comparison_Exp>;
  list_currency_symbol?: InputMaybe<String_Comparison_Exp>;
  list_eth_price?: InputMaybe<Float8_Comparison_Exp>;
  list_expiration_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  list_platform?: InputMaybe<String_Comparison_Exp>;
  list_price?: InputMaybe<Float8_Comparison_Exp>;
  list_url?: InputMaybe<String_Comparison_Exp>;
  live_view_path?: InputMaybe<String_Comparison_Exp>;
  live_view_url?: InputMaybe<String_Comparison_Exp>;
  low_res_image?: InputMaybe<Media_Bool_Exp>;
  low_res_image_id?: InputMaybe<Int_Comparison_Exp>;
  media_url?: InputMaybe<String_Comparison_Exp>;
  mint_transaction_hash?: InputMaybe<String_Comparison_Exp>;
  minted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_address?: InputMaybe<String_Comparison_Exp>;
  pmps?: InputMaybe<Pmps_Metadata_Bool_Exp>;
  pmps_aggregate?: InputMaybe<Pmps_Metadata_Aggregate_Bool_Exp>;
  preview_asset_url?: InputMaybe<String_Comparison_Exp>;
  primary_asset_url?: InputMaybe<String_Comparison_Exp>;
  primary_purchase_details?: InputMaybe<Primary_Purchases_Bool_Exp>;
  primary_purchase_id?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  token_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  video?: InputMaybe<Media_Bool_Exp>;
  video_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "tokens_metadata" */
export enum Tokens_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  TokensMetadataPkey = 'tokens_metadata_pkey',
  /** unique or primary key constraint on columns "token_id", "contract_address" */
  TokensMetadataTokenIdContractAddressKey = 'tokens_metadata_token_id_contract_address_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tokens_Metadata_Delete_At_Path_Input = {
  features?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tokens_Metadata_Delete_Elem_Input = {
  features?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tokens_Metadata_Delete_Key_Input = {
  features?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "tokens_metadata" */
export type Tokens_Metadata_Inc_Input = {
  gif_id?: InputMaybe<Scalars['Int']['input']>;
  high_res_image_id?: InputMaybe<Scalars['Int']['input']>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  list_eth_price?: InputMaybe<Scalars['float8']['input']>;
  list_price?: InputMaybe<Scalars['float8']['input']>;
  low_res_image_id?: InputMaybe<Scalars['Int']['input']>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tokens_metadata" */
export type Tokens_Metadata_Insert_Input = {
  bids?: InputMaybe<Bids_Metadata_Arr_Rel_Insert_Input>;
  contract?: InputMaybe<Contracts_Metadata_Obj_Rel_Insert_Input>;
  contract_address?: InputMaybe<Scalars['String']['input']>;
  favorites?: InputMaybe<Favorites_Arr_Rel_Insert_Input>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  gif?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  gif_id?: InputMaybe<Scalars['Int']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  high_res_image?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  high_res_image_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  is_flagged?: InputMaybe<Scalars['Boolean']['input']>;
  last_refreshed?: InputMaybe<Scalars['timestamptz']['input']>;
  list_creation_date?: InputMaybe<Scalars['timestamptz']['input']>;
  list_currency_address?: InputMaybe<Scalars['String']['input']>;
  list_currency_symbol?: InputMaybe<Scalars['String']['input']>;
  list_eth_price?: InputMaybe<Scalars['float8']['input']>;
  list_expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  list_platform?: InputMaybe<Scalars['String']['input']>;
  list_price?: InputMaybe<Scalars['float8']['input']>;
  list_url?: InputMaybe<Scalars['String']['input']>;
  low_res_image?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  low_res_image_id?: InputMaybe<Scalars['Int']['input']>;
  mint_transaction_hash?: InputMaybe<Scalars['String']['input']>;
  minted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  owner_address?: InputMaybe<Scalars['String']['input']>;
  pmps?: InputMaybe<Pmps_Metadata_Arr_Rel_Insert_Input>;
  primary_purchase_details?: InputMaybe<Primary_Purchases_Obj_Rel_Insert_Input>;
  primary_purchase_id?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Projects_Metadata_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  video?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Tokens_Metadata_Max_Fields = {
  __typename?: 'tokens_metadata_max_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  gif_id?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  high_res_image_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_id?: Maybe<Scalars['Int']['output']>;
  invocation?: Maybe<Scalars['Int']['output']>;
  last_refreshed?: Maybe<Scalars['timestamptz']['output']>;
  list_creation_date?: Maybe<Scalars['timestamptz']['output']>;
  list_currency_address?: Maybe<Scalars['String']['output']>;
  list_currency_symbol?: Maybe<Scalars['String']['output']>;
  list_eth_price?: Maybe<Scalars['float8']['output']>;
  list_expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  list_platform?: Maybe<Scalars['String']['output']>;
  list_price?: Maybe<Scalars['float8']['output']>;
  list_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "live_view_path" */
  live_view_path?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "live_view_url" */
  live_view_url?: Maybe<Scalars['String']['output']>;
  low_res_image_id?: Maybe<Scalars['Int']['output']>;
  /** a computed field that returns the media proxy url for this token's statically rendered image */
  media_url?: Maybe<Scalars['String']['output']>;
  mint_transaction_hash?: Maybe<Scalars['String']['output']>;
  minted_at?: Maybe<Scalars['timestamptz']['output']>;
  owner_address?: Maybe<Scalars['String']['output']>;
  /** returns the preview asset url based on preview_render_type and availability */
  preview_asset_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "primary_asset_url" */
  primary_asset_url?: Maybe<Scalars['String']['output']>;
  primary_purchase_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Max_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  gif_id?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  last_refreshed?: InputMaybe<Order_By>;
  list_creation_date?: InputMaybe<Order_By>;
  list_currency_address?: InputMaybe<Order_By>;
  list_currency_symbol?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_expiration_date?: InputMaybe<Order_By>;
  list_platform?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  list_url?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  mint_transaction_hash?: InputMaybe<Order_By>;
  minted_at?: InputMaybe<Order_By>;
  owner_address?: InputMaybe<Order_By>;
  primary_purchase_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tokens_Metadata_Min_Fields = {
  __typename?: 'tokens_metadata_min_fields';
  contract_address?: Maybe<Scalars['String']['output']>;
  gif_id?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  high_res_image_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_id?: Maybe<Scalars['Int']['output']>;
  invocation?: Maybe<Scalars['Int']['output']>;
  last_refreshed?: Maybe<Scalars['timestamptz']['output']>;
  list_creation_date?: Maybe<Scalars['timestamptz']['output']>;
  list_currency_address?: Maybe<Scalars['String']['output']>;
  list_currency_symbol?: Maybe<Scalars['String']['output']>;
  list_eth_price?: Maybe<Scalars['float8']['output']>;
  list_expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  list_platform?: Maybe<Scalars['String']['output']>;
  list_price?: Maybe<Scalars['float8']['output']>;
  list_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "live_view_path" */
  live_view_path?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "live_view_url" */
  live_view_url?: Maybe<Scalars['String']['output']>;
  low_res_image_id?: Maybe<Scalars['Int']['output']>;
  /** a computed field that returns the media proxy url for this token's statically rendered image */
  media_url?: Maybe<Scalars['String']['output']>;
  mint_transaction_hash?: Maybe<Scalars['String']['output']>;
  minted_at?: Maybe<Scalars['timestamptz']['output']>;
  owner_address?: Maybe<Scalars['String']['output']>;
  /** returns the preview asset url based on preview_render_type and availability */
  preview_asset_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "primary_asset_url" */
  primary_asset_url?: Maybe<Scalars['String']['output']>;
  primary_purchase_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  token_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Min_Order_By = {
  contract_address?: InputMaybe<Order_By>;
  gif_id?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  last_refreshed?: InputMaybe<Order_By>;
  list_creation_date?: InputMaybe<Order_By>;
  list_currency_address?: InputMaybe<Order_By>;
  list_currency_symbol?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_expiration_date?: InputMaybe<Order_By>;
  list_platform?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  list_url?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  mint_transaction_hash?: InputMaybe<Order_By>;
  minted_at?: InputMaybe<Order_By>;
  owner_address?: InputMaybe<Order_By>;
  primary_purchase_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tokens_metadata" */
export type Tokens_Metadata_Mutation_Response = {
  __typename?: 'tokens_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tokens_Metadata>;
};

/** input type for inserting object relation for remote table "tokens_metadata" */
export type Tokens_Metadata_Obj_Rel_Insert_Input = {
  data: Tokens_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tokens_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "tokens_metadata" */
export type Tokens_Metadata_On_Conflict = {
  constraint: Tokens_Metadata_Constraint;
  update_columns?: Array<Tokens_Metadata_Update_Column>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "tokens_metadata". */
export type Tokens_Metadata_Order_By = {
  active_pmps_aggregate?: InputMaybe<Pmps_Metadata_Aggregate_Order_By>;
  bids_aggregate?: InputMaybe<Bids_Metadata_Aggregate_Order_By>;
  contract?: InputMaybe<Contracts_Metadata_Order_By>;
  contract_address?: InputMaybe<Order_By>;
  favorited_by_user?: InputMaybe<Order_By>;
  favorites_aggregate?: InputMaybe<Favorites_Aggregate_Order_By>;
  features?: InputMaybe<Order_By>;
  gif?: InputMaybe<Media_Order_By>;
  gif_id?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  high_res_image?: InputMaybe<Media_Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Media_Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  is_flagged?: InputMaybe<Order_By>;
  last_refreshed?: InputMaybe<Order_By>;
  list_creation_date?: InputMaybe<Order_By>;
  list_currency_address?: InputMaybe<Order_By>;
  list_currency_symbol?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_expiration_date?: InputMaybe<Order_By>;
  list_platform?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  list_url?: InputMaybe<Order_By>;
  live_view_path?: InputMaybe<Order_By>;
  live_view_url?: InputMaybe<Order_By>;
  low_res_image?: InputMaybe<Media_Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  media_url?: InputMaybe<Order_By>;
  mint_transaction_hash?: InputMaybe<Order_By>;
  minted_at?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_address?: InputMaybe<Order_By>;
  pmps_aggregate?: InputMaybe<Pmps_Metadata_Aggregate_Order_By>;
  preview_asset_url?: InputMaybe<Order_By>;
  primary_asset_url?: InputMaybe<Order_By>;
  primary_purchase_details?: InputMaybe<Primary_Purchases_Order_By>;
  primary_purchase_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video?: InputMaybe<Media_Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tokens_metadata */
export type Tokens_Metadata_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tokens_Metadata_Prepend_Input = {
  features?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  Features = 'features',
  /** column name */
  GifId = 'gif_id',
  /** column name */
  Hash = 'hash',
  /** column name */
  HighResImageId = 'high_res_image_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  Invocation = 'invocation',
  /** column name */
  IsFlagged = 'is_flagged',
  /** column name */
  LastRefreshed = 'last_refreshed',
  /** column name */
  ListCreationDate = 'list_creation_date',
  /** column name */
  ListCurrencyAddress = 'list_currency_address',
  /** column name */
  ListCurrencySymbol = 'list_currency_symbol',
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListExpirationDate = 'list_expiration_date',
  /** column name */
  ListPlatform = 'list_platform',
  /** column name */
  ListPrice = 'list_price',
  /** column name */
  ListUrl = 'list_url',
  /** column name */
  LowResImageId = 'low_res_image_id',
  /** column name */
  MintTransactionHash = 'mint_transaction_hash',
  /** column name */
  MintedAt = 'minted_at',
  /** column name */
  OwnerAddress = 'owner_address',
  /** column name */
  PrimaryPurchaseId = 'primary_purchase_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideoId = 'video_id'
}

/** select "tokens_metadata_aggregate_bool_exp_avg_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListPrice = 'list_price'
}

/** select "tokens_metadata_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsFlagged = 'is_flagged'
}

/** select "tokens_metadata_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsFlagged = 'is_flagged'
}

/** select "tokens_metadata_aggregate_bool_exp_corr_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListPrice = 'list_price'
}

/** select "tokens_metadata_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListPrice = 'list_price'
}

/** select "tokens_metadata_aggregate_bool_exp_max_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListPrice = 'list_price'
}

/** select "tokens_metadata_aggregate_bool_exp_min_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListPrice = 'list_price'
}

/** select "tokens_metadata_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListPrice = 'list_price'
}

/** select "tokens_metadata_aggregate_bool_exp_sum_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListPrice = 'list_price'
}

/** select "tokens_metadata_aggregate_bool_exp_var_samp_arguments_columns" columns of table "tokens_metadata" */
export enum Tokens_Metadata_Select_Column_Tokens_Metadata_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListPrice = 'list_price'
}

/** input type for updating data in table "tokens_metadata" */
export type Tokens_Metadata_Set_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  gif_id?: InputMaybe<Scalars['Int']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  high_res_image_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  is_flagged?: InputMaybe<Scalars['Boolean']['input']>;
  last_refreshed?: InputMaybe<Scalars['timestamptz']['input']>;
  list_creation_date?: InputMaybe<Scalars['timestamptz']['input']>;
  list_currency_address?: InputMaybe<Scalars['String']['input']>;
  list_currency_symbol?: InputMaybe<Scalars['String']['input']>;
  list_eth_price?: InputMaybe<Scalars['float8']['input']>;
  list_expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  list_platform?: InputMaybe<Scalars['String']['input']>;
  list_price?: InputMaybe<Scalars['float8']['input']>;
  list_url?: InputMaybe<Scalars['String']['input']>;
  low_res_image_id?: InputMaybe<Scalars['Int']['input']>;
  mint_transaction_hash?: InputMaybe<Scalars['String']['input']>;
  minted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  owner_address?: InputMaybe<Scalars['String']['input']>;
  primary_purchase_id?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Tokens_Metadata_Stddev_Fields = {
  __typename?: 'tokens_metadata_stddev_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  high_res_image_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  invocation?: Maybe<Scalars['Float']['output']>;
  list_eth_price?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['Float']['output']>;
  low_res_image_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Stddev_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tokens_Metadata_Stddev_Pop_Fields = {
  __typename?: 'tokens_metadata_stddev_pop_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  high_res_image_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  invocation?: Maybe<Scalars['Float']['output']>;
  list_eth_price?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['Float']['output']>;
  low_res_image_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Stddev_Pop_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tokens_Metadata_Stddev_Samp_Fields = {
  __typename?: 'tokens_metadata_stddev_samp_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  high_res_image_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  invocation?: Maybe<Scalars['Float']['output']>;
  list_eth_price?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['Float']['output']>;
  low_res_image_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Stddev_Samp_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tokens_metadata" */
export type Tokens_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tokens_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tokens_Metadata_Stream_Cursor_Value_Input = {
  contract_address?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Scalars['jsonb']['input']>;
  gif_id?: InputMaybe<Scalars['Int']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  high_res_image_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image_id?: InputMaybe<Scalars['Int']['input']>;
  invocation?: InputMaybe<Scalars['Int']['input']>;
  is_flagged?: InputMaybe<Scalars['Boolean']['input']>;
  last_refreshed?: InputMaybe<Scalars['timestamptz']['input']>;
  list_creation_date?: InputMaybe<Scalars['timestamptz']['input']>;
  list_currency_address?: InputMaybe<Scalars['String']['input']>;
  list_currency_symbol?: InputMaybe<Scalars['String']['input']>;
  list_eth_price?: InputMaybe<Scalars['float8']['input']>;
  list_expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  list_platform?: InputMaybe<Scalars['String']['input']>;
  list_price?: InputMaybe<Scalars['float8']['input']>;
  list_url?: InputMaybe<Scalars['String']['input']>;
  low_res_image_id?: InputMaybe<Scalars['Int']['input']>;
  mint_transaction_hash?: InputMaybe<Scalars['String']['input']>;
  minted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  owner_address?: InputMaybe<Scalars['String']['input']>;
  primary_purchase_id?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  token_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Tokens_Metadata_Sum_Fields = {
  __typename?: 'tokens_metadata_sum_fields';
  gif_id?: Maybe<Scalars['Int']['output']>;
  high_res_image_id?: Maybe<Scalars['Int']['output']>;
  image_id?: Maybe<Scalars['Int']['output']>;
  invocation?: Maybe<Scalars['Int']['output']>;
  list_eth_price?: Maybe<Scalars['float8']['output']>;
  list_price?: Maybe<Scalars['float8']['output']>;
  low_res_image_id?: Maybe<Scalars['Int']['output']>;
  video_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Sum_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** update columns of table "tokens_metadata" */
export enum Tokens_Metadata_Update_Column {
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  Features = 'features',
  /** column name */
  GifId = 'gif_id',
  /** column name */
  Hash = 'hash',
  /** column name */
  HighResImageId = 'high_res_image_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFlagged = 'is_flagged',
  /** column name */
  LastRefreshed = 'last_refreshed',
  /** column name */
  ListCreationDate = 'list_creation_date',
  /** column name */
  ListCurrencyAddress = 'list_currency_address',
  /** column name */
  ListCurrencySymbol = 'list_currency_symbol',
  /** column name */
  ListEthPrice = 'list_eth_price',
  /** column name */
  ListExpirationDate = 'list_expiration_date',
  /** column name */
  ListPlatform = 'list_platform',
  /** column name */
  ListPrice = 'list_price',
  /** column name */
  ListUrl = 'list_url',
  /** column name */
  LowResImageId = 'low_res_image_id',
  /** column name */
  MintTransactionHash = 'mint_transaction_hash',
  /** column name */
  MintedAt = 'minted_at',
  /** column name */
  OwnerAddress = 'owner_address',
  /** column name */
  PrimaryPurchaseId = 'primary_purchase_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideoId = 'video_id'
}

export type Tokens_Metadata_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tokens_Metadata_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tokens_Metadata_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tokens_Metadata_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tokens_Metadata_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tokens_Metadata_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tokens_Metadata_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tokens_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tokens_Metadata_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tokens_Metadata_Var_Pop_Fields = {
  __typename?: 'tokens_metadata_var_pop_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  high_res_image_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  invocation?: Maybe<Scalars['Float']['output']>;
  list_eth_price?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['Float']['output']>;
  low_res_image_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Var_Pop_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tokens_Metadata_Var_Samp_Fields = {
  __typename?: 'tokens_metadata_var_samp_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  high_res_image_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  invocation?: Maybe<Scalars['Float']['output']>;
  list_eth_price?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['Float']['output']>;
  low_res_image_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Var_Samp_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tokens_Metadata_Variance_Fields = {
  __typename?: 'tokens_metadata_variance_fields';
  gif_id?: Maybe<Scalars['Float']['output']>;
  high_res_image_id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  invocation?: Maybe<Scalars['Float']['output']>;
  list_eth_price?: Maybe<Scalars['Float']['output']>;
  list_price?: Maybe<Scalars['Float']['output']>;
  low_res_image_id?: Maybe<Scalars['Float']['output']>;
  video_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tokens_metadata" */
export type Tokens_Metadata_Variance_Order_By = {
  gif_id?: InputMaybe<Order_By>;
  high_res_image_id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  invocation?: InputMaybe<Order_By>;
  list_eth_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  low_res_image_id?: InputMaybe<Order_By>;
  video_id?: InputMaybe<Order_By>;
};

/** Art Blocks public profiles */
export type User_Profiles = {
  __typename?: 'user_profiles';
  bio?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  profile_picture?: Maybe<Media>;
  profile_picture_id?: Maybe<Scalars['Int']['output']>;
  twitter_username?: Maybe<Scalars['String']['output']>;
  user_address: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type User_Profiles_Aggregate = {
  __typename?: 'user_profiles_aggregate';
  aggregate?: Maybe<User_Profiles_Aggregate_Fields>;
  nodes: Array<User_Profiles>;
};

/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_Fields = {
  __typename?: 'user_profiles_aggregate_fields';
  avg?: Maybe<User_Profiles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Profiles_Max_Fields>;
  min?: Maybe<User_Profiles_Min_Fields>;
  stddev?: Maybe<User_Profiles_Stddev_Fields>;
  stddev_pop?: Maybe<User_Profiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Profiles_Stddev_Samp_Fields>;
  sum?: Maybe<User_Profiles_Sum_Fields>;
  var_pop?: Maybe<User_Profiles_Var_Pop_Fields>;
  var_samp?: Maybe<User_Profiles_Var_Samp_Fields>;
  variance?: Maybe<User_Profiles_Variance_Fields>;
};


/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Profiles_Avg_Fields = {
  __typename?: 'user_profiles_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type User_Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  _not?: InputMaybe<User_Profiles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  bio?: InputMaybe<String_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  profile_picture?: InputMaybe<Media_Bool_Exp>;
  profile_picture_id?: InputMaybe<Int_Comparison_Exp>;
  twitter_username?: InputMaybe<String_Comparison_Exp>;
  user_address?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profiles" */
export enum User_Profiles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProfilesPkey = 'user_profiles_pkey',
  /** unique or primary key constraint on columns "user_address" */
  UserProfilesUserAddressKey = 'user_profiles_user_address_key',
  /** unique or primary key constraint on columns "username" */
  UserProfilesUsernameKey = 'user_profiles_username_key'
}

/** input type for incrementing numeric columns in table "user_profiles" */
export type User_Profiles_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  profile_picture_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_profiles" */
export type User_Profiles_Insert_Input = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile_picture?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  profile_picture_id?: InputMaybe<Scalars['Int']['input']>;
  twitter_username?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Profiles_Max_Fields = {
  __typename?: 'user_profiles_max_fields';
  bio?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile_picture_id?: Maybe<Scalars['Int']['output']>;
  twitter_username?: Maybe<Scalars['String']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Profiles_Min_Fields = {
  __typename?: 'user_profiles_min_fields';
  bio?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profile_picture_id?: Maybe<Scalars['Int']['output']>;
  twitter_username?: Maybe<Scalars['String']['output']>;
  user_address?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_profiles" */
export type User_Profiles_Mutation_Response = {
  __typename?: 'user_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profiles>;
};

/** input type for inserting object relation for remote table "user_profiles" */
export type User_Profiles_Obj_Rel_Insert_Input = {
  data: User_Profiles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};

/** on_conflict condition type for table "user_profiles" */
export type User_Profiles_On_Conflict = {
  constraint: User_Profiles_Constraint;
  update_columns?: Array<User_Profiles_Update_Column>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profiles". */
export type User_Profiles_Order_By = {
  bio?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  profile_picture?: InputMaybe<Media_Order_By>;
  profile_picture_id?: InputMaybe<Order_By>;
  twitter_username?: InputMaybe<Order_By>;
  user_address?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profiles */
export type User_Profiles_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_profiles" */
export enum User_Profiles_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProfilePictureId = 'profile_picture_id',
  /** column name */
  TwitterUsername = 'twitter_username',
  /** column name */
  UserAddress = 'user_address',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "user_profiles" */
export type User_Profiles_Set_Input = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile_picture_id?: InputMaybe<Scalars['Int']['input']>;
  twitter_username?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Profiles_Stddev_Fields = {
  __typename?: 'user_profiles_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Profiles_Stddev_Pop_Fields = {
  __typename?: 'user_profiles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Profiles_Stddev_Samp_Fields = {
  __typename?: 'user_profiles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_profiles" */
export type User_Profiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profiles_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile_picture_id?: InputMaybe<Scalars['Int']['input']>;
  twitter_username?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Profiles_Sum_Fields = {
  __typename?: 'user_profiles_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  profile_picture_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_profiles" */
export enum User_Profiles_Update_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProfilePictureId = 'profile_picture_id',
  /** column name */
  TwitterUsername = 'twitter_username',
  /** column name */
  UserAddress = 'user_address',
  /** column name */
  Username = 'username'
}

export type User_Profiles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profiles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Profiles_Var_Pop_Fields = {
  __typename?: 'user_profiles_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Profiles_Var_Samp_Fields = {
  __typename?: 'user_profiles_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Profiles_Variance_Fields = {
  __typename?: 'user_profiles_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  profile_picture_id?: Maybe<Scalars['Float']['output']>;
};

/** Art Blocks users */
export type Users = {
  __typename?: 'users';
  account?: Maybe<Account>;
  /** An array relationship */
  allowlisted_on: Array<Contract_Allowlistings>;
  /** An aggregate relationship */
  allowlisted_on_aggregate: Contract_Allowlistings_Aggregate;
  /** An array relationship */
  bids: Array<Bids_Metadata>;
  /** An aggregate relationship */
  bids_aggregate: Bids_Metadata_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "user_display_name" */
  display_name?: Maybe<Scalars['String']['output']>;
  favorited_by_user?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  favorites: Array<Favorites>;
  /** An aggregate relationship */
  favorites_aggregate: Favorites_Aggregate;
  /** A computed field, executes function "user_feature_flags" */
  feature_flags?: Maybe<Scalars['jsonb']['output']>;
  is_ab_staff?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "user_is_curated" */
  is_curated?: Maybe<Scalars['Boolean']['output']>;
  is_curator?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "generate_nonce" */
  nonce?: Maybe<Scalars['String']['output']>;
  nonce_offset: Scalars['Int']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  privy_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  profile?: Maybe<User_Profiles>;
  /** An array relationship */
  projects_created: Array<Projects_Metadata>;
  /** An aggregate relationship */
  projects_created_aggregate: Projects_Metadata_Aggregate;
  public_address: Scalars['String']['output'];
  /** An array relationship */
  receipts: Array<Receipt_Metadata>;
  /** An aggregate relationship */
  receipts_aggregate: Receipt_Metadata_Aggregate;
  /** An array relationship */
  tags: Array<Entity_Tags>;
  /** An aggregate relationship */
  tags_aggregate: Entity_Tags_Aggregate;
  /** An array relationship */
  tokens: Array<Tokens_Metadata>;
  /** An aggregate relationship */
  tokens_aggregate: Tokens_Metadata_Aggregate;
  tos_accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  viewed_warning_banner?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  webflow_artist_info?: Maybe<Webflow_Artist_Info>;
};


/** Art Blocks users */
export type UsersAccountArgs = {
  block?: InputMaybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


/** Art Blocks users */
export type UsersAllowlisted_OnArgs = {
  distinct_on?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Allowlistings_Order_By>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


/** Art Blocks users */
export type UsersAllowlisted_On_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contract_Allowlistings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contract_Allowlistings_Order_By>>;
  where?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
};


/** Art Blocks users */
export type UsersBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


/** Art Blocks users */
export type UsersBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bids_Metadata_Order_By>>;
  where?: InputMaybe<Bids_Metadata_Bool_Exp>;
};


/** Art Blocks users */
export type UsersFavoritesArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


/** Art Blocks users */
export type UsersFavorites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorites_Order_By>>;
  where?: InputMaybe<Favorites_Bool_Exp>;
};


/** Art Blocks users */
export type UsersFeature_FlagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Art Blocks users */
export type UsersNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** Art Blocks users */
export type UsersNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** Art Blocks users */
export type UsersProjects_CreatedArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


/** Art Blocks users */
export type UsersProjects_Created_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Metadata_Order_By>>;
  where?: InputMaybe<Projects_Metadata_Bool_Exp>;
};


/** Art Blocks users */
export type UsersReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


/** Art Blocks users */
export type UsersReceipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Receipt_Metadata_Order_By>>;
  where?: InputMaybe<Receipt_Metadata_Bool_Exp>;
};


/** Art Blocks users */
export type UsersTagsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


/** Art Blocks users */
export type UsersTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Tags_Order_By>>;
  where?: InputMaybe<Entity_Tags_Bool_Exp>;
};


/** Art Blocks users */
export type UsersTokensArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};


/** Art Blocks users */
export type UsersTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tokens_Metadata_Order_By>>;
  where?: InputMaybe<Tokens_Metadata_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  allowlisted_on?: InputMaybe<Contract_Allowlistings_Bool_Exp>;
  allowlisted_on_aggregate?: InputMaybe<Contract_Allowlistings_Aggregate_Bool_Exp>;
  bids?: InputMaybe<Bids_Metadata_Bool_Exp>;
  bids_aggregate?: InputMaybe<Bids_Metadata_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  favorited_by_user?: InputMaybe<Boolean_Comparison_Exp>;
  favorites?: InputMaybe<Favorites_Bool_Exp>;
  favorites_aggregate?: InputMaybe<Favorites_Aggregate_Bool_Exp>;
  feature_flags?: InputMaybe<Jsonb_Comparison_Exp>;
  is_ab_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_curated?: InputMaybe<Boolean_Comparison_Exp>;
  is_curator?: InputMaybe<Boolean_Comparison_Exp>;
  nonce?: InputMaybe<String_Comparison_Exp>;
  nonce_offset?: InputMaybe<Int_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  privy_id?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<User_Profiles_Bool_Exp>;
  projects_created?: InputMaybe<Projects_Metadata_Bool_Exp>;
  projects_created_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Bool_Exp>;
  public_address?: InputMaybe<String_Comparison_Exp>;
  receipts?: InputMaybe<Receipt_Metadata_Bool_Exp>;
  receipts_aggregate?: InputMaybe<Receipt_Metadata_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Entity_Tags_Bool_Exp>;
  tags_aggregate?: InputMaybe<Entity_Tags_Aggregate_Bool_Exp>;
  tokens?: InputMaybe<Tokens_Metadata_Bool_Exp>;
  tokens_aggregate?: InputMaybe<Tokens_Metadata_Aggregate_Bool_Exp>;
  tos_accepted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  viewed_warning_banner?: InputMaybe<Boolean_Comparison_Exp>;
  webflow_artist_info?: InputMaybe<Webflow_Artist_Info_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "public_address" */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint on columns "public_address" */
  UsersPublicAddressKey = 'users_public_address_key'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  nonce_offset?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  allowlisted_on?: InputMaybe<Contract_Allowlistings_Arr_Rel_Insert_Input>;
  bids?: InputMaybe<Bids_Metadata_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  favorites?: InputMaybe<Favorites_Arr_Rel_Insert_Input>;
  is_ab_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_curator?: InputMaybe<Scalars['Boolean']['input']>;
  nonce_offset?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<Notifications_Arr_Rel_Insert_Input>;
  privy_id?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>;
  projects_created?: InputMaybe<Projects_Metadata_Arr_Rel_Insert_Input>;
  public_address?: InputMaybe<Scalars['String']['input']>;
  receipts?: InputMaybe<Receipt_Metadata_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Entity_Tags_Arr_Rel_Insert_Input>;
  tokens?: InputMaybe<Tokens_Metadata_Arr_Rel_Insert_Input>;
  tos_accepted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viewed_warning_banner?: InputMaybe<Scalars['Boolean']['input']>;
  webflow_artist_info?: InputMaybe<Webflow_Artist_Info_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "user_display_name" */
  display_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "generate_nonce" */
  nonce?: Maybe<Scalars['String']['output']>;
  nonce_offset?: Maybe<Scalars['Int']['output']>;
  privy_id?: Maybe<Scalars['String']['output']>;
  public_address?: Maybe<Scalars['String']['output']>;
  tos_accepted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "user_display_name" */
  display_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "generate_nonce" */
  nonce?: Maybe<Scalars['String']['output']>;
  nonce_offset?: Maybe<Scalars['Int']['output']>;
  privy_id?: Maybe<Scalars['String']['output']>;
  public_address?: Maybe<Scalars['String']['output']>;
  tos_accepted_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  allowlisted_on_aggregate?: InputMaybe<Contract_Allowlistings_Aggregate_Order_By>;
  bids_aggregate?: InputMaybe<Bids_Metadata_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  favorited_by_user?: InputMaybe<Order_By>;
  favorites_aggregate?: InputMaybe<Favorites_Aggregate_Order_By>;
  feature_flags?: InputMaybe<Order_By>;
  is_ab_staff?: InputMaybe<Order_By>;
  is_curated?: InputMaybe<Order_By>;
  is_curator?: InputMaybe<Order_By>;
  nonce?: InputMaybe<Order_By>;
  nonce_offset?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  privy_id?: InputMaybe<Order_By>;
  profile?: InputMaybe<User_Profiles_Order_By>;
  projects_created_aggregate?: InputMaybe<Projects_Metadata_Aggregate_Order_By>;
  public_address?: InputMaybe<Order_By>;
  receipts_aggregate?: InputMaybe<Receipt_Metadata_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Entity_Tags_Aggregate_Order_By>;
  tokens_aggregate?: InputMaybe<Tokens_Metadata_Aggregate_Order_By>;
  tos_accepted_at?: InputMaybe<Order_By>;
  viewed_warning_banner?: InputMaybe<Order_By>;
  webflow_artist_info?: InputMaybe<Webflow_Artist_Info_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  public_address: Scalars['String']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsAbStaff = 'is_ab_staff',
  /** column name */
  IsCurator = 'is_curator',
  /** column name */
  NonceOffset = 'nonce_offset',
  /** column name */
  PrivyId = 'privy_id',
  /** column name */
  PublicAddress = 'public_address',
  /** column name */
  TosAcceptedAt = 'tos_accepted_at',
  /** column name */
  ViewedWarningBanner = 'viewed_warning_banner'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_ab_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_curator?: InputMaybe<Scalars['Boolean']['input']>;
  nonce_offset?: InputMaybe<Scalars['Int']['input']>;
  privy_id?: InputMaybe<Scalars['String']['input']>;
  public_address?: InputMaybe<Scalars['String']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viewed_warning_banner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_ab_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_curator?: InputMaybe<Scalars['Boolean']['input']>;
  nonce_offset?: InputMaybe<Scalars['Int']['input']>;
  privy_id?: InputMaybe<Scalars['String']['input']>;
  public_address?: InputMaybe<Scalars['String']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  viewed_warning_banner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  nonce_offset?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsAbStaff = 'is_ab_staff',
  /** column name */
  IsCurator = 'is_curator',
  /** column name */
  NonceOffset = 'nonce_offset',
  /** column name */
  PrivyId = 'privy_id',
  /** column name */
  PublicAddress = 'public_address',
  /** column name */
  TosAcceptedAt = 'tos_accepted_at',
  /** column name */
  ViewedWarningBanner = 'viewed_warning_banner'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  nonce_offset?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** vertical enums */
export type Verticals = {
  __typename?: 'verticals';
  name: Scalars['String']['output'];
  /** An object relationship */
  project_vertical?: Maybe<Project_Verticals>;
};

/** aggregated selection of "verticals" */
export type Verticals_Aggregate = {
  __typename?: 'verticals_aggregate';
  aggregate?: Maybe<Verticals_Aggregate_Fields>;
  nodes: Array<Verticals>;
};

/** aggregate fields of "verticals" */
export type Verticals_Aggregate_Fields = {
  __typename?: 'verticals_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Verticals_Max_Fields>;
  min?: Maybe<Verticals_Min_Fields>;
};


/** aggregate fields of "verticals" */
export type Verticals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Verticals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "verticals". All fields are combined with a logical 'AND'. */
export type Verticals_Bool_Exp = {
  _and?: InputMaybe<Array<Verticals_Bool_Exp>>;
  _not?: InputMaybe<Verticals_Bool_Exp>;
  _or?: InputMaybe<Array<Verticals_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_vertical?: InputMaybe<Project_Verticals_Bool_Exp>;
};

/** unique or primary key constraints on table "verticals" */
export enum Verticals_Constraint {
  /** unique or primary key constraint on columns "name" */
  VerticalsPkey = 'verticals_pkey'
}

export enum Verticals_Enum {
  Artblocksxbrightmoments = 'artblocksxbrightmoments',
  Artblocksxpace = 'artblocksxpace',
  Curated = 'curated',
  Explorations = 'explorations',
  Factory = 'factory',
  Flex = 'flex',
  Fullyonchain = 'fullyonchain',
  Playground = 'playground',
  Presents = 'presents',
  Studio = 'studio',
  Unassigned = 'unassigned'
}

/** Boolean expression to compare columns of type "verticals_enum". All fields are combined with logical 'AND'. */
export type Verticals_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Verticals_Enum>;
  _in?: InputMaybe<Array<Verticals_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Verticals_Enum>;
  _nin?: InputMaybe<Array<Verticals_Enum>>;
};

/** input type for inserting data into table "verticals" */
export type Verticals_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  project_vertical?: InputMaybe<Project_Verticals_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Verticals_Max_Fields = {
  __typename?: 'verticals_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Verticals_Min_Fields = {
  __typename?: 'verticals_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "verticals" */
export type Verticals_Mutation_Response = {
  __typename?: 'verticals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Verticals>;
};

/** input type for inserting object relation for remote table "verticals" */
export type Verticals_Obj_Rel_Insert_Input = {
  data: Verticals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Verticals_On_Conflict>;
};

/** on_conflict condition type for table "verticals" */
export type Verticals_On_Conflict = {
  constraint: Verticals_Constraint;
  update_columns?: Array<Verticals_Update_Column>;
  where?: InputMaybe<Verticals_Bool_Exp>;
};

/** Ordering options when selecting data from "verticals". */
export type Verticals_Order_By = {
  name?: InputMaybe<Order_By>;
  project_vertical?: InputMaybe<Project_Verticals_Order_By>;
};

/** primary key columns input for table: verticals */
export type Verticals_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "verticals" */
export enum Verticals_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "verticals" */
export type Verticals_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "verticals" */
export type Verticals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Verticals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Verticals_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "verticals" */
export enum Verticals_Update_Column {
  /** column name */
  Name = 'name'
}

export type Verticals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Verticals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Verticals_Bool_Exp;
};

/** Table describing the valid aspect ratios available to projects when generating video preview assets. */
export type Video_Aspect_Ratios = {
  __typename?: 'video_aspect_ratios';
  label: Scalars['String']['output'];
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "video_aspect_ratios" */
export type Video_Aspect_Ratios_Aggregate = {
  __typename?: 'video_aspect_ratios_aggregate';
  aggregate?: Maybe<Video_Aspect_Ratios_Aggregate_Fields>;
  nodes: Array<Video_Aspect_Ratios>;
};

/** aggregate fields of "video_aspect_ratios" */
export type Video_Aspect_Ratios_Aggregate_Fields = {
  __typename?: 'video_aspect_ratios_aggregate_fields';
  avg?: Maybe<Video_Aspect_Ratios_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Video_Aspect_Ratios_Max_Fields>;
  min?: Maybe<Video_Aspect_Ratios_Min_Fields>;
  stddev?: Maybe<Video_Aspect_Ratios_Stddev_Fields>;
  stddev_pop?: Maybe<Video_Aspect_Ratios_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Video_Aspect_Ratios_Stddev_Samp_Fields>;
  sum?: Maybe<Video_Aspect_Ratios_Sum_Fields>;
  var_pop?: Maybe<Video_Aspect_Ratios_Var_Pop_Fields>;
  var_samp?: Maybe<Video_Aspect_Ratios_Var_Samp_Fields>;
  variance?: Maybe<Video_Aspect_Ratios_Variance_Fields>;
};


/** aggregate fields of "video_aspect_ratios" */
export type Video_Aspect_Ratios_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Video_Aspect_Ratios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Video_Aspect_Ratios_Avg_Fields = {
  __typename?: 'video_aspect_ratios_avg_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "video_aspect_ratios". All fields are combined with a logical 'AND'. */
export type Video_Aspect_Ratios_Bool_Exp = {
  _and?: InputMaybe<Array<Video_Aspect_Ratios_Bool_Exp>>;
  _not?: InputMaybe<Video_Aspect_Ratios_Bool_Exp>;
  _or?: InputMaybe<Array<Video_Aspect_Ratios_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "video_aspect_ratios" */
export enum Video_Aspect_Ratios_Constraint {
  /** unique or primary key constraint on columns "label" */
  VideoAspectRatiosLabelKey = 'video_aspect_ratios_label_key',
  /** unique or primary key constraint on columns "value" */
  VideoAspectRatiosPkey = 'video_aspect_ratios_pkey'
}

/** input type for incrementing numeric columns in table "video_aspect_ratios" */
export type Video_Aspect_Ratios_Inc_Input = {
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "video_aspect_ratios" */
export type Video_Aspect_Ratios_Insert_Input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Video_Aspect_Ratios_Max_Fields = {
  __typename?: 'video_aspect_ratios_max_fields';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Video_Aspect_Ratios_Min_Fields = {
  __typename?: 'video_aspect_ratios_min_fields';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "video_aspect_ratios" */
export type Video_Aspect_Ratios_Mutation_Response = {
  __typename?: 'video_aspect_ratios_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Video_Aspect_Ratios>;
};

/** on_conflict condition type for table "video_aspect_ratios" */
export type Video_Aspect_Ratios_On_Conflict = {
  constraint: Video_Aspect_Ratios_Constraint;
  update_columns?: Array<Video_Aspect_Ratios_Update_Column>;
  where?: InputMaybe<Video_Aspect_Ratios_Bool_Exp>;
};

/** Ordering options when selecting data from "video_aspect_ratios". */
export type Video_Aspect_Ratios_Order_By = {
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: video_aspect_ratios */
export type Video_Aspect_Ratios_Pk_Columns_Input = {
  value: Scalars['numeric']['input'];
};

/** select columns of table "video_aspect_ratios" */
export enum Video_Aspect_Ratios_Select_Column {
  /** column name */
  Label = 'label',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "video_aspect_ratios" */
export type Video_Aspect_Ratios_Set_Input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Video_Aspect_Ratios_Stddev_Fields = {
  __typename?: 'video_aspect_ratios_stddev_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Video_Aspect_Ratios_Stddev_Pop_Fields = {
  __typename?: 'video_aspect_ratios_stddev_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Video_Aspect_Ratios_Stddev_Samp_Fields = {
  __typename?: 'video_aspect_ratios_stddev_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "video_aspect_ratios" */
export type Video_Aspect_Ratios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Video_Aspect_Ratios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Video_Aspect_Ratios_Stream_Cursor_Value_Input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Video_Aspect_Ratios_Sum_Fields = {
  __typename?: 'video_aspect_ratios_sum_fields';
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "video_aspect_ratios" */
export enum Video_Aspect_Ratios_Update_Column {
  /** column name */
  Label = 'label',
  /** column name */
  Value = 'value'
}

export type Video_Aspect_Ratios_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Video_Aspect_Ratios_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Video_Aspect_Ratios_Set_Input>;
  /** filter the rows which have to be updated */
  where: Video_Aspect_Ratios_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Video_Aspect_Ratios_Var_Pop_Fields = {
  __typename?: 'video_aspect_ratios_var_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Video_Aspect_Ratios_Var_Samp_Fields = {
  __typename?: 'video_aspect_ratios_var_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Video_Aspect_Ratios_Variance_Fields = {
  __typename?: 'video_aspect_ratios_variance_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** Table describing the valid frame rates available to projects when generating dynamic media assets. */
export type Video_Frame_Rates = {
  __typename?: 'video_frame_rates';
  value: Scalars['Int']['output'];
};

/** aggregated selection of "video_frame_rates" */
export type Video_Frame_Rates_Aggregate = {
  __typename?: 'video_frame_rates_aggregate';
  aggregate?: Maybe<Video_Frame_Rates_Aggregate_Fields>;
  nodes: Array<Video_Frame_Rates>;
};

/** aggregate fields of "video_frame_rates" */
export type Video_Frame_Rates_Aggregate_Fields = {
  __typename?: 'video_frame_rates_aggregate_fields';
  avg?: Maybe<Video_Frame_Rates_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Video_Frame_Rates_Max_Fields>;
  min?: Maybe<Video_Frame_Rates_Min_Fields>;
  stddev?: Maybe<Video_Frame_Rates_Stddev_Fields>;
  stddev_pop?: Maybe<Video_Frame_Rates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Video_Frame_Rates_Stddev_Samp_Fields>;
  sum?: Maybe<Video_Frame_Rates_Sum_Fields>;
  var_pop?: Maybe<Video_Frame_Rates_Var_Pop_Fields>;
  var_samp?: Maybe<Video_Frame_Rates_Var_Samp_Fields>;
  variance?: Maybe<Video_Frame_Rates_Variance_Fields>;
};


/** aggregate fields of "video_frame_rates" */
export type Video_Frame_Rates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Video_Frame_Rates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Video_Frame_Rates_Avg_Fields = {
  __typename?: 'video_frame_rates_avg_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "video_frame_rates". All fields are combined with a logical 'AND'. */
export type Video_Frame_Rates_Bool_Exp = {
  _and?: InputMaybe<Array<Video_Frame_Rates_Bool_Exp>>;
  _not?: InputMaybe<Video_Frame_Rates_Bool_Exp>;
  _or?: InputMaybe<Array<Video_Frame_Rates_Bool_Exp>>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "video_frame_rates" */
export enum Video_Frame_Rates_Constraint {
  /** unique or primary key constraint on columns "value" */
  VideoFrameRatesPkey = 'video_frame_rates_pkey'
}

/** input type for incrementing numeric columns in table "video_frame_rates" */
export type Video_Frame_Rates_Inc_Input = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "video_frame_rates" */
export type Video_Frame_Rates_Insert_Input = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Video_Frame_Rates_Max_Fields = {
  __typename?: 'video_frame_rates_max_fields';
  value?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Video_Frame_Rates_Min_Fields = {
  __typename?: 'video_frame_rates_min_fields';
  value?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "video_frame_rates" */
export type Video_Frame_Rates_Mutation_Response = {
  __typename?: 'video_frame_rates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Video_Frame_Rates>;
};

/** on_conflict condition type for table "video_frame_rates" */
export type Video_Frame_Rates_On_Conflict = {
  constraint: Video_Frame_Rates_Constraint;
  update_columns?: Array<Video_Frame_Rates_Update_Column>;
  where?: InputMaybe<Video_Frame_Rates_Bool_Exp>;
};

/** Ordering options when selecting data from "video_frame_rates". */
export type Video_Frame_Rates_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: video_frame_rates */
export type Video_Frame_Rates_Pk_Columns_Input = {
  value: Scalars['Int']['input'];
};

/** select columns of table "video_frame_rates" */
export enum Video_Frame_Rates_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "video_frame_rates" */
export type Video_Frame_Rates_Set_Input = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Video_Frame_Rates_Stddev_Fields = {
  __typename?: 'video_frame_rates_stddev_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Video_Frame_Rates_Stddev_Pop_Fields = {
  __typename?: 'video_frame_rates_stddev_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Video_Frame_Rates_Stddev_Samp_Fields = {
  __typename?: 'video_frame_rates_stddev_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "video_frame_rates" */
export type Video_Frame_Rates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Video_Frame_Rates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Video_Frame_Rates_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Video_Frame_Rates_Sum_Fields = {
  __typename?: 'video_frame_rates_sum_fields';
  value?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "video_frame_rates" */
export enum Video_Frame_Rates_Update_Column {
  /** column name */
  Value = 'value'
}

export type Video_Frame_Rates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Video_Frame_Rates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Video_Frame_Rates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Video_Frame_Rates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Video_Frame_Rates_Var_Pop_Fields = {
  __typename?: 'video_frame_rates_var_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Video_Frame_Rates_Var_Samp_Fields = {
  __typename?: 'video_frame_rates_var_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Video_Frame_Rates_Variance_Fields = {
  __typename?: 'video_frame_rates_variance_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "webflow_artist_info" */
export type Webflow_Artist_Info = {
  __typename?: 'webflow_artist_info';
  published: Scalars['Boolean']['output'];
  raw_data: Scalars['jsonb']['output'];
  slug: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
  user_public_address: Scalars['String']['output'];
  webflow_collection_id: Scalars['String']['output'];
  webflow_item_id: Scalars['String']['output'];
};


/** columns and relationships of "webflow_artist_info" */
export type Webflow_Artist_InfoRaw_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "webflow_artist_info" */
export type Webflow_Artist_Info_Aggregate = {
  __typename?: 'webflow_artist_info_aggregate';
  aggregate?: Maybe<Webflow_Artist_Info_Aggregate_Fields>;
  nodes: Array<Webflow_Artist_Info>;
};

/** aggregate fields of "webflow_artist_info" */
export type Webflow_Artist_Info_Aggregate_Fields = {
  __typename?: 'webflow_artist_info_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Webflow_Artist_Info_Max_Fields>;
  min?: Maybe<Webflow_Artist_Info_Min_Fields>;
};


/** aggregate fields of "webflow_artist_info" */
export type Webflow_Artist_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Webflow_Artist_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Webflow_Artist_Info_Append_Input = {
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "webflow_artist_info". All fields are combined with a logical 'AND'. */
export type Webflow_Artist_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Webflow_Artist_Info_Bool_Exp>>;
  _not?: InputMaybe<Webflow_Artist_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Webflow_Artist_Info_Bool_Exp>>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  raw_data?: InputMaybe<Jsonb_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_public_address?: InputMaybe<String_Comparison_Exp>;
  webflow_collection_id?: InputMaybe<String_Comparison_Exp>;
  webflow_item_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "webflow_artist_info" */
export enum Webflow_Artist_Info_Constraint {
  /** unique or primary key constraint on columns "webflow_item_id" */
  WebflowArtistInfoPkey = 'webflow_artist_info_pkey',
  /** unique or primary key constraint on columns "user_public_address" */
  WebflowArtistInfoUserPublicAddressKey = 'webflow_artist_info_user_public_address_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Webflow_Artist_Info_Delete_At_Path_Input = {
  raw_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Webflow_Artist_Info_Delete_Elem_Input = {
  raw_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Webflow_Artist_Info_Delete_Key_Input = {
  raw_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "webflow_artist_info" */
export type Webflow_Artist_Info_Insert_Input = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_public_address?: InputMaybe<Scalars['String']['input']>;
  webflow_collection_id?: InputMaybe<Scalars['String']['input']>;
  webflow_item_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Webflow_Artist_Info_Max_Fields = {
  __typename?: 'webflow_artist_info_max_fields';
  slug?: Maybe<Scalars['String']['output']>;
  user_public_address?: Maybe<Scalars['String']['output']>;
  webflow_collection_id?: Maybe<Scalars['String']['output']>;
  webflow_item_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Webflow_Artist_Info_Min_Fields = {
  __typename?: 'webflow_artist_info_min_fields';
  slug?: Maybe<Scalars['String']['output']>;
  user_public_address?: Maybe<Scalars['String']['output']>;
  webflow_collection_id?: Maybe<Scalars['String']['output']>;
  webflow_item_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "webflow_artist_info" */
export type Webflow_Artist_Info_Mutation_Response = {
  __typename?: 'webflow_artist_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Webflow_Artist_Info>;
};

/** input type for inserting object relation for remote table "webflow_artist_info" */
export type Webflow_Artist_Info_Obj_Rel_Insert_Input = {
  data: Webflow_Artist_Info_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Webflow_Artist_Info_On_Conflict>;
};

/** on_conflict condition type for table "webflow_artist_info" */
export type Webflow_Artist_Info_On_Conflict = {
  constraint: Webflow_Artist_Info_Constraint;
  update_columns?: Array<Webflow_Artist_Info_Update_Column>;
  where?: InputMaybe<Webflow_Artist_Info_Bool_Exp>;
};

/** Ordering options when selecting data from "webflow_artist_info". */
export type Webflow_Artist_Info_Order_By = {
  published?: InputMaybe<Order_By>;
  raw_data?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_public_address?: InputMaybe<Order_By>;
  webflow_collection_id?: InputMaybe<Order_By>;
  webflow_item_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: webflow_artist_info */
export type Webflow_Artist_Info_Pk_Columns_Input = {
  webflow_item_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Webflow_Artist_Info_Prepend_Input = {
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "webflow_artist_info" */
export enum Webflow_Artist_Info_Select_Column {
  /** column name */
  Published = 'published',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Slug = 'slug',
  /** column name */
  UserPublicAddress = 'user_public_address',
  /** column name */
  WebflowCollectionId = 'webflow_collection_id',
  /** column name */
  WebflowItemId = 'webflow_item_id'
}

/** input type for updating data in table "webflow_artist_info" */
export type Webflow_Artist_Info_Set_Input = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  user_public_address?: InputMaybe<Scalars['String']['input']>;
  webflow_collection_id?: InputMaybe<Scalars['String']['input']>;
  webflow_item_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "webflow_artist_info" */
export type Webflow_Artist_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Webflow_Artist_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Webflow_Artist_Info_Stream_Cursor_Value_Input = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  user_public_address?: InputMaybe<Scalars['String']['input']>;
  webflow_collection_id?: InputMaybe<Scalars['String']['input']>;
  webflow_item_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "webflow_artist_info" */
export enum Webflow_Artist_Info_Update_Column {
  /** column name */
  Published = 'published',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Slug = 'slug',
  /** column name */
  UserPublicAddress = 'user_public_address',
  /** column name */
  WebflowCollectionId = 'webflow_collection_id',
  /** column name */
  WebflowItemId = 'webflow_item_id'
}

export type Webflow_Artist_Info_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Webflow_Artist_Info_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Webflow_Artist_Info_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Webflow_Artist_Info_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Webflow_Artist_Info_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Webflow_Artist_Info_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Webflow_Artist_Info_Set_Input>;
  /** filter the rows which have to be updated */
  where: Webflow_Artist_Info_Bool_Exp;
};

/** columns and relationships of "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles = {
  __typename?: 'webflow_spectrum_articles';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  extra_info?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  raw_data: Scalars['jsonb']['output'];
  section?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  webflow_collection_id: Scalars['String']['output'];
  webflow_item_id: Scalars['String']['output'];
};


/** columns and relationships of "webflow_spectrum_articles" */
export type Webflow_Spectrum_ArticlesRaw_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles_Aggregate = {
  __typename?: 'webflow_spectrum_articles_aggregate';
  aggregate?: Maybe<Webflow_Spectrum_Articles_Aggregate_Fields>;
  nodes: Array<Webflow_Spectrum_Articles>;
};

/** aggregate fields of "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles_Aggregate_Fields = {
  __typename?: 'webflow_spectrum_articles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Webflow_Spectrum_Articles_Max_Fields>;
  min?: Maybe<Webflow_Spectrum_Articles_Min_Fields>;
};


/** aggregate fields of "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Webflow_Spectrum_Articles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Webflow_Spectrum_Articles_Append_Input = {
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "webflow_spectrum_articles". All fields are combined with a logical 'AND'. */
export type Webflow_Spectrum_Articles_Bool_Exp = {
  _and?: InputMaybe<Array<Webflow_Spectrum_Articles_Bool_Exp>>;
  _not?: InputMaybe<Webflow_Spectrum_Articles_Bool_Exp>;
  _or?: InputMaybe<Array<Webflow_Spectrum_Articles_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  extra_info?: InputMaybe<String_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  raw_data?: InputMaybe<Jsonb_Comparison_Exp>;
  section?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  webflow_collection_id?: InputMaybe<String_Comparison_Exp>;
  webflow_item_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "webflow_spectrum_articles" */
export enum Webflow_Spectrum_Articles_Constraint {
  /** unique or primary key constraint on columns "webflow_item_id" */
  WebflowSpectrumArticlesPkey = 'webflow_spectrum_articles_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Webflow_Spectrum_Articles_Delete_At_Path_Input = {
  raw_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Webflow_Spectrum_Articles_Delete_Elem_Input = {
  raw_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Webflow_Spectrum_Articles_Delete_Key_Input = {
  raw_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extra_info?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  webflow_collection_id?: InputMaybe<Scalars['String']['input']>;
  webflow_item_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Webflow_Spectrum_Articles_Max_Fields = {
  __typename?: 'webflow_spectrum_articles_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extra_info?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  webflow_collection_id?: Maybe<Scalars['String']['output']>;
  webflow_item_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Webflow_Spectrum_Articles_Min_Fields = {
  __typename?: 'webflow_spectrum_articles_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extra_info?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  webflow_collection_id?: Maybe<Scalars['String']['output']>;
  webflow_item_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles_Mutation_Response = {
  __typename?: 'webflow_spectrum_articles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Webflow_Spectrum_Articles>;
};

/** on_conflict condition type for table "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles_On_Conflict = {
  constraint: Webflow_Spectrum_Articles_Constraint;
  update_columns?: Array<Webflow_Spectrum_Articles_Update_Column>;
  where?: InputMaybe<Webflow_Spectrum_Articles_Bool_Exp>;
};

/** Ordering options when selecting data from "webflow_spectrum_articles". */
export type Webflow_Spectrum_Articles_Order_By = {
  category?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  extra_info?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  raw_data?: InputMaybe<Order_By>;
  section?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  webflow_collection_id?: InputMaybe<Order_By>;
  webflow_item_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: webflow_spectrum_articles */
export type Webflow_Spectrum_Articles_Pk_Columns_Input = {
  webflow_item_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Webflow_Spectrum_Articles_Prepend_Input = {
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "webflow_spectrum_articles" */
export enum Webflow_Spectrum_Articles_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description',
  /** column name */
  ExtraInfo = 'extra_info',
  /** column name */
  Image = 'image',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Section = 'section',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  WebflowCollectionId = 'webflow_collection_id',
  /** column name */
  WebflowItemId = 'webflow_item_id'
}

/** input type for updating data in table "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extra_info?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  webflow_collection_id?: InputMaybe<Scalars['String']['input']>;
  webflow_item_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "webflow_spectrum_articles" */
export type Webflow_Spectrum_Articles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Webflow_Spectrum_Articles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Webflow_Spectrum_Articles_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extra_info?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  raw_data?: InputMaybe<Scalars['jsonb']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  webflow_collection_id?: InputMaybe<Scalars['String']['input']>;
  webflow_item_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "webflow_spectrum_articles" */
export enum Webflow_Spectrum_Articles_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description',
  /** column name */
  ExtraInfo = 'extra_info',
  /** column name */
  Image = 'image',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Section = 'section',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  WebflowCollectionId = 'webflow_collection_id',
  /** column name */
  WebflowItemId = 'webflow_item_id'
}

export type Webflow_Spectrum_Articles_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Webflow_Spectrum_Articles_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Webflow_Spectrum_Articles_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Webflow_Spectrum_Articles_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Webflow_Spectrum_Articles_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Webflow_Spectrum_Articles_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Webflow_Spectrum_Articles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Webflow_Spectrum_Articles_Bool_Exp;
};

export type ProjectSearchResultFragment = { __typename?: 'projects_metadata', id: string, name?: string | null, slug: string, project_id: string, artist_name?: string | null, disable_auto_image_format?: boolean | null, aspect_ratio: any, vertical_name: string, start_datetime?: string | null, vertical: { __typename?: 'project_verticals', category_name: string }, contract: { __typename?: 'contracts_metadata', address: string }, tokens: Array<{ __typename?: 'tokens_metadata', token_id: string, media_url?: string | null, image?: { __typename?: 'media', metadata?: any | null } | null }>, oob_tokens: Array<{ __typename?: 'oob_tokens_metadata', token_id: number, media_url?: string | null, image?: { __typename?: 'media', metadata?: any | null } | null }> };

export type UserSearchResultFragment = { __typename?: 'user_profiles', user_address: string, username?: string | null, profile_picture?: { __typename?: 'media', url?: string | null } | null };

export type FullSiteSearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  projectWhere: Projects_Metadata_Bool_Exp;
  resolvedEnsAddress?: InputMaybe<Scalars['String']['input']>;
  includeResolvedEnsLookup: Scalars['Boolean']['input'];
  ttl: Scalars['Int']['input'];
}>;


export type FullSiteSearchQuery = { __typename?: 'query_root', search_projects: Array<{ __typename?: 'projects_metadata', id: string, name?: string | null, slug: string, project_id: string, artist_name?: string | null, disable_auto_image_format?: boolean | null, aspect_ratio: any, vertical_name: string, start_datetime?: string | null, vertical: { __typename?: 'project_verticals', category_name: string }, contract: { __typename?: 'contracts_metadata', address: string }, tokens: Array<{ __typename?: 'tokens_metadata', token_id: string, media_url?: string | null, image?: { __typename?: 'media', metadata?: any | null } | null }>, oob_tokens: Array<{ __typename?: 'oob_tokens_metadata', token_id: number, media_url?: string | null, image?: { __typename?: 'media', metadata?: any | null } | null }> }>, search_users: Array<{ __typename?: 'user_profiles', user_address: string, username?: string | null, profile_picture?: { __typename?: 'media', url?: string | null } | null }>, user_profiles?: Array<{ __typename?: 'user_profiles', user_address: string, username?: string | null, profile_picture?: { __typename?: 'media', url?: string | null } | null }> };

export type ArtistProjectMetadataFragment = { __typename?: 'projects_metadata', name?: string | null, vertical_name: string, featured_token?: Array<{ __typename?: 'tokens_metadata', media_url?: string | null, image?: { __typename?: 'media', metadata?: any | null } | null }> | null, vertical: { __typename?: 'project_verticals', category_name: string, display_name: string }, tags: Array<{ __typename?: 'entity_tags', tag_name: string }> };

export type GetProjectGridTokensQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectGridTokensQuery = { __typename?: 'query_root', tokens_metadata: Array<{ __typename?: 'tokens_metadata', id: string, token_id: string, features: any, owner_address: string, invocation: number }> };

export type CollectionGridTokenDataFragment = { __typename?: 'tokens_metadata', id: string, token_id: string, features: any, owner_address: string, invocation: number };

export type GetProjectQueryQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
}>;


export type GetProjectQueryQuery = { __typename?: 'query_root', projects_metadata: Array<{ __typename?: 'projects_metadata', project_id: string, name?: string | null, script?: string | null, script_type_and_version?: string | null, external_asset_dependency_count?: any | null, contract: { __typename?: 'contracts_metadata', address: string } }> };

export type GetAllLiveArticlePagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLiveArticlePagesQuery = { __typename?: 'query_root', articles?: { __typename?: 'ArticleEntityResponseCollection', data: Array<{ __typename?: 'ArticleEntity', attributes?: { __typename?: 'Article', slug: string, title?: string | null, category?: Enum_Article_Category | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null }> } | null };

export type GetAllLiveExhibitionPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLiveExhibitionPagesQuery = { __typename?: 'query_root', exhibitions?: { __typename?: 'ExhibitionEntityResponseCollection', data: Array<{ __typename?: 'ExhibitionEntity', attributes?: { __typename?: 'Exhibition', slug: string, Title: string, Type: Enum_Exhibition_Type, HeaderImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, Collections: Array<{ __typename?: 'ComponentExhibitionsExhibitionCollection', Collection?: { __typename?: 'ComponentProjectMetadataProjectMetadata', Project?: { __typename?: 'projects_metadata', artist_name?: string | null } | null } | null } | null> } | null }> } | null };

export type GetAllArtistEditorialPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllArtistEditorialPagesQuery = { __typename?: 'query_root', artistEditorialPages?: { __typename?: 'ArtistEditorialPageEntityResponseCollection', data: Array<{ __typename?: 'ArtistEditorialPageEntity', attributes?: { __typename?: 'ArtistEditorialPage', slug: string, artistName: string, userProfileAddress?: string | null, ReleasesSection?: { __typename?: 'ComponentArtistEditorialPageProjectsCreated', projectMetadata?: Array<{ __typename?: 'ComponentProjectMetadataProjectMetadata', Project?: { __typename?: 'projects_metadata', name?: string | null, vertical_name: string, featured_token?: Array<{ __typename?: 'tokens_metadata', media_url?: string | null, image?: { __typename?: 'media', metadata?: any | null } | null }> | null, vertical: { __typename?: 'project_verticals', category_name: string, display_name: string }, tags: Array<{ __typename?: 'entity_tags', tag_name: string }> } | null } | null> | null } | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null }> } | null };

export type ArtistItemInfoFragment = { __typename?: 'artists', public_address?: string | null, user?: { __typename?: 'users', display_name?: string | null, is_curated?: boolean | null, profile?: { __typename?: 'user_profiles', name?: string | null, username?: string | null, bio?: string | null, profile_picture?: { __typename?: 'media', url?: string | null } | null } | null } | null, projects: Array<{ __typename?: 'projects_metadata', name?: string | null, vertical_name: string, featured_token?: Array<{ __typename?: 'tokens_metadata', media_url?: string | null, image?: { __typename?: 'media', metadata?: any | null } | null }> | null, vertical: { __typename?: 'project_verticals', category_name: string, display_name: string }, tags: Array<{ __typename?: 'entity_tags', tag_name: string }> }> };

export type GetArtistsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  where: Artists_Bool_Exp;
  offset: Scalars['Int']['input'];
}>;


export type GetArtistsQuery = { __typename?: 'query_root', artists: Array<{ __typename?: 'artists', public_address?: string | null, user?: { __typename?: 'users', display_name?: string | null, is_curated?: boolean | null, profile?: { __typename?: 'user_profiles', name?: string | null, username?: string | null, bio?: string | null, profile_picture?: { __typename?: 'media', url?: string | null } | null } | null } | null, projects: Array<{ __typename?: 'projects_metadata', name?: string | null, vertical_name: string, featured_token?: Array<{ __typename?: 'tokens_metadata', media_url?: string | null, image?: { __typename?: 'media', metadata?: any | null } | null }> | null, vertical: { __typename?: 'project_verticals', category_name: string, display_name: string }, tags: Array<{ __typename?: 'entity_tags', tag_name: string }> }> }> };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProjectQuery = { __typename?: 'query_root', projects_metadata_by_pk?: { __typename?: 'projects_metadata', id: string, render_delay?: number | null } | null };

export type CuratedProjectsListQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CuratedProjectsListQueryQuery = { __typename?: 'query_root', projects_metadata: Array<{ __typename?: 'projects_metadata', id: string, name?: string | null, artist_name?: string | null, aspect_ratio: any, series_id?: number | null, invocations?: any | null, contract_address: string, artist_address: string, slippy_map_grid_column_count?: number | null, features?: { __typename?: 'projects_features', feature_fields?: any | null, feature_fields_counts?: any | null } | null }> };

export type ProjectGridDataFragment = { __typename?: 'projects_metadata', id: string, name?: string | null, artist_name?: string | null, aspect_ratio: any, series_id?: number | null, invocations?: any | null, contract_address: string, artist_address: string, slippy_map_grid_column_count?: number | null, features?: { __typename?: 'projects_features', feature_fields?: any | null, feature_fields_counts?: any | null } | null };

export type CollectionProjectDetailsFragment = { __typename?: 'projects_metadata', id: string, project_id: string, name?: string | null, description?: string | null, max_invocations: number, invocations?: any | null, artist_address: string, artist_name?: string | null, website?: string | null, paused: boolean, active: boolean, complete: boolean, contract_address: string, curation_status: Curation_Statuses_Enum, heritage_curation_status?: string | null, start_datetime?: string | null, aspect_ratio: any, vertical_name: string, artist_display_notes?: string | null, creative_credit?: string | null, sales_notes?: string | null, license?: string | null, link_to_license?: string | null, render_delay?: number | null, disable_sample_generator: boolean, video_render_delay?: number | null, video_duration?: number | null, video_fps?: number | null, video_aspect_ratio?: any | null, primary_render_type: Render_Types_Enum, preview_render_type: Render_Types_Enum, generate_video_assets: boolean, completed_at?: string | null, script_type_and_version?: string | null, charitable_giving_details?: string | null, featured_token?: Array<{ __typename?: 'tokens_metadata', token_id: string, media_url?: string | null }> | null, oob_tokens: Array<{ __typename?: 'oob_tokens_metadata', id: string, media_url?: string | null }> };

export type GetTokenQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTokenQuery = { __typename?: 'query_root', tokens_metadata_by_pk?: { __typename?: 'tokens_metadata', id: string, image_id?: number | null, project_name?: string | null, features: any, hash: string, primary_asset_url?: string | null, preview_asset_url?: string | null, media_url?: string | null, project: { __typename?: 'projects_metadata', aspect_ratio: any, primary_render_type: Render_Types_Enum, preview_render_type: Render_Types_Enum }, contract?: { __typename?: 'contracts_metadata', generator_url?: string | null } | null } | null };

export type UpdateWalletProfileMutationVariables = Exact<{
  object: User_Profiles_Insert_Input;
}>;


export type UpdateWalletProfileMutation = { __typename?: 'mutation_root', insert_user_profiles_one?: { __typename?: 'user_profiles', id: number, user_address: string, username?: string | null, bio?: string | null, profile_picture?: { __typename?: 'media', url?: string | null, file_path: string, bucket_name: string } | null } | null };

export type GetWalletProfileDetailsQueryVariables = Exact<{
  walletAddress: Scalars['String']['input'];
}>;


export type GetWalletProfileDetailsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', public_address: string, profile?: { __typename?: 'user_profiles', username?: string | null, bio?: string | null, profile_picture?: { __typename?: 'media', url?: string | null, file_path: string, bucket_name: string } | null } | null }> };

export type GetCollectionProjectDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCollectionProjectDetailsQuery = { __typename?: 'query_root', projects_metadata_by_pk?: { __typename?: 'projects_metadata', id: string, project_id: string, name?: string | null, description?: string | null, max_invocations: number, invocations?: any | null, artist_address: string, artist_name?: string | null, website?: string | null, paused: boolean, active: boolean, complete: boolean, contract_address: string, curation_status: Curation_Statuses_Enum, heritage_curation_status?: string | null, start_datetime?: string | null, aspect_ratio: any, vertical_name: string, artist_display_notes?: string | null, creative_credit?: string | null, sales_notes?: string | null, license?: string | null, link_to_license?: string | null, render_delay?: number | null, disable_sample_generator: boolean, video_render_delay?: number | null, video_duration?: number | null, video_fps?: number | null, video_aspect_ratio?: any | null, primary_render_type: Render_Types_Enum, preview_render_type: Render_Types_Enum, generate_video_assets: boolean, completed_at?: string | null, script_type_and_version?: string | null, charitable_giving_details?: string | null, featured_token?: Array<{ __typename?: 'tokens_metadata', token_id: string, media_url?: string | null }> | null, oob_tokens: Array<{ __typename?: 'oob_tokens_metadata', id: string, media_url?: string | null }> } | null };

export type GetContractProjectsQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetContractProjectsQuery = { __typename?: 'query_root', contracts_metadata: Array<{ __typename?: 'contracts_metadata', projects: Array<{ __typename?: 'projects_metadata', id: string, project_id: string, name?: string | null, description?: string | null, max_invocations: number, invocations?: any | null, artist_address: string, artist_name?: string | null, website?: string | null, paused: boolean, active: boolean, complete: boolean, contract_address: string, curation_status: Curation_Statuses_Enum, heritage_curation_status?: string | null, start_datetime?: string | null, aspect_ratio: any, vertical_name: string, artist_display_notes?: string | null, creative_credit?: string | null, sales_notes?: string | null, license?: string | null, link_to_license?: string | null, render_delay?: number | null, disable_sample_generator: boolean, video_render_delay?: number | null, video_duration?: number | null, video_fps?: number | null, video_aspect_ratio?: any | null, primary_render_type: Render_Types_Enum, preview_render_type: Render_Types_Enum, generate_video_assets: boolean, completed_at?: string | null, script_type_and_version?: string | null, charitable_giving_details?: string | null, featured_token?: Array<{ __typename?: 'tokens_metadata', token_id: string, media_url?: string | null }> | null, oob_tokens: Array<{ __typename?: 'oob_tokens_metadata', id: string, media_url?: string | null }> }> }> };

export type AuthenticatePrivyUserMutationVariables = Exact<{
  input: PrivyAuthenticateInput;
}>;


export type AuthenticatePrivyUserMutation = { __typename?: 'mutation_root', privyAuthenticate?: { __typename?: 'AuthenticateOutput', jwt: string, expiration: number } | null };

export const ProjectSearchResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectSearchResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"artist_name"}},{"kind":"Field","name":{"kind":"Name","value":"disable_auto_image_format"}},{"kind":"Field","name":{"kind":"Name","value":"aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invocation"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"oob_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectSearchResultFragment, unknown>;
export const UserSearchResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSearchResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_profiles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"profile_picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<UserSearchResultFragment, unknown>;
export const CollectionGridTokenDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionGridTokenData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tokens_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"owner_address"}},{"kind":"Field","name":{"kind":"Name","value":"invocation"}}]}}]} as unknown as DocumentNode<CollectionGridTokenDataFragment, unknown>;
export const ArtistProjectMetadataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArtistProjectMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featured_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag_name"}}]}}]}}]} as unknown as DocumentNode<ArtistProjectMetadataFragment, unknown>;
export const ArtistItemInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArtistItemInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"artists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_address"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_curated"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"profile_picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArtistProjectMetadata"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArtistProjectMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featured_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag_name"}}]}}]}}]} as unknown as DocumentNode<ArtistItemInfoFragment, unknown>;
export const ProjectGridDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectGridData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"artist_name"}},{"kind":"Field","name":{"kind":"Name","value":"aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"series_id"}},{"kind":"Field","name":{"kind":"Name","value":"invocations"}},{"kind":"Field","name":{"kind":"Name","value":"contract_address"}},{"kind":"Field","name":{"kind":"Name","value":"artist_address"}},{"kind":"Field","name":{"kind":"Name","value":"slippy_map_grid_column_count"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature_fields"}},{"kind":"Field","name":{"kind":"Name","value":"feature_fields_counts"}}]}}]}}]} as unknown as DocumentNode<ProjectGridDataFragment, unknown>;
export const CollectionProjectDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"max_invocations"}},{"kind":"Field","name":{"kind":"Name","value":"invocations"}},{"kind":"Field","name":{"kind":"Name","value":"artist_address"}},{"kind":"Field","name":{"kind":"Name","value":"artist_name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"contract_address"}},{"kind":"Field","name":{"kind":"Name","value":"curation_status"}},{"kind":"Field","name":{"kind":"Name","value":"heritage_curation_status"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"artist_display_notes"}},{"kind":"Field","name":{"kind":"Name","value":"creative_credit"}},{"kind":"Field","name":{"kind":"Name","value":"sales_notes"}},{"kind":"Field","name":{"kind":"Name","value":"license"}},{"kind":"Field","name":{"kind":"Name","value":"link_to_license"}},{"kind":"Field","name":{"kind":"Name","value":"render_delay"}},{"kind":"Field","name":{"kind":"Name","value":"disable_sample_generator"}},{"kind":"Field","name":{"kind":"Name","value":"video_render_delay"}},{"kind":"Field","name":{"kind":"Name","value":"video_duration"}},{"kind":"Field","name":{"kind":"Name","value":"video_fps"}},{"kind":"Field","name":{"kind":"Name","value":"video_aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"primary_render_type"}},{"kind":"Field","name":{"kind":"Name","value":"preview_render_type"}},{"kind":"Field","name":{"kind":"Name","value":"generate_video_assets"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"script_type_and_version"}},{"kind":"Field","name":{"kind":"Name","value":"charitable_giving_details"}},{"kind":"Field","name":{"kind":"Name","value":"featured_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oob_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}}]}}]}}]} as unknown as DocumentNode<CollectionProjectDetailsFragment, unknown>;
export const FullSiteSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FullSiteSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resolvedEnsAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeResolvedEnsLookup"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ttl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ttl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectSearchResult"}}]}},{"kind":"Field","name":{"kind":"Name","value":"search_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSearchResult"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resolvedEnsAddress"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeResolvedEnsLookup"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSearchResult"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectSearchResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"artist_name"}},{"kind":"Field","name":{"kind":"Name","value":"disable_auto_image_format"}},{"kind":"Field","name":{"kind":"Name","value":"aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invocation"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"oob_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSearchResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_profiles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"profile_picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<FullSiteSearchQuery, FullSiteSearchQueryVariables>;
export const GetProjectGridTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectGridTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokens_metadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invocation"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionGridTokenData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionGridTokenData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tokens_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"owner_address"}},{"kind":"Field","name":{"kind":"Name","value":"invocation"}}]}}]} as unknown as DocumentNode<GetProjectGridTokensQuery, GetProjectGridTokensQueryVariables>;
export const GetProjectQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_metadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"contract_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractAddress"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"script"}},{"kind":"Field","name":{"kind":"Name","value":"script_type_and_version"}},{"kind":"Field","name":{"kind":"Name","value":"external_asset_dependency_count"}}]}}]}}]} as unknown as DocumentNode<GetProjectQueryQuery, GetProjectQueryQueryVariables>;
export const GetAllLiveArticlePagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLiveArticlePages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLiveArticlePagesQuery, GetAllLiveArticlePagesQueryVariables>;
export const GetAllLiveExhibitionPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLiveExhibitionPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exhibitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"HeaderImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artist_name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLiveExhibitionPagesQuery, GetAllLiveExhibitionPagesQueryVariables>;
export const GetAllArtistEditorialPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllArtistEditorialPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artistEditorialPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"artistName:asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"artistName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ReleasesSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArtistProjectMetadata"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArtistProjectMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featured_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag_name"}}]}}]}}]} as unknown as DocumentNode<GetAllArtistEditorialPagesQuery, GetAllArtistEditorialPagesQueryVariables>;
export const GetArtistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArtists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"artists_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArtistItemInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArtistProjectMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featured_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArtistItemInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"artists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_address"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_curated"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"profile_picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArtistProjectMetadata"}}]}}]}}]} as unknown as DocumentNode<GetArtistsQuery, GetArtistsQueryVariables>;
export const GetProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_metadata_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"render_delay"}}]}}]}}]} as unknown as DocumentNode<GetProjectQuery, GetProjectQueryVariables>;
export const CuratedProjectsListQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CuratedProjectsListQuery"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_metadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vertical_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"curated","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"render_complete"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"index"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectGridData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectGridData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"artist_name"}},{"kind":"Field","name":{"kind":"Name","value":"aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"series_id"}},{"kind":"Field","name":{"kind":"Name","value":"invocations"}},{"kind":"Field","name":{"kind":"Name","value":"contract_address"}},{"kind":"Field","name":{"kind":"Name","value":"artist_address"}},{"kind":"Field","name":{"kind":"Name","value":"slippy_map_grid_column_count"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature_fields"}},{"kind":"Field","name":{"kind":"Name","value":"feature_fields_counts"}}]}}]}}]} as unknown as DocumentNode<CuratedProjectsListQueryQuery, CuratedProjectsListQueryQueryVariables>;
export const GetTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokens_metadata_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"primary_asset_url"}},{"kind":"Field","name":{"kind":"Name","value":"preview_asset_url"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"primary_render_type"}},{"kind":"Field","name":{"kind":"Name","value":"preview_render_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generator_url"}}]}}]}}]}}]} as unknown as DocumentNode<GetTokenQuery, GetTokenQueryVariables>;
export const UpdateWalletProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWalletProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_profiles_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_profiles_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_profiles_user_address_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"username"},{"kind":"EnumValue","value":"bio"},{"kind":"EnumValue","value":"profile_picture_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"profile_picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_path"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateWalletProfileMutation, UpdateWalletProfileMutationVariables>;
export const GetWalletProfileDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWalletProfileDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"walletAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public_address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"walletAddress"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_address"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"profile_picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_path"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWalletProfileDetailsQuery, GetWalletProfileDetailsQueryVariables>;
export const GetCollectionProjectDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectionProjectDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_metadata_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionProjectDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"max_invocations"}},{"kind":"Field","name":{"kind":"Name","value":"invocations"}},{"kind":"Field","name":{"kind":"Name","value":"artist_address"}},{"kind":"Field","name":{"kind":"Name","value":"artist_name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"contract_address"}},{"kind":"Field","name":{"kind":"Name","value":"curation_status"}},{"kind":"Field","name":{"kind":"Name","value":"heritage_curation_status"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"artist_display_notes"}},{"kind":"Field","name":{"kind":"Name","value":"creative_credit"}},{"kind":"Field","name":{"kind":"Name","value":"sales_notes"}},{"kind":"Field","name":{"kind":"Name","value":"license"}},{"kind":"Field","name":{"kind":"Name","value":"link_to_license"}},{"kind":"Field","name":{"kind":"Name","value":"render_delay"}},{"kind":"Field","name":{"kind":"Name","value":"disable_sample_generator"}},{"kind":"Field","name":{"kind":"Name","value":"video_render_delay"}},{"kind":"Field","name":{"kind":"Name","value":"video_duration"}},{"kind":"Field","name":{"kind":"Name","value":"video_fps"}},{"kind":"Field","name":{"kind":"Name","value":"video_aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"primary_render_type"}},{"kind":"Field","name":{"kind":"Name","value":"preview_render_type"}},{"kind":"Field","name":{"kind":"Name","value":"generate_video_assets"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"script_type_and_version"}},{"kind":"Field","name":{"kind":"Name","value":"charitable_giving_details"}},{"kind":"Field","name":{"kind":"Name","value":"featured_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oob_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}}]}}]}}]} as unknown as DocumentNode<GetCollectionProjectDetailsQuery, GetCollectionProjectDetailsQueryVariables>;
export const GetContractProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContractProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts_metadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionProjectDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"max_invocations"}},{"kind":"Field","name":{"kind":"Name","value":"invocations"}},{"kind":"Field","name":{"kind":"Name","value":"artist_address"}},{"kind":"Field","name":{"kind":"Name","value":"artist_name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"contract_address"}},{"kind":"Field","name":{"kind":"Name","value":"curation_status"}},{"kind":"Field","name":{"kind":"Name","value":"heritage_curation_status"}},{"kind":"Field","name":{"kind":"Name","value":"start_datetime"}},{"kind":"Field","name":{"kind":"Name","value":"aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"vertical_name"}},{"kind":"Field","name":{"kind":"Name","value":"artist_display_notes"}},{"kind":"Field","name":{"kind":"Name","value":"creative_credit"}},{"kind":"Field","name":{"kind":"Name","value":"sales_notes"}},{"kind":"Field","name":{"kind":"Name","value":"license"}},{"kind":"Field","name":{"kind":"Name","value":"link_to_license"}},{"kind":"Field","name":{"kind":"Name","value":"render_delay"}},{"kind":"Field","name":{"kind":"Name","value":"disable_sample_generator"}},{"kind":"Field","name":{"kind":"Name","value":"video_render_delay"}},{"kind":"Field","name":{"kind":"Name","value":"video_duration"}},{"kind":"Field","name":{"kind":"Name","value":"video_fps"}},{"kind":"Field","name":{"kind":"Name","value":"video_aspect_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"primary_render_type"}},{"kind":"Field","name":{"kind":"Name","value":"preview_render_type"}},{"kind":"Field","name":{"kind":"Name","value":"generate_video_assets"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"script_type_and_version"}},{"kind":"Field","name":{"kind":"Name","value":"charitable_giving_details"}},{"kind":"Field","name":{"kind":"Name","value":"featured_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oob_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"media_url"}}]}}]}}]} as unknown as DocumentNode<GetContractProjectsQuery, GetContractProjectsQueryVariables>;
export const AuthenticatePrivyUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthenticatePrivyUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrivyAuthenticateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"privyAuthenticate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwt"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}}]}}]}}]} as unknown as DocumentNode<AuthenticatePrivyUserMutation, AuthenticatePrivyUserMutationVariables>;